export type blogListType = {
  slug: string;
  title: string;
  summary: string;
  thumbnailImage: string;
  date: string;
  author: string;
  featured?: boolean;
  type:
    | "Story"
    | "Collaboration"
    | "News"
    | "Opinion"
    | "Analysis"
    | "Project"
    | "Article";
};

export const globalBlogs: blogListType[] = [
  {
    slug: "nepal-flood-recovery-september-briefing",
    title: "Nepal floods: the work of recovery continues",
    summary: "The latest published assessment of safe water, essential services and family needs — and where Nivaran’s appeal stands.",
    thumbnailImage: "/hero_img/nepal-flood-river.webp",
    date: "2026-09-14",
    author: "Nivaran Foundation Nepal Desk",
    featured: true,
    type: "News",
  },
  {
    slug: "sanjeevani-bringing-care-closer-to-rural-nepal",
    title: "Sanjeevani: bringing care closer to rural Nepal",
    summary: "The purpose behind Nivaran’s mobile health camps, with a clear look at the program’s published progress and reporting dates.",
    thumbnailImage: "/blogs/images/nepaliVillageInHills.jpg",
    date: "2026-09-14",
    author: "Nivaran Foundation Nepal Desk",
    featured: true,
    type: "Story",
  },
  {
    slug: "nepal-flood-health-response-early-warning",
    title: "After Nepal’s floods, early warning protects health",
    summary: "A WHO update explains how local reporting and rapid verification help Nepal’s health authorities respond to emerging threats.",
    thumbnailImage: "/hero_img/nepal-flood-street.webp",
    date: "2026-09-14",
    author: "Nivaran Foundation Nepal Desk",
    featured: true,
    type: "News",
  },
  {
    slug: "nepal-children-learning-after-floods",
    title: "Making room for childhood after Nepal’s floods",
    summary: "A perspective on safe spaces, play and learning, informed by UNICEF’s recent reporting from Nuwakot.",
    thumbnailImage: "/hero_img/nepal-flood-family.webp",
    date: "2026-09-14",
    author: "Nivaran Foundation Nepal Desk",
    featured: true,
    type: "Article",
  },
  {
    slug: "global-health-and-education-watch-mail-on-sunday-ends-up-funding-state-school-scholarship",
    title: "Global Health and Education Watch: Mail on Sunday ends up funding state school scholarship",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-12-global-health-and-education-watch-mail-on-sunday-ends-up-funding-state-school-sc.jpg",
    date: "2026-09-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-deadly-drc-school-fire-prompts-calls-for-safety-reforms",
    title: "Global Health and Education Watch: Deadly DRC school fire prompts calls for safety reforms",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-11-global-health-and-education-watch-deadly-drc-school-fire-prompts-calls-for-safet.jpg",
    date: "2026-09-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-water-comes-up-to-our-knees-climate-hazards",
    title: "Global Health and Education Watch: ‘The water comes up to our knees’: Climate hazards",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-11-global-health-and-education-watch-the-water-comes-up-to-our-knees-climate-hazard.jpg",
    date: "2026-09-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-from-ozempic-breath-to-hair-loss-sorting-the-science",
    title: "Global Health and Education Watch: From ‘Ozempic breath’ to hair loss: sorting the science",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-11-global-health-and-education-watch-from-ozempic-breath-to-hair-loss-sorting-the-s.jpg",
    date: "2026-09-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-strengthening-public-health-across-lebanon-with-eib-global-2",
    title: "Global Health and Education Watch: Strengthening public health across Lebanon with EIB Global",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-11-global-health-and-education-watch-strengthening-public-health-across-lebanon-wit.jpg",
    date: "2026-09-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-salmonella-outbreak-that-sickened-22-is-linked-to-broccoli",
    title: "Global Health and Education Watch: Salmonella Outbreak That Sickened 22 Is Linked to Broccoli",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-11-global-health-and-education-watch-salmonella-outbreak-that-sickened-22-is-linked.jpg",
    date: "2026-09-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-new-ai-health-tools-need-l-plates-says-uk-review",
    title: "Global Health and Education Watch: New AI health tools need ‘L-plates’, says UK review",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-11-global-health-and-education-watch-new-ai-health-tools-need-l-plates-says-uk-revi.jpg",
    date: "2026-09-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-nhs-reports-busiest-ever-summer-as-heatwaves-drive-up",
    title: "Global Health and Education Watch: NHS reports busiest ever summer as heatwaves drive up",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-10-global-health-and-education-watch-nhs-reports-busiest-ever-summer-as-heatwaves-d.jpg",
    date: "2026-09-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hundreds-of-thousands-lack-adequate-shelter-at-sudan-s-tawila",
    title: "Global Health and Education Watch: Hundreds of thousands lack adequate shelter at Sudan’s Tawila",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-10-global-health-and-education-watch-hundreds-of-thousands-lack-adequate-shelter-at.jpg",
    date: "2026-09-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-record-number-of-attacks-on-education-global-fund-warns",
    title: "Global Health and Education Watch: Record number of attacks on education, global fund warns",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-10-global-health-and-education-watch-record-number-of-attacks-on-education-global-f.jpg",
    date: "2026-09-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-teachers-say-holidays-in-term-can-be-worth-more",
    title: "Global Health and Education Watch: Teachers say holidays in term can be worth more",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-10-global-health-and-education-watch-teachers-say-holidays-in-term-can-be-worth-mor.jpg",
    date: "2026-09-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-qatar-fund-for-development-qffd-supports-the-implementation-of-2",
    title: "Global Health and Education Watch: Qatar Fund for Development (QFFD) supports the implementation of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-10-global-health-and-education-watch-qatar-fund-for-development-qffd-supports-the-i.jpg",
    date: "2026-09-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-back-to-school-now-with-a-i",
    title: "Global Health and Education Watch: Back to School, Now With A.I.",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-09-global-health-and-education-watch-back-to-school-now-with-a-i.jpg",
    date: "2026-09-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-to-do-about-the-uk-s-mental-health-crisis",
    title: "Global Health and Education Watch: What to do about the UK’s mental health crisis",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-09-global-health-and-education-watch-what-to-do-about-the-uk-s-mental-health-crisis.jpg",
    date: "2026-09-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tobacco-use-can-undermine-fertility-un-health-agency-warns",
    title: "Global Health and Education Watch: Tobacco use can undermine fertility, UN health agency warns",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-09-global-health-and-education-watch-tobacco-use-can-undermine-fertility-un-health-.jpg",
    date: "2026-09-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mamdani-releases-records-on-toxic-air-in-new-york",
    title: "Global Health and Education Watch: Mamdani releases records on toxic air in New York",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-09-global-health-and-education-watch-mamdani-releases-records-on-toxic-air-in-new-y.jpg",
    date: "2026-09-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-covid-data-for-shared-learning-cdsl-a-multimodal-publicly",
    title: "Global Health and Education Watch: COVID Data for Shared Learning (CDSL): a multimodal publicly",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-08-global-health-and-education-watch-covid-data-for-shared-learning-cdsl-a-multimod.jpg",
    date: "2026-09-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-students-are-suffering-from-us-colleges-shaky-finances-trump",
    title: "Global Health and Education Watch: Students are suffering from US colleges’ shaky finances. Trump",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-08-global-health-and-education-watch-students-are-suffering-from-us-colleges-shaky-.jpg",
    date: "2026-09-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-and-the-netherlands-renew-their-partnership-on-climate-2",
    title: "Global Health and Education Watch: WHO and the Netherlands renew their partnership on climate",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-08-global-health-and-education-watch-who-and-the-netherlands-renew-their-partnershi.jpg",
    date: "2026-09-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-neighbors-rally-after-a-manhattan-preschool-s-corn-stalks-are",
    title: "Global Health and Education Watch: Neighbors Rally After a Manhattan Preschool’s Corn Stalks Are",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-08-global-health-and-education-watch-neighbors-rally-after-a-manhattan-preschool-s-.jpg",
    date: "2026-09-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-weather-tracker-typhoon-saudel-causes-mass-evacuations-in-south-east-3",
    title: "Global Health and Education Watch: Weather tracker: Typhoon Saudel causes mass evacuations in south-east",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-08-global-health-and-education-watch-weather-tracker-typhoon-saudel-causes-mass-eva.jpg",
    date: "2026-09-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-weather-tracker-typhoon-saudel-causes-mass-evacuations-in-south-east-2",
    title: "Global Health and Education Watch: Weather tracker: Typhoon Saudel causes mass evacuations in south-east",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-07-global-health-and-education-watch-weather-tracker-typhoon-saudel-causes-mass-eva.jpg",
    date: "2026-09-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-weather-tracker-typhoon-saudel-causes-mass-evacuations-in-south-east",
    title: "Global Health and Education Watch: Weather tracker: Typhoon Saudel causes mass evacuations in south-east",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-07-global-health-and-education-watch-weather-tracker-typhoon-saudel-causes-mass-eva.jpg",
    date: "2026-09-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-human-rights-chief-turk-renews-call-for-end-to",
    title: "Global Health and Education Watch: Human rights chief Türk renews call for end to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-07-global-health-and-education-watch-human-rights-chief-t-rk-renews-call-for-end-to.jpg",
    date: "2026-09-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-breaks-my-heart-yemen-jab-shortages-spark-fears-for",
    title: "Global Health and Education Watch: ‘Breaks my heart’: Yemen jab shortages spark fears for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-07-global-health-and-education-watch-breaks-my-heart-yemen-jab-shortages-spark-fear.jpg",
    date: "2026-09-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-inside-pepsico-s-battle-to-remake-gatorade-for-the-kennedy",
    title: "Global Health and Education Watch: Inside PepsiCo’s battle to remake Gatorade for the Kennedy",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-07-global-health-and-education-watch-inside-pepsico-s-battle-to-remake-gatorade-for.jpg",
    date: "2026-09-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-remarkable-documentary-made-by-blind-students-we-were",
    title: "Global Health and Education Watch: A remarkable documentary made by blind students: ‘We were",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-07-global-health-and-education-watch-a-remarkable-documentary-made-by-blind-student.jpg",
    date: "2026-09-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-enhancing-global-health-and-well-being-who-and-the-netherlands-2",
    title: "Global Health and Education Watch: Enhancing Global Health and Well-Being: WHO and the Netherlands",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-06-global-health-and-education-watch-enhancing-global-health-and-well-being-who-and.jpg",
    date: "2026-09-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-kenyans-made-a-living-writing-college-essays-then-a-i",
    title: "Global Health and Education Watch: Kenyans Made a Living Writing College Essays. Then A.I",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-06-global-health-and-education-watch-kenyans-made-a-living-writing-college-essays-t.jpg",
    date: "2026-09-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-pupils-with-send-plans-in-england-likely-to-double",
    title: "Global Health and Education Watch: Pupils with Send plans in England likely to double",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-06-global-health-and-education-watch-pupils-with-send-plans-in-england-likely-to-do.jpg",
    date: "2026-09-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-spain-s-secretary-of-state-for-health-discusses-health-priorities-2",
    title: "Global Health and Education Watch: Spain's Secretary of State for Health discusses health priorities",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-06-global-health-and-education-watch-spain-s-secretary-of-state-for-health-discusse.jpg",
    date: "2026-09-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-prediction-of-maternal-and-infant-outcomes-from-longitudinal-electronic",
    title: "Global Health and Education Watch: Prediction of maternal and infant outcomes from longitudinal electronic",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-06-global-health-and-education-watch-prediction-of-maternal-and-infant-outcomes-fro.jpg",
    date: "2026-09-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-nearly-9-000-killed-in-israeli-attacks-on-lebanon-since",
    title: "Global Health and Education Watch: Nearly 9,000 killed in Israeli attacks on Lebanon since",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-06-global-health-and-education-watch-nearly-9-000-killed-in-israeli-attacks-on-leba.jpg",
    date: "2026-09-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-unpaid-and-under-attack-the-frontline-workers-fighting-ebola",
    title: "Global Health and Education Watch: Unpaid and under attack: the frontline workers fighting Ebola",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-06-global-health-and-education-watch-unpaid-and-under-attack-the-frontline-workers-.jpg",
    date: "2026-09-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-bold-brilliant-thrilling-leading-authors-on-the-novels-every",
    title: "Global Health and Education Watch: ‘Bold, brilliant, thrilling’: leading authors on the novels every",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-06-global-health-and-education-watch-bold-brilliant-thrilling-leading-authors-on-th.jpg",
    date: "2026-09-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-new-york-city-supports-push-to-reopen-columbia-pathway",
    title: "Global Health and Education Watch: New York City Supports Push to Reopen Columbia Pathway",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-05-global-health-and-education-watch-new-york-city-supports-push-to-reopen-columbia.jpg",
    date: "2026-09-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-general-assembly-backs-creation-of-new-un-learning-institute",
    title: "Global Health and Education Watch: General Assembly backs creation of new UN learning institute",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-05-global-health-and-education-watch-general-assembly-backs-creation-of-new-un-lear.jpg",
    date: "2026-09-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-timor-leste-certified-malaria-free-by-who-2",
    title: "Global Health and Education Watch: Timor-Leste certified malaria-free by WHO",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-05-global-health-and-education-watch-timor-leste-certified-malaria-free-by-who.jpg",
    date: "2026-09-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-un-tells-the-world-stop-making-africa-look-small",
    title: "Global Health and Education Watch: UN tells the world: Stop making Africa look small",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-05-global-health-and-education-watch-un-tells-the-world-stop-making-africa-look-sma.jpg",
    date: "2026-09-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-heart-drug-pelacarsen-fails-shocking-novartis-and-cardiologists",
    title: "Global Health and Education Watch: The Heart Drug Pelacarsen Fails, Shocking Novartis and Cardiologists",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-05-global-health-and-education-watch-the-heart-drug-pelacarsen-fails-shocking-novar.jpg",
    date: "2026-09-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-chat-to-strangers-and-let-your-kids-be-bored",
    title: "Global Health and Education Watch: Chat to strangers and let your kids be bored",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-05-global-health-and-education-watch-chat-to-strangers-and-let-your-kids-be-bored.jpg",
    date: "2026-09-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-signing-ceremony-for-contribution-agreements-between-who-and-france-2",
    title: "Global Health and Education Watch: Signing ceremony for contribution agreements between WHO and France",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-05-global-health-and-education-watch-signing-ceremony-for-contribution-agreements-b.jpg",
    date: "2026-09-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-alcohol-related-cancer-deaths-in-us-have-more-than-doubled",
    title: "Global Health and Education Watch: Alcohol-related cancer deaths in US have more than doubled",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-05-global-health-and-education-watch-alcohol-related-cancer-deaths-in-us-have-more-.jpg",
    date: "2026-09-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-psilocybin-may-prevent-nerve-damage-caused-by-chemotherapy-study",
    title: "Global Health and Education Watch: Psilocybin May Prevent Nerve Damage Caused by Chemotherapy, Study",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-04-global-health-and-education-watch-psilocybin-may-prevent-nerve-damage-caused-by-.jpg",
    date: "2026-09-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-repeated-attacks-on-humanitarian-warehouses-put-vital-medical-aid",
    title: "Global Health and Education Watch: Repeated attacks on humanitarian warehouses put vital medical aid",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-04-global-health-and-education-watch-repeated-attacks-on-humanitarian-warehouses-pu.jpg",
    date: "2026-09-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-african-union-and-world-health-organization-renew-strategic-partnership-2",
    title: "Global Health and Education Watch: African Union and World Health Organization renew strategic partnership",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-04-global-health-and-education-watch-african-union-and-world-health-organization-re.jpg",
    date: "2026-09-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-after-gen-z-india-s-gen-alpha-rises-demanding-education",
    title: "Global Health and Education Watch: After Gen Z, India’s Gen Alpha rises, demanding education",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-04-global-health-and-education-watch-after-gen-z-india-s-gen-alpha-rises-demanding-.jpg",
    date: "2026-09-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-higher-education-regulator-apologises-for-imposing-585-000-fine-on",
    title: "Global Health and Education Watch: Higher education regulator apologises for imposing £585,000 fine on",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-04-global-health-and-education-watch-higher-education-regulator-apologises-for-impo.jpg",
    date: "2026-09-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-schools-giving-aid-to-minority-students-could-lose-tax",
    title: "Global Health and Education Watch: Schools Giving Aid to Minority Students Could Lose Tax",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-04-global-health-and-education-watch-schools-giving-aid-to-minority-students-could-.jpg",
    date: "2026-09-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-schools-in-england-face-checks-to-root-out-unhealthy",
    title: "Global Health and Education Watch: Schools in England face checks to root out unhealthy",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-03-global-health-and-education-watch-schools-in-england-face-checks-to-root-out-unh.jpg",
    date: "2026-09-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-food-aid-cutback-in-the-occupied-west-bank-as",
    title: "Global Health and Education Watch: Food aid cutback in the occupied West Bank as",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-03-global-health-and-education-watch-food-aid-cutback-in-the-occupied-west-bank-as.jpg",
    date: "2026-09-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ireland-and-who-work-together-to-improve-access-to-2",
    title: "Global Health and Education Watch: Ireland and WHO work together to improve access to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-03-global-health-and-education-watch-ireland-and-who-work-together-to-improve-acces.jpg",
    date: "2026-09-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-medical-groups-issue-vaccine-guidance-urge-jabs-for",
    title: "Global Health and Education Watch: US medical groups issue vaccine guidance, urge jabs for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-03-global-health-and-education-watch-us-medical-groups-issue-vaccine-guidance-urge-.jpg",
    date: "2026-09-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-for-these-children-getting-a-safe-education-means-going",
    title: "Global Health and Education Watch: For These Children, Getting a Safe Education Means Going",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-03-global-health-and-education-watch-for-these-children-getting-a-safe-education-me.jpg",
    date: "2026-09-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-an-autism-or-adhd-diagnosis-without-access-to-treatment",
    title: "Global Health and Education Watch: An autism or ADHD diagnosis without access to treatment",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-03-global-health-and-education-watch-an-autism-or-adhd-diagnosis-without-access-to-.jpg",
    date: "2026-09-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-new-york-city-bans-a-i-in-elementary-and-middle",
    title: "Global Health and Education Watch: New York City Bans A.I. in Elementary and Middle",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-02-global-health-and-education-watch-new-york-city-bans-a-i-in-elementary-and-middl.jpg",
    date: "2026-09-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-i-is-to-be-banned-in-n-y-c-elementary-and-2",
    title: "Global Health and Education Watch: A.I. Is to Be Banned in N.Y.C. Elementary and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-02-global-health-and-education-watch-a-i-is-to-be-banned-in-n-y-c-elementary-and.jpg",
    date: "2026-09-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-i-is-to-be-banned-in-n-y-c-elementary-and",
    title: "Global Health and Education Watch: A.I. Is to Be Banned in N.Y.C. Elementary and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-02-global-health-and-education-watch-a-i-is-to-be-banned-in-n-y-c-elementary-and.jpg",
    date: "2026-09-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-free-cholesterol-tests-on-the-nhs-are-great",
    title: "Global Health and Education Watch: Free cholesterol tests on the NHS are great –",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-02-global-health-and-education-watch-free-cholesterol-tests-on-the-nhs-are-great.jpg",
    date: "2026-09-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-response-must-outpace-spread-of-ebola-un-relief-chief",
    title: "Global Health and Education Watch: Response must outpace spread of Ebola: UN relief chief",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-02-global-health-and-education-watch-response-must-outpace-spread-of-ebola-un-relie.jpg",
    date: "2026-09-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-justice-department-sues-kansas-city-schools-over-gender-policy",
    title: "Global Health and Education Watch: Justice Department Sues Kansas City Schools Over Gender Policy",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-02-global-health-and-education-watch-justice-department-sues-kansas-city-schools-ov.jpg",
    date: "2026-09-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-health-crisis-looming-as-gaza-heads-towards-rainy-season",
    title: "Global Health and Education Watch: Health crisis looming as Gaza heads towards rainy season",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-01-global-health-and-education-watch-health-crisis-looming-as-gaza-heads-towards-ra.jpg",
    date: "2026-09-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-c-d-c-director-challenges-pennsylvania-s-report-of-two-measles-deaths",
    title: "Global Health and Education Watch: C.D.C. Director Challenges Pennsylvania’s Report of Two Measles Deaths",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-01-global-health-and-education-watch-c-d-c-director-challenges-pennsylvania-s-repor.jpg",
    date: "2026-09-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-albanese-has-everything-to-lose-engaging-in-a-fight-3",
    title: "Global Health and Education Watch: Albanese has everything to lose engaging in a fight",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-01-global-health-and-education-watch-albanese-has-everything-to-lose-engaging-in-a-.jpg",
    date: "2026-09-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-albanese-has-everything-to-lose-engaging-in-a-fight-2",
    title: "Global Health and Education Watch: Albanese has everything to lose engaging in a fight",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-01-global-health-and-education-watch-albanese-has-everything-to-lose-engaging-in-a-.jpg",
    date: "2026-09-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-albanese-has-everything-to-lose-engaging-in-a-fight",
    title: "Global Health and Education Watch: Albanese has everything to lose engaging in a fight",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-01-global-health-and-education-watch-albanese-has-everything-to-lose-engaging-in-a-.jpg",
    date: "2026-09-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-more-and-more-undergrads-are-living-at-home-that-s",
    title: "Global Health and Education Watch: More and more undergrads are living at home. That’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-09-01-global-health-and-education-watch-more-and-more-undergrads-are-living-at-home-th.jpg",
    date: "2026-09-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-un-chief-condemns-indifference-as-ebola-cases-mount-in",
    title: "Global Health and Education Watch: UN chief condemns ‘indifference’ as Ebola cases mount in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-31-global-health-and-education-watch-un-chief-condemns-indifference-as-ebola-cases-.jpg",
    date: "2026-08-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-pharma-stocks-soar-as-investors-seek-ai-alternatives",
    title: "Global Health and Education Watch: Pharma stocks soar as investors seek AI alternatives",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-31-global-health-and-education-watch-pharma-stocks-soar-as-investors-seek-ai-altern.jpg",
    date: "2026-08-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-digital-public-mental-health-a-dataset-for-monitoring-mental",
    title: "Global Health and Education Watch: Digital Public Mental Health: a dataset for monitoring mental",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-31-global-health-and-education-watch-digital-public-mental-health-a-dataset-for-mon.jpg",
    date: "2026-08-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tunisia-swelters-as-power-cuts-disrupt-water-supplies",
    title: "Global Health and Education Watch: Tunisia swelters as power cuts disrupt water supplies",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-31-global-health-and-education-watch-tunisia-swelters-as-power-cuts-disrupt-water-s.jpg",
    date: "2026-08-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-inside-a-secret-school-for-afghan-girls-3",
    title: "Global Health and Education Watch: Inside a Secret School for Afghan Girls",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-30-global-health-and-education-watch-inside-a-secret-school-for-afghan-girls.jpg",
    date: "2026-08-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-new-york-city-to-increase-cooling-tower-inspections-after",
    title: "Global Health and Education Watch: New York City to increase cooling tower inspections after",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-30-global-health-and-education-watch-new-york-city-to-increase-cooling-tower-inspec.jpg",
    date: "2026-08-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-inside-a-secret-school-for-afghan-girls-2",
    title: "Global Health and Education Watch: Inside a Secret School for Afghan Girls",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-30-global-health-and-education-watch-inside-a-secret-school-for-afghan-girls.jpg",
    date: "2026-08-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-inside-a-secret-school-for-afghan-girls",
    title: "Global Health and Education Watch: Inside a Secret School for Afghan Girls",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-30-global-health-and-education-watch-inside-a-secret-school-for-afghan-girls.jpg",
    date: "2026-08-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-meet-the-gen-zers-finding-job-opportunities-teaching-english",
    title: "Global Health and Education Watch: Meet the gen Zers finding job opportunities teaching English",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-30-global-health-and-education-watch-meet-the-gen-zers-finding-job-opportunities-te.jpg",
    date: "2026-08-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-judge-rules-trump-unlawfully-targeted-stanford-students-who-criticized",
    title: "Global Health and Education Watch: Judge Rules Trump Unlawfully Targeted Stanford Students Who Criticized",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-30-global-health-and-education-watch-judge-rules-trump-unlawfully-targeted-stanford.jpg",
    date: "2026-08-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-inside-america-s-rogue-stem-cell-industry",
    title: "Global Health and Education Watch: Inside America’s rogue stem cell industry",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-30-global-health-and-education-watch-inside-america-s-rogue-stem-cell-industry.jpg",
    date: "2026-08-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-reports-more-than-3-200-attacks-on-ukraine-s-healthcare",
    title: "Global Health and Education Watch: WHO reports more than 3,200 attacks on Ukraine’s healthcare",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-29-global-health-and-education-watch-who-reports-more-than-3-200-attacks-on-ukraine.jpg",
    date: "2026-08-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-in-walked-this-big-bundle-of-energy-the-day",
    title: "Global Health and Education Watch: ‘In walked this big bundle of energy’: the day",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-29-global-health-and-education-watch-in-walked-this-big-bundle-of-energy-the-day.jpg",
    date: "2026-08-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-inside-afghanistan-s-secret-schools-for-girls",
    title: "Global Health and Education Watch: Inside Afghanistan’s Secret Schools for Girls",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-29-global-health-and-education-watch-inside-afghanistan-s-secret-schools-for-girls.jpg",
    date: "2026-08-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-clive-parkinson-obituary",
    title: "Global Health and Education Watch: Clive Parkinson obituary",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-29-global-health-and-education-watch-clive-parkinson-obituary.jpg",
    date: "2026-08-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-spreads-to-two-new-zones-in-drc-60",
    title: "Global Health and Education Watch: Ebola spreads to two new zones in DRC; 60",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-29-global-health-and-education-watch-ebola-spreads-to-two-new-zones-in-drc-60.jpg",
    date: "2026-08-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-drc-begins-vaccinating-front-line-healthcare-workers-against-ebola-2",
    title: "Global Health and Education Watch: DRC begins vaccinating front-line healthcare workers against Ebola",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-28-global-health-and-education-watch-drc-begins-vaccinating-front-line-healthcare-w.jpg",
    date: "2026-08-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-drc-begins-vaccinating-front-line-healthcare-workers-against-ebola",
    title: "Global Health and Education Watch: DRC begins vaccinating front-line healthcare workers against Ebola",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-28-global-health-and-education-watch-drc-begins-vaccinating-front-line-healthcare-w.jpg",
    date: "2026-08-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-london-neurosurgeons-perform-first-successful-ai-assisted-operation-to-remove",
    title: "Global Health and Education Watch: London neurosurgeons perform first successful AI-assisted operation to remove",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-27-global-health-and-education-watch-london-neurosurgeons-perform-first-successful-.jpg",
    date: "2026-08-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-london-is-worst-area-in-england-and-wales-for",
    title: "Global Health and Education Watch: London is worst area in England and Wales for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-27-global-health-and-education-watch-london-is-worst-area-in-england-and-wales-for.jpg",
    date: "2026-08-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-more-health-workers-stronger-systems-africa-s-new-ambitious-goal",
    title: "Global Health and Education Watch: More health workers, stronger systems: Africa’s new ambitious goal",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-26-global-health-and-education-watch-more-health-workers-stronger-systems-africa-s-.jpg",
    date: "2026-08-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mpox-is-back-and-in-new-countries-how-3",
    title: "Global Health and Education Watch: Mpox is back – and in new countries. How",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-26-global-health-and-education-watch-mpox-is-back-and-in-new-countries-how.jpg",
    date: "2026-08-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mpox-is-back-and-in-new-countries-how-2",
    title: "Global Health and Education Watch: Mpox is back – and in new countries. How",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-26-global-health-and-education-watch-mpox-is-back-and-in-new-countries-how.jpg",
    date: "2026-08-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mpox-is-back-and-in-new-countries-how",
    title: "Global Health and Education Watch: Mpox is back – and in new countries. How",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-26-global-health-and-education-watch-mpox-is-back-and-in-new-countries-how.jpg",
    date: "2026-08-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-american-students-shouldn-t-be-guinea-pigs-for-chatbots",
    title: "Global Health and Education Watch: American Students Shouldn’t Be Guinea Pigs for Chatbots",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-26-global-health-and-education-watch-american-students-shouldn-t-be-guinea-pigs-for.jpg",
    date: "2026-08-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-i-just-give-from-my-heart-how-dolly-parton-s",
    title: "Global Health and Education Watch: ‘I just give from my heart’: how Dolly Parton’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-26-global-health-and-education-watch-i-just-give-from-my-heart-how-dolly-parton-s.jpg",
    date: "2026-08-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-at-least-14-newborns-die-in-hospital-fire-in",
    title: "Global Health and Education Watch: At Least 14 Newborns Die in Hospital Fire in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-26-global-health-and-education-watch-at-least-14-newborns-die-in-hospital-fire-in.jpg",
    date: "2026-08-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-two-dan-sullivans-to-appear-on-alaska-s-us-senate",
    title: "Global Health and Education Watch: Two Dan Sullivans to appear on Alaska’s US Senate",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-26-global-health-and-education-watch-two-dan-sullivans-to-appear-on-alaska-s-us-sen.jpg",
    date: "2026-08-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-instagram-chief-testifies-at-meta-trial-says-few-teens",
    title: "Global Health and Education Watch: Instagram chief testifies at Meta trial, says few teens",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-26-global-health-and-education-watch-instagram-chief-testifies-at-meta-trial-says-f.jpg",
    date: "2026-08-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-year-of-after-school-care-now-costs-2-800-a-child",
    title: "Global Health and Education Watch: Year of after-school care now costs £2,800 a child",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-26-global-health-and-education-watch-year-of-after-school-care-now-costs-2-800-a-ch.jpg",
    date: "2026-08-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ulez-has-been-a-breath-of-fresh-air-for",
    title: "Global Health and Education Watch: Ulez has been a breath of fresh air for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-26-global-health-and-education-watch-ulez-has-been-a-breath-of-fresh-air-for.jpg",
    date: "2026-08-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-two-unvaccinated-people-die-of-measles-in-us-state",
    title: "Global Health and Education Watch: Two unvaccinated people die of measles in US state",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-25-global-health-and-education-watch-two-unvaccinated-people-die-of-measles-in-us-s.jpg",
    date: "2026-08-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-one-million-children-in-afghanistan-face-deadly-malnutrition",
    title: "Global Health and Education Watch: One million children in Afghanistan face deadly malnutrition",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-25-global-health-and-education-watch-one-million-children-in-afghanistan-face-deadl.jpg",
    date: "2026-08-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-students-clash-with-police-in-india-in-a-new",
    title: "Global Health and Education Watch: Students clash with police in India in a new",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-25-global-health-and-education-watch-students-clash-with-police-in-india-in-a-new.jpg",
    date: "2026-08-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-two-unvaccinated-people-die-of-measles-in-pennsylvania",
    title: "Global Health and Education Watch: Two unvaccinated people die of measles in Pennsylvania",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-25-global-health-and-education-watch-two-unvaccinated-people-die-of-measles-in-penn.jpg",
    date: "2026-08-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-reader-q-a-international-correspondent-luke-harding-answers-your-questions",
    title: "Global Health and Education Watch: Reader Q&A: international correspondent Luke Harding answers your questions",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-25-global-health-and-education-watch-reader-q-a-international-correspondent-luke-ha.jpg",
    date: "2026-08-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-epa-aims-to-exempt-datacenters-from-disclosing-air",
    title: "Global Health and Education Watch: Trump EPA aims to exempt datacenters from disclosing air",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-25-global-health-and-education-watch-trump-epa-aims-to-exempt-datacenters-from-disc.jpg",
    date: "2026-08-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uss-abraham-lincoln-to-dock-in-thailand-next-week",
    title: "Global Health and Education Watch: USS Abraham Lincoln to dock in Thailand next week",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-25-global-health-and-education-watch-uss-abraham-lincoln-to-dock-in-thailand-next-w.jpg",
    date: "2026-08-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-standard-velvet-hangers-there-s-nothing-standard-about-some-of",
    title: "Global Health and Education Watch: ‘Standard’ velvet hangers? There’s nothing standard about some of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-25-global-health-and-education-watch-standard-velvet-hangers-there-s-nothing-standa.jpg",
    date: "2026-08-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-push-your-musical-gods-off-their-pedestals",
    title: "Global Health and Education Watch: Push Your Musical Gods Off Their Pedestals",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-25-global-health-and-education-watch-push-your-musical-gods-off-their-pedestals.jpg",
    date: "2026-08-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-new-mexico-to-continue-funding-gender-affirming-care-for-minors",
    title: "Global Health and Education Watch: New Mexico to continue funding gender-affirming care for minors",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-25-global-health-and-education-watch-new-mexico-to-continue-funding-gender-affirmin.jpg",
    date: "2026-08-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-europe-s-heatwaves-threaten-insurers-earnings-rating-agency-s-p-says-3",
    title: "Global Health and Education Watch: Europe’s heatwaves threaten insurers’ earnings, rating agency S&P says",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-25-global-health-and-education-watch-europe-s-heatwaves-threaten-insurers-earnings-.jpg",
    date: "2026-08-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-europe-s-heatwaves-threaten-insurers-earnings-rating-agency-s-p-says-2",
    title: "Global Health and Education Watch: Europe’s heatwaves threaten insurers’ earnings, rating agency S&P says",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-25-global-health-and-education-watch-europe-s-heatwaves-threaten-insurers-earnings-.jpg",
    date: "2026-08-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-europe-s-heatwaves-threaten-insurers-earnings-rating-agency-s-p-says",
    title: "Global Health and Education Watch: Europe’s heatwaves threaten insurers’ earnings, rating agency S&P says",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-25-global-health-and-education-watch-europe-s-heatwaves-threaten-insurers-earnings-.jpg",
    date: "2026-08-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-massachusetts-woman-suspected-of-killing-police-officer-husband-found",
    title: "Global Health and Education Watch: Massachusetts woman suspected of killing police officer husband found",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-25-global-health-and-education-watch-massachusetts-woman-suspected-of-killing-polic.jpg",
    date: "2026-08-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-should-huckleberry-finn-be-taught",
    title: "Global Health and Education Watch: How Should ‘Huckleberry Finn’ Be Taught?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-25-global-health-and-education-watch-how-should-huckleberry-finn-be-taught.jpg",
    date: "2026-08-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-100-days-of-ebola-and-the-race-to-stop",
    title: "Global Health and Education Watch: 100 days of Ebola and the race to stop",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-25-global-health-and-education-watch-100-days-of-ebola-and-the-race-to-stop.jpg",
    date: "2026-08-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-largest-review-of-its-kind-confirms-benefits-of-tai",
    title: "Global Health and Education Watch: Largest review of its kind confirms benefits of tai",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-24-global-health-and-education-watch-largest-review-of-its-kind-confirms-benefits-o.jpg",
    date: "2026-08-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-graduate-job-vacancies-plunge-to-lowest-in-a",
    title: "Global Health and Education Watch: UK graduate job vacancies plunge to lowest in a",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-24-global-health-and-education-watch-uk-graduate-job-vacancies-plunge-to-lowest-in-.jpg",
    date: "2026-08-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-can-we-stop-destroying-the-prospects-of-a-2",
    title: "Global Health and Education Watch: How can we stop destroying the prospects of a",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-24-global-health-and-education-watch-how-can-we-stop-destroying-the-prospects-of-a.jpg",
    date: "2026-08-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-can-we-stop-destroying-the-prospects-of-a",
    title: "Global Health and Education Watch: How can we stop destroying the prospects of a",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-24-global-health-and-education-watch-how-can-we-stop-destroying-the-prospects-of-a.jpg",
    date: "2026-08-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-alfalfa-sprouts-linked-to-food-poisoning-outbreak-in-15-states",
    title: "Global Health and Education Watch: Alfalfa sprouts linked to food-poisoning outbreak in 15 states",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-24-global-health-and-education-watch-alfalfa-sprouts-linked-to-food-poisoning-outbr.jpg",
    date: "2026-08-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-we-would-like-to-hear-from-young-people-in",
    title: "Global Health and Education Watch: We would like to hear from young people in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-24-global-health-and-education-watch-we-would-like-to-hear-from-young-people-in.jpg",
    date: "2026-08-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-you-should-know-about-college-admissions-changes",
    title: "Global Health and Education Watch: What You Should Know About College Admissions Changes",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-24-global-health-and-education-watch-what-you-should-know-about-college-admissions-.jpg",
    date: "2026-08-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-algeria-s-schools-put-shakespeare-before-moliere-in-break-from",
    title: "Global Health and Education Watch: Algeria’s schools put Shakespeare before Molière in break from",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-24-global-health-and-education-watch-algeria-s-schools-put-shakespeare-before-moli-.jpg",
    date: "2026-08-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-sudan-war-22-million-education-boost-to-help-200-000",
    title: "Global Health and Education Watch: Sudan war: $22 million education boost to help 200,000",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-24-global-health-and-education-watch-sudan-war-22-million-education-boost-to-help-2.jpg",
    date: "2026-08-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-after-100-days-of-the-deadliest-ebola-outbreak-it",
    title: "Global Health and Education Watch: After 100 days of the deadliest Ebola outbreak, it",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-24-global-health-and-education-watch-after-100-days-of-the-deadliest-ebola-outbreak.jpg",
    date: "2026-08-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-social-media-goes-into-overdrive-with-lindsay-clancy-conspiracy",
    title: "Global Health and Education Watch: Social media goes into overdrive with Lindsay Clancy conspiracy",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-24-global-health-and-education-watch-social-media-goes-into-overdrive-with-lindsay-.jpg",
    date: "2026-08-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-children-make-up-half-of-mpox-cases-in-guinea-bissau",
    title: "Global Health and Education Watch: Children make up half of mpox cases in Guinea-Bissau",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-24-global-health-and-education-watch-children-make-up-half-of-mpox-cases-in-guinea-.jpg",
    date: "2026-08-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-dreamy-ice-creams-controversial-country-houses-and-hot-health",
    title: "Global Health and Education Watch: Dreamy ice creams, controversial country houses and hot health",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-24-global-health-and-education-watch-dreamy-ice-creams-controversial-country-houses.jpg",
    date: "2026-08-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-college-students-worried-about-a-i-should-study-the-humanities",
    title: "Global Health and Education Watch: College Students Worried About A.I. Should Study the Humanities",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-24-global-health-and-education-watch-college-students-worried-about-a-i-should-stud.jpg",
    date: "2026-08-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-india-crushes-cockroach-dissent-as-fix-schools-campaign-riles",
    title: "Global Health and Education Watch: India crushes cockroach dissent as ‘Fix Schools’ campaign riles",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-24-global-health-and-education-watch-india-crushes-cockroach-dissent-as-fix-schools.jpg",
    date: "2026-08-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-air-conditioning-push-favoured-over-emissions-cuts-in-six",
    title: "Global Health and Education Watch: Air conditioning push favoured over emissions cuts in six",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-24-global-health-and-education-watch-air-conditioning-push-favoured-over-emissions-.jpg",
    date: "2026-08-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-most-english-secondary-schools-are-breaking-healthy-food-rules",
    title: "Global Health and Education Watch: Most English secondary schools are breaking healthy food rules",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-24-global-health-and-education-watch-most-english-secondary-schools-are-breaking-he.jpg",
    date: "2026-08-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-government-vows-to-make-business-rate-valuations-for-pubs",
    title: "Global Health and Education Watch: Government vows to make business rate valuations for pubs",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-24-global-health-and-education-watch-government-vows-to-make-business-rate-valuatio.jpg",
    date: "2026-08-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-eight-year-old-dies-after-contracting-rare-brain-eating-amoeba-in-louisiana",
    title: "Global Health and Education Watch: Eight-year-old dies after contracting rare brain-eating amoeba in Louisiana",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-24-global-health-and-education-watch-eight-year-old-dies-after-contracting-rare-bra.jpg",
    date: "2026-08-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-productivity-growing-faster-than-official-figures-suggest-thinktank",
    title: "Global Health and Education Watch: UK productivity growing faster than official figures suggest, thinktank",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-uk-productivity-growing-faster-than-official-f.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-fast-moving-wildfire-in-reno-nevada-forces-thousands-to-evacuate",
    title: "Global Health and Education Watch: Fast-moving wildfire in Reno, Nevada, forces thousands to evacuate",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-fast-moving-wildfire-in-reno-nevada-forces-tho.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-gaza-s-hospitals-are-running-out-of-oxygen-as-healthcare",
    title: "Global Health and Education Watch: Gaza’s hospitals are running out of oxygen as healthcare",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-gaza-s-hospitals-are-running-out-of-oxygen-as-.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-to-know-about-the-ebola-outbreak-centered-in-3",
    title: "Global Health and Education Watch: What to Know About the Ebola Outbreak Centered in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-what-to-know-about-the-ebola-outbreak-centered.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-to-know-about-the-ebola-outbreak-centered-in-2",
    title: "Global Health and Education Watch: What to Know About the Ebola Outbreak Centered in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-what-to-know-about-the-ebola-outbreak-centered.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-to-know-about-the-ebola-outbreak-centered-in",
    title: "Global Health and Education Watch: What to Know About the Ebola Outbreak Centered in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-what-to-know-about-the-ebola-outbreak-centered.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-lesson-from-canada-s-collapsed-trade-talks-with-the",
    title: "Global Health and Education Watch: The lesson from Canada’s collapsed trade talks with the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-the-lesson-from-canada-s-collapsed-trade-talks.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-it-s-unwise-to-end-local-scrutiny-of-nhs-trusts",
    title: "Global Health and Education Watch: It’s unwise to end local scrutiny of NHS trusts",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-it-s-unwise-to-end-local-scrutiny-of-nhs-trust.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-double-jeopardy-luigi-mangione-state-case-unlikely-to-proceed",
    title: "Global Health and Education Watch: Double jeopardy? Luigi Mangione state case unlikely to proceed",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-double-jeopardy-luigi-mangione-state-case-unli.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-former-abercrombie-ceo-mentally-fit-for-sex-trafficking-trial-judge",
    title: "Global Health and Education Watch: Former Abercrombie CEO mentally fit for sex-trafficking trial, judge",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-former-abercrombie-ceo-mentally-fit-for-sex-tr.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israel-s-war-on-gaza-forces-palestinians-to-rely-on-5",
    title: "Global Health and Education Watch: Israel’s war on Gaza forces Palestinians to rely on",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-israel-s-war-on-gaza-forces-palestinians-to-re.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israel-s-war-on-gaza-forces-palestinians-to-rely-on-4",
    title: "Global Health and Education Watch: Israel’s war on Gaza forces Palestinians to rely on",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-israel-s-war-on-gaza-forces-palestinians-to-re.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israel-s-war-on-gaza-forces-palestinians-to-rely-on-3",
    title: "Global Health and Education Watch: Israel’s war on Gaza forces Palestinians to rely on",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-israel-s-war-on-gaza-forces-palestinians-to-re.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israel-s-war-on-gaza-forces-palestinians-to-rely-on-2",
    title: "Global Health and Education Watch: Israel’s war on Gaza forces Palestinians to rely on",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-israel-s-war-on-gaza-forces-palestinians-to-re.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israel-s-war-on-gaza-forces-palestinians-to-rely-on",
    title: "Global Health and Education Watch: Israel’s war on Gaza forces Palestinians to rely on",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-israel-s-war-on-gaza-forces-palestinians-to-re.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-personal-care-products-are-awash-in-unlabeled-toxic-chemicals",
    title: "Global Health and Education Watch: Personal care products are awash in unlabeled toxic chemicals",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-personal-care-products-are-awash-in-unlabeled-.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-the-deadliest-bundibugyo-ebola-outbreak-can-be-stopped-2",
    title: "Global Health and Education Watch: How the deadliest Bundibugyo Ebola outbreak can be stopped",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-how-the-deadliest-bundibugyo-ebola-outbreak-ca.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-the-deadliest-bundibugyo-ebola-outbreak-can-be-stopped",
    title: "Global Health and Education Watch: How the deadliest Bundibugyo Ebola outbreak can be stopped",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-how-the-deadliest-bundibugyo-ebola-outbreak-ca.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-big-tech-captured-american-schools",
    title: "Global Health and Education Watch: How Big Tech Captured American Schools",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-how-big-tech-captured-american-schools.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-frustrated-gp-patients-hang-up-as-yorkshire-accent-baffles",
    title: "Global Health and Education Watch: Frustrated GP patients hang up as Yorkshire accent baffles",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-frustrated-gp-patients-hang-up-as-yorkshire-ac.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-london-s-low-emission-zone-is-working-so-why",
    title: "Global Health and Education Watch: London’s low emission zone is working – so why",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-london-s-low-emission-zone-is-working-so-why.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-gcse-results-almost-one-in-four-boys-in-england",
    title: "Global Health and Education Watch: GCSE results: almost one in four boys in England",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-gcse-results-almost-one-in-four-boys-in-englan.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-does-the-trump-administration-have-against-the-26th-3",
    title: "Global Health and Education Watch: What Does the Trump Administration Have Against the 26th",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-what-does-the-trump-administration-have-agains.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-in-rural-chad-solar-kiosks-bring-healthcare-closer",
    title: "Global Health and Education Watch: In rural Chad, solar kiosks bring healthcare closer",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-in-rural-chad-solar-kiosks-bring-healthcare-cl.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-does-the-trump-administration-have-against-the-26th-2",
    title: "Global Health and Education Watch: What Does the Trump Administration Have Against the 26th",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-what-does-the-trump-administration-have-agains.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-does-the-trump-administration-have-against-the-26th",
    title: "Global Health and Education Watch: What Does the Trump Administration Have Against the 26th",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-what-does-the-trump-administration-have-agains.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-australia-news-live-one-nation-mp-gives-hat-tip",
    title: "Global Health and Education Watch: Australia news live: One Nation MP gives ‘hat tip’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-23-global-health-and-education-watch-australia-news-live-one-nation-mp-gives-hat-ti.jpg",
    date: "2026-08-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-moderna-s-shift-to-cancer-company-lifts-stock-up-177",
    title: "Global Health and Education Watch: Moderna’s Shift to Cancer Company Lifts Stock Up 177%",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-moderna-s-shift-to-cancer-company-lifts-stock-.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-academic-who-accused-jason-arday-of-plagiarism-suspended-by",
    title: "Global Health and Education Watch: Academic who accused Jason Arday of plagiarism suspended by",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-academic-who-accused-jason-arday-of-plagiarism.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-swedish-police-identify-17-year-old-girl-as-victim-in-school",
    title: "Global Health and Education Watch: Swedish police identify 17-year-old girl as victim in school",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-swedish-police-identify-17-year-old-girl-as-vi.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-indiana-residents-endure-11th-day-without-power-after-storms-3",
    title: "Global Health and Education Watch: Indiana residents endure 11th day without power after storms",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-indiana-residents-endure-11th-day-without-powe.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-indiana-residents-endure-11th-day-without-power-after-storms-2",
    title: "Global Health and Education Watch: Indiana residents endure 11th day without power after storms",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-indiana-residents-endure-11th-day-without-powe.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-indiana-residents-endure-11th-day-without-power-after-storms",
    title: "Global Health and Education Watch: Indiana residents endure 11th day without power after storms",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-indiana-residents-endure-11th-day-without-powe.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-seventeen-year-old-girl-killed-in-sword-attack-at-school-in",
    title: "Global Health and Education Watch: Seventeen-year-old girl killed in sword attack at school in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-seventeen-year-old-girl-killed-in-sword-attack.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-does-harry-and-meghan-s-return-to-england-mean",
    title: "Global Health and Education Watch: What Does Harry and Meghan’s Return to England Mean",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-what-does-harry-and-meghan-s-return-to-england.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-40-000-bottles-of-eye-drops-across-the-us-recalled",
    title: "Global Health and Education Watch: 40,000 bottles of eye drops across the US recalled",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-40-000-bottles-of-eye-drops-across-the-us-reca.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-nebraska-school-district-asks-police-to-stop-using-shock",
    title: "Global Health and Education Watch: Nebraska school district asks police to stop using shock",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-nebraska-school-district-asks-police-to-stop-u.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-continues-to-spread-in-the-drc-as-16-000",
    title: "Global Health and Education Watch: Ebola continues to spread in the DRC as 16,000",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-ebola-continues-to-spread-in-the-drc-as-16-000.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-harvard-s-a-i-clones-will-hear-your-start-up-pitch-now",
    title: "Global Health and Education Watch: Harvard’s A.I. Clones Will Hear Your Start-Up Pitch Now",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-harvard-s-a-i-clones-will-hear-your-start-up-p.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-kindergarten-vaccination-rates-dip-as-exemptions-hit-record",
    title: "Global Health and Education Watch: US kindergarten vaccination rates dip as exemptions hit record",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-us-kindergarten-vaccination-rates-dip-as-exemp.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mpox-children-account-for-half-of-suspected-cases-in",
    title: "Global Health and Education Watch: Mpox: Children account for half of suspected cases in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-mpox-children-account-for-half-of-suspected-ca.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-reliability-and-validity-of-the-perceived-stress-scale-among",
    title: "Global Health and Education Watch: Reliability and validity of the Perceived Stress Scale among",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-reliability-and-validity-of-the-perceived-stre.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-it-brings-me-joy-how-young-people-are-making",
    title: "Global Health and Education Watch: ‘It brings me joy’: how young people are making",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-it-brings-me-joy-how-young-people-are-making.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-i-asked-13-college-grads-for-dorm-essentials-that",
    title: "Global Health and Education Watch: I asked 13 college grads for dorm essentials that",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-i-asked-13-college-grads-for-dorm-essentials-t.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-somalia-child-hunger-crisis-deepens-after-aid-cuts-unicef",
    title: "Global Health and Education Watch: Somalia child hunger crisis deepens after aid cuts, UNICEF",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-somalia-child-hunger-crisis-deepens-after-aid-.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cameroon-s-aging-president-returns-from-monthslong-stay-abroad",
    title: "Global Health and Education Watch: Cameroon’s Aging President Returns From Monthslong Stay Abroad",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-cameroon-s-aging-president-returns-from-months.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-strangers-in-their-own-land-mexicans-deported-from-trump-s",
    title: "Global Health and Education Watch: Strangers in their own land: Mexicans deported from Trump’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-strangers-in-their-own-land-mexicans-deported-.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-happens-to-people-s-health-when-air-pollution-is",
    title: "Global Health and Education Watch: What happens to people’s health when air pollution is",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-what-happens-to-people-s-health-when-air-pollu.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ai-for-good-how-the-un-uses-ai-to",
    title: "Global Health and Education Watch: AI for Good: How the UN uses AI to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-ai-for-good-how-the-un-uses-ai-to.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-men-with-heart-disease-at-higher-risk-of",
    title: "Global Health and Education Watch: UK men with heart disease at higher risk of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-uk-men-with-heart-disease-at-higher-risk-of.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-outrage-in-india-over-death-of-six-year-old-slapped-by",
    title: "Global Health and Education Watch: Outrage in India over death of six-year-old ‘slapped’ by",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-22-global-health-and-education-watch-outrage-in-india-over-death-of-six-year-old-sl.jpg",
    date: "2026-08-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-pakistan-s-imran-khan-back-to-prison-after-evaluation-at",
    title: "Global Health and Education Watch: Pakistan’s Imran Khan back to prison after evaluation at",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-pakistan-s-imran-khan-back-to-prison-after-eva.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-one-killed-three-wounded-in-sword-attack-at-swedish",
    title: "Global Health and Education Watch: One killed, three wounded in sword attack at Swedish",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-one-killed-three-wounded-in-sword-attack-at-sw.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-rare-south-american-diseases-offer-clues-on-the-next",
    title: "Global Health and Education Watch: Rare South American Diseases Offer Clues on the Next",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-rare-south-american-diseases-offer-clues-on-th.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ditch-the-giant-handbag-don-t-overdo-the-botox-and",
    title: "Global Health and Education Watch: Ditch the giant handbag, don’t overdo the botox and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-ditch-the-giant-handbag-don-t-overdo-the-botox.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-experts-raise-alarm-over-trump-s-public-consultation-on-vaccines",
    title: "Global Health and Education Watch: Experts raise alarm over Trump’s public consultation on vaccines",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-experts-raise-alarm-over-trump-s-public-consul.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-is-salmonella-how-does-it-spread-and-are",
    title: "Global Health and Education Watch: What is salmonella, how does it spread and are",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-what-is-salmonella-how-does-it-spread-and-are.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-dr-congo-receives-70-000-ebola-vaccine-doses-as-bundibugyo",
    title: "Global Health and Education Watch: DR Congo receives 70,000 Ebola vaccine doses as Bundibugyo",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-dr-congo-receives-70-000-ebola-vaccine-doses-a.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-dr-congo-ebola-outbreak-spreading-exponentially-un-responders-warn",
    title: "Global Health and Education Watch: DR Congo Ebola outbreak spreading exponentially, UN responders warn",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-dr-congo-ebola-outbreak-spreading-exponentiall.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-outbreak-growing-faster-wider-as-drc-death-toll",
    title: "Global Health and Education Watch: Ebola outbreak ‘growing faster, ⁠⁠wider’ as DRC death toll",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-ebola-outbreak-growing-faster-wider-as-drc-dea.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-imran-khan-is-granted-brief-hospital-visit-before-returning",
    title: "Global Health and Education Watch: Imran Khan Is Granted Brief Hospital Visit Before Returning",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-imran-khan-is-granted-brief-hospital-visit-bef.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-first-thing-us-aircraft-carrier-arrives-to-relieve-uss",
    title: "Global Health and Education Watch: First Thing: US aircraft carrier arrives to relieve USS",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-first-thing-us-aircraft-carrier-arrives-to-rel.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-harvard-s-epic-fight-with-trump-is-costing-the",
    title: "Global Health and Education Watch: How Harvard’s Epic Fight With Trump Is Costing the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-how-harvard-s-epic-fight-with-trump-is-costing.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-outbreak-five-big-questions",
    title: "Global Health and Education Watch: Ebola outbreak: five big questions",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-ebola-outbreak-five-big-questions.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-burnham-to-chair-growth-meeting-call-at-no-10",
    title: "Global Health and Education Watch: Burnham to chair growth meeting call at No 10",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-burnham-to-chair-growth-meeting-call-at-no-10.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-dr-tiktok-mental-health-moves-from-consulting-rooms-to",
    title: "Global Health and Education Watch: Dr TikTok: Mental health moves from consulting rooms to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-dr-tiktok-mental-health-moves-from-consulting-.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-jailed-ex-pakistan-pm-imran-khan-allowed-brief-hospital-visit",
    title: "Global Health and Education Watch: Jailed ex-Pakistan PM Imran Khan allowed brief hospital visit",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-jailed-ex-pakistan-pm-imran-khan-allowed-brief.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-academic-who-publicized-plagiarism-allegations-against-jason-arday-is",
    title: "Global Health and Education Watch: Academic Who Publicized Plagiarism Allegations Against Jason Arday Is",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-academic-who-publicized-plagiarism-allegations.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-brains-of-wellbeing-beauty-2026-3",
    title: "Global Health and Education Watch: The Brains of Wellbeing & Beauty 2026",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-the-brains-of-wellbeing-beauty-2026.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-brains-of-wellbeing-beauty-2026-2",
    title: "Global Health and Education Watch: The Brains of Wellbeing & Beauty 2026",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-the-brains-of-wellbeing-beauty-2026.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-brains-of-wellbeing-beauty-2026",
    title: "Global Health and Education Watch: The Brains of Wellbeing & Beauty 2026",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-the-brains-of-wellbeing-beauty-2026.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-guardian-view-on-gcse-results-much-to-celebrate",
    title: "Global Health and Education Watch: The Guardian view on GCSE results: much to celebrate",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-21-global-health-and-education-watch-the-guardian-view-on-gcse-results-much-to-cele.jpg",
    date: "2026-08-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-leaders-attack-demotivating-plan-to-make-pupils-who-fail",
    title: "Global Health and Education Watch: Leaders attack ‘demotivating’ plan to make pupils who fail",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-leaders-attack-demotivating-plan-to-make-pupil.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-pakistan-s-ex-pm-imran-khan-reportedly-moved-to-hospital-from",
    title: "Global Health and Education Watch: Pakistan’s ex-PM Imran Khan reportedly moved to hospital from",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-pakistan-s-ex-pm-imran-khan-reportedly-moved-t.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-dr-congo-to-receive-70-000-doses-of-ervebo-vaccine",
    title: "Global Health and Education Watch: DR Congo to receive 70,000 doses of Ervebo vaccine",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-dr-congo-to-receive-70-000-doses-of-ervebo-vac.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-university-suspends-us-academic-leading-jason-arday-plagiarism-accusations-2",
    title: "Global Health and Education Watch: University suspends US academic leading Jason Arday plagiarism accusations",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-university-suspends-us-academic-leading-jason-.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-university-suspends-us-academic-leading-jason-arday-plagiarism-accusations",
    title: "Global Health and Education Watch: University suspends US academic leading Jason Arday plagiarism accusations",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-university-suspends-us-academic-leading-jason-.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-guardian-view-on-trump-s-mmr-executive-order-endangering",
    title: "Global Health and Education Watch: The Guardian view on Trump’s MMR executive order: endangering",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-the-guardian-view-on-trump-s-mmr-executive-ord.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mamdani-sues-city-council-over-10-000-bonuses-to-teachers",
    title: "Global Health and Education Watch: Mamdani Sues City Council Over $10,000 Bonuses to Teachers’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-mamdani-sues-city-council-over-10-000-bonuses-.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-kat-chan-eating-your-way-to-better-health",
    title: "Global Health and Education Watch: Kat Chan: eating your way to better health",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-kat-chan-eating-your-way-to-better-health.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-burnham-announces-plans-to-clean-up-illegal-waste-dumps",
    title: "Global Health and Education Watch: Burnham announces plans to clean up illegal waste dumps",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-burnham-announces-plans-to-clean-up-illegal-wa.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-solidarity-is-essential-in-a-more-transactional-global-health-2",
    title: "Global Health and Education Watch: Solidarity is essential in a more transactional global health",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-solidarity-is-essential-in-a-more-transactiona.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-gcse-results-hundreds-of-thousands-of-pupils-across-england",
    title: "Global Health and Education Watch: GCSE results: hundreds of thousands of pupils across England",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-gcse-results-hundreds-of-thousands-of-pupils-a.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-kyiv-comes-under-heavy-russian-missile-attack-killing-at",
    title: "Global Health and Education Watch: Kyiv comes under heavy Russian missile attack, killing at",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-kyiv-comes-under-heavy-russian-missile-attack-.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-moderna-merck-say-mrna-vaccine-prevents-melanoma-from-returning",
    title: "Global Health and Education Watch: Moderna, Merck Say mRNA Vaccine Prevents Melanoma From Returning",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-moderna-merck-say-mrna-vaccine-prevents-melano.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-moderna-pins-hopes-on-mrna-game-changer-for-cancer-vaccines",
    title: "Global Health and Education Watch: Moderna pins hopes on mRNA ‘game-changer’ for cancer vaccines",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-moderna-pins-hopes-on-mrna-game-changer-for-ca.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-love-you-to-death-review-is-this-all-5",
    title: "Global Health and Education Watch: Love You to Death review – is this all",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-love-you-to-death-review-is-this-all.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-love-you-to-death-review-is-this-all-4",
    title: "Global Health and Education Watch: Love You to Death review – is this all",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-love-you-to-death-review-is-this-all.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-love-you-to-death-review-is-this-all-3",
    title: "Global Health and Education Watch: Love You to Death review – is this all",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-love-you-to-death-review-is-this-all.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-solidarity-is-essential-in-a-more-transactional-global-health",
    title: "Global Health and Education Watch: Solidarity is essential in a more transactional global health",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-solidarity-is-essential-in-a-more-transactiona.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-love-you-to-death-review-is-this-all-2",
    title: "Global Health and Education Watch: Love You to Death review – is this all",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-love-you-to-death-review-is-this-all.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-love-you-to-death-review-is-this-all",
    title: "Global Health and Education Watch: Love You to Death review – is this all",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-love-you-to-death-review-is-this-all.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-harvard-agrees-to-53-million-settlement-in-body-part",
    title: "Global Health and Education Watch: Harvard Agrees to $53 Million Settlement in Body Part",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-20-global-health-and-education-watch-harvard-agrees-to-53-million-settlement-in-bod.jpg",
    date: "2026-08-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-at-43-i-was-fit-and-happy-then-i",
    title: "Global Health and Education Watch: At 43, I was fit and happy. Then I",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-19-global-health-and-education-watch-at-43-i-was-fit-and-happy-then-i.jpg",
    date: "2026-08-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-guardian-view-on-the-ebola-outbreak-in-the",
    title: "Global Health and Education Watch: The Guardian view on the Ebola outbreak in the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-19-global-health-and-education-watch-the-guardian-view-on-the-ebola-outbreak-in-the.jpg",
    date: "2026-08-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-compulsory-gcse-resits-in-england-harm-teenagers-mental-wellbeing",
    title: "Global Health and Education Watch: Compulsory GCSE resits in England harm teenagers’ mental wellbeing",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-19-global-health-and-education-watch-compulsory-gcse-resits-in-england-harm-teenage.jpg",
    date: "2026-08-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-nominates-heidi-overton-to-lead-us-food-and-2",
    title: "Global Health and Education Watch: Trump nominates Heidi Overton to lead US Food and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-19-global-health-and-education-watch-trump-nominates-heidi-overton-to-lead-us-food-.jpg",
    date: "2026-08-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-nominates-heidi-overton-to-lead-us-food-and",
    title: "Global Health and Education Watch: Trump nominates Heidi Overton to lead US Food and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-19-global-health-and-education-watch-trump-nominates-heidi-overton-to-lead-us-food-.jpg",
    date: "2026-08-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-brazil-bus-crash-kills-at-least-23-and-injures",
    title: "Global Health and Education Watch: Brazil bus crash kills at least 23 and injures",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-19-global-health-and-education-watch-brazil-bus-crash-kills-at-least-23-and-injures.jpg",
    date: "2026-08-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-nominates-abortion-opponent-heidi-overton-to-be-head",
    title: "Global Health and Education Watch: Trump nominates abortion opponent Heidi Overton to be head",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-19-global-health-and-education-watch-trump-nominates-abortion-opponent-heidi-overto.jpg",
    date: "2026-08-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-american-hiker-dies-after-lightning-strike-on-mount-etna",
    title: "Global Health and Education Watch: American Hiker Dies After Lightning Strike on Mount Etna",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-19-global-health-and-education-watch-american-hiker-dies-after-lightning-strike-on-.jpg",
    date: "2026-08-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-moderna-share-price-doubles-on-melanoma-vaccine-trial-success",
    title: "Global Health and Education Watch: Moderna share price doubles on melanoma vaccine trial success",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-19-global-health-and-education-watch-moderna-share-price-doubles-on-melanoma-vaccin.jpg",
    date: "2026-08-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-medical-researcher-who-touted-covid-cure-and-was-hailed",
    title: "Global Health and Education Watch: Medical researcher who touted Covid ‘cure’ and was hailed",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-19-global-health-and-education-watch-medical-researcher-who-touted-covid-cure-and-w.jpg",
    date: "2026-08-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-it-s-easy-to-slip-into-the-negatives-students-on",
    title: "Global Health and Education Watch: ‘It’s easy to slip into the negatives’: students on",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-19-global-health-and-education-watch-it-s-easy-to-slip-into-the-negatives-students-.jpg",
    date: "2026-08-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-asia-s-longevity-gains-must-be-translated-into-better-health",
    title: "Global Health and Education Watch: Asia’s longevity gains must be translated into better health",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-19-global-health-and-education-watch-asia-s-longevity-gains-must-be-translated-into.jpg",
    date: "2026-08-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-unions-sue-over-new-visa-rule-for-foreign",
    title: "Global Health and Education Watch: US unions sue over new visa rule for foreign",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-19-global-health-and-education-watch-us-unions-sue-over-new-visa-rule-for-foreign.jpg",
    date: "2026-08-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-introducing-ulez-was-my-hardest-decision-as-mayor-of",
    title: "Global Health and Education Watch: Introducing Ulez was my hardest decision as mayor of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-19-global-health-and-education-watch-introducing-ulez-was-my-hardest-decision-as-ma.jpg",
    date: "2026-08-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-to-nominate-heidi-overton-a-top-domestic-policy",
    title: "Global Health and Education Watch: Trump to Nominate Heidi Overton, a Top Domestic Policy",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-19-global-health-and-education-watch-trump-to-nominate-heidi-overton-a-top-domestic.jpg",
    date: "2026-08-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-gps-advice-service-is-causing-cancer-diagnoses-to-be",
    title: "Global Health and Education Watch: GPs’ advice service is causing cancer diagnoses to be",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-19-global-health-and-education-watch-gps-advice-service-is-causing-cancer-diagnoses.jpg",
    date: "2026-08-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-one-person-dead-and-more-than-200-ill-in",
    title: "Global Health and Education Watch: One person dead and more than 200 ill in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-19-global-health-and-education-watch-one-person-dead-and-more-than-200-ill-in.jpg",
    date: "2026-08-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-officials-ignored-their-own-university-investigations-lawyer-says",
    title: "Global Health and Education Watch: Trump Officials Ignored Their Own University Investigations, Lawyer Says",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-19-global-health-and-education-watch-trump-officials-ignored-their-own-university-i.jpg",
    date: "2026-08-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-london-s-clean-air-zone-linked-to-improvement-in-children-s",
    title: "Global Health and Education Watch: London’s clean air zone linked to improvement in children’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-19-global-health-and-education-watch-london-s-clean-air-zone-linked-to-improvement-.jpg",
    date: "2026-08-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-dr-congo-s-ebola-outbreak-global-emergency-as-infections-pass",
    title: "Global Health and Education Watch: DR Congo’s Ebola outbreak ‘global emergency’ as infections pass",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-18-global-health-and-education-watch-dr-congo-s-ebola-outbreak-global-emergency-as-.jpg",
    date: "2026-08-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-ebola-can-be-contained-in-months-if-enough",
    title: "Global Health and Education Watch: WHO: Ebola can be contained in months if enough",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-18-global-health-and-education-watch-who-ebola-can-be-contained-in-months-if-enough.jpg",
    date: "2026-08-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-more-u-s-parents-opting-children-out-of-vaccine-requirements-3",
    title: "Global Health and Education Watch: More U.S. Parents Opting Children Out of Vaccine Requirements",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-18-global-health-and-education-watch-more-u-s-parents-opting-children-out-of-vaccin.jpg",
    date: "2026-08-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-more-u-s-parents-opting-children-out-of-vaccine-requirements-2",
    title: "Global Health and Education Watch: More U.S. Parents Opting Children Out of Vaccine Requirements",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-18-global-health-and-education-watch-more-u-s-parents-opting-children-out-of-vaccin.jpg",
    date: "2026-08-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-more-u-s-parents-opting-children-out-of-vaccine-requirements",
    title: "Global Health and Education Watch: More U.S. Parents Opting Children Out of Vaccine Requirements",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-18-global-health-and-education-watch-more-u-s-parents-opting-children-out-of-vaccin.jpg",
    date: "2026-08-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tracking-funding-disparities-in-global-health-aid-with-machine",
    title: "Global Health and Education Watch: Tracking funding disparities in global health aid with machine",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-18-global-health-and-education-watch-tracking-funding-disparities-in-global-health-.jpg",
    date: "2026-08-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-philippine-school-shooter-kills-fellow-student-and-himself-in",
    title: "Global Health and Education Watch: Philippine school shooter kills fellow student and himself in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-18-global-health-and-education-watch-philippine-school-shooter-kills-fellow-student.jpg",
    date: "2026-08-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-motorbike-riders-carrying-the-sick-may-hold-key",
    title: "Global Health and Education Watch: Ebola: Motorbike riders carrying the sick may hold key",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-18-global-health-and-education-watch-ebola-motorbike-riders-carrying-the-sick-may-h.jpg",
    date: "2026-08-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-2-0-has-deleted-or-altered-nearly-400-us",
    title: "Global Health and Education Watch: Trump 2.0 has deleted or altered nearly 400 US",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-18-global-health-and-education-watch-trump-2-0-has-deleted-or-altered-nearly-400-us.jpg",
    date: "2026-08-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-india-s-cockroach-movement-makes-schools-next-battleground-against-modi",
    title: "Global Health and Education Watch: India’s ‘Cockroach’ movement makes schools next battleground against Modi",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-18-global-health-and-education-watch-india-s-cockroach-movement-makes-schools-next-.jpg",
    date: "2026-08-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-texas-tech-university-is-using-a-i-to-cut-left-leaning",
    title: "Global Health and Education Watch: Texas Tech University Is Using A.I. to Cut Left-Leaning",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-18-global-health-and-education-watch-texas-tech-university-is-using-a-i-to-cut-left.jpg",
    date: "2026-08-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-too-hot-to-sleep-how-heatwaves-at-night-affect",
    title: "Global Health and Education Watch: Too hot to sleep? How heatwaves at night affect",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-18-global-health-and-education-watch-too-hot-to-sleep-how-heatwaves-at-night-affect.jpg",
    date: "2026-08-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-student-bank-accounts-don-t-be-swayed-by-the-freebies",
    title: "Global Health and Education Watch: Student bank accounts: don’t be swayed by the freebies",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-18-global-health-and-education-watch-student-bank-accounts-don-t-be-swayed-by-the-f.jpg",
    date: "2026-08-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tuesday-briefing-what-the-simon-levy-case-tells-us",
    title: "Global Health and Education Watch: Tuesday briefing: What the Simon Levy case tells us",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-18-global-health-and-education-watch-tuesday-briefing-what-the-simon-levy-case-tell.jpg",
    date: "2026-08-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-top-economists-urge-burnham-to-sign-uk-up-to",
    title: "Global Health and Education Watch: Top economists urge Burnham to sign UK up to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-18-global-health-and-education-watch-top-economists-urge-burnham-to-sign-uk-up-to.jpg",
    date: "2026-08-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-spend-more-on-vet-services-to-curb-pandemic-threat",
    title: "Global Health and Education Watch: Spend more on vet services to curb pandemic threat",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-18-global-health-and-education-watch-spend-more-on-vet-services-to-curb-pandemic-th.jpg",
    date: "2026-08-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-two-killed-as-student-opens-fire-at-philippines-high",
    title: "Global Health and Education Watch: Two killed as student opens fire at Philippines high",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-18-global-health-and-education-watch-two-killed-as-student-opens-fire-at-philippine.jpg",
    date: "2026-08-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-do-students-lose-when-they-stop-writing",
    title: "Global Health and Education Watch: What Do Students Lose When They Stop Writing?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-18-global-health-and-education-watch-what-do-students-lose-when-they-stop-writing.jpg",
    date: "2026-08-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-outbreak-becomes-deadliest-in-dr-congo-s-history",
    title: "Global Health and Education Watch: Ebola outbreak becomes deadliest in DR Congo’s history",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-18-global-health-and-education-watch-ebola-outbreak-becomes-deadliest-in-dr-congo-s.jpg",
    date: "2026-08-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-extreme-heat-more-dangerous-for-people-60-and-over-3",
    title: "Global Health and Education Watch: Extreme heat more dangerous for people 60 and over",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-extreme-heat-more-dangerous-for-people-60-and-.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-extreme-heat-more-dangerous-for-people-60-and-over-2",
    title: "Global Health and Education Watch: Extreme heat more dangerous for people 60 and over",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-extreme-heat-more-dangerous-for-people-60-and-.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-extreme-heat-more-dangerous-for-people-60-and-over",
    title: "Global Health and Education Watch: Extreme heat more dangerous for people 60 and over",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-extreme-heat-more-dangerous-for-people-60-and-.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-says-kim-jong-un-has-responded-to-his-overtures",
    title: "Global Health and Education Watch: Trump says Kim Jong-un has responded to his overtures",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-trump-says-kim-jong-un-has-responded-to-his-ov.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-i-let-my-students-watch-me-struggle-with-a",
    title: "Global Health and Education Watch: I Let My Students Watch Me Struggle With a",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-i-let-my-students-watch-me-struggle-with-a.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-one-woman-with-a-very-rare-disease-secured",
    title: "Global Health and Education Watch: How One Woman With a Very Rare Disease Secured",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-how-one-woman-with-a-very-rare-disease-secured.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-explosion-reported-at-school-in-afghan-capital-kabul",
    title: "Global Health and Education Watch: Explosion reported at school in Afghan capital Kabul",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-explosion-reported-at-school-in-afghan-capital.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-support-for-jason-arday-s-family-shows-britain-still-cares",
    title: "Global Health and Education Watch: Support for Jason Arday’s family shows ‘Britain still cares’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-support-for-jason-arday-s-family-shows-britain.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-louisiana-s-new-surgeon-general-wants-to-transform-public",
    title: "Global Health and Education Watch: How Louisiana’s New Surgeon General Wants to Transform Public",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-how-louisiana-s-new-surgeon-general-wants-to-t.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-outbreak-becomes-dr-congo-s-deadliest",
    title: "Global Health and Education Watch: Ebola outbreak becomes DR Congo’s deadliest",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-ebola-outbreak-becomes-dr-congo-s-deadliest.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-share-your-experiences-with-the-public-health-system-in",
    title: "Global Health and Education Watch: Share Your Experiences With the Public Health System in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-share-your-experiences-with-the-public-health-.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-photos-rising-energy-prices-disrupt-education-on-cambodia-s-tonle-2",
    title: "Global Health and Education Watch: Photos: Rising energy prices disrupt education on Cambodia’s Tonle",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-photos-rising-energy-prices-disrupt-education-.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-photos-rising-energy-prices-disrupt-education-on-cambodia-s-tonle",
    title: "Global Health and Education Watch: Photos: Rising energy prices disrupt education on Cambodia’s Tonle",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-photos-rising-energy-prices-disrupt-education-.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-alzheimer-s-research-is-latest-casualty-in-trump-administration-war",
    title: "Global Health and Education Watch: Alzheimer’s research is latest casualty in Trump administration war",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-alzheimer-s-research-is-latest-casualty-in-tru.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-cuts-us-south-korea-military-drills-citing-good-relationship",
    title: "Global Health and Education Watch: Trump cuts US-South Korea military drills citing ‘good relationship",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-trump-cuts-us-south-korea-military-drills-citi.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-developmental-benchmarks-of-executive-function-reveal-sensitive-periods-for",
    title: "Global Health and Education Watch: Developmental benchmarks of executive function reveal sensitive periods for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-developmental-benchmarks-of-executive-function.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-nothing-less-than-radical-whole-system-change-is-required-to",
    title: "Global Health and Education Watch: Nothing less than radical whole-system change is required to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-nothing-less-than-radical-whole-system-change-.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-monday-briefing-what-can-andy-burnham-learn-from-spain-s",
    title: "Global Health and Education Watch: Monday briefing: What can Andy Burnham learn from Spain’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-monday-briefing-what-can-andy-burnham-learn-fr.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-covid-vaccine-and-pregnancy-what-to-know-now",
    title: "Global Health and Education Watch: Covid Vaccine and Pregnancy: What to Know Now",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-covid-vaccine-and-pregnancy-what-to-know-now.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-outbreak-in-dr-congo-becomes-deadliest-in-country-s",
    title: "Global Health and Education Watch: Ebola outbreak in DR Congo becomes deadliest in country’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-ebola-outbreak-in-dr-congo-becomes-deadliest-i.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-california-law-would-force-companies-to-disclose-toxic-chemicals",
    title: "Global Health and Education Watch: California law would force companies to disclose toxic chemicals",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-california-law-would-force-companies-to-disclo.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-all-aboard-the-cervical-screening-bus-how-nhs-clinic-on-wheels",
    title: "Global Health and Education Watch: All aboard the cervical screening bus: how NHS clinic-on-wheels",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-all-aboard-the-cervical-screening-bus-how-nhs-.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-orders-cuts-to-south-korea-joint-drills-despite",
    title: "Global Health and Education Watch: Trump orders cuts to South Korea joint drills despite",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-trump-orders-cuts-to-south-korea-joint-drills-.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-outbreak-in-democratic-republic-of-congo-now-deadliest",
    title: "Global Health and Education Watch: Ebola outbreak in Democratic Republic of Congo now deadliest",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-17-global-health-and-education-watch-ebola-outbreak-in-democratic-republic-of-congo.jpg",
    date: "2026-08-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-it-was-barbaric-i-was-crying-my-eyes-out",
    title: "Global Health and Education Watch: ‘It was barbaric. I was crying my eyes out’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-it-was-barbaric-i-was-crying-my-eyes-out.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-suspect-in-virginia-state-university-shooting-found-hiding-in",
    title: "Global Health and Education Watch: Suspect in Virginia State University shooting found hiding in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-suspect-in-virginia-state-university-shooting-.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-admiral-praises-uss-lincoln-crew-amid-reported-mental",
    title: "Global Health and Education Watch: US admiral praises USS Lincoln crew amid reported mental",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-us-admiral-praises-uss-lincoln-crew-amid-repor.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-republican-senator-denounces-trump-s-crazy-stupid-claims-about-mmr",
    title: "Global Health and Education Watch: Republican senator denounces Trump’s ‘crazy, stupid’ claims about MMR",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-republican-senator-denounces-trump-s-crazy-stu.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-women-should-not-have-to-travel-for-hours-to",
    title: "Global Health and Education Watch: Women should not have to travel for hours to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-women-should-not-have-to-travel-for-hours-to.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-this-is-the-solution-to-america-s-literacy-crisis-and",
    title: "Global Health and Education Watch: This Is the Solution to America’s Literacy Crisis, and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-this-is-the-solution-to-america-s-literacy-cri.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-democrats-demand-answers-from-trump-on-uss-abraham-lincoln",
    title: "Global Health and Education Watch: Democrats demand answers from Trump on USS Abraham Lincoln",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-democrats-demand-answers-from-trump-on-uss-abr.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cambridge-university-defends-its-mental-health-support-for-jason-3",
    title: "Global Health and Education Watch: Cambridge University defends its mental health support for Jason",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-cambridge-university-defends-its-mental-health.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cambridge-university-defends-its-mental-health-support-for-jason-2",
    title: "Global Health and Education Watch: Cambridge University defends its mental health support for Jason",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-cambridge-university-defends-its-mental-health.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cambridge-university-defends-its-mental-health-support-for-jason",
    title: "Global Health and Education Watch: Cambridge University defends its mental health support for Jason",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-cambridge-university-defends-its-mental-health.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-patients-treated-in-tents-after-earthquake-damages-indonesia-hospital-3",
    title: "Global Health and Education Watch: Patients treated in tents after earthquake damages Indonesia hospital",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-patients-treated-in-tents-after-earthquake-dam.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-patients-treated-in-tents-after-earthquake-damages-indonesia-hospital-2",
    title: "Global Health and Education Watch: Patients treated in tents after earthquake damages Indonesia hospital",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-patients-treated-in-tents-after-earthquake-dam.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-patients-treated-in-tents-after-earthquake-damages-indonesia-hospital",
    title: "Global Health and Education Watch: Patients treated in tents after earthquake damages Indonesia hospital",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-patients-treated-in-tents-after-earthquake-dam.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-cancer-not-cost-of-living-may-be-the",
    title: "Global Health and Education Watch: Why cancer, not cost of living, may be the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-why-cancer-not-cost-of-living-may-be-the.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ai-cheating-leaked-papers-and-marking-errors-how-exam",
    title: "Global Health and Education Watch: AI cheating, leaked papers and marking errors: how exam",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-ai-cheating-leaked-papers-and-marking-errors-h.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cholera-outbreak-sickens-over-90-in-myanmar-s-biggest-city",
    title: "Global Health and Education Watch: Cholera Outbreak Sickens Over 90 in Myanmar’s Biggest City",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-cholera-outbreak-sickens-over-90-in-myanmar-s-.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-our-children-are-less-cognitively-capable-says-neuroscientist-who-3",
    title: "Global Health and Education Watch: ‘Our children are less cognitively capable,’ says neuroscientist who",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-our-children-are-less-cognitively-capable-says.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-our-children-are-less-cognitively-capable-says-neuroscientist-who-2",
    title: "Global Health and Education Watch: ‘Our children are less cognitively capable,’ says neuroscientist who",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-our-children-are-less-cognitively-capable-says.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-our-children-are-less-cognitively-capable-says-neuroscientist-who",
    title: "Global Health and Education Watch: ‘Our children are less cognitively capable,’ says neuroscientist who",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-our-children-are-less-cognitively-capable-says.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-environmental-treaties-must-also-address-mental-health",
    title: "Global Health and Education Watch: Why environmental treaties must also address mental health",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-why-environmental-treaties-must-also-address-m.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-dangerously-hostile-heatwaves-leave-hospital-wards-unsafe-data-reveals",
    title: "Global Health and Education Watch: ‘Dangerously hostile’: heatwaves leave hospital wards unsafe, data reveals",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-dangerously-hostile-heatwaves-leave-hospital-w.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-is-the-latest-ebola-outbreak-worsening",
    title: "Global Health and Education Watch: Why is the latest Ebola outbreak worsening?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-why-is-the-latest-ebola-outbreak-worsening.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-watch-your-spending-use-free-perks-an-insider-s-tips",
    title: "Global Health and Education Watch: ‘Watch your spending, use free perks’: an insider’s tips",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-watch-your-spending-use-free-perks-an-insider-.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-from-food-to-tech-to-travel-the-best-student",
    title: "Global Health and Education Watch: From food to tech to travel: the best student",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-from-food-to-tech-to-travel-the-best-student.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israeli-strikes-in-lebanon-kill-11-health-officials-say",
    title: "Global Health and Education Watch: Israeli Strikes in Lebanon Kill 11, Health Officials Say",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-israeli-strikes-in-lebanon-kill-11-health-offi.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-where-the-teacher-is-a-hero",
    title: "Global Health and Education Watch: Where the Teacher Is a Hero",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-16-global-health-and-education-watch-where-the-teacher-is-a-hero.jpg",
    date: "2026-08-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-drc-s-fast-growing-ebola-outbreak-spreads-to-sixth-province",
    title: "Global Health and Education Watch: DRC’s fast-growing Ebola outbreak spreads to sixth province",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-drc-s-fast-growing-ebola-outbreak-spreads-to-s.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-body-found-in-romania-believed-to-be-missing-british",
    title: "Global Health and Education Watch: Body found in Romania believed to be missing British",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-body-found-in-romania-believed-to-be-missing-b.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-five-wounded-in-shooting-at-virginia-state-university-multiple",
    title: "Global Health and Education Watch: Five wounded in shooting at Virginia State University, multiple",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-five-wounded-in-shooting-at-virginia-state-uni.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-massive-egg-recall-in-us-south-and-south-west-due",
    title: "Global Health and Education Watch: Massive egg recall in US south and south-west due",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-massive-egg-recall-in-us-south-and-south-west-.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-outrage-at-unitedhealth-and-other-insurers-persists-after-brian",
    title: "Global Health and Education Watch: Outrage at UnitedHealth and Other Insurers Persists After Brian",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-outrage-at-unitedhealth-and-other-insurers-per.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-jason-arday-professor-at-centre-of-cambridge-plagiarism-row",
    title: "Global Health and Education Watch: Jason Arday, professor at centre of Cambridge plagiarism row",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-jason-arday-professor-at-centre-of-cambridge-p.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tributes-paid-to-jason-arday-after-former-cambridge-professor-s-3",
    title: "Global Health and Education Watch: Tributes paid to Jason Arday after former Cambridge professor’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-tributes-paid-to-jason-arday-after-former-camb.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tributes-paid-to-jason-arday-after-former-cambridge-professor-s-2",
    title: "Global Health and Education Watch: Tributes paid to Jason Arday after former Cambridge professor’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-tributes-paid-to-jason-arday-after-former-camb.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tributes-paid-to-jason-arday-after-former-cambridge-professor-s",
    title: "Global Health and Education Watch: Tributes paid to Jason Arday after former Cambridge professor’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-tributes-paid-to-jason-arday-after-former-camb.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-multiple-people-injured-in-shooting-at-virginia-state-university",
    title: "Global Health and Education Watch: Multiple people injured in shooting at Virginia State University",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-multiple-people-injured-in-shooting-at-virgini.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cheap-travel-is-not-a-defence-the-parents-facing",
    title: "Global Health and Education Watch: ‘Cheap travel is not a defence’: the parents facing",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-cheap-travel-is-not-a-defence-the-parents-faci.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-black-professor-at-centre-of-cambridge-plagiarism-row-found",
    title: "Global Health and Education Watch: Black professor at centre of Cambridge plagiarism row found",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-black-professor-at-centre-of-cambridge-plagiar.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-navy-veterans-and-military-health-experts-express-concern",
    title: "Global Health and Education Watch: US navy veterans and military health experts express concern",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-us-navy-veterans-and-military-health-experts-e.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-professor-s-death-leaves-behind-hard-questions-for-cambridge-on",
    title: "Global Health and Education Watch: Professor’s Death Leaves Behind Hard Questions for Cambridge on",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-professor-s-death-leaves-behind-hard-questions.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-sudan-the-harrowing-reality-of-giving-birth-in-a",
    title: "Global Health and Education Watch: Sudan: The harrowing reality of giving birth in a",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-sudan-the-harrowing-reality-of-giving-birth-in.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-american-missionary-kidnapped-in-niger-freed-after-nine-months",
    title: "Global Health and Education Watch: American missionary kidnapped in Niger freed after nine months",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-american-missionary-kidnapped-in-niger-freed-a.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-iceberg-romaine-kale-which-salad-greens-are-healthiest",
    title: "Global Health and Education Watch: Iceberg, romaine, kale: which salad greens are healthiest?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-iceberg-romaine-kale-which-salad-greens-are-he.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-canadian-plasma-clinics-pause-collections-after-deaths-of-two",
    title: "Global Health and Education Watch: Canadian plasma clinics pause collections after deaths of two",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-canadian-plasma-clinics-pause-collections-afte.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-we-know-about-the-crisis-aboard-the-uss",
    title: "Global Health and Education Watch: What we know about the crisis aboard the USS",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-what-we-know-about-the-crisis-aboard-the-uss.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-a-sudanese-refugee-became-a-head-teacher-in",
    title: "Global Health and Education Watch: How a Sudanese refugee became a head teacher in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-how-a-sudanese-refugee-became-a-head-teacher-i.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-brazil-s-disease-fighting-mosquitoes",
    title: "Global Health and Education Watch: Brazil’s Disease-Fighting Mosquitoes",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-brazil-s-disease-fighting-mosquitoes.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-is-winning-epidemic-now-killing-one-person-every",
    title: "Global Health and Education Watch: ‘Ebola is winning’: Epidemic now killing one person every",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-ebola-is-winning-epidemic-now-killing-one-pers.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-warned-but-not-protected-four-in-ten-adults-in",
    title: "Global Health and Education Watch: ‘Warned but not protected’: Four in ten adults in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-warned-but-not-protected-four-in-ten-adults-in.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-dismisses-mental-health-concerns-on-uss-lincoln-aircraft",
    title: "Global Health and Education Watch: Trump dismisses mental health concerns on USS Lincoln aircraft",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-15-global-health-and-education-watch-trump-dismisses-mental-health-concerns-on-uss-.jpg",
    date: "2026-08-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-downplays-concerns-about-sailors-onboard-uss-abraham-lincoln",
    title: "Global Health and Education Watch: Trump downplays concerns about sailors onboard USS Abraham Lincoln",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-14-global-health-and-education-watch-trump-downplays-concerns-about-sailors-onboard.jpg",
    date: "2026-08-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-downplays-concerns-about-sailors-aboard-uss-abraham-lincoln-2",
    title: "Global Health and Education Watch: Trump downplays concerns about sailors aboard USS Abraham Lincoln",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-14-global-health-and-education-watch-trump-downplays-concerns-about-sailors-aboard-.jpg",
    date: "2026-08-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-downplays-concerns-about-sailors-aboard-uss-abraham-lincoln",
    title: "Global Health and Education Watch: Trump downplays concerns about sailors aboard USS Abraham Lincoln",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-14-global-health-and-education-watch-trump-downplays-concerns-about-sailors-aboard-.jpg",
    date: "2026-08-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-an-attack-on-healthcare-every-six-hours-and-no",
    title: "Global Health and Education Watch: An attack on healthcare every six hours, and no",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-14-global-health-and-education-watch-an-attack-on-healthcare-every-six-hours-and-no.jpg",
    date: "2026-08-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-luigi-mangione-pleads-guilty-in-unitedhealthcare-ceo-s-killing",
    title: "Global Health and Education Watch: Luigi Mangione pleads guilty in UnitedHealthcare CEO’s killing",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-14-global-health-and-education-watch-luigi-mangione-pleads-guilty-in-unitedhealthca.jpg",
    date: "2026-08-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-google-turns-on-gemini-a-i-for-students-using-its",
    title: "Global Health and Education Watch: Google Turns On Gemini A.I. for Students Using Its",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-14-global-health-and-education-watch-google-turns-on-gemini-a-i-for-students-using-.jpg",
    date: "2026-08-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-we-re-seeing-lots-of-people-who-feel-dizzy-how",
    title: "Global Health and Education Watch: ‘We’re seeing lots of people who feel dizzy’: how",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-14-global-health-and-education-watch-we-re-seeing-lots-of-people-who-feel-dizzy-how.jpg",
    date: "2026-08-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-students-squeezed-out-of-university-courses-after-bumper-crop",
    title: "Global Health and Education Watch: Students squeezed out of university courses after bumper crop",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-14-global-health-and-education-watch-students-squeezed-out-of-university-courses-af.jpg",
    date: "2026-08-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-first-generation-monovalent-vaccines-blocked-transmission-of-delta-and-omicron",
    title: "Global Health and Education Watch: First-generation monovalent vaccines blocked transmission of Delta and Omicron",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-14-global-health-and-education-watch-first-generation-monovalent-vaccines-blocked-t.jpg",
    date: "2026-08-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-world-news-in-brief-afghanistan-education-myanmar-flooding-syria",
    title: "Global Health and Education Watch: World News in Brief: Afghanistan education, Myanmar flooding, Syria",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-14-global-health-and-education-watch-world-news-in-brief-afghanistan-education-myan.jpg",
    date: "2026-08-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-new-yorkers-who-lost-insurance-after-trump-cuts-face",
    title: "Global Health and Education Watch: New Yorkers Who Lost Insurance After Trump Cuts Face",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-14-global-health-and-education-watch-new-yorkers-who-lost-insurance-after-trump-cut.jpg",
    date: "2026-08-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-wildfires-force-thousands-to-flee-as-blazes-spread-across",
    title: "Global Health and Education Watch: Wildfires force thousands to flee as blazes spread across",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-14-global-health-and-education-watch-wildfires-force-thousands-to-flee-as-blazes-sp.jpg",
    date: "2026-08-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-polls-open-in-clacton-where-farage-spent-more-than",
    title: "Global Health and Education Watch: Polls open in Clacton, where Farage spent more than",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-14-global-health-and-education-watch-polls-open-in-clacton-where-farage-spent-more-.jpg",
    date: "2026-08-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-parkrun-is-a-joy-for-many-get-involved",
    title: "Global Health and Education Watch: Parkrun is a joy for many. Get involved |",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-14-global-health-and-education-watch-parkrun-is-a-joy-for-many-get-involved.jpg",
    date: "2026-08-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-california-bans-paraquat-highly-toxic-herbicide-outlawed-in-more",
    title: "Global Health and Education Watch: California bans paraquat, highly toxic herbicide outlawed in more",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-14-global-health-and-education-watch-california-bans-paraquat-highly-toxic-herbicid.jpg",
    date: "2026-08-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-is-the-mmr-vaccine-and-how-does-trump-s",
    title: "Global Health and Education Watch: What is the MMR vaccine and how does Trump’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-14-global-health-and-education-watch-what-is-the-mmr-vaccine-and-how-does-trump-s.jpg",
    date: "2026-08-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-tracing-improves-in-dr-congo-but-the",
    title: "Global Health and Education Watch: Ebola tracing improves in DR Congo – but the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-13-global-health-and-education-watch-ebola-tracing-improves-in-dr-congo-but-the.jpg",
    date: "2026-08-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-city-mobilizes-against-a-stubborn-health-threat-mosquitoes",
    title: "Global Health and Education Watch: A City Mobilizes Against a Stubborn Health Threat: Mosquitoes",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-13-global-health-and-education-watch-a-city-mobilizes-against-a-stubborn-health-thr.jpg",
    date: "2026-08-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-stop-the-bites-how-to-survive-another-summer-of",
    title: "Global Health and Education Watch: Stop the bites! How to survive another summer of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-13-global-health-and-education-watch-stop-the-bites-how-to-survive-another-summer-o.jpg",
    date: "2026-08-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-universities-face-financial-crisis-amid-collapse-in-international",
    title: "Global Health and Education Watch: UK universities face ‘financial crisis’ amid collapse in international",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-13-global-health-and-education-watch-uk-universities-face-financial-crisis-amid-col.jpg",
    date: "2026-08-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-judge-nixes-trump-lawsuit-alleging-harvard-did-not-protect",
    title: "Global Health and Education Watch: Judge nixes Trump lawsuit alleging Harvard did not protect",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-13-global-health-and-education-watch-judge-nixes-trump-lawsuit-alleging-harvard-did.jpg",
    date: "2026-08-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hegseth-downplays-uss-abraham-lincoln-conditions-amid-reports-of",
    title: "Global Health and Education Watch: Hegseth downplays USS Abraham Lincoln conditions amid reports of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-13-global-health-and-education-watch-hegseth-downplays-uss-abraham-lincoln-conditio.jpg",
    date: "2026-08-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cholera-spreads-across-borders-in-west-and-central-africa-3",
    title: "Global Health and Education Watch: Cholera spreads across borders in West and Central Africa",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-13-global-health-and-education-watch-cholera-spreads-across-borders-in-west-and-cen.jpg",
    date: "2026-08-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-g20-health-ministers-rally-support-for-who-s-investment-round",
    title: "Global Health and Education Watch: G20 health ministers rally support for WHO’s Investment Round",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-13-global-health-and-education-watch-g20-health-ministers-rally-support-for-who-s-i.jpg",
    date: "2026-08-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cholera-spreads-across-borders-in-west-and-central-africa-2",
    title: "Global Health and Education Watch: Cholera spreads across borders in West and Central Africa",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-13-global-health-and-education-watch-cholera-spreads-across-borders-in-west-and-cen.jpg",
    date: "2026-08-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cholera-spreads-across-borders-in-west-and-central-africa",
    title: "Global Health and Education Watch: Cholera spreads across borders in West and Central Africa",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-13-global-health-and-education-watch-cholera-spreads-across-borders-in-west-and-cen.jpg",
    date: "2026-08-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-patient-s-final-breath-in-a-congolese-ebola-ward",
    title: "Global Health and Education Watch: A Patient’s Final Breath in a Congolese Ebola Ward",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-13-global-health-and-education-watch-a-patient-s-final-breath-in-a-congolese-ebola-.jpg",
    date: "2026-08-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-jason-arday-is-now-the-stick-the-right-will",
    title: "Global Health and Education Watch: Jason Arday is now the stick the right will",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-13-global-health-and-education-watch-jason-arday-is-now-the-stick-the-right-will.jpg",
    date: "2026-08-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-level-results-students-across-england-wales-and-northern-ireland",
    title: "Global Health and Education Watch: A-level results: students across England, Wales and Northern Ireland",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-13-global-health-and-education-watch-a-level-results-students-across-england-wales-.jpg",
    date: "2026-08-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-search-efforts-in-colombia-enter-final-phase-as-quake",
    title: "Global Health and Education Watch: Search efforts in Colombia enter ‘final phase’ as quake",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-13-global-health-and-education-watch-search-efforts-in-colombia-enter-final-phase-a.jpg",
    date: "2026-08-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-luxembourg-and-who-sign-two-strategic-agreements",
    title: "Global Health and Education Watch: Luxembourg and WHO sign two strategic agreements",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-13-global-health-and-education-watch-luxembourg-and-who-sign-two-strategic-agreemen.jpg",
    date: "2026-08-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-always-cracking-jokes-questions-raised-over-jason-arday-s-claim",
    title: "Global Health and Education Watch: ‘Always cracking jokes’: questions raised over Jason Arday’s claim",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-12-global-health-and-education-watch-always-cracking-jokes-questions-raised-over-ja.jpg",
    date: "2026-08-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-chief-voices-concern-over-trump-administration-s-executive-order",
    title: "Global Health and Education Watch: WHO chief voices concern over Trump Administration’s executive order",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-12-global-health-and-education-watch-who-chief-voices-concern-over-trump-administra.jpg",
    date: "2026-08-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-rfk-jr-stirred-vaccine-fears-in-pennsylvania-years-before",
    title: "Global Health and Education Watch: RFK Jr. Stirred Vaccine Fears in Pennsylvania Years Before",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-12-global-health-and-education-watch-rfk-jr-stirred-vaccine-fears-in-pennsylvania-y.jpg",
    date: "2026-08-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-former-mexican-governor-charged-in-case-of-43-students",
    title: "Global Health and Education Watch: Former Mexican governor charged in case of 43 students",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-12-global-health-and-education-watch-former-mexican-governor-charged-in-case-of-43-.jpg",
    date: "2026-08-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-five-years-after-taliban-takeover-afghan-women-erased-from",
    title: "Global Health and Education Watch: Five years after Taliban takeover, Afghan women ‘erased from",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-12-global-health-and-education-watch-five-years-after-taliban-takeover-afghan-women.jpg",
    date: "2026-08-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-chief-says-trump-vaccine-push-goes-against-decades",
    title: "Global Health and Education Watch: WHO chief says Trump vaccine push goes against ‘decades",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-12-global-health-and-education-watch-who-chief-says-trump-vaccine-push-goes-against.jpg",
    date: "2026-08-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-burn-in-hell-israeli-settlers-spread-hate-through-graffiti",
    title: "Global Health and Education Watch: ‘Burn in hell’: Israeli settlers spread hate through graffiti",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-12-global-health-and-education-watch-burn-in-hell-israeli-settlers-spread-hate-thro.jpg",
    date: "2026-08-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-david-crowley-wins-messy-democratic-primary-for-wisconsin-governor",
    title: "Global Health and Education Watch: David Crowley wins messy Democratic primary for Wisconsin governor",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-12-global-health-and-education-watch-david-crowley-wins-messy-democratic-primary-fo.jpg",
    date: "2026-08-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-even-elite-colleges-have-become-trade-schools",
    title: "Global Health and Education Watch: Even Elite Colleges Have Become Trade Schools",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-12-global-health-and-education-watch-even-elite-colleges-have-become-trade-schools.jpg",
    date: "2026-08-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-university-of-cambridge-whistleblower-who-reported-alleged-bullying-wins",
    title: "Global Health and Education Watch: University of Cambridge whistleblower who reported alleged bullying wins",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-12-global-health-and-education-watch-university-of-cambridge-whistleblower-who-repo.jpg",
    date: "2026-08-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-s-vaccine-order-is-about-feelings-not-facts",
    title: "Global Health and Education Watch: Trump’s vaccine order is about feelings, not facts |",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-12-global-health-and-education-watch-trump-s-vaccine-order-is-about-feelings-not-fa.jpg",
    date: "2026-08-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-an-hbcu-has-banned-durags-and-bonnets-that-reinforces",
    title: "Global Health and Education Watch: An HBCU has banned durags and bonnets. That reinforces",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-12-global-health-and-education-watch-an-hbcu-has-banned-durags-and-bonnets-that-rei.jpg",
    date: "2026-08-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-comments-on-united-states-announcement-of-intent-to",
    title: "Global Health and Education Watch: WHO comments on United States’ announcement of intent to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-12-global-health-and-education-watch-who-comments-on-united-states-announcement-of-.jpg",
    date: "2026-08-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-signs-executive-order-calling-for-fewer-childhood-vaccines",
    title: "Global Health and Education Watch: Trump Signs Executive Order Calling for Fewer Childhood Vaccines",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-12-global-health-and-education-watch-trump-signs-executive-order-calling-for-fewer-.jpg",
    date: "2026-08-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-unesco-says-2-4-million-afghan-girls-denied-access-to-3",
    title: "Global Health and Education Watch: UNESCO says 2.4 million Afghan girls denied access to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-11-global-health-and-education-watch-unesco-says-2-4-million-afghan-girls-denied-ac.jpg",
    date: "2026-08-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-unesco-says-2-4-million-afghan-girls-denied-access-to-2",
    title: "Global Health and Education Watch: UNESCO says 2.4 million Afghan girls denied access to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-11-global-health-and-education-watch-unesco-says-2-4-million-afghan-girls-denied-ac.jpg",
    date: "2026-08-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-unesco-says-2-4-million-afghan-girls-denied-access-to",
    title: "Global Health and Education Watch: UNESCO says 2.4 million Afghan girls denied access to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-11-global-health-and-education-watch-unesco-says-2-4-million-afghan-girls-denied-ac.jpg",
    date: "2026-08-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-deaths-top-2-000-as-scientists-race-to-develop",
    title: "Global Health and Education Watch: Ebola deaths top 2,000 as scientists race to develop",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-11-global-health-and-education-watch-ebola-deaths-top-2-000-as-scientists-race-to-d.jpg",
    date: "2026-08-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-myanmar-un-investigators-document-deliberate-military-attacks-on-civilians-3",
    title: "Global Health and Education Watch: Myanmar: UN investigators document deliberate military attacks on civilians",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-11-global-health-and-education-watch-myanmar-un-investigators-document-deliberate-m.jpg",
    date: "2026-08-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-university-of-michigan-will-ease-up-on-grades-for",
    title: "Global Health and Education Watch: University of Michigan Will Ease Up on Grades for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-11-global-health-and-education-watch-university-of-michigan-will-ease-up-on-grades-.jpg",
    date: "2026-08-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-myanmar-un-investigators-document-deliberate-military-attacks-on-civilians-2",
    title: "Global Health and Education Watch: Myanmar: UN investigators document deliberate military attacks on civilians",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-11-global-health-and-education-watch-myanmar-un-investigators-document-deliberate-m.jpg",
    date: "2026-08-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-myanmar-un-investigators-document-deliberate-military-attacks-on-civilians",
    title: "Global Health and Education Watch: Myanmar: UN investigators document deliberate military attacks on civilians",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-11-global-health-and-education-watch-myanmar-un-investigators-document-deliberate-m.jpg",
    date: "2026-08-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-statement-on-notification-of-withdrawal-of-the-united",
    title: "Global Health and Education Watch: WHO statement on notification of withdrawal of the United",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-11-global-health-and-education-watch-who-statement-on-notification-of-withdrawal-of.jpg",
    date: "2026-08-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hca-workers-push-for-higher-pay-and-more-staffing",
    title: "Global Health and Education Watch: HCA workers push for higher pay and more staffing",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-11-global-health-and-education-watch-hca-workers-push-for-higher-pay-and-more-staff.jpg",
    date: "2026-08-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-good-luck-if-you-re-waiting-for-a-level-results-just",
    title: "Global Health and Education Watch: Good luck if you’re waiting for A-level results. Just",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-11-global-health-and-education-watch-good-luck-if-you-re-waiting-for-a-level-result.jpg",
    date: "2026-08-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-my-father-is-in-rss-india-s-gen-z-confronts",
    title: "Global Health and Education Watch: ‘My father is in RSS’: India’s Gen Z confronts",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-11-global-health-and-education-watch-my-father-is-in-rss-india-s-gen-z-confronts.jpg",
    date: "2026-08-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-amber-heat-health-alerts-kick-in-across-most-of",
    title: "Global Health and Education Watch: Amber heat health alerts kick in across most of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-11-global-health-and-education-watch-amber-heat-health-alerts-kick-in-across-most-o.jpg",
    date: "2026-08-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-breast-cancer-screening-guidelines-discriminate-against-families-like-mine-2",
    title: "Global Health and Education Watch: Breast cancer screening guidelines discriminate against families like mine",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-11-global-health-and-education-watch-breast-cancer-screening-guidelines-discriminat.jpg",
    date: "2026-08-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-breast-cancer-screening-guidelines-discriminate-against-families-like-mine",
    title: "Global Health and Education Watch: Breast cancer screening guidelines discriminate against families like mine",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-11-global-health-and-education-watch-breast-cancer-screening-guidelines-discriminat.jpg",
    date: "2026-08-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-could-you-predict-which-children-will-be-neets-no",
    title: "Global Health and Education Watch: Could you predict which children will be Neets? No",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-11-global-health-and-education-watch-could-you-predict-which-children-will-be-neets.jpg",
    date: "2026-08-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-louisiana-warns-beachgoers-amid-surge-in-flesh-eating-bacteria-infections",
    title: "Global Health and Education Watch: Louisiana warns beachgoers amid surge in flesh-eating bacteria infections",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-11-global-health-and-education-watch-louisiana-warns-beachgoers-amid-surge-in-flesh.jpg",
    date: "2026-08-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-launches-unique-training-course-to-enable-parliamentarians-in",
    title: "Global Health and Education Watch: WHO launches unique training course to enable parliamentarians in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-11-global-health-and-education-watch-who-launches-unique-training-course-to-enable-.jpg",
    date: "2026-08-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-takeaways-from-jason-arday-s-memoir",
    title: "Global Health and Education Watch: Takeaways From Jason Arday’s Memoir",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-10-global-health-and-education-watch-takeaways-from-jason-arday-s-memoir.jpg",
    date: "2026-08-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mental-health-one-step-forward-and-two-steps-back",
    title: "Global Health and Education Watch: Mental health: one step forward and two steps back?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-10-global-health-and-education-watch-mental-health-one-step-forward-and-two-steps-b.jpg",
    date: "2026-08-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-drc-s-ebola-outbreak-began-months-before-it-was-officially",
    title: "Global Health and Education Watch: DRC’s Ebola outbreak began months before it was officially",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-10-global-health-and-education-watch-drc-s-ebola-outbreak-began-months-before-it-wa.jpg",
    date: "2026-08-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-dr-congo-ebola-is-killing-people-before-they-ever",
    title: "Global Health and Education Watch: DR Congo: Ebola is killing people before they ever",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-10-global-health-and-education-watch-dr-congo-ebola-is-killing-people-before-they-e.jpg",
    date: "2026-08-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-signs-order-attempting-to-override-cdc-vaccine-schedule",
    title: "Global Health and Education Watch: Trump signs order attempting to override CDC vaccine schedule",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-10-global-health-and-education-watch-trump-signs-order-attempting-to-override-cdc-v.jpg",
    date: "2026-08-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-safe-quick-and-painless-what-is-a-dxa-scan",
    title: "Global Health and Education Watch: ‘Safe, quick and painless’: what is a DXA scan",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-10-global-health-and-education-watch-safe-quick-and-painless-what-is-a-dxa-scan.jpg",
    date: "2026-08-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-happens-when-medical-students-rely-on-ai",
    title: "Global Health and Education Watch: What happens when medical students rely on AI –",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-10-global-health-and-education-watch-what-happens-when-medical-students-rely-on-ai.jpg",
    date: "2026-08-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-i-agents-are-taking-entire-online-courses-for-cheating",
    title: "Global Health and Education Watch: A.I. Agents Are Taking Entire Online Courses for Cheating",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-10-global-health-and-education-watch-a-i-agents-are-taking-entire-online-courses-fo.jpg",
    date: "2026-08-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-sudan-it-made-me-dream-again-the-students-refusing",
    title: "Global Health and Education Watch: Sudan: ‘It made me dream again’: The students refusing",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-10-global-health-and-education-watch-sudan-it-made-me-dream-again-the-students-refu.jpg",
    date: "2026-08-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-wildfire-smoke-threatens-to-cloud-the-pure-michigan-brand",
    title: "Global Health and Education Watch: Wildfire smoke threatens to cloud the ‘Pure Michigan’ brand",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-10-global-health-and-education-watch-wildfire-smoke-threatens-to-cloud-the-pure-mic.jpg",
    date: "2026-08-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israeli-forces-kill-one-in-gaza-as-another-body",
    title: "Global Health and Education Watch: Israeli forces kill one in Gaza as another body",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-10-global-health-and-education-watch-israeli-forces-kill-one-in-gaza-as-another-bod.jpg",
    date: "2026-08-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-i-cheating-threatens-the-value-of-online-degrees",
    title: "Global Health and Education Watch: A.I. Cheating Threatens the Value of Online Degrees",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-10-global-health-and-education-watch-a-i-cheating-threatens-the-value-of-online-deg.jpg",
    date: "2026-08-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-frank-in-depth-discussion-as-belgium-and-who-map-ahead",
    title: "Global Health and Education Watch: Frank, in-depth discussion as Belgium and WHO map ahead",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-10-global-health-and-education-watch-frank-in-depth-discussion-as-belgium-and-who-m.jpg",
    date: "2026-08-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-students-face-ticking-timebomb-of-debt-and-higher-taxes",
    title: "Global Health and Education Watch: Students face ‘ticking timebomb’ of debt and higher taxes",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-10-global-health-and-education-watch-students-face-ticking-timebomb-of-debt-and-hig.jpg",
    date: "2026-08-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israel-confirms-death-of-palestinian-detainee-nearly-two-years",
    title: "Global Health and Education Watch: Israel confirms death of Palestinian detainee, nearly two years",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-10-global-health-and-education-watch-israel-confirms-death-of-palestinian-detainee-.jpg",
    date: "2026-08-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cambridge-academics-reject-university-s-attempt-to-end-row-over",
    title: "Global Health and Education Watch: Cambridge academics reject university’s attempt to end row over",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-10-global-health-and-education-watch-cambridge-academics-reject-university-s-attemp.jpg",
    date: "2026-08-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-nhs-must-prepare-for-annual-summer-heat-pressures-says",
    title: "Global Health and Education Watch: NHS must prepare for annual summer heat pressures, says",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-nhs-must-prepare-for-annual-summer-heat-pressu.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-australia-news-live-nsw-schools-may-ban-take-home-tests",
    title: "Global Health and Education Watch: Australia news live: NSW schools may ban take-home tests",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-australia-news-live-nsw-schools-may-ban-take-h.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-friday-briefing-what-the-jason-arday-row-reveals-about",
    title: "Global Health and Education Watch: Friday briefing: What the Jason Arday row reveals about",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-friday-briefing-what-the-jason-arday-row-revea.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-are-ultra-processed-food-firms-panicking-and-suing-because-5",
    title: "Global Health and Education Watch: Why are ultra-processed food firms panicking and suing? Because",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-why-are-ultra-processed-food-firms-panicking-a.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-culture-surrounding-ideal-childbirth-has-to-evolve",
    title: "Global Health and Education Watch: The culture surrounding ‘ideal’ childbirth has to evolve |",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-the-culture-surrounding-ideal-childbirth-has-t.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-guardian-view-on-the-two-cultures-bridge-the-3",
    title: "Global Health and Education Watch: The Guardian view on the two cultures: bridge the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-the-guardian-view-on-the-two-cultures-bridge-t.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-guardian-view-on-the-two-cultures-bridge-the-2",
    title: "Global Health and Education Watch: The Guardian view on the two cultures: bridge the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-the-guardian-view-on-the-two-cultures-bridge-t.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-guardian-view-on-the-two-cultures-bridge-the",
    title: "Global Health and Education Watch: The Guardian view on the two cultures: bridge the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-the-guardian-view-on-the-two-cultures-bridge-t.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-healthy-vaccinee-effect-in-the-evaluation-of-updated-covid-19-2",
    title: "Global Health and Education Watch: Healthy vaccinee effect in the evaluation of updated COVID-19",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-healthy-vaccinee-effect-in-the-evaluation-of-u.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-middle-east-crisis-live-netanyahu-rejects-trump-s-gaza-plan",
    title: "Global Health and Education Watch: Middle East crisis live: Netanyahu rejects Trump’s Gaza plan",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-middle-east-crisis-live-netanyahu-rejects-trum.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-we-know-sleep-exercise-and-diet-are-vital-for-4",
    title: "Global Health and Education Watch: We know sleep, exercise and diet are vital for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-we-know-sleep-exercise-and-diet-are-vital-for.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-we-know-sleep-exercise-and-diet-are-vital-for-3",
    title: "Global Health and Education Watch: We know sleep, exercise and diet are vital for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-we-know-sleep-exercise-and-diet-are-vital-for.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-healthy-vaccinee-effect-in-the-evaluation-of-updated-covid-19",
    title: "Global Health and Education Watch: Healthy vaccinee effect in the evaluation of updated COVID-19",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-healthy-vaccinee-effect-in-the-evaluation-of-u.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-we-know-sleep-exercise-and-diet-are-vital-for-2",
    title: "Global Health and Education Watch: We know sleep, exercise and diet are vital for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-we-know-sleep-exercise-and-diet-are-vital-for.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-we-know-sleep-exercise-and-diet-are-vital-for",
    title: "Global Health and Education Watch: We know sleep, exercise and diet are vital for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-we-know-sleep-exercise-and-diet-are-vital-for.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-press-access-spat-adds-to-fears-of-circus-around",
    title: "Global Health and Education Watch: Press access spat adds to fears of circus around",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-press-access-spat-adds-to-fears-of-circus-arou.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-worldwide-rally-for-maternal-and-newborn-health-marks-world-2",
    title: "Global Health and Education Watch: Worldwide rally for maternal and newborn health marks World",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-worldwide-rally-for-maternal-and-newborn-healt.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-worldwide-rally-for-maternal-and-newborn-health-marks-world",
    title: "Global Health and Education Watch: Worldwide rally for maternal and newborn health marks World",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-worldwide-rally-for-maternal-and-newborn-healt.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-are-ultra-processed-food-firms-panicking-and-suing-because-4",
    title: "Global Health and Education Watch: Why are ultra-processed food firms panicking and suing? Because",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-why-are-ultra-processed-food-firms-panicking-a.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-amid-cyclospora-outbreak-demand-for-locally-grown-lettuce-surges",
    title: "Global Health and Education Watch: Amid Cyclospora Outbreak, Demand for Locally Grown Lettuce Surges",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-amid-cyclospora-outbreak-demand-for-locally-gr.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-director-general-visits-jordan-to-recognize-strong-collaboration-on",
    title: "Global Health and Education Watch: WHO Director-General visits Jordan to recognize strong collaboration on",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-who-director-general-visits-jordan-to-recogniz.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-costa-rican-diplomat-emerges-as-strong-contender-to-be",
    title: "Global Health and Education Watch: Costa Rican diplomat emerges as strong contender to be",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-costa-rican-diplomat-emerges-as-strong-contend.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cockroach-protests-parents-of-indian-students-who-took-their-3",
    title: "Global Health and Education Watch: Cockroach protests: parents of Indian students who took their",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-cockroach-protests-parents-of-indian-students-.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cockroach-protests-parents-of-indian-students-who-took-their-2",
    title: "Global Health and Education Watch: Cockroach protests: parents of Indian students who took their",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-cockroach-protests-parents-of-indian-students-.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cockroach-protests-parents-of-indian-students-who-took-their",
    title: "Global Health and Education Watch: Cockroach protests: parents of Indian students who took their",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-cockroach-protests-parents-of-indian-students-.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-thailand-school-shooting-toll-rises-to-nine-after-12-year-old",
    title: "Global Health and Education Watch: Thailand school shooting toll rises to nine after 12-year-old",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-09-global-health-and-education-watch-thailand-school-shooting-toll-rises-to-nine-af.jpg",
    date: "2026-08-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-takedown-of-jason-arday-has-overjoyed-the-right",
    title: "Global Health and Education Watch: The takedown of Jason Arday has overjoyed the right",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-the-takedown-of-jason-arday-has-overjoyed-the-.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-lionel-messi-s-father-dies-aged-68-after-a-long",
    title: "Global Health and Education Watch: Lionel Messi’s father dies aged 68 after a long",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-lionel-messi-s-father-dies-aged-68-after-a-lon.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-is-it-ok-to-talk-about-ariana-grande-s-body-3",
    title: "Global Health and Education Watch: Is it OK to talk about Ariana Grande’s body?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-is-it-ok-to-talk-about-ariana-grande-s-body.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-is-it-ok-to-talk-about-ariana-grande-s-body-2",
    title: "Global Health and Education Watch: Is it OK to talk about Ariana Grande’s body?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-is-it-ok-to-talk-about-ariana-grande-s-body.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-is-it-ok-to-talk-about-ariana-grande-s-body",
    title: "Global Health and Education Watch: Is it OK to talk about Ariana Grande’s body?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-is-it-ok-to-talk-about-ariana-grande-s-body.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-gaza-health-chief-urges-action-to-save-dr-abu",
    title: "Global Health and Education Watch: Gaza health chief urges action to ‘save’ Dr Abu",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-gaza-health-chief-urges-action-to-save-dr-abu.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-as-thailand-gets-known-for-mass-shootings-fresh-pledges",
    title: "Global Health and Education Watch: As Thailand Gets Known for Mass Shootings, Fresh Pledges",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-as-thailand-gets-known-for-mass-shootings-fres.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-virus-behind-massive-outbreak-in-drc-could-be",
    title: "Global Health and Education Watch: Ebola virus behind massive outbreak in DRC could be",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-ebola-virus-behind-massive-outbreak-in-drc-cou.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-lion-saved-as-cub-from-ukraine-war-and-brought",
    title: "Global Health and Education Watch: Lion saved as cub from Ukraine war and brought",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-lion-saved-as-cub-from-ukraine-war-and-brought.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-yemen-s-collapsing-healthcare-forces-the-sick-to-seek-alternative",
    title: "Global Health and Education Watch: Yemen’s collapsing healthcare forces the sick to seek alternative",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-yemen-s-collapsing-healthcare-forces-the-sick-.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cdc-reportedly-expands-scope-of-us-cyclosporiasis-outbreak-to",
    title: "Global Health and Education Watch: CDC reportedly expands scope of US cyclosporiasis outbreak to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-cdc-reportedly-expands-scope-of-us-cyclosporia.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-i-hate-what-ai-is-doing-to-the-minds",
    title: "Global Health and Education Watch: ‘I hate what AI is doing to the minds",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-i-hate-what-ai-is-doing-to-the-minds.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-rest-assured-the-new-cdc-director-thinks-abortion-surveillance",
    title: "Global Health and Education Watch: Rest assured, the new CDC director thinks ‘abortion surveillance’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-rest-assured-the-new-cdc-director-thinks-abort.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-judge-rules-two-virginia-schools-must-change-confederate-names",
    title: "Global Health and Education Watch: Judge Rules Two Virginia Schools Must Change Confederate Names",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-judge-rules-two-virginia-schools-must-change-c.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-sudan-is-losing-another-generation-to-war-mohammed-warns",
    title: "Global Health and Education Watch: ‘Sudan is losing another generation’ to war, Mohammed warns",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-sudan-is-losing-another-generation-to-war-moha.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-fourteen-african-countries-key-partners-unite-to-provide-critical",
    title: "Global Health and Education Watch: Fourteen African countries, key partners unite to provide critical",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-fourteen-african-countries-key-partners-unite-.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-sudan-s-war-threatens-an-entire-generation-s-future-un-warns",
    title: "Global Health and Education Watch: Sudan’s war threatens an ‘entire generation’s’ future, UN warns",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-sudan-s-war-threatens-an-entire-generation-s-f.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-comparative-analysis-of-mental-health-among-austrian-farmers-and",
    title: "Global Health and Education Watch: Comparative analysis of mental health among Austrian farmers and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-comparative-analysis-of-mental-health-among-au.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-millions-in-england-face-longer-waits-for-mental-health",
    title: "Global Health and Education Watch: Millions in England face longer waits for mental health",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-millions-in-england-face-longer-waits-for-ment.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-i-couldn-t-breathe-the-deadly-health-burden-of-wildfire",
    title: "Global Health and Education Watch: ‘I couldn’t breathe’: the deadly health burden of wildfire",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-i-couldn-t-breathe-the-deadly-health-burden-of.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-are-ultra-processed-food-firms-panicking-and-suing-because-3",
    title: "Global Health and Education Watch: Why are ultra-processed food firms panicking and suing? Because",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-why-are-ultra-processed-food-firms-panicking-a.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-are-ultra-processed-food-firms-panicking-and-suing-because-2",
    title: "Global Health and Education Watch: Why are ultra-processed food firms panicking and suing? Because",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-why-are-ultra-processed-food-firms-panicking-a.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-reading-scores-drop-for-n-y-c-students-amid-revamp-of",
    title: "Global Health and Education Watch: Reading Scores Drop for N.Y.C. Students Amid Revamp of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-08-global-health-and-education-watch-reading-scores-drop-for-n-y-c-students-amid-re.jpg",
    date: "2026-08-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-students-skinned-a-bear-in-a-dorm-cornell-realized",
    title: "Global Health and Education Watch: Students Skinned a Bear in a Dorm. Cornell Realized",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-07-global-health-and-education-watch-students-skinned-a-bear-in-a-dorm-cornell-real.jpg",
    date: "2026-08-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-republic-of-korea-and-who-discuss-joint-priorities",
    title: "Global Health and Education Watch: The Republic of Korea and WHO discuss joint priorities",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-07-global-health-and-education-watch-the-republic-of-korea-and-who-discuss-joint-pr.jpg",
    date: "2026-08-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-cases-top-4-000-in-drc-as-who-urges",
    title: "Global Health and Education Watch: Ebola cases top 4,000 in DRC as WHO urges",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-07-global-health-and-education-watch-ebola-cases-top-4-000-in-drc-as-who-urges.jpg",
    date: "2026-08-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-in-dr-congo-childhood-deaths-rise-hopes-raised-2",
    title: "Global Health and Education Watch: Ebola in DR Congo: Childhood deaths rise; hopes raised",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-07-global-health-and-education-watch-ebola-in-dr-congo-childhood-deaths-rise-hopes-.jpg",
    date: "2026-08-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-in-dr-congo-childhood-deaths-rise-hopes-raised",
    title: "Global Health and Education Watch: Ebola in DR Congo: Childhood deaths rise; hopes raised",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-07-global-health-and-education-watch-ebola-in-dr-congo-childhood-deaths-rise-hopes-.jpg",
    date: "2026-08-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-are-ultra-processed-food-firms-panicking-and-suing-because",
    title: "Global Health and Education Watch: Why are ultra-processed food firms panicking and suing? Because",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-07-global-health-and-education-watch-why-are-ultra-processed-food-firms-panicking-a.jpg",
    date: "2026-08-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-boy-kills-grandparents-and-then-five-teachers-thai-authorities",
    title: "Global Health and Education Watch: Boy Kills Grandparents and Then Five Teachers, Thai Authorities",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-07-global-health-and-education-watch-boy-kills-grandparents-and-then-five-teachers-.jpg",
    date: "2026-08-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-thailand-school-shooting-eight-killed-including-suspected-attacker-police",
    title: "Global Health and Education Watch: Thailand school shooting: eight killed including suspected attacker, police",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-07-global-health-and-education-watch-thailand-school-shooting-eight-killed-includin.jpg",
    date: "2026-08-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-primary-schools-to-be-told-to-identify-children-at",
    title: "Global Health and Education Watch: Primary schools to be told to identify children at",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-07-global-health-and-education-watch-primary-schools-to-be-told-to-identify-childre.jpg",
    date: "2026-08-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-with-their-assault-on-science-trumpists-aren-t-just-harming",
    title: "Global Health and Education Watch: With their assault on science, Trumpists aren’t just harming",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-07-global-health-and-education-watch-with-their-assault-on-science-trumpists-aren-t.jpg",
    date: "2026-08-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-and-the-kingdom-of-saudi-arabia-sign-agreements",
    title: "Global Health and Education Watch: WHO and the Kingdom of Saudi Arabia sign agreements",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-07-global-health-and-education-watch-who-and-the-kingdom-of-saudi-arabia-sign-agree.jpg",
    date: "2026-08-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-several-killed-after-student-opens-fire-inside-thailand-school",
    title: "Global Health and Education Watch: Several killed after student opens fire inside Thailand school",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-07-global-health-and-education-watch-several-killed-after-student-opens-fire-inside.jpg",
    date: "2026-08-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-governments-agree-to-continue-their-steady-progress-on-proposed",
    title: "Global Health and Education Watch: Governments agree to continue their steady progress on proposed",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-07-global-health-and-education-watch-governments-agree-to-continue-their-steady-pro.jpg",
    date: "2026-08-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-justice-department-accuses-duke-law-school-of-racial-discrimination",
    title: "Global Health and Education Watch: Justice Department Accuses Duke Law School of Racial Discrimination",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-07-global-health-and-education-watch-justice-department-accuses-duke-law-school-of-.jpg",
    date: "2026-08-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-security-council-live-warnings-of-famine-and-collapse-as",
    title: "Global Health and Education Watch: Security Council LIVE: Warnings of famine and collapse as",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-07-global-health-and-education-watch-security-council-live-warnings-of-famine-and-c.jpg",
    date: "2026-08-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-promising-heart-drug-fails-challenging-a-long-held-theory",
    title: "Global Health and Education Watch: A Promising Heart Drug Fails, Challenging a Long-Held Theory",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-07-global-health-and-education-watch-a-promising-heart-drug-fails-challenging-a-lon.jpg",
    date: "2026-08-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-travel-restrictions-from-israel-and-europe-trap",
    title: "Global Health and Education Watch: Travel restrictions – from Israel and Europe – trap",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-07-global-health-and-education-watch-travel-restrictions-from-israel-and-europe-tra.jpg",
    date: "2026-08-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-senate-panel-votes-to-hold-fauci-in-contempt",
    title: "Global Health and Education Watch: US Senate panel votes to hold Fauci in contempt",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-06-global-health-and-education-watch-us-senate-panel-votes-to-hold-fauci-in-contemp.jpg",
    date: "2026-08-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-it-can-make-you-psychotic-or-give-you-a",
    title: "Global Health and Education Watch: ‘It can make you psychotic or give you a",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-06-global-health-and-education-watch-it-can-make-you-psychotic-or-give-you-a.jpg",
    date: "2026-08-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-s-strategic-engagement-with-philanthropies-advancing-global-health-and-4",
    title: "Global Health and Education Watch: WHO’s strategic engagement with philanthropies: advancing global health and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-06-global-health-and-education-watch-who-s-strategic-engagement-with-philanthropies.jpg",
    date: "2026-08-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-s-strategic-engagement-with-philanthropies-advancing-global-health-and-3",
    title: "Global Health and Education Watch: WHO’s strategic engagement with philanthropies: advancing global health and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-06-global-health-and-education-watch-who-s-strategic-engagement-with-philanthropies.jpg",
    date: "2026-08-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-s-strategic-engagement-with-philanthropies-advancing-global-health-and-2",
    title: "Global Health and Education Watch: WHO’s strategic engagement with philanthropies: advancing global health and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-06-global-health-and-education-watch-who-s-strategic-engagement-with-philanthropies.jpg",
    date: "2026-08-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-s-strategic-engagement-with-philanthropies-advancing-global-health-and",
    title: "Global Health and Education Watch: WHO’s strategic engagement with philanthropies: advancing global health and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-06-global-health-and-education-watch-who-s-strategic-engagement-with-philanthropies.jpg",
    date: "2026-08-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-erica-schwartz-confirmed-as-new-cdc-chief-amid-us",
    title: "Global Health and Education Watch: Erica Schwartz confirmed as new CDC chief amid US",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-06-global-health-and-education-watch-erica-schwartz-confirmed-as-new-cdc-chief-amid.jpg",
    date: "2026-08-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-gaza-unsafe-for-civilians-as-israeli-attacks-hit-homes-2",
    title: "Global Health and Education Watch: Gaza ‘unsafe for civilians’ as Israeli attacks hit homes",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-05-global-health-and-education-watch-gaza-unsafe-for-civilians-as-israeli-attacks-h.jpg",
    date: "2026-08-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-gaza-unsafe-for-civilians-as-israeli-attacks-hit-homes",
    title: "Global Health and Education Watch: Gaza ‘unsafe for civilians’ as Israeli attacks hit homes",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-05-global-health-and-education-watch-gaza-unsafe-for-civilians-as-israeli-attacks-h.jpg",
    date: "2026-08-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tuskegee-university-banned-bonnets-and-durags-students-mostly-wonder",
    title: "Global Health and Education Watch: Tuskegee University Banned Bonnets and Durags. Students Mostly Wonder",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-05-global-health-and-education-watch-tuskegee-university-banned-bonnets-and-durags-.jpg",
    date: "2026-08-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-he-had-tenure-the-new-school-laid-him-off",
    title: "Global Health and Education Watch: He Had Tenure. The New School Laid Him Off",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-05-global-health-and-education-watch-he-had-tenure-the-new-school-laid-him-off.jpg",
    date: "2026-08-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-teachers-need-help-with-ai-a-union-is-offering",
    title: "Global Health and Education Watch: Teachers need help with AI. A union is offering",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-05-global-health-and-education-watch-teachers-need-help-with-ai-a-union-is-offering.jpg",
    date: "2026-08-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-women-must-not-be-put-under-pressure-to-have",
    title: "Global Health and Education Watch: Women must not be put under pressure to have",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-05-global-health-and-education-watch-women-must-not-be-put-under-pressure-to-have.jpg",
    date: "2026-08-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-strengthening-public-health-across-lebanon-with-eib-global",
    title: "Global Health and Education Watch: Strengthening public health across Lebanon with EIB Global",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-05-global-health-and-education-watch-strengthening-public-health-across-lebanon-wit.jpg",
    date: "2026-08-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-p-g-seals-3-8bn-deal-for-supplements-company-thorne",
    title: "Global Health and Education Watch: P&G seals $3.8bn deal for supplements company Thorne",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-05-global-health-and-education-watch-p-g-seals-3-8bn-deal-for-supplements-company-t.jpg",
    date: "2026-08-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-new-ebola-vaccine-trial-launches-as-outbreak-spreads-in",
    title: "Global Health and Education Watch: New Ebola vaccine trial launches as outbreak spreads in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-04-global-health-and-education-watch-new-ebola-vaccine-trial-launches-as-outbreak-s.jpg",
    date: "2026-08-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-spotlight-on-fauci-said-to-boost-book-sales-for",
    title: "Global Health and Education Watch: Spotlight on Fauci Said to Boost Book Sales for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-04-global-health-and-education-watch-spotlight-on-fauci-said-to-boost-book-sales-fo.jpg",
    date: "2026-08-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-dr-congo-ebola-outbreak-kills-more-than-1-700-as",
    title: "Global Health and Education Watch: DR Congo Ebola outbreak kills more than 1,700 as",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-04-global-health-and-education-watch-dr-congo-ebola-outbreak-kills-more-than-1-700-.jpg",
    date: "2026-08-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-education-dept-to-wipe-out-student-loans-of-170-000",
    title: "Global Health and Education Watch: Education Dept. to Wipe Out Student Loans of 170,000",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-04-global-health-and-education-watch-education-dept-to-wipe-out-student-loans-of-17.jpg",
    date: "2026-08-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-gps-breast-cancer-guidelines-miss-95-of-women-who",
    title: "Global Health and Education Watch: GPs’ breast cancer guidelines ‘miss’ 95% of women who",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-04-global-health-and-education-watch-gps-breast-cancer-guidelines-miss-95-of-women-.jpg",
    date: "2026-08-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-qatar-fund-for-development-qffd-supports-the-implementation-of",
    title: "Global Health and Education Watch: Qatar Fund for Development (QFFD) supports the implementation of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-04-global-health-and-education-watch-qatar-fund-for-development-qffd-supports-the-i.jpg",
    date: "2026-08-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-children-using-social-media-at-younger-age-appear-to",
    title: "Global Health and Education Watch: Children using social media at younger age appear to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-03-global-health-and-education-watch-children-using-social-media-at-younger-age-app.jpg",
    date: "2026-08-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-announces-first-two-deaths-from-cyclospora-outbreak",
    title: "Global Health and Education Watch: US announces first two deaths from cyclospora outbreak",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-03-global-health-and-education-watch-us-announces-first-two-deaths-from-cyclospora-.jpg",
    date: "2026-08-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-dr-congo-new-centre-opens-at-heart-of-record",
    title: "Global Health and Education Watch: DR Congo: New centre opens at heart of record",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-03-global-health-and-education-watch-dr-congo-new-centre-opens-at-heart-of-record.jpg",
    date: "2026-08-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-after-colleges-reject-compact-trump-officials-try-a-letter",
    title: "Global Health and Education Watch: After Colleges Reject ‘Compact,’ Trump Officials Try a Letter",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-03-global-health-and-education-watch-after-colleges-reject-compact-trump-officials-.jpg",
    date: "2026-08-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-montessori-learning-is-being-shut-down-at-leah-s-school",
    title: "Global Health and Education Watch: Montessori learning is being shut down at Leah’s school",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-03-global-health-and-education-watch-montessori-learning-is-being-shut-down-at-leah.jpg",
    date: "2026-08-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-and-the-netherlands-renew-their-partnership-on-climate",
    title: "Global Health and Education Watch: WHO and the Netherlands renew their partnership on climate",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-03-global-health-and-education-watch-who-and-the-netherlands-renew-their-partnershi.jpg",
    date: "2026-08-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-self-help-influencer-nicole-lepera-faces-litigation-2",
    title: "Global Health and Education Watch: Self-Help Influencer Nicole LePera Faces Litigation",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-03-global-health-and-education-watch-self-help-influencer-nicole-lepera-faces-litig.jpg",
    date: "2026-08-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-suicide-bombing-kills-at-least-14-people-in-pakistan-s",
    title: "Global Health and Education Watch: Suicide bombing kills at least 14 people in Pakistan’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-03-global-health-and-education-watch-suicide-bombing-kills-at-least-14-people-in-pa.jpg",
    date: "2026-08-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-self-help-influencer-nicole-lepera-faces-litigation",
    title: "Global Health and Education Watch: Self-Help Influencer Nicole LePera Faces Litigation",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-03-global-health-and-education-watch-self-help-influencer-nicole-lepera-faces-litig.jpg",
    date: "2026-08-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-he-s-a-narcissist-could-idaho-killer-bryan-kohberger-win",
    title: "Global Health and Education Watch: ‘He’s a narcissist’: could Idaho killer Bryan Kohberger win",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-02-global-health-and-education-watch-he-s-a-narcissist-could-idaho-killer-bryan-koh.jpg",
    date: "2026-08-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-enhancing-global-health-and-well-being-who-and-the-netherlands",
    title: "Global Health and Education Watch: Enhancing Global Health and Well-Being: WHO and the Netherlands",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-02-global-health-and-education-watch-enhancing-global-health-and-well-being-who-and.jpg",
    date: "2026-08-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-mystery-virus-started-killing-horses-then-humans-was",
    title: "Global Health and Education Watch: A mystery virus started killing horses. Then humans. Was",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-02-global-health-and-education-watch-a-mystery-virus-started-killing-horses-then-hu.jpg",
    date: "2026-08-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-rfk-jr-tells-us-families-to-vaccinate-children-against",
    title: "Global Health and Education Watch: RFK Jr tells US families to vaccinate children against",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-02-global-health-and-education-watch-rfk-jr-tells-us-families-to-vaccinate-children.jpg",
    date: "2026-08-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-annie-thought-perimenopause-symptoms-were-keeping-her-awake-alcohol-3",
    title: "Global Health and Education Watch: Annie thought perimenopause symptoms were keeping her awake. Alcohol",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-02-global-health-and-education-watch-annie-thought-perimenopause-symptoms-were-keep.jpg",
    date: "2026-08-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-annie-thought-perimenopause-symptoms-were-keeping-her-awake-alcohol-2",
    title: "Global Health and Education Watch: Annie thought perimenopause symptoms were keeping her awake. Alcohol",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-02-global-health-and-education-watch-annie-thought-perimenopause-symptoms-were-keep.jpg",
    date: "2026-08-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-annie-thought-perimenopause-symptoms-were-keeping-her-awake-alcohol",
    title: "Global Health and Education Watch: Annie thought perimenopause symptoms were keeping her awake. Alcohol",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-02-global-health-and-education-watch-annie-thought-perimenopause-symptoms-were-keep.jpg",
    date: "2026-08-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-u-s-restores-some-vaccine-and-health-aid-to-unicef",
    title: "Global Health and Education Watch: U.S. Restores Some Vaccine and Health Aid to Unicef",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-02-global-health-and-education-watch-u-s-restores-some-vaccine-and-health-aid-to-un.jpg",
    date: "2026-08-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-gaza-students-overcome-israel-s-genocide-to-mark-tawjihi-results-2",
    title: "Global Health and Education Watch: Gaza students overcome Israel’s genocide to mark Tawjihi results",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-02-global-health-and-education-watch-gaza-students-overcome-israel-s-genocide-to-ma.jpg",
    date: "2026-08-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-gaza-students-overcome-israel-s-genocide-to-mark-tawjihi-results",
    title: "Global Health and Education Watch: Gaza students overcome Israel’s genocide to mark Tawjihi results",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-02-global-health-and-education-watch-gaza-students-overcome-israel-s-genocide-to-ma.jpg",
    date: "2026-08-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mps-call-for-routine-lead-testing-for-children-near-3",
    title: "Global Health and Education Watch: MPs call for routine lead testing for children near",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-02-global-health-and-education-watch-mps-call-for-routine-lead-testing-for-children.jpg",
    date: "2026-08-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mps-call-for-routine-lead-testing-for-children-near-2",
    title: "Global Health and Education Watch: MPs call for routine lead testing for children near",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-02-global-health-and-education-watch-mps-call-for-routine-lead-testing-for-children.jpg",
    date: "2026-08-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mps-call-for-routine-lead-testing-for-children-near",
    title: "Global Health and Education Watch: MPs call for routine lead testing for children near",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-02-global-health-and-education-watch-mps-call-for-routine-lead-testing-for-children.jpg",
    date: "2026-08-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-spain-s-secretary-of-state-for-health-discusses-health-priorities",
    title: "Global Health and Education Watch: Spain's Secretary of State for Health discusses health priorities",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-02-global-health-and-education-watch-spain-s-secretary-of-state-for-health-discusse.jpg",
    date: "2026-08-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-timor-leste-certified-malaria-free-by-who",
    title: "Global Health and Education Watch: Timor-Leste certified malaria-free by WHO",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-02-global-health-and-education-watch-timor-leste-certified-malaria-free-by-who.jpg",
    date: "2026-08-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-outbreak-is-now-the-second-largest-ever-and-in",
    title: "Global Health and Education Watch: Ebola Outbreak Is Now the Second-Largest Ever, and in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-01-global-health-and-education-watch-ebola-outbreak-is-now-the-second-largest-ever-.jpg",
    date: "2026-08-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-recovery-in-ukraine-one-life-at-a-time",
    title: "Global Health and Education Watch: Recovery in Ukraine, one life at a time",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-01-global-health-and-education-watch-recovery-in-ukraine-one-life-at-a-time.jpg",
    date: "2026-08-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ultra-processed-food-companies-hindering-health-drives-by-suing-countries",
    title: "Global Health and Education Watch: Ultra-processed food companies hindering health drives by suing countries",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-01-global-health-and-education-watch-ultra-processed-food-companies-hindering-healt.jpg",
    date: "2026-08-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israeli-strikes-kill-four-across-gaza-destroy-medical-supply",
    title: "Global Health and Education Watch: Israeli strikes kill four across Gaza, destroy medical supply",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-01-global-health-and-education-watch-israeli-strikes-kill-four-across-gaza-destroy-.jpg",
    date: "2026-08-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-signing-ceremony-for-contribution-agreements-between-who-and-france",
    title: "Global Health and Education Watch: Signing ceremony for contribution agreements between WHO and France",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-01-global-health-and-education-watch-signing-ceremony-for-contribution-agreements-b.jpg",
    date: "2026-08-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-if-you-think-kids-will-respect-a-robot-teacher",
    title: "Global Health and Education Watch: If you think kids will respect a robot teacher",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-01-global-health-and-education-watch-if-you-think-kids-will-respect-a-robot-teacher.jpg",
    date: "2026-08-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-retrospective-evaluation-of-school-related-measures-on-pre-vaccination-transmission-dynamics",
    title: "Global Health and Education Watch: Retrospective evaluation of school-related measures on pre-vaccination transmission dynamics",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-01-global-health-and-education-watch-retrospective-evaluation-of-school-related-mea.jpg",
    date: "2026-08-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-african-union-and-world-health-organization-renew-strategic-partnership",
    title: "Global Health and Education Watch: African Union and World Health Organization renew strategic partnership",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-01-global-health-and-education-watch-african-union-and-world-health-organization-re.jpg",
    date: "2026-08-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-did-75-000-students-cheat-on-a-college-entrance-exam-in",
    title: "Global Health and Education Watch: Did 75,000 Students Cheat on a College-Entrance Exam in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-01-global-health-and-education-watch-did-75-000-students-cheat-on-a-college-entranc.jpg",
    date: "2026-08-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-is-the-cyclosporiasis-outbreak-slowing-test-makers-are-hopeful",
    title: "Global Health and Education Watch: Is the cyclosporiasis outbreak slowing? Test-makers are hopeful",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-01-global-health-and-education-watch-is-the-cyclosporiasis-outbreak-slowing-test-ma.jpg",
    date: "2026-08-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cambridge-students-on-why-they-protested-at-graduation-ceremony",
    title: "Global Health and Education Watch: Cambridge students on why they protested at graduation ceremony",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-01-global-health-and-education-watch-cambridge-students-on-why-they-protested-at-gr.jpg",
    date: "2026-08-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-wildfire-smoke-poses-hidden-health-threat",
    title: "Global Health and Education Watch: Wildfire smoke poses hidden health threat",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-08-01-global-health-and-education-watch-wildfire-smoke-poses-hidden-health-threat.jpg",
    date: "2026-08-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-administration-plans-to-upend-head-start-by-deregulating",
    title: "Global Health and Education Watch: Trump Administration Plans to Upend Head Start by Deregulating",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-31-global-health-and-education-watch-trump-administration-plans-to-upend-head-start.jpg",
    date: "2026-07-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ireland-and-who-work-together-to-improve-access-to",
    title: "Global Health and Education Watch: Ireland and WHO work together to improve access to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-31-global-health-and-education-watch-ireland-and-who-work-together-to-improve-acces.jpg",
    date: "2026-07-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-calls-grow-to-flunk-portugal-s-education-minister-amid-exam",
    title: "Global Health and Education Watch: Calls grow ‘to flunk’ Portugal’s education minister amid exam",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-31-global-health-and-education-watch-calls-grow-to-flunk-portugal-s-education-minis.jpg",
    date: "2026-07-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-safe-blood-supply-improves-as-voluntary-donations-exceed-85-2",
    title: "Global Health and Education Watch: Safe blood supply improves as voluntary donations exceed 85%",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-31-global-health-and-education-watch-safe-blood-supply-improves-as-voluntary-donati.jpg",
    date: "2026-07-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-you-re-welcome-at-suny-new-york-tells-students-disenrolled",
    title: "Global Health and Education Watch: You’re Welcome at SUNY, New York Tells Students Disenrolled",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-31-global-health-and-education-watch-you-re-welcome-at-suny-new-york-tells-students.jpg",
    date: "2026-07-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-first-somewhat-optimistic-day-in-france-since-fire-outbreak",
    title: "Global Health and Education Watch: ‘First somewhat optimistic day’ in France since fire outbreak",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-31-global-health-and-education-watch-first-somewhat-optimistic-day-in-france-since-.jpg",
    date: "2026-07-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mount-olympus-and-d-day-beaches-among-new-world-heritage",
    title: "Global Health and Education Watch: Mount Olympus and D-Day beaches among new World Heritage",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-31-global-health-and-education-watch-mount-olympus-and-d-day-beaches-among-new-worl.jpg",
    date: "2026-07-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hiv-hepatitis-sti-gains-at-risk-as-funding-falls",
    title: "Global Health and Education Watch: HIV, hepatitis, STI gains at risk as funding falls",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-31-global-health-and-education-watch-hiv-hepatitis-sti-gains-at-risk-as-funding-fal.jpg",
    date: "2026-07-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-former-officials-protest-u-s-plan-to-defund-pan-american",
    title: "Global Health and Education Watch: Former Officials Protest U.S. Plan to Defund Pan American",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-30-global-health-and-education-watch-former-officials-protest-u-s-plan-to-defund-pa.jpg",
    date: "2026-07-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-us-public-is-fed-up-with-rfk-jr",
    title: "Global Health and Education Watch: The US public is fed up with RFK Jr",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-30-global-health-and-education-watch-the-us-public-is-fed-up-with-rfk-jr.jpg",
    date: "2026-07-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-i-m-torn-by-the-hard-hat-v-graduation-cap",
    title: "Global Health and Education Watch: I’m torn by the hard hat v graduation cap",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-30-global-health-and-education-watch-i-m-torn-by-the-hard-hat-v-graduation-cap.jpg",
    date: "2026-07-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-florida-professor-fired-for-assigning-a-profane-story-lawsuit",
    title: "Global Health and Education Watch: Florida Professor Fired for Assigning a Profane Story, Lawsuit",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-30-global-health-and-education-watch-florida-professor-fired-for-assigning-a-profan.jpg",
    date: "2026-07-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-have-you-done-an-apprenticeship-in-recent-years-in",
    title: "Global Health and Education Watch: Have you done an apprenticeship in recent years in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-30-global-health-and-education-watch-have-you-done-an-apprenticeship-in-recent-year.jpg",
    date: "2026-07-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-cuts-who-off-from-gavi-vaccine-alliance-funding",
    title: "Global Health and Education Watch: Trump cuts WHO off from Gavi vaccine alliance funding",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-30-global-health-and-education-watch-trump-cuts-who-off-from-gavi-vaccine-alliance-.jpg",
    date: "2026-07-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-high-prices-and-funding-cuts-stall-hiv-prevention-revolution-4",
    title: "Global Health and Education Watch: High prices and funding cuts stall HIV prevention revolution",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-29-global-health-and-education-watch-high-prices-and-funding-cuts-stall-hiv-prevent.jpg",
    date: "2026-07-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-high-prices-and-funding-cuts-stall-hiv-prevention-revolution-3",
    title: "Global Health and Education Watch: High prices and funding cuts stall HIV prevention revolution",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-29-global-health-and-education-watch-high-prices-and-funding-cuts-stall-hiv-prevent.jpg",
    date: "2026-07-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ice-cream-for-education-gaza-cafe-raises-funds-for",
    title: "Global Health and Education Watch: Ice cream for education: Gaza cafe raises funds for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-29-global-health-and-education-watch-ice-cream-for-education-gaza-cafe-raises-funds.jpg",
    date: "2026-07-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hunger-hampers-ebola-response-as-cases-top-3-200-in",
    title: "Global Health and Education Watch: Hunger hampers Ebola response as cases top 3,200 in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-29-global-health-and-education-watch-hunger-hampers-ebola-response-as-cases-top-3-2.jpg",
    date: "2026-07-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-should-we-make-daylight-saving-time-permanent-3",
    title: "Global Health and Education Watch: Should We Make Daylight Saving Time Permanent?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-29-global-health-and-education-watch-should-we-make-daylight-saving-time-permanent.jpg",
    date: "2026-07-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-should-we-make-daylight-saving-time-permanent-2",
    title: "Global Health and Education Watch: Should We Make Daylight Saving Time Permanent?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-29-global-health-and-education-watch-should-we-make-daylight-saving-time-permanent.jpg",
    date: "2026-07-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-should-we-make-daylight-saving-time-permanent",
    title: "Global Health and Education Watch: Should We Make Daylight Saving Time Permanent?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-29-global-health-and-education-watch-should-we-make-daylight-saving-time-permanent.jpg",
    date: "2026-07-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-deep-breathing-the-asthma-clinic-buried-250-metres-into",
    title: "Global Health and Education Watch: Deep breathing: the asthma clinic buried 250 metres into",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-29-global-health-and-education-watch-deep-breathing-the-asthma-clinic-buried-250-me.jpg",
    date: "2026-07-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-to-recruit-teachers-school-districts-are-building-homes",
    title: "Global Health and Education Watch: To Recruit Teachers, School Districts Are Building Homes",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-29-global-health-and-education-watch-to-recruit-teachers-school-districts-are-build.jpg",
    date: "2026-07-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-india-s-cockroach-movement-threatens-to-restart-protests-after-mass-2",
    title: "Global Health and Education Watch: India’s Cockroach movement threatens to restart protests after mass",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-29-global-health-and-education-watch-india-s-cockroach-movement-threatens-to-restar.jpg",
    date: "2026-07-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-india-s-cockroach-movement-threatens-to-restart-protests-after-mass",
    title: "Global Health and Education Watch: India’s Cockroach movement threatens to restart protests after mass",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-29-global-health-and-education-watch-india-s-cockroach-movement-threatens-to-restar.jpg",
    date: "2026-07-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uganda-declares-end-to-ebola-outbreak",
    title: "Global Health and Education Watch: Uganda declares end to Ebola outbreak",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-28-global-health-and-education-watch-uganda-declares-end-to-ebola-outbreak.jpg",
    date: "2026-07-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-hijab-inspection-a-slap-a-warning-letter-inside",
    title: "Global Health and Education Watch: A hijab inspection, a slap, a warning letter: Inside",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-28-global-health-and-education-watch-a-hijab-inspection-a-slap-a-warning-letter-ins.jpg",
    date: "2026-07-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-future-at-stake-india-moves-to-demolish-university-muslim",
    title: "Global Health and Education Watch: ‘Future at stake’: India moves to demolish university Muslim",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-28-global-health-and-education-watch-future-at-stake-india-moves-to-demolish-univer.jpg",
    date: "2026-07-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-we-are-not-learning-anything-india-s-gen-z-rage",
    title: "Global Health and Education Watch: ‘We Are Not Learning Anything’: India’s Gen Z Rage",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-28-global-health-and-education-watch-we-are-not-learning-anything-india-s-gen-z-rag.jpg",
    date: "2026-07-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-london-members-clubs-joining-the-wellness-revolution-3",
    title: "Global Health and Education Watch: The London members’ clubs joining the wellness revolution",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-28-global-health-and-education-watch-the-london-members-clubs-joining-the-wellness-.jpg",
    date: "2026-07-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-london-members-clubs-joining-the-wellness-revolution-2",
    title: "Global Health and Education Watch: The London members’ clubs joining the wellness revolution",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-28-global-health-and-education-watch-the-london-members-clubs-joining-the-wellness-.jpg",
    date: "2026-07-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-london-members-clubs-joining-the-wellness-revolution",
    title: "Global Health and Education Watch: The London members’ clubs joining the wellness revolution",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-28-global-health-and-education-watch-the-london-members-clubs-joining-the-wellness-.jpg",
    date: "2026-07-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-burnham-to-tell-schools-in-england-to-adapt-teaching",
    title: "Global Health and Education Watch: Burnham to tell schools in England to adapt teaching",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-28-global-health-and-education-watch-burnham-to-tell-schools-in-england-to-adapt-te.jpg",
    date: "2026-07-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ai-can-fuel-biological-weapons-we-must-harness-its",
    title: "Global Health and Education Watch: AI can fuel biological weapons. We must harness its",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-28-global-health-and-education-watch-ai-can-fuel-biological-weapons-we-must-harness.jpg",
    date: "2026-07-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-integration-innovation-and-community-leadership-key-to-ending",
    title: "Global Health and Education Watch: WHO: Integration, innovation and community leadership key to ending",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-27-global-health-and-education-watch-who-integration-innovation-and-community-leade.jpg",
    date: "2026-07-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-high-prices-and-funding-cuts-stall-hiv-prevention-revolution-2",
    title: "Global Health and Education Watch: High prices and funding cuts stall HIV prevention revolution",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-27-global-health-and-education-watch-high-prices-and-funding-cuts-stall-hiv-prevent.jpg",
    date: "2026-07-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-high-prices-and-funding-cuts-stall-hiv-prevention-revolution",
    title: "Global Health and Education Watch: High prices and funding cuts stall HIV prevention revolution",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-27-global-health-and-education-watch-high-prices-and-funding-cuts-stall-hiv-prevent.jpg",
    date: "2026-07-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cyberattacks-and-the-digital-divide-are-creating-new-barriers",
    title: "Global Health and Education Watch: Cyberattacks and the digital divide are creating new barriers",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-27-global-health-and-education-watch-cyberattacks-and-the-digital-divide-are-creati.jpg",
    date: "2026-07-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-students-and-staff-work-to-bring-islamic-university-of",
    title: "Global Health and Education Watch: Students and staff work to bring Islamic University of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-27-global-health-and-education-watch-students-and-staff-work-to-bring-islamic-unive.jpg",
    date: "2026-07-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-can-this-new-enzyme-turn-back-the-clock-in",
    title: "Global Health and Education Watch: Can This New Enzyme Turn Back the Clock in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-27-global-health-and-education-watch-can-this-new-enzyme-turn-back-the-clock-in.jpg",
    date: "2026-07-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-palantir-tool-has-not-cut-hospital-discharge-delays-study",
    title: "Global Health and Education Watch: Palantir tool has not cut hospital discharge delays, study",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-27-global-health-and-education-watch-palantir-tool-has-not-cut-hospital-discharge-d.jpg",
    date: "2026-07-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-s-border-czar-probes-possible-vetting-failures-after-ice-5",
    title: "Global Health and Education Watch: Trump’s border czar probes possible vetting failures after ICE",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-27-global-health-and-education-watch-trump-s-border-czar-probes-possible-vetting-fa.jpg",
    date: "2026-07-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-s-border-czar-probes-possible-vetting-failures-after-ice-4",
    title: "Global Health and Education Watch: Trump’s border czar probes possible vetting failures after ICE",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-27-global-health-and-education-watch-trump-s-border-czar-probes-possible-vetting-fa.jpg",
    date: "2026-07-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-s-border-czar-probes-possible-vetting-failures-after-ice-3",
    title: "Global Health and Education Watch: Trump’s border czar probes possible vetting failures after ICE",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-27-global-health-and-education-watch-trump-s-border-czar-probes-possible-vetting-fa.jpg",
    date: "2026-07-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-s-border-czar-probes-possible-vetting-failures-after-ice-2",
    title: "Global Health and Education Watch: Trump’s border czar probes possible vetting failures after ICE",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-26-global-health-and-education-watch-trump-s-border-czar-probes-possible-vetting-fa.jpg",
    date: "2026-07-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-s-border-czar-probes-possible-vetting-failures-after-ice",
    title: "Global Health and Education Watch: Trump’s border czar probes possible vetting failures after ICE",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-26-global-health-and-education-watch-trump-s-border-czar-probes-possible-vetting-fa.jpg",
    date: "2026-07-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-england-s-north-south-life-expectancy-gap-grows-despite-record-longevity",
    title: "Global Health and Education Watch: England’s north-south life expectancy gap grows despite record longevity",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-26-global-health-and-education-watch-england-s-north-south-life-expectancy-gap-grow.jpg",
    date: "2026-07-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-australia-news-live-new-sydney-harbour-pool-slated-to",
    title: "Global Health and Education Watch: Australia news live: new Sydney Harbour pool slated to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-26-global-health-and-education-watch-australia-news-live-new-sydney-harbour-pool-sl.jpg",
    date: "2026-07-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-20-years-after-its-own-outbreak-an-ugandan-town",
    title: "Global Health and Education Watch: 20 Years After Its Own Outbreak, an Ugandan Town",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-26-global-health-and-education-watch-20-years-after-its-own-outbreak-an-ugandan-tow.jpg",
    date: "2026-07-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-unsafe-food-causes-866-million-illnesses-and-1-5-million-2",
    title: "Global Health and Education Watch: Unsafe food causes 866 million illnesses and 1.5 million",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-26-global-health-and-education-watch-unsafe-food-causes-866-million-illnesses-and-1.jpg",
    date: "2026-07-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-gaza-dialysis-patients-face-grueling-hospital-journey-by-donkey",
    title: "Global Health and Education Watch: Gaza: Dialysis patients face grueling hospital journey by donkey",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-26-global-health-and-education-watch-gaza-dialysis-patients-face-grueling-hospital-.jpg",
    date: "2026-07-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-yemen-s-health-workers-race-to-halt-latest-outbreak-of",
    title: "Global Health and Education Watch: Yemen’s health workers race to halt latest outbreak of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-26-global-health-and-education-watch-yemen-s-health-workers-race-to-halt-latest-out.jpg",
    date: "2026-07-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-is-burnham-s-oxbridge-heavy-cabinet-a-sign-of-social-mobility",
    title: "Global Health and Education Watch: Is Burnham’s Oxbridge-heavy cabinet a sign of social mobility",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-26-global-health-and-education-watch-is-burnham-s-oxbridge-heavy-cabinet-a-sign-of-.jpg",
    date: "2026-07-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-socialist-teachers-target-eight-victorian-labor-mps-including-education",
    title: "Global Health and Education Watch: ‘Socialist’ teachers target eight Victorian Labor MPs including education",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-26-global-health-and-education-watch-socialist-teachers-target-eight-victorian-labo.jpg",
    date: "2026-07-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-lead-pollution-poses-health-risk-says-review-sparked-by",
    title: "Global Health and Education Watch: Lead pollution poses health risk, says review sparked by",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-26-global-health-and-education-watch-lead-pollution-poses-health-risk-says-review-s.jpg",
    date: "2026-07-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-sally-the-robot-was-coming-to-a-new-york-2",
    title: "Global Health and Education Watch: Sally the Robot Was Coming to a New York",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-26-global-health-and-education-watch-sally-the-robot-was-coming-to-a-new-york.jpg",
    date: "2026-07-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israeli-forces-target-gaza-s-al-aqsa-hospital-2",
    title: "Global Health and Education Watch: Israeli forces target Gaza’s Al-Aqsa hospital",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-26-global-health-and-education-watch-israeli-forces-target-gaza-s-al-aqsa-hospital.jpg",
    date: "2026-07-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israeli-forces-target-gaza-s-al-aqsa-hospital",
    title: "Global Health and Education Watch: Israeli forces target Gaza’s Al-Aqsa hospital",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-25-global-health-and-education-watch-israeli-forces-target-gaza-s-al-aqsa-hospital.jpg",
    date: "2026-07-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-sally-the-robot-was-coming-to-a-new-york",
    title: "Global Health and Education Watch: Sally the Robot Was Coming to a New York",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-25-global-health-and-education-watch-sally-the-robot-was-coming-to-a-new-york.jpg",
    date: "2026-07-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-more-than-500-howard-university-students-are-bumped-from",
    title: "Global Health and Education Watch: More Than 500 Howard University Students Are Bumped From",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-25-global-health-and-education-watch-more-than-500-howard-university-students-are-b.jpg",
    date: "2026-07-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-reclaiming-stolen-childhoods-swimming-classes-resume-in-gaza-after",
    title: "Global Health and Education Watch: Reclaiming stolen childhoods: swimming classes resume in Gaza after",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-25-global-health-and-education-watch-reclaiming-stolen-childhoods-swimming-classes-.jpg",
    date: "2026-07-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-global-south-is-being-forced-to-choose-creditors",
    title: "Global Health and Education Watch: The Global South is being forced to choose creditors",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-25-global-health-and-education-watch-the-global-south-is-being-forced-to-choose-cre.jpg",
    date: "2026-07-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-women-do-not-stop-giving-birth-in-an-emergency",
    title: "Global Health and Education Watch: ‘Women do not stop giving birth in an emergency’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-25-global-health-and-education-watch-women-do-not-stop-giving-birth-in-an-emergency.jpg",
    date: "2026-07-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-geriatric-emergency-departments-do-differently",
    title: "Global Health and Education Watch: What Geriatric Emergency Departments Do Differently",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-25-global-health-and-education-watch-what-geriatric-emergency-departments-do-differ.jpg",
    date: "2026-07-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-maha-inc-how-companies-tied-to-kennedy-s-movement-are-5",
    title: "Global Health and Education Watch: Maha Inc: how companies tied to Kennedy’s movement are",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-25-global-health-and-education-watch-maha-inc-how-companies-tied-to-kennedy-s-movem.jpg",
    date: "2026-07-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-maha-inc-how-companies-tied-to-kennedy-s-movement-are-4",
    title: "Global Health and Education Watch: Maha Inc: how companies tied to Kennedy’s movement are",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-25-global-health-and-education-watch-maha-inc-how-companies-tied-to-kennedy-s-movem.jpg",
    date: "2026-07-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-maha-inc-how-companies-tied-to-kennedy-s-movement-are-3",
    title: "Global Health and Education Watch: Maha Inc: how companies tied to Kennedy’s movement are",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-25-global-health-and-education-watch-maha-inc-how-companies-tied-to-kennedy-s-movem.jpg",
    date: "2026-07-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-maha-inc-how-companies-tied-to-kennedy-s-movement-are-2",
    title: "Global Health and Education Watch: Maha Inc: how companies tied to Kennedy’s movement are",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-25-global-health-and-education-watch-maha-inc-how-companies-tied-to-kennedy-s-movem.jpg",
    date: "2026-07-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-maha-inc-how-companies-tied-to-kennedy-s-movement-are",
    title: "Global Health and Education Watch: Maha Inc: how companies tied to Kennedy’s movement are",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-25-global-health-and-education-watch-maha-inc-how-companies-tied-to-kennedy-s-movem.jpg",
    date: "2026-07-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-unequal-mental-health-impacts-of-extreme-weather-and-climate",
    title: "Global Health and Education Watch: Unequal mental health impacts of extreme weather and climate",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-25-global-health-and-education-watch-unequal-mental-health-impacts-of-extreme-weath.jpg",
    date: "2026-07-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-my-advice-to-new-tate-director-show-us",
    title: "Global Health and Education Watch: My advice to new Tate director – show us",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-25-global-health-and-education-watch-my-advice-to-new-tate-director-show-us.jpg",
    date: "2026-07-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-africa-cdc-and-who-launch-joint-continental-ebola-response-4",
    title: "Global Health and Education Watch: Africa CDC and WHO launch joint continental Ebola response",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-25-global-health-and-education-watch-africa-cdc-and-who-launch-joint-continental-eb.jpg",
    date: "2026-07-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-africa-cdc-and-who-launch-joint-continental-ebola-response-3",
    title: "Global Health and Education Watch: Africa CDC and WHO launch joint continental Ebola response",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-25-global-health-and-education-watch-africa-cdc-and-who-launch-joint-continental-eb.jpg",
    date: "2026-07-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-africa-cdc-and-who-launch-joint-continental-ebola-response-2",
    title: "Global Health and Education Watch: Africa CDC and WHO launch joint continental Ebola response",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-25-global-health-and-education-watch-africa-cdc-and-who-launch-joint-continental-eb.jpg",
    date: "2026-07-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-school-shooter-pleads-guilty-in-georgia-following-father-s",
    title: "Global Health and Education Watch: US school shooter pleads guilty in Georgia following father’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-24-global-health-and-education-watch-us-school-shooter-pleads-guilty-in-georgia-fol.jpg",
    date: "2026-07-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-teachers-union-boss-vows-all-out-war-if-mamdani-doesn-t-back",
    title: "Global Health and Education Watch: Teachers’ Union Boss Vows ‘All-Out-War’ if Mamdani Doesn’t Back",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-24-global-health-and-education-watch-teachers-union-boss-vows-all-out-war-if-mamdan.jpg",
    date: "2026-07-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-after-an-ebola-centre-was-attacked-peacekeepers-moved-in",
    title: "Global Health and Education Watch: After an Ebola centre was attacked, peacekeepers moved in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-24-global-health-and-education-watch-after-an-ebola-centre-was-attacked-peacekeeper.jpg",
    date: "2026-07-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-wildfires-surge-across-europe-as-spain-and-france-battle",
    title: "Global Health and Education Watch: Wildfires surge across Europe as Spain and France battle",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-24-global-health-and-education-watch-wildfires-surge-across-europe-as-spain-and-fra.jpg",
    date: "2026-07-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-indian-student-protests-what-s-next-after-modi-s-promise-on",
    title: "Global Health and Education Watch: Indian student protests: What’s next after Modi’s promise on",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-24-global-health-and-education-watch-indian-student-protests-what-s-next-after-modi.jpg",
    date: "2026-07-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-replacing-gas-stove-can-help-asthmatics-as-much-as",
    title: "Global Health and Education Watch: Replacing gas stove can help asthmatics as much as",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-24-global-health-and-education-watch-replacing-gas-stove-can-help-asthmatics-as-muc.jpg",
    date: "2026-07-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-rapid-rise-of-english-councils-funding-private-online",
    title: "Global Health and Education Watch: The rapid rise of English councils funding private online",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-24-global-health-and-education-watch-the-rapid-rise-of-english-councils-funding-pri.jpg",
    date: "2026-07-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-key-republican-senator-says-he-will-support-erica-schwartz",
    title: "Global Health and Education Watch: Key Republican Senator Says He Will Support Erica Schwartz",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-24-global-health-and-education-watch-key-republican-senator-says-he-will-support-er.jpg",
    date: "2026-07-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-only-way-to-stop-petrol-pump-thieves",
    title: "Global Health and Education Watch: The only way to stop petrol pump thieves |",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-24-global-health-and-education-watch-the-only-way-to-stop-petrol-pump-thieves.jpg",
    date: "2026-07-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-indian-activist-wangchuk-ends-26-day-hunger-strike-over-exam",
    title: "Global Health and Education Watch: Indian activist Wangchuk ends 26-day hunger strike over exam",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-23-global-health-and-education-watch-indian-activist-wangchuk-ends-26-day-hunger-st.jpg",
    date: "2026-07-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-launches-seven-strategies-to-prevent-drowning",
    title: "Global Health and Education Watch: WHO launches seven strategies to prevent drowning",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-23-global-health-and-education-watch-who-launches-seven-strategies-to-prevent-drown.jpg",
    date: "2026-07-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-n-y-c-schools-miss-out-on-431-million-in-medicaid",
    title: "Global Health and Education Watch: N.Y.C. Schools Miss Out on $431 Million in Medicaid",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-23-global-health-and-education-watch-n-y-c-schools-miss-out-on-431-million-in-medic.jpg",
    date: "2026-07-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-gaza-s-food-gains-could-unravel-without-sustained-aid-un",
    title: "Global Health and Education Watch: Gaza’s food gains could unravel without sustained aid, UN",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-23-global-health-and-education-watch-gaza-s-food-gains-could-unravel-without-sustai.jpg",
    date: "2026-07-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-does-make-america-healthy-again-hold-up-against",
    title: "Global Health and Education Watch: How does Make America Healthy Again hold up against",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-23-global-health-and-education-watch-how-does-make-america-healthy-again-hold-up-ag.jpg",
    date: "2026-07-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-fifth-person-dies-in-new-york-city-amid-legionnaires",
    title: "Global Health and Education Watch: Fifth person dies in New York City amid legionnaires’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-23-global-health-and-education-watch-fifth-person-dies-in-new-york-city-amid-legion.jpg",
    date: "2026-07-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-india-s-modi-promises-fast-track-courts-for-exam-fraud-fuelling",
    title: "Global Health and Education Watch: India’s Modi promises fast-track courts for exam fraud fuelling",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-23-global-health-and-education-watch-india-s-modi-promises-fast-track-courts-for-ex.jpg",
    date: "2026-07-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-marks-25-years-of-research4life-advancing-access-to",
    title: "Global Health and Education Watch: WHO marks 25 years of Research4Life, advancing access to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-23-global-health-and-education-watch-who-marks-25-years-of-research4life-advancing-.jpg",
    date: "2026-07-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cdc-cuts-leave-us-less-prepared-for-disease-outbreaks",
    title: "Global Health and Education Watch: CDC cuts leave US less prepared for disease outbreaks",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-23-global-health-and-education-watch-cdc-cuts-leave-us-less-prepared-for-disease-ou.jpg",
    date: "2026-07-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-my-stepdaughter-s-college-was-paid-for-do-we-have",
    title: "Global Health and Education Watch: My Stepdaughter’s College Was Paid For. Do We Have",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-23-global-health-and-education-watch-my-stepdaughter-s-college-was-paid-for-do-we-h.jpg",
    date: "2026-07-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-thousands-prevented-from-returning-home-to-southern-lebanon",
    title: "Global Health and Education Watch: Thousands prevented from returning home to southern Lebanon",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-22-global-health-and-education-watch-thousands-prevented-from-returning-home-to-sou.jpg",
    date: "2026-07-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-cyclospora-cases-mount-as-authorities-struggle-to-find",
    title: "Global Health and Education Watch: US cyclospora cases mount as authorities struggle to find",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-22-global-health-and-education-watch-us-cyclospora-cases-mount-as-authorities-strug.jpg",
    date: "2026-07-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-at-a-utah-campus-an-emotional-odyssey-after-charlie",
    title: "Global Health and Education Watch: At a Utah Campus, an Emotional Odyssey After Charlie",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-22-global-health-and-education-watch-at-a-utah-campus-an-emotional-odyssey-after-ch.jpg",
    date: "2026-07-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-india-protest-how-modi-s-refusal-to-sack-education-minister",
    title: "Global Health and Education Watch: India protest: How Modi’s refusal to sack education minister",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-22-global-health-and-education-watch-india-protest-how-modi-s-refusal-to-sack-educa.jpg",
    date: "2026-07-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-nhs-england-adds-caveat-to-pro-palantir-data-after-watchdog",
    title: "Global Health and Education Watch: NHS England adds caveat to pro-Palantir data after watchdog",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-22-global-health-and-education-watch-nhs-england-adds-caveat-to-pro-palantir-data-a.jpg",
    date: "2026-07-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-un-report-global-hunger-levels-ease-for-third-consecutive",
    title: "Global Health and Education Watch: UN report: Global hunger levels ease for third consecutive",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-22-global-health-and-education-watch-un-report-global-hunger-levels-ease-for-third-.jpg",
    date: "2026-07-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-fourth-person-dies-in-new-york-city-legionnaires-disease",
    title: "Global Health and Education Watch: Fourth person dies in New York City legionnaires’ disease",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-22-global-health-and-education-watch-fourth-person-dies-in-new-york-city-legionnair.jpg",
    date: "2026-07-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-health-worker-monitored-for-ebola-in-london-hospital-after",
    title: "Global Health and Education Watch: Health worker monitored for Ebola in London hospital after",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-22-global-health-and-education-watch-health-worker-monitored-for-ebola-in-london-ho.jpg",
    date: "2026-07-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-joint-statement-by-the-government-of-the-democratic-republic",
    title: "Global Health and Education Watch: Joint statement by the Government of the Democratic Republic",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-22-global-health-and-education-watch-joint-statement-by-the-government-of-the-democ.jpg",
    date: "2026-07-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-india-s-young-protesters-are-bloodied-but-unbowed",
    title: "Global Health and Education Watch: India’s Young Protesters Are Bloodied but Unbowed",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-21-global-health-and-education-watch-india-s-young-protesters-are-bloodied-but-unbo.jpg",
    date: "2026-07-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-funding-cuts-deal-blow-to-global-hiv-treatment",
    title: "Global Health and Education Watch: US funding cuts deal blow to global HIV treatment",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-21-global-health-and-education-watch-us-funding-cuts-deal-blow-to-global-hiv-treatm.jpg",
    date: "2026-07-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-yet-another-wake-up-call-on-declining-child-health",
    title: "Global Health and Education Watch: Yet another wake-up call on declining child health |",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-21-global-health-and-education-watch-yet-another-wake-up-call-on-declining-child-he.jpg",
    date: "2026-07-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-dr-congo-ebola-outbreak-still-expanding-who-sees-signs",
    title: "Global Health and Education Watch: DR Congo: Ebola outbreak still expanding, WHO sees signs",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-21-global-health-and-education-watch-dr-congo-ebola-outbreak-still-expanding-who-se.jpg",
    date: "2026-07-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-too-rare-to-care-a-new-center-for-rare",
    title: "Global Health and Education Watch: ‘Too Rare to Care’? A New Center for Rare",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-21-global-health-and-education-watch-too-rare-to-care-a-new-center-for-rare.jpg",
    date: "2026-07-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-won-t-back-down-indian-student-protesters-return-after-police-2",
    title: "Global Health and Education Watch: ‘Won’t back down’: Indian student protesters return after police",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-21-global-health-and-education-watch-won-t-back-down-indian-student-protesters-retu.jpg",
    date: "2026-07-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-won-t-back-down-indian-student-protesters-return-after-police",
    title: "Global Health and Education Watch: ‘Won’t back down’: Indian student protesters return after police",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-21-global-health-and-education-watch-won-t-back-down-indian-student-protesters-retu.jpg",
    date: "2026-07-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-palantir-isn-t-the-only-option-for-the-nhs",
    title: "Global Health and Education Watch: Palantir isn’t the only option for the NHS |",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-21-global-health-and-education-watch-palantir-isn-t-the-only-option-for-the-nhs.jpg",
    date: "2026-07-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-road-deaths-fall-by-21-globally-but-stronger-action",
    title: "Global Health and Education Watch: Road deaths fall by 21% globally but stronger action",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-21-global-health-and-education-watch-road-deaths-fall-by-21-globally-but-stronger-a.jpg",
    date: "2026-07-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-health-response-brings-lifesaving-care-closer-to-thousands-in",
    title: "Global Health and Education Watch: Health response brings lifesaving care closer to thousands in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-21-global-health-and-education-watch-health-response-brings-lifesaving-care-closer-.jpg",
    date: "2026-07-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-seventy-ninth-world-health-assembly-daily-update-19-may-2",
    title: "Global Health and Education Watch: Seventy-ninth World Health Assembly – Daily update: 19 May",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-21-global-health-and-education-watch-seventy-ninth-world-health-assembly-daily-upda.jpg",
    date: "2026-07-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-guardian-view-on-humanities-cuts-in-universities-academic",
    title: "Global Health and Education Watch: The Guardian view on humanities cuts in universities: academic",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-20-global-health-and-education-watch-the-guardian-view-on-humanities-cuts-in-univer.jpg",
    date: "2026-07-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-epidemics-and-rage",
    title: "Global Health and Education Watch: Epidemics and Rage",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-20-global-health-and-education-watch-epidemics-and-rage.jpg",
    date: "2026-07-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-now-or-never-students-defy-delhi-lockdown-to-march",
    title: "Global Health and Education Watch: ‘Now or never’: Students defy Delhi lockdown to march",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-20-global-health-and-education-watch-now-or-never-students-defy-delhi-lockdown-to-m.jpg",
    date: "2026-07-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-death-toll-rises-to-930-as-outbreak-spreads",
    title: "Global Health and Education Watch: Ebola death toll rises to 930, as outbreak spreads",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-20-global-health-and-education-watch-ebola-death-toll-rises-to-930-as-outbreak-spre.jpg",
    date: "2026-07-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-best-genetic-risk-tools-don-t-work-equally-for",
    title: "Global Health and Education Watch: The Best Genetic Risk Tools Don’t Work Equally for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-20-global-health-and-education-watch-the-best-genetic-risk-tools-don-t-work-equally.jpg",
    date: "2026-07-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-photos-police-fire-tear-gas-at-india-s-cockroach-movement",
    title: "Global Health and Education Watch: Photos: Police fire tear gas at India’s Cockroach movement",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-20-global-health-and-education-watch-photos-police-fire-tear-gas-at-india-s-cockroa.jpg",
    date: "2026-07-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-complete-shock-and-dismay-scientists-unite-against-trump-s-1tn",
    title: "Global Health and Education Watch: ‘Complete shock and dismay’: scientists unite against Trump’s $1tn",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-20-global-health-and-education-watch-complete-shock-and-dismay-scientists-unite-aga.jpg",
    date: "2026-07-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-astrazeneca-highlights-rare-diseases-in-80bn-revenue-push",
    title: "Global Health and Education Watch: AstraZeneca highlights rare diseases in $80bn revenue push",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-20-global-health-and-education-watch-astrazeneca-highlights-rare-diseases-in-80bn-r.jpg",
    date: "2026-07-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israel-s-brutality-cannot-continue-in-plain-sight-letters",
    title: "Global Health and Education Watch: Israel’s brutality cannot continue in plain sight | Letters",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-20-global-health-and-education-watch-israel-s-brutality-cannot-continue-in-plain-si.jpg",
    date: "2026-07-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-urges-governments-to-protect-young-people-from-addiction-2",
    title: "Global Health and Education Watch: WHO urges governments to protect young people from addiction",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-20-global-health-and-education-watch-who-urges-governments-to-protect-young-people-.jpg",
    date: "2026-07-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-second-person-dies-in-legionnaires-disease-outbreak-in-new-5",
    title: "Global Health and Education Watch: Second person dies in legionnaires’ disease outbreak in New",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-19-global-health-and-education-watch-second-person-dies-in-legionnaires-disease-out.jpg",
    date: "2026-07-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-7-americans-sent-to-disputed-kenya-ebola-site-after",
    title: "Global Health and Education Watch: 7 Americans Sent to Disputed Kenya Ebola Site After",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-19-global-health-and-education-watch-7-americans-sent-to-disputed-kenya-ebola-site-.jpg",
    date: "2026-07-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-second-person-dies-in-legionnaires-disease-outbreak-in-new-4",
    title: "Global Health and Education Watch: Second person dies in legionnaires’ disease outbreak in New",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-19-global-health-and-education-watch-second-person-dies-in-legionnaires-disease-out.jpg",
    date: "2026-07-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-second-person-dies-in-legionnaires-disease-outbreak-in-new-3",
    title: "Global Health and Education Watch: Second person dies in legionnaires’ disease outbreak in New",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-19-global-health-and-education-watch-second-person-dies-in-legionnaires-disease-out.jpg",
    date: "2026-07-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-second-person-dies-in-legionnaires-disease-outbreak-in-new-2",
    title: "Global Health and Education Watch: Second person dies in legionnaires’ disease outbreak in New",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-19-global-health-and-education-watch-second-person-dies-in-legionnaires-disease-out.jpg",
    date: "2026-07-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-second-person-dies-in-legionnaires-disease-outbreak-in-new",
    title: "Global Health and Education Watch: Second person dies in legionnaires’ disease outbreak in New",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-19-global-health-and-education-watch-second-person-dies-in-legionnaires-disease-out.jpg",
    date: "2026-07-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israel-uses-law-to-destroy-palestinian-education-in-east",
    title: "Global Health and Education Watch: Israel uses law to destroy Palestinian education in East",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-19-global-health-and-education-watch-israel-uses-law-to-destroy-palestinian-educati.jpg",
    date: "2026-07-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-trump-and-his-administration-have-mired-the-us",
    title: "Global Health and Education Watch: How Trump and his administration have mired the US",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-19-global-health-and-education-watch-how-trump-and-his-administration-have-mired-th.jpg",
    date: "2026-07-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-truth-about-migraines-what-causes-them-and-3",
    title: "Global Health and Education Watch: The truth about migraines: what causes them – and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-19-global-health-and-education-watch-the-truth-about-migraines-what-causes-them-and.jpg",
    date: "2026-07-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-truth-about-migraines-what-causes-them-and-2",
    title: "Global Health and Education Watch: The truth about migraines: what causes them – and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-19-global-health-and-education-watch-the-truth-about-migraines-what-causes-them-and.jpg",
    date: "2026-07-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-truth-about-migraines-what-causes-them-and",
    title: "Global Health and Education Watch: The truth about migraines: what causes them – and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-19-global-health-and-education-watch-the-truth-about-migraines-what-causes-them-and.jpg",
    date: "2026-07-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-is-this-billionaire-s-name-all-over-harvard-s-campus",
    title: "Global Health and Education Watch: Why Is This Billionaire’s Name All Over Harvard’s Campus?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-19-global-health-and-education-watch-why-is-this-billionaire-s-name-all-over-harvar.jpg",
    date: "2026-07-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-experts-convened-by-who-advise-on-candidate-treatments-and-2",
    title: "Global Health and Education Watch: Experts convened by WHO advise on candidate treatments and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-19-global-health-and-education-watch-experts-convened-by-who-advise-on-candidate-tr.jpg",
    date: "2026-07-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cockroach-party-protest-intensifies-after-wangchuk-forcibly-hospitalised-3",
    title: "Global Health and Education Watch: Cockroach Party protest intensifies after Wangchuk forcibly hospitalised",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-19-global-health-and-education-watch-cockroach-party-protest-intensifies-after-wang.jpg",
    date: "2026-07-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cockroach-party-protest-intensifies-after-wangchuk-forcibly-hospitalised-2",
    title: "Global Health and Education Watch: Cockroach Party protest intensifies after Wangchuk forcibly hospitalised",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-19-global-health-and-education-watch-cockroach-party-protest-intensifies-after-wang.jpg",
    date: "2026-07-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cockroach-party-protest-intensifies-after-wangchuk-forcibly-hospitalised",
    title: "Global Health and Education Watch: Cockroach Party protest intensifies after Wangchuk forcibly hospitalised",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-19-global-health-and-education-watch-cockroach-party-protest-intensifies-after-wang.jpg",
    date: "2026-07-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cyclospora-is-easy-for-doctors-to-miss-the-us",
    title: "Global Health and Education Watch: Cyclospora is easy for doctors to miss. The US",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-19-global-health-and-education-watch-cyclospora-is-easy-for-doctors-to-miss-the-us.jpg",
    date: "2026-07-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-faced-with-inadequate-us-healthcare-black-women-fly-to",
    title: "Global Health and Education Watch: Faced with inadequate US healthcare, Black women fly to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-18-global-health-and-education-watch-faced-with-inadequate-us-healthcare-black-wome.jpg",
    date: "2026-07-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-taylor-farms-expands-iceberg-lettuce-recall-to-27-states",
    title: "Global Health and Education Watch: Taylor Farms Expands Iceberg Lettuce Recall to 27 States",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-18-global-health-and-education-watch-taylor-farms-expands-iceberg-lettuce-recall-to.jpg",
    date: "2026-07-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-message-by-the-who-director-general-to-the-people-of-3",
    title: "Global Health and Education Watch: Message by the WHO Director-General to the people of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-18-global-health-and-education-watch-message-by-the-who-director-general-to-the-peo.jpg",
    date: "2026-07-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-harnessing-data-science-to-control-non-communicable-diseases-in-africa",
    title: "Global Health and Education Watch: Harnessing data science to control non-communicable diseases in Africa",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-18-global-health-and-education-watch-harnessing-data-science-to-control-non-communi.jpg",
    date: "2026-07-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-north-dakota-men-who-discover-they-were-switched-as",
    title: "Global Health and Education Watch: North Dakota men who discover they were switched as",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-18-global-health-and-education-watch-north-dakota-men-who-discover-they-were-switch.jpg",
    date: "2026-07-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-death-toll-from-uganda-school-bus-crash-rises-to",
    title: "Global Health and Education Watch: Death toll from Uganda school bus crash rises to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-18-global-health-and-education-watch-death-toll-from-uganda-school-bus-crash-rises-.jpg",
    date: "2026-07-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-s-deep-public-health-cuts-hinder-response-to-record-3",
    title: "Global Health and Education Watch: Trump’s deep public health cuts hinder response to record",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-18-global-health-and-education-watch-trump-s-deep-public-health-cuts-hinder-respons.jpg",
    date: "2026-07-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-s-deep-public-health-cuts-hinder-response-to-record-2",
    title: "Global Health and Education Watch: Trump’s deep public health cuts hinder response to record",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-18-global-health-and-education-watch-trump-s-deep-public-health-cuts-hinder-respons.jpg",
    date: "2026-07-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-s-deep-public-health-cuts-hinder-response-to-record",
    title: "Global Health and Education Watch: Trump’s deep public health cuts hinder response to record",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-18-global-health-and-education-watch-trump-s-deep-public-health-cuts-hinder-respons.jpg",
    date: "2026-07-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-one-person-dies-amid-legionnaires-disease-outbreak-in-new",
    title: "Global Health and Education Watch: One person dies amid legionnaires’ disease outbreak in New",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-18-global-health-and-education-watch-one-person-dies-amid-legionnaires-disease-outb.jpg",
    date: "2026-07-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-indian-activist-on-hunger-strike-is-forcibly-removed-by",
    title: "Global Health and Education Watch: Indian Activist on Hunger Strike Is Forcibly Removed by",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-18-global-health-and-education-watch-indian-activist-on-hunger-strike-is-forcibly-r.jpg",
    date: "2026-07-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-seventy-ninth-world-health-assembly-daily-update-20-may",
    title: "Global Health and Education Watch: Seventy-ninth World Health Assembly – Daily update: 20 May",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-18-global-health-and-education-watch-seventy-ninth-world-health-assembly-daily-upda.jpg",
    date: "2026-07-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israeli-army-destroys-three-schools-in-southern-lebanon-minister",
    title: "Global Health and Education Watch: Israeli army destroys three schools in southern Lebanon, minister",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-18-global-health-and-education-watch-israeli-army-destroys-three-schools-in-souther.jpg",
    date: "2026-07-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-new-guidance-offers-hope-for-reducing-the-global-toll",
    title: "Global Health and Education Watch: New guidance offers hope for reducing the global toll",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-18-global-health-and-education-watch-new-guidance-offers-hope-for-reducing-the-glob.jpg",
    date: "2026-07-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cdc-and-fda-link-lettuce-at-taco-bell-in",
    title: "Global Health and Education Watch: CDC and FDA link lettuce at Taco Bell in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-18-global-health-and-education-watch-cdc-and-fda-link-lettuce-at-taco-bell-in.jpg",
    date: "2026-07-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-help-my-sofa-is-killing-me-the-toxic-chemicals",
    title: "Global Health and Education Watch: Help, my sofa is killing me! The toxic chemicals",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-17-global-health-and-education-watch-help-my-sofa-is-killing-me-the-toxic-chemicals.jpg",
    date: "2026-07-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-seventy-ninth-world-health-assembly-daily-update-22-may-2",
    title: "Global Health and Education Watch: Seventy-ninth World Health Assembly – Daily update: 22 May",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-17-global-health-and-education-watch-seventy-ninth-world-health-assembly-daily-upda.jpg",
    date: "2026-07-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-parents-in-uganda-demand-answers-after-bus-crash-kills",
    title: "Global Health and Education Watch: Parents in Uganda Demand Answers After Bus Crash Kills",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-17-global-health-and-education-watch-parents-in-uganda-demand-answers-after-bus-cra.jpg",
    date: "2026-07-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-breaking-the-silence-zimbabwean-youth-leader-calls-for-urgent",
    title: "Global Health and Education Watch: Breaking the silence: Zimbabwean youth leader calls for urgent",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-17-global-health-and-education-watch-breaking-the-silence-zimbabwean-youth-leader-c.jpg",
    date: "2026-07-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-taking-salsa-classes-can-improve-mental-health-oxford-study",
    title: "Global Health and Education Watch: Taking salsa classes can improve mental health, Oxford study",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-17-global-health-and-education-watch-taking-salsa-classes-can-improve-mental-health.jpg",
    date: "2026-07-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uganda-school-bus-crash-kills-20-children-and-1",
    title: "Global Health and Education Watch: Uganda school bus crash kills 20 children and 1",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-17-global-health-and-education-watch-uganda-school-bus-crash-kills-20-children-and-.jpg",
    date: "2026-07-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cyclospora-linked-to-taylor-farms-lettuce-sent-to-taco",
    title: "Global Health and Education Watch: Cyclospora Linked to Taylor Farms Lettuce Sent to Taco",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-17-global-health-and-education-watch-cyclospora-linked-to-taylor-farms-lettuce-sent.jpg",
    date: "2026-07-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-is-pakistan-s-sindh-province-facing-a-major-child-3",
    title: "Global Health and Education Watch: Why is Pakistan’s Sindh province facing a major child",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-17-global-health-and-education-watch-why-is-pakistan-s-sindh-province-facing-a-majo.jpg",
    date: "2026-07-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-is-pakistan-s-sindh-province-facing-a-major-child-2",
    title: "Global Health and Education Watch: Why is Pakistan’s Sindh province facing a major child",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-17-global-health-and-education-watch-why-is-pakistan-s-sindh-province-facing-a-majo.jpg",
    date: "2026-07-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-is-pakistan-s-sindh-province-facing-a-major-child",
    title: "Global Health and Education Watch: Why is Pakistan’s Sindh province facing a major child",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-17-global-health-and-education-watch-why-is-pakistan-s-sindh-province-facing-a-majo.jpg",
    date: "2026-07-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-seventy-ninth-world-health-assembly-daily-update-23-may-2",
    title: "Global Health and Education Watch: Seventy-ninth World Health Assembly – Daily update: 23 May",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-17-global-health-and-education-watch-seventy-ninth-world-health-assembly-daily-upda.jpg",
    date: "2026-07-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-africa-s-response-to-this-ebola-outbreak-shows-how-to",
    title: "Global Health and Education Watch: Africa’s response to this Ebola outbreak shows how to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-17-global-health-and-education-watch-africa-s-response-to-this-ebola-outbreak-shows.jpg",
    date: "2026-07-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-warns-dr-congo-ebola-outbreak-is-outpacing-response",
    title: "Global Health and Education Watch: WHO warns DR Congo Ebola outbreak is outpacing response",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-17-global-health-and-education-watch-who-warns-dr-congo-ebola-outbreak-is-outpacing.jpg",
    date: "2026-07-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-offer-teenagers-a-meningitis-b-vaccine-on-nhs-advisers",
    title: "Global Health and Education Watch: Offer teenagers a meningitis B vaccine on NHS, advisers",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-16-global-health-and-education-watch-offer-teenagers-a-meningitis-b-vaccine-on-nhs-.jpg",
    date: "2026-07-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-private-schools-offer-41-more-tree-shade-than-state",
    title: "Global Health and Education Watch: Private schools offer 41% more tree shade than state",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-16-global-health-and-education-watch-private-schools-offer-41-more-tree-shade-than-.jpg",
    date: "2026-07-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-f-d-a-approves-a-new-pill-to-slash-cholesterol",
    title: "Global Health and Education Watch: The F.D.A. Approves a New Pill to Slash Cholesterol",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-16-global-health-and-education-watch-the-f-d-a-approves-a-new-pill-to-slash-cholest.jpg",
    date: "2026-07-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-heat-deaths-are-not-inevitable-who-pushes-europe-to",
    title: "Global Health and Education Watch: ‘Heat deaths are not inevitable’: WHO pushes Europe to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-16-global-health-and-education-watch-heat-deaths-are-not-inevitable-who-pushes-euro.jpg",
    date: "2026-07-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-first-meeting-of-the-ihr-emergency-committee-regarding-the",
    title: "Global Health and Education Watch: First meeting of the IHR Emergency Committee regarding the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-16-global-health-and-education-watch-first-meeting-of-the-ihr-emergency-committee-r.jpg",
    date: "2026-07-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uganda-calls-for-travel-restrictions-to-be-lifted-after",
    title: "Global Health and Education Watch: Uganda calls for travel restrictions to be lifted after",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-16-global-health-and-education-watch-uganda-calls-for-travel-restrictions-to-be-lif.jpg",
    date: "2026-07-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-is-cyclospora-diarrhoea-symptoms-foods-linked-to-us",
    title: "Global Health and Education Watch: What is cyclospora? Diarrhoea symptoms, foods linked to US",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-16-global-health-and-education-watch-what-is-cyclospora-diarrhoea-symptoms-foods-li.jpg",
    date: "2026-07-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cdc-nominee-erica-schwartz-pressed-on-whether-she-will",
    title: "Global Health and Education Watch: CDC nominee Erica Schwartz pressed on whether she will",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-16-global-health-and-education-watch-cdc-nominee-erica-schwartz-pressed-on-whether-.jpg",
    date: "2026-07-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-canada-wildfire-air-pollution-and-heat-wave-combo-pose",
    title: "Global Health and Education Watch: Canada Wildfire Air Pollution and Heat Wave Combo Pose",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-16-global-health-and-education-watch-canada-wildfire-air-pollution-and-heat-wave-co.jpg",
    date: "2026-07-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-iranian-doctor-says-us-strike-damaged-children-s-cancer-hospital",
    title: "Global Health and Education Watch: Iranian doctor says US strike damaged children’s cancer hospital",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-16-global-health-and-education-watch-iranian-doctor-says-us-strike-damaged-children.jpg",
    date: "2026-07-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-new-who-guidelines-up-to-45-of-dementia-risk",
    title: "Global Health and Education Watch: New WHO guidelines: up to 45% of dementia risk",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-16-global-health-and-education-watch-new-who-guidelines-up-to-45-of-dementia-risk.jpg",
    date: "2026-07-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-world-news-in-brief-schools-closed-in-west-bank",
    title: "Global Health and Education Watch: World News in Brief: Schools closed in West Bank",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-15-global-health-and-education-watch-world-news-in-brief-schools-closed-in-west-ban.jpg",
    date: "2026-07-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-bristol-declared-city-of-harm-reduction-as-greens-seek",
    title: "Global Health and Education Watch: Bristol declared ‘city of harm reduction’ as Greens seek",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-15-global-health-and-education-watch-bristol-declared-city-of-harm-reduction-as-gre.jpg",
    date: "2026-07-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-s-latest-c-d-c-nominee-vows-not-to-betray-the",
    title: "Global Health and Education Watch: Trump’s Latest C.D.C. Nominee Vows Not to ‘Betray the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-15-global-health-and-education-watch-trump-s-latest-c-d-c-nominee-vows-not-to-betra.jpg",
    date: "2026-07-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-childhood-vaccination-rate-increases-slightly-but-millions-remain-unprotected",
    title: "Global Health and Education Watch: Childhood vaccination rate increases slightly, but millions remain unprotected",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-15-global-health-and-education-watch-childhood-vaccination-rate-increases-slightly-.jpg",
    date: "2026-07-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-global-childhood-immunization-coverage-inches-forward-despite-conflict-and-3",
    title: "Global Health and Education Watch: Global childhood immunization coverage inches forward despite conflict and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-15-global-health-and-education-watch-global-childhood-immunization-coverage-inches-.jpg",
    date: "2026-07-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-effectiveness-and-cost-effectiveness-of-digital-approaches-for-training-frontline",
    title: "Global Health and Education Watch: Effectiveness and cost-effectiveness of digital approaches for training frontline",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-15-global-health-and-education-watch-effectiveness-and-cost-effectiveness-of-digita.jpg",
    date: "2026-07-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-global-childhood-immunization-coverage-inches-forward-despite-conflict-and-2",
    title: "Global Health and Education Watch: Global childhood immunization coverage inches forward despite conflict and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-15-global-health-and-education-watch-global-childhood-immunization-coverage-inches-.jpg",
    date: "2026-07-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-global-childhood-immunization-coverage-inches-forward-despite-conflict-and",
    title: "Global Health and Education Watch: Global childhood immunization coverage inches forward despite conflict and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-15-global-health-and-education-watch-global-childhood-immunization-coverage-inches-.jpg",
    date: "2026-07-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mps-call-for-ban-on-fast-food-outlets-opening",
    title: "Global Health and Education Watch: MPs call for ban on fast food outlets opening",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-15-global-health-and-education-watch-mps-call-for-ban-on-fast-food-outlets-opening.jpg",
    date: "2026-07-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-seventy-ninth-world-health-assembly-daily-update-21-may",
    title: "Global Health and Education Watch: Seventy-ninth World Health Assembly – Daily update: 21 May",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-15-global-health-and-education-watch-seventy-ninth-world-health-assembly-daily-upda.jpg",
    date: "2026-07-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-public-health-groups-sue-f-d-a-over-flavored-e-cigarette-policy",
    title: "Global Health and Education Watch: Public Health Groups Sue F.D.A. Over Flavored E-Cigarette Policy",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-15-global-health-and-education-watch-public-health-groups-sue-f-d-a-over-flavored-e.jpg",
    date: "2026-07-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-palestine-weekly-israel-attacks-children-hospitals-in-bloody-week",
    title: "Global Health and Education Watch: Palestine weekly: Israel attacks children, hospitals in bloody week",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-15-global-health-and-education-watch-palestine-weekly-israel-attacks-children-hospi.jpg",
    date: "2026-07-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-world-cup-football-s-other-goal-helping-young-people-talk",
    title: "Global Health and Education Watch: World Cup football’s other goal: Helping young people talk",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-14-global-health-and-education-watch-world-cup-football-s-other-goal-helping-young-.jpg",
    date: "2026-07-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cyclospora-outbreaks-causing-diarrhea-in-us-expected-to-continue",
    title: "Global Health and Education Watch: Cyclospora outbreaks causing diarrhea in US expected to continue",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-14-global-health-and-education-watch-cyclospora-outbreaks-causing-diarrhea-in-us-ex.jpg",
    date: "2026-07-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-pilot-scheme-in-england-to-convert-empty-classrooms-into",
    title: "Global Health and Education Watch: Pilot scheme in England to convert empty classrooms into",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-14-global-health-and-education-watch-pilot-scheme-in-england-to-convert-empty-class.jpg",
    date: "2026-07-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-lettuce-or-salad-greens-identified-as-potential-source-of",
    title: "Global Health and Education Watch: ‘Lettuce or Salad Greens’ Identified as Potential Source of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-14-global-health-and-education-watch-lettuce-or-salad-greens-identified-as-potentia.jpg",
    date: "2026-07-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tuberculosis-outbreak-at-colorado-ice-jail-sickens-at-least",
    title: "Global Health and Education Watch: Tuberculosis outbreak at Colorado ICE jail sickens at least",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-14-global-health-and-education-watch-tuberculosis-outbreak-at-colorado-ice-jail-sic.jpg",
    date: "2026-07-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-this-is-a-fire-drc-ebola-outbreak-is-fastest-growing",
    title: "Global Health and Education Watch: ‘This is a fire’: DRC Ebola outbreak is fastest-growing",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-14-global-health-and-education-watch-this-is-a-fire-drc-ebola-outbreak-is-fastest-g.jpg",
    date: "2026-07-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-el-salvador-validated-by-who-as-having-eliminated-trachoma-3",
    title: "Global Health and Education Watch: El Salvador validated by WHO as having eliminated trachoma",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-14-global-health-and-education-watch-el-salvador-validated-by-who-as-having-elimina.jpg",
    date: "2026-07-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-bangkok-bar-fire-death-toll-rises-to-30-as",
    title: "Global Health and Education Watch: Bangkok bar fire death toll rises to 30 as",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-14-global-health-and-education-watch-bangkok-bar-fire-death-toll-rises-to-30-as.jpg",
    date: "2026-07-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-taliban-s-war-on-education-nobody-talks-about-what",
    title: "Global Health and Education Watch: The Taliban’s war on education: ‘Nobody talks about what",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-14-global-health-and-education-watch-the-taliban-s-war-on-education-nobody-talks-ab.jpg",
    date: "2026-07-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-indonesia-s-jailing-of-gojek-founder-raises-fears-for-investor",
    title: "Global Health and Education Watch: Indonesia’s jailing of Gojek founder raises fears for investor",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-14-global-health-and-education-watch-indonesia-s-jailing-of-gojek-founder-raises-fe.jpg",
    date: "2026-07-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-in-turning-to-trade-school-gen-z-confronts-an",
    title: "Global Health and Education Watch: In Turning to Trade School, Gen Z Confronts an",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-14-global-health-and-education-watch-in-turning-to-trade-school-gen-z-confronts-an.jpg",
    date: "2026-07-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-children-will-be-one-of-unhealthiest-generations-in",
    title: "Global Health and Education Watch: UK children will be one of unhealthiest generations in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-13-global-health-and-education-watch-uk-children-will-be-one-of-unhealthiest-genera.jpg",
    date: "2026-07-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-afghanistan-3-7-million-young-lives-at-risk-of-malnutrition",
    title: "Global Health and Education Watch: Afghanistan: 3.7 million young lives at risk of malnutrition",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-13-global-health-and-education-watch-afghanistan-3-7-million-young-lives-at-risk-of.jpg",
    date: "2026-07-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-el-salvador-validated-by-who-as-having-eliminated-trachoma-2",
    title: "Global Health and Education Watch: El Salvador validated by WHO as having eliminated trachoma",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-13-global-health-and-education-watch-el-salvador-validated-by-who-as-having-elimina.jpg",
    date: "2026-07-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-el-salvador-validated-by-who-as-having-eliminated-trachoma",
    title: "Global Health and Education Watch: El Salvador validated by WHO as having eliminated trachoma",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-13-global-health-and-education-watch-el-salvador-validated-by-who-as-having-elimina.jpg",
    date: "2026-07-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-seventy-ninth-world-health-assembly-honours-global-champions-advancing-primary-2",
    title: "Global Health and Education Watch: Seventy-ninth World Health Assembly honours global champions advancing primary",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-13-global-health-and-education-watch-seventy-ninth-world-health-assembly-honours-gl.jpg",
    date: "2026-07-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-a-teacher-revived-backyard-baseball-2",
    title: "Global Health and Education Watch: How a Teacher Revived Backyard Baseball",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-13-global-health-and-education-watch-how-a-teacher-revived-backyard-baseball.jpg",
    date: "2026-07-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-a-teacher-revived-backyard-baseball",
    title: "Global Health and Education Watch: How a Teacher Revived Backyard Baseball",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-13-global-health-and-education-watch-how-a-teacher-revived-backyard-baseball.jpg",
    date: "2026-07-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-from-nasa-to-the-classroom-the-engineer-bringing-ai",
    title: "Global Health and Education Watch: From NASA to the classroom: The engineer bringing AI",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-13-global-health-and-education-watch-from-nasa-to-the-classroom-the-engineer-bringi.jpg",
    date: "2026-07-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-physical-education-review-boisterous-cliche-busting-lesson-on-teen-2",
    title: "Global Health and Education Watch: Physical Education review – boisterous, cliche-busting lesson on teen",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-13-global-health-and-education-watch-physical-education-review-boisterous-cliche-bu.jpg",
    date: "2026-07-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-physical-education-review-boisterous-cliche-busting-lesson-on-teen",
    title: "Global Health and Education Watch: Physical Education review – boisterous, cliche-busting lesson on teen",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-13-global-health-and-education-watch-physical-education-review-boisterous-cliche-bu.jpg",
    date: "2026-07-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mitch-mcconnell-reveals-fall-led-to-hospitalization-after-weeks",
    title: "Global Health and Education Watch: Mitch McConnell reveals fall led to hospitalization after weeks",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-13-global-health-and-education-watch-mitch-mcconnell-reveals-fall-led-to-hospitaliz.jpg",
    date: "2026-07-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mitch-mcconnell-releases-health-update-says-he-is-regaining",
    title: "Global Health and Education Watch: Mitch McConnell releases health update, says he is ‘regaining’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-13-global-health-and-education-watch-mitch-mcconnell-releases-health-update-says-he.jpg",
    date: "2026-07-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-flawed-disciplinary-hearings-at-work-cost-uk-economy-28-5bn",
    title: "Global Health and Education Watch: Flawed disciplinary hearings at work cost UK economy £28.5bn",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-12-global-health-and-education-watch-flawed-disciplinary-hearings-at-work-cost-uk-e.jpg",
    date: "2026-07-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-dj-and-broadcaster-paul-gambaccini-reveals-alzheimer-s-diagnosis",
    title: "Global Health and Education Watch: DJ and broadcaster Paul Gambaccini reveals Alzheimer’s diagnosis",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-12-global-health-and-education-watch-dj-and-broadcaster-paul-gambaccini-reveals-alz.jpg",
    date: "2026-07-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-university-where-kirk-died-ponders-how-to-remember",
    title: "Global Health and Education Watch: The University Where Kirk Died Ponders How to Remember",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-12-global-health-and-education-watch-the-university-where-kirk-died-ponders-how-to-.jpg",
    date: "2026-07-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-couple-found-burned-and-semi-conscious-in-almeria-amid",
    title: "Global Health and Education Watch: UK couple found burned and semi-conscious in Almería amid",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-12-global-health-and-education-watch-uk-couple-found-burned-and-semi-conscious-in-a.jpg",
    date: "2026-07-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-georgia-teen-to-appear-in-plea-hearing-over-2024",
    title: "Global Health and Education Watch: Georgia teen to appear in plea hearing over 2024",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-12-global-health-and-education-watch-georgia-teen-to-appear-in-plea-hearing-over-20.jpg",
    date: "2026-07-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-at-last-a-proper-excuse-for-monoglots-to-learn",
    title: "Global Health and Education Watch: At last, a proper excuse for monoglots to learn",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-12-global-health-and-education-watch-at-last-a-proper-excuse-for-monoglots-to-learn.jpg",
    date: "2026-07-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-becoming-wild-west-for-experimental-peptides-expert-warns",
    title: "Global Health and Education Watch: UK becoming ‘wild west’ for experimental peptides, expert warns",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-12-global-health-and-education-watch-uk-becoming-wild-west-for-experimental-peptide.jpg",
    date: "2026-07-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-new-anti-racism-standard-will-force-australian-universities-to-use",
    title: "Global Health and Education Watch: New anti-racism standard will force Australian universities to use",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-12-global-health-and-education-watch-new-anti-racism-standard-will-force-australian.jpg",
    date: "2026-07-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-first-patients-enrolled-in-record-breaking-ebola-treatment-trial-in",
    title: "Global Health and Education Watch: First patients enrolled in record-breaking Ebola treatment trial in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-12-global-health-and-education-watch-first-patients-enrolled-in-record-breaking-ebo.jpg",
    date: "2026-07-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-our-bacteria-are-talking-we-ve-just-begun-to-understand",
    title: "Global Health and Education Watch: Our Bacteria Are Talking. We’ve Just Begun to Understand",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-12-global-health-and-education-watch-our-bacteria-are-talking-we-ve-just-begun-to-u.jpg",
    date: "2026-07-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-director-general-presents-award-for-global-health-to-four-distinguished-2",
    title: "Global Health and Education Watch: Director-General presents Award for Global Health to four distinguished",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-12-global-health-and-education-watch-director-general-presents-award-for-global-hea.jpg",
    date: "2026-07-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-launches-national-dementia-registry-to-speed-up-search",
    title: "Global Health and Education Watch: UK launches national dementia registry to speed up search",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-12-global-health-and-education-watch-uk-launches-national-dementia-registry-to-spee.jpg",
    date: "2026-07-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-nigeria-rescues-dozens-of-abducted-school-children-in-oyo",
    title: "Global Health and Education Watch: Nigeria rescues dozens of abducted school children in Oyo",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-12-global-health-and-education-watch-nigeria-rescues-dozens-of-abducted-school-chil.jpg",
    date: "2026-07-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-guggenheim-museum-in-new-york-city-tests-positive-for",
    title: "Global Health and Education Watch: Guggenheim museum in New York City tests positive for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-12-global-health-and-education-watch-guggenheim-museum-in-new-york-city-tests-posit.jpg",
    date: "2026-07-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-heatwave-conditions-in-england-and-wales-to-continue-into",
    title: "Global Health and Education Watch: Heatwave conditions in England and Wales to continue into",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-11-global-health-and-education-watch-heatwave-conditions-in-england-and-wales-to-co.jpg",
    date: "2026-07-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-n-y-c-council-speaker-turns-up-pressure-on-schools-chief-2",
    title: "Global Health and Education Watch: N.Y.C. Council Speaker Turns Up Pressure on Schools Chief",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-11-global-health-and-education-watch-n-y-c-council-speaker-turns-up-pressure-on-sch.jpg",
    date: "2026-07-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-lack-of-documented-prophylactic-vitamin-k-administration-in-newborns",
    title: "Global Health and Education Watch: Lack of documented prophylactic vitamin K administration in newborns",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-11-global-health-and-education-watch-lack-of-documented-prophylactic-vitamin-k-admi.jpg",
    date: "2026-07-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-n-y-c-council-speaker-turns-up-pressure-on-schools-chief",
    title: "Global Health and Education Watch: N.Y.C. Council Speaker Turns Up Pressure on Schools Chief",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-11-global-health-and-education-watch-n-y-c-council-speaker-turns-up-pressure-on-sch.jpg",
    date: "2026-07-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tarmac-playgrounds-and-windows-that-don-t-open-why-hot-3",
    title: "Global Health and Education Watch: Tarmac playgrounds and windows that don’t open: why hot",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-11-global-health-and-education-watch-tarmac-playgrounds-and-windows-that-don-t-open.jpg",
    date: "2026-07-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-power-cuts-plunge-gaza-hospitals-into-darkness-as-israel-s",
    title: "Global Health and Education Watch: Power cuts plunge Gaza hospitals into darkness as Israel’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-11-global-health-and-education-watch-power-cuts-plunge-gaza-hospitals-into-darkness.jpg",
    date: "2026-07-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-htsi-health-and-fitness-issue-10-ways-to",
    title: "Global Health and Education Watch: The HTSI health and fitness issue: 10 ways to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-11-global-health-and-education-watch-the-htsi-health-and-fitness-issue-10-ways-to.jpg",
    date: "2026-07-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-more-than-200-people-at-summer-camp-airlifted-to",
    title: "Global Health and Education Watch: More than 200 people at summer camp airlifted to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-11-global-health-and-education-watch-more-than-200-people-at-summer-camp-airlifted-.jpg",
    date: "2026-07-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mitch-mcconnell-mystery-deepens-as-health-questions-remain-unanswered",
    title: "Global Health and Education Watch: Mitch McConnell mystery deepens as health questions remain unanswered",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-11-global-health-and-education-watch-mitch-mcconnell-mystery-deepens-as-health-ques.jpg",
    date: "2026-07-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-children-were-calling-for-their-mummies-uk-pupils-struggle",
    title: "Global Health and Education Watch: ‘Children were calling for their mummies’: UK pupils struggle",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-11-global-health-and-education-watch-children-were-calling-for-their-mummies-uk-pup.jpg",
    date: "2026-07-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-u-s-citizen-tests-positive-for-ebola-in-democratic-republic",
    title: "Global Health and Education Watch: U.S. Citizen Tests Positive for Ebola in Democratic Republic",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-11-global-health-and-education-watch-u-s-citizen-tests-positive-for-ebola-in-democr.jpg",
    date: "2026-07-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-we-are-the-lost-generation-of-sudan-students-in",
    title: "Global Health and Education Watch: ‘We are the lost generation of Sudan’: Students in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-11-global-health-and-education-watch-we-are-the-lost-generation-of-sudan-students-i.jpg",
    date: "2026-07-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-s-really-going-on-with-mental-health",
    title: "Global Health and Education Watch: What’s really going on with mental health?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-11-global-health-and-education-watch-what-s-really-going-on-with-mental-health.jpg",
    date: "2026-07-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-fastest-growing-ebola-outbreak-ever-how-conflict-aid-cuts",
    title: "Global Health and Education Watch: Fastest growing Ebola outbreak ever: how conflict, aid cuts",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-11-global-health-and-education-watch-fastest-growing-ebola-outbreak-ever-how-confli.jpg",
    date: "2026-07-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-historian-kerri-k-greenidge-and-her-book-the-grimkes",
    title: "Global Health and Education Watch: Historian Kerri K. Greenidge and Her Book ‘The Grimkes’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-11-global-health-and-education-watch-historian-kerri-k-greenidge-and-her-book-the-g.jpg",
    date: "2026-07-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-male-wellness-guide-to-peptides",
    title: "Global Health and Education Watch: The male wellness guide to peptides",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-10-global-health-and-education-watch-the-male-wellness-guide-to-peptides.jpg",
    date: "2026-07-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-epidemic-of-ebola-disease-caused-by-bundibugyo-virus-in",
    title: "Global Health and Education Watch: Epidemic of Ebola Disease caused by Bundibugyo virus in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-10-global-health-and-education-watch-epidemic-of-ebola-disease-caused-by-bundibugyo.jpg",
    date: "2026-07-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-world-news-in-brief-un-spotlights-education-aid-solution",
    title: "Global Health and Education Watch: World News in Brief: UN spotlights education aid solution",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-10-global-health-and-education-watch-world-news-in-brief-un-spotlights-education-ai.jpg",
    date: "2026-07-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-family-mourns-baby-after-israeli-forces-blocked-journey-to",
    title: "Global Health and Education Watch: Family mourns baby after Israeli forces blocked journey to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-10-global-health-and-education-watch-family-mourns-baby-after-israeli-forces-blocke.jpg",
    date: "2026-07-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-new-cholera-outbreak-alert-for-sudan-s-war-weary-communities",
    title: "Global Health and Education Watch: New cholera outbreak alert for Sudan’s war-weary communities",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-10-global-health-and-education-watch-new-cholera-outbreak-alert-for-sudan-s-war-wea.jpg",
    date: "2026-07-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-developing-countries-spend-more-repaying-foreign-debt-than-on",
    title: "Global Health and Education Watch: Developing countries spend more repaying foreign debt than on",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-10-global-health-and-education-watch-developing-countries-spend-more-repaying-forei.jpg",
    date: "2026-07-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-fake-ids-dummy-manuscripts-and-a-rare-book-heist",
    title: "Global Health and Education Watch: Fake IDs, Dummy Manuscripts and a Rare Book Heist",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-10-global-health-and-education-watch-fake-ids-dummy-manuscripts-and-a-rare-book-hei.jpg",
    date: "2026-07-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-venezuela-earthquakes-toll-rises-to-3-889-as-risk-of",
    title: "Global Health and Education Watch: Venezuela earthquakes toll rises to 3,889 as risk of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-10-global-health-and-education-watch-venezuela-earthquakes-toll-rises-to-3-889-as-r.jpg",
    date: "2026-07-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-an-athlete-s-guide-to-healthy-feet",
    title: "Global Health and Education Watch: An athlete’s guide to healthy feet",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-09-global-health-and-education-watch-an-athlete-s-guide-to-healthy-feet.jpg",
    date: "2026-07-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-calls-for-urgent-action-as-new-cancer-cases",
    title: "Global Health and Education Watch: WHO calls for urgent action as new cancer cases",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-09-global-health-and-education-watch-who-calls-for-urgent-action-as-new-cancer-case.jpg",
    date: "2026-07-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-is-cyclosporiasis-the-parasitic-illness-causing-explosive-diarrhea",
    title: "Global Health and Education Watch: What is cyclosporiasis, the parasitic illness causing ‘explosive’ diarrhea?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-09-global-health-and-education-watch-what-is-cyclosporiasis-the-parasitic-illness-c.jpg",
    date: "2026-07-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-to-turn-your-phone-into-a-personal-health",
    title: "Global Health and Education Watch: How to Turn Your Phone Into a Personal Health",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-09-global-health-and-education-watch-how-to-turn-your-phone-into-a-personal-health.jpg",
    date: "2026-07-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-legionnaires-outbreak-rocks-new-york-as-experts-warn-of",
    title: "Global Health and Education Watch: Legionnaires’ outbreak rocks New York as experts warn of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-09-global-health-and-education-watch-legionnaires-outbreak-rocks-new-york-as-expert.jpg",
    date: "2026-07-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-restoring-dignity-senegalese-surgeon-and-burundian-foundation-win-reproductive",
    title: "Global Health and Education Watch: Restoring dignity: Senegalese surgeon and Burundian foundation win reproductive",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-09-global-health-and-education-watch-restoring-dignity-senegalese-surgeon-and-burun.jpg",
    date: "2026-07-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ministers-look-at-restricting-cash-payments-as-disability-benefits",
    title: "Global Health and Education Watch: Ministers look at restricting cash payments as disability benefits",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-09-global-health-and-education-watch-ministers-look-at-restricting-cash-payments-as.jpg",
    date: "2026-07-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-warns-nicotine-pouch-brands-targeting-youth-as-sales-2",
    title: "Global Health and Education Watch: WHO warns nicotine pouch brands targeting youth as sales",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-09-global-health-and-education-watch-who-warns-nicotine-pouch-brands-targeting-yout.jpg",
    date: "2026-07-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-lawmakers-target-the-power-of-health-insurance-giants",
    title: "Global Health and Education Watch: Lawmakers Target the Power of Health Insurance Giants",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-09-global-health-and-education-watch-lawmakers-target-the-power-of-health-insurance.jpg",
    date: "2026-07-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-geospatial-science-can-boost-equitable-access-to-healthcare",
    title: "Global Health and Education Watch: How geospatial science can boost equitable access to healthcare",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-08-global-health-and-education-watch-how-geospatial-science-can-boost-equitable-acc.jpg",
    date: "2026-07-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-france-returns-syrian-artefacts-it-s-held-since-civil-war",
    title: "Global Health and Education Watch: France returns Syrian artefacts it’s held since civil war",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-08-global-health-and-education-watch-france-returns-syrian-artefacts-it-s-held-sinc.jpg",
    date: "2026-07-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cancer-cases-expected-to-soar-worldwide-who-report-finds",
    title: "Global Health and Education Watch: Cancer cases expected to soar worldwide, WHO report finds",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-08-global-health-and-education-watch-cancer-cases-expected-to-soar-worldwide-who-re.jpg",
    date: "2026-07-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cancer-cases-could-nearly-double-by-2050-without-urgent",
    title: "Global Health and Education Watch: Cancer cases could nearly double by 2050 without urgent",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-08-global-health-and-education-watch-cancer-cases-could-nearly-double-by-2050-witho.jpg",
    date: "2026-07-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-megan-nolan-health-self-and-weight-control-in-the",
    title: "Global Health and Education Watch: Megan Nolan: health, self and weight control in the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-08-global-health-and-education-watch-megan-nolan-health-self-and-weight-control-in-.jpg",
    date: "2026-07-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-follow-up-message-by-the-who-director-general-to-the-people-2",
    title: "Global Health and Education Watch: Follow-up message by the WHO Director-General to the people",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-08-global-health-and-education-watch-follow-up-message-by-the-who-director-general-.jpg",
    date: "2026-07-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-appeals-court-strikes-down-key-part-of-florida",
    title: "Global Health and Education Watch: US appeals court strikes down key part of Florida",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-08-global-health-and-education-watch-us-appeals-court-strikes-down-key-part-of-flor.jpg",
    date: "2026-07-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-yale-law-school-fights-to-stop-trump-deal-3",
    title: "Global Health and Education Watch: Yale Law School Fights to Stop Trump Deal",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-08-global-health-and-education-watch-yale-law-school-fights-to-stop-trump-deal.jpg",
    date: "2026-07-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-prolonged-hospitalisation-of-us-republican-mitch-mcconnell-raises-questions",
    title: "Global Health and Education Watch: Prolonged hospitalisation of US Republican Mitch McConnell raises questions",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-07-global-health-and-education-watch-prolonged-hospitalisation-of-us-republican-mit.jpg",
    date: "2026-07-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-yale-law-school-fights-to-stop-trump-deal-2",
    title: "Global Health and Education Watch: Yale Law School Fights to Stop Trump Deal",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-07-global-health-and-education-watch-yale-law-school-fights-to-stop-trump-deal.jpg",
    date: "2026-07-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-yale-law-school-fights-to-stop-trump-deal",
    title: "Global Health and Education Watch: Yale Law School Fights to Stop Trump Deal",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-07-global-health-and-education-watch-yale-law-school-fights-to-stop-trump-deal.jpg",
    date: "2026-07-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-andrea-shaw-plaintiff-in-anti-vaccine-suit-is-charged-with",
    title: "Global Health and Education Watch: Andrea Shaw, Plaintiff in Anti-Vaccine Suit, Is Charged With",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-07-global-health-and-education-watch-andrea-shaw-plaintiff-in-anti-vaccine-suit-is-.jpg",
    date: "2026-07-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-continues-to-spread-in-drc-as-death-toll",
    title: "Global Health and Education Watch: Ebola continues to spread in DRC as death toll",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-07-global-health-and-education-watch-ebola-continues-to-spread-in-drc-as-death-toll.jpg",
    date: "2026-07-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-administration-guts-efforts-to-prevent-gun-violence-suppressing",
    title: "Global Health and Education Watch: Trump Administration Guts Efforts to Prevent Gun Violence, Suppressing",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-07-global-health-and-education-watch-trump-administration-guts-efforts-to-prevent-g.jpg",
    date: "2026-07-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-is-the-new-gaza-administration-as-hamas-dissolves",
    title: "Global Health and Education Watch: What is the new Gaza administration as Hamas dissolves",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-07-global-health-and-education-watch-what-is-the-new-gaza-administration-as-hamas-d.jpg",
    date: "2026-07-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-details-scarce-as-mitch-mcconnell-continues-recovery-in-hospital",
    title: "Global Health and Education Watch: Details scarce as Mitch McConnell ‘continues recovery’ in hospital",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-07-global-health-and-education-watch-details-scarce-as-mitch-mcconnell-continues-re.jpg",
    date: "2026-07-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-taking-a-walk-down-memory-lane-letters",
    title: "Global Health and Education Watch: Taking a walk down memory lane | Letters",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-07-global-health-and-education-watch-taking-a-walk-down-memory-lane-letters.jpg",
    date: "2026-07-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-us-uk-drug-deal-will-benefit-patients-letters",
    title: "Global Health and Education Watch: How US-UK drug deal will benefit patients | Letters",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-07-global-health-and-education-watch-how-us-uk-drug-deal-will-benefit-patients-lett.jpg",
    date: "2026-07-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-death-toll-in-dr-congo-surpasses-500",
    title: "Global Health and Education Watch: Ebola death toll in DR Congo surpasses 500",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-06-global-health-and-education-watch-ebola-death-toll-in-dr-congo-surpasses-500.jpg",
    date: "2026-07-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-politics-farage-warned-attack-against-establishment-over-unregistered",
    title: "Global Health and Education Watch: UK politics: Farage warned attack against ‘establishment’ over unregistered",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-06-global-health-and-education-watch-uk-politics-farage-warned-attack-against-estab.jpg",
    date: "2026-07-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-zyn-s-popularity-has-tobacco-companies-racing-to-cash-in",
    title: "Global Health and Education Watch: Zyn’s Popularity Has Tobacco Companies Racing to Cash In",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-06-global-health-and-education-watch-zyn-s-popularity-has-tobacco-companies-racing-.jpg",
    date: "2026-07-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-baby-dies-after-israeli-troops-block-emergency-journey-to",
    title: "Global Health and Education Watch: Baby dies after Israeli troops block emergency journey to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-06-global-health-and-education-watch-baby-dies-after-israeli-troops-block-emergency.jpg",
    date: "2026-07-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-bring-back-the-sat-california",
    title: "Global Health and Education Watch: Bring Back the SAT, California",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-06-global-health-and-education-watch-bring-back-the-sat-california.jpg",
    date: "2026-07-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-inside-the-nhs-hospital-trialling-psychedelics-to-treat-depression",
    title: "Global Health and Education Watch: Inside the NHS hospital trialling psychedelics to treat depression",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-06-global-health-and-education-watch-inside-the-nhs-hospital-trialling-psychedelics.jpg",
    date: "2026-07-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-integrating-a-national-crisis-counseling-hotline-into-iran-s-primary",
    title: "Global Health and Education Watch: Integrating a national crisis counseling hotline into Iran’s primary",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-06-global-health-and-education-watch-integrating-a-national-crisis-counseling-hotli.jpg",
    date: "2026-07-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-nhs-to-rate-english-trusts-on-tackling-violence-and",
    title: "Global Health and Education Watch: NHS to rate English trusts on tackling violence and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-05-global-health-and-education-watch-nhs-to-rate-english-trusts-on-tackling-violenc.jpg",
    date: "2026-07-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-palestinians-rally-outside-al-shifa-hospital-demanding-medical-evacuation",
    title: "Global Health and Education Watch: Palestinians rally outside Al-Shifa hospital, demanding medical evacuation",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-05-global-health-and-education-watch-palestinians-rally-outside-al-shifa-hospital-d.jpg",
    date: "2026-07-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ofsted-drops-clumsy-and-offensive-guidance-linking-autism-and",
    title: "Global Health and Education Watch: Ofsted drops ‘clumsy’ and ‘offensive’ guidance linking autism and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-05-global-health-and-education-watch-ofsted-drops-clumsy-and-offensive-guidance-lin.jpg",
    date: "2026-07-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cutting-language-courses-puts-social-mobility-at-risk-say",
    title: "Global Health and Education Watch: Cutting language courses puts social mobility at risk, say",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-05-global-health-and-education-watch-cutting-language-courses-puts-social-mobility-.jpg",
    date: "2026-07-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-pro-maga-groups-spur-trump-push-for-cultural-change-in",
    title: "Global Health and Education Watch: Pro-MAGA Groups Spur Trump Push For Cultural Change In",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-05-global-health-and-education-watch-pro-maga-groups-spur-trump-push-for-cultural-c.jpg",
    date: "2026-07-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-jailed-gaza-hospital-chief-in-life-threatening-condition-rights-group",
    title: "Global Health and Education Watch: Jailed Gaza hospital chief in life-threatening condition, rights group",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-05-global-health-and-education-watch-jailed-gaza-hospital-chief-in-life-threatening.jpg",
    date: "2026-07-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-week-long-heatwave-due-in-england-with-34c-peak-in",
    title: "Global Health and Education Watch: Week-long heatwave due in England with 34C peak in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-05-global-health-and-education-watch-week-long-heatwave-due-in-england-with-34c-pea.jpg",
    date: "2026-07-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-situation-is-terrible-aid-workers-on-life-in-3",
    title: "Global Health and Education Watch: ‘The situation is terrible’: aid workers on life in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-05-global-health-and-education-watch-the-situation-is-terrible-aid-workers-on-life-.jpg",
    date: "2026-07-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-roll-up-roll-up-older-generation-find-joy-and",
    title: "Global Health and Education Watch: Roll up, roll up! Older generation find joy and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-05-global-health-and-education-watch-roll-up-roll-up-older-generation-find-joy-and.jpg",
    date: "2026-07-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-situation-is-terrible-aid-workers-on-life-in-2",
    title: "Global Health and Education Watch: ‘The situation is terrible’: aid workers on life in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-05-global-health-and-education-watch-the-situation-is-terrible-aid-workers-on-life-.jpg",
    date: "2026-07-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-situation-is-terrible-aid-workers-on-life-in",
    title: "Global Health and Education Watch: ‘The situation is terrible’: aid workers on life in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-05-global-health-and-education-watch-the-situation-is-terrible-aid-workers-on-life-.jpg",
    date: "2026-07-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-third-of-disadvantaged-white-pupils-in-england-leave-primary-4",
    title: "Global Health and Education Watch: Third of disadvantaged white pupils in England leave primary",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-05-global-health-and-education-watch-third-of-disadvantaged-white-pupils-in-england.jpg",
    date: "2026-07-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-clusters-of-severe-stomach-illness-reported-across-the-u-s",
    title: "Global Health and Education Watch: Clusters of Severe Stomach Illness Reported Across the U.S.",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-04-global-health-and-education-watch-clusters-of-severe-stomach-illness-reported-ac.jpg",
    date: "2026-07-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-at-least-20-drown-as-boat-carrying-students-after",
    title: "Global Health and Education Watch: At least 20 drown as boat carrying students after",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-04-global-health-and-education-watch-at-least-20-drown-as-boat-carrying-students-af.jpg",
    date: "2026-07-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-safe-return-home-tackling-stigma-on-uganda-s-ebola",
    title: "Global Health and Education Watch: A safe return home: Tackling stigma on Uganda's Ebola",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-04-global-health-and-education-watch-a-safe-return-home-tackling-stigma-on-uganda-s.jpg",
    date: "2026-07-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-third-of-disadvantaged-white-pupils-in-england-leave-primary-3",
    title: "Global Health and Education Watch: Third of disadvantaged white pupils in England leave primary",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-04-global-health-and-education-watch-third-of-disadvantaged-white-pupils-in-england.jpg",
    date: "2026-07-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-association-of-baseline-brain-care-score-with-the-incidence",
    title: "Global Health and Education Watch: Association of baseline brain care score with the incidence",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-04-global-health-and-education-watch-association-of-baseline-brain-care-score-with-.jpg",
    date: "2026-07-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-third-of-disadvantaged-white-pupils-in-england-leave-primary-2",
    title: "Global Health and Education Watch: Third of disadvantaged white pupils in England leave primary",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-04-global-health-and-education-watch-third-of-disadvantaged-white-pupils-in-england.jpg",
    date: "2026-07-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-third-of-disadvantaged-white-pupils-in-england-leave-primary",
    title: "Global Health and Education Watch: Third of disadvantaged white pupils in England leave primary",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-04-global-health-and-education-watch-third-of-disadvantaged-white-pupils-in-england.jpg",
    date: "2026-07-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-brain-drain-leaves-yemen-s-health-sector-in-tatters-and",
    title: "Global Health and Education Watch: Brain drain leaves Yemen’s health sector in tatters and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-04-global-health-and-education-watch-brain-drain-leaves-yemen-s-health-sector-in-ta.jpg",
    date: "2026-07-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-inside-the-c-d-c-s-mad-scramble-to-meet-kennedy-s-demands",
    title: "Global Health and Education Watch: Inside the C.D.C.’s Mad Scramble to Meet Kennedy’s Demands",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-04-global-health-and-education-watch-inside-the-c-d-c-s-mad-scramble-to-meet-kenned.jpg",
    date: "2026-07-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-overseas-education-project-for-women-and-girls-axed-by",
    title: "Global Health and Education Watch: Overseas education project for women and girls axed by",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-04-global-health-and-education-watch-overseas-education-project-for-women-and-girls.jpg",
    date: "2026-07-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-pull-an-all-nighter-how-parents-schools-fans-and-police",
    title: "Global Health and Education Watch: Pull an all-nighter? How parents, schools, fans and police",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-04-global-health-and-education-watch-pull-an-all-nighter-how-parents-schools-fans-a.jpg",
    date: "2026-07-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-teachers-in-england-get-two-year-6-6-pay-rise-but",
    title: "Global Health and Education Watch: Teachers in England get two-year 6.6% pay rise but",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-04-global-health-and-education-watch-teachers-in-england-get-two-year-6-6-pay-rise-.jpg",
    date: "2026-07-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-deaths-in-france-surged-30-during-hottest-week-of",
    title: "Global Health and Education Watch: Deaths in France surged 30% during hottest week of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-04-global-health-and-education-watch-deaths-in-france-surged-30-during-hottest-week.jpg",
    date: "2026-07-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-courtney-sale-ross-founder-and-funder-of-a-quirky",
    title: "Global Health and Education Watch: Courtney Sale Ross, Founder and Funder of a Quirky",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-03-global-health-and-education-watch-courtney-sale-ross-founder-and-funder-of-a-qui.jpg",
    date: "2026-07-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-consider-the-parents-caring-for-adult-children-not-in",
    title: "Global Health and Education Watch: Consider the parents caring for adult children not in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-03-global-health-and-education-watch-consider-the-parents-caring-for-adult-children.jpg",
    date: "2026-07-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-don-t-eat-your-greens-a-diet-taking-yemen-by",
    title: "Global Health and Education Watch: Don’t eat your greens? A diet taking Yemen by",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-03-global-health-and-education-watch-don-t-eat-your-greens-a-diet-taking-yemen-by.jpg",
    date: "2026-07-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-china-says-man-who-flew-plane-into-beijing-skyscraper",
    title: "Global Health and Education Watch: China says man who flew plane into Beijing skyscraper",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-03-global-health-and-education-watch-china-says-man-who-flew-plane-into-beijing-sky.jpg",
    date: "2026-07-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-election-wins-prove-pro-palestine-us-campus-protests-didn-t-fail",
    title: "Global Health and Education Watch: Election wins prove pro-Palestine US campus protests didn’t fail",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-03-global-health-and-education-watch-election-wins-prove-pro-palestine-us-campus-pr.jpg",
    date: "2026-07-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-plans-must-be-put-in-place-before-heatwaves",
    title: "Global Health and Education Watch: Plans must be put in place before heatwaves –",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-03-global-health-and-education-watch-plans-must-be-put-in-place-before-heatwaves.jpg",
    date: "2026-07-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-adds-first-diagnostic-test-for-ebola-bundibugyo-virus",
    title: "Global Health and Education Watch: WHO adds first diagnostic test for Ebola Bundibugyo virus",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-03-global-health-and-education-watch-who-adds-first-diagnostic-test-for-ebola-bundi.jpg",
    date: "2026-07-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-deadly-mv-hondius-hantavirus-outbreak-is-over-w-h-o-says",
    title: "Global Health and Education Watch: Deadly MV Hondius Hantavirus Outbreak Is Over, W.H.O. Says",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-03-global-health-and-education-watch-deadly-mv-hondius-hantavirus-outbreak-is-over-.jpg",
    date: "2026-07-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-venezuela-s-earthquake-hit-hospitals-pushed-to-the-brink-as-disease",
    title: "Global Health and Education Watch: Venezuela's earthquake-hit hospitals pushed to the brink as disease",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-03-global-health-and-education-watch-venezuela-s-earthquake-hit-hospitals-pushed-to.jpg",
    date: "2026-07-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-patient-enrolment-begins-in-a-scientific-trial-to-identify",
    title: "Global Health and Education Watch: Patient enrolment begins in a scientific trial to identify",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-02-global-health-and-education-watch-patient-enrolment-begins-in-a-scientific-trial.jpg",
    date: "2026-07-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-taking-the-world-s-temperature-who-chief-spotlights-global-health-3",
    title: "Global Health and Education Watch: Taking the world’s temperature: WHO chief spotlights global health",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-02-global-health-and-education-watch-taking-the-world-s-temperature-who-chief-spotl.jpg",
    date: "2026-07-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-taking-the-world-s-temperature-who-chief-spotlights-global-health-2",
    title: "Global Health and Education Watch: Taking the world’s temperature: WHO chief spotlights global health",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-02-global-health-and-education-watch-taking-the-world-s-temperature-who-chief-spotl.jpg",
    date: "2026-07-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-taking-the-world-s-temperature-who-chief-spotlights-global-health",
    title: "Global Health and Education Watch: Taking the world’s temperature: WHO chief spotlights global health",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-02-global-health-and-education-watch-taking-the-world-s-temperature-who-chief-spotl.jpg",
    date: "2026-07-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-job-growth-slows-in-june-hospitality-sheds-roles",
    title: "Global Health and Education Watch: US job growth slows in June; hospitality sheds roles",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-02-global-health-and-education-watch-us-job-growth-slows-in-june-hospitality-sheds-.jpg",
    date: "2026-07-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-understanding-ebola-s-wildlife-origins-is-crucial-to-preventing-next",
    title: "Global Health and Education Watch: Understanding Ebola’s wildlife origins is crucial to preventing next",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-02-global-health-and-education-watch-understanding-ebola-s-wildlife-origins-is-cruc.jpg",
    date: "2026-07-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-dark-and-light-words-for-the-fourth",
    title: "Global Health and Education Watch: Dark and Light: Words for the Fourth",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-02-global-health-and-education-watch-dark-and-light-words-for-the-fourth.jpg",
    date: "2026-07-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-starmer-s-goodbye-gift-to-britain-a-us-pharma-deal-3",
    title: "Global Health and Education Watch: Starmer’s goodbye gift to Britain: a US pharma deal",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-02-global-health-and-education-watch-starmer-s-goodbye-gift-to-britain-a-us-pharma-.jpg",
    date: "2026-07-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-starmer-s-goodbye-gift-to-britain-a-us-pharma-deal-2",
    title: "Global Health and Education Watch: Starmer’s goodbye gift to Britain: a US pharma deal",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-02-global-health-and-education-watch-starmer-s-goodbye-gift-to-britain-a-us-pharma-.jpg",
    date: "2026-07-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-starmer-s-goodbye-gift-to-britain-a-us-pharma-deal",
    title: "Global Health and Education Watch: Starmer’s goodbye gift to Britain: a US pharma deal",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-02-global-health-and-education-watch-starmer-s-goodbye-gift-to-britain-a-us-pharma-.jpg",
    date: "2026-07-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-when-the-right-denies-the-true-danger-of-heatwaves-3",
    title: "Global Health and Education Watch: When the right denies the true danger of heatwaves",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-02-global-health-and-education-watch-when-the-right-denies-the-true-danger-of-heatw.jpg",
    date: "2026-07-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-when-the-right-denies-the-true-danger-of-heatwaves-2",
    title: "Global Health and Education Watch: When the right denies the true danger of heatwaves",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-01-global-health-and-education-watch-when-the-right-denies-the-true-danger-of-heatw.jpg",
    date: "2026-07-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-when-the-right-denies-the-true-danger-of-heatwaves",
    title: "Global Health and Education Watch: When the right denies the true danger of heatwaves",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-01-global-health-and-education-watch-when-the-right-denies-the-true-danger-of-heatw.jpg",
    date: "2026-07-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-three-dead-after-massive-world-cup-celebrations-in-mexico",
    title: "Global Health and Education Watch: Three dead after massive World Cup celebrations in Mexico",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-01-global-health-and-education-watch-three-dead-after-massive-world-cup-celebration.jpg",
    date: "2026-07-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-risky-burial-in-the-heart-of-an-ebola",
    title: "Global Health and Education Watch: A Risky Burial in the Heart of an Ebola",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-01-global-health-and-education-watch-a-risky-burial-in-the-heart-of-an-ebola.jpg",
    date: "2026-07-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-nearly-three-in-four-us-scam-victims-report-mental",
    title: "Global Health and Education Watch: Nearly three in four US scam victims report mental",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-01-global-health-and-education-watch-nearly-three-in-four-us-scam-victims-report-me.jpg",
    date: "2026-07-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-aid-workers-in-venezuela-fear-disease-outbreaks-after-twin-3",
    title: "Global Health and Education Watch: Aid Workers in Venezuela Fear Disease Outbreaks After Twin",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-01-global-health-and-education-watch-aid-workers-in-venezuela-fear-disease-outbreak.jpg",
    date: "2026-07-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-aid-workers-in-venezuela-fear-disease-outbreaks-after-twin-2",
    title: "Global Health and Education Watch: Aid Workers in Venezuela Fear Disease Outbreaks After Twin",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-01-global-health-and-education-watch-aid-workers-in-venezuela-fear-disease-outbreak.jpg",
    date: "2026-07-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-aid-workers-in-venezuela-fear-disease-outbreaks-after-twin",
    title: "Global Health and Education Watch: Aid Workers in Venezuela Fear Disease Outbreaks After Twin",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-01-global-health-and-education-watch-aid-workers-in-venezuela-fear-disease-outbreak.jpg",
    date: "2026-07-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-people-with-strong-chest-and-back-less-likely-to",
    title: "Global Health and Education Watch: People with strong chest and back less likely to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-07-01-global-health-and-education-watch-people-with-strong-chest-and-back-less-likely-.jpg",
    date: "2026-07-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-frequent-ai-chatbot-users-more-likely-to-believe-anti-vaccine",
    title: "Global Health and Education Watch: Frequent AI chatbot users more likely to believe anti-vaccine",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-30-global-health-and-education-watch-frequent-ai-chatbot-users-more-likely-to-belie.jpg",
    date: "2026-06-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-healthcare-situation-in-dr-congo-improves-amidst-ebola-crisis-2",
    title: "Global Health and Education Watch: Healthcare situation in DR Congo improves amidst Ebola crisis",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-30-global-health-and-education-watch-healthcare-situation-in-dr-congo-improves-amid.jpg",
    date: "2026-06-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-healthcare-situation-in-dr-congo-improves-amidst-ebola-crisis",
    title: "Global Health and Education Watch: Healthcare situation in DR Congo improves amidst Ebola crisis",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-30-global-health-and-education-watch-healthcare-situation-in-dr-congo-improves-amid.jpg",
    date: "2026-06-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-new-who-plan-urges-stronger-action-against-fungal-disease",
    title: "Global Health and Education Watch: New WHO plan urges stronger action against fungal disease",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-30-global-health-and-education-watch-new-who-plan-urges-stronger-action-against-fun.jpg",
    date: "2026-06-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-venezuela-quake-key-services-crippled-and-health-workers-missing",
    title: "Global Health and Education Watch: Venezuela quake: Key services crippled and health workers missing",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-30-global-health-and-education-watch-venezuela-quake-key-services-crippled-and-heal.jpg",
    date: "2026-06-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-columbia-university-has-a-new-president-again-this-one",
    title: "Global Health and Education Watch: Columbia University Has a New President. Again. This One",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-30-global-health-and-education-watch-columbia-university-has-a-new-president-again-.jpg",
    date: "2026-06-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-dr-congo-says-1-307-ebola-cases-confirmed-including-377",
    title: "Global Health and Education Watch: DR Congo says 1,307 Ebola cases confirmed, including 377",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-30-global-health-and-education-watch-dr-congo-says-1-307-ebola-cases-confirmed-incl.jpg",
    date: "2026-06-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-norway-s-viking-row-is-a-fan-phenomenon-at-the",
    title: "Global Health and Education Watch: Norway’s ‘Viking Row’ Is a Fan Phenomenon at the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-30-global-health-and-education-watch-norway-s-viking-row-is-a-fan-phenomenon-at-the.jpg",
    date: "2026-06-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-england-to-get-powerful-maternity-commissioner-after-shocking-failings",
    title: "Global Health and Education Watch: England to get powerful maternity commissioner after ‘shocking’ failings",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-30-global-health-and-education-watch-england-to-get-powerful-maternity-commissioner.jpg",
    date: "2026-06-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-one-person-a-week-in-england-dies-with-undiagnosed",
    title: "Global Health and Education Watch: One person a week in England dies with undiagnosed",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-29-global-health-and-education-watch-one-person-a-week-in-england-dies-with-undiagn.jpg",
    date: "2026-06-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-high-performing-schools-in-england-should-be-encouraged-to-admit",
    title: "Global Health and Education Watch: High-performing schools in England ‘should be encouraged to admit",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-29-global-health-and-education-watch-high-performing-schools-in-england-should-be-e.jpg",
    date: "2026-06-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-gaza-high-school-student-s-fight-for-a-future",
    title: "Global Health and Education Watch: Gaza high school student’s fight for a future",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-29-global-health-and-education-watch-gaza-high-school-student-s-fight-for-a-future.jpg",
    date: "2026-06-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-england-facing-children-s-mental-health-crisis-as-referrals-hit",
    title: "Global Health and Education Watch: England facing children’s mental health ‘crisis’ as referrals hit",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-29-global-health-and-education-watch-england-facing-children-s-mental-health-crisis.jpg",
    date: "2026-06-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-it-definitely-trickles-down-muslims-in-texas-suffer-effects",
    title: "Global Health and Education Watch: ‘It definitely trickles down’: Muslims in Texas suffer effects",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-29-global-health-and-education-watch-it-definitely-trickles-down-muslims-in-texas-s.jpg",
    date: "2026-06-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-an-attack-on-ebola-s-first-responders",
    title: "Global Health and Education Watch: An Attack on Ebola’s First Responders",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-29-global-health-and-education-watch-an-attack-on-ebola-s-first-responders.jpg",
    date: "2026-06-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-trump-s-education-department-is-targeting-trans-students-2",
    title: "Global Health and Education Watch: How Trump’s Education Department Is Targeting Trans Students",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-29-global-health-and-education-watch-how-trump-s-education-department-is-targeting-.jpg",
    date: "2026-06-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-trump-s-education-department-is-targeting-trans-students",
    title: "Global Health and Education Watch: How Trump’s Education Department Is Targeting Trans Students",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-28-global-health-and-education-watch-how-trump-s-education-department-is-targeting-.jpg",
    date: "2026-06-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-whereabouts-of-nearly-300-people-with-ebola-unknown-in",
    title: "Global Health and Education Watch: Whereabouts of nearly 300 people with Ebola unknown in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-28-global-health-and-education-watch-whereabouts-of-nearly-300-people-with-ebola-un.jpg",
    date: "2026-06-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-q-a-why-humanitarian-aid-is-crucial-to-stopping-the",
    title: "Global Health and Education Watch: Q&A: Why humanitarian aid is crucial to stopping the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-28-global-health-and-education-watch-q-a-why-humanitarian-aid-is-crucial-to-stoppin.jpg",
    date: "2026-06-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-guardian-view-on-universities-public-confidence-in-degrees",
    title: "Global Health and Education Watch: The Guardian view on universities: public confidence in degrees",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-28-global-health-and-education-watch-the-guardian-view-on-universities-public-confi.jpg",
    date: "2026-06-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-do-you-need-electrolytes-will-tea-cool-you-down",
    title: "Global Health and Education Watch: Do you need electrolytes? Will tea cool you down?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-28-global-health-and-education-watch-do-you-need-electrolytes-will-tea-cool-you-dow.jpg",
    date: "2026-06-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-at-least-11-dead-as-skydiving-plane-crashes-in",
    title: "Global Health and Education Watch: At least 11 dead as skydiving plane crashes in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-28-global-health-and-education-watch-at-least-11-dead-as-skydiving-plane-crashes-in.jpg",
    date: "2026-06-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-young-britons-turn-to-private-healthcare-as-faith-in-3",
    title: "Global Health and Education Watch: Young Britons turn to private healthcare as faith in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-28-global-health-and-education-watch-young-britons-turn-to-private-healthcare-as-fa.jpg",
    date: "2026-06-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-young-britons-turn-to-private-healthcare-as-faith-in-2",
    title: "Global Health and Education Watch: Young Britons turn to private healthcare as faith in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-28-global-health-and-education-watch-young-britons-turn-to-private-healthcare-as-fa.jpg",
    date: "2026-06-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-young-britons-turn-to-private-healthcare-as-faith-in",
    title: "Global Health and Education Watch: Young Britons turn to private healthcare as faith in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-28-global-health-and-education-watch-young-britons-turn-to-private-healthcare-as-fa.jpg",
    date: "2026-06-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-drones-used-to-fight-mosquitoes-as-dengue-fever-surges",
    title: "Global Health and Education Watch: Drones Used to Fight Mosquitoes as Dengue Fever Surges",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-28-global-health-and-education-watch-drones-used-to-fight-mosquitoes-as-dengue-feve.jpg",
    date: "2026-06-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tarmac-playgrounds-and-windows-that-don-t-open-why-hot-2",
    title: "Global Health and Education Watch: Tarmac playgrounds and windows that don’t open: why hot",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-28-global-health-and-education-watch-tarmac-playgrounds-and-windows-that-don-t-open.jpg",
    date: "2026-06-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tarmac-playgrounds-and-windows-that-don-t-open-why-hot",
    title: "Global Health and Education Watch: Tarmac playgrounds and windows that don’t open: why hot",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-28-global-health-and-education-watch-tarmac-playgrounds-and-windows-that-don-t-open.jpg",
    date: "2026-06-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-volunteers-are-risking-their-lives-to-stop-ebola-they",
    title: "Global Health and Education Watch: Volunteers Are Risking Their Lives to Stop Ebola. They",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-27-global-health-and-education-watch-volunteers-are-risking-their-lives-to-stop-ebo.jpg",
    date: "2026-06-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-world-news-in-brief-students-injured-in-sudan-drone-3",
    title: "Global Health and Education Watch: World News in Brief: Students injured in Sudan drone",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-27-global-health-and-education-watch-world-news-in-brief-students-injured-in-sudan-.jpg",
    date: "2026-06-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-bodies-in-nottingham-nhs-trust-mortuary-in-state-of",
    title: "Global Health and Education Watch: Bodies in Nottingham NHS trust mortuary in state of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-27-global-health-and-education-watch-bodies-in-nottingham-nhs-trust-mortuary-in-sta.jpg",
    date: "2026-06-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-guardian-view-on-the-ockenden-maternity-review-lifting",
    title: "Global Health and Education Watch: The Guardian view on the Ockenden maternity review: lifting",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-27-global-health-and-education-watch-the-guardian-view-on-the-ockenden-maternity-re.jpg",
    date: "2026-06-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-no-school-living-in-a-tent-but-it-s-exam",
    title: "Global Health and Education Watch: No school, living in a tent, but it’s exam",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-27-global-health-and-education-watch-no-school-living-in-a-tent-but-it-s-exam.jpg",
    date: "2026-06-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-quidelortho-looks-to-sell-testing-unit-as-pe-circles",
    title: "Global Health and Education Watch: QuidelOrtho looks to sell testing unit as PE circles",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-27-global-health-and-education-watch-quidelortho-looks-to-sell-testing-unit-as-pe-c.jpg",
    date: "2026-06-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-world-news-in-brief-students-injured-in-sudan-drone-2",
    title: "Global Health and Education Watch: World News in Brief: Students injured in Sudan drone",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-27-global-health-and-education-watch-world-news-in-brief-students-injured-in-sudan-.jpg",
    date: "2026-06-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-world-news-in-brief-students-injured-in-sudan-drone",
    title: "Global Health and Education Watch: World News in Brief: Students injured in Sudan drone",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-27-global-health-and-education-watch-world-news-in-brief-students-injured-in-sudan-.jpg",
    date: "2026-06-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-administration-orders-us-health-programs-to-move-away-3",
    title: "Global Health and Education Watch: Trump administration orders US health programs to move away",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-27-global-health-and-education-watch-trump-administration-orders-us-health-programs.jpg",
    date: "2026-06-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-bible-passages-will-be-required-reading-in-texas-public",
    title: "Global Health and Education Watch: Bible Passages Will Be Required Reading in Texas Public",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-27-global-health-and-education-watch-bible-passages-will-be-required-reading-in-tex.jpg",
    date: "2026-06-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-administration-orders-us-health-programs-to-move-away-2",
    title: "Global Health and Education Watch: Trump administration orders US health programs to move away",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-26-global-health-and-education-watch-trump-administration-orders-us-health-programs.jpg",
    date: "2026-06-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-administration-orders-us-health-programs-to-move-away",
    title: "Global Health and Education Watch: Trump administration orders US health programs to move away",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-26-global-health-and-education-watch-trump-administration-orders-us-health-programs.jpg",
    date: "2026-06-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-global-drug-use-reaches-record-high-as-increasingly-potent",
    title: "Global Health and Education Watch: Global drug use reaches record high as increasingly potent",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-26-global-health-and-education-watch-global-drug-use-reaches-record-high-as-increas.jpg",
    date: "2026-06-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-venezuela-earthquakes-hit-a-health-system-already-in",
    title: "Global Health and Education Watch: The Venezuela Earthquakes Hit a Health System Already in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-26-global-health-and-education-watch-the-venezuela-earthquakes-hit-a-health-system-.jpg",
    date: "2026-06-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-new-evidence-casts-doubt-on-rfk-jr-testimony-before",
    title: "Global Health and Education Watch: New evidence casts doubt on RFK Jr testimony before",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-26-global-health-and-education-watch-new-evidence-casts-doubt-on-rfk-jr-testimony-b.jpg",
    date: "2026-06-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mark-tame-obituary-3",
    title: "Global Health and Education Watch: Mark Tame obituary",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-26-global-health-and-education-watch-mark-tame-obituary.jpg",
    date: "2026-06-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mark-tame-obituary-2",
    title: "Global Health and Education Watch: Mark Tame obituary",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-26-global-health-and-education-watch-mark-tame-obituary.jpg",
    date: "2026-06-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mark-tame-obituary",
    title: "Global Health and Education Watch: Mark Tame obituary",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-26-global-health-and-education-watch-mark-tame-obituary.jpg",
    date: "2026-06-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-europe-heatwave-breaks-records-as-un-agencies-ramp-up",
    title: "Global Health and Education Watch: Europe heatwave breaks records as UN agencies ramp up",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-26-global-health-and-education-watch-europe-heatwave-breaks-records-as-un-agencies-.jpg",
    date: "2026-06-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-plan-intl-mental-health-impact-of-venezuelan-quakes-can",
    title: "Global Health and Education Watch: Plan Intl: ‘Mental health impact of Venezuelan quakes can",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-26-global-health-and-education-watch-plan-intl-mental-health-impact-of-venezuelan-q.jpg",
    date: "2026-06-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-m-i-t-didn-t-publish-an-antisemitism-report-a-professor-wrote",
    title: "Global Health and Education Watch: M.I.T. Didn’t Publish an Antisemitism Report. A Professor Wrote",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-26-global-health-and-education-watch-m-i-t-didn-t-publish-an-antisemitism-report-a-.jpg",
    date: "2026-06-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-the-hpv-vaccine-changes-how-we-think-about-2",
    title: "Global Health and Education Watch: How the HPV vaccine changes how we think about",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-25-global-health-and-education-watch-how-the-hpv-vaccine-changes-how-we-think-about.jpg",
    date: "2026-06-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-the-hpv-vaccine-changes-how-we-think-about",
    title: "Global Health and Education Watch: How the HPV vaccine changes how we think about",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-25-global-health-and-education-watch-how-the-hpv-vaccine-changes-how-we-think-about.jpg",
    date: "2026-06-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-hospitals-cancel-operations-because-of-lack-of-air",
    title: "Global Health and Education Watch: UK hospitals cancel operations because of lack of air",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-25-global-health-and-education-watch-uk-hospitals-cancel-operations-because-of-lack.jpg",
    date: "2026-06-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-unions-urge-teachers-to-strike-as-french-school-exams",
    title: "Global Health and Education Watch: Unions urge teachers to strike as French school exams",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-25-global-health-and-education-watch-unions-urge-teachers-to-strike-as-french-schoo.jpg",
    date: "2026-06-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hundreds-of-mothers-and-babies-died-or-were-harmed-2",
    title: "Global Health and Education Watch: Hundreds of mothers and babies died or were harmed",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-25-global-health-and-education-watch-hundreds-of-mothers-and-babies-died-or-were-ha.jpg",
    date: "2026-06-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-655-million-people-still-living-without-electricity-underscore-urgent",
    title: "Global Health and Education Watch: 655 million people still living without electricity underscore urgent",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-25-global-health-and-education-watch-655-million-people-still-living-without-electr.jpg",
    date: "2026-06-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-los-angeles-names-a-new-schools-superintendent-after-scandal",
    title: "Global Health and Education Watch: Los Angeles Names a New Schools Superintendent After Scandal",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-25-global-health-and-education-watch-los-angeles-names-a-new-schools-superintendent.jpg",
    date: "2026-06-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hundreds-of-mothers-and-babies-died-or-were-harmed",
    title: "Global Health and Education Watch: Hundreds of mothers and babies died or were harmed",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-25-global-health-and-education-watch-hundreds-of-mothers-and-babies-died-or-were-ha.jpg",
    date: "2026-06-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-lives-at-risk-in-dr-congo-as-ebola-outbreak",
    title: "Global Health and Education Watch: Lives at risk in DR Congo as Ebola outbreak",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-24-global-health-and-education-watch-lives-at-risk-in-dr-congo-as-ebola-outbreak.jpg",
    date: "2026-06-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-public-health-agency-concludes-hantavirus-response-as-outbreak",
    title: "Global Health and Education Watch: US public health agency concludes hantavirus response as outbreak",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-24-global-health-and-education-watch-us-public-health-agency-concludes-hantavirus-r.jpg",
    date: "2026-06-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-stripe-and-anthropic-invest-in-combating-respiratory-diseases-2",
    title: "Global Health and Education Watch: Stripe and Anthropic invest in combating respiratory diseases",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-24-global-health-and-education-watch-stripe-and-anthropic-invest-in-combating-respi.jpg",
    date: "2026-06-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-stripe-and-anthropic-invest-in-combating-respiratory-diseases",
    title: "Global Health and Education Watch: Stripe and Anthropic invest in combating respiratory diseases",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-24-global-health-and-education-watch-stripe-and-anthropic-invest-in-combating-respi.jpg",
    date: "2026-06-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-symptoms-in-current-outbreak-may-be-milder-than-3",
    title: "Global Health and Education Watch: Ebola Symptoms in Current Outbreak May Be Milder Than",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-24-global-health-and-education-watch-ebola-symptoms-in-current-outbreak-may-be-mild.jpg",
    date: "2026-06-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-diabetes-patients-in-gaza-face-survival-battle-amid-war",
    title: "Global Health and Education Watch: Diabetes patients in Gaza face survival battle amid war",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-24-global-health-and-education-watch-diabetes-patients-in-gaza-face-survival-battle.jpg",
    date: "2026-06-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-wednesday-briefing-how-can-the-uk-protect-its-landscape",
    title: "Global Health and Education Watch: Wednesday briefing: How can the UK protect its landscape",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-24-global-health-and-education-watch-wednesday-briefing-how-can-the-uk-protect-its-.jpg",
    date: "2026-06-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-symptoms-in-current-outbreak-may-be-milder-than-2",
    title: "Global Health and Education Watch: Ebola Symptoms in Current Outbreak May Be Milder Than",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-24-global-health-and-education-watch-ebola-symptoms-in-current-outbreak-may-be-mild.jpg",
    date: "2026-06-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-symptoms-in-current-outbreak-may-be-milder-than",
    title: "Global Health and Education Watch: Ebola Symptoms in Current Outbreak May Be Milder Than",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-24-global-health-and-education-watch-ebola-symptoms-in-current-outbreak-may-be-mild.jpg",
    date: "2026-06-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-searing-uk-heat-leaves-schools-hospitals-and-transport-networks-3",
    title: "Global Health and Education Watch: Searing UK heat leaves schools, hospitals and transport networks",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-24-global-health-and-education-watch-searing-uk-heat-leaves-schools-hospitals-and-t.jpg",
    date: "2026-06-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-searing-uk-heat-leaves-schools-hospitals-and-transport-networks-2",
    title: "Global Health and Education Watch: Searing UK heat leaves schools, hospitals and transport networks",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-23-global-health-and-education-watch-searing-uk-heat-leaves-schools-hospitals-and-t.jpg",
    date: "2026-06-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-searing-uk-heat-leaves-schools-hospitals-and-transport-networks",
    title: "Global Health and Education Watch: Searing UK heat leaves schools, hospitals and transport networks",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-23-global-health-and-education-watch-searing-uk-heat-leaves-schools-hospitals-and-t.jpg",
    date: "2026-06-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-in-dr-congo-first-month-of-outbreak-sees",
    title: "Global Health and Education Watch: Ebola in DR Congo: first month of outbreak sees",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-23-global-health-and-education-watch-ebola-in-dr-congo-first-month-of-outbreak-sees.jpg",
    date: "2026-06-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-global-learning-losses-threaten-an-entire-generation",
    title: "Global Health and Education Watch: Global learning losses threaten an entire generation",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-23-global-health-and-education-watch-global-learning-losses-threaten-an-entire-gene.jpg",
    date: "2026-06-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-urges-scale-up-of-newborn-screening-to-improve",
    title: "Global Health and Education Watch: WHO urges scale up of newborn screening to improve",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-23-global-health-and-education-watch-who-urges-scale-up-of-newborn-screening-to-imp.jpg",
    date: "2026-06-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cuba-s-fuel-crisis-brings-schools-to-a-standstill",
    title: "Global Health and Education Watch: Cuba’s Fuel Crisis Brings Schools to a Standstill",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-23-global-health-and-education-watch-cuba-s-fuel-crisis-brings-schools-to-a-standst.jpg",
    date: "2026-06-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-bullying-investigated-after-rare-philippines-school-shooting-kills-three",
    title: "Global Health and Education Watch: Bullying investigated after rare Philippines school shooting kills three",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-23-global-health-and-education-watch-bullying-investigated-after-rare-philippines-s.jpg",
    date: "2026-06-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-can-you-refuse-to-work-or-send-your-kids",
    title: "Global Health and Education Watch: Can you refuse to work or send your kids",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-23-global-health-and-education-watch-can-you-refuse-to-work-or-send-your-kids.jpg",
    date: "2026-06-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-high-school-students-heckle-bard-president-over-his-ties",
    title: "Global Health and Education Watch: High School Students Heckle Bard President Over His Ties",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-23-global-health-and-education-watch-high-school-students-heckle-bard-president-ove.jpg",
    date: "2026-06-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-to-start-strength-training-in-midlife-according-to",
    title: "Global Health and Education Watch: How to start strength training in midlife, according to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-22-global-health-and-education-watch-how-to-start-strength-training-in-midlife-acco.jpg",
    date: "2026-06-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-truly-horrific-the-stories-of-five-people-affected-by",
    title: "Global Health and Education Watch: ‘Truly horrific’: the stories of five people affected by",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-22-global-health-and-education-watch-truly-horrific-the-stories-of-five-people-affe.jpg",
    date: "2026-06-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-afghanistan-in-crisis-drought-malnutrition-and-a-worsening-humanitarian",
    title: "Global Health and Education Watch: Afghanistan in crisis: Drought, malnutrition and a worsening humanitarian",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-22-global-health-and-education-watch-afghanistan-in-crisis-drought-malnutrition-and.jpg",
    date: "2026-06-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-two-students-arrested-after-three-killed-in-philippines-school",
    title: "Global Health and Education Watch: Two students arrested after three killed in Philippines school",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-22-global-health-and-education-watch-two-students-arrested-after-three-killed-in-ph.jpg",
    date: "2026-06-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-rates-on-new-student-loans-will-rise-on-july",
    title: "Global Health and Education Watch: Rates on New Student Loans Will Rise on July",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-22-global-health-and-education-watch-rates-on-new-student-loans-will-rise-on-july.jpg",
    date: "2026-06-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-currency-crash-and-visa-crackdowns-force-indian-students-to",
    title: "Global Health and Education Watch: Currency crash and visa crackdowns force Indian students to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-21-global-health-and-education-watch-currency-crash-and-visa-crackdowns-force-india.jpg",
    date: "2026-06-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-much-preventive-health-screening-should-i-be-getting",
    title: "Global Health and Education Watch: How much preventive health screening should I be getting?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-21-global-health-and-education-watch-how-much-preventive-health-screening-should-i-.jpg",
    date: "2026-06-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-lives-are-being-ruined-by-undiagnosed-hypermobility-and-lack",
    title: "Global Health and Education Watch: Lives are being ruined by undiagnosed hypermobility and lack",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-21-global-health-and-education-watch-lives-are-being-ruined-by-undiagnosed-hypermob.jpg",
    date: "2026-06-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-india-s-cockroach-movement-camps-out-until-education-minister-resigns",
    title: "Global Health and Education Watch: India’s ‘Cockroach’ movement camps out until education minister resigns",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-21-global-health-and-education-watch-india-s-cockroach-movement-camps-out-until-edu.jpg",
    date: "2026-06-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tight-security-as-indian-students-resit-medical-exam-after",
    title: "Global Health and Education Watch: Tight security as Indian students resit medical exam after",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-21-global-health-and-education-watch-tight-security-as-indian-students-resit-medica.jpg",
    date: "2026-06-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cities-and-schools-are-testing-wastewater-for-illicit-drugs",
    title: "Global Health and Education Watch: Cities and Schools Are Testing Wastewater for Illicit Drugs",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-21-global-health-and-education-watch-cities-and-schools-are-testing-wastewater-for-.jpg",
    date: "2026-06-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-prediction-markets-surge-in-us-as-public-health-advocates",
    title: "Global Health and Education Watch: Prediction markets surge in US as public health advocates",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-21-global-health-and-education-watch-prediction-markets-surge-in-us-as-public-healt.jpg",
    date: "2026-06-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-in-dr-congo-one-month-on-scaled-up",
    title: "Global Health and Education Watch: Ebola in DR Congo: One month on, scaled up",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-21-global-health-and-education-watch-ebola-in-dr-congo-one-month-on-scaled-up.jpg",
    date: "2026-06-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-student-cheating-is-becoming-impossible-to-detect-in-an",
    title: "Global Health and Education Watch: Student Cheating Is Becoming Impossible to Detect in an",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-21-global-health-and-education-watch-student-cheating-is-becoming-impossible-to-det.jpg",
    date: "2026-06-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-bird-flu-vaccine-trial-against-potential-pandemic-strain-begins",
    title: "Global Health and Education Watch: Bird flu vaccine trial against potential pandemic strain begins",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-20-global-health-and-education-watch-bird-flu-vaccine-trial-against-potential-pande.jpg",
    date: "2026-06-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-child-goes-to-bed-and-doesn-t-wake-up",
    title: "Global Health and Education Watch: ‘A child goes to bed and doesn’t wake up’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-20-global-health-and-education-watch-a-child-goes-to-bed-and-doesn-t-wake-up.jpg",
    date: "2026-06-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-social-media-ban-saving-kids-or-punishing-them",
    title: "Global Health and Education Watch: Social media ban: saving kids or punishing them? |",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-20-global-health-and-education-watch-social-media-ban-saving-kids-or-punishing-them.jpg",
    date: "2026-06-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-nine-left-in-critical-condition-after-uk-train-collision",
    title: "Global Health and Education Watch: Nine left in critical condition after UK train collision",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-20-global-health-and-education-watch-nine-left-in-critical-condition-after-uk-train.jpg",
    date: "2026-06-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-minimum-age-of-11-set-for-uk-puberty-blocker",
    title: "Global Health and Education Watch: Minimum age of 11 set for UK puberty blocker",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-20-global-health-and-education-watch-minimum-age-of-11-set-for-uk-puberty-blocker.jpg",
    date: "2026-06-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-disability-groups-fear-rfk-jr-s-new-special-education-role",
    title: "Global Health and Education Watch: Disability Groups Fear RFK Jr.’s New Special Education Role",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-20-global-health-and-education-watch-disability-groups-fear-rfk-jr-s-new-special-ed.jpg",
    date: "2026-06-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-i-m-a-critical-care-doctor-i-ve-never-seen-the",
    title: "Global Health and Education Watch: I’m a critical care doctor. I’ve never seen the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-20-global-health-and-education-watch-i-m-a-critical-care-doctor-i-ve-never-seen-the.jpg",
    date: "2026-06-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-beer-can-boost-spiritual-or-mental-health-says-kirin",
    title: "Global Health and Education Watch: Beer can boost ‘spiritual or mental’ health, says Kirin",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-20-global-health-and-education-watch-beer-can-boost-spiritual-or-mental-health-says.jpg",
    date: "2026-06-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-does-it-all-mean-once-a-year-french",
    title: "Global Health and Education Watch: What Does It All Mean? Once a Year, French",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-20-global-health-and-education-watch-what-does-it-all-mean-once-a-year-french.jpg",
    date: "2026-06-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-dr-congo-efforts-ramp-up-as-ebola-outbreak-accelerates",
    title: "Global Health and Education Watch: DR Congo: Efforts ramp up as Ebola outbreak accelerates",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-19-global-health-and-education-watch-dr-congo-efforts-ramp-up-as-ebola-outbreak-acc.jpg",
    date: "2026-06-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-average-student-in-england-leaves-university-with-47-700-debt",
    title: "Global Health and Education Watch: Average student in England leaves university with £47,700 debt",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-19-global-health-and-education-watch-average-student-in-england-leaves-university-w.jpg",
    date: "2026-06-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-elizabeth-greenhall-obituary",
    title: "Global Health and Education Watch: Elizabeth Greenhall obituary",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-19-global-health-and-education-watch-elizabeth-greenhall-obituary.jpg",
    date: "2026-06-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-fermentation-flavour-and-the-future-of-food-making-sustainability",
    title: "Global Health and Education Watch: Fermentation, flavour and the future of food: Making sustainability",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-19-global-health-and-education-watch-fermentation-flavour-and-the-future-of-food-ma.jpg",
    date: "2026-06-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-could-the-hpv-vaccine-eliminate-cervical-cancer-deaths",
    title: "Global Health and Education Watch: Could the HPV vaccine eliminate cervical cancer deaths?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-19-global-health-and-education-watch-could-the-hpv-vaccine-eliminate-cervical-cance.jpg",
    date: "2026-06-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-at-past-championship-parades-many-students-skipped-school",
    title: "Global Health and Education Watch: At Past Championship Parades, Many Students Skipped School",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-19-global-health-and-education-watch-at-past-championship-parades-many-students-ski.jpg",
    date: "2026-06-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cdc-to-tap-107m-in-emergency-funding-for-ebola",
    title: "Global Health and Education Watch: CDC to tap $107m in emergency funding for Ebola",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-19-global-health-and-education-watch-cdc-to-tap-107m-in-emergency-funding-for-ebola.jpg",
    date: "2026-06-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-london-hospital-worker-tried-to-sell-princess-catherine-s-medical",
    title: "Global Health and Education Watch: London Hospital Worker Tried to Sell Princess Catherine’s Medical",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-19-global-health-and-education-watch-london-hospital-worker-tried-to-sell-princess-.jpg",
    date: "2026-06-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-young-women-now-have-close-to-zero-risk-of",
    title: "Global Health and Education Watch: Young women now have 'close to zero' risk of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-18-global-health-and-education-watch-young-women-now-have-close-to-zero-risk-of.jpg",
    date: "2026-06-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hpv-jabs-cut-risk-of-dying-from-cervical-cancer",
    title: "Global Health and Education Watch: HPV jabs cut risk of dying from cervical cancer",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-18-global-health-and-education-watch-hpv-jabs-cut-risk-of-dying-from-cervical-cance.jpg",
    date: "2026-06-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-issues-comprehensive-guidelines-on-filovirus-disease-including-ebola",
    title: "Global Health and Education Watch: WHO issues comprehensive guidelines on filovirus disease, including Ebola",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-18-global-health-and-education-watch-who-issues-comprehensive-guidelines-on-filovir.jpg",
    date: "2026-06-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-treatment-capacity-expands-in-dr-congo-as-who",
    title: "Global Health and Education Watch: Ebola treatment capacity expands in DR Congo as WHO",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-18-global-health-and-education-watch-ebola-treatment-capacity-expands-in-dr-congo-a.jpg",
    date: "2026-06-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ai-medical-tools-match-or-surpass-doctors-for-advice",
    title: "Global Health and Education Watch: AI medical tools match or surpass doctors for advice",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-18-global-health-and-education-watch-ai-medical-tools-match-or-surpass-doctors-for-.jpg",
    date: "2026-06-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-luigi-mangione-to-use-psychiatric-defence-in-healthcare-ceo",
    title: "Global Health and Education Watch: Luigi Mangione to use psychiatric defence in healthcare CEO",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-17-global-health-and-education-watch-luigi-mangione-to-use-psychiatric-defence-in-h.jpg",
    date: "2026-06-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-battle-over-a-i-in-the-classroom",
    title: "Global Health and Education Watch: The Battle Over A.I. in the Classroom",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-17-global-health-and-education-watch-the-battle-over-a-i-in-the-classroom.jpg",
    date: "2026-06-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-and-brazil-urge-world-leaders-to-finalise-pandemic",
    title: "Global Health and Education Watch: WHO and Brazil urge world leaders to finalise Pandemic",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-17-global-health-and-education-watch-who-and-brazil-urge-world-leaders-to-finalise-.jpg",
    date: "2026-06-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-lack-of-learning-disability-nurses-in-uk-is-an-absolute",
    title: "Global Health and Education Watch: Lack of learning-disability nurses in UK is an ‘absolute",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-17-global-health-and-education-watch-lack-of-learning-disability-nurses-in-uk-is-an.jpg",
    date: "2026-06-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-keir-starmer-says-he-wants-to-offer-burnham-big",
    title: "Global Health and Education Watch: Keir Starmer says he wants to offer Burnham ‘big",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-17-global-health-and-education-watch-keir-starmer-says-he-wants-to-offer-burnham-bi.jpg",
    date: "2026-06-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-recovery-of-ebola-patients-offers-rare-moments-of-joy",
    title: "Global Health and Education Watch: Recovery of Ebola patients offers rare moments of joy",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-17-global-health-and-education-watch-recovery-of-ebola-patients-offers-rare-moments.jpg",
    date: "2026-06-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-best-books-on-sport-health-and-wellness-to",
    title: "Global Health and Education Watch: The best books on sport, health and wellness to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-16-global-health-and-education-watch-the-best-books-on-sport-health-and-wellness-to.jpg",
    date: "2026-06-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-post-apartheid-south-africa-50-years-after-soweto-riots-what",
    title: "Global Health and Education Watch: Post-apartheid South Africa: 50 years after Soweto riots, what",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-16-global-health-and-education-watch-post-apartheid-south-africa-50-years-after-sow.jpg",
    date: "2026-06-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-kennedy-orders-woman-to-stay-in-hantavirus-quarantine-despite",
    title: "Global Health and Education Watch: Kennedy Orders Woman to Stay in Hantavirus Quarantine, Despite",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-16-global-health-and-education-watch-kennedy-orders-woman-to-stay-in-hantavirus-qua.jpg",
    date: "2026-06-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-commends-uganda-s-ebola-response-urges-vigilance-and-regional",
    title: "Global Health and Education Watch: WHO commends Uganda’s Ebola response, urges vigilance and regional",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-16-global-health-and-education-watch-who-commends-uganda-s-ebola-response-urges-vig.jpg",
    date: "2026-06-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-open-letter-to-leaders-of-g7-g20-brics-and",
    title: "Global Health and Education Watch: Open letter to leaders of G7, G20, BRICS and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-16-global-health-and-education-watch-open-letter-to-leaders-of-g7-g20-brics-and.jpg",
    date: "2026-06-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-violent-attacks-on-schools-pupils-and-staff-around-the",
    title: "Global Health and Education Watch: Violent attacks on schools, pupils and staff around the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-16-global-health-and-education-watch-violent-attacks-on-schools-pupils-and-staff-ar.jpg",
    date: "2026-06-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-taboo-subjects-on-the-table-at-women-s-health-event",
    title: "Global Health and Education Watch: Taboo subjects on the table at women's health event",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-15-global-health-and-education-watch-taboo-subjects-on-the-table-at-women-s-health-.jpg",
    date: "2026-06-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-right-now-we-could-be-living-through-a-hantavirus",
    title: "Global Health and Education Watch: Right now, we could be living through a hantavirus",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-15-global-health-and-education-watch-right-now-we-could-be-living-through-a-hantavi.jpg",
    date: "2026-06-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ivory-coast-beats-ecuador-1-0-at-fifa-world-cup",
    title: "Global Health and Education Watch: Ivory Coast beats Ecuador 1-0 at FIFA World Cup",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-15-global-health-and-education-watch-ivory-coast-beats-ecuador-1-0-at-fifa-world-cu.jpg",
    date: "2026-06-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-hypermobility-sufferers-wait-up-to-21-years-for",
    title: "Global Health and Education Watch: UK hypermobility sufferers wait up to 21 years for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-14-global-health-and-education-watch-uk-hypermobility-sufferers-wait-up-to-21-years.jpg",
    date: "2026-06-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-more-strikes-impact-lebanon-hospitals-as-humanitarian-situation-deteriorates",
    title: "Global Health and Education Watch: More strikes impact Lebanon hospitals as humanitarian situation deteriorates",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-14-global-health-and-education-watch-more-strikes-impact-lebanon-hospitals-as-human.jpg",
    date: "2026-06-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-secrets-of-a-soccer-turf-master",
    title: "Global Health and Education Watch: The Secrets of a Soccer-Turf Master",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-14-global-health-and-education-watch-the-secrets-of-a-soccer-turf-master.jpg",
    date: "2026-06-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-one-month-on-will-the-latest-outbreak-in",
    title: "Global Health and Education Watch: Ebola one month on: will the latest outbreak in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-14-global-health-and-education-watch-ebola-one-month-on-will-the-latest-outbreak-in.jpg",
    date: "2026-06-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-is-meningitis-b-and-why-is-a-vaccine",
    title: "Global Health and Education Watch: What is meningitis B and why is a vaccine",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-14-global-health-and-education-watch-what-is-meningitis-b-and-why-is-a-vaccine.jpg",
    date: "2026-06-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-huge-spectrum-of-people-coming-together-how-parkrun",
    title: "Global Health and Education Watch: ‘A huge spectrum of people coming together’: how parkrun",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-14-global-health-and-education-watch-a-huge-spectrum-of-people-coming-together-how-.jpg",
    date: "2026-06-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-instability-war-and-closed-borders-how-aid-workers-get",
    title: "Global Health and Education Watch: Instability, war and closed borders: How aid workers get",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-14-global-health-and-education-watch-instability-war-and-closed-borders-how-aid-wor.jpg",
    date: "2026-06-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-is-your-health-hack-worth-it-we-ask-the",
    title: "Global Health and Education Watch: Is your health hack worth it? We ask the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-14-global-health-and-education-watch-is-your-health-hack-worth-it-we-ask-the.jpg",
    date: "2026-06-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-scientists-race-to-test-treatments-as-ebola-outbreak-widens",
    title: "Global Health and Education Watch: Scientists Race to Test Treatments as Ebola Outbreak Widens",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-14-global-health-and-education-watch-scientists-race-to-test-treatments-as-ebola-ou.jpg",
    date: "2026-06-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-gaza-pet-owners-struggle-to-keep-animals-healthy-amid",
    title: "Global Health and Education Watch: Gaza pet owners struggle to keep animals healthy amid",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-13-global-health-and-education-watch-gaza-pet-owners-struggle-to-keep-animals-healt.jpg",
    date: "2026-06-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-women-and-girls-caught-up-in-yemen-s-forgotten-crisis",
    title: "Global Health and Education Watch: Women and girls caught up in Yemen’s ‘forgotten crisis’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-13-global-health-and-education-watch-women-and-girls-caught-up-in-yemen-s-forgotten.jpg",
    date: "2026-06-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-meningitis-b-vaccine-to-be-offered-to-a-million",
    title: "Global Health and Education Watch: Meningitis B vaccine to be offered to a million",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-13-global-health-and-education-watch-meningitis-b-vaccine-to-be-offered-to-a-millio.jpg",
    date: "2026-06-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-natural-history-gcse-to-teach-teenagers-to-plant-wildflower-friendly",
    title: "Global Health and Education Watch: Natural history GCSE to teach teenagers to plant wildflower-friendly",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-13-global-health-and-education-watch-natural-history-gcse-to-teach-teenagers-to-pla.jpg",
    date: "2026-06-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-comes-for-congo-s-most-vulnerable-children",
    title: "Global Health and Education Watch: Ebola Comes for Congo’s Most Vulnerable Children",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-13-global-health-and-education-watch-ebola-comes-for-congo-s-most-vulnerable-childr.jpg",
    date: "2026-06-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-more-than-one-in-five-pupils-in-england-have",
    title: "Global Health and Education Watch: More than one in five pupils in England have",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-13-global-health-and-education-watch-more-than-one-in-five-pupils-in-england-have.jpg",
    date: "2026-06-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-molokhia-cigarettes-gaza-s-toxic-alternative-to-tobacco",
    title: "Global Health and Education Watch: Molokhia cigarettes: Gaza’s toxic alternative to tobacco",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-13-global-health-and-education-watch-molokhia-cigarettes-gaza-s-toxic-alternative-t.jpg",
    date: "2026-06-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-ebola-came-back-and-a-warning-for",
    title: "Global Health and Education Watch: Why Ebola came back — and a warning for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-13-global-health-and-education-watch-why-ebola-came-back-and-a-warning-for.jpg",
    date: "2026-06-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-report-shows-progress-in-blood-safety-but-there",
    title: "Global Health and Education Watch: WHO report shows progress in blood safety, but there",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-13-global-health-and-education-watch-who-report-shows-progress-in-blood-safety-but-.jpg",
    date: "2026-06-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-college-opens-lifelike-hospital-training-ward",
    title: "Global Health and Education Watch: College opens lifelike hospital training ward",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-12-global-health-and-education-watch-college-opens-lifelike-hospital-training-ward.jpg",
    date: "2026-06-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-safe-blood-supply-improves-as-voluntary-donations-exceed-85",
    title: "Global Health and Education Watch: Safe blood supply improves as voluntary donations exceed 85%",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-12-global-health-and-education-watch-safe-blood-supply-improves-as-voluntary-donati.jpg",
    date: "2026-06-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-world-cup-ticket-prices-in-mexico-city-too-expensive",
    title: "Global Health and Education Watch: World Cup Ticket Prices in Mexico City Too Expensive",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-12-global-health-and-education-watch-world-cup-ticket-prices-in-mexico-city-too-exp.jpg",
    date: "2026-06-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-bananas-could-vanish-from-us-school-meals-here-s-why",
    title: "Global Health and Education Watch: Bananas could vanish from US school meals. Here’s why",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-12-global-health-and-education-watch-bananas-could-vanish-from-us-school-meals-here.jpg",
    date: "2026-06-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-thai-princess-bajrakitiyabha-dies-at-47-after-three-years",
    title: "Global Health and Education Watch: Thai Princess Bajrakitiyabha dies at 47 after three years",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-12-global-health-and-education-watch-thai-princess-bajrakitiyabha-dies-at-47-after-.jpg",
    date: "2026-06-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-world-news-in-brief-turk-condemns-northern-ireland-riots",
    title: "Global Health and Education Watch: World News in Brief: Turk condemns Northern Ireland riots",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-12-global-health-and-education-watch-world-news-in-brief-turk-condemns-northern-ire.jpg",
    date: "2026-06-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-school-leavers-and-new-students-to-be-offered",
    title: "Global Health and Education Watch: UK school leavers and new students to be offered",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-12-global-health-and-education-watch-uk-school-leavers-and-new-students-to-be-offer.jpg",
    date: "2026-06-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-more-than-one-in-five-pupils-in-england-getting",
    title: "Global Health and Education Watch: More than one in five pupils in England getting",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-11-global-health-and-education-watch-more-than-one-in-five-pupils-in-england-gettin.jpg",
    date: "2026-06-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-deadly-quake-strikes-philippines-on-first-day-of-school",
    title: "Global Health and Education Watch: Deadly quake strikes Philippines on first day of school",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-11-global-health-and-education-watch-deadly-quake-strikes-philippines-on-first-day-.jpg",
    date: "2026-06-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-researcher-who-didn-t-want-to-know",
    title: "Global Health and Education Watch: The Researcher Who Didn’t Want to Know",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-11-global-health-and-education-watch-the-researcher-who-didn-t-want-to-know.jpg",
    date: "2026-06-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-children-hit-by-parents-more-likely-to-bully-others",
    title: "Global Health and Education Watch: Children hit by parents more likely to bully others",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-11-global-health-and-education-watch-children-hit-by-parents-more-likely-to-bully-o.jpg",
    date: "2026-06-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-india-s-deadly-dengue-crisis-is-now-no-longer",
    title: "Global Health and Education Watch: Why India’s deadly dengue crisis is now no longer",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-11-global-health-and-education-watch-why-india-s-deadly-dengue-crisis-is-now-no-lon.jpg",
    date: "2026-06-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-naep-test-shows-younger-students-recovering-from-pandemic",
    title: "Global Health and Education Watch: NAEP Test Shows Younger Students Recovering From Pandemic",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-11-global-health-and-education-watch-naep-test-shows-younger-students-recovering-fr.jpg",
    date: "2026-06-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-measles-cases-pass-2-000-this-year-as-outbreak",
    title: "Global Health and Education Watch: US measles cases pass 2,000 this year as outbreak",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-10-global-health-and-education-watch-us-measles-cases-pass-2-000-this-year-as-outbr.jpg",
    date: "2026-06-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-advanced-radiotherapy-for-prostate-cancer-to-cut-sessions-from",
    title: "Global Health and Education Watch: Advanced radiotherapy for prostate cancer to cut sessions from",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-10-global-health-and-education-watch-advanced-radiotherapy-for-prostate-cancer-to-c.jpg",
    date: "2026-06-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-author-on-benefits-of-investing-in-children-s-mental-health",
    title: "Global Health and Education Watch: Author on benefits of investing in children's mental health",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-10-global-health-and-education-watch-author-on-benefits-of-investing-in-children-s-.jpg",
    date: "2026-06-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-it-just-fell-off-him-parents-turn-to-private",
    title: "Global Health and Education Watch: ‘It just fell off him’: Parents turn to private",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-10-global-health-and-education-watch-it-just-fell-off-him-parents-turn-to-private.jpg",
    date: "2026-06-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-woefully-unprepared-extreme-heat-will-double-us-hospitalizations-by",
    title: "Global Health and Education Watch: ‘Woefully unprepared’: extreme heat will double US hospitalizations by",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-10-global-health-and-education-watch-woefully-unprepared-extreme-heat-will-double-u.jpg",
    date: "2026-06-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-majority-of-city-council-members-urge-mamdani-to-pause",
    title: "Global Health and Education Watch: Majority of City Council Members Urge Mamdani to Pause",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-10-global-health-and-education-watch-majority-of-city-council-members-urge-mamdani-.jpg",
    date: "2026-06-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-building-trust-and-lab-testing-at-the-heart-of",
    title: "Global Health and Education Watch: Building trust and lab testing at the heart of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-10-global-health-and-education-watch-building-trust-and-lab-testing-at-the-heart-of.jpg",
    date: "2026-06-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-bear-captured-after-days-of-panic-and-school-closures",
    title: "Global Health and Education Watch: Bear captured after days of panic and school closures",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-09-global-health-and-education-watch-bear-captured-after-days-of-panic-and-school-c.jpg",
    date: "2026-06-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-karmelo-anthony-19-found-guilty-of-murder-of-austin",
    title: "Global Health and Education Watch: Karmelo Anthony, 19, found guilty of murder of Austin",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-09-global-health-and-education-watch-karmelo-anthony-19-found-guilty-of-murder-of-a.jpg",
    date: "2026-06-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-are-the-plans-for-liverpool-women-s-hospital",
    title: "Global Health and Education Watch: What are the plans for Liverpool Women's Hospital?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-09-global-health-and-education-watch-what-are-the-plans-for-liverpool-women-s-hospi.jpg",
    date: "2026-06-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-plan-to-tighten-healthy-food-rules-provokes-backlash-from",
    title: "Global Health and Education Watch: Plan to tighten healthy food rules provokes backlash from",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-09-global-health-and-education-watch-plan-to-tighten-healthy-food-rules-provokes-ba.jpg",
    date: "2026-06-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-have-a-thorny-medical-question-your-doctor-may-be",
    title: "Global Health and Education Watch: Have a Thorny Medical Question? Your Doctor May Be",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-09-global-health-and-education-watch-have-a-thorny-medical-question-your-doctor-may.jpg",
    date: "2026-06-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-healthy-cooperation-how-northern-universities-are-linking-with-nhs",
    title: "Global Health and Education Watch: Healthy cooperation: how northern universities are linking with NHS",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-09-global-health-and-education-watch-healthy-cooperation-how-northern-universities-.jpg",
    date: "2026-06-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-rare-untreatable-strain-ebola-toll-mounts-in-eastern-dr",
    title: "Global Health and Education Watch: ‘Rare, untreatable strain’: Ebola toll mounts in eastern DR",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-09-global-health-and-education-watch-rare-untreatable-strain-ebola-toll-mounts-in-e.jpg",
    date: "2026-06-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-chief-lauds-uganda-s-response-to-ebola-outbreak",
    title: "Global Health and Education Watch: WHO chief lauds Uganda’s response to Ebola outbreak",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-08-global-health-and-education-watch-who-chief-lauds-uganda-s-response-to-ebola-out.jpg",
    date: "2026-06-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-more-than-half-of-staff-who-died-in-service",
    title: "Global Health and Education Watch: More than half of staff who died in service",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-08-global-health-and-education-watch-more-than-half-of-staff-who-died-in-service.jpg",
    date: "2026-06-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-monday-briefing-are-we-any-closer-to-a-cure",
    title: "Global Health and Education Watch: Monday briefing: Are we any closer to a cure",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-08-global-health-and-education-watch-monday-briefing-are-we-any-closer-to-a-cure.jpg",
    date: "2026-06-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-a-i-classroom-is-quiet-way-too-quiet",
    title: "Global Health and Education Watch: The A.I. Classroom Is Quiet. Way Too Quiet.",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-08-global-health-and-education-watch-the-a-i-classroom-is-quiet-way-too-quiet.jpg",
    date: "2026-06-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-and-jihadis-threaten-africa-s-oldest-national-park",
    title: "Global Health and Education Watch: Ebola and jihadis threaten Africa’s oldest national park",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-08-global-health-and-education-watch-ebola-and-jihadis-threaten-africa-s-oldest-nat.jpg",
    date: "2026-06-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-no-dead-ends-what-the-dutch-can-teach-us",
    title: "Global Health and Education Watch: 'No dead ends': What the Dutch can teach us",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-08-global-health-and-education-watch-no-dead-ends-what-the-dutch-can-teach-us.jpg",
    date: "2026-06-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-rfk-jr-appears-disengaged-on-many-health-department-matters",
    title: "Global Health and Education Watch: RFK Jr. Appears Disengaged on Many Health Department Matters",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-07-global-health-and-education-watch-rfk-jr-appears-disengaged-on-many-health-depar.jpg",
    date: "2026-06-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-genital-herpes-rising-in-england-despite-overall-drop-in",
    title: "Global Health and Education Watch: Genital herpes rising in England, despite overall drop in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-07-global-health-and-education-watch-genital-herpes-rising-in-england-despite-overa.jpg",
    date: "2026-06-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-unsafe-food-kills-1-5-million-people-each-year-children",
    title: "Global Health and Education Watch: Unsafe food kills 1.5 million people each year; children",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-07-global-health-and-education-watch-unsafe-food-kills-1-5-million-people-each-year.jpg",
    date: "2026-06-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-factors-leading-to-failures-in-nhs-maternity-care",
    title: "Global Health and Education Watch: Factors leading to failures in NHS maternity care |",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-07-global-health-and-education-watch-factors-leading-to-failures-in-nhs-maternity-c.jpg",
    date: "2026-06-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-labour-doesn-t-seem-to-like-send-schools-for-kids",
    title: "Global Health and Education Watch: Labour doesn't seem to like Send schools for kids",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-07-global-health-and-education-watch-labour-doesn-t-seem-to-like-send-schools-for-k.jpg",
    date: "2026-06-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-the-hosts-are-preparing-for-an-ebola-outbreak",
    title: "Global Health and Education Watch: How the hosts are preparing for an Ebola outbreak",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-07-global-health-and-education-watch-how-the-hosts-are-preparing-for-an-ebola-outbr.jpg",
    date: "2026-06-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-stevie-nicks-donates-3m-to-medical-school-to-recognize",
    title: "Global Health and Education Watch: Stevie Nicks donates $3m to medical school to recognize",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-07-global-health-and-education-watch-stevie-nicks-donates-3m-to-medical-school-to-r.jpg",
    date: "2026-06-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-should-get-an-a-at-harvard",
    title: "Global Health and Education Watch: Who Should Get an A at Harvard?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-07-global-health-and-education-watch-who-should-get-an-a-at-harvard.jpg",
    date: "2026-06-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-faith-fear-and-trust-inside-dr-congo-s-fight-against",
    title: "Global Health and Education Watch: Faith, fear and trust: Inside DR Congo’s fight against",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-07-global-health-and-education-watch-faith-fear-and-trust-inside-dr-congo-s-fight-a.jpg",
    date: "2026-06-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-world-has-learned-from-the-last-ebola-outbreak",
    title: "Global Health and Education Watch: The World Has Learned From the Last Ebola Outbreak",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-06-global-health-and-education-watch-the-world-has-learned-from-the-last-ebola-outb.jpg",
    date: "2026-06-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-level-maths-exam-marking-to-be-watched-closely-by",
    title: "Global Health and Education Watch: A-level maths exam marking to be watched closely by",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-06-global-health-and-education-watch-a-level-maths-exam-marking-to-be-watched-close.jpg",
    date: "2026-06-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-i-m-a-cockroach-gen-z-protest-movement-lands-in",
    title: "Global Health and Education Watch: ‘I’m a cockroach’: Gen Z protest movement lands in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-06-global-health-and-education-watch-i-m-a-cockroach-gen-z-protest-movement-lands-i.jpg",
    date: "2026-06-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-world-news-in-brief-un-scales-up-ebola-response",
    title: "Global Health and Education Watch: World News in Brief: UN scales up Ebola response",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-06-global-health-and-education-watch-world-news-in-brief-un-scales-up-ebola-respons.jpg",
    date: "2026-06-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-new-study-casts-doubt-on-reliability-of-mental-health",
    title: "Global Health and Education Watch: New study casts doubt on reliability of mental health",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-06-global-health-and-education-watch-new-study-casts-doubt-on-reliability-of-mental.jpg",
    date: "2026-06-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-pupils-asked-to-walk-to-school-through-army-firing",
    title: "Global Health and Education Watch: Pupils asked to walk to school through army firing",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-06-global-health-and-education-watch-pupils-asked-to-walk-to-school-through-army-fi.jpg",
    date: "2026-06-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-supporters-of-the-cockroach-people-s-party-hold-protest-in",
    title: "Global Health and Education Watch: Supporters of the Cockroach People’s Party hold protest in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-06-global-health-and-education-watch-supporters-of-the-cockroach-people-s-party-hol.jpg",
    date: "2026-06-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-s-justice-department-is-weaponizing-civil-rights-laws-against",
    title: "Global Health and Education Watch: Trump’s justice department is weaponizing civil rights laws against",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-06-global-health-and-education-watch-trump-s-justice-department-is-weaponizing-civi.jpg",
    date: "2026-06-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-africa-cdc-and-who-launch-joint-continental-ebola-response",
    title: "Global Health and Education Watch: Africa CDC and WHO launch joint continental Ebola response",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-06-global-health-and-education-watch-africa-cdc-and-who-launch-joint-continental-eb.jpg",
    date: "2026-06-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ohio-state-agrees-to-100-million-payout-over-sexual",
    title: "Global Health and Education Watch: Ohio State Agrees to $100 Million Payout Over Sexual",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-06-global-health-and-education-watch-ohio-state-agrees-to-100-million-payout-over-s.jpg",
    date: "2026-06-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-from-food-lines-in-somalia-to-clinics-in-afghanistan",
    title: "Global Health and Education Watch: From food lines in Somalia to clinics in Afghanistan",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-05-global-health-and-education-watch-from-food-lines-in-somalia-to-clinics-in-afgha.jpg",
    date: "2026-06-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mistrust-spreads-with-the-ebola-virus-in-congo",
    title: "Global Health and Education Watch: Mistrust Spreads With the Ebola Virus in Congo",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-05-global-health-and-education-watch-mistrust-spreads-with-the-ebola-virus-in-congo.jpg",
    date: "2026-06-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-world-first-vaccine-designed-by-artificial-intelligence",
    title: "Global Health and Education Watch: 'World-first' vaccine designed by artificial intelligence",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-05-global-health-and-education-watch-world-first-vaccine-designed-by-artificial-int.jpg",
    date: "2026-06-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-africa-cdc-unveil-518m-ebola-plan-as-uganda",
    title: "Global Health and Education Watch: WHO, Africa CDC unveil $518m Ebola plan as Uganda",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-05-global-health-and-education-watch-who-africa-cdc-unveil-518m-ebola-plan-as-ugand.jpg",
    date: "2026-06-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ultra-processed-food-harms-tied-to-content-not-manufacture-review",
    title: "Global Health and Education Watch: Ultra-processed food harms tied to content not manufacture, review",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-05-global-health-and-education-watch-ultra-processed-food-harms-tied-to-content-not.jpg",
    date: "2026-06-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-experts-criticise-plan-for-american-only-ebola-quarantine-centre-in",
    title: "Global Health and Education Watch: Experts criticise plan for American-only Ebola quarantine centre in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-05-global-health-and-education-watch-experts-criticise-plan-for-american-only-ebola.jpg",
    date: "2026-06-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-family-of-girl-left-brain-damaged-at-birth-accept-28m",
    title: "Global Health and Education Watch: Family of girl left brain-damaged at birth accept £28m",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-05-global-health-and-education-watch-family-of-girl-left-brain-damaged-at-birth-acc.jpg",
    date: "2026-06-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-from-the-field-in-crisis-hit-middle-east-renewables-power",
    title: "Global Health and Education Watch: From the Field: In crisis-hit Middle East, renewables power",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-05-global-health-and-education-watch-from-the-field-in-crisis-hit-middle-east-renew.jpg",
    date: "2026-06-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-teachers-are-going-to-hate-it-how-social-media",
    title: "Global Health and Education Watch: ‘Teachers Are Going to Hate It’: How Social Media",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-04-global-health-and-education-watch-teachers-are-going-to-hate-it-how-social-media.jpg",
    date: "2026-06-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-falling-pupil-numbers-should-lead-to-smaller-class-sizes",
    title: "Global Health and Education Watch: Falling pupil numbers should lead to smaller class sizes",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-04-global-health-and-education-watch-falling-pupil-numbers-should-lead-to-smaller-c.jpg",
    date: "2026-06-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-pro-palestinian-badges-should-not-be-worn-by-nhs-staff",
    title: "Global Health and Education Watch: Pro-Palestinian badges should not be worn by NHS staff",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-04-global-health-and-education-watch-pro-palestinian-badges-should-not-be-worn-by-n.jpg",
    date: "2026-06-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-spreads-to-new-areas-of-dr-congo-as",
    title: "Global Health and Education Watch: Ebola spreads to new areas of DR Congo as",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-04-global-health-and-education-watch-ebola-spreads-to-new-areas-of-dr-congo-as.jpg",
    date: "2026-06-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-unsafe-food-causes-866-million-illnesses-and-1-5-million",
    title: "Global Health and Education Watch: Unsafe food causes 866 million illnesses and 1.5 million",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-04-global-health-and-education-watch-unsafe-food-causes-866-million-illnesses-and-1.jpg",
    date: "2026-06-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-smartglasses-and-earpieces-may-worsen-exam-cheating-in-schools",
    title: "Global Health and Education Watch: Smartglasses and earpieces may worsen exam cheating in schools",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-04-global-health-and-education-watch-smartglasses-and-earpieces-may-worsen-exam-che.jpg",
    date: "2026-06-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-regional-health-agency-issues-measles-alert-for-world-cup",
    title: "Global Health and Education Watch: Regional health agency issues measles alert for World Cup",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-04-global-health-and-education-watch-regional-health-agency-issues-measles-alert-fo.jpg",
    date: "2026-06-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ballet-tech-gave-them-dance-now-they-give-back",
    title: "Global Health and Education Watch: Ballet Tech Gave Them Dance. Now They Give Back.",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-03-global-health-and-education-watch-ballet-tech-gave-them-dance-now-they-give-back.jpg",
    date: "2026-06-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-we-are-catching-up-who-chief-on-dr",
    title: "Global Health and Education Watch: ‘We are catching up’ – WHO chief on DR",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-03-global-health-and-education-watch-we-are-catching-up-who-chief-on-dr.jpg",
    date: "2026-06-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-don-t-be-too-kind-maternity-staff-used-offensive-terms",
    title: "Global Health and Education Watch: 'Don't be too kind': Maternity staff used offensive terms",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-03-global-health-and-education-watch-don-t-be-too-kind-maternity-staff-used-offensi.jpg",
    date: "2026-06-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-fire-at-new-delhi-hotel-kills-at-least-21",
    title: "Global Health and Education Watch: Fire at New Delhi hotel kills at least 21",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-03-global-health-and-education-watch-fire-at-new-delhi-hotel-kills-at-least-21.jpg",
    date: "2026-06-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-outbreak-stirs-familiar-grim-sense-of-foreboding",
    title: "Global Health and Education Watch: Ebola outbreak stirs familiar grim sense of foreboding",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-03-global-health-and-education-watch-ebola-outbreak-stirs-familiar-grim-sense-of-fo.jpg",
    date: "2026-06-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-students-and-graduates-share-your-views-on-going",
    title: "Global Health and Education Watch: UK students and graduates: share your views on going",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-03-global-health-and-education-watch-uk-students-and-graduates-share-your-views-on-.jpg",
    date: "2026-06-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-lebanon-hospital-strikes-impact-most-vulnerable-patients-warns-who",
    title: "Global Health and Education Watch: Lebanon hospital strikes impact most vulnerable patients, warns WHO",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-02-global-health-and-education-watch-lebanon-hospital-strikes-impact-most-vulnerabl.jpg",
    date: "2026-06-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-as-ebola-spreads-scientists-race-to-find-vaccines-and",
    title: "Global Health and Education Watch: As Ebola Spreads, Scientists Race to Find Vaccines and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-02-global-health-and-education-watch-as-ebola-spreads-scientists-race-to-find-vacci.jpg",
    date: "2026-06-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-rude-awakening-more-doctors-running-for-office-in",
    title: "Global Health and Education Watch: ‘A rude awakening’: more doctors running for office in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-02-global-health-and-education-watch-a-rude-awakening-more-doctors-running-for-offi.jpg",
    date: "2026-06-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-three-ebola-vaccines-in-development-amid-growing-outbreak-fears",
    title: "Global Health and Education Watch: Three Ebola vaccines in development amid growing outbreak fears",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-02-global-health-and-education-watch-three-ebola-vaccines-in-development-amid-growi.jpg",
    date: "2026-06-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-dr-congo-ebola-outbreak-nurses-discharged-after-full-recovery",
    title: "Global Health and Education Watch: DR Congo Ebola outbreak: Nurses discharged after full recovery",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-02-global-health-and-education-watch-dr-congo-ebola-outbreak-nurses-discharged-afte.jpg",
    date: "2026-06-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-midwives-want-to-make-childbirth-miraculous-so-what",
    title: "Global Health and Education Watch: Midwives want to make childbirth miraculous – so what",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-02-global-health-and-education-watch-midwives-want-to-make-childbirth-miraculous-so.jpg",
    date: "2026-06-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israeli-strike-damages-hospital-in-southern-lebanon",
    title: "Global Health and Education Watch: Israeli strike damages hospital in southern Lebanon",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-06-01-global-health-and-education-watch-israeli-strike-damages-hospital-in-southern-le.jpg",
    date: "2026-06-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ai-university-experiment-california-s-costly-chaos-in-higher-education",
    title: "AI University Experiment: California's Costly Chaos in Higher Education",
    summary:
      "California's ambitious $16.9 million initiative to integrate AI across its public university system has instead resulted in significant operational chaos and student discontent. This case study offers crucial insights for global educational institutions considering similar large-scale technological transformations.",
    thumbnailImage: "/images/global-news/2026/2026-06-01-ai-university-experiment-california-s-costly-chaos-in-higher-education.jpg",
    date: "2026-06-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "drc-who-forge-united-front-against-bundibugyo-ebola-outbreak",
    title: "DRC, WHO Forge United Front Against Bundibugyo Ebola Outbreak",
    summary:
      "The Democratic Republic of Congo and the World Health Organization have reaffirmed their robust partnership to tackle a rapidly evolving Ebola outbreak caused by the Bundibugyo virus. Joint efforts focus on intensified surveillance, patient care, and crucial community engagement to interrupt transmission and strengthen long-term health resilience.",
    thumbnailImage: "/images/global-news/2026/2026-06-01-drc-who-forge-united-front-against-bundibugyo-ebola-outbreak.jpg",
    date: "2026-06-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "notre-dame-report-uncovers-priest-abuse-exposing-global-institutional-failures-in-safeguarding-students",
    title: "Notre Dame Report Uncovers Priest Abuse, Exposing Global Institutional Failures in Safeguarding Students",
    summary:
      "A commissioned report found Notre Dame failed to adequately respond to sexual misconduct allegations against a priest, involving a 'weighing scheme.' This investigation underscores critical global lessons in institutional accountability and student safeguarding within educational settings.",
    thumbnailImage: "/images/global-news/2026/2026-05-31-notre-dame-report-uncovers-priest-abuse-exposing-global-institutional-failures-i.jpg",
    date: "2026-05-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-youth-disengagement-understanding-the-neet-challenge",
    title: "Global Youth Disengagement: Understanding the NEET Challenge",
    summary:
      "The phenomenon of young people Not in Education, Employment, or Training (NEET) represents a critical global challenge impacting socio-economic stability and individual well-being. Addressing this issue requires comprehensive strategies that span educational reform, economic opportunity, and robust social support systems.",
    thumbnailImage: "/images/global-news/2026/2026-05-31-global-youth-disengagement-understanding-the-neet-challenge.jpg",
    date: "2026-05-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-you-are-not-alone-who-chief-vows-to-stand",
    title: "Global Health and Education Watch: ‘You are not alone’: WHO chief vows to stand",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-31-global-health-and-education-watch-you-are-not-alone-who-chief-vows-to-stand.jpg",
    date: "2026-05-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-calls-for-community-cooperation-to-contain-ebola-outbreak",
    title: "Global Health and Education Watch: WHO calls for community cooperation to contain Ebola outbreak",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-31-global-health-and-education-watch-who-calls-for-community-cooperation-to-contain.jpg",
    date: "2026-05-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "who-hails-ebola-recoveries-amidst-challenging-outbreak-response",
    title: "WHO Hails Ebola Recoveries Amidst Challenging Outbreak Response",
    summary:
      "The World Health Organization has announced the recovery of five Ebola patients, offering a beacon of hope amidst a recent outbreak that has tragically claimed over 220 suspected lives within two weeks. This development underscores the critical importance of rapid response and effective medical interventions in containing the highly contagious disease.",
    thumbnailImage: "/images/global-news/2026/2026-05-31-who-hails-ebola-recoveries-amidst-challenging-outbreak-response.jpg",
    date: "2026-05-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-cancer-workforce-crisis-looms-100-million-shortfall-by-2050",
    title: "Global Cancer Workforce Crisis Looms: 100 Million Shortfall by 2050",
    summary:
      "A dire report reveals the world faces a staggering 100 million healthcare staff shortfall by 2050, primarily impacting cancer care. This impending crisis threatens to overwhelm global healthcare systems, leading to severe delays in diagnosis and treatment for millions.",
    thumbnailImage: "/images/global-news/2026/2026-05-31-global-cancer-workforce-crisis-looms-100-million-shortfall-by-2050.jpg",
    date: "2026-05-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "rethinking-pcos-a-global-call-for-clarity-and-empowerment",
    title: "Rethinking PCOS: A Global Call for Clarity and Empowerment",
    summary:
      "Over 170 million women globally grapple with Polycystic Ovary Syndrome, a condition often misunderstood due to its misleading name. A growing movement advocates for renaming PCOS to better reflect its complex systemic nature and empower affected individuals worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-05-31-rethinking-pcos-a-global-call-for-clarity-and-empowerment.jpg",
    date: "2026-05-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-nigeria-s-algorithmic-apothecary-fuels-a-surge-in-risky",
    title: "Global Health and Education Watch: How Nigeria’s ‘algorithmic apothecary’ fuels a surge in risky",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-31-global-health-and-education-watch-how-nigeria-s-algorithmic-apothecary-fuels-a-s.jpg",
    date: "2026-05-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-seventy-ninth-world-health-assembly-daily-update-19-may",
    title: "Global Health and Education Watch: Seventy-ninth World Health Assembly – Daily update: 19 May",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-31-global-health-and-education-watch-seventy-ninth-world-health-assembly-daily-upda.jpg",
    date: "2026-05-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-china-s-rise-in-drug-development-looms-over-u-s",
    title: "Global Health and Education Watch: China’s Rise in Drug Development Looms Over U.S.",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-31-global-health-and-education-watch-china-s-rise-in-drug-development-looms-over-u-.jpg",
    date: "2026-05-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "inside-an-ebola-ward-a-glimpse-into-humanity-s-fight",
    title: "Inside an Ebola Ward: A Glimpse into Humanity's Fight",
    summary:
      "A recent report offers a stark look inside an Ebola treatment ward in an African region, where patients, including children, battle a deadly disease amid a rapidly escalating outbreak. The account highlights the immense challenges faced by healthcare workers and the profound human cost of the epidemic.",
    thumbnailImage: "/images/global-news/2026/2026-05-30-inside-an-ebola-ward-a-glimpse-into-humanity-s-fight.jpg",
    date: "2026-05-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-among-the-things-he-feared-most-was-death-the",
    title: "Global Health and Education Watch: ‘Among the things he feared most was death’: the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-30-global-health-and-education-watch-among-the-things-he-feared-most-was-death-the.jpg",
    date: "2026-05-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "healing-heights-rooftop-gardens-transform-intensive-care-recovery",
    title: "Healing Heights: Rooftop Gardens Transform Intensive Care Recovery",
    summary:
      "A groundbreaking initiative at King's College Hospital in London introduces a rooftop intensive care ward, allowing critically ill patients access to natural environments. This innovative approach aims to accelerate healing and improve mental well-being during prolonged hospital stays.",
    thumbnailImage: "/images/global-news/2026/2026-05-30-healing-heights-rooftop-gardens-transform-intensive-care-recovery.jpg",
    date: "2026-05-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "football-s-respite-kicking-hope-amidst-gaza-s-hardship",
    title: "Football's Respite: Kicking Hope Amidst Gaza's Hardship",
    summary:
      "In the shattered Occupied Palestinian Territory of Gaza, football matches organized by a former professional player are providing a crucial, albeit brief, respite from daily hardship. These games offer a vital sense of normalcy and joy for thousands living in overcrowded temporary shelters, fostering mental well-being and community cohesion.",
    thumbnailImage: "/images/global-news/2026/2026-05-30-football-s-respite-kicking-hope-amidst-gaza-s-hardship.jpg",
    date: "2026-05-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-chief-visits-bunia-epicentre-of-the-ebola-outbreak",
    title: "Global Health and Education Watch: WHO chief visits Bunia, epicentre of the Ebola outbreak",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-30-global-health-and-education-watch-who-chief-visits-bunia-epicentre-of-the-ebola-.jpg",
    date: "2026-05-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "aid-cuts-jeopardize-ebola-containment-in-drc-as-virus-spreads-regionally",
    title: "Aid Cuts Jeopardize Ebola Containment in DRC as Virus Spreads Regionally",
    summary:
      "A rapidly spreading Ebola outbreak in the Democratic Republic of Congo's Ituri province has claimed hundreds of lives and now threatens wider regional stability. Health workers warn that significant cuts in international aid are severely hampering containment efforts, making a prolonged crisis increasingly likely.",
    thumbnailImage: "/images/global-news/2026/2026-05-30-aid-cuts-jeopardize-ebola-containment-in-drc-as-virus-spreads-regionally.jpg",
    date: "2026-05-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-urges-governments-to-protect-young-people-from-addiction",
    title: "Global Health and Education Watch: WHO urges governments to protect young people from addiction",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-30-global-health-and-education-watch-who-urges-governments-to-protect-young-people-.jpg",
    date: "2026-05-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-implications-of-leader-health-after-presidential-checkup",
    title: "Global Implications of Leader Health After Presidential Checkup",
    summary:
      "The White House recently released the results of the US president's annual medical examination, confirming his excellent health and fitness for duty. This report reignites global conversations about the transparency of leaders' health and its profound impact on international governance and stability.",
    thumbnailImage: "/images/global-news/2026/2026-05-30-global-implications-of-leader-health-after-presidential-checkup.jpg",
    date: "2026-05-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "rwanda-russia-nuclear-pact-boosts-africa-s-health-education-future",
    title: "Rwanda-Russia Nuclear Pact Boosts Africa's Health, Education Future",
    summary:
      "Rwanda's recent nuclear deal with Russia signals a pivotal moment for scientific advancement and healthcare capacity building in Africa. The collaboration focuses on training and research, aiming to cultivate a skilled workforce and enhance medical technology across the region.",
    thumbnailImage: "/images/global-news/2026/2026-05-30-rwanda-russia-nuclear-pact-boosts-africa-s-health-education-future.jpg",
    date: "2026-05-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-classrooms-bake-climate-change-extends-heat-season-threatening-education",
    title: "Global Classrooms Bake: Climate Change Extends Heat Season, Threatening Education",
    summary:
      "Climate change is extending heat seasons globally, causing classrooms to become dangerously hot and disrupting academic calendars. This phenomenon threatens student health, impairs learning, and demands urgent, adaptive strategies for educational systems worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-05-30-global-classrooms-bake-climate-change-extends-heat-season-threatening-education.jpg",
    date: "2026-05-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "kenya-dorm-fire-kills-16-eight-students-arrested-in-tragic-blaze",
    title: "Kenya Dorm Fire Kills 16, Eight Students Arrested in Tragic Blaze",
    summary:
      "Sixteen students perished in a dormitory fire at a Kenyan school, leading to the arrest of eight students who may face charges next week. The tragedy has prompted a national inquiry into school safety standards and infrastructure.",
    thumbnailImage: "/images/global-news/2026/2026-05-29-kenya-dorm-fire-kills-16-eight-students-arrested-in-tragic-blaze.jpg",
    date: "2026-05-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-sunak-is-right-that-our-students-need-financial-literacy",
    title: "Global Health and Education Watch: Sunak is right that our students need financial literacy",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-29-global-health-and-education-watch-sunak-is-right-that-our-students-need-financia.jpg",
    date: "2026-05-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ebola-s-cruel-paradox-when-care-becomes-contagion-on-the-frontline",
    title: "Ebola's Cruel Paradox: When Care Becomes Contagion on the Frontline",
    summary:
      "A deadly Ebola outbreak grips the Democratic Republic of Congo, with the World Health Organization reporting over 900 suspected cases and more than 200 deaths. The crisis underscores the profound risks faced by those caring for the sick, transforming acts of compassion into pathways for contagion.",
    thumbnailImage: "/images/global-news/2026/2026-05-29-ebola-s-cruel-paradox-when-care-becomes-contagion-on-the-frontline.jpg",
    date: "2026-05-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-experts-convened-by-who-advise-on-candidate-treatments-and",
    title: "Global Health and Education Watch: Experts convened by WHO advise on candidate treatments and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-29-global-health-and-education-watch-experts-convened-by-who-advise-on-candidate-tr.jpg",
    date: "2026-05-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-i-forgot-what-it-s-like-to-be-outside-intensive",
    title: "Global Health and Education Watch: 'I forgot what it's like to be outside': Intensive",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-29-global-health-and-education-watch-i-forgot-what-it-s-like-to-be-outside-intensiv.jpg",
    date: "2026-05-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "gaza-s-silent-crisis-dental-health-forfeited-amidst-economic-desperation",
    title: "Gaza's Silent Crisis: Dental Health Forfeited Amidst Economic Desperation",
    summary:
      "In Gaza, families are increasingly forced to forgo critical dental treatment due to prohibitive costs and severe economic hardship. This difficult decision has profound and lasting negative impacts on public health, particularly among vulnerable children.",
    thumbnailImage: "/images/global-news/2026/2026-05-29-gaza-s-silent-crisis-dental-health-forfeited-amidst-economic-desperation.jpg",
    date: "2026-05-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-youth-crisis-disengagement-threatens-future-health-and-education",
    title: "Global Youth Crisis: Disengagement Threatens Future Health and Education",
    summary:
      "A growing global phenomenon sees millions of young people disengaged from education, employment, and training, raising alarms about a potential \"lost generation.\" This widespread issue threatens long-term societal health, educational progress, and economic stability across continents.",
    thumbnailImage: "/images/global-news/2026/2026-05-29-global-youth-crisis-disengagement-threatens-future-health-and-education.jpg",
    date: "2026-05-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-we-investigated-police-use-of-force-in-texas",
    title: "Global Health and Education Watch: How We Investigated Police Use of Force in Texas",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-28-global-health-and-education-watch-how-we-investigated-police-use-of-force-in-tex.jpg",
    date: "2026-05-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-message-by-the-who-director-general-to-the-people-of-2",
    title: "Global Health and Education Watch: Message by the WHO Director-General to the people of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-28-global-health-and-education-watch-message-by-the-who-director-general-to-the-peo.jpg",
    date: "2026-05-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "who-chief-urges-ceasefire-amidst-dr-congo-ebola-resurgence",
    title: "WHO Chief Urges Ceasefire Amidst DR Congo Ebola Resurgence",
    summary:
      "The Director-General of the World Health Organization traveled to the Democratic Republic of the Congo to address a severe Ebola resurgence in its conflict-ridden eastern provinces. He emphasized that a ceasefire is crucial for health workers to effectively contain the deadly virus amidst rampant instability.",
    thumbnailImage: "/images/global-news/2026/2026-05-28-who-chief-urges-ceasefire-amidst-dr-congo-ebola-resurgence.jpg",
    date: "2026-05-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-youth-crisis-a-generation-betrayed-by-systemic-neglect",
    title: "Global Youth Crisis: A Generation Betrayed by Systemic Neglect",
    summary:
      "A profound global crisis is marginalizing millions of young people, leaving them without adequate support in education, health, and employment. This systemic neglect demands a comprehensive, integrated international response to avert a deepening societal catastrophe.",
    thumbnailImage: "/images/global-news/2026/2026-05-28-global-youth-crisis-a-generation-betrayed-by-systemic-neglect.jpg",
    date: "2026-05-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "digital-exam-flaws-erode-trust-in-global-education",
    title: "Digital Exam Flaws Erode Trust in Global Education",
    summary:
      "Recent controversies surrounding India's Grade 12 examinations, including allegations of hacking and mismatched answer sheets, have cast a shadow over the integrity of digital evaluation. These issues underscore the global challenges in implementing reliable and secure large-scale educational assessment technologies.",
    thumbnailImage: "/images/global-news/2026/2026-05-28-digital-exam-flaws-erode-trust-in-global-education.jpg",
    date: "2026-05-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "dr-congo-ebola-fight-hampered-by-deep-mistrust-and-disinformation",
    title: "DR Congo Ebola Fight Hampered by Deep Mistrust and Disinformation",
    summary:
      "The ongoing Ebola outbreak in eastern DR Congo, the third-worst in history, faces severe challenges from widespread disinformation and community mistrust. These factors significantly impede public health efforts, delaying containment and increasing the risk of further spread.",
    thumbnailImage: "/images/global-news/2026/2026-05-28-dr-congo-ebola-fight-hampered-by-deep-mistrust-and-disinformation.jpg",
    date: "2026-05-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-aid-cuts-and-climate-change-drive-deadly-malaria-surge",
    title: "Global Health and Education Watch: Aid cuts and climate change drive deadly malaria surge",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-28-global-health-and-education-watch-aid-cuts-and-climate-change-drive-deadly-malar.jpg",
    date: "2026-05-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-educators-ponder-ai-and-screen-time-curbs-for-young-learners",
    title: "Global Educators Ponder AI and Screen Time Curbs for Young Learners",
    summary:
      "A prominent teachers' union has issued strong recommendations against screen time for young children and AI chatbot use in elementary schools. This move highlights growing global concerns about technology's impact on child development and learning.",
    thumbnailImage: "/images/global-news/2026/2026-05-27-global-educators-ponder-ai-and-screen-time-curbs-for-young-learners.jpg",
    date: "2026-05-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-youth-disengagement-crisis-looms-urgent-action-needed-to-avert-lost-generation",
    title: "Global Youth Disengagement Crisis Looms: Urgent Action Needed to Avert Lost Generation",
    summary:
      "A recent UK review highlights a potential 25% surge in young people not in employment, education, or training by the early 2030s, signaling a critical global challenge. This trend underscores the urgent need for comprehensive policy overhauls to prevent a widespread 'lost generation' across nations.",
    thumbnailImage: "/images/global-news/2026/2026-05-27-global-youth-disengagement-crisis-looms-urgent-action-needed-to-avert-lost-gener.jpg",
    date: "2026-05-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-outbreak-in-dr-congo-collides-with-conflict-and",
    title: "Global Health and Education Watch: Ebola outbreak in DR Congo collides with conflict and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-27-global-health-and-education-watch-ebola-outbreak-in-dr-congo-collides-with-confl.jpg",
    date: "2026-05-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "who-chief-urges-drc-ceasefire-amidst-escalating-ebola-crisis",
    title: "WHO Chief Urges DRC Ceasefire Amidst Escalating Ebola Crisis",
    summary:
      "The head of the World Health Organization has urgently called for an immediate ceasefire in eastern Democratic Republic of Congo to combat a rapidly escalating Ebola outbreak. This plea comes as Uganda closes its border, highlighting the severe regional implications of the health crisis compounded by ongoing conflict.",
    thumbnailImage: "/images/global-news/2026/2026-05-27-who-chief-urges-drc-ceasefire-amidst-escalating-ebola-crisis.jpg",
    date: "2026-05-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "climate-crisis-accelerates-global-antibiotic-resistance-posing-grave-health-threat",
    title: "Climate Crisis Accelerates Global Antibiotic Resistance, Posing Grave Health Threat",
    summary:
      "The climate crisis is significantly accelerating the global rise of antibiotic resistance, with experts linking it to a 10% increase in salmonella resistance genes. This escalating threat to human health now claims over a million lives annually, demanding urgent international attention.",
    thumbnailImage: "/images/global-news/2026/2026-05-27-climate-crisis-accelerates-global-antibiotic-resistance-posing-grave-health-thre.jpg",
    date: "2026-05-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-my-daughter-went-into-hospital-to-get-better",
    title: "Global Health and Education Watch: 'My daughter went into hospital to get better",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-27-global-health-and-education-watch-my-daughter-went-into-hospital-to-get-better.jpg",
    date: "2026-05-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-aviation-urged-to-uphold-ebola-safety-amidst-spreading-outbreak",
    title: "Global Aviation Urged to Uphold Ebola Safety Amidst Spreading Outbreak",
    summary:
      "A deadly Ebola strain continues its spread in the Democratic Republic of the Congo, with cases now confirmed in neighboring Uganda. The UN aviation agency is urging international governments and flight operators to strictly follow established post-COVID-19 pandemic safety guidelines.",
    thumbnailImage: "/images/global-news/2026/2026-05-27-global-aviation-urged-to-uphold-ebola-safety-amidst-spreading-outbreak.jpg",
    date: "2026-05-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "belgium-train-collision-claims-four-lives-including-two-children",
    title: "Belgium Train Collision Claims Four Lives, Including Two Children",
    summary:
      "A devastating train collision with a school van near Brussels resulted in four fatalities, including two children aged 12 and 15. The victims were students attending a special education institution, prompting urgent calls for enhanced transport safety.",
    thumbnailImage: "/images/global-news/2026/2026-05-26-belgium-train-collision-claims-four-lives-including-two-children.jpg",
    date: "2026-05-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-scotland-fans-book-20-school-buses-for-games-at",
    title: "Global Health and Education Watch: Scotland fans book 20 school buses for games at",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-26-global-health-and-education-watch-scotland-fans-book-20-school-buses-for-games-a.jpg",
    date: "2026-05-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "australia-s-first-diphtheria-death-in-decades-signals-global-health-warning",
    title: "Australia's First Diphtheria Death in Decades Signals Global Health Warning",
    summary:
      "Australia has recorded its first diphtheria death in decades amidst its worst outbreak in generations, highlighting a critical global health concern. This tragic event underscores the urgent need for robust vaccination programs and vigilance against vaccine-preventable diseases worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-05-26-australia-s-first-diphtheria-death-in-decades-signals-global-health-warning.jpg",
    date: "2026-05-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-strep-a-vaccine-gets-140mn-backing",
    title: "Global Health and Education Watch: Strep A vaccine gets $140mn backing",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-26-global-health-and-education-watch-strep-a-vaccine-gets-140mn-backing.jpg",
    date: "2026-05-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-curse-of-burnout-britain-affects-politicians-as-much",
    title: "Global Health and Education Watch: The curse of burnout Britain affects politicians as much",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-26-global-health-and-education-watch-the-curse-of-burnout-britain-affects-politicia.jpg",
    date: "2026-05-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ebola-outbreak-in-drc-outpaces-response-who-warns-global-health-crisis-looms",
    title: "Ebola Outbreak in DRC Outpaces Response, WHO Warns Global Health Crisis Looms",
    summary:
      "The World Health Organization warns the Ebola outbreak in the Democratic Republic of Congo is accelerating faster than containment efforts. Neighboring countries face an elevated risk, necessitating immediate, coordinated international intervention to prevent wider regional spread.",
    thumbnailImage: "/images/global-news/2026/2026-05-26-ebola-outbreak-in-drc-outpaces-response-who-warns-global-health-crisis-looms.jpg",
    date: "2026-05-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ebola-s-resurgence-in-drc-outpaces-containment-threatening-regional-stability",
    title: "Ebola's Resurgence in DRC Outpaces Containment, Threatening Regional Stability",
    summary:
      "The Democratic Republic of the Congo faces a rapidly escalating Ebola epidemic with over 900 suspected cases of the Bundibugyo strain and 220 suspected deaths. Containment efforts are struggling to keep pace with the virus's spread, prompting urgent calls for enhanced international support.",
    thumbnailImage: "/images/global-news/2026/2026-05-25-ebola-s-resurgence-in-drc-outpaces-containment-threatening-regional-stability.jpg",
    date: "2026-05-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-one-and-done-heart-disease-prevention-scientists-show-it-may-be",
    title: "Global Health and Education Watch: One-and-Done Heart Disease Prevention? Scientists Show It May Be",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-25-global-health-and-education-watch-one-and-done-heart-disease-prevention-scientis.jpg",
    date: "2026-05-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ebola-epidemic-escalates-who-chief-warns-of-crisis-outpacing-global-response",
    title: "Ebola Epidemic Escalates: WHO Chief Warns of Crisis Outpacing Global Response",
    summary:
      "The World Health Organization's chief warns that a rapidly escalating Ebola epidemic is outpacing current response efforts, with suspected deaths reaching 220. Delayed detection of cases means health responders are struggling to catch up, risking wider spread and greater loss of life.",
    thumbnailImage: "/images/global-news/2026/2026-05-25-ebola-epidemic-escalates-who-chief-warns-of-crisis-outpacing-global-response.jpg",
    date: "2026-05-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-childcare-costs-under-scrutiny-a-universal-challenge",
    title: "Global Childcare Costs Under Scrutiny: A Universal Challenge",
    summary:
      "An initiative in the UK to investigate hidden childcare costs highlights a pervasive global issue. Families worldwide face unexpected expenses that erode the benefits of government-funded early education and care programs.",
    thumbnailImage: "/images/global-news/2026/2026-05-25-global-childcare-costs-under-scrutiny-a-universal-challenge.jpg",
    date: "2026-05-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-seventy-ninth-world-health-assembly-daily-update-22-may",
    title: "Global Health and Education Watch: Seventy-ninth World Health Assembly – Daily update: 22 May",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-25-global-health-and-education-watch-seventy-ninth-world-health-assembly-daily-upda.jpg",
    date: "2026-05-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "europe-s-unexpected-firefighters-vineyards-truffles-and-honey",
    title: "Europe's Unexpected Firefighters: Vineyards, Truffles, and Honey",
    summary:
      "As climate change intensifies wildfire threats, European nations are discovering how specialized agriculture like viticulture, truffle cultivation, and apiculture can create natural firebreaks and resilient landscapes. These methods not only protect communities and ecosystems but also offer significant economic and health benefits.",
    thumbnailImage: "/images/global-news/2026/2026-05-25-europe-s-unexpected-firefighters-vineyards-truffles-and-honey.jpg",
    date: "2026-05-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "us-voters-strongly-back-global-hiv-aids-relief-amidst-midterm-stakes",
    title: "US Voters Strongly Back Global HIV/AIDS Relief Amidst Midterm Stakes",
    summary:
      "A recent poll indicates strong US voter support for the global HIV/AIDS relief program, PEPFAR, which also fortifies health systems against other threats. This widespread public backing could significantly influence the upcoming US midterm elections, as voters favor candidates who champion the initiative.",
    thumbnailImage: "/images/global-news/2026/2026-05-25-us-voters-strongly-back-global-hiv-aids-relief-amidst-midterm-stakes.jpg",
    date: "2026-05-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "who-chief-urges-urgent-global-action-on-ebola-pandemic-preparedness",
    title: "WHO Chief Urges Urgent Global Action on Ebola, Pandemic Preparedness",
    summary:
      "The head of the World Health Organization has issued a stark warning regarding global vulnerability to rapidly spreading infectious diseases, citing recent Ebola and hantavirus outbreaks. He emphasized the critical need for urgent action and sustained investment in pandemic preparedness and response mechanisms worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-05-25-who-chief-urges-urgent-global-action-on-ebola-pandemic-preparedness.jpg",
    date: "2026-05-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "dr-congo-ebola-crisis-deepens-amidst-rising-cases-and-health-worker-attacks",
    title: "DR Congo Ebola Crisis Deepens Amidst Rising Cases and Health Worker Attacks",
    summary:
      "The Democratic Republic of Congo is grappling with a severe Ebola outbreak, with over 900 suspected cases reported in the country's eastern region. Health workers face escalating attacks and critical resource shortages, complicating containment efforts and posing a significant challenge to public health.",
    thumbnailImage: "/images/global-news/2026/2026-05-24-dr-congo-ebola-crisis-deepens-amidst-rising-cases-and-health-worker-attacks.jpg",
    date: "2026-05-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ebola-spreads-to-uganda-escalating-drc-outbreak-crisis",
    title: "Ebola Spreads to Uganda, Escalating DRC Outbreak Crisis",
    summary:
      "The Ebola outbreak in eastern Democratic Republic of Congo has escalated with confirmed cases now reported in neighboring Uganda. This cross-border spread highlights the urgent need for intensified regional and international cooperation to contain the deadly virus.",
    thumbnailImage: "/images/global-news/2026/2026-05-24-ebola-spreads-to-uganda-escalating-drc-outbreak-crisis.jpg",
    date: "2026-05-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "breakthrough-hope-for-pre-eclampsia-a-global-health-imperative",
    title: "Breakthrough Hope for Pre-eclampsia: A Global Health Imperative",
    summary:
      "Pre-eclampsia tragically claims over 70,000 maternal lives annually across the globe, underscoring an urgent need for effective interventions. Emerging research into a potential new treatment offers a beacon of hope for improving maternal and infant health outcomes.",
    thumbnailImage: "/images/global-news/2026/2026-05-24-breakthrough-hope-for-pre-eclampsia-a-global-health-imperative.jpg",
    date: "2026-05-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-seventy-ninth-world-health-assembly-daily-update-23-may",
    title: "Global Health and Education Watch: Seventy-ninth World Health Assembly – Daily update: 23 May",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-24-global-health-and-education-watch-seventy-ninth-world-health-assembly-daily-upda.jpg",
    date: "2026-05-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-u-s-ebola-travel-ban-faces-criticism-from-congo-health",
    title: "Global Health and Education Watch: U.S. Ebola Travel Ban Faces Criticism From Congo Health",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-24-global-health-and-education-watch-u-s-ebola-travel-ban-faces-criticism-from-cong.jpg",
    date: "2026-05-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-alarm-us-absence-feared-amidst-central-african-ebola-resurgence",
    title: "Global Health Alarm: US Absence Feared Amidst Central African Ebola Resurgence",
    summary:
      "An undetected Ebola outbreak, involving the rare Bundibugyo variant, is spreading across central Africa, particularly in the Democratic Republic of Congo. Experts warn of a critical lack of US engagement and support, following significant cuts to global public health initiatives and vital scientific research.",
    thumbnailImage: "/images/global-news/2026/2026-05-24-global-health-alarm-us-absence-feared-amidst-central-african-ebola-resurgence.jpg",
    date: "2026-05-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "from-kharkiv-s-echoes-to-uk-s-health-service-a-doctor-s-resilient-journey",
    title: "From Kharkiv's Echoes to UK's Health Service: A Doctor's Resilient Journey",
    summary:
      "Dr. Inna Soldatenko, a Ukrainian physician, escaped the 2022 conflict in Kharkiv and has since established a new life and career within the United Kingdom's health system. Her journey highlights the profound resilience of displaced professionals contributing vital skills to their new communities while inspiring others.",
    thumbnailImage: "/images/global-news/2026/2026-05-23-from-kharkiv-s-echoes-to-uk-s-health-service-a-doctor-s-resilient-journey.jpg",
    date: "2026-05-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-women-cycle-syncing-their-workflow",
    title: "Global Health and Education Watch: The women ‘cycle syncing’ their workflow",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-23-global-health-and-education-watch-the-women-cycle-syncing-their-workflow.jpg",
    date: "2026-05-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "measles-outbreak-claims-over-500-children-in-bangladesh-igniting-global-health-concerns",
    title: "Measles Outbreak Claims Over 500 Children in Bangladesh, Igniting Global Health Concerns",
    summary:
      "A devastating measles outbreak in Bangladesh has claimed the lives of over 500 children, primarily those aged six months to five years. This tragedy underscores persistent vulnerabilities in global health systems and the critical importance of widespread immunization.",
    thumbnailImage: "/images/global-news/2026/2026-05-23-measles-outbreak-claims-over-500-children-in-bangladesh-igniting-global-health-c.jpg",
    date: "2026-05-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "uk-scientists-near-trials-for-bundibugyo-ebola-vaccine",
    title: "UK Scientists Near Trials for Bundibugyo Ebola Vaccine",
    summary:
      "UK scientists are on the verge of clinical trials for a new vaccine specifically designed to combat the Bundibugyo strain of Ebola, a variant responsible for a third of infections. This development marks a significant step towards global health security, addressing a strain for which no proven vaccine currently exists.",
    thumbnailImage: "/images/global-news/2026/2026-05-23-uk-scientists-near-trials-for-bundibugyo-ebola-vaccine.jpg",
    date: "2026-05-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ebola-bundibugyo-declared-global-health-emergency-in-drc-uganda",
    title: "Ebola Bundibugyo Declared Global Health Emergency in DRC, Uganda",
    summary:
      "The WHO has declared an Ebola Bundibugyo outbreak in the Democratic Republic of the Congo and Uganda a Public Health Emergency of International Concern (PHEIC). This critical designation triggers heightened global vigilance and coordinated international response efforts to contain the deadly virus.",
    thumbnailImage: "/images/global-news/2026/2026-05-23-ebola-bundibugyo-declared-global-health-emergency-in-drc-uganda.jpg",
    date: "2026-05-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-autism-therapy-boom-ethical-concerns-emerge-amidst-financial-pressures",
    title: "Global Autism Therapy Boom: Ethical Concerns Emerge Amidst Financial Pressures",
    summary:
      "The global surge in autism therapy clinics, while expanding access, has introduced significant financial pressures, leading to concerns about overbilling and potential harm. Public health systems worldwide face increasing strain as the industry's focus on revenue can overshadow the ethical delivery of crucial services to preschoolers.",
    thumbnailImage: "/images/global-news/2026/2026-05-23-global-autism-therapy-boom-ethical-concerns-emerge-amidst-financial-pressures.jpg",
    date: "2026-05-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-concerns-mount-over-diminishing-investment-in-primary-school-sports-programs",
    title: "Global Concerns Mount Over Diminishing Investment in Primary School Sports Programs",
    summary:
      "Recent policy changes in a major developed economy signal a significant reduction in funding for primary school sports initiatives. This move raises global concerns about the long-term implications for child health, physical literacy, and comprehensive educational development.",
    thumbnailImage: "/images/global-news/2026/2026-05-23-global-concerns-mount-over-diminishing-investment-in-primary-school-sports-progr.jpg",
    date: "2026-05-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-risk-very-high-in-eastern-dr-congo-as",
    title: "Global Health and Education Watch: Ebola risk ‘very high’ in eastern DR Congo as",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-23-global-health-and-education-watch-ebola-risk-very-high-in-eastern-dr-congo-as.jpg",
    date: "2026-05-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-britons-use-overseas-clinics-to-pick-babies-sex",
    title: "Global Health and Education Watch: Britons use overseas clinics to pick babies’ sex",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-23-global-health-and-education-watch-britons-use-overseas-clinics-to-pick-babies-se.jpg",
    date: "2026-05-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-outbreak-disrupts-life-along-the-drc-uganda-border",
    title: "Global Health and Education Watch: Ebola outbreak disrupts life along the DRC-Uganda border",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-23-global-health-and-education-watch-ebola-outbreak-disrupts-life-along-the-drc-uga.jpg",
    date: "2026-05-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-leaders-chart-future-course-at-world-health-assembly",
    title: "Global Health Leaders Chart Future Course at World Health Assembly",
    summary:
      "The Seventy-ninth World Health Assembly concluded its 20 May session with robust discussions on pressing global health priorities. Member states deliberated on strategies to strengthen health systems, enhance pandemic preparedness, and advance universal health coverage worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-05-22-global-health-leaders-chart-future-course-at-world-health-assembly.jpg",
    date: "2026-05-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ebola-risk-escalates-to-very-high-in-dr-congo-amid-regional-concerns",
    title: "Ebola Risk Escalates to 'Very High' in DR Congo Amid Regional Concerns",
    summary:
      "The Democratic Republic of Congo faces a 'very high' Ebola risk, according to the UN health agency. While the wider region is at 'high' risk, global concern remains 'low' due to robust preparedness measures.",
    thumbnailImage: "/images/global-news/2026/2026-05-22-ebola-risk-escalates-to-very-high-in-dr-congo-amid-regional-concerns.jpg",
    date: "2026-05-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-deadly-measles-outbreak-sickens-thousands-of-children-in-bangladesh",
    title: "Global Health and Education Watch: Deadly Measles Outbreak Sickens Thousands of Children in Bangladesh",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-22-global-health-and-education-watch-deadly-measles-outbreak-sickens-thousands-of-c.jpg",
    date: "2026-05-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "meta-settles-landmark-social-media-addiction-lawsuit-sparking-global-accountability-debate",
    title: "Meta Settles Landmark Social Media Addiction Lawsuit, Sparking Global Accountability Debate",
    summary:
      "Meta has reached a significant settlement with a Kentucky school district regarding claims that its social platforms are designed to be addictive, harming children's mental health. This resolution, following similar agreements by TikTok, Snap, and YouTube, underscores growing global scrutiny on tech companies' impact on youth well-being and education.",
    thumbnailImage: "/images/global-news/2026/2026-05-22-meta-settles-landmark-social-media-addiction-lawsuit-sparking-global-accountabil.jpg",
    date: "2026-05-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-crisis-looms-as-who-assembly-confronts-ebola-hantavirus",
    title: "Global Health Crisis Looms as WHO Assembly Confronts Ebola, Hantavirus",
    summary:
      "The World Health Organization's annual assembly convened amidst urgent global health crises, including active Ebola outbreaks and a hantavirus-stricken cruise ship. Delegates grappled with the dual challenges of escalating disease threats and critical funding shortfalls, compounded by geopolitical complexities.",
    thumbnailImage: "/images/global-news/2026/2026-05-22-global-health-crisis-looms-as-who-assembly-confronts-ebola-hantavirus.jpg",
    date: "2026-05-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-big-europe-and-asian-private-equity-health-funds-merge",
    title: "Global Health and Education Watch: Big Europe and Asian private equity health funds merge",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-22-global-health-and-education-watch-big-europe-and-asian-private-equity-health-fun.jpg",
    date: "2026-05-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "arson-at-drc-ebola-hospital-undermines-global-health-security",
    title: "Arson at DRC Ebola Hospital Undermines Global Health Security",
    summary:
      "An Ebola treatment facility in the Democratic Republic of Congo was deliberately set ablaze by protesters, marking a severe setback in efforts to control a burgeoning outbreak. This act underscores the critical challenges of community mistrust and misinformation in global health emergencies.",
    thumbnailImage: "/images/global-news/2026/2026-05-22-arson-at-drc-ebola-hospital-undermines-global-health-security.jpg",
    date: "2026-05-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-leaders-convene-at-wha-to-tackle-pandemics-uhc-and-climate-crisis",
    title: "Global Health Leaders Convene at WHA to Tackle Pandemics, UHC, and Climate Crisis",
    summary:
      "The 79th World Health Assembly on May 21, 2026, focused on strengthening global health security, advancing universal health coverage, and addressing climate change impacts. Member states deliberated on equitable access to care, pandemic preparedness, and sustainable health financing for a healthier future.",
    thumbnailImage: "/images/global-news/2026/2026-05-22-global-health-leaders-convene-at-wha-to-tackle-pandemics-uhc-and-climate-crisis.jpg",
    date: "2026-05-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-gonorrhoea-and-syphilis-hit-record-levels-in-europe",
    title: "Global Health and Education Watch: Gonorrhoea and syphilis hit record levels in Europe",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-21-global-health-and-education-watch-gonorrhoea-and-syphilis-hit-record-levels-in-e.jpg",
    date: "2026-05-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-u-s-adds-security-measures-at-dulles-to-receive-citizens",
    title: "Global Health and Education Watch: U.S. Adds Security Measures at Dulles to Receive Citizens",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-21-global-health-and-education-watch-u-s-adds-security-measures-at-dulles-to-receiv.jpg",
    date: "2026-05-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "children-at-climate-crisis-forefront-a-global-health-imperative",
    title: "Children at Climate Crisis Forefront: A Global Health Imperative",
    summary:
      "The climate crisis demands recognition as a global public health emergency, with children positioned at the absolute forefront of any effective response. Early life disruptions from climate change profoundly affect child nutrition, learning, and physical and mental health, threatening decades of global progress.",
    thumbnailImage: "/images/global-news/2026/2026-05-21-children-at-climate-crisis-forefront-a-global-health-imperative.jpg",
    date: "2026-05-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ebola-s-front-line-communities-key-to-halting-rare-strain-outbreak",
    title: "Ebola's Front Line: Communities Key to Halting Rare Strain Outbreak",
    summary:
      "A rare and aggressive Ebola strain is challenging health authorities in Eastern Democratic Republic of Congo and Uganda. The World Health Organization is implementing a swift, community-centered strategy to contain the outbreak and prevent wider transmission.",
    thumbnailImage: "/images/global-news/2026/2026-05-21-ebola-s-front-line-communities-key-to-halting-rare-strain-outbreak.jpg",
    date: "2026-05-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "delayed-ebola-detection-in-dr-congo-exposes-global-health-fragility",
    title: "Delayed Ebola Detection in DR Congo Exposes Global Health Fragility",
    summary:
      "An Ebola outbreak in the Democratic Republic of Congo went undetected for weeks, highlighting severe breakdowns in reporting and weak health systems. This alarming delay in a conflict-affected area poses significant global health security risks.",
    thumbnailImage: "/images/global-news/2026/2026-05-21-delayed-ebola-detection-in-dr-congo-exposes-global-health-fragility.jpg",
    date: "2026-05-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-mental-health-crisis-one-in-eight-lives-with-a-disorder-suicide-a-constant-threat",
    title: "Global Mental Health Crisis: One in Eight Lives with a Disorder, Suicide a Constant Threat",
    summary:
      "A recent report indicates that nearly one in eight individuals globally lives with a mental disorder. Alarmingly, a life is lost to suicide every 43 seconds, underscoring the profound human cost of these conditions.",
    thumbnailImage: "/images/global-news/2026/2026-05-21-global-mental-health-crisis-one-in-eight-lives-with-a-disorder-suicide-a-constan.jpg",
    date: "2026-05-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-seventy-ninth-world-health-assembly-honours-global-champions-advancing-primary",
    title: "Global Health and Education Watch: Seventy-ninth World Health Assembly honours global champions advancing primary",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-21-global-health-and-education-watch-seventy-ninth-world-health-assembly-honours-gl.jpg",
    date: "2026-05-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "meningitis-cluster-highlights-global-public-health-vigilance",
    title: "Meningitis Cluster Highlights Global Public Health Vigilance",
    summary:
      "A recent cluster of Meningitis B cases has prompted heightened public health awareness, emphasizing the ongoing global challenge of infectious disease management. This incident highlights the critical importance of widespread vaccination and vigilant public health responses to safeguard communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-21-meningitis-cluster-highlights-global-public-health-vigilance.jpg",
    date: "2026-05-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-outbreak-is-unlikely-to-become-global-threat-w-h-o",
    title: "Global Health and Education Watch: Ebola Outbreak Is Unlikely to Become Global Threat, W.H.O",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-20-global-health-and-education-watch-ebola-outbreak-is-unlikely-to-become-global-th.jpg",
    date: "2026-05-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-doctor-who-contracted-ebola-in-drc-flown-to",
    title: "Global Health and Education Watch: US doctor who contracted Ebola in DRC flown to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-20-global-health-and-education-watch-us-doctor-who-contracted-ebola-in-drc-flown-to.jpg",
    date: "2026-05-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-risk-is-high-inside-dr-congo-but-it-s",
    title: "Global Health and Education Watch: Ebola risk is high inside DR Congo but it’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-20-global-health-and-education-watch-ebola-risk-is-high-inside-dr-congo-but-it-s.jpg",
    date: "2026-05-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-modelling-impacts-of-paediatric-amoxicillin-shortage-management-on-pneumococcal",
    title: "Global Health and Education Watch: Modelling impacts of paediatric amoxicillin shortage management on pneumococcal",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-20-global-health-and-education-watch-modelling-impacts-of-paediatric-amoxicillin-sh.jpg",
    date: "2026-05-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-fear-grips-eastern-dr-congo-amid-deadly-ebola-outbreak",
    title: "Global Health and Education Watch: Fear grips eastern DR Congo amid deadly Ebola outbreak",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-20-global-health-and-education-watch-fear-grips-eastern-dr-congo-amid-deadly-ebola-.jpg",
    date: "2026-05-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ebola-crisis-exposes-global-health-preparedness-gaps",
    title: "Ebola Crisis Exposes Global Health Preparedness Gaps",
    summary:
      "The recent Ebola outbreak has starkly revealed critical deficiencies in global pandemic preparedness. Reduced international aid and a growing political aversion to collaborative public health initiatives are undermining collective defenses worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-05-20-ebola-crisis-exposes-global-health-preparedness-gaps.jpg",
    date: "2026-05-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ebola-outbreak-feared-spreading-faster-in-central-africa-who-warns",
    title: "Ebola Outbreak Feared Spreading Faster in Central Africa, WHO Warns",
    summary:
      "A World Health Organization doctor warns that the Ebola outbreak in central Africa may be accelerating beyond initial estimates, with hundreds of suspected cases. Experts fear the true number of infections could be significantly higher, necessitating immediate and robust international intervention.",
    thumbnailImage: "/images/global-news/2026/2026-05-20-ebola-outbreak-feared-spreading-faster-in-central-africa-who-warns.jpg",
    date: "2026-05-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ebola-threatens-central-africa-who-warns-of-prolonged-outbreak",
    title: "Ebola Threatens Central Africa: WHO Warns of Prolonged Outbreak",
    summary:
      "A new Ebola outbreak in Central Africa poses a severe public health crisis, with the World Health Organization warning it could persist for months. Over 130 suspected deaths and 540 cases have been reported in the Democratic Republic of Congo and Uganda, though experts believe the true figures are considerably higher.",
    thumbnailImage: "/images/global-news/2026/2026-05-19-ebola-threatens-central-africa-who-warns-of-prolonged-outbreak.jpg",
    date: "2026-05-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-rubio-criticizes-who-s-ebola-response-as-us-continues-sweeping",
    title: "Global Health and Education Watch: Rubio criticizes WHO’s Ebola response as US continues sweeping",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-19-global-health-and-education-watch-rubio-criticizes-who-s-ebola-response-as-us-co.jpg",
    date: "2026-05-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-drc-ebola-outbreak-hundreds-of-suspected-cases-no-vaccine",
    title: "Global Health and Education Watch: DRC Ebola outbreak: hundreds of suspected cases, no vaccine",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-19-global-health-and-education-watch-drc-ebola-outbreak-hundreds-of-suspected-cases.jpg",
    date: "2026-05-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "anticipating-respiratory-crises-a-new-global-early-warning-system",
    title: "Anticipating Respiratory Crises: A New Global Early Warning System",
    summary:
      "Researchers have developed an advanced real-time early warning system utilizing transfer learning to anticipate respiratory disease outbreaks globally. This innovative approach promises to revolutionize public health preparedness and response by providing crucial lead time for intervention.",
    thumbnailImage: "/images/global-news/2026/2026-05-19-anticipating-respiratory-crises-a-new-global-early-warning-system.jpg",
    date: "2026-05-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "gunmen-abduct-dozens-in-nigeria-school-attacks-sparking-global-concern",
    title: "Gunmen Abduct Dozens in Nigeria School Attacks, Sparking Global Concern",
    summary:
      "In a series of coordinated attacks, gunmen abducted 39 students and 7 teachers from schools in Nigeria, targeting children as young as two. These latest kidnappings underscore the escalating insecurity and profound challenges facing education and child safety across the region.",
    thumbnailImage: "/images/global-news/2026/2026-05-19-gunmen-abduct-dozens-in-nigeria-school-attacks-sparking-global-concern.jpg",
    date: "2026-05-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-emergency-ebola-outbreak-ignites-urgent-vaccine-race",
    title: "Global Health Emergency: Ebola Outbreak Ignites Urgent Vaccine Race",
    summary:
      "A virulent Ebola outbreak has prompted an international scramble for new vaccine solutions. World Health Organization experts are meeting to identify and recommend candidate jabs for immediate clinical trials.",
    thumbnailImage: "/images/global-news/2026/2026-05-19-global-health-emergency-ebola-outbreak-ignites-urgent-vaccine-race.jpg",
    date: "2026-05-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-director-general-presents-award-for-global-health-to-four-distinguished",
    title: "Global Health and Education Watch: Director-General presents Award for Global Health to four distinguished",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-19-global-health-and-education-watch-director-general-presents-award-for-global-hea.jpg",
    date: "2026-05-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-surge-in-childhood-anxiety-demands-urgent-attention",
    title: "Global Surge in Childhood Anxiety Demands Urgent Attention",
    summary:
      "Doctor's visits for children's anxiety have escalated by over 250 percent in a decade, according to a significant study involving nearly two million children. This alarming trend underscores a pervasive global challenge impacting the well-being of the younger generation.",
    thumbnailImage: "/images/global-news/2026/2026-05-18-global-surge-in-childhood-anxiety-demands-urgent-attention.jpg",
    date: "2026-05-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-call-to-action-integrating-arts-for-health-and-education",
    title: "Global Call to Action: Integrating Arts for Health and Education",
    summary:
      "Engaging with the arts offers significant benefits for mental health, cognitive development, and social cohesion across all age groups. Global advocates urge policymakers to prioritize creative opportunities, integrating them into education and public health strategies.",
    thumbnailImage: "/images/global-news/2026/2026-05-18-global-call-to-action-integrating-arts-for-health-and-education.jpg",
    date: "2026-05-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-outbreak-follows-hunger-and-displacement-crisis-in-dr",
    title: "Global Health and Education Watch: Ebola outbreak follows hunger and displacement crisis in DR",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-18-global-health-and-education-watch-ebola-outbreak-follows-hunger-and-displacement.jpg",
    date: "2026-05-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ebola-emergency-declared-global-health-security-under-renewed-threat",
    title: "Ebola Emergency Declared: Global Health Security Under Renewed Threat",
    summary:
      "The World Health Organization has declared the latest Ebola outbreak a Public Health Emergency of International Concern. This critical designation mobilizes global resources and mandates coordinated efforts to contain the virus and bolster future pandemic preparedness.",
    thumbnailImage: "/images/global-news/2026/2026-05-18-ebola-emergency-declared-global-health-security-under-renewed-threat.jpg",
    date: "2026-05-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-crisis-women-children-adolescents-face-breaking-point",
    title: "Global Health Crisis: Women, Children, Adolescents Face Breaking Point",
    summary:
      "A confluence of global crises—reduced aid, crippling debt, and widespread conflict—is severely undermining maternal and child health systems. This escalating emergency threatens to reverse decades of progress, demanding urgent international action to protect the world's most vulnerable populations.",
    thumbnailImage: "/images/global-news/2026/2026-05-18-global-health-crisis-women-children-adolescents-face-breaking-point.jpg",
    date: "2026-05-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-alarm-un-warns-of-escalating-violence-against-lgbtiq-communities",
    title: "Global Alarm: UN Warns of Escalating Violence Against LGBTIQ+ Communities",
    summary:
      "The United Nations human rights chief has issued a stark warning about the pervasive violence and discrimination faced by LGBTIQ+ individuals worldwide. This includes significant bullying in schools, which severely impacts youth, and broader systemic barriers to health and well-being.",
    thumbnailImage: "/images/global-news/2026/2026-05-18-global-alarm-un-warns-of-escalating-violence-against-lgbtiq-communities.jpg",
    date: "2026-05-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "meningitis-b-cases-spotlight-global-school-health-vigilance",
    title: "Meningitis B Cases Spotlight Global School Health Vigilance",
    summary:
      "Two pupils in Reading, UK, have been confirmed with Meningitis B, prompting public health action. This incident serves as a stark reminder of the persistent global threat posed by infectious diseases within school communities and the vital role of vaccination.",
    thumbnailImage: "/images/global-news/2026/2026-05-18-meningitis-b-cases-spotlight-global-school-health-vigilance.jpg",
    date: "2026-05-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-emergency-declared-as-ebola-claims-lives-in-democratic-republic-of-congo",
    title: "Global Health Emergency Declared as Ebola Claims Lives in Democratic Republic of Congo",
    summary:
      "The World Health Organization has declared a global health emergency after a recent Ebola outbreak claimed approximately 80 lives in the Democratic Republic of Congo. This critical declaration underscores the urgent need for international collaboration and robust public health interventions to contain the deadly virus.",
    thumbnailImage: "/images/global-news/2026/2026-05-18-global-health-emergency-declared-as-ebola-claims-lives-in-democratic-republic-of.jpg",
    date: "2026-05-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "dementia-s-ncd-status-a-global-health-paradigm-shift",
    title: "Dementia's NCD Status: A Global Health Paradigm Shift",
    summary:
      "The classification of dementia as a noncommunicable disease marks a pivotal moment in global health policy, promising increased focus and resources. This redefinition is expected to drive integrated public health strategies, enhanced research, and improved care worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-05-18-dementia-s-ncd-status-a-global-health-paradigm-shift.jpg",
    date: "2026-05-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "making-physical-activity-core-to-global-education-for-lifelong-health",
    title: "Making Physical Activity Core to Global Education for Lifelong Health",
    summary:
      "Integrating sport and physical activity into the heart of school life globally is essential for fostering lifelong healthy habits and holistic development. This demands significant structural changes and innovative approaches to ensure positive and inclusive experiences for all students.",
    thumbnailImage: "/images/global-news/2026/2026-05-17-making-physical-activity-core-to-global-education-for-lifelong-health.jpg",
    date: "2026-05-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "who-declares-ebola-outbreak-in-drc-and-uganda-a-global-health-emergency",
    title: "WHO Declares Ebola Outbreak in DRC and Uganda a Global Health Emergency",
    summary:
      "The World Health Organization has declared the Ebola outbreak in the Democratic Republic of Congo and Uganda a public health emergency of international concern. This decision follows over 80 reported deaths and hundreds of suspected cases, highlighting the urgent need for a coordinated global response.",
    thumbnailImage: "/images/global-news/2026/2026-05-17-who-declares-ebola-outbreak-in-drc-and-uganda-a-global-health-emergency.jpg",
    date: "2026-05-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ebola-s-resurgence-who-declares-global-emergency-in-dr-congo-uganda",
    title: "Ebola's Resurgence: WHO Declares Global Emergency in DR Congo, Uganda",
    summary:
      "The World Health Organization has declared the latest Ebola outbreak in the Democratic Republic of Congo and Uganda a global health emergency. This critical designation underscores the urgent need for international cooperation to contain the virus and prevent further regional and global spread.",
    thumbnailImage: "/images/global-news/2026/2026-05-17-ebola-s-resurgence-who-declares-global-emergency-in-dr-congo-uganda.jpg",
    date: "2026-05-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ebola-outbreak-in-central-africa-declared-a-public-health",
    title: "Global Health and Education Watch: Ebola outbreak in Central Africa declared a ‘Public Health",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-17-global-health-and-education-watch-ebola-outbreak-in-central-africa-declared-a-pu.jpg",
    date: "2026-05-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "university-insolvency-threatens-global-student-futures-demands-urgent-action",
    title: "University Insolvency Threatens Global Student Futures, Demands Urgent Action",
    summary:
      "A recent parliamentary committee report underscores the severe financial risks facing universities globally, calling for immediate governmental contingency planning. This looming crisis could jeopardize millions of students' education and financial investments if institutions fail.",
    thumbnailImage: "/images/global-news/2026/2026-05-17-university-insolvency-threatens-global-student-futures-demands-urgent-action.jpg",
    date: "2026-05-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "who-declares-ebola-outbreak-global-emergency-amidst-vaccine-gap",
    title: "WHO Declares Ebola Outbreak Global Emergency Amidst Vaccine Gap",
    summary:
      "The World Health Organization has declared the escalating Ebola outbreak a Public Health Emergency of International Concern, following confirmed cases in the Democratic Republic of Congo and Uganda. This critical declaration highlights the urgent need for a coordinated global response, especially given the absence of an approved vaccine for this particular Ebola strain.",
    thumbnailImage: "/images/global-news/2026/2026-05-17-who-declares-ebola-outbreak-global-emergency-amidst-vaccine-gap.jpg",
    date: "2026-05-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-declares-global-health-emergency-on-ebola",
    title: "Global Health and Education Watch: WHO declares global health emergency on Ebola",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-17-global-health-and-education-watch-who-declares-global-health-emergency-on-ebola.jpg",
    date: "2026-05-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "who-declares-ebola-outbreak-in-dr-congo-uganda-a-global-health-emergency",
    title: "WHO Declares Ebola Outbreak in DR Congo, Uganda a Global Health Emergency",
    summary:
      "The World Health Organization has declared the escalating Ebola outbreak spanning the Democratic Republic of Congo and Uganda a global health emergency. This critical designation aims to galvanize international resources and coordinated efforts to contain the deadly virus.",
    thumbnailImage: "/images/global-news/2026/2026-05-17-who-declares-ebola-outbreak-in-dr-congo-uganda-a-global-health-emergency.jpg",
    date: "2026-05-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ebola-outbreak-in-drc-uganda-declared-global-health-emergency",
    title: "Ebola Outbreak in DRC, Uganda Declared Global Health Emergency",
    summary:
      "The World Health Organization has declared an Ebola epidemic caused by the Bundibugyo virus in the Democratic Republic of the Congo and Uganda a Public Health Emergency of International Concern. This critical designation mobilizes global resources and coordination to contain the cross-border outbreak and prevent wider spread.",
    thumbnailImage: "/images/global-news/2026/2026-05-17-ebola-outbreak-in-drc-uganda-declared-global-health-emergency.jpg",
    date: "2026-05-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-hunger-crisis-deepens-millions-face-acute-malnutrition-in-somalia-and-dr-congo",
    title: "Global Hunger Crisis Deepens: Millions Face Acute Malnutrition in Somalia and DR Congo",
    summary:
      "Nearly six million people in Somalia are projected to face acute hunger, with 1.9 million at emergency levels, as a severe food crisis grips the nation. Simultaneously, a protracted humanitarian emergency continues to drive widespread hunger and health crises across the Democratic Republic of Congo, demanding immediate global attention and action.",
    thumbnailImage: "/images/global-news/2026/2026-05-17-global-hunger-crisis-deepens-millions-face-acute-malnutrition-in-somalia-and-dr-.jpg",
    date: "2026-05-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-new-cancer-test-makes-me-feel-women-s-health-matters",
    title: "Global Health and Education Watch: 'New cancer test makes me feel women's health matters'",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-17-global-health-and-education-watch-new-cancer-test-makes-me-feel-women-s-health-m.jpg",
    date: "2026-05-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "patagonia-s-hantavirus-battle-a-global-health-blueprint",
    title: "Patagonia's Hantavirus Battle: A Global Health Blueprint",
    summary:
      "The Hantavirus outbreak in Argentina's Patagonia region in 2018 prompted significant public health reforms, demonstrating the critical need for robust disease control measures. This regional experience offers invaluable insights for global strategies against emerging zoonotic threats and enhancing health security worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-05-17-patagonia-s-hantavirus-battle-a-global-health-blueprint.jpg",
    date: "2026-05-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "hantavirus-outbreak-on-antarctic-cruise-reignites-global-pandemic-concerns",
    title: "Hantavirus Outbreak on Antarctic Cruise Reignites Global Pandemic Concerns",
    summary:
      "The hantavirus outbreak aboard the MV Hondius during an Antarctic cruise triggered widespread alarm, reminding a world still recovering from Covid-19 of persistent zoonotic threats. For passengers and crew, the immediate danger was a terrifying reality in the isolated polar region.",
    thumbnailImage: "/images/global-news/2026/2026-05-17-hantavirus-outbreak-on-antarctic-cruise-reignites-global-pandemic-concerns.jpg",
    date: "2026-05-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-canada-confirms-first-hantavirus-case-in-isolation-in-british",
    title: "Global Health and Education Watch: Canada confirms first hantavirus case in isolation in British",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-16-global-health-and-education-watch-canada-confirms-first-hantavirus-case-in-isola.jpg",
    date: "2026-05-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-experts-urge-who-declare-climate-crisis-an-emergency",
    title: "Global Health Experts Urge WHO: Declare Climate Crisis an Emergency",
    summary:
      "Leading international experts are calling on the World Health Organization to declare the climate crisis a global public health emergency. Such a declaration would trigger a crucial coordinated international response, potentially saving millions of lives from escalating health threats.",
    thumbnailImage: "/images/global-news/2026/2026-05-16-global-health-experts-urge-who-declare-climate-crisis-an-emergency.jpg",
    date: "2026-05-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "drc-ebola-outbreak-high-lethality-rapid-spread-risk-amidst-population-movement",
    title: "DRC Ebola Outbreak: High Lethality, Rapid Spread Risk Amidst Population Movement",
    summary:
      "The Democratic Republic of Congo faces a severe Ebola outbreak with a very high lethality rate, as the death toll reaches 80. Concerns are mounting over the Bundibugyo strain's rapid spread potential, exacerbated by intense population movement across the region.",
    thumbnailImage: "/images/global-news/2026/2026-05-16-drc-ebola-outbreak-high-lethality-rapid-spread-risk-amidst-population-movement.jpg",
    date: "2026-05-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "sudan-s-hunger-crisis-deepens-millions-face-acute-food-shortages-amid-conflict",
    title: "Sudan's Hunger Crisis Deepens: Millions Face Acute Food Shortages Amid Conflict",
    summary:
      "Nearly 20 million people in Sudan are grappling with acute hunger, with over 800,000 children at severe malnutrition risk this year. Ongoing civil war, widespread displacement, and failing food and health systems are exacerbating one of the world’s gravest humanitarian crises, pushing regions closer to famine.",
    thumbnailImage: "/images/global-news/2026/2026-05-16-sudan-s-hunger-crisis-deepens-millions-face-acute-food-shortages-amid-conflict.jpg",
    date: "2026-05-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-after-three-years-of-conflict-sudan-faces-a-deeper-2",
    title: "Global Health and Education Watch: After three years of conflict, Sudan faces a deeper",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-16-global-health-and-education-watch-after-three-years-of-conflict-sudan-faces-a-de.jpg",
    date: "2026-05-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "unpacking-the-saltiest-meal-a-global-health-wake-up-call",
    title: "Unpacking the 'Saltiest' Meal: A Global Health Wake-Up Call",
    summary:
      "A health correspondent's experiment vividly demonstrated the profound immediate effects of consuming excessive dietary salt. This experience underscores the urgent global need to address high sodium intake and its widespread impact on public health.",
    thumbnailImage: "/images/global-news/2026/2026-05-16-unpacking-the-saltiest-meal-a-global-health-wake-up-call.jpg",
    date: "2026-05-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "congo-declares-major-ebola-outbreak-amid-concerns-over-delayed-announcement",
    title: "Congo Declares Major Ebola Outbreak Amid Concerns Over Delayed Announcement",
    summary:
      "The Democratic Republic of Congo has officially declared a significant Ebola outbreak, with an African health agency reporting dozens of fatalities and hundreds of suspected cases. This announcement has raised concerns among global health experts regarding the delay in public disclosure.",
    thumbnailImage: "/images/global-news/2026/2026-05-16-congo-declares-major-ebola-outbreak-amid-concerns-over-delayed-announcement.jpg",
    date: "2026-05-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "genomic-screening-s-ethical-crossroads-guiding-public-health-with-duty-based-principles",
    title: "Genomic Screening's Ethical Crossroads: Guiding Public Health with Duty-Based Principles",
    summary:
      "The global expansion of genomic-based public health screening programs necessitates a robust ethical framework. Duty-based ethics offers a critical guide for responsible implementation, emphasizing individual rights, equity, and data protection.",
    thumbnailImage: "/images/global-news/2026/2026-05-16-genomic-screening-s-ethical-crossroads-guiding-public-health-with-duty-based-pri.jpg",
    date: "2026-05-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-health-agency-names-two-schools-affected-by-berkshire-meningitis",
    title: "Global Health and Education Watch: Health agency names two schools affected by Berkshire meningitis",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-16-global-health-and-education-watch-health-agency-names-two-schools-affected-by-be.jpg",
    date: "2026-05-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-gunmen-kidnap-dozens-of-students-in-nigeria-s-borno-state",
    title: "Global Health and Education Watch: Gunmen kidnap dozens of students in Nigeria’s Borno State",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-16-global-health-and-education-watch-gunmen-kidnap-dozens-of-students-in-nigeria-s-.jpg",
    date: "2026-05-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "cuba-s-healthcare-system-grapples-with-crippling-blackouts-and-medicine-scarcity",
    title: "Cuba's Healthcare System Grapples with Crippling Blackouts and Medicine Scarcity",
    summary:
      "Hospitals across Cuba are facing an escalating healthcare crisis, marked by widespread blackouts and severe fuel shortages. UN officials have warned that these disruptions are forcing the suspension of critical surgeries and jeopardizing the operation of lifesaving medical equipment.",
    thumbnailImage: "/images/global-news/2026/2026-05-16-cuba-s-healthcare-system-grapples-with-crippling-blackouts-and-medicine-scarcity.jpg",
    date: "2026-05-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-warns-nicotine-pouch-brands-targeting-youth-as-sales",
    title: "Global Health and Education Watch: WHO warns nicotine pouch brands targeting youth as sales",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-16-global-health-and-education-watch-who-warns-nicotine-pouch-brands-targeting-yout.jpg",
    date: "2026-05-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-leadership-shifts-new-minister-faces-universal-challenges",
    title: "Global Health Leadership Shifts: New Minister Faces Universal Challenges",
    summary:
      "James Murray's appointment as health secretary highlights the universal challenges confronting health ministers globally. His tenure will be defined by efforts to address post-pandemic recovery, chronic diseases, and health equity.",
    thumbnailImage: "/images/global-news/2026/2026-05-16-global-health-leadership-shifts-new-minister-faces-universal-challenges.jpg",
    date: "2026-05-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cornell-criticizes-students-after-its-president-bumps-them-with",
    title: "Global Health and Education Watch: Cornell Criticizes Students After Its President Bumps Them With",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-15-global-health-and-education-watch-cornell-criticizes-students-after-its-presiden.jpg",
    date: "2026-05-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-briefing-chat-hantavirus-what-this-outbreak-reveals-about",
    title: "Global Health and Education Watch: Briefing Chat: Hantavirus — what this outbreak reveals about",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-15-global-health-and-education-watch-briefing-chat-hantavirus-what-this-outbreak-re.jpg",
    date: "2026-05-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-teens-getting-less-sleep-than-ever-new-report",
    title: "Global Health and Education Watch: US teens getting less sleep than ever, new report",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-15-global-health-and-education-watch-us-teens-getting-less-sleep-than-ever-new-repo.jpg",
    date: "2026-05-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "hantavirus-resurgence-global-health-preparedness-under-scrutiny",
    title: "Hantavirus Resurgence: Global Health Preparedness Under Scrutiny",
    summary:
      "Three fatalities from a hantavirus outbreak on a cruise ship have triggered global health alarms, prompting a reevaluation of pandemic preparedness. This incident underscores the persistent threat of zoonotic diseases and the critical need for robust surveillance and rapid response mechanisms worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-05-15-hantavirus-resurgence-global-health-preparedness-under-scrutiny.jpg",
    date: "2026-05-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-sounds-alarm-over-nicotine-pouches-targeting-young-people",
    title: "Global Health and Education Watch: WHO sounds alarm over nicotine pouches targeting young people",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-15-global-health-and-education-watch-who-sounds-alarm-over-nicotine-pouches-targeti.jpg",
    date: "2026-05-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-follow-up-message-by-the-who-director-general-to-the-people",
    title: "Global Health and Education Watch: Follow-up message by the WHO Director-General to the people",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-15-global-health-and-education-watch-follow-up-message-by-the-who-director-general-.jpg",
    date: "2026-05-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-are-the-symptoms-of-meningitis-and-is-there-2",
    title: "Global Health and Education Watch: What are the symptoms of meningitis and is there",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-15-global-health-and-education-watch-what-are-the-symptoms-of-meningitis-and-is-the.jpg",
    date: "2026-05-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-graduates-forge-resilience-amidst-turbulent-years-in-higher-education",
    title: "Global Graduates Forge Resilience Amidst Turbulent Years in Higher Education",
    summary:
      "University graduates globally are emerging from academic careers marked by significant political and social upheaval. Their journey underscores the critical role of higher education in fostering resilience and adaptability in a rapidly changing world.",
    thumbnailImage: "/images/global-news/2026/2026-05-15-global-graduates-forge-resilience-amidst-turbulent-years-in-higher-education.jpg",
    date: "2026-05-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "elevating-mental-health-research-a-global-imperative-for-visibility-and-impact",
    title: "Elevating Mental Health Research: A Global Imperative for Visibility and Impact",
    summary:
      "Mental health research globally suffers from critical invisibility, impeding progress against widespread conditions. Elevating its profile through increased funding, open science, and community engagement is essential for global well-being.",
    thumbnailImage: "/images/global-news/2026/2026-05-15-elevating-mental-health-research-a-global-imperative-for-visibility-and-impact.jpg",
    date: "2026-05-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "antidepressants-in-pregnancy-new-global-study-offers-reassurance-on-autism-adhd-risk",
    title: "Antidepressants in Pregnancy: New Global Study Offers Reassurance on Autism, ADHD Risk",
    summary:
      "A comprehensive global study involving over half a million pregnancies has found that antidepressant use during gestation does not increase a child's risk of developing autism or ADHD. The research suggests that any previously observed correlations were likely due to underlying maternal mental health conditions and genetic predispositions, offering significant reassurance to expectant mothers and clinicians worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-05-15-antidepressants-in-pregnancy-new-global-study-offers-reassurance-on-autism-adhd-.jpg",
    date: "2026-05-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-acute-hunger-grips-nearly-20-million-people-in-war-battered",
    title: "Global Health and Education Watch: Acute hunger grips nearly 20 million people in war-battered",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-14-global-health-and-education-watch-acute-hunger-grips-nearly-20-million-people-in.jpg",
    date: "2026-05-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-says-hantavirus-ship-operation-completed-monitoring-to-continue",
    title: "Global Health and Education Watch: WHO says hantavirus ship operation completed, monitoring to continue",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-14-global-health-and-education-watch-who-says-hantavirus-ship-operation-completed-m.jpg",
    date: "2026-05-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tunisia-validated-by-who-as-having-eliminated-trachoma-as",
    title: "Global Health and Education Watch: Tunisia validated by WHO as having eliminated trachoma as",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-14-global-health-and-education-watch-tunisia-validated-by-who-as-having-eliminated-.jpg",
    date: "2026-05-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-healthcare-systems-tackle-waiting-lists-amidst-efficiency-drives",
    title: "Global Healthcare Systems Tackle Waiting Lists Amidst Efficiency Drives",
    summary:
      "Healthcare systems globally are striving to reduce patient waiting times, a critical challenge impacting millions. England's recent achievement of an interim target for treating patients within 18 weeks highlights both progress and persistent obstacles in delivering equitable and timely care.",
    thumbnailImage: "/images/global-news/2026/2026-05-14-global-healthcare-systems-tackle-waiting-lists-amidst-efficiency-drives.jpg",
    date: "2026-05-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ucf-commencement-speaker-draws-boos-after-a-i-remarks",
    title: "Global Health and Education Watch: UCF Commencement Speaker Draws Boos After A.I. Remarks",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-14-global-health-and-education-watch-ucf-commencement-speaker-draws-boos-after-a-i-.jpg",
    date: "2026-05-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-for-three-years-i-scoured-the-world-for-answers",
    title: "Global Health and Education Watch: For three years I scoured the world for answers",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-14-global-health-and-education-watch-for-three-years-i-scoured-the-world-for-answer.jpg",
    date: "2026-05-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-data-and-knowledge-cross-level-fusion-driven-learning-framework-for",
    title: "Global Health and Education Watch: A data and knowledge cross-level fusion-driven learning framework for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-14-global-health-and-education-watch-a-data-and-knowledge-cross-level-fusion-driven.jpg",
    date: "2026-05-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-students-in-caracas-to-demand-release-of-political-prisoners",
    title: "Global Health and Education Watch: Students in Caracas to demand release of political prisoners",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-14-global-health-and-education-watch-students-in-caracas-to-demand-release-of-polit.jpg",
    date: "2026-05-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "hidden-salt-threat-global-lunch-choices-expose-unseen-health-risks",
    title: "Hidden Salt Threat: Global Lunch Choices Expose Unseen Health Risks",
    summary:
      "A recent analysis reveals that many popular convenience lunch options, such as sandwiches, contain dangerously high levels of sodium, often exceeding the salt content of multiple fast-food cheeseburgers. This hidden health risk underscores a critical global challenge in promoting healthier dietary choices and addressing non-communicable diseases.",
    thumbnailImage: "/images/global-news/2026/2026-05-14-hidden-salt-threat-global-lunch-choices-expose-unseen-health-risks.jpg",
    date: "2026-05-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "chad-s-refugee-crisis-overwhelms-eastern-maternity-care",
    title: "Chad’s Refugee Crisis Overwhelms Eastern Maternity Care",
    summary:
      "Eastern Chad's maternity care is severely strained by a worsening humanitarian crisis, forcing women to give birth in overcrowded clinics lacking essential resources. The UN reproductive health agency, UNFPA, highlights critical shortages of medicine, equipment, and anesthesia, jeopardizing maternal and infant lives.",
    thumbnailImage: "/images/global-news/2026/2026-05-14-chad-s-refugee-crisis-overwhelms-eastern-maternity-care.jpg",
    date: "2026-05-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "us-withholds-major-health-funding-amid-fraud-concerns",
    title: "US Withholds Major Health Funding Amid Fraud Concerns",
    summary:
      "The United States administration will withhold $1.3 billion in Medicaid payments from California, citing insufficient efforts to combat fraud. This decision highlights global challenges in maintaining fiscal integrity within large-scale public health insurance programs.",
    thumbnailImage: "/images/global-news/2026/2026-05-13-us-withholds-major-health-funding-amid-fraud-concerns.jpg",
    date: "2026-05-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-world-news-in-brief-mounting-waste-in-gaza-drone",
    title: "Global Health and Education Watch: World News in Brief: Mounting waste in Gaza, drone",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-13-global-health-and-education-watch-world-news-in-brief-mounting-waste-in-gaza-dro.jpg",
    date: "2026-05-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-alert-hantavirus-cruise-passengers-begin-home-isolation",
    title: "Global Health Alert: Hantavirus Cruise Passengers Begin Home Isolation",
    summary:
      "Six individuals from the MV Hondius cruise ship, implicated in a hantavirus outbreak, have been discharged from a UK hospital to continue their isolation at home. Health officials confirm they remain asymptomatic as they undertake a mandatory 45-day isolation period.",
    thumbnailImage: "/images/global-news/2026/2026-05-13-global-health-alert-hantavirus-cruise-passengers-begin-home-isolation.jpg",
    date: "2026-05-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-progress-falters-who-report-warns-of-reversal",
    title: "Global Health Progress Falters: WHO Report Warns of Reversal",
    summary:
      "A new WHO report reveals global health progress is stalling and even reversing in critical areas, threatening decades of advancements. Disparities in health outcomes are widening, demanding immediate and concerted international efforts.",
    thumbnailImage: "/images/global-news/2026/2026-05-13-global-health-progress-falters-who-report-warns-of-reversal.jpg",
    date: "2026-05-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-class-politics-of-modern-outbreaks",
    title: "Global Health and Education Watch: The class politics of modern outbreaks",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-13-global-health-and-education-watch-the-class-politics-of-modern-outbreaks.jpg",
    date: "2026-05-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "sydney-dental-clinic-prompts-global-health-warning",
    title: "Sydney Dental Clinic Prompts Global Health Warning",
    summary:
      "Australian health authorities have issued an urgent warning to patients of a Sydney dental clinic, advising them to undergo testing for viruses including HIV due to significant infection control failures. This incident underscores the critical importance of stringent health safety protocols in healthcare settings globally.",
    thumbnailImage: "/images/global-news/2026/2026-05-13-sydney-dental-clinic-prompts-global-health-warning.jpg",
    date: "2026-05-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-worried-should-we-be-about-hantavirus",
    title: "Global Health and Education Watch: How Worried Should We Be About Hantavirus?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-13-global-health-and-education-watch-how-worried-should-we-be-about-hantavirus.jpg",
    date: "2026-05-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "us-regulator-faces-scrutiny-over-alleged-vaccine-safety-data-suppression",
    title: "US Regulator Faces Scrutiny Over Alleged Vaccine Safety Data Suppression",
    summary:
      "The US Food and Drug Administration is under scrutiny following reports of alleged suppression of vaccine safety studies. This situation raises significant questions about transparency and the integrity of public health data dissemination worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-05-13-us-regulator-faces-scrutiny-over-alleged-vaccine-safety-data-suppression.jpg",
    date: "2026-05-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-from-childhood-to-university-economic-inequality-shapes-life-chances",
    title: "Global Health and Education Watch: From childhood to university, economic inequality shapes life chances",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-12-global-health-and-education-watch-from-childhood-to-university-economic-inequali.jpg",
    date: "2026-05-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-architecture-can-save-lives",
    title: "Global Health and Education Watch: How architecture can save lives",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-12-global-health-and-education-watch-how-architecture-can-save-lives.jpg",
    date: "2026-05-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "lebanon-s-education-crisis-deepens-war-threatens-a-generation",
    title: "Lebanon's Education Crisis Deepens: War Threatens a Generation",
    summary:
      "Israel's war on Lebanon has displaced hundreds of thousands, exacerbating an already fragile education system. This latest crisis threatens to create a \"lost generation\" of Lebanese students, impacting their future and the nation's stability.",
    thumbnailImage: "/images/global-news/2026/2026-05-12-lebanon-s-education-crisis-deepens-war-threatens-a-generation.jpg",
    date: "2026-05-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "pemphigus-unveiling-the-global-family-burden-of-chronic-disease",
    title: "Pemphigus: Unveiling the Global Family Burden of Chronic Disease",
    summary:
      "A recent cross-sectional survey sheds light on the significant, multifaceted burden pemphigus places on families globally. The findings underscore the critical need for comprehensive support systems extending beyond individual patient care.",
    thumbnailImage: "/images/global-news/2026/2026-05-12-pemphigus-unveiling-the-global-family-burden-of-chronic-disease.jpg",
    date: "2026-05-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "women-only-mental-health-sanctuaries-emerge-globally-as-hospital-alternatives",
    title: "Women-Only Mental Health Sanctuaries Emerge Globally as Hospital Alternatives",
    summary:
      "A pioneering women-only mental health crisis house is set to open, offering a vital alternative to traditional hospital care. This initiative highlights a growing global movement towards gender-specific, community-based mental health support.",
    thumbnailImage: "/images/global-news/2026/2026-05-12-women-only-mental-health-sanctuaries-emerge-globally-as-hospital-alternatives.jpg",
    date: "2026-05-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-progress-in-reducing-child-deaths-slows-as-4-9-million-3",
    title: "Global Health and Education Watch: Progress in reducing child deaths slows as 4.9 million",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-12-global-health-and-education-watch-progress-in-reducing-child-deaths-slows-as-4-9.jpg",
    date: "2026-05-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ai-for-good-transforming-global-health-and-education-through-intelligent-systems",
    title: "AI for Good: Transforming Global Health and Education Through Intelligent Systems",
    summary:
      "A new book highlights the global applications of artificial intelligence in advancing health and education. It explores how AI is moving beyond theoretical discussions to deliver tangible societal benefits.",
    thumbnailImage: "/images/global-news/2026/2026-05-12-ai-for-good-transforming-global-health-and-education-through-intelligent-systems.jpg",
    date: "2026-05-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hantavirus-hit-ship-evacuation-completed-as-quarantines-begin",
    title: "Global Health and Education Watch: Hantavirus-hit ship evacuation completed as quarantines begin",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-12-global-health-and-education-watch-hantavirus-hit-ship-evacuation-completed-as-qu.jpg",
    date: "2026-05-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-birmingham-city-university-urged-not-to-axe-black-studies",
    title: "Global Health and Education Watch: Birmingham City University urged not to axe Black studies",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-12-global-health-and-education-watch-birmingham-city-university-urged-not-to-axe-bl.jpg",
    date: "2026-05-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hundreds-displaced-medical-services-suspended-amid-gang-violence-in",
    title: "Global Health and Education Watch: Hundreds displaced, medical services suspended amid gang violence in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-12-global-health-and-education-watch-hundreds-displaced-medical-services-suspended-.jpg",
    date: "2026-05-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-monday-briefing-will-the-international-effort-to-stop-the",
    title: "Global Health and Education Watch: Monday briefing: Will the international effort to stop the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-11-global-health-and-education-watch-monday-briefing-will-the-international-effort-.jpg",
    date: "2026-05-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-hantavirus-outbreak-highlights-critical-gaps-in-disease-transmission-knowledge",
    title: "Global Hantavirus Outbreak Highlights Critical Gaps in Disease Transmission Knowledge",
    summary:
      "A recent global Hantavirus outbreak is challenging established understandings of disease transmission, revealing critical gaps in scientific knowledge. This event emphasizes the necessity for enhanced international research and robust public health strategies to combat emerging zoonotic threats.",
    thumbnailImage: "/images/global-news/2026/2026-05-11-global-hantavirus-outbreak-highlights-critical-gaps-in-disease-transmission-know.jpg",
    date: "2026-05-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-newcastle-s-burn-on-mental-health-and-importance-of-asking",
    title: "Global Health and Education Watch: Newcastle's Burn on mental health and importance of asking",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-11-global-health-and-education-watch-newcastle-s-burn-on-mental-health-and-importan.jpg",
    date: "2026-05-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-revival-cursive-writing-flourishes-beyond-classrooms",
    title: "Global Revival: Cursive Writing Flourishes Beyond Classrooms",
    summary:
      "Across the globe, after-school clubs and libraries are witnessing a resurgence in cursive writing instruction, filling a gap left by its removal from many formal curricula. This revival is fueled by a growing understanding of cursive's cognitive benefits for brain development, fine motor skills, and its role in cultural literacy.",
    thumbnailImage: "/images/global-news/2026/2026-05-11-global-revival-cursive-writing-flourishes-beyond-classrooms.jpg",
    date: "2026-05-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "from-death-row-to-new-life-a-story-of-rehabilitation-and-hope",
    title: "From Death Row to New Life: A Story of Rehabilitation and Hope",
    summary:
      "A Thai woman, once on death row for drug trafficking, found solace and a path to rehabilitation through learning to sew during her 20-year imprisonment. Her story underscores the transformative potential of vocational training and support for re-entry into society.",
    thumbnailImage: "/images/global-news/2026/2026-05-11-from-death-row-to-new-life-a-story-of-rehabilitation-and-hope.jpg",
    date: "2026-05-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-crises-disrupt-pregnancy-outcomes-a-call-for-resilient-systems",
    title: "Global Health Crises Disrupt Pregnancy Outcomes: A Call for Resilient Systems",
    summary:
      "A recent study reveals significant shifts in pregnancy outcomes during periods of major health system disruption, highlighting increased risks for mothers and newborns globally. This analysis calls for robust, adaptable healthcare infrastructures to safeguard maternal and child health during future crises.",
    thumbnailImage: "/images/global-news/2026/2026-05-11-global-health-crises-disrupt-pregnancy-outcomes-a-call-for-resilient-systems.jpg",
    date: "2026-05-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-push-for-equitable-women-s-health-addressing-historical-disparities",
    title: "Global Push for Equitable Women's Health: Addressing Historical Disparities",
    summary:
      "Across the globe, advocates are intensifying efforts to rectify long-standing inequities in women's healthcare provision. These initiatives aim to dismantle systemic barriers and ensure more responsive, comprehensive health services for all women.",
    thumbnailImage: "/images/global-news/2026/2026-05-11-global-push-for-equitable-women-s-health-addressing-historical-disparities.jpg",
    date: "2026-05-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "gaza-health-system-documentary-wins-bafta-spotlighting-crisis",
    title: "Gaza Health System Documentary Wins BAFTA, Spotlighting Crisis",
    summary:
      "A documentary revealing the severe impact on Gaza's health system and its dedicated personnel has been honored with a BAFTA for Best Current Affairs. This prestigious award brings critical global attention to the ongoing humanitarian crisis and the urgent need for protection of medical infrastructure and staff in conflict zones.",
    thumbnailImage: "/images/global-news/2026/2026-05-11-gaza-health-system-documentary-wins-bafta-spotlighting-crisis.jpg",
    date: "2026-05-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cruise-ship-linked-to-hantavirus-outbreak-arrives-in-spain-s",
    title: "Global Health and Education Watch: Cruise Ship Linked to Hantavirus Outbreak Arrives in Spain’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-11-global-health-and-education-watch-cruise-ship-linked-to-hantavirus-outbreak-arri.jpg",
    date: "2026-05-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-advocates-challenge-baby-formula-safety-claims",
    title: "Global Health Advocates Challenge Baby Formula Safety Claims",
    summary:
      "Independent scientists have challenged government claims of high safety standards for baby formula, revealing widespread contamination with dangerous chemicals like PFAS and phthalates. This discrepancy raises significant global health concerns for infant development and calls for greater transparency and stricter regulation.",
    thumbnailImage: "/images/global-news/2026/2026-05-10-global-health-advocates-challenge-baby-formula-safety-claims.jpg",
    date: "2026-05-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-dozens-of-people-from-cruise-ship-struck-by-hantavirus",
    title: "Global Health and Education Watch: Dozens of people from cruise ship struck by hantavirus",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-10-global-health-and-education-watch-dozens-of-people-from-cruise-ship-struck-by-ha.jpg",
    date: "2026-05-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "pregnancy-s-hidden-crisis-mental-illness-demands-global-attention",
    title: "Pregnancy's Hidden Crisis: Mental Illness Demands Global Attention",
    summary:
      "Mental illness is the most common complication of pregnancy and postpartum, often overlooked by healthcare providers. Integrated care, specialist support, and public awareness are crucial to prevent severe maternal health crises globally.",
    thumbnailImage: "/images/global-news/2026/2026-05-10-pregnancy-s-hidden-crisis-mental-illness-demands-global-attention.jpg",
    date: "2026-05-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-response-hantavirus-cruise-ship-disembarkation-in-tenerife",
    title: "Global Health Response: Hantavirus Cruise Ship Disembarkation in Tenerife",
    summary:
      "Passengers and crew from the MV Hondius cruise ship have begun disembarking in Tenerife following a hantavirus alert, managed by a coordinated international health operation. The World Health Organization has reassured the public, emphasizing that this outbreak does not pose a similar threat to the recent global pandemic.",
    thumbnailImage: "/images/global-news/2026/2026-05-10-global-health-response-hantavirus-cruise-ship-disembarkation-in-tenerife.jpg",
    date: "2026-05-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-guardian-view-on-the-who-pandemic-treaty-the",
    title: "Global Health and Education Watch: The Guardian view on the WHO pandemic treaty: the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-10-global-health-and-education-watch-the-guardian-view-on-the-who-pandemic-treaty-t.jpg",
    date: "2026-05-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-passengers-from-hantavirus-hit-cruise-begin-disembarking-ship",
    title: "Global Health and Education Watch: Passengers from Hantavirus-hit cruise begin disembarking ship",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-10-global-health-and-education-watch-passengers-from-hantavirus-hit-cruise-begin-di.jpg",
    date: "2026-05-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-education-grapples-with-ai-shaping-future-learning",
    title: "Global Education Grapples with AI: Shaping Future Learning",
    summary:
      "The integration of artificial intelligence into educational settings globally presents both opportunities and challenges for student learning and development. Educators are increasingly focusing on how students interact with AI tools to foster critical thinking rather than simply avoiding their use.",
    thumbnailImage: "/images/global-news/2026/2026-05-10-global-education-grapples-with-ai-shaping-future-learning.jpg",
    date: "2026-05-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ukraine-healthcare-under-siege-over-3-000-attacks-verified-since-invasion",
    title: "Ukraine Healthcare Under Siege: Over 3,000 Attacks Verified Since Invasion",
    summary:
      "Over 3,000 attacks on healthcare infrastructure and personnel have been verified in Ukraine since the full-scale Russian invasion began in February 2022. This alarming figure, reported by the World Health Organization, underscores a severe violation of international humanitarian law and a catastrophic impact on civilian health.",
    thumbnailImage: "/images/global-news/2026/2026-05-10-ukraine-healthcare-under-siege-over-3-000-attacks-verified-since-invasion.jpg",
    date: "2026-05-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-call-for-unity-health-and-science-unite-for-a-healthier-future",
    title: "Global Call for Unity: Health and Science Unite for a Healthier Future",
    summary:
      "The World Health Organization marks its anniversary with a global campaign, \"Together for health. Stand with science.\" This initiative calls for renewed worldwide commitment to collaborative action and scientific support as fundamental drivers for improving global health outcomes.",
    thumbnailImage: "/images/global-news/2026/2026-05-10-global-call-for-unity-health-and-science-unite-for-a-healthier-future.jpg",
    date: "2026-05-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-expected-to-fire-head-of-food-and-drug",
    title: "Global Health and Education Watch: Trump expected to fire head of Food and Drug",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-10-global-health-and-education-watch-trump-expected-to-fire-head-of-food-and-drug.jpg",
    date: "2026-05-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hantavirus-your-questions-answered",
    title: "Global Health and Education Watch: Hantavirus: Your questions answered",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-10-global-health-and-education-watch-hantavirus-your-questions-answered.jpg",
    date: "2026-05-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-my-husband-s-weight-loss-is-triggering-my-eating-disorders",
    title: "Global Health and Education Watch: My husband’s weight loss is triggering my eating disorders",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-10-global-health-and-education-watch-my-husband-s-weight-loss-is-triggering-my-eati.jpg",
    date: "2026-05-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "who-clarifies-hantavirus-outbreak-distinct-from-covid-19-pandemic-threat",
    title: "WHO Clarifies Hantavirus Outbreak Distinct from COVID-19 Pandemic Threat",
    summary:
      "The World Health Organization has clarified that the recent Hantavirus outbreak poses a different public health challenge than the COVID-19 pandemic. Experts highlight the virus's specific transmission routes and lower risk of widespread human-to-human spread.",
    thumbnailImage: "/images/global-news/2026/2026-05-10-who-clarifies-hantavirus-outbreak-distinct-from-covid-19-pandemic-threat.jpg",
    date: "2026-05-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-to-know-about-the-hantavirus-outbreak-on-an",
    title: "Global Health and Education Watch: What to Know About the Hantavirus Outbreak on an",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-10-global-health-and-education-watch-what-to-know-about-the-hantavirus-outbreak-on-.jpg",
    date: "2026-05-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-empty-and-vapid-cdc-finally-responds-to-hantavirus-outbreak",
    title: "Global Health and Education Watch: ‘Empty and vapid’ CDC finally responds to hantavirus outbreak",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-10-global-health-and-education-watch-empty-and-vapid-cdc-finally-responds-to-hantav.jpg",
    date: "2026-05-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-chief-heads-to-tenerife-to-oversee-sunday-arrival",
    title: "Global Health and Education Watch: WHO chief heads to Tenerife to oversee Sunday arrival",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-09-global-health-and-education-watch-who-chief-heads-to-tenerife-to-oversee-sunday-.jpg",
    date: "2026-05-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-message-by-the-who-director-general-to-the-people-of",
    title: "Global Health and Education Watch: Message by the WHO Director-General to the people of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-09-global-health-and-education-watch-message-by-the-who-director-general-to-the-peo.jpg",
    date: "2026-05-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hantavirus-vaccines-and-treatments-are-in-the-pipeline",
    title: "Global Health and Education Watch: Hantavirus Vaccines and Treatments Are in the Pipeline",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-09-global-health-and-education-watch-hantavirus-vaccines-and-treatments-are-in-the-.jpg",
    date: "2026-05-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "england-s-teacher-strike-vote-echoes-global-education-funding-crisis",
    title: "England's Teacher Strike Vote Echoes Global Education Funding Crisis",
    summary:
      "Teachers in England are preparing to vote on strike action over pay, signaling growing discontent within the education sector. This development underscores a broader global struggle to adequately compensate educators and maintain educational quality.",
    thumbnailImage: "/images/global-news/2026/2026-05-09-england-s-teacher-strike-vote-echoes-global-education-funding-crisis.jpg",
    date: "2026-05-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "education-endures-lebanese-children-learn-amidst-displacement-crisis",
    title: "Education Endures: Lebanese Children Learn Amidst Displacement Crisis",
    summary:
      "Amidst ongoing displacement in Lebanon, a school in Sidon has become a haven for families from the south, ensuring children can continue their education. This initiative highlights the critical importance of maintaining learning environments even in the face of profound adversity and instability.",
    thumbnailImage: "/images/global-news/2026/2026-05-09-education-endures-lebanese-children-learn-amidst-displacement-crisis.jpg",
    date: "2026-05-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tenerife-prepares-to-evacuate-hantavirus-cruise-ship",
    title: "Global Health and Education Watch: Tenerife prepares to evacuate hantavirus cruise ship",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-09-global-health-and-education-watch-tenerife-prepares-to-evacuate-hantavirus-cruis.jpg",
    date: "2026-05-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-people-should-be-talking-about-it-moves-to-curtail",
    title: "Global Health and Education Watch: ‘People should be talking about it’: moves to curtail",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-09-global-health-and-education-watch-people-should-be-talking-about-it-moves-to-cur.jpg",
    date: "2026-05-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-wider-hantavirus-outbreak-risk-is-absolutely-low-insists-un",
    title: "Global Health and Education Watch: Wider hantavirus outbreak risk is ‘absolutely low’, insists UN",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-09-global-health-and-education-watch-wider-hantavirus-outbreak-risk-is-absolutely-l.jpg",
    date: "2026-05-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-unites-who-forum-forges-stronger-scientific-collaboration-2",
    title: "Global Health Unites: WHO Forum Forges Stronger Scientific Collaboration",
    summary:
      "The World Health Organization convened its inaugural Global Forum of Collaborating Centres, bringing together a vast network of over 800 institutions from more than 80 countries. This landmark event aims to fortify scientific cooperation and enhance collective responses to pressing global health challenges.",
    thumbnailImage: "/images/global-news/2026/2026-05-09-global-health-unites-who-forum-forges-stronger-scientific-collaboration.jpg",
    date: "2026-05-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-breakthrough-air-sampling-revolutionizes-virus-surveillance",
    title: "Global Health Breakthrough: Air Sampling Revolutionizes Virus Surveillance",
    summary:
      "A groundbreaking study published in *Nature* demonstrates that indoor air sampling accurately tracks respiratory viruses, mirroring wastewater and clinical data. This innovation promises a transformative, non-invasive approach to global public health surveillance and early outbreak detection.",
    thumbnailImage: "/images/global-news/2026/2026-05-09-global-health-breakthrough-air-sampling-revolutionizes-virus-surveillance.jpg",
    date: "2026-05-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-initiative-stalled-green-school-playgrounds-face-funding-cuts",
    title: "Global Health Initiative Stalled: Green School Playgrounds Face Funding Cuts",
    summary:
      "A critical U.S. Environmental Protection Agency grant, focused on enhancing school playgrounds for children's health, was abruptly canceled. This setback underscores broader global challenges in securing sustained funding for vital environmental health and education initiatives.",
    thumbnailImage: "/images/global-news/2026/2026-05-09-global-health-initiative-stalled-green-school-playgrounds-face-funding-cuts.jpg",
    date: "2026-05-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "cambodian-children-s-education-shattered-by-border-conflict-displacement",
    title: "Cambodian Children's Education Shattered by Border Conflict Displacement",
    summary:
      "In Cambodia's volatile border regions, thousands of families remain displaced by past conflicts with Thailand, living under a tense ceasefire. The instability has severely impacted children's access to education, threatening their future prospects and perpetuating cycles of vulnerability.",
    thumbnailImage: "/images/global-news/2026/2026-05-09-cambodian-children-s-education-shattered-by-border-conflict-displacement.jpg",
    date: "2026-05-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-house-home-wellbeing-active-living-special-2026",
    title: "Global Health and Education Watch: House & Home Wellbeing & Active Living Special 2026",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-09-global-health-and-education-watch-house-home-wellbeing-active-living-special-202.jpg",
    date: "2026-05-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hantavirus-misinformation-runs-rampant-as-the-us-is-unequipped",
    title: "Global Health and Education Watch: Hantavirus misinformation runs rampant as the US is unequipped",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-09-global-health-and-education-watch-hantavirus-misinformation-runs-rampant-as-the-.jpg",
    date: "2026-05-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-malaria-vaccine-is-saving-children-s-lives-who",
    title: "Global Health and Education Watch: Malaria vaccine is saving children’s lives: WHO",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-09-global-health-and-education-watch-malaria-vaccine-is-saving-children-s-lives-who.jpg",
    date: "2026-05-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-alert-hantavirus-outbreak-on-cruise-ship-triggers-worldwide-tracing-effort",
    title: "Global Health Alert: Hantavirus Outbreak on Cruise Ship Triggers Worldwide Tracing Effort",
    summary:
      "An urgent global health operation is underway to trace passengers from the MV Hondius cruise ship following a hantavirus outbreak. The UN health agency has confirmed at least five cases, linking the infection to individuals who have dispersed across approximately 12 countries.",
    thumbnailImage: "/images/global-news/2026/2026-05-08-global-health-alert-hantavirus-outbreak-on-cruise-ship-triggers-worldwide-tracin.jpg",
    date: "2026-05-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "advanced-ai-model-revolutionizes-epidemic-monitoring-in-europe",
    title: "Advanced AI Model Revolutionizes Epidemic Monitoring in Europe",
    summary:
      "A groundbreaking study introduces an advanced epidemiological model combining networked SIRS dynamics with Kalman filter state estimation. This innovation promises significantly enhanced real-time epidemic monitoring and response capabilities across Europe.",
    thumbnailImage: "/images/global-news/2026/2026-05-08-advanced-ai-model-revolutionizes-epidemic-monitoring-in-europe.jpg",
    date: "2026-05-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-education-faces-crisis-as-student-enrollment-declines-worldwide",
    title: "Global Education Faces Crisis as Student Enrollment Declines Worldwide",
    summary:
      "Across continents, declining birth rates are fundamentally reshaping public education, leading to underutilized schools and unprecedented budget challenges. Nations must adapt infrastructure and funding models to ensure quality learning amid this profound demographic transformation.",
    thumbnailImage: "/images/global-news/2026/2026-05-08-global-education-faces-crisis-as-student-enrollment-declines-worldwide.jpg",
    date: "2026-05-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "football-calendar-failings-admitted-player-health-crisis-demands-global-action",
    title: "Football Calendar Failings Admitted: Player Health Crisis Demands Global Action",
    summary:
      "A landmark admission by a European football body acknowledges critical failings in the sport's calendar, jeopardizing player health and safety. This development follows a challenge by the global players' union, FIFPRO, highlighting the urgent need for systemic change in professional football.",
    thumbnailImage: "/images/global-news/2026/2026-05-08-football-calendar-failings-admitted-player-health-crisis-demands-global-action.jpg",
    date: "2026-05-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "remote-island-battles-hantavirus-as-cruise-outbreak-highlights-global-health-vulnerabilities",
    title: "Remote Island Battles Hantavirus as Cruise Outbreak Highlights Global Health Vulnerabilities",
    summary:
      "A hantavirus outbreak on a cruise ship has led to a British national receiving critical care on the extremely remote island of Tristan da Cunha. This incident highlights the profound challenges of global health security and rapid response in isolated communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-08-remote-island-battles-hantavirus-as-cruise-outbreak-highlights-global-health-vul.jpg",
    date: "2026-05-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "hantavirus-scare-third-briton-linked-to-cruise-outbreak",
    title: "Hantavirus Scare: Third Briton Linked to Cruise Outbreak",
    summary:
      "A third British national is suspected of contracting hantavirus, linked to an ongoing outbreak originating from a cruise ship. Health authorities are closely monitoring the situation as cases emerge across multiple continents, underscoring global health security concerns.",
    thumbnailImage: "/images/global-news/2026/2026-05-08-hantavirus-scare-third-briton-linked-to-cruise-outbreak.jpg",
    date: "2026-05-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-crises-threaten-health-education-and-future-skills",
    title: "Global Crises Threaten Health, Education, and Future Skills",
    summary:
      "The United Nations has voiced profound alarm over escalating humanitarian crises, particularly the staggering health needs in regions like Gaza. Concurrently, a growing global skills gap poses a significant threat to future economic stability and human development, underscoring interconnected challenges.",
    thumbnailImage: "/images/global-news/2026/2026-05-08-global-crises-threaten-health-education-and-future-skills.jpg",
    date: "2026-05-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-university-explores-endometriosis-and-cancer-link",
    title: "Global Health and Education Watch: University explores endometriosis and cancer link",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-08-global-health-and-education-watch-university-explores-endometriosis-and-cancer-l.jpg",
    date: "2026-05-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-s-response-to-hantavirus-cases-linked-to-a-cruise",
    title: "Global Health and Education Watch: WHO’s response to hantavirus cases linked to a cruise",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-08-global-health-and-education-watch-who-s-response-to-hantavirus-cases-linked-to-a.jpg",
    date: "2026-05-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hantavirus-response-shows-how-trump-cuts-have-compromised-u-s",
    title: "Global Health and Education Watch: Hantavirus Response Shows How Trump Cuts Have Compromised U.S",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-08-global-health-and-education-watch-hantavirus-response-shows-how-trump-cuts-have-.jpg",
    date: "2026-05-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mo-farah-urges-against-possible-120m-cut-to-school",
    title: "Global Health and Education Watch: Mo Farah urges against possible £120m cut to school",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-08-global-health-and-education-watch-mo-farah-urges-against-possible-120m-cut-to-sc.jpg",
    date: "2026-05-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-dangerous-is-the-hantavirus-outbreak",
    title: "Global Health and Education Watch: How dangerous is the hantavirus outbreak?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-08-global-health-and-education-watch-how-dangerous-is-the-hantavirus-outbreak.jpg",
    date: "2026-05-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-practice-based-framework-for-point-of-care-chronic-disease-management",
    title: "Global Health and Education Watch: A practice-based framework for point-of-care chronic disease management",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-07-global-health-and-education-watch-a-practice-based-framework-for-point-of-care-c.jpg",
    date: "2026-05-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-confirms-five-cases-of-hantavirus-linked-to-cruise",
    title: "Global Health and Education Watch: WHO confirms five cases of hantavirus linked to cruise",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-07-global-health-and-education-watch-who-confirms-five-cases-of-hantavirus-linked-t.jpg",
    date: "2026-05-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hantavirus-outbreak-on-cruise-ship-not-another-covid-who",
    title: "Global Health and Education Watch: Hantavirus outbreak on cruise ship not ‘another COVID’, WHO",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-07-global-health-and-education-watch-hantavirus-outbreak-on-cruise-ship-not-another.jpg",
    date: "2026-05-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "hantavirus-risk-assessed-low-amid-global-health-vigilance",
    title: "Hantavirus Risk Assessed Low Amid Global Health Vigilance",
    summary:
      "The World Health Organization has declared the public health risk from Hantavirus to be low, despite ongoing investigations into its origins. Global health bodies remain vigilant, emphasizing surveillance and preparedness for emerging zoonotic threats.",
    thumbnailImage: "/images/global-news/2026/2026-05-07-hantavirus-risk-assessed-low-amid-global-health-vigilance.jpg",
    date: "2026-05-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-florida-creates-a-more-conservative-course-to-rival-a-p",
    title: "Global Health and Education Watch: Florida Creates a More Conservative Course to Rival A.P",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-07-global-health-and-education-watch-florida-creates-a-more-conservative-course-to-.jpg",
    date: "2026-05-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-more-than-50-000-pupils-expected-to-strike-over-german",
    title: "Global Health and Education Watch: More than 50,000 pupils expected to strike over German",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-07-global-health-and-education-watch-more-than-50-000-pupils-expected-to-strike-ove.jpg",
    date: "2026-05-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-and-us-launch-disease-control-measures-over-hantavirus",
    title: "Global Health and Education Watch: UK and US launch disease control measures over hantavirus",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-07-global-health-and-education-watch-uk-and-us-launch-disease-control-measures-over.jpg",
    date: "2026-05-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-leaders-unite-for-transformative-one-health-action",
    title: "Global Health Leaders Unite for Transformative One Health Action",
    summary:
      "The World Health Organization and France launched high-impact One Health initiatives on World Health Day 2026, aiming to prevent future health crises. This collaborative effort addresses critical global challenges like climate change, zoonotic diseases, and health inequities through integrated strategies.",
    thumbnailImage: "/images/global-news/2026/2026-05-07-global-health-leaders-unite-for-transformative-one-health-action.jpg",
    date: "2026-05-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-argentina-investigates-link-to-deadly-hantavirus-outbreak-on-cruise",
    title: "Global Health and Education Watch: Argentina investigates link to deadly hantavirus outbreak on cruise",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-07-global-health-and-education-watch-argentina-investigates-link-to-deadly-hantavir.jpg",
    date: "2026-05-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "hantavirus-outbreak-on-cruise-liner-global-health-alert-intensifies-with-new-case",
    title: "Hantavirus Outbreak on Cruise Liner: Global Health Alert Intensifies with New Case",
    summary:
      "A new hantavirus case linked to a recent cruise liner voyage has intensified a global health alert, bringing the total confirmed cases to several, including three fatalities. The UN World Health Organization is coordinating an international response to contain the rodent-borne disease and investigate its source.",
    thumbnailImage: "/images/global-news/2026/2026-05-07-hantavirus-outbreak-on-cruise-liner-global-health-alert-intensifies-with-new-cas.jpg",
    date: "2026-05-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-i-didn-t-know-how-much-i-struggled-with-my",
    title: "Global Health and Education Watch: 'I didn't know how much I struggled with my",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-06-global-health-and-education-watch-i-didn-t-know-how-much-i-struggled-with-my.jpg",
    date: "2026-05-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-justice-dept-accuses-u-c-l-a-medical-school-of-bias-against",
    title: "Global Health and Education Watch: Justice Dept. Accuses U.C.L.A. Medical School of Bias Against",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-06-global-health-and-education-watch-justice-dept-accuses-u-c-l-a-medical-school-of.jpg",
    date: "2026-05-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-crisis-abortion-pills-under-threat-women-s-lives-at-risk",
    title: "Global Health Crisis: Abortion Pills Under Threat, Women's Lives at Risk",
    summary:
      "Around the globe, access to safe medical abortion, particularly through pills like mifepristone, is increasingly under threat from restrictive legislation and judicial challenges. This erosion of reproductive rights leads to tragic outcomes, including preventable deaths and profound socio-economic setbacks for women.",
    thumbnailImage: "/images/global-news/2026/2026-05-06-global-health-crisis-abortion-pills-under-threat-women-s-lives-at-risk.jpg",
    date: "2026-05-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "american-healthcare-costs-a-hidden-driver-of-global-economic-imbalance",
    title: "American Healthcare Costs: A Hidden Driver of Global Economic Imbalance",
    summary:
      "The exorbitant cost of healthcare in the United States is increasingly recognized as a significant, yet often overlooked, factor contributing to global economic disparities. These expenditures influence everything from pharmaceutical pricing to the migration of medical professionals, shaping health outcomes far beyond American borders.",
    thumbnailImage: "/images/global-news/2026/2026-05-06-american-healthcare-costs-a-hidden-driver-of-global-economic-imbalance.jpg",
    date: "2026-05-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-psychotropic-medication-use-lifestyle-genetic-risk-for-high-bmi",
    title: "Global Health and Education Watch: Psychotropic medication use, lifestyle, genetic risk for high BMI",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-06-global-health-and-education-watch-psychotropic-medication-use-lifestyle-genetic-.jpg",
    date: "2026-05-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "visa-barriers-threaten-global-health-and-education-exchange",
    title: "Visa Barriers Threaten Global Health and Education Exchange",
    summary:
      "Stringent visa policies and rising global tensions are significantly impeding international cooperation in health and education sectors. This trend threatens scientific progress, academic exchange, and the global capacity to address critical challenges.",
    thumbnailImage: "/images/global-news/2026/2026-05-06-visa-barriers-threaten-global-health-and-education-exchange.jpg",
    date: "2026-05-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-cyberattacks-threaten-health-education-technical-fixes-insufficient",
    title: "Global Cyberattacks Threaten Health, Education: Technical Fixes Insufficient",
    summary:
      "The global rise of cyberattacks is critically endangering health systems and educational institutions worldwide. Purely technical solutions are proving insufficient, demanding a holistic strategy involving human factors, policy, and international cooperation.",
    thumbnailImage: "/images/global-news/2026/2026-05-06-global-cyberattacks-threaten-health-education-technical-fixes-insufficient.jpg",
    date: "2026-05-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "human-transmissible-hantavirus-strain-detected-on-cruise-ship",
    title: "Human-Transmissible Hantavirus Strain Detected on Cruise Ship",
    summary:
      "The Andes strain of Hantavirus, known for its human-to-human transmission capability, has been identified in two confirmed cases linked to a recent cruise ship outbreak. This discovery by South African health authorities highlights the urgent need for robust international surveillance and rapid response mechanisms against emerging infectious threats.",
    thumbnailImage: "/images/global-news/2026/2026-05-06-human-transmissible-hantavirus-strain-detected-on-cruise-ship.jpg",
    date: "2026-05-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "universities-worldwide-embrace-ai-integration-for-future-of-education-and-health",
    title: "Universities Worldwide Embrace AI Integration for Future of Education and Health",
    summary:
      "Academic institutions globally are making substantial investments to integrate artificial intelligence across various disciplines, aiming to revolutionize education and critical sectors like healthcare. This strategic shift reflects a worldwide commitment to leveraging AI's transformative potential for societal advancement.",
    thumbnailImage: "/images/global-news/2026/2026-05-06-universities-worldwide-embrace-ai-integration-for-future-of-education-and-health.jpg",
    date: "2026-05-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ann-barrett-obituary",
    title: "Global Health and Education Watch: Ann Barrett obituary",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-06-global-health-and-education-watch-ann-barrett-obituary.jpg",
    date: "2026-05-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-alert-rare-viruses-resurface-posing-new-threats-in-confined-environments",
    title: "Global Health Alert: Rare Viruses Resurface, Posing New Threats in Confined Environments",
    summary:
      "The recent suspected hantavirus outbreak serves as a stark reminder of the global threat posed by rare, re-emerging viruses. It highlights the critical need for robust public health infrastructure and rapid response mechanisms, especially in environments where disease transmission can accelerate quickly.",
    thumbnailImage: "/images/global-news/2026/2026-05-06-global-health-alert-rare-viruses-resurface-posing-new-threats-in-confined-enviro.jpg",
    date: "2026-05-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-inference-of-latent-epidemic-regimes-and-generative-simulations-reveal",
    title: "Global Health and Education Watch: Inference of latent epidemic regimes and generative simulations reveal",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-05-global-health-and-education-watch-inference-of-latent-epidemic-regimes-and-gener.jpg",
    date: "2026-05-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "mauritania-s-private-school-closure-plan-ignites-nationwide-education-debate",
    title: "Mauritania's Private School Closure Plan Ignites Nationwide Education Debate",
    summary:
      "Mauritania's government has announced a controversial plan to shut down most private primary schools, aiming to consolidate students into the public education system. This policy shift has triggered widespread public outcry and protests across the nation.",
    thumbnailImage: "/images/global-news/2026/2026-05-05-mauritania-s-private-school-closure-plan-ignites-nationwide-education-debate.jpg",
    date: "2026-05-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-education-or-food-funding-shortfalls-force-sudanese-refugees-in",
    title: "Global Health and Education Watch: Education or food? Funding shortfalls force Sudanese refugees in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-05-global-health-and-education-watch-education-or-food-funding-shortfalls-force-sud.jpg",
    date: "2026-05-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "stranded-cruise-ship-battles-hantavirus-outbreak-amid-global-health-fears",
    title: "Stranded Cruise Ship Battles Hantavirus Outbreak Amid Global Health Fears",
    summary:
      "A cruise ship is stranded at sea following a hantavirus outbreak, prompting global health concerns. Passengers remain calm but face an extended journey as authorities assess the disease's potential spread.",
    thumbnailImage: "/images/global-news/2026/2026-05-05-stranded-cruise-ship-battles-hantavirus-outbreak-amid-global-health-fears.jpg",
    date: "2026-05-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "hantavirus-struck-cruise-ship-heads-to-canaries-amid-transmission-concerns",
    title: "Hantavirus-Struck Cruise Ship Heads to Canaries Amid Transmission Concerns",
    summary:
      "A cruise ship affected by Hantavirus is en route to the Canary Islands, prompting Spanish authorities to await expert health inspections before granting port entry. The World Health Organization is closely monitoring the situation, noting the unusual possibility of human-to-human transmission in this outbreak.",
    thumbnailImage: "/images/global-news/2026/2026-05-05-hantavirus-struck-cruise-ship-heads-to-canaries-amid-transmission-concerns.jpg",
    date: "2026-05-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "rethinking-nutrition-why-when-we-eat-matters-for-global-health",
    title: "Rethinking Nutrition: Why 'When' We Eat Matters for Global Health",
    summary:
      "New research is challenging decades of dietary advice by highlighting the critical role of meal timing in overall health. This evolving understanding could revolutionize global approaches to metabolic well-being and chronic disease prevention.",
    thumbnailImage: "/images/global-news/2026/2026-05-05-rethinking-nutrition-why-when-we-eat-matters-for-global-health.jpg",
    date: "2026-05-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "homes-as-health-hubs-a-new-era-of-proactive-design",
    title: "Homes as Health Hubs: A New Era of Proactive Design",
    summary:
      "A global movement is emerging where medical consultants collaborate with architects and designers to \"diagnose\" and enhance the health-promoting qualities of homes. This innovative approach aims to embed long-term well-being into residential environments, transforming how we perceive and construct our living spaces.",
    thumbnailImage: "/images/global-news/2026/2026-05-05-homes-as-health-hubs-a-new-era-of-proactive-design.jpg",
    date: "2026-05-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "a-decade-of-disregard-global-healthcare-under-siege-in-conflicts",
    title: "A Decade of Disregard: Global Healthcare Under Siege in Conflicts",
    summary:
      "A decade since UN Resolution 2286 aimed to safeguard healthcare in armed conflicts, the situation has alarmingly worsened. Major humanitarian organizations are now issuing a joint, urgent call for global action to protect medical facilities and personnel.",
    thumbnailImage: "/images/global-news/2026/2026-05-05-a-decade-of-disregard-global-healthcare-under-siege-in-conflicts.jpg",
    date: "2026-05-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "escalating-regional-tensions-devastate-lebanese-health-sector-threaten-global-aid",
    title: "Escalating Regional Tensions Devastate Lebanese Health Sector, Threaten Global Aid",
    summary:
      "Ongoing regional conflicts have inflicted a devastating human cost in Lebanon, with thousands killed and injured, severely straining the nation's healthcare infrastructure. This crisis highlights the urgent global need for sustained humanitarian aid and robust health system support amidst escalating geopolitical tensions.",
    thumbnailImage: "/images/global-news/2026/2026-05-05-escalating-regional-tensions-devastate-lebanese-health-sector-threaten-global-ai.jpg",
    date: "2026-05-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-association-between-health-literacy-and-the-need-for-hemodialysis",
    title: "Global Health and Education Watch: Association between health literacy and the need for hemodialysis",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-05-global-health-and-education-watch-association-between-health-literacy-and-the-ne.jpg",
    date: "2026-05-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-scramble-to-evacuate-two-people-from-cruise-ship-amid",
    title: "Global Health and Education Watch: Scramble to evacuate two people from cruise ship amid",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-04-global-health-and-education-watch-scramble-to-evacuate-two-people-from-cruise-sh.jpg",
    date: "2026-05-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-to-know-about-the-suspected-hantavirus-outbreak-on",
    title: "Global Health and Education Watch: What to Know About the Suspected Hantavirus Outbreak on",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-04-global-health-and-education-watch-what-to-know-about-the-suspected-hantavirus-ou.jpg",
    date: "2026-05-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "deadly-hantavirus-outbreak-on-cruise-ship-triggers-global-health-emergency",
    title: "Deadly Hantavirus Outbreak on Cruise Ship Triggers Global Health Emergency",
    summary:
      "A virulent hantavirus outbreak aboard a cruise ship in the Atlantic Ocean has prompted an immediate, coordinated international public health intervention. The World Health Organization is leading efforts to contain the deadly pathogen and prevent its wider spread.",
    thumbnailImage: "/images/global-news/2026/2026-05-04-deadly-hantavirus-outbreak-on-cruise-ship-triggers-global-health-emergency.jpg",
    date: "2026-05-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "hantavirus-outbreak-on-cruise-ship-claims-three-lives-who-monitors-global-health-threat",
    title: "Hantavirus Outbreak on Cruise Ship Claims Three Lives, WHO Monitors Global Health Threat",
    summary:
      "Three individuals have died and three others are critically ill following a suspected hantavirus outbreak on a cruise ship, as confirmed by the World Health Organization. The incident highlights the complex challenges of managing zoonotic diseases within international travel contexts and the critical need for robust global health surveillance.",
    thumbnailImage: "/images/global-news/2026/2026-05-04-hantavirus-outbreak-on-cruise-ship-claims-three-lives-who-monitors-global-health.jpg",
    date: "2026-05-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "data-driven-insights-transform-global-healthcare-slash-costs",
    title: "Data-Driven Insights Transform Global Healthcare, Slash Costs",
    summary:
      "New research leverages data analytics to pinpoint critical disease pathways, known as \"hub chains,\" that drive healthcare utilization. This innovative approach promises to reduce global healthcare costs and improve patient outcomes by enabling more targeted interventions.",
    thumbnailImage: "/images/global-news/2026/2026-05-04-data-driven-insights-transform-global-healthcare-slash-costs.jpg",
    date: "2026-05-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "former-nyc-mayor-giuliani-hospitalized-in-critical-condition-global-concerns-emerge",
    title: "Former NYC Mayor Giuliani Hospitalized in Critical Condition, Global Concerns Emerge",
    summary:
      "Former New York City Mayor Rudy Giuliani has been hospitalized in critical but stable condition, according to his spokesman. The news has drawn global attention, with political figures and the public closely following developments.",
    thumbnailImage: "/images/global-news/2026/2026-05-04-former-nyc-mayor-giuliani-hospitalized-in-critical-condition-global-concerns-eme.jpg",
    date: "2026-05-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "virtual-reality-trials-offer-new-hope-for-student-stress-relief-globally",
    title: "Virtual Reality Trials Offer New Hope for Student Stress Relief Globally",
    summary:
      "A pioneering program in London schools is deploying virtual reality to help students manage stress from exams, ADHD, and personal challenges. This initiative highlights a growing global trend towards innovative tech solutions for youth mental health in educational settings.",
    thumbnailImage: "/images/global-news/2026/2026-05-04-virtual-reality-trials-offer-new-hope-for-student-stress-relief-globally.jpg",
    date: "2026-05-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "denmark-s-triumph-a-global-blueprint-to-end-mother-to-child-hiv-syphilis-transmission",
    title: "Denmark's Triumph: A Global Blueprint to End Mother-to-Child HIV, Syphilis Transmission",
    summary:
      "Denmark has become the first EU nation certified by WHO for eliminating mother-to-child transmission of HIV and syphilis. This landmark achievement highlights the critical role of universal healthcare and sustained public health commitment.",
    thumbnailImage: "/images/global-news/2026/2026-05-04-denmark-s-triumph-a-global-blueprint-to-end-mother-to-child-hiv-syphilis-transmi.jpg",
    date: "2026-05-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-school-cellphone-ban-study-finds-mixed-results",
    title: "Global Health and Education Watch: School Cellphone Ban Study Finds Mixed Results",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-04-global-health-and-education-watch-school-cellphone-ban-study-finds-mixed-results.jpg",
    date: "2026-05-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-cancer-care-revolutionized-by-rapid-injectable-immunotherapy",
    title: "Global Cancer Care Revolutionized by Rapid Injectable Immunotherapy",
    summary:
      "A groundbreaking injectable immunotherapy drug, initially rolled out in the UK, promises to transform cancer treatment by significantly cutting down hospital time for patients. This innovation offers a more convenient and efficient approach to care, with potential global implications for healthcare systems and patient quality of life.",
    thumbnailImage: "/images/global-news/2026/2026-05-04-global-cancer-care-revolutionized-by-rapid-injectable-immunotherapy.jpg",
    date: "2026-05-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "suspected-hantavirus-outbreak-claims-three-lives-on-atlantic-cruise",
    title: "Suspected Hantavirus Outbreak Claims Three Lives on Atlantic Cruise",
    summary:
      "A suspected hantavirus outbreak aboard an Atlantic cruise ship has resulted in three passenger deaths and one critical case, according to the World Health Organization. This rare incident has triggered an urgent international public health investigation into the rodent-transmitted illness.",
    thumbnailImage: "/images/global-news/2026/2026-05-03-suspected-hantavirus-outbreak-claims-three-lives-on-atlantic-cruise.jpg",
    date: "2026-05-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "lorraine-ribbons-a-life-of-heartfelt-service-for-children-globally",
    title: "Lorraine Ribbons: A Life of Heartfelt Service for Children Globally",
    summary:
      "Lorraine Ribbons, who passed at 72, dedicated her life to supporting families affected by children's heart conditions through extensive volunteering. Her personal experience became a global beacon of empathy, providing vital hospital visits, therapeutic holidays, and peer counselling.",
    thumbnailImage: "/images/global-news/2026/2026-05-03-lorraine-ribbons-a-life-of-heartfelt-service-for-children-globally.jpg",
    date: "2026-05-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "deadly-hantavirus-outbreak-strikes-cruise-ship-raising-global-health-concerns",
    title: "Deadly Hantavirus Outbreak Strikes Cruise Ship, Raising Global Health Concerns",
    summary:
      "A suspected hantavirus outbreak aboard a cruise ship in the Atlantic has led to three passenger deaths and several others falling critically ill. Global health authorities are monitoring the situation closely as the vessel docks in South Africa, initiating an immediate public health investigation.",
    thumbnailImage: "/images/global-news/2026/2026-05-03-deadly-hantavirus-outbreak-strikes-cruise-ship-raising-global-health-concerns.jpg",
    date: "2026-05-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-is-chickenpox-and-who-can-get-an-nhs-3",
    title: "Global Health and Education Watch: What is chickenpox and who can get an NHS",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-03-global-health-and-education-watch-what-is-chickenpox-and-who-can-get-an-nhs.jpg",
    date: "2026-05-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-posting-the-ten-commandments-in-classrooms",
    title: "Global Health and Education Watch: Posting the Ten Commandments in Classrooms",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-03-global-health-and-education-watch-posting-the-ten-commandments-in-classrooms.jpg",
    date: "2026-05-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-guardian-view-on-unhealthy-britain-from-housing-to",
    title: "Global Health and Education Watch: The Guardian view on unhealthy Britain: from housing to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-03-global-health-and-education-watch-the-guardian-view-on-unhealthy-britain-from-ho.jpg",
    date: "2026-05-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "the-echo-of-words-how-teacher-comments-shape-global-education-and-identity",
    title: "The Echo of Words: How Teacher Comments Shape Global Education and Identity",
    summary:
      "A seemingly minor comment from an educator can have profound, lifelong impacts on a student's self-esteem and educational path. This global issue highlights the critical importance of empathetic communication and inclusive practices in classrooms worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-05-03-the-echo-of-words-how-teacher-comments-shape-global-education-and-identity.jpg",
    date: "2026-05-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-drowning-in-misinformation-under-rfk-jr-autism-advocates",
    title: "Global Health and Education Watch: US ‘drowning in misinformation’ under RFK Jr, autism advocates",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-03-global-health-and-education-watch-us-drowning-in-misinformation-under-rfk-jr-aut.jpg",
    date: "2026-05-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-christofascism-is-here-inside-the-slow-demolition-of-us",
    title: "Global Health and Education Watch: ‘Christofascism’ is here: inside the slow demolition of US",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-03-global-health-and-education-watch-christofascism-is-here-inside-the-slow-demolit.jpg",
    date: "2026-05-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hospitals-in-lebanon-overwhelmed-with-patients-injured-by-israeli",
    title: "Global Health and Education Watch: Hospitals in Lebanon overwhelmed with patients injured by Israeli",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-03-global-health-and-education-watch-hospitals-in-lebanon-overwhelmed-with-patients.jpg",
    date: "2026-05-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-apartheid-in-the-us-arizona-s-secretary-of-state-fights",
    title: "Global Health and Education Watch: ‘Apartheid in the US’: Arizona’s secretary of state fights",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-03-global-health-and-education-watch-apartheid-in-the-us-arizona-s-secretary-of-sta.jpg",
    date: "2026-05-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-classrooms-confront-demographic-shift-fewer-students-more-questions",
    title: "Global Classrooms Confront Demographic Shift: Fewer Students, More Questions",
    summary:
      "Across continents, educational systems are grappling with shrinking student enrollments, a phenomenon driven by profound demographic shifts. This global trend necessitates innovative policy responses to manage underutilized facilities and sustain high-quality learning environments.",
    thumbnailImage: "/images/global-news/2026/2026-05-03-global-classrooms-confront-demographic-shift-fewer-students-more-questions.jpg",
    date: "2026-05-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-global-commitment-on-display-as-countries-negotiate-key-annex-2",
    title: "Global Health and Education Watch: Global commitment on display as countries negotiate key annex",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-03-global-health-and-education-watch-global-commitment-on-display-as-countries-nego.jpg",
    date: "2026-05-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-brixton-drive-by-shooting-act-of-indiscriminate-violence-say-met",
    title: "Global Health and Education Watch: Brixton drive-by shooting ‘act of indiscriminate violence’, say Met",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-03-global-health-and-education-watch-brixton-drive-by-shooting-act-of-indiscriminat.jpg",
    date: "2026-05-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "thailand-s-muay-thai-visa-a-global-model-for-health-and-cultural-immersion",
    title: "Thailand's Muay Thai Visa: A Global Model for Health and Cultural Immersion",
    summary:
      "Thailand is offering a five-year visa to visitors who engage in “soft power” activities like Muay Thai training, promoting cultural exchange and extended stays. This initiative highlights a growing trend in global travel, blending health, education, and immersive experiences.",
    thumbnailImage: "/images/global-news/2026/2026-05-03-thailand-s-muay-thai-visa-a-global-model-for-health-and-cultural-immersion.jpg",
    date: "2026-05-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "us-supreme-court-appeal-ignites-global-debate-on-abortion-pill-access",
    title: "US Supreme Court Appeal Ignites Global Debate on Abortion Pill Access",
    summary:
      "A US Supreme Court appeal by Danco Laboratories challenges restrictions on telemedicine and mail-order access to the abortion pill mifepristone. This legal battle has significant global implications for reproductive rights, healthcare equity, and the future of medication access worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-05-02-us-supreme-court-appeal-ignites-global-debate-on-abortion-pill-access.jpg",
    date: "2026-05-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-happiest-time-of-life-is-as-you-get",
    title: "Global Health and Education Watch: ‘The happiest time of life is as you get",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-02-global-health-and-education-watch-the-happiest-time-of-life-is-as-you-get.jpg",
    date: "2026-05-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israel-s-two-tier-policing-and-the-crime-epidemic-in-palestinian",
    title: "Global Health and Education Watch: Israel’s ‘two-tier’ policing and the crime epidemic in Palestinian",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-02-global-health-and-education-watch-israel-s-two-tier-policing-and-the-crime-epide.jpg",
    date: "2026-05-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-e-mobility-safety-parental-accountability-after-fatal-teen-crash",
    title: "Global E-Mobility Safety: Parental Accountability After Fatal Teen Crash",
    summary:
      "A California mother faces involuntary manslaughter charges after her son's illegal e-motorcycle ride led to a fatal collision with an elderly man. This tragic event underscores growing global concerns about e-mobility safety, parental responsibility, and the urgent need for comprehensive regulatory frameworks.",
    thumbnailImage: "/images/global-news/2026/2026-05-02-global-e-mobility-safety-parental-accountability-after-fatal-teen-crash.jpg",
    date: "2026-05-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-conflict-deepens-health-crisis-across-middle-east-who-says-3",
    title: "Global Health and Education Watch: Conflict deepens health crisis across Middle East, WHO says",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-02-global-health-and-education-watch-conflict-deepens-health-crisis-across-middle-e.jpg",
    date: "2026-05-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "caffeine-pouch-craze-global-health-alarm-for-youth",
    title: "Caffeine Pouch Craze: Global Health Alarm for Youth",
    summary:
      "A global surge in caffeine pouch use among teenagers, driven by social media influencers, is alarming health experts. These products pose serious risks to adolescent health, including cardiac issues, anxiety, and addiction, prompting calls for urgent regulation and awareness.",
    thumbnailImage: "/images/global-news/2026/2026-05-02-caffeine-pouch-craze-global-health-alarm-for-youth.jpg",
    date: "2026-05-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-obamacare-enrollment-drops-sharply-as-costs-rise",
    title: "Global Health and Education Watch: Obamacare Enrollment Drops Sharply as Costs Rise",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-02-global-health-and-education-watch-obamacare-enrollment-drops-sharply-as-costs-ri.jpg",
    date: "2026-05-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-office-for-students-university-of-sussex-humiliation-is-a",
    title: "Global Health and Education Watch: Office for Students’ University of Sussex humiliation is a",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-02-global-health-and-education-watch-office-for-students-university-of-sussex-humil.jpg",
    date: "2026-05-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-higher-education-redefining-its-enduring-purpose",
    title: "Global Higher Education: Redefining Its Enduring Purpose",
    summary:
      "Across continents, educators, policymakers, and students are engaging in a profound debate about the fundamental purpose of higher education. This global conversation explores whether universities should prioritize career readiness, intellectual development, social equity, or groundbreaking research.",
    thumbnailImage: "/images/global-news/2026/2026-05-02-global-higher-education-redefining-its-enduring-purpose.jpg",
    date: "2026-05-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "severe-uk-threat-level-prompts-global-health-education-preparedness-focus",
    title: "Severe UK Threat Level Prompts Global Health, Education Preparedness Focus",
    summary:
      "A severe threat level in the United Kingdom has prompted advisories for citizens, highlighting the profound implications for public health and educational continuity. This development underscores the urgent need for robust global strategies to safeguard community well-being and learning environments amidst evolving security landscapes.",
    thumbnailImage: "/images/global-news/2026/2026-05-02-severe-uk-threat-level-prompts-global-health-education-preparedness-focus.jpg",
    date: "2026-05-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "west-bank-schools-under-siege-a-global-education-crisis",
    title: "West Bank Schools Under Siege: A Global Education Crisis",
    summary:
      "Education across Palestine faces severe threats as violence escalates, exemplified by the recent killing of 14-year-old Aws al-Naasan outside his school. This ongoing targeting of educational institutions jeopardizes the safety and future of countless students in the West Bank.",
    thumbnailImage: "/images/global-news/2026/2026-05-02-west-bank-schools-under-siege-a-global-education-crisis.jpg",
    date: "2026-05-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-first-malaria-drug-for-babies-is-approved-in-major",
    title: "Global Health and Education Watch: First malaria drug for babies is approved in ‘major",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-02-global-health-and-education-watch-first-malaria-drug-for-babies-is-approved-in-m.jpg",
    date: "2026-05-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-revise-recall-then-rest-your-exam-season-survival",
    title: "Global Health and Education Watch: Revise, recall, then rest - your exam season survival",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-02-global-health-and-education-watch-revise-recall-then-rest-your-exam-season-survi.jpg",
    date: "2026-05-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-problem-with-healthy-life-expectancy",
    title: "Global Health and Education Watch: The problem with healthy life expectancy",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-02-global-health-and-education-watch-the-problem-with-healthy-life-expectancy.jpg",
    date: "2026-05-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-member-states-agree-to-extend-negotiations-on-pathogen",
    title: "Global Health and Education Watch: WHO Member States agree to extend negotiations on Pathogen",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-02-global-health-and-education-watch-who-member-states-agree-to-extend-negotiations.jpg",
    date: "2026-05-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "campus-discourse-erupts-cornell-incident-reflects-global-higher-education-tensions",
    title: "Campus Discourse Erupts: Cornell Incident Reflects Global Higher Education Tensions",
    summary:
      "A debate on the Israeli-Palestinian conflict at Cornell University reportedly culminated in an alleged physical altercation involving the university president and student protesters. This incident underscores the growing global challenges faced by higher education institutions in balancing free expression with campus safety.",
    thumbnailImage: "/images/global-news/2026/2026-05-02-campus-discourse-erupts-cornell-incident-reflects-global-higher-education-tensio.jpg",
    date: "2026-05-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-iranian-nobel-laureate-narges-mohammadi-hospitalised-as-health-deteriorates",
    title: "Global Health and Education Watch: Iranian Nobel laureate Narges Mohammadi hospitalised as health deteriorates",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-01-global-health-and-education-watch-iranian-nobel-laureate-narges-mohammadi-hospit.jpg",
    date: "2026-05-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "south-america-grapples-with-persistent-healthcare-inequities-demanding-urgent-global-attention",
    title: "South America Grapples with Persistent Healthcare Inequities, Demanding Urgent Global Attention",
    summary:
      "Healthcare inequalities remain a critical issue across South America, with millions facing significant barriers to essential medical services. These disparities, often rooted in socioeconomic status, geography, and ethnicity, exacerbate health outcomes and hinder regional development.",
    thumbnailImage: "/images/global-news/2026/2026-05-01-south-america-grapples-with-persistent-healthcare-inequities-demanding-urgent-gl.jpg",
    date: "2026-05-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ability-grouping-boosts-top-maths-students-harms-none-study-finds",
    title: "Ability Grouping Boosts Top Maths Students, Harms None, Study Finds",
    summary:
      "A groundbreaking study from University College London suggests teaching secondary school maths in ability-grouped classes significantly improves outcomes for high-achievers. Crucially, the research indicates this approach does not negatively impact the progress of students with lower prior attainment, upending long-held assumptions in education.",
    thumbnailImage: "/images/global-news/2026/2026-05-01-ability-grouping-boosts-top-maths-students-harms-none-study-finds.jpg",
    date: "2026-05-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-it-s-the-most-normal-thing-in-the-world-to",
    title: "Global Health and Education Watch: 'It's the most normal thing in the world to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-01-global-health-and-education-watch-it-s-the-most-normal-thing-in-the-world-to.jpg",
    date: "2026-05-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ofsted-inspections-pushing-headteachers-to-point-of-destruction-union",
    title: "Global Health and Education Watch: Ofsted inspections pushing headteachers to ‘point of destruction’, union",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-01-global-health-and-education-watch-ofsted-inspections-pushing-headteachers-to-poi.jpg",
    date: "2026-05-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "cricket-club-curbs-social-media-to-safeguard-player-mental-health-globally",
    title: "Cricket Club Curbs Social Media to Safeguard Player Mental Health Globally",
    summary:
      "An English cricket club has implemented a ban on social media comments to shield its players from online abuse and safeguard their mental health. This initiative underscores a growing global awareness of the psychological toll social media can take on professional athletes.",
    thumbnailImage: "/images/global-news/2026/2026-05-01-cricket-club-curbs-social-media-to-safeguard-player-mental-health-globally.jpg",
    date: "2026-05-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "brazil-s-hiv-transmission-elimination-a-global-health-blueprint",
    title: "Brazil's HIV Transmission Elimination: A Global Health Blueprint",
    summary:
      "Brazil has achieved a significant milestone in eliminating mother-to-child HIV transmission, showcasing the power of universal healthcare and integrated services. This success provides a vital framework for other nations striving to achieve similar public health goals.",
    thumbnailImage: "/images/global-news/2026/2026-05-01-brazil-s-hiv-transmission-elimination-a-global-health-blueprint.jpg",
    date: "2026-05-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-vaccine-skeptic-in-trump-s-new-c-d-c-leadership-team",
    title: "Global Health and Education Watch: The Vaccine Skeptic in Trump’s New C.D.C. Leadership Team",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-01-global-health-and-education-watch-the-vaccine-skeptic-in-trump-s-new-c-d-c-leade.jpg",
    date: "2026-05-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-sudanese-journalists-awarded-unesco-press-freedom-prize",
    title: "Global Health and Education Watch: Sudanese journalists awarded UNESCO press freedom prize",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-01-global-health-and-education-watch-sudanese-journalists-awarded-unesco-press-free.jpg",
    date: "2026-05-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-is-ofsted-and-how-does-the-new-school",
    title: "Global Health and Education Watch: What is Ofsted and how does the new school",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-01-global-health-and-education-watch-what-is-ofsted-and-how-does-the-new-school.jpg",
    date: "2026-05-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-firms-rethink-weight-loss-drug-coverage-amid-soaring-costs",
    title: "Global Firms Rethink Weight-Loss Drug Coverage Amid Soaring Costs",
    summary:
      "PwC is withdrawing coverage for popular weight-loss medications from its employee health plans, citing unsustainable costs and the drugs' widespread adoption. This move highlights a growing global challenge for corporations balancing employee wellness with escalating pharmaceutical expenses.",
    thumbnailImage: "/images/global-news/2026/2026-05-01-global-firms-rethink-weight-loss-drug-coverage-amid-soaring-costs.jpg",
    date: "2026-05-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-it-ruined-my-night-photographers-accused-of-targeting-women",
    title: "Global Health and Education Watch: ‘It ruined my night’: photographers accused of targeting women",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-01-global-health-and-education-watch-it-ruined-my-night-photographers-accused-of-ta.jpg",
    date: "2026-05-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-nigerian-military-runs-a-fulani-concentration-camp-group-says",
    title: "Global Health and Education Watch: Nigerian Military Runs a Fulani ‘Concentration Camp,’ Group Says",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-05-01-global-health-and-education-watch-nigerian-military-runs-a-fulani-concentration-.jpg",
    date: "2026-05-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-crisis-austerity-policies-erode-healthy-life-expectancy-worldwide",
    title: "Global Health Crisis: Austerity Policies Erode Healthy Life Expectancy Worldwide",
    summary:
      "A growing body of evidence suggests that economic austerity measures are contributing to a troubling decline in healthy life expectancy across various nations. These policies, often characterized by cuts to public spending, are exacerbating health inequalities and undermining essential social services globally.",
    thumbnailImage: "/images/global-news/2026/2026-04-30-global-health-crisis-austerity-policies-erode-healthy-life-expectancy-worldwide.jpg",
    date: "2026-04-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "gaza-doctors-release-sought-by-rights-group-in-landmark-israel-court-petition",
    title: "Gaza Doctors' Release Sought by Rights Group in Landmark Israel Court Petition",
    summary:
      "A prominent Israeli human rights organization has petitioned the nation's highest court, demanding the immediate release of fourteen Palestinian doctors detained from Gaza. The group argues their continued incarceration severely impedes efforts to restore the territory's collapsed healthcare system.",
    thumbnailImage: "/images/global-news/2026/2026-04-30-gaza-doctors-release-sought-by-rights-group-in-landmark-israel-court-petition.jpg",
    date: "2026-04-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ai-fuels-escalating-online-abuse-against-women-journalists-threatening-global-press-freedom",
    title: "AI Fuels Escalating Online Abuse Against Women Journalists, Threatening Global Press Freedom",
    summary:
      "Online violence targeting women journalists has doubled since 2020, with artificial intelligence amplifying its severity and reach. This alarming trend poses significant threats to their well-being, press freedom, and the integrity of global information ecosystems.",
    thumbnailImage: "/images/global-news/2026/2026-04-30-ai-fuels-escalating-online-abuse-against-women-journalists-threatening-global-pr.jpg",
    date: "2026-04-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-push-for-integrated-maternal-mental-health-care-gains-momentum",
    title: "Global Push for Integrated Maternal Mental Health Care Gains Momentum",
    summary:
      "A new mother and baby mental health unit planned for Northern Ireland highlights a growing global commitment to integrated perinatal care. This development underscores the urgent need for accessible, specialized support for mothers and infants facing mental health challenges.",
    thumbnailImage: "/images/global-news/2026/2026-04-30-global-push-for-integrated-maternal-mental-health-care-gains-momentum.jpg",
    date: "2026-04-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "indoor-air-purifiers-offer-vital-shield-against-wildfire-smoke-health-risks",
    title: "Indoor Air Purifiers Offer Vital Shield Against Wildfire Smoke Health Risks",
    summary:
      "As wildfires intensify globally, new research highlights the effectiveness of indoor air purifiers in safeguarding public health. These devices significantly reduce exposure to harmful particulate matter, mitigating severe respiratory and cardiovascular impacts.",
    thumbnailImage: "/images/global-news/2026/2026-04-30-indoor-air-purifiers-offer-vital-shield-against-wildfire-smoke-health-risks.jpg",
    date: "2026-04-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "radioactive-heavy-metals-in-breast-milk-a-global-health-concern-for-infants",
    title: "Radioactive Heavy Metals in Breast Milk: A Global Health Concern for Infants",
    summary:
      "A global review reveals the concerning presence of uranium and other radioactive heavy metals in breast milk. This critical finding underscores potential environmental health risks and their profound impact on early life development worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-30-radioactive-heavy-metals-in-breast-milk-a-global-health-concern-for-infants.jpg",
    date: "2026-04-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-a-i-killed-student-writing-and-revived-it",
    title: "Global Health and Education Watch: How A.I. Killed Student Writing (and Revived It)",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-30-global-health-and-education-watch-how-a-i-killed-student-writing-and-revived-it.jpg",
    date: "2026-04-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-chile-police-blast-water-cannons-at-student-protesters",
    title: "Global Health and Education Watch: Chile police blast water cannons at student protesters",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-30-global-health-and-education-watch-chile-police-blast-water-cannons-at-student-pr.jpg",
    date: "2026-04-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-teachers-vow-to-fight-censorship-after-school-book-row",
    title: "Global Health and Education Watch: Teachers vow to 'fight censorship' after school book row",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-30-global-health-and-education-watch-teachers-vow-to-fight-censorship-after-school-.jpg",
    date: "2026-04-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "advanced-practitioners-enhancing-global-healthcare-not-compromising-safety",
    title: "Advanced Practitioners: Enhancing Global Healthcare, Not Compromising Safety",
    summary:
      "The global healthcare landscape is increasingly relying on advanced practitioners to address physician shortages and improve patient access. These highly trained professionals operate within multidisciplinary teams, providing evidence-based care without compromising safety.",
    thumbnailImage: "/images/global-news/2026/2026-04-30-advanced-practitioners-enhancing-global-healthcare-not-compromising-safety.jpg",
    date: "2026-04-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-in-backlash-against-tech-in-schools-parents-are-winning",
    title: "Global Health and Education Watch: In Backlash Against Tech in Schools, Parents Are Winning",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-30-global-health-and-education-watch-in-backlash-against-tech-in-schools-parents-ar.jpg",
    date: "2026-04-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-alarms-silenced-a-threat-to-disease-surveillance",
    title: "Global Health Alarms Silenced: A Threat to Disease Surveillance",
    summary:
      "Recent actions to dismantle key scientific advisory panels threaten the global public health infrastructure vital for early disease detection. This move echoes historical challenges, underscoring the critical importance of robust surveillance systems in preventing future health crises.",
    thumbnailImage: "/images/global-news/2026/2026-04-29-global-health-alarms-silenced-a-threat-to-disease-surveillance.jpg",
    date: "2026-04-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "australia-eradicates-trachoma-a-global-health-milestone",
    title: "Australia Eradicates Trachoma: A Global Health Milestone",
    summary:
      "Australia has been validated by the World Health Organization for eliminating trachoma as a public health problem, a significant achievement for global health. This milestone underscores successful efforts in combating neglected tropical diseases and improving the well-being of indigenous populations.",
    thumbnailImage: "/images/global-news/2026/2026-04-29-australia-eradicates-trachoma-a-global-health-milestone.jpg",
    date: "2026-04-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-families-sue-openai-alleging-chatbot-aided-in-canadian-school",
    title: "Global Health and Education Watch: Families sue OpenAI, alleging chatbot aided in Canadian school",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-29-global-health-and-education-watch-families-sue-openai-alleging-chatbot-aided-in-.jpg",
    date: "2026-04-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "american-universities-lose-luster-for-french-students-amid-shifting-global-perceptions",
    title: "American Universities Lose Luster for French Students Amid Shifting Global Perceptions",
    summary:
      "A notable shift is occurring in international student preferences, with French students increasingly opting for European universities over traditional American Ivy League institutions. This trend is driven by growing anxieties regarding U.S. visa policies, perceived threats to academic freedom, and safety concerns.",
    thumbnailImage: "/images/global-news/2026/2026-04-29-american-universities-lose-luster-for-french-students-amid-shifting-global-perce.jpg",
    date: "2026-04-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-university-wins-record-freedom-of-speech-fine-challenge",
    title: "Global Health and Education Watch: University wins record freedom of speech fine challenge",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-29-global-health-and-education-watch-university-wins-record-freedom-of-speech-fine-.jpg",
    date: "2026-04-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "south-sudan-faces-catastrophic-hunger-over-half-population-acutely-food-insecure",
    title: "South Sudan Faces Catastrophic Hunger: Over Half Population Acutely Food Insecure",
    summary:
      "Over half of South Sudan's population, 7.8 million people, is grappling with an acute hunger crisis exacerbated by ongoing conflict and widespread displacement. This dire situation has left 2.2 million children suffering from acute malnutrition, demanding urgent global attention and humanitarian intervention.",
    thumbnailImage: "/images/global-news/2026/2026-04-29-south-sudan-faces-catastrophic-hunger-over-half-population-acutely-food-insecure.jpg",
    date: "2026-04-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "unveiling-cognitive-health-disparities-in-indigenous-communities",
    title: "Unveiling Cognitive Health Disparities in Indigenous Communities",
    summary:
      "A groundbreaking study reveals significant cognitive impairment and related health conditions within American Indian communities. This research underscores urgent global health disparities facing indigenous populations worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-29-unveiling-cognitive-health-disparities-in-indigenous-communities.jpg",
    date: "2026-04-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "uk-s-gradual-smoking-ban-a-global-blueprint-for-a-smoke-free-future",
    title: "UK's Gradual Smoking Ban: A Global Blueprint for a Smoke-Free Future",
    summary:
      "The UK has enacted a landmark bill to create a \"smoke-free generation\" by gradually increasing the legal smoking age annually from 2027. This novel approach, deemed a public relations success, is being closely watched globally as a potential model for other nations seeking to end tobacco use.",
    thumbnailImage: "/images/global-news/2026/2026-04-29-uk-s-gradual-smoking-ban-a-global-blueprint-for-a-smoke-free-future.jpg",
    date: "2026-04-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "afghan-university-attack-shatters-student-dreams-deepens-education-crisis",
    title: "Afghan University Attack Shatters Student Dreams, Deepens Education Crisis",
    summary:
      "Afghan students are reeling from a missile attack on their university, an incident officials attribute to regional tensions. This devastating event underscores the critical vulnerability of educational spaces and the profound impact on academic futures in conflict-affected areas.",
    thumbnailImage: "/images/global-news/2026/2026-04-29-afghan-university-attack-shatters-student-dreams-deepens-education-crisis.jpg",
    date: "2026-04-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "canada-s-shifting-appeal-indian-students-reconsider-study-abroad-dreams",
    title: "Canada's Shifting Appeal: Indian Students Reconsider Study Abroad Dreams",
    summary:
      "Indian students are increasingly reassessing Canada as a study destination due to evolving immigration policies and escalating living expenses. This shift marks a significant change in global education migration trends, impacting thousands of aspiring international students.",
    thumbnailImage: "/images/global-news/2026/2026-04-29-canada-s-shifting-appeal-indian-students-reconsider-study-abroad-dreams.jpg",
    date: "2026-04-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-education-equity-threatened-by-slowdown-in-discrimination-cases",
    title: "Global Education Equity Threatened by Slowdown in Discrimination Cases",
    summary:
      "Recent data reveals a substantial decrease in the resolution of discrimination complaints within a prominent education department, raising concerns about the enforcement of civil rights in educational settings. This trend underscores a broader global challenge to ensuring equitable access and treatment for all students.",
    thumbnailImage: "/images/global-news/2026/2026-04-29-global-education-equity-threatened-by-slowdown-in-discrimination-cases.jpg",
    date: "2026-04-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-efforts-to-eliminate-hepatitis-delivers-gains-but-more-action",
    title: "Global Health and Education Watch: Efforts to eliminate hepatitis delivers gains but more action",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-28-global-health-and-education-watch-efforts-to-eliminate-hepatitis-delivers-gains-.jpg",
    date: "2026-04-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-if-it-feels-like-the-world-is-rejecting-science",
    title: "Global Health and Education Watch: If it feels like the world is rejecting science",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-28-global-health-and-education-watch-if-it-feels-like-the-world-is-rejecting-scienc.jpg",
    date: "2026-04-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-half-of-england-s-schools-unfit-due-to-leaks-mould",
    title: "Global Health and Education Watch: Half of England’s schools unfit due to leaks, mould",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-28-global-health-and-education-watch-half-of-england-s-schools-unfit-due-to-leaks-m.jpg",
    date: "2026-04-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-calls-for-stepped-up-action-to-eliminate-viral",
    title: "Global Health and Education Watch: WHO calls for stepped up action to eliminate viral",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-28-global-health-and-education-watch-who-calls-for-stepped-up-action-to-eliminate-v.jpg",
    date: "2026-04-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-college-aid-appeals-face-delays-stressing-students",
    title: "Global College Aid Appeals Face Delays, Stressing Students",
    summary:
      "Delays in financial aid appeal responses are causing significant stress for students globally, hindering their ability to make timely enrollment decisions. This widespread issue underscores the urgent need for greater transparency and efficiency in university financial aid systems.",
    thumbnailImage: "/images/global-news/2026/2026-04-28-global-college-aid-appeals-face-delays-stressing-students.jpg",
    date: "2026-04-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-adenomyosis-ruined-my-life",
    title: "Global Health and Education Watch: 'Adenomyosis ruined my life'",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-28-global-health-and-education-watch-adenomyosis-ruined-my-life.jpg",
    date: "2026-04-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "gaza-s-child-survivors-face-lifelong-scars-amidst-collapsed-healthcare",
    title: "Gaza's Child Survivors Face Lifelong Scars Amidst Collapsed Healthcare",
    summary:
      "Children surviving the conflict in Gaza are facing lifelong disabilities from injuries like burns and toxic gas exposure. The collapse of the region's healthcare system leaves them without essential care and rehabilitation.",
    thumbnailImage: "/images/global-news/2026/2026-04-28-gaza-s-child-survivors-face-lifelong-scars-amidst-collapsed-healthcare.jpg",
    date: "2026-04-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-some-form-of-social-media-restrictions-for-under-16s-minister",
    title: "Global Health and Education Watch: 'Some form' of social media restrictions for under-16s, minister",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-28-global-health-and-education-watch-some-form-of-social-media-restrictions-for-und.jpg",
    date: "2026-04-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-italy-extradites-chinese-cyber-espionage-suspect-to-us",
    title: "Global Health and Education Watch: Italy extradites Chinese cyber-espionage suspect to US",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-28-global-health-and-education-watch-italy-extradites-chinese-cyber-espionage-suspe.jpg",
    date: "2026-04-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-afghanistan-risks-losing-25-000-women-teachers-and-health-workers",
    title: "Global Health and Education Watch: Afghanistan risks losing 25,000 women teachers and health workers",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-28-global-health-and-education-watch-afghanistan-risks-losing-25-000-women-teachers.jpg",
    date: "2026-04-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-has-wealthy-europe-s-third-highest-rate-of-young-adults",
    title: "Global Health and Education Watch: UK has wealthy Europe’s ‘third-highest’ rate of young adults",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-28-global-health-and-education-watch-uk-has-wealthy-europe-s-third-highest-rate-of-.jpg",
    date: "2026-04-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-quest-for-longevity-does-wealth-buy-health-and-extended-life",
    title: "Global Quest for Longevity: Does Wealth Buy Health and Extended Life?",
    summary:
      "The global desire for extended, healthier lives has fueled a massive wellness industry offering myriad services and supplements. This article examines the efficacy of these costly interventions versus foundational health practices.",
    thumbnailImage: "/images/global-news/2026/2026-04-27-global-quest-for-longevity-does-wealth-buy-health-and-extended-life.jpg",
    date: "2026-04-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "who-director-general-lauds-jordan-s-health-progress-and-global-partnership",
    title: "WHO Director-General Lauds Jordan's Health Progress and Global Partnership",
    summary:
      "The World Health Organization's Director-General, Dr. Tedros Adhanom Ghebreyesus, recently concluded a significant visit to Jordan, reinforcing a strong partnership. His trip underscored Jordan's advancements in health system delivery, emergency relief, and the critical area of mental health.",
    thumbnailImage: "/images/global-news/2026/2026-04-27-who-director-general-lauds-jordan-s-health-progress-and-global-partnership.jpg",
    date: "2026-04-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "school-pe-trauma-a-global-barrier-to-lifelong-health-and-movement",
    title: "School PE Trauma: A Global Barrier to Lifelong Health and Movement",
    summary:
      "Negative experiences in school physical education can lead to a lifelong aversion to exercise, contributing to global health crises. A paradigm shift in PE is crucial to foster a love for movement and combat sedentary lifestyles worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-27-school-pe-trauma-a-global-barrier-to-lifelong-health-and-movement.jpg",
    date: "2026-04-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-subtle-but-powerful-form-of-self-validation-how-to-start",
    title: "Global Health and Education Watch: ‘Subtle but powerful form of self-validation’: how to start",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-27-global-health-and-education-watch-subtle-but-powerful-form-of-self-validation-ho.jpg",
    date: "2026-04-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cellular-rejuvenation-has-the-potential-to-reverse-aging",
    title: "Global Health and Education Watch: Cellular Rejuvenation Has the Potential to Reverse Aging",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-27-global-health-and-education-watch-cellular-rejuvenation-has-the-potential-to-rev.jpg",
    date: "2026-04-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "sleep-rebound-after-restriction-linked-to-lower-mortality-risk",
    title: "Sleep Rebound After Restriction Linked to Lower Mortality Risk",
    summary:
      "Groundbreaking research published in Nature Communications indicates that acute sleep rebound following periods of sleep restriction is associated with a reduced risk of mortality. This finding suggests that the body's ability to recover lost sleep plays a crucial role in long-term health and survival.",
    thumbnailImage: "/images/global-news/2026/2026-04-27-sleep-rebound-after-restriction-linked-to-lower-mortality-risk.jpg",
    date: "2026-04-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-warning-healthy-life-expectancy-declines-amidst-widespread-challenges",
    title: "Global Health Warning: Healthy Life Expectancy Declines Amidst Widespread Challenges",
    summary:
      "A recent decline in healthy life expectancy in developed nations signals a worrying global trend. Underlying factors like deprivation, poor housing, and obesity are universally eroding years of good health, necessitating a concerted international response.",
    thumbnailImage: "/images/global-news/2026/2026-04-27-global-health-warning-healthy-life-expectancy-declines-amidst-widespread-challen.jpg",
    date: "2026-04-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-war-and-neglect-fuel-deadly-measles-epidemic-in-sudan-s",
    title: "Global Health and Education Watch: War and neglect fuel deadly measles epidemic in Sudan’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-27-global-health-and-education-watch-war-and-neglect-fuel-deadly-measles-epidemic-i.jpg",
    date: "2026-04-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "healthcare-s-global-economic-footprint-a-double-edged-sword",
    title: "Healthcare's Global Economic Footprint: A Double-Edged Sword",
    summary:
      "Healthcare has become a dominant force in the global economy, fueling growth and employment across nations. However, this expansion also brings escalating costs and significant disparities in access and affordability.",
    thumbnailImage: "/images/global-news/2026/2026-04-27-healthcare-s-global-economic-footprint-a-double-edged-sword.jpg",
    date: "2026-04-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-conflicts-undermine-health-education-systems",
    title: "Global Conflicts Undermine Health, Education Systems",
    summary:
      "Recent violence in Mali, including the killing of its defence minister, highlights the severe threats posed by insurgencies to critical health and education infrastructure. Such conflicts globally disrupt essential services, displacing populations and hindering long-term development efforts.",
    thumbnailImage: "/images/global-news/2026/2026-04-27-global-conflicts-undermine-health-education-systems.jpg",
    date: "2026-04-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-foot-health-crisis-ill-fitting-children-s-shoes-cause-rising-ailments",
    title: "Global Foot Health Crisis: Ill-Fitting Children's Shoes Cause Rising Ailments",
    summary:
      "A global health concern is emerging as experts report an increase in childhood foot conditions like bunions, primarily linked to ill-fitting footwear. The decline of specialist children's shoe shops leaves many parents without crucial fitting advice, jeopardizing long-term foot health.",
    thumbnailImage: "/images/global-news/2026/2026-04-26-global-foot-health-crisis-ill-fitting-children-s-shoes-cause-rising-ailments.jpg",
    date: "2026-04-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "brain-science-unlocks-global-media-engagement-secrets",
    title: "Brain Science Unlocks Global Media Engagement Secrets",
    summary:
      "A groundbreaking project at the University of Bristol tracks brain activity and physiological responses to understand deep viewer engagement with media. This innovative research aims to provide data-driven insights for creators globally, enhancing educational content, public health messaging, and overall cognitive well-being.",
    thumbnailImage: "/images/global-news/2026/2026-04-26-brain-science-unlocks-global-media-engagement-secrets.jpg",
    date: "2026-04-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-government-move-to-delay-social-media-ban-faces",
    title: "Global Health and Education Watch: UK government move to delay social media ban faces",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-26-global-health-and-education-watch-uk-government-move-to-delay-social-media-ban-f.jpg",
    date: "2026-04-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-unitedhealth-group-reports-flat-earnings-in-the-first-quarter",
    title: "Global Health and Education Watch: UnitedHealth Group Reports Flat Earnings in the First Quarter",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-26-global-health-and-education-watch-unitedhealth-group-reports-flat-earnings-in-th.jpg",
    date: "2026-04-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ban-fur-farming-or-risk-a-new-pandemic",
    title: "Global Health and Education Watch: Ban fur farming or risk a new pandemic |",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-26-global-health-and-education-watch-ban-fur-farming-or-risk-a-new-pandemic.jpg",
    date: "2026-04-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "libya-eradicates-trachoma-a-global-health-milestone",
    title: "Libya Eradicates Trachoma, A Global Health Milestone",
    summary:
      "Libya has achieved a significant public health victory, eliminating trachoma as a public health problem, as validated by the World Health Organization. This landmark accomplishment safeguards future generations from preventable blindness and underscores the global commitment to overcoming neglected tropical diseases.",
    thumbnailImage: "/images/global-news/2026/2026-04-26-libya-eradicates-trachoma-a-global-health-milestone.jpg",
    date: "2026-04-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-a-a-u-p-is-growing-fast-as-it-ramps-up",
    title: "Global Health and Education Watch: The A.A.U.P. Is Growing Fast as It Ramps Up",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-26-global-health-and-education-watch-the-a-a-u-p-is-growing-fast-as-it-ramps-up.jpg",
    date: "2026-04-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-are-people-pumping-their-bodies-with-fat-from",
    title: "Global Health and Education Watch: Why are people pumping their bodies with fat from",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-26-global-health-and-education-watch-why-are-people-pumping-their-bodies-with-fat-f.jpg",
    date: "2026-04-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-truth-about-cooking-oils-14-essential-facts-for",
    title: "Global Health and Education Watch: The truth about cooking oils: 14 essential facts for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-26-global-health-and-education-watch-the-truth-about-cooking-oils-14-essential-fact.jpg",
    date: "2026-04-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-scrolling-and-worrying-the-hidden-dangers-of-diy-diagnosis",
    title: "Global Health and Education Watch: Scrolling and worrying: the hidden dangers of DIY diagnosis",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-26-global-health-and-education-watch-scrolling-and-worrying-the-hidden-dangers-of-d.jpg",
    date: "2026-04-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-accord-negotiations-extended-on-critical-pandemic-annex",
    title: "Global Health Accord Negotiations Extended on Critical Pandemic Annex",
    summary:
      "WHO Member States have agreed to extend crucial negotiations on the Pathogen Access and Benefit Sharing (PABS) annex to the Pandemic Agreement. Discussions will resume in late April, aiming for a robust consensus before the World Health Assembly's scheduled consideration in May.",
    thumbnailImage: "/images/global-news/2026/2026-04-26-global-health-accord-negotiations-extended-on-critical-pandemic-annex.jpg",
    date: "2026-04-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-alarm-rises-over-politicization-of-drug-pricing-decisions",
    title: "Global Alarm Rises Over Politicization of Drug Pricing Decisions",
    summary:
      "A recent policy shift allowing direct government intervention in drug pricing, bypassing independent health technology assessments, has sparked global concern. Critics fear such moves could compromise healthcare integrity, benefit pharmaceutical giants, and jeopardize patient access to vital treatments.",
    thumbnailImage: "/images/global-news/2026/2026-04-26-global-alarm-rises-over-politicization-of-drug-pricing-decisions.jpg",
    date: "2026-04-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-from-syringes-to-stents-iran-war-exposes-nhs-dependency",
    title: "Global Health and Education Watch: From syringes to stents: Iran war exposes NHS dependency",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-26-global-health-and-education-watch-from-syringes-to-stents-iran-war-exposes-nhs-d.jpg",
    date: "2026-04-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-recommendations-for-influenza-vaccine-composition-for-the-2026-2027-northern-3",
    title: "Global Health and Education Watch: Recommendations for influenza vaccine composition for the 2026-2027 northern",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-26-global-health-and-education-watch-recommendations-for-influenza-vaccine-composit.jpg",
    date: "2026-04-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-i-m-out-of-a-job-after-issues-at-the",
    title: "Global Health and Education Watch: I’m out of a job after issues at the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-26-global-health-and-education-watch-i-m-out-of-a-job-after-issues-at-the.jpg",
    date: "2026-04-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-i-paid-for-a-private-hysterectomy",
    title: "Global Health and Education Watch: 'I paid for a private hysterectomy'",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-26-global-health-and-education-watch-i-paid-for-a-private-hysterectomy.jpg",
    date: "2026-04-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "new-bacterial-discovery-offers-hope-against-deadly-childhood-disease-noma",
    title: "New Bacterial Discovery Offers Hope Against Deadly Childhood Disease Noma",
    summary:
      "An unprecedented bacterial species has been identified in patients suffering from noma, a severe neglected tropical disease. This breakthrough offers significant potential for developing more effective interventions against the devastating childhood condition.",
    thumbnailImage: "/images/global-news/2026/2026-04-26-new-bacterial-discovery-offers-hope-against-deadly-childhood-disease-noma.jpg",
    date: "2026-04-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-families-of-iranian-children-killed-in-school-airstrike-pen",
    title: "Global Health and Education Watch: Families of Iranian Children Killed in School Airstrike Pen",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-25-global-health-and-education-watch-families-of-iranian-children-killed-in-school-.jpg",
    date: "2026-04-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-schools-forced-to-cut-back-on-support-for-send",
    title: "Global Health and Education Watch: Schools forced to cut back on support for Send",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-25-global-health-and-education-watch-schools-forced-to-cut-back-on-support-for-send.jpg",
    date: "2026-04-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-eugene-braunwald-whose-research-reshaped-cardiology-dies-at-96",
    title: "Global Health and Education Watch: Eugene Braunwald, Whose Research Reshaped Cardiology, Dies at 96",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-25-global-health-and-education-watch-eugene-braunwald-whose-research-reshaped-cardi.jpg",
    date: "2026-04-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "texas-camp-tragedy-prompts-global-review-of-youth-safety-protocols",
    title: "Texas Camp Tragedy Prompts Global Review of Youth Safety Protocols",
    summary:
      "A Texas summer camp where 27 individuals died in a 2025 flood faces potential closure due to unmet health and safety requirements. This incident highlights critical global challenges in ensuring robust emergency protocols and regulatory oversight for youth facilities.",
    thumbnailImage: "/images/global-news/2026/2026-04-25-texas-camp-tragedy-prompts-global-review-of-youth-safety-protocols.jpg",
    date: "2026-04-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-healthcare-under-siege-protecting-frontline-workers-and-sacred-spaces",
    title: "Global Healthcare Under Siege: Protecting Frontline Workers and Sacred Spaces",
    summary:
      "A tragic incident at a Chicago hospital, resulting in the death of a police officer and critical injury to another, highlights the escalating global issue of violence impacting healthcare environments. This event serves as a stark reminder of the imperative to safeguard medical professionals and patients from harm.",
    thumbnailImage: "/images/global-news/2026/2026-04-25-global-healthcare-under-siege-protecting-frontline-workers-and-sacred-spaces.jpg",
    date: "2026-04-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "england-s-school-meal-overhaul-sparks-global-debate-on-child-nutrition",
    title: "England's School Meal Overhaul Sparks Global Debate on Child Nutrition",
    summary:
      "A new initiative to enhance school meal nutrition in England faces significant pushback from caterers, who warn of service disruptions and increased costs. This development underscores the complex global dilemma of balancing children's health with the practicalities of food provision in educational settings.",
    thumbnailImage: "/images/global-news/2026/2026-04-25-england-s-school-meal-overhaul-sparks-global-debate-on-child-nutrition.jpg",
    date: "2026-04-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "youths-plead-guilty-in-harvard-medical-school-lab-explosion",
    title: "Youths Plead Guilty in Harvard Medical School Lab Explosion",
    summary:
      "Two young men, Logan David Patterson and Dominick Frank Cardoza, have pleaded guilty to charges stemming from a November incident involving the detonation of a commercial firework in a Harvard Medical School research laboratory. The event underscores critical discussions on campus security and the protection of vital scientific infrastructure worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-25-youths-plead-guilty-in-harvard-medical-school-lab-explosion.jpg",
    date: "2026-04-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "student-heroism-on-school-bus-a-global-call-for-emergency-preparedness",
    title: "Student Heroism on School Bus: A Global Call for Emergency Preparedness",
    summary:
      "In a remarkable act of bravery, middle school students in Mississippi averted a potential tragedy by safely stopping their bus after the driver lost consciousness. This incident underscores the urgent global imperative for comprehensive emergency preparedness and health education within school systems.",
    thumbnailImage: "/images/global-news/2026/2026-04-25-student-heroism-on-school-bus-a-global-call-for-emergency-preparedness.jpg",
    date: "2026-04-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-roommate-charged-with-murder-in-deaths-of-university-of",
    title: "Global Health and Education Watch: Roommate charged with murder in deaths of University of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-25-global-health-and-education-watch-roommate-charged-with-murder-in-deaths-of-univ.jpg",
    date: "2026-04-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "native-hawaiian-medical-scholarship-faces-discrimination-lawsuit-threatening-decades-of-progress",
    title: "Native Hawaiian Medical Scholarship Faces Discrimination Lawsuit, Threatening Decades of Progress",
    summary:
      "A federal scholarship program vital to Native Hawaiian healthcare for over 35 years is facing a discrimination lawsuit from a conservative group. This legal challenge threatens to dismantle a crucial pathway for medical students serving Hawaii's underserved communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-25-native-hawaiian-medical-scholarship-faces-discrimination-lawsuit-threatening-dec.jpg",
    date: "2026-04-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "digital-communication-s-subtle-strain-on-global-mental-health",
    title: "Digital Communication's Subtle Strain on Global Mental Health",
    summary:
      "The pervasive nature of digital communication, even beyond social media, is subtly eroding global mental well-being by fostering an 'always-on' culture. This constant connectivity blurs personal and professional boundaries, contributing to widespread stress and mental fatigue.",
    thumbnailImage: "/images/global-news/2026/2026-04-25-digital-communication-s-subtle-strain-on-global-mental-health.jpg",
    date: "2026-04-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-senior-lucy-letby-hospital-boss-arrested",
    title: "Global Health and Education Watch: Senior Lucy Letby hospital boss arrested",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-25-global-health-and-education-watch-senior-lucy-letby-hospital-boss-arrested.jpg",
    date: "2026-04-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "chile-achieves-historic-leprosy-elimination-inspiring-global-health-efforts-2",
    title: "Chile Achieves Historic Leprosy Elimination, Inspiring Global Health Efforts",
    summary:
      "Chile has been officially verified by the World Health Organization (WHO) as having eliminated leprosy, marking a significant public health milestone. This achievement positions Chile as the first country in the Americas and only the second globally to reach this critical benchmark.",
    thumbnailImage: "/images/global-news/2026/2026-04-25-chile-achieves-historic-leprosy-elimination-inspiring-global-health-efforts.jpg",
    date: "2026-04-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-as-trump-officials-pushed-health-savings-accounts-rfk-jr",
    title: "Global Health and Education Watch: As Trump Officials Pushed Health Savings Accounts, RFK Jr",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-25-global-health-and-education-watch-as-trump-officials-pushed-health-savings-accou.jpg",
    date: "2026-04-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ireland-demands-israel-compensate-for-demolished-palestinian-school",
    title: "Ireland Demands Israel Compensate for Demolished Palestinian School",
    summary:
      "Ireland has formally demanded that Israeli authorities reimburse the costs of a Palestinian school in the West Bank, which was demolished by settlers. This move underscores growing international concern over the destruction of critical educational infrastructure in occupied territories.",
    thumbnailImage: "/images/global-news/2026/2026-04-25-ireland-demands-israel-compensate-for-demolished-palestinian-school.jpg",
    date: "2026-04-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-schoolboys-fatal-hike-remembered-in-black-forest-90",
    title: "Global Health and Education Watch: UK schoolboys’ fatal hike remembered in Black Forest 90",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-25-global-health-and-education-watch-uk-schoolboys-fatal-hike-remembered-in-black-f.jpg",
    date: "2026-04-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "gaza-s-health-crisis-deepens-amid-recovery-hurdles-unexploded-ordnance-threat",
    title: "Gaza's Health Crisis Deepens Amid Recovery Hurdles, Unexploded Ordnance Threat",
    summary:
      "Gaza faces a deepening humanitarian catastrophe, with critical health services crippled and recovery efforts severely hampered by ongoing dangers. UN experts highlight the immense threat posed by widespread unexploded ordnance, barely surveyed, complicating any return to normalcy.",
    thumbnailImage: "/images/global-news/2026/2026-04-25-gaza-s-health-crisis-deepens-amid-recovery-hurdles-unexploded-ordnance-threat.jpg",
    date: "2026-04-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-education-shifts-los-angeles-curbs-student-screen-time",
    title: "Global Education Shifts: Los Angeles Curbs Student Screen Time",
    summary:
      "The Los Angeles Unified School District has voted to implement strict new screen time limits for students, including device bans during breaks and classroom restrictions. This move signals a significant global trend towards re-evaluating technology's role in education and safeguarding student well-being.",
    thumbnailImage: "/images/global-news/2026/2026-04-25-global-education-shifts-los-angeles-curbs-student-screen-time.jpg",
    date: "2026-04-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "grief-s-ultimate-toll-mother-seeks-assisted-death-amidst-global-debate",
    title: "Grief's Ultimate Toll: Mother Seeks Assisted Death Amidst Global Debate",
    summary:
      "A mother, profoundly affected by her son's death, traveled to a Swiss clinic for assisted dying, highlighting the global complexities of end-of-life choices. Her case underscores the intense debate surrounding grief, mental health, and the legal landscape of assisted dying worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-24-grief-s-ultimate-toll-mother-seeks-assisted-death-amidst-global-debate.jpg",
    date: "2026-04-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "tragic-discovery-rocks-usf-roommate-held-after-student-found-deceased",
    title: "Tragic Discovery Rocks USF: Roommate Held After Student Found Deceased",
    summary:
      "The discovery of a Bangladeshi doctoral student's body near a Tampa Bay bridge has led to the arrest of his roommate. This tragic event has intensified the search for another missing student and sparked urgent discussions about international student welfare and safety at universities worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-24-tragic-discovery-rocks-usf-roommate-held-after-student-found-deceased.jpg",
    date: "2026-04-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-officials-investigate-n-y-c-schools-over-pro-palestinian-group",
    title: "Global Health and Education Watch: Trump Officials Investigate N.Y.C. Schools Over Pro-Palestinian Group",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-24-global-health-and-education-watch-trump-officials-investigate-n-y-c-schools-over.jpg",
    date: "2026-04-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-biobank-health-data-listed-for-sale-in-china",
    title: "Global Health and Education Watch: UK Biobank health data listed for sale in China",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-24-global-health-and-education-watch-uk-biobank-health-data-listed-for-sale-in-chin.jpg",
    date: "2026-04-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-prequalifies-first-ever-malaria-treatment-for-newborns-and-infants",
    title: "Global Health and Education Watch: WHO prequalifies first-ever malaria treatment for newborns and infants",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-24-global-health-and-education-watch-who-prequalifies-first-ever-malaria-treatment-.jpg",
    date: "2026-04-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-for-every-generation-vaccines-work-and-they-have-saved",
    title: "Global Health and Education Watch: For every generation, vaccines work and they have saved",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-24-global-health-and-education-watch-for-every-generation-vaccines-work-and-they-ha.jpg",
    date: "2026-04-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-health-secretary-s-son-launches-investment-fund-tied-to",
    title: "Global Health and Education Watch: US health secretary’s son launches investment fund tied to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-24-global-health-and-education-watch-us-health-secretary-s-son-launches-investment-.jpg",
    date: "2026-04-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "gaza-s-silent-crisis-children-losing-their-voices-amidst-unspeakable-trauma",
    title: "Gaza's Silent Crisis: Children Losing Their Voices Amidst Unspeakable Trauma",
    summary:
      "An estimated one million children in Gaza urgently require mental health support, as a growing number are losing their ability to speak due to profound trauma. This crisis highlights the devastating, long-term psychological impact of conflict on young populations worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-24-gaza-s-silent-crisis-children-losing-their-voices-amidst-unspeakable-trauma.jpg",
    date: "2026-04-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-gambling-addiction-is-out-of-control-as-betting",
    title: "Global Health and Education Watch: US gambling addiction is ‘out of control’ as betting",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-24-global-health-and-education-watch-us-gambling-addiction-is-out-of-control-as-bet.jpg",
    date: "2026-04-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-mamdani-expected-to-reject-bill-involving-police-at-school",
    title: "Global Health and Education Watch: Mamdani Expected to Reject Bill Involving Police at School",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-24-global-health-and-education-watch-mamdani-expected-to-reject-bill-involving-poli.jpg",
    date: "2026-04-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "surprising-pint-beer-s-unexpected-brain-boosting-vitamin-contribution-revealed",
    title: "Surprising Pint: Beer's Unexpected Brain-Boosting Vitamin Contribution Revealed",
    summary:
      "Groundbreaking research published in a respected journal indicates that moderate beer consumption may contribute substantial levels of essential brain-boosting vitamins to one's diet. This finding prompts a global conversation on the nuanced relationship between fermented beverages, nutrition, and public health, underscoring the critical importance of moderation.",
    thumbnailImage: "/images/global-news/2026/2026-04-24-surprising-pint-beer-s-unexpected-brain-boosting-vitamin-contribution-revealed.jpg",
    date: "2026-04-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-algeria-eliminates-trachoma-as-a-public-health-problem",
    title: "Global Health and Education Watch: Algeria eliminates trachoma as a public health problem",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-24-global-health-and-education-watch-algeria-eliminates-trachoma-as-a-public-health.jpg",
    date: "2026-04-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-largest-catch-up-initiative-delivers-over-100-million-childhood-vaccinations",
    title: "Global Health and Education Watch: Largest catch-up initiative delivers over 100 million childhood vaccinations",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-24-global-health-and-education-watch-largest-catch-up-initiative-delivers-over-100-.jpg",
    date: "2026-04-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "south-lebanon-hospital-devastated-un-mission-reveals-dire-health-crisis",
    title: "South Lebanon Hospital Devastated: UN Mission Reveals Dire Health Crisis",
    summary:
      "A recent United Nations Children's Fund (UNICEF) mission to southern Lebanon's Tebnine region revealed widespread destruction, particularly impacting a major hospital. The assessment underscores the critical need for immediate humanitarian aid and long-term reconstruction efforts to restore essential health services.",
    thumbnailImage: "/images/global-news/2026/2026-04-24-south-lebanon-hospital-devastated-un-mission-reveals-dire-health-crisis.jpg",
    date: "2026-04-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-make-america-healthy-again-movement-is-cooling-on",
    title: "Global Health and Education Watch: The ‘Make America Healthy Again’ Movement Is Cooling on",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-24-global-health-and-education-watch-the-make-america-healthy-again-movement-is-coo.jpg",
    date: "2026-04-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "university-sued-over-professor-arrests-during-pro-palestine-campus-protests",
    title: "University Sued Over Professor Arrests During Pro-Palestine Campus Protests",
    summary:
      "A philosophy professor and colleagues have initiated legal action against their university, alleging a failure to safeguard students and staff during a crackdown on pro-Palestine protests. The lawsuit highlights growing global tensions between academic institutions and their communities regarding freedom of expression.",
    thumbnailImage: "/images/global-news/2026/2026-04-24-university-sued-over-professor-arrests-during-pro-palestine-campus-protests.jpg",
    date: "2026-04-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "uk-health-data-scandal-half-million-patient-records-allegedly-for-sale-in-china",
    title: "UK Health Data Scandal: Half-Million Patient Records Allegedly For Sale in China",
    summary:
      "Sensitive health data belonging to half a million participants in a prominent UK research project was reportedly discovered for sale on a Chinese e-commerce site. This alarming incident has ignited serious concerns regarding data security, patient privacy, and the international governance of biomedical information.",
    thumbnailImage: "/images/global-news/2026/2026-04-23-uk-health-data-scandal-half-million-patient-records-allegedly-for-sale-in-china.jpg",
    date: "2026-04-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-call-for-enhanced-maternal-safety-after-tragic-home-birth-fatality",
    title: "Global Call for Enhanced Maternal Safety After Tragic Home Birth Fatality",
    summary:
      "A devastating case involving the death of an infant following an 'unsafe' home birth has brought renewed scrutiny to global maternal healthcare standards. The incident, where medical advice was reportedly overridden, emphasizes the critical need for robust patient safety protocols and transparent communication worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-23-global-call-for-enhanced-maternal-safety-after-tragic-home-birth-fatality.jpg",
    date: "2026-04-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-reports-measurable-health-impact-in-2025-amid-transition",
    title: "Global Health and Education Watch: WHO reports measurable health impact in 2025 amid transition",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-23-global-health-and-education-watch-who-reports-measurable-health-impact-in-2025-a.jpg",
    date: "2026-04-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-progress-defies-funding-challenges-who-report-reveals",
    title: "Global Health Progress Defies Funding Challenges, WHO Report Reveals",
    summary:
      "The World Health Organization's 2025 Results Report indicates remarkable health gains for hundreds of millions globally, achieved despite considerable funding reductions. This highlights the organization's strategic resilience and the enduring impact of international health initiatives amidst financial pressures.",
    thumbnailImage: "/images/global-news/2026/2026-04-23-global-health-progress-defies-funding-challenges-who-report-reveals.jpg",
    date: "2026-04-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "iran-school-bombing-the-lingering-shadow-of-a-missing-child",
    title: "Iran School Bombing: The Lingering Shadow of a Missing Child",
    summary:
      "The case of Makan Nasiri, a seven-year-old boy missing after a school bombing in Iran, has been closed by authorities, leaving his parents without closure. His disappearance highlights the profound and tragic impact of conflict on children and educational institutions globally.",
    thumbnailImage: "/images/global-news/2026/2026-04-23-iran-school-bombing-the-lingering-shadow-of-a-missing-child.jpg",
    date: "2026-04-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-kathy-attawell-obituary",
    title: "Global Health and Education Watch: Kathy Attawell obituary",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-23-global-health-and-education-watch-kathy-attawell-obituary.jpg",
    date: "2026-04-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "new-therapies-offer-hope-in-global-fight-against-pancreatic-cancer",
    title: "New Therapies Offer Hope in Global Fight Against Pancreatic Cancer",
    summary:
      "Recent clinical trials have unveiled two distinct experimental treatments demonstrating encouraging potential against pancreatic cancer, a notoriously aggressive disease. These developments offer a crucial glimmer of hope for patients globally, where current therapeutic options remain limited.",
    thumbnailImage: "/images/global-news/2026/2026-04-23-new-therapies-offer-hope-in-global-fight-against-pancreatic-cancer.jpg",
    date: "2026-04-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-your-pint-could-come-with-a-surprising-health-benefit",
    title: "Global Health and Education Watch: Your pint could come with a surprising health benefit",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-23-global-health-and-education-watch-your-pint-could-come-with-a-surprising-health-.jpg",
    date: "2026-04-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-certifies-the-bahamas-for-eliminating-mother-to-child-transmission-of",
    title: "Global Health and Education Watch: WHO certifies the Bahamas for eliminating mother-to-child transmission of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-23-global-health-and-education-watch-who-certifies-the-bahamas-for-eliminating-moth.jpg",
    date: "2026-04-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-i-was-wrong-about-the-danger-of-smartphones-in",
    title: "Global Health and Education Watch: I was wrong about the danger of smartphones in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-23-global-health-and-education-watch-i-was-wrong-about-the-danger-of-smartphones-in.jpg",
    date: "2026-04-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-restrictions-on-transgender-students-violated-law-new-york-finds",
    title: "Global Health and Education Watch: Restrictions on Transgender Students Violated Law, New York Finds",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-23-global-health-and-education-watch-restrictions-on-transgender-students-violated-.jpg",
    date: "2026-04-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "west-bank-funeral-disrupted-by-tear-gas-raising-health-and-education-concerns",
    title: "West Bank Funeral Disrupted by Tear Gas, Raising Health and Education Concerns",
    summary:
      "A funeral for two Palestinians, reportedly killed by settlers, was disrupted by Israeli forces firing tear gas at a West Bank school. This incident underscores the profound challenges to community well-being and educational stability in conflict-affected regions.",
    thumbnailImage: "/images/global-news/2026/2026-04-22-west-bank-funeral-disrupted-by-tear-gas-raising-health-and-education-concerns.jpg",
    date: "2026-04-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "steering-ai-s-future-global-regulation-crucial-for-health-and-education",
    title: "Steering AI's Future: Global Regulation Crucial for Health and Education",
    summary:
      "Artificial Intelligence pioneer Geoffrey Hinton warns that unregulated AI resembles a powerful vehicle without control, necessitating urgent global governance. This call underscores the critical need for frameworks to ethically guide AI's transformative potential in global health and education.",
    thumbnailImage: "/images/global-news/2026/2026-04-22-steering-ai-s-future-global-regulation-crucial-for-health-and-education.jpg",
    date: "2026-04-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-calls-for-clarity-over-schools-smartphone-ban",
    title: "Global Health and Education Watch: Calls for clarity over schools smartphone ban",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-22-global-health-and-education-watch-calls-for-clarity-over-schools-smartphone-ban.jpg",
    date: "2026-04-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-palestinian-boy-14-among-two-killed-in-settler-attack",
    title: "Global Health and Education Watch: Palestinian boy, 14, among two killed in settler attack",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-22-global-health-and-education-watch-palestinian-boy-14-among-two-killed-in-settler.jpg",
    date: "2026-04-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-long-hours-stress-and-harassment-are-causing-hundreds-of",
    title: "Global Health and Education Watch: Long hours, stress and harassment are causing hundreds of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-22-global-health-and-education-watch-long-hours-stress-and-harassment-are-causing-h.jpg",
    date: "2026-04-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "west-bank-children-face-daily-obstacles-to-education-amidst-settler-blockades",
    title: "West Bank Children Face Daily Obstacles to Education Amidst Settler Blockades",
    summary:
      "In the West Bank, Palestinian children face daily impediments to accessing education, as Israeli settlers reportedly block their path to school. This ongoing disruption has led to peaceful daily sit-ins by students, teachers, and families near Umm al-Khair village, highlighting a critical challenge to fundamental educational rights.",
    thumbnailImage: "/images/global-news/2026/2026-04-22-west-bank-children-face-daily-obstacles-to-education-amidst-settler-blockades.jpg",
    date: "2026-04-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-attacks-on-ukraine-s-health-care-increased-by-20-in-3",
    title: "Global Health and Education Watch: Attacks on Ukraine’s health care increased by 20% in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-22-global-health-and-education-watch-attacks-on-ukraine-s-health-care-increased-by-.jpg",
    date: "2026-04-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-study-links-dietary-intake-to-women-s-infertility",
    title: "Global Study Links Dietary Intake to Women's Infertility",
    summary:
      "A recent global study published in Nature reveals significant links between dietary nutrient intake, nutritional status, and infertility in women. The findings underscore the urgent need for comprehensive nutritional strategies to support reproductive health.",
    thumbnailImage: "/images/global-news/2026/2026-04-22-global-study-links-dietary-intake-to-women-s-infertility.jpg",
    date: "2026-04-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-security-under-scrutiny-amid-vaccine-policy-disagreements",
    title: "Global Health Security Under Scrutiny Amid Vaccine Policy Disagreements",
    summary:
      "A recent high-profile refusal to endorse a public health leader's vaccine stance highlights growing global challenges to immunization efforts. This political friction emerges as vaccine-preventable diseases, like measles, experience alarming resurgences across various nations.",
    thumbnailImage: "/images/global-news/2026/2026-04-22-global-health-security-under-scrutiny-amid-vaccine-policy-disagreements.jpg",
    date: "2026-04-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-education-systems-grapple-with-falling-birth-rates-and-surplus-school-places",
    title: "Global Education Systems Grapple with Falling Birth Rates and Surplus School Places",
    summary:
      "Nations globally face a critical juncture as declining birth rates lead to an unprecedented surplus of school places, threatening funding and infrastructure. Proactive policy and integrated planning are urgently needed to avert widespread disruption to education systems.",
    thumbnailImage: "/images/global-news/2026/2026-04-22-global-education-systems-grapple-with-falling-birth-rates-and-surplus-school-pla.jpg",
    date: "2026-04-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "avian-flu-vaccine-trial-advances-global-pandemic-preparedness",
    title: "Avian Flu Vaccine Trial Advances Global Pandemic Preparedness",
    summary:
      "A significant human trial has commenced for a vaccine designed to combat the H5N1 avian influenza strain, a virus devastating bird populations globally. This proactive measure aims to prepare the world for a potential pandemic, though the virus has not yet demonstrated sustained human-to-human spread.",
    thumbnailImage: "/images/global-news/2026/2026-04-22-avian-flu-vaccine-trial-advances-global-pandemic-preparedness.jpg",
    date: "2026-04-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "west-bank-school-shooting-kills-child-raises-global-education-and-health-concerns",
    title: "West Bank School Shooting Kills Child, Raises Global Education and Health Concerns",
    summary:
      "Two Palestinians, including a child, were killed in an Israeli shooting near a West Bank school, according to the Palestinian health ministry. The incident in Al Mughayir, a village experiencing increased settler violence, highlights grave concerns for civilian health and education in conflict zones.",
    thumbnailImage: "/images/global-news/2026/2026-04-22-west-bank-school-shooting-kills-child-raises-global-education-and-health-concern.jpg",
    date: "2026-04-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-paradox-students-trained-but-jobs-scarce",
    title: "Global Health Paradox: Students Trained, But Jobs Scarce",
    summary:
      "Across various nations, a concerning trend is emerging where healthcare systems invest heavily in training professionals, only for graduates to face significant challenges securing employment. This paradox highlights systemic failures in long-term workforce planning and resource allocation within the global health sector.",
    thumbnailImage: "/images/global-news/2026/2026-04-22-global-health-paradox-students-trained-but-jobs-scarce.jpg",
    date: "2026-04-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-sudan-refugees-returning-home-face-new-struggle-for-survival",
    title: "Global Health and Education Watch: Sudan refugees returning home face new ‘struggle for survival’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-21-global-health-and-education-watch-sudan-refugees-returning-home-face-new-struggl.jpg",
    date: "2026-04-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-economic-collapse-pushes-highly-educated-gazans-into-the-survival",
    title: "Global Health and Education Watch: Economic collapse pushes highly educated Gazans into the ‘survival",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-21-global-health-and-education-watch-economic-collapse-pushes-highly-educated-gazan.jpg",
    date: "2026-04-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "malaria-deaths-rise-amidst-vaccine-promise-a-global-health-paradox",
    title: "Malaria Deaths Rise Amidst Vaccine Promise: A Global Health Paradox",
    summary:
      "The global health community grapples with a paradoxical rise in malaria deaths, even as innovative vaccines offer new hope. This alarming trend underscores the complex interplay of environmental, biological, and systemic factors hindering progress against the ancient disease.",
    thumbnailImage: "/images/global-news/2026/2026-04-21-malaria-deaths-rise-amidst-vaccine-promise-a-global-health-paradox.jpg",
    date: "2026-04-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-encouraging-progress-in-inclusive-health-policies-for-refugees-and",
    title: "Global Health and Education Watch: Encouraging progress in inclusive health policies for refugees and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-21-global-health-and-education-watch-encouraging-progress-in-inclusive-health-polic.jpg",
    date: "2026-04-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "us-military-ends-mandatory-flu-vaccine-for-soldiers",
    title: "US Military Ends Mandatory Flu Vaccine for Soldiers",
    summary:
      "The US military has ceased mandatory flu vaccinations for its personnel, citing principles of 'medical autonomy' and criticizing previous mandates as 'overreaching'. This policy shift initiates a broader global discussion on individual health rights versus collective military readiness and public health imperatives.",
    thumbnailImage: "/images/global-news/2026/2026-04-21-us-military-ends-mandatory-flu-vaccine-for-soldiers.jpg",
    date: "2026-04-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "chinese-student-jailed-after-australian-protests-sparks-global-concern-over-academic-freedom",
    title: "Chinese Student Jailed After Australian Protests, Sparks Global Concern Over Academic Freedom",
    summary:
      "An international student has reportedly been sentenced to six years in prison in China after participating in pro-democracy protests in Australia. This incident has prompted urgent calls for the Australian government to enhance protections for overseas students against political repression.",
    thumbnailImage: "/images/global-news/2026/2026-04-21-chinese-student-jailed-after-australian-protests-sparks-global-concern-over-acad.jpg",
    date: "2026-04-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tuesday-briefing-what-it-might-take-for-lasting-peace",
    title: "Global Health and Education Watch: Tuesday briefing: What it might take for lasting peace",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-21-global-health-and-education-watch-tuesday-briefing-what-it-might-take-for-lastin.jpg",
    date: "2026-04-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-is-borderline-personality-disorder",
    title: "Global Health and Education Watch: What Is Borderline Personality Disorder?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-21-global-health-and-education-watch-what-is-borderline-personality-disorder.jpg",
    date: "2026-04-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-world-news-in-brief-ai-diagnostics-humanitarian-deal-for",
    title: "Global Health and Education Watch: World News in Brief: AI diagnostics, humanitarian deal for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-21-global-health-and-education-watch-world-news-in-brief-ai-diagnostics-humanitaria.jpg",
    date: "2026-04-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "sustainable-housing-design-transforms-child-health-in-rural-africa",
    title: "Sustainable Housing Design Transforms Child Health in Rural Africa",
    summary:
      "A landmark cluster-randomized controlled trial published in Nature Medicine demonstrates the profound impact of sustainable housing on child health in rural Africa. The innovative designs significantly reduce respiratory infections, diarrheal diseases, and malaria, offering a scalable blueprint for global health improvement.",
    thumbnailImage: "/images/global-news/2026/2026-04-21-sustainable-housing-design-transforms-child-health-in-rural-africa.jpg",
    date: "2026-04-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "wellington-emergency-highlights-global-climate-threat-to-education-and-health",
    title: "Wellington Emergency Highlights Global Climate Threat to Education and Health",
    summary:
      "New Zealand's capital, Wellington, has declared an emergency following torrential rains that triggered widespread flash floods and landslides, forcing the closure of over 100 schools. This event underscores the escalating global challenge extreme weather poses to public health and education infrastructure.",
    thumbnailImage: "/images/global-news/2026/2026-04-21-wellington-emergency-highlights-global-climate-threat-to-education-and-health.jpg",
    date: "2026-04-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-maternity-boss-confident-as-unit-reopens",
    title: "Global Health and Education Watch: Maternity boss 'confident' as unit reopens",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-21-global-health-and-education-watch-maternity-boss-confident-as-unit-reopens.jpg",
    date: "2026-04-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-healthcare-s-crisis-long-waits-sicker-patients-strained-systems",
    title: "Global Healthcare's Crisis: Long Waits, Sicker Patients, Strained Systems",
    summary:
      "Healthcare systems worldwide are struggling under immense pressure, leading to prolonged patient waiting times and deteriorating health conditions. This global crisis, fueled by staff shortages and systemic inefficiencies, demands urgent attention to prevent further erosion of public health.",
    thumbnailImage: "/images/global-news/2026/2026-04-21-global-healthcare-s-crisis-long-waits-sicker-patients-strained-systems.jpg",
    date: "2026-04-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "england-moves-to-legally-ban-mobile-phones-in-schools-to-boost-learning-and-wellbeing",
    title: "England Moves to Legally Ban Mobile Phones in Schools to Boost Learning and Wellbeing",
    summary:
      "England's government is set to introduce legislation mandating a ban on mobile phones in all schools, transforming existing guidance into a legal requirement. This initiative seeks to enhance educational environments, reduce distractions, and support student mental well-being across the nation.",
    thumbnailImage: "/images/global-news/2026/2026-04-20-england-moves-to-legally-ban-mobile-phones-in-schools-to-boost-learning-and-well.jpg",
    date: "2026-04-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "gaza-s-decade-long-recovery-needs-over-71-billion-for-essential-services",
    title: "Gaza's Decade-Long Recovery Needs Over $71 Billion for Essential Services",
    summary:
      "A recent international assessment reveals Gaza requires more than $71 billion over the next decade for comprehensive recovery. The report underscores extensive devastation across critical sectors including health, education, and housing, necessitating urgent global support.",
    thumbnailImage: "/images/global-news/2026/2026-04-20-gaza-s-decade-long-recovery-needs-over-71-billion-for-essential-services.jpg",
    date: "2026-04-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "un-forum-urges-global-action-for-indigenous-healthcare-in-conflict-zones",
    title: "UN Forum Urges Global Action for Indigenous Healthcare in Conflict Zones",
    summary:
      "A significant UN forum in New York recently addressed critical healthcare disparities for Indigenous Peoples, especially those affected by conflict. Discussions emphasized the urgent need for culturally sensitive services and robust international support to protect their fundamental right to health.",
    thumbnailImage: "/images/global-news/2026/2026-04-20-un-forum-urges-global-action-for-indigenous-healthcare-in-conflict-zones.jpg",
    date: "2026-04-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "breakthrough-in-organ-transplants-offers-hope-for-drug-free-life",
    title: "Breakthrough in Organ Transplants Offers Hope for Drug-Free Life",
    summary:
      "A groundbreaking study at the University of Pittsburgh enabled three liver transplant recipients to cease anti-rejection drugs by introducing donor immune cells. This innovative approach, while not universally successful, offers significant hope for improving post-transplant quality of life globally.",
    thumbnailImage: "/images/global-news/2026/2026-04-20-breakthrough-in-organ-transplants-offers-hope-for-drug-free-life.jpg",
    date: "2026-04-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "economic-evaluation-guiding-global-health-investment-for-impact",
    title: "Economic Evaluation: Guiding Global Health Investment for Impact",
    summary:
      "Health economic evaluation is crucial for making informed decisions in global health, ensuring resources are allocated effectively for maximum impact. This analytical approach supports policymakers worldwide in developing sustainable and equitable health interventions.",
    thumbnailImage: "/images/global-news/2026/2026-04-20-economic-evaluation-guiding-global-health-investment-for-impact.jpg",
    date: "2026-04-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-crisis-public-sanitation-decline-threatens-well-being-and-equity",
    title: "Global Health Crisis: Public Sanitation Decline Threatens Well-being and Equity",
    summary:
      "A new report reveals a significant decline in public toilet facilities across England, creating 'toilet deserts' that harm public health and local economies. This trend mirrors a broader global challenge in maintaining essential sanitation infrastructure, impacting vulnerable populations and urban development worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-20-global-health-crisis-public-sanitation-decline-threatens-well-being-and-equity.jpg",
    date: "2026-04-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "sudan-s-last-stand-one-hospital-battles-tropical-disease-amidst-war-s-devastation",
    title: "Sudan's Last Stand: One Hospital Battles Tropical Disease Amidst War's Devastation",
    summary:
      "Sudan's protracted conflict has rendered 37 percent of its health facilities non-operational, leaving millions without critical medical care. Amidst this collapse, a solitary hospital remains functional, serving as the nation's only bulwark against a surge in tropical diseases exacerbated by the ongoing war.",
    thumbnailImage: "/images/global-news/2026/2026-04-20-sudan-s-last-stand-one-hospital-battles-tropical-disease-amidst-war-s-devastatio.jpg",
    date: "2026-04-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-exam-obsessed-schools-leave-pupils-unready-for-work-alan-milburn",
    title: "Global Health and Education Watch: ‘Exam-obsessed’ schools leave pupils unready for work, Alan Milburn",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-20-global-health-and-education-watch-exam-obsessed-schools-leave-pupils-unready-for.jpg",
    date: "2026-04-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-universities-in-england-could-face-fines-for-freedom-of",
    title: "Global Health and Education Watch: Universities in England could face fines for freedom of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-20-global-health-and-education-watch-universities-in-england-could-face-fines-for-f.jpg",
    date: "2026-04-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-falls-crisis-trillion-dollar-economic-burden-looms-by-2050",
    title: "Global Falls Crisis: Trillion-Dollar Economic Burden Looms by 2050",
    summary:
      "A groundbreaking study projects the global economic burden of falls to reach trillions by 2050, impacting 190 countries. This escalating crisis necessitates immediate, coordinated health and economic interventions worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-20-global-falls-crisis-trillion-dollar-economic-burden-looms-by-2050.jpg",
    date: "2026-04-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-analysis-of-alzheimer-s-drugs-stirs-debate-about-their-effectiveness",
    title: "Global Health and Education Watch: Analysis of Alzheimer’s Drugs Stirs Debate About Their Effectiveness",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-20-global-health-and-education-watch-analysis-of-alzheimer-s-drugs-stirs-debate-abo.jpg",
    date: "2026-04-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "universities-face-fines-for-free-speech-failures-amid-global-education-debate",
    title: "Universities Face Fines for Free Speech Failures Amid Global Education Debate",
    summary:
      "A new complaints system is set to impose substantial fines on universities failing to uphold free speech, with penalties reaching up to £500,000 or 2% of income. This development underscores a growing international focus on safeguarding open dialogue within higher education institutions.",
    thumbnailImage: "/images/global-news/2026/2026-04-20-universities-face-fines-for-free-speech-failures-amid-global-education-debate.jpg",
    date: "2026-04-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-health-visitors-call-for-limits-on-impossible-1-000-family-caseloads",
    title: "Global Health and Education Watch: Health visitors call for limits on 'impossible' 1,000-family caseloads",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-19-global-health-and-education-watch-health-visitors-call-for-limits-on-impossible-.jpg",
    date: "2026-04-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-schools-shops-shut-in-northern-israel-to-protest-the",
    title: "Global Health and Education Watch: Schools, shops shut in northern Israel to protest the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-19-global-health-and-education-watch-schools-shops-shut-in-northern-israel-to-prote.jpg",
    date: "2026-04-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-three-young-people-contract-meningitis-in-weymouth",
    title: "Global Health and Education Watch: Three young people contract meningitis in Weymouth",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-19-global-health-and-education-watch-three-young-people-contract-meningitis-in-weym.jpg",
    date: "2026-04-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-leaders-champion-early-learning-in-symbolic-cross-partisan-outreach",
    title: "Global Leaders Champion Early Learning in Symbolic Cross-Partisan Outreach",
    summary:
      "Former US President Barack Obama and New York City Mayor Zohran Mamdani recently engaged with preschoolers at a Bronx childcare center, highlighting the critical role of early learning. This bipartisan interaction serves as a powerful reminder of the global imperative to invest in foundational education for future generations.",
    thumbnailImage: "/images/global-news/2026/2026-04-19-global-leaders-champion-early-learning-in-symbolic-cross-partisan-outreach.jpg",
    date: "2026-04-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-fight-against-medical-misogyny-has-a-long-way",
    title: "Global Health and Education Watch: The fight against medical misogyny has a long way",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-19-global-health-and-education-watch-the-fight-against-medical-misogyny-has-a-long-.jpg",
    date: "2026-04-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-student-groups-navigate-ideological-shifts-campus-discontent",
    title: "Global Student Groups Navigate Ideological Shifts, Campus Discontent",
    summary:
      "Student organizations worldwide are increasingly confronting internal ideological disagreements and shifts in leadership direction. These challenges are reshaping campus activism and influencing the broader educational environment for youth.",
    thumbnailImage: "/images/global-news/2026/2026-04-19-global-student-groups-navigate-ideological-shifts-campus-discontent.jpg",
    date: "2026-04-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "escalating-attacks-cripple-healthcare-across-middle-east",
    title: "Escalating Attacks Cripple Healthcare Across Middle East",
    summary:
      "Recent Israeli military actions have profoundly impacted healthcare systems across Iran, Lebanon, and Gaza, leading to widespread destruction of medical facilities and critical service disruptions. These assaults pose severe challenges to civilian populations and humanitarian efforts, undermining the fundamental right to health in conflict zones.",
    thumbnailImage: "/images/global-news/2026/2026-04-19-escalating-attacks-cripple-healthcare-across-middle-east.jpg",
    date: "2026-04-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-guardian-view-on-school-food-there-is-no",
    title: "Global Health and Education Watch: The Guardian view on school food: there is no",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-19-global-health-and-education-watch-the-guardian-view-on-school-food-there-is-no.jpg",
    date: "2026-04-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-3-university-of-iowa-students-injured-during-a-shooting",
    title: "Global Health and Education Watch: 3 University of Iowa Students Injured During a Shooting",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-19-global-health-and-education-watch-3-university-of-iowa-students-injured-during-a.jpg",
    date: "2026-04-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "principal-honored-for-heroism-after-disarming-school-intruder",
    title: "Principal Honored for Heroism After Disarming School Intruder",
    summary:
      "A high school principal in Oklahoma, Kirk Moore, was recently honored as prom king by his students after he bravely disarmed an armed intruder on campus. This act of heroism, which saw him sustain a gunshot wound, underscored his dedication to student safety and inspired his community.",
    thumbnailImage: "/images/global-news/2026/2026-04-19-principal-honored-for-heroism-after-disarming-school-intruder.jpg",
    date: "2026-04-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "world-cup-winner-s-revelation-highlights-global-body-image-crisis",
    title: "World Cup Winner's Revelation Highlights Global Body Image Crisis",
    summary:
      "England rugby international Ellie Kildunne has openly discussed her battle with body dysmorphia and disordered eating during the Covid-19 pandemic. Her experience underscores a critical global health challenge affecting individuals across all walks of life, including elite athletes.",
    thumbnailImage: "/images/global-news/2026/2026-04-19-world-cup-winner-s-revelation-highlights-global-body-image-crisis.jpg",
    date: "2026-04-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-vaccine-success-heralds-new-era-but-trust-remains-elusive",
    title: "Global Vaccine Success Heralds New Era, But Trust Remains Elusive",
    summary:
      "Recent findings confirm that widespread immunisation campaigns have averted countless deaths globally, particularly during health crises. However, the critical need to rebuild and sustain public trust in health interventions remains a significant hurdle for future global health initiatives.",
    thumbnailImage: "/images/global-news/2026/2026-04-19-global-vaccine-success-heralds-new-era-but-trust-remains-elusive.jpg",
    date: "2026-04-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-fee-hikes-big-bonuses-then-bosses-exit-the-curious",
    title: "Global Health and Education Watch: Fee hikes, big bonuses, then bosses exit: the curious",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-19-global-health-and-education-watch-fee-hikes-big-bonuses-then-bosses-exit-the-cur.jpg",
    date: "2026-04-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "michigan-clerk-s-heroism-highlights-global-call-for-vigilance-in-youth-safety",
    title: "Michigan Clerk's Heroism Highlights Global Call for Vigilance in Youth Safety",
    summary:
      "A quick-thinking gas station clerk in Michigan saved a 16-year-old girl from an alleged kidnapper after she silently mouthed \"help.\" This act of bravery highlights the critical role of community vigilance in safeguarding young people worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-19-michigan-clerk-s-heroism-highlights-global-call-for-vigilance-in-youth-safety.jpg",
    date: "2026-04-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-push-for-early-science-engagement-california-museum-sets-example",
    title: "Global Push for Early Science Engagement: California Museum Sets Example",
    summary:
      "The KidSTREAM museum, a $7 million initiative in California, exemplifies a growing global recognition of the importance of early childhood science education. Born from a teacher's vision, it underscores the value of interactive learning environments for young minds worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-19-global-push-for-early-science-engagement-california-museum-sets-example.jpg",
    date: "2026-04-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "the-digital-dilemma-reclaiming-education-from-tech-over-reliance",
    title: "The Digital Dilemma: Reclaiming Education from Tech Over-Reliance",
    summary:
      "Across the globe, educational institutions are grappling with the pervasive influence of technology, prompting a critical re-evaluation of its role. This shift advocates for technology to return to its rightful place as a supportive tool, rather than the central pillar of learning.",
    thumbnailImage: "/images/global-news/2026/2026-04-19-the-digital-dilemma-reclaiming-education-from-tech-over-reliance.jpg",
    date: "2026-04-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-recommends-new-diagnostic-tools-to-help-end-tb-2",
    title: "Global Health and Education Watch: WHO recommends new diagnostic tools to help end TB",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-19-global-health-and-education-watch-who-recommends-new-diagnostic-tools-to-help-en.jpg",
    date: "2026-04-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-is-the-uk-covid-inquiry-and-how-does",
    title: "Global Health and Education Watch: What is the UK Covid inquiry and how does",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-19-global-health-and-education-watch-what-is-the-uk-covid-inquiry-and-how-does.jpg",
    date: "2026-04-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-should-you-really-trust-health-advice-from-an-ai",
    title: "Global Health and Education Watch: Should you really trust health advice from an AI",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-18-global-health-and-education-watch-should-you-really-trust-health-advice-from-an-.jpg",
    date: "2026-04-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "alzheimer-s-gamechanger-drugs-show-trivial-impact-global-review-concludes",
    title: "Alzheimer's 'Gamechanger' Drugs Show Trivial Impact, Global Review Concludes",
    summary:
      "A comprehensive global review of anti-amyloid Alzheimer's drugs has found their impact on cognitive decline to be 'trivial,' offering no noticeable difference for patients. This challenges previous 'gamechanger' claims, prompting re-evaluation of current treatment paradigms.",
    thumbnailImage: "/images/global-news/2026/2026-04-18-alzheimer-s-gamechanger-drugs-show-trivial-impact-global-review-concludes.jpg",
    date: "2026-04-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "healthcare-decentralization-a-global-blueprint-for-community-well-being",
    title: "Healthcare Decentralization: A Global Blueprint for Community Well-being",
    summary:
      "A pioneering initiative in the UK demonstrates how relocating medical services to community spaces can significantly improve healthcare accessibility and patient experience. This innovative model also offers a powerful strategy for rejuvenating urban retail areas, presenting a global blueprint for integrated health and sustainable urban development.",
    thumbnailImage: "/images/global-news/2026/2026-04-18-healthcare-decentralization-a-global-blueprint-for-community-well-being.jpg",
    date: "2026-04-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-australia-s-other-half-heals-all-aboard-the-superyacht",
    title: "Global Health and Education Watch: How Australia’s other half heals: all aboard the superyacht",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-18-global-health-and-education-watch-how-australia-s-other-half-heals-all-aboard-th.jpg",
    date: "2026-04-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cookie-house-at-carleton-college-in-minnesota-keeps-students",
    title: "Global Health and Education Watch: Cookie House at Carleton College in Minnesota Keeps Students",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-18-global-health-and-education-watch-cookie-house-at-carleton-college-in-minnesota-.jpg",
    date: "2026-04-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-my-weekly-juggling-act-being-a-teacher-to",
    title: "Global Health and Education Watch: My weekly juggling act - being a teacher to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-18-global-health-and-education-watch-my-weekly-juggling-act-being-a-teacher-to.jpg",
    date: "2026-04-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-as-fentanyl-crisis-evolves-experts-say-us-is-still",
    title: "Global Health and Education Watch: As fentanyl crisis evolves, experts say US is still",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-18-global-health-and-education-watch-as-fentanyl-crisis-evolves-experts-say-us-is-s.jpg",
    date: "2026-04-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trust-in-vaccines-needs-rebuilding-despite-extraordinary-feat-of",
    title: "Global Health and Education Watch: Trust in vaccines needs rebuilding despite ‘extraordinary feat’ of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-18-global-health-and-education-watch-trust-in-vaccines-needs-rebuilding-despite-ext.jpg",
    date: "2026-04-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "community-health-workers-a-global-lifeline-for-aging-populations",
    title: "Community Health Workers: A Global Lifeline for Aging Populations",
    summary:
      "Globally, an aging population and healthcare professional shortages strain health systems, leaving many older adults vulnerable. Community health workers are emerging as a critical solution, providing personalized care and connecting seniors to essential services worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-18-community-health-workers-a-global-lifeline-for-aging-populations.jpg",
    date: "2026-04-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "geopolitical-stability-a-cornerstone-for-global-health-and-education",
    title: "Geopolitical Stability: A Cornerstone for Global Health and Education",
    summary:
      "Geopolitical dynamics, exemplified by the strategic importance of maritime routes like the Strait of Hormuz, profoundly influence the global landscape of health and education. Maintaining stability in these critical areas is paramount for ensuring the consistent delivery of essential medical supplies and educational materials worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-18-geopolitical-stability-a-cornerstone-for-global-health-and-education.jpg",
    date: "2026-04-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "embracing-the-downpour-how-rain-walks-nurture-global-mental-well-being",
    title: "Embracing the Downpour: How Rain Walks Nurture Global Mental Well-being",
    summary:
      "Walking in the rain offers unique sensory immersion and psychological benefits, fostering mindfulness and reducing stress globally. This simple act can significantly contribute to mental well-being by connecting individuals with nature.",
    thumbnailImage: "/images/global-news/2026/2026-04-18-embracing-the-downpour-how-rain-walks-nurture-global-mental-well-being.jpg",
    date: "2026-04-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "harvard-s-slavery-legacy-project-marred-by-researcher-exodus-and-obstruction-claims",
    title: "Harvard's Slavery Legacy Project Marred by Researcher Exodus and Obstruction Claims",
    summary:
      "Harvard University's ambitious $100 million project investigating its historical ties to slavery is embroiled in controversy. Academics involved allege obstruction and a hostile environment, leading to departures and firings, raising concerns about institutional commitment to historical truth.",
    thumbnailImage: "/images/global-news/2026/2026-04-18-harvard-s-slavery-legacy-project-marred-by-researcher-exodus-and-obstruction-cla.jpg",
    date: "2026-04-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-shift-trump-administration-eyes-loosening-psychedelic-research-restrictions",
    title: "Global Shift: Trump Administration Eyes Loosening Psychedelic Research Restrictions",
    summary:
      "The Trump administration is reportedly preparing an executive order to ease restrictions on psychedelic drug research. This move could significantly accelerate studies into their potential for treating PTSD, depression, and other mental health conditions globally.",
    thumbnailImage: "/images/global-news/2026/2026-04-18-global-shift-trump-administration-eyes-loosening-psychedelic-research-restrictio.jpg",
    date: "2026-04-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-it-s-a-powder-keg-romania-leads-eu-measles-cases",
    title: "Global Health and Education Watch: ‘It’s a powder keg’: Romania leads EU measles cases",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-18-global-health-and-education-watch-it-s-a-powder-keg-romania-leads-eu-measles-cas.jpg",
    date: "2026-04-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "sudan-conflict-plunges-women-into-pervasive-fear-and-gender-based-violence-risk",
    title: "Sudan Conflict Plunges Women into Pervasive Fear and Gender-Based Violence Risk",
    summary:
      "The escalating conflict in Sudan has created an environment of extreme peril for women and girls, with widespread reports of insecurity and heightened risks of gender-based violence. Displaced populations are particularly vulnerable, facing dangers both during flight and within crowded humanitarian settings.",
    thumbnailImage: "/images/global-news/2026/2026-04-18-sudan-conflict-plunges-women-into-pervasive-fear-and-gender-based-violence-risk.jpg",
    date: "2026-04-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-individual-versus-group-based-interventions-a-systematic-review-and-meta-analysis",
    title: "Global Health and Education Watch: Individual versus group-based interventions: a systematic review and meta-analysis",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-18-global-health-and-education-watch-individual-versus-group-based-interventions-a-.jpg",
    date: "2026-04-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "gaza-s-al-noor-centre-a-beacon-of-hope-for-visually-impaired-children",
    title: "Gaza's Al-Noor Centre: A Beacon of Hope for Visually Impaired Children",
    summary:
      "The Al-Noor Centre in Gaza offers vital education and comprehensive support to visually impaired children, serving as a critical lifeline. Operated by UNRWA, it empowers these children to overcome adversity and build brighter futures.",
    thumbnailImage: "/images/global-news/2026/2026-04-18-gaza-s-al-noor-centre-a-beacon-of-hope-for-visually-impaired-children.jpg",
    date: "2026-04-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "pregnancy-vaccine-offers-80-protection-against-infant-rsv-hospitalizations",
    title: "Pregnancy Vaccine Offers 80% Protection Against Infant RSV Hospitalizations",
    summary:
      "A new study validates a maternal vaccine's remarkable effectiveness, showing an 80% reduction in infant hospital admissions due to severe RSV. This breakthrough offers excellent protection against life-threatening chest infections, promising a significant global health impact.",
    thumbnailImage: "/images/global-news/2026/2026-04-18-pregnancy-vaccine-offers-80-protection-against-infant-rsv-hospitalizations.jpg",
    date: "2026-04-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "solomon-islands-confronts-hidden-gambling-surge-amidst-economic-strain",
    title: "Solomon Islands Confronts Hidden Gambling Surge Amidst Economic Strain",
    summary:
      "In Honiara, Solomon Islands, an illegal street card game called 'Pass' is rapidly gaining traction, luring individuals with the promise of quick wealth despite significant financial risks. This growing phenomenon, often played in clandestine, smoky venues, raises concerns about its socio-economic impact on the community and its vital institutions.",
    thumbnailImage: "/images/global-news/2026/2026-04-17-solomon-islands-confronts-hidden-gambling-surge-amidst-economic-strain.jpg",
    date: "2026-04-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-surgeon-who-removed-wrong-organ-from-patient-is-charged",
    title: "Global Health and Education Watch: Surgeon Who Removed Wrong Organ From Patient Is Charged",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-17-global-health-and-education-watch-surgeon-who-removed-wrong-organ-from-patient-i.jpg",
    date: "2026-04-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "integrated-mental-health-support-for-diabetes-patients-a-global-imperative",
    title: "Integrated Mental Health Support for Diabetes Patients: A Global Imperative",
    summary:
      "A new program in the UK aims to provide integrated mental health support for people living with diabetes, addressing a significant comorbidity. This initiative underscores the urgent global need for holistic care models that recognize the profound link between physical and mental well-being.",
    thumbnailImage: "/images/global-news/2026/2026-04-17-integrated-mental-health-support-for-diabetes-patients-a-global-imperative.jpg",
    date: "2026-04-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "south-sudan-s-deepening-crisis-violence-hunger-and-health-collapse-amid-un-cuts",
    title: "South Sudan's Deepening Crisis: Violence, Hunger, and Health Collapse Amid UN Cuts",
    summary:
      "Senior UN officials recently presented a dire assessment of South Sudan to the Security Council, highlighting escalating violence, widespread hunger, and a collapsing health system. These challenges are compounded by significant budget cuts to the UN peacekeeping mission, severely limiting its ability to protect civilians and deliver crucial aid.",
    thumbnailImage: "/images/global-news/2026/2026-04-17-south-sudan-s-deepening-crisis-violence-hunger-and-health-collapse-amid-un-cuts.jpg",
    date: "2026-04-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ensuring-student-health-global-food-safety-standards-in-higher-education",
    title: "Ensuring Student Health: Global Food Safety Standards in Higher Education",
    summary:
      "A new study reveals significant insights into food safety knowledge, attitudes, and practices among university food handlers in Northwestern China. These findings underscore the global imperative for enhanced training and oversight to protect student health in educational institutions.",
    thumbnailImage: "/images/global-news/2026/2026-04-17-ensuring-student-health-global-food-safety-standards-in-higher-education.jpg",
    date: "2026-04-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "unesco-bolsters-protection-for-middle-east-heritage-amid-escalating-conflict",
    title: "UNESCO Bolsters Protection for Middle East Heritage Amid Escalating Conflict",
    summary:
      "UNESCO has granted enhanced protection status to numerous cultural heritage sites across the Middle East. This critical intervention follows reports of significant damage to historical locations in Israel, Iran, and Lebanon since the regional conflict escalated on February 28, 2026.",
    thumbnailImage: "/images/global-news/2026/2026-04-17-unesco-bolsters-protection-for-middle-east-heritage-amid-escalating-conflict.jpg",
    date: "2026-04-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "southern-lebanon-s-sole-functioning-hospital-damaged-amidst-escalating-conflict",
    title: "Southern Lebanon's Sole Functioning Hospital Damaged Amidst Escalating Conflict",
    summary:
      "Tibnin Hospital, the sole operational medical facility in southern Lebanon, sustained damage from recent Israeli strikes, severely impacting healthcare access for thousands. This incident underscores the devastating consequences of conflict on civilian infrastructure and humanitarian aid efforts in the region.",
    thumbnailImage: "/images/global-news/2026/2026-04-17-southern-lebanon-s-sole-functioning-hospital-damaged-amidst-escalating-conflict.jpg",
    date: "2026-04-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-three-meningitis-b-cases-confirmed-in-dorset-as-young",
    title: "Global Health and Education Watch: Three meningitis B cases confirmed in Dorset as young",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-17-global-health-and-education-watch-three-meningitis-b-cases-confirmed-in-dorset-a.jpg",
    date: "2026-04-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-leadership-trump-nominates-erica-schwartz-to-helm-cdc",
    title: "Global Health Leadership: Trump Nominates Erica Schwartz to Helm CDC",
    summary:
      "President Donald Trump has nominated Dr. Erica Schwartz, a former Deputy Surgeon General and US Coast Guard Rear Admiral, to lead the Centers for Disease Control and Prevention (CDC). This appointment concludes a prolonged search for a permanent head of the vital global public health agency, signaling a new chapter for its international operations.",
    thumbnailImage: "/images/global-news/2026/2026-04-17-global-health-leadership-trump-nominates-erica-schwartz-to-helm-cdc.jpg",
    date: "2026-04-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "prominent-figure-adjusts-stance-on-vaccine-safety-amid-congressional-scrutiny",
    title: "Prominent Figure Adjusts Stance on Vaccine Safety Amid Congressional Scrutiny",
    summary:
      "During a recent congressional hearing, Robert F. Kennedy Jr. acknowledged the measles vaccine's safety and effectiveness for most people. This statement represents a notable shift from his long-standing skepticism regarding established vaccine policies.",
    thumbnailImage: "/images/global-news/2026/2026-04-17-prominent-figure-adjusts-stance-on-vaccine-safety-amid-congressional-scrutiny.jpg",
    date: "2026-04-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-inside-the-cdc-s-leadership-vacuum-work-at-a-standstill",
    title: "Global Health and Education Watch: Inside the CDC’s leadership vacuum: work at a ‘standstill’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-17-global-health-and-education-watch-inside-the-cdc-s-leadership-vacuum-work-at-a-s.jpg",
    date: "2026-04-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-lawmakers-clash-with-rfk-jr-as-he-shifts-focus",
    title: "Global Health and Education Watch: Lawmakers clash with RFK Jr as he shifts focus",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-17-global-health-and-education-watch-lawmakers-clash-with-rfk-jr-as-he-shifts-focus.jpg",
    date: "2026-04-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "development-s-double-edge-vietnam-s-infectious-disease-paradox",
    title: "Development's Double Edge: Vietnam's Infectious Disease Paradox",
    summary:
      "Vietnam's journey of rapid development highlights a 'paradox of progress,' where societal advancements inadvertently create new vulnerabilities to infectious diseases. This global phenomenon underscores the need for integrated public health strategies in rapidly changing economies.",
    thumbnailImage: "/images/global-news/2026/2026-04-17-development-s-double-edge-vietnam-s-infectious-disease-paradox.jpg",
    date: "2026-04-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-vaccine-rollout-hailed-as-feat-support-urged-for-harmed",
    title: "Global Vaccine Rollout Hailed as Feat, Support Urged for Harmed",
    summary:
      "A recent inquiry report extols the global Covid-19 vaccine rollout as an extraordinary achievement, saving countless lives worldwide. Concurrently, it underscores the critical need for improved support systems for the small minority who suffered adverse effects.",
    thumbnailImage: "/images/global-news/2026/2026-04-17-global-vaccine-rollout-hailed-as-feat-support-urged-for-harmed.jpg",
    date: "2026-04-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "rethinking-colonial-narratives-the-global-imperative-for-truth-in-education",
    title: "Rethinking Colonial Narratives: The Global Imperative for Truth in Education",
    summary:
      "Educational systems globally must confront how colonial histories are taught, moving beyond biased narratives to foster a deeper, more accurate understanding. This critical shift is essential for shaping students' perspectives on race, migration, and global justice.",
    thumbnailImage: "/images/global-news/2026/2026-04-16-rethinking-colonial-narratives-the-global-imperative-for-truth-in-education.jpg",
    date: "2026-04-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-education-tensions-chicago-union-mayor-standoff-reflects-wider-challenges",
    title: "Global Education Tensions: Chicago Union-Mayor Standoff Reflects Wider Challenges",
    summary:
      "A conflict between the Chicago Teachers Union and Mayor Brandon Johnson regarding school operations on May Day underscores global challenges in urban education. This local dispute reflects broader tensions between labor advocacy, administrative priorities, and parental concerns across international school systems.",
    thumbnailImage: "/images/global-news/2026/2026-04-16-global-education-tensions-chicago-union-mayor-standoff-reflects-wider-challenges.jpg",
    date: "2026-04-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-rfk-jr-accused-of-dangerous-conspiracy-theories-at-heated",
    title: "Global Health and Education Watch: RFK Jr accused of ‘dangerous conspiracy theories’ at heated",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-16-global-health-and-education-watch-rfk-jr-accused-of-dangerous-conspiracy-theorie.jpg",
    date: "2026-04-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-utah-reports-more-than-600-measles-cases-as-outbreak",
    title: "Global Health and Education Watch: Utah reports more than 600 measles cases as outbreak",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-16-global-health-and-education-watch-utah-reports-more-than-600-measles-cases-as-ou.jpg",
    date: "2026-04-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "turkiye-s-schools-grapple-with-grief-after-second-deadly-shooting",
    title: "Turkiye's Schools Grapple with Grief After Second Deadly Shooting",
    summary:
      "Turkiye is reeling from its second school shooting in a week, with a 14-year-old student's actions at Ayser Calik School raising the death toll to 10. This devastating event highlights the urgent global need to address school violence and its profound impact on student safety and mental health.",
    thumbnailImage: "/images/global-news/2026/2026-04-16-turkiye-s-schools-grapple-with-grief-after-second-deadly-shooting.jpg",
    date: "2026-04-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "game-theory-models-revolutionize-university-public-health-emergency-response",
    title: "Game Theory Models Revolutionize University Public Health Emergency Response",
    summary:
      "A groundbreaking study introduces an evolutionary game model to enhance public health emergency management within universities globally. This innovative approach analyzes strategic interactions among campus stakeholders to foster more resilient and adaptive response mechanisms.",
    thumbnailImage: "/images/global-news/2026/2026-04-16-game-theory-models-revolutionize-university-public-health-emergency-response.jpg",
    date: "2026-04-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "children-unprepared-global-schools-face-basic-skill-deficit",
    title: "Children Unprepared: Global Schools Face Basic Skill Deficit",
    summary:
      "Schools globally are increasingly encountering children starting primary education without essential skills like toilet training and basic communication. This trend places significant demands on educators and impacts early learning environments worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-16-children-unprepared-global-schools-face-basic-skill-deficit.jpg",
    date: "2026-04-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-rollout-of-covid-19-vaccines-was-extraordinary-feat-inquiry",
    title: "Global Health and Education Watch: UK rollout of Covid-19 vaccines was ‘extraordinary feat’, inquiry",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-16-global-health-and-education-watch-uk-rollout-of-covid-19-vaccines-was-extraordin.jpg",
    date: "2026-04-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-universities-grapple-with-mounting-crises-amidst-eroding-public-trust",
    title: "Global Universities Grapple with Mounting Crises Amidst Eroding Public Trust",
    summary:
      "Across the globe, universities are confronting a wave of complex challenges, ranging from internal governance issues to financial instability and declining public confidence. These mounting troubles highlight a critical juncture for higher education, demanding urgent and comprehensive reforms to safeguard its future.",
    thumbnailImage: "/images/global-news/2026/2026-04-16-global-universities-grapple-with-mounting-crises-amidst-eroding-public-trust.jpg",
    date: "2026-04-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "israeli-strike-devastates-area-near-lebanon-hospital-sparking-global-health-concerns",
    title: "Israeli Strike Devastates Area Near Lebanon Hospital, Sparking Global Health Concerns",
    summary:
      "An Israeli air attack near a hospital in southern Lebanon destroyed surrounding buildings and emergency vehicles, severely impacting regional healthcare infrastructure. This incident underscores the escalating global challenge of protecting medical facilities and ensuring humanitarian access in areas of conflict.",
    thumbnailImage: "/images/global-news/2026/2026-04-16-israeli-strike-devastates-area-near-lebanon-hospital-sparking-global-health-conc.jpg",
    date: "2026-04-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-call-bridging-the-educational-psychology-gap-for-children-s-futures",
    title: "Global Call: Bridging the Educational Psychology Gap for Children's Futures",
    summary:
      "A recent report underscores a significant shortage of educational psychologists in England, revealing a critical need for enhanced support for children with special educational needs. This challenge mirrors a broader global issue, demanding urgent investment in child mental health and inclusive education services worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-16-global-call-bridging-the-educational-psychology-gap-for-children-s-futures.jpg",
    date: "2026-04-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uncharted-territory-uncertainty-as-us-vaccine-guidance-falls-apart",
    title: "Global Health and Education Watch: ‘Uncharted territory’: uncertainty as US vaccine guidance falls apart",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-16-global-health-and-education-watch-uncharted-territory-uncertainty-as-us-vaccine-.jpg",
    date: "2026-04-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ai-s-dual-edge-transforming-global-public-health-navigating-complexities",
    title: "AI's Dual Edge: Transforming Global Public Health, Navigating Complexities",
    summary:
      "Artificial intelligence is poised to revolutionize global public health, offering powerful tools for disease prediction, personalized care, and resource optimization. However, its widespread adoption necessitates careful navigation of ethical dilemmas, data privacy concerns, and equity challenges.",
    thumbnailImage: "/images/global-news/2026/2026-04-16-ai-s-dual-edge-transforming-global-public-health-navigating-complexities.jpg",
    date: "2026-04-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "women-s-health-plans-launched-amid-persistent-global-concerns-of-being-unheard",
    title: "Women's Health Plans Launched Amid Persistent Global Concerns of Being Unheard",
    summary:
      "New global health strategies are being introduced to improve care for women and girls, yet many remain unconvinced these plans will address long-standing issues of feeling ignored within healthcare systems. The initiatives aim to tackle disparities, but a history of medical neglect fuels skepticism about their real-world impact.",
    thumbnailImage: "/images/global-news/2026/2026-04-15-women-s-health-plans-launched-amid-persistent-global-concerns-of-being-unheard.jpg",
    date: "2026-04-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-people-in-england-s-poorest-areas-live-less-than-50",
    title: "Global Health and Education Watch: People in England’s poorest areas live less than 50",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-15-global-health-and-education-watch-people-in-england-s-poorest-areas-live-less-th.jpg",
    date: "2026-04-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-at-least-4-dead-in-second-school-shooting-in",
    title: "Global Health and Education Watch: At Least 4 Dead in Second School Shooting in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-15-global-health-and-education-watch-at-least-4-dead-in-second-school-shooting-in.jpg",
    date: "2026-04-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "healthcare-strikes-a-global-call-for-diplomacy-amidst-mounting-crisis",
    title: "Healthcare Strikes: A Global Call for Diplomacy Amidst Mounting Crisis",
    summary:
      "Ongoing healthcare strikes worldwide are profoundly impacting patient services and exacerbating divisions within the medical community. Urgent diplomatic intervention is increasingly seen as essential to mitigate the crisis and restore stability to health systems.",
    thumbnailImage: "/images/global-news/2026/2026-04-15-healthcare-strikes-a-global-call-for-diplomacy-amidst-mounting-crisis.jpg",
    date: "2026-04-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-africa-nearly-20-million-measles-deaths-averted-since-2000",
    title: "Global Health and Education Watch: Africa: Nearly 20 million measles deaths averted since 2000",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-15-global-health-and-education-watch-africa-nearly-20-million-measles-deaths-averte.jpg",
    date: "2026-04-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-leaders-urge-who-action-on-steatotic-liver-disease",
    title: "Global Health Leaders Urge WHO Action on Steatotic Liver Disease",
    summary:
      "A global coalition of health experts is advocating for a World Health Assembly resolution to address steatotic liver disease. This critical step aims to elevate awareness, standardize care, and accelerate research for the escalating global health challenge.",
    thumbnailImage: "/images/global-news/2026/2026-04-15-global-health-leaders-urge-who-action-on-steatotic-liver-disease.jpg",
    date: "2026-04-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "immunocompromised-patients-face-deadly-risks-amid-global-healthcare-strain",
    title: "Immunocompromised Patients Face Deadly Risks Amid Global Healthcare Strain",
    summary:
      "The perilous experiences of immunocompromised patients in crowded emergency departments underscore a critical global health challenge. These environments, often strained by capacity issues, heighten the risk of severe infections for the most vulnerable.",
    thumbnailImage: "/images/global-news/2026/2026-04-15-immunocompromised-patients-face-deadly-risks-amid-global-healthcare-strain.jpg",
    date: "2026-04-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "turkiye-school-shootings-spark-global-alarm-over-education-safety",
    title: "Turkiye School Shootings Spark Global Alarm Over Education Safety",
    summary:
      "Three students and a teacher were tragically killed in a school shooting in Turkiye's Kahramanmaras province, marking the country's second such incident in two days. This alarming event underscores the escalating global concerns about violence threatening educational institutions and the safety of students and educators.",
    thumbnailImage: "/images/global-news/2026/2026-04-15-turkiye-school-shootings-spark-global-alarm-over-education-safety.jpg",
    date: "2026-04-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-sri-lankan-student-could-be-deported-from-uk-after",
    title: "Global Health and Education Watch: Sri Lankan student could be deported from UK after",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-15-global-health-and-education-watch-sri-lankan-student-could-be-deported-from-uk-a.jpg",
    date: "2026-04-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-fertility-decisions-shaped-by-mental-health-concerns",
    title: "Global Fertility Decisions Shaped by Mental Health Concerns",
    summary:
      "Mental health is increasingly influencing reproductive choices globally, prompting individuals to assess their capacity for parenthood. This shift highlights the urgent need for accessible mental healthcare and robust societal support systems for prospective parents.",
    thumbnailImage: "/images/global-news/2026/2026-04-15-global-fertility-decisions-shaped-by-mental-health-concerns.jpg",
    date: "2026-04-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-watchdog-warns-unmaintained-water-filters-pose-widespread-health-risks",
    title: "Global Health Watchdog Warns: Unmaintained Water Filters Pose Widespread Health Risks",
    summary:
      "A global health watchdog has issued a stark warning regarding the widespread health risks posed by poorly maintained domestic water filters. Despite the safety of many public water supplies, consumer reliance on neglected private filtration systems creates a dangerous pathway for contamination.",
    thumbnailImage: "/images/global-news/2026/2026-04-15-global-health-watchdog-warns-unmaintained-water-filters-pose-widespread-health-r.jpg",
    date: "2026-04-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-systems-at-a-crossroads-navigating-the-public-private-divide",
    title: "Global Health Systems at a Crossroads: Navigating the Public-Private Divide",
    summary:
      "Across the globe, healthcare systems face increasing pressure, leading to a complex interplay between public provision and private alternatives. This shift raises significant concerns about equitable access and the potential for creating deeply divided health services.",
    thumbnailImage: "/images/global-news/2026/2026-04-15-global-health-systems-at-a-crossroads-navigating-the-public-private-divide.jpg",
    date: "2026-04-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "flawed-data-undermines-ai-disease-prediction-posing-global-health-risks",
    title: "Flawed Data Undermines AI Disease Prediction, Posing Global Health Risks",
    summary:
      "A recent Nature investigation highlights a critical flaw in numerous AI disease-prediction models: their training on questionable data. This widespread issue poses a significant global health risk, potentially leading to biased diagnoses and exacerbating health inequities across diverse populations.",
    thumbnailImage: "/images/global-news/2026/2026-04-15-flawed-data-undermines-ai-disease-prediction-posing-global-health-risks.jpg",
    date: "2026-04-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-one-school-has-banned-phones-for-some-pupils",
    title: "Global Health and Education Watch: Why one school has banned phones for some pupils",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-14-global-health-and-education-watch-why-one-school-has-banned-phones-for-some-pupi.jpg",
    date: "2026-04-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-after-three-years-of-conflict-sudan-faces-a-deeper",
    title: "Global Health and Education Watch: After three years of conflict, Sudan faces a deeper",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-14-global-health-and-education-watch-after-three-years-of-conflict-sudan-faces-a-de.jpg",
    date: "2026-04-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "canada-s-refugee-healthcare-cuts-spark-global-concern-over-human-rights",
    title: "Canada's Refugee Healthcare Cuts Spark Global Concern Over Human Rights",
    summary:
      "Canada faces intense criticism for planned co-payments on refugee healthcare, set to begin May 1, 2026. Health workers and rights advocates argue these financial barriers will deny essential care and contradict international human rights commitments.",
    thumbnailImage: "/images/global-news/2026/2026-04-14-canada-s-refugee-healthcare-cuts-spark-global-concern-over-human-rights.jpg",
    date: "2026-04-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ishmael-jaffree-who-won-case-rejecting-school-prayer-dies",
    title: "Global Health and Education Watch: Ishmael Jaffree, Who Won Case Rejecting School Prayer, Dies",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-14-global-health-and-education-watch-ishmael-jaffree-who-won-case-rejecting-school-.jpg",
    date: "2026-04-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-post-acute-organ-complications-within-one-year-following-covid-19-hospitalization",
    title: "Global Health and Education Watch: Post-acute organ complications within one year following COVID-19 hospitalization",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-14-global-health-and-education-watch-post-acute-organ-complications-within-one-year.jpg",
    date: "2026-04-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-school-food-standards-pilot-in-england-cuts-meal-uptake",
    title: "Global Health and Education Watch: School food standards pilot in England cuts meal uptake",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-14-global-health-and-education-watch-school-food-standards-pilot-in-england-cuts-me.jpg",
    date: "2026-04-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "hospital-scandal-exposes-global-healthcare-safety-crisis",
    title: "Hospital Scandal Exposes Global Healthcare Safety Crisis",
    summary:
      "An HIV outbreak among children in Pakistan has been linked to a hospital caught reusing syringes on camera. The incident highlights critical global challenges in healthcare safety, infection control, and regulatory oversight.",
    thumbnailImage: "/images/global-news/2026/2026-04-14-hospital-scandal-exposes-global-healthcare-safety-crisis.jpg",
    date: "2026-04-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-equity-unpacking-the-dynamics-of-influence",
    title: "Global Health Equity: Unpacking the Dynamics of Influence",
    summary:
      "Global health equity faces significant challenges from the disproportionate influence of powerful nations and economic blocs. This article explores how politicized agendas and resource control impact health and education access globally.",
    thumbnailImage: "/images/global-news/2026/2026-04-14-global-health-equity-unpacking-the-dynamics-of-influence.jpg",
    date: "2026-04-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-alarm-us-shifts-contraception-program-to-pro-natalist-agenda",
    title: "Global Alarm: US Shifts Contraception Program to Pro-Natalist Agenda",
    summary:
      "The US administration is reportedly transforming Title X, a federal contraception program, into a pro-conception initiative. This ideological shift raises global concerns about reproductive health access and women's autonomy.",
    thumbnailImage: "/images/global-news/2026/2026-04-14-global-alarm-us-shifts-contraception-program-to-pro-natalist-agenda.jpg",
    date: "2026-04-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-wildlife-trade-accelerates-disease-spillover-to-humans",
    title: "Global Wildlife Trade Accelerates Disease Spillover to Humans",
    summary:
      "A recent study reveals that the global wildlife trade significantly accelerates the spread of diseases from animals to humans, posing substantial public health risks. Both legal and illegal trade, particularly live animal markets, create dangerous conditions for pathogen spillover.",
    thumbnailImage: "/images/global-news/2026/2026-04-14-global-wildlife-trade-accelerates-disease-spillover-to-humans.jpg",
    date: "2026-04-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-child-poverty-and-liver-disease-threaten-future-generations",
    title: "Global Health: Child Poverty and Liver Disease Threaten Future Generations",
    summary:
      "Child poverty, exacerbated by austerity policies, continues to scar millions globally, impacting health and education. Concurrently, Metabolic Associated Steatotic Liver Disease (MASLD) is projected to affect 1.8 billion people worldwide by 2050, driven by rising obesity and blood sugar levels.",
    thumbnailImage: "/images/global-news/2026/2026-04-14-global-health-child-poverty-and-liver-disease-threaten-future-generations.jpg",
    date: "2026-04-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-youth-readiness-a-call-for-educational-reform",
    title: "Global Youth Readiness: A Call for Educational Reform",
    summary:
      "A global challenge is emerging as education systems struggle to prepare young people for the demands of modern employment, leading to widespread youth unemployment and inactivity. This issue necessitates a concerted effort from parents, schools, and policymakers to foster essential skills and pathways to productive futures.",
    thumbnailImage: "/images/global-news/2026/2026-04-14-global-youth-readiness-a-call-for-educational-reform.jpg",
    date: "2026-04-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-almost-2bn-to-be-affected-by-metabolic-liver-disease",
    title: "Global Health and Education Watch: Almost 2bn to be affected by metabolic liver disease",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-14-global-health-and-education-watch-almost-2bn-to-be-affected-by-metabolic-liver-d.jpg",
    date: "2026-04-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "tragedy-highlights-global-risks-in-medical-tourism-and-mental-health-support",
    title: "Tragedy Highlights Global Risks in Medical Tourism and Mental Health Support",
    summary:
      "The tragic death of Pawel Bukowski, who took his own life after a disastrous dental procedure in Turkey left him toothless and severely depressed, has brought the inherent risks of global medical tourism into sharp focus. This incident prompts a crucial re-evaluation of patient safety, regulatory oversight, and mental health support systems for individuals seeking medical care abroad.",
    thumbnailImage: "/images/global-news/2026/2026-04-13-tragedy-highlights-global-risks-in-medical-tourism-and-mental-health-support.jpg",
    date: "2026-04-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-nurse-wins-settlement-in-trans-pronouns-dispute",
    title: "Global Health and Education Watch: Nurse wins settlement in trans pronouns dispute",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-13-global-health-and-education-watch-nurse-wins-settlement-in-trans-pronouns-disput.jpg",
    date: "2026-04-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israel-kills-three-palestinians-in-separate-gaza-strikes",
    title: "Global Health and Education Watch: Israel kills three Palestinians in separate Gaza strikes",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-13-global-health-and-education-watch-israel-kills-three-palestinians-in-separate-ga.jpg",
    date: "2026-04-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "russia-s-drone-force-recruitment-a-global-challenge-to-education-and-youth",
    title: "Russia's Drone Force Recruitment: A Global Challenge to Education and Youth",
    summary:
      "Russia is extensively recruiting students from hundreds of universities for its drone forces, sparking global concerns about the militarization of education. This initiative profoundly impacts academic autonomy, student well-being, and long-term societal development.",
    thumbnailImage: "/images/global-news/2026/2026-04-13-russia-s-drone-force-recruitment-a-global-challenge-to-education-and-youth.jpg",
    date: "2026-04-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-kratom-poisonings-soar-in-us-as-experts-blame-synthetic",
    title: "Global Health and Education Watch: Kratom poisonings soar in US as experts blame synthetic",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-13-global-health-and-education-watch-kratom-poisonings-soar-in-us-as-experts-blame-.jpg",
    date: "2026-04-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-sussex-baby-deaths-inquiry-will-fail-to-learn-lessons",
    title: "Global Health and Education Watch: Sussex baby deaths inquiry will fail to learn lessons",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-13-global-health-and-education-watch-sussex-baby-deaths-inquiry-will-fail-to-learn-.jpg",
    date: "2026-04-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-alert-understanding-the-noble-false-widow-spider-s-impact",
    title: "Global Health Alert: Understanding the Noble False Widow Spider's Impact",
    summary:
      "The noble false widow spider is increasingly implicated in a rise of hospital-treated bites across various regions. While often alarming, experts clarify the typical severity and necessary precautions for these encounters.",
    thumbnailImage: "/images/global-news/2026/2026-04-13-global-health-alert-understanding-the-noble-false-widow-spider-s-impact.jpg",
    date: "2026-04-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-building-a-program-to-improve-postpartum-depression-screening-triage",
    title: "Global Health and Education Watch: Building a program to improve postpartum depression screening, triage",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-13-global-health-and-education-watch-building-a-program-to-improve-postpartum-depre.jpg",
    date: "2026-04-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israeli-forces-fire-tear-gas-near-palestinian-schoolchildren",
    title: "Global Health and Education Watch: Israeli forces fire tear gas near Palestinian schoolchildren",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-13-global-health-and-education-watch-israeli-forces-fire-tear-gas-near-palestinian-.jpg",
    date: "2026-04-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ai-revolutionizes-bowel-cancer-treatment-predicting-drug-response-globally",
    title: "AI Revolutionizes Bowel Cancer Treatment: Predicting Drug Response Globally",
    summary:
      "Researchers have developed an AI-driven tool, PhenMap, to predict how advanced bowel cancer patients will respond to new NHS drugs. This innovation aims to prevent ineffective treatments, improving patient outcomes and optimizing healthcare resources globally.",
    thumbnailImage: "/images/global-news/2026/2026-04-13-ai-revolutionizes-bowel-cancer-treatment-predicting-drug-response-globally.jpg",
    date: "2026-04-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-new-focus-on-wellness-for-students-at-the",
    title: "Global Health and Education Watch: A New Focus on Wellness for Students at the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-13-global-health-and-education-watch-a-new-focus-on-wellness-for-students-at-the.jpg",
    date: "2026-04-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "genomic-testing-s-global-reach-bridging-gaps-in-community-health-centers",
    title: "Genomic Testing's Global Reach: Bridging Gaps in Community Health Centers",
    summary:
      "A pivotal study examines the integration of genomic testing into Federally Qualified Health Centers, highlighting the critical role of providers in expanding equitable access to precision medicine. It underscores both the significant opportunities and the systemic hurdles faced in diverse global healthcare landscapes.",
    thumbnailImage: "/images/global-news/2026/2026-04-13-genomic-testing-s-global-reach-bridging-gaps-in-community-health-centers.jpg",
    date: "2026-04-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-silence-on-school-strike-undermines-education-in-conflict",
    title: "Global Silence on School Strike Undermines Education in Conflict",
    summary:
      "A recent Tomahawk missile strike on an Iranian school received no official comment from the Pentagon, despite a concurrent, highly publicized rescue mission. This selective transparency highlights critical global concerns regarding the protection of educational institutions in conflict zones.",
    thumbnailImage: "/images/global-news/2026/2026-04-13-global-silence-on-school-strike-undermines-education-in-conflict.jpg",
    date: "2026-04-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-concerns-raised-about-motorbike-tourist-trail-after-death-of",
    title: "Global Health and Education Watch: Concerns raised about motorbike tourist trail after death of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-12-global-health-and-education-watch-concerns-raised-about-motorbike-tourist-trail-.jpg",
    date: "2026-04-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-deep-fried-food-banned-in-new-plans-for-school-dinners",
    title: "Global Health and Education Watch: Deep-fried food banned in new plans for school dinners",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-12-global-health-and-education-watch-deep-fried-food-banned-in-new-plans-for-school.jpg",
    date: "2026-04-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "england-s-school-food-overhaul-signals-global-health-imperative",
    title: "England's School Food Overhaul Signals Global Health Imperative",
    summary:
      "England's first school food standards update in 13 years will ban high-calorie items to tackle childhood obesity, impacting meals from September. This move highlights a critical global challenge in child health and nutrition, prompting a reevaluation of school meal policies worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-12-england-s-school-food-overhaul-signals-global-health-imperative.jpg",
    date: "2026-04-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "rodolfo-acuna-chicano-studies-pioneer-leaves-enduring-educational-legacy",
    title: "Rodolfo Acuña, Chicano Studies Pioneer, Leaves Enduring Educational Legacy",
    summary:
      "Rodolfo Acuña, a pivotal figure in the establishment of Chicano Studies, has passed away at 93. His foundational text, 'Occupied America,' continues to influence academic discourse and educational programs worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-12-rodolfo-acu-a-chicano-studies-pioneer-leaves-enduring-educational-legacy.jpg",
    date: "2026-04-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "nursing-loan-repayment-shocks-students-face-unexpected-debt-burden",
    title: "Nursing Loan Repayment Shocks: Students Face Unexpected Debt Burden",
    summary:
      "Students and recent graduates worldwide are facing profound financial distress after being informed that educational loans, previously granted for their nursing degrees, were issued in error and must now be repaid. This unexpected demand for repayment is causing significant anxiety and jeopardizing the financial stability of many aspiring healthcare professionals.",
    thumbnailImage: "/images/global-news/2026/2026-04-12-nursing-loan-repayment-shocks-students-face-unexpected-debt-burden.jpg",
    date: "2026-04-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-higher-education-governance-under-scrutiny-after-university-leader-s-dismissal",
    title: "Global Higher Education Governance Under Scrutiny After University Leader's Dismissal",
    summary:
      "The recent dismissal of a leading university president has ignited a global conversation on the intricate dynamics of higher education governance. Regents assert the former leader was fully aware of performance concerns, highlighting the complexities of institutional oversight.",
    thumbnailImage: "/images/global-news/2026/2026-04-12-global-higher-education-governance-under-scrutiny-after-university-leader-s-dism.jpg",
    date: "2026-04-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "fatal-dog-attacks-spark-global-dialogue-on-public-safety-and-animal-welfare",
    title: "Fatal Dog Attacks Spark Global Dialogue on Public Safety and Animal Welfare",
    summary:
      "Recent fatal dog attacks in the United Kingdom have brought renewed international attention to critical issues of public safety and animal welfare. These incidents highlight the global imperative for comprehensive strategies in responsible pet ownership and effective animal control.",
    thumbnailImage: "/images/global-news/2026/2026-04-12-fatal-dog-attacks-spark-global-dialogue-on-public-safety-and-animal-welfare.jpg",
    date: "2026-04-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-votes-for-populist-parties-in-may-elections-will-put",
    title: "Global Health and Education Watch: Votes for populist parties in May elections will put",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-12-global-health-and-education-watch-votes-for-populist-parties-in-may-elections-wi.jpg",
    date: "2026-04-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-schools-in-knife-crime-hotspots-to-get-specialist-training",
    title: "Global Health and Education Watch: Schools in knife crime hotspots to get specialist training",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-12-global-health-and-education-watch-schools-in-knife-crime-hotspots-to-get-special.jpg",
    date: "2026-04-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-dr-tiktok-patients-diagnose-chronic-illnesses-with-anonymous-commenters",
    title: "Global Health and Education Watch: Dr TikTok: patients diagnose chronic illnesses with anonymous commenters’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-12-global-health-and-education-watch-dr-tiktok-patients-diagnose-chronic-illnesses-.jpg",
    date: "2026-04-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-indian-music-legend-asha-bhosle-dies-aged-92",
    title: "Global Health and Education Watch: Indian music legend Asha Bhosle dies aged 92",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-12-global-health-and-education-watch-indian-music-legend-asha-bhosle-dies-aged-92.jpg",
    date: "2026-04-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-s-new-budget-ignores-dying-americans-and-gives-away",
    title: "Global Health and Education Watch: Trump’s new budget ignores dying Americans and gives away",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-12-global-health-and-education-watch-trump-s-new-budget-ignores-dying-americans-and.jpg",
    date: "2026-04-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-wes-streeting-attacks-trump-s-outrageous-iran-war-rhetoric",
    title: "Global Health and Education Watch: Wes Streeting attacks Trump’s ‘outrageous’ Iran war rhetoric",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-12-global-health-and-education-watch-wes-streeting-attacks-trump-s-outrageous-iran-.jpg",
    date: "2026-04-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-in-private-meeting-trump-soothes-disenchanted-maha-leaders",
    title: "Global Health and Education Watch: In Private Meeting, Trump Soothes Disenchanted MAHA Leaders",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-12-global-health-and-education-watch-in-private-meeting-trump-soothes-disenchanted-.jpg",
    date: "2026-04-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-cholera-vaccination-resumes-after-critical-supply-milestone",
    title: "Global Cholera Vaccination Resumes After Critical Supply Milestone",
    summary:
      "Preventive cholera vaccination campaigns have resumed globally following a crucial increase in vaccine supply, enabling the first such initiatives in over three years. Mozambique leads the restart, with Bangladesh and the Democratic Republic of the Congo also slated for vital preventive efforts.",
    thumbnailImage: "/images/global-news/2026/2026-04-12-global-cholera-vaccination-resumes-after-critical-supply-milestone.jpg",
    date: "2026-04-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-progress-in-reducing-child-deaths-slows-as-4-9-million-2",
    title: "Global Health and Education Watch: Progress in reducing child deaths slows as 4.9 million",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-12-global-health-and-education-watch-progress-in-reducing-child-deaths-slows-as-4-9.jpg",
    date: "2026-04-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-we-will-end-up-with-an-nhs-without-doctors",
    title: "Global Health and Education Watch: 'We will end up with an NHS without doctors'",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-12-global-health-and-education-watch-we-will-end-up-with-an-nhs-without-doctors.jpg",
    date: "2026-04-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-bangladesh-launches-measles-vaccination-drive-as-child-death-toll",
    title: "Global Health and Education Watch: Bangladesh launches measles vaccination drive as child death toll",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-12-global-health-and-education-watch-bangladesh-launches-measles-vaccination-drive-.jpg",
    date: "2026-04-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "university-leadership-navigates-global-campus-safety-challenges-post-incident",
    title: "University Leadership Navigates Global Campus Safety Challenges Post-Incident",
    summary:
      "A major university's decision to retain its police chief following a fatal campus incident highlights ongoing global discussions about security and leadership in higher education. This move underscores the complex challenges institutions face in ensuring student safety while maintaining community trust and academic freedom.",
    thumbnailImage: "/images/global-news/2026/2026-04-11-university-leadership-navigates-global-campus-safety-challenges-post-incident.jpg",
    date: "2026-04-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-education-under-scrutiny-academic-freedom-challenged-by-political-intervention",
    title: "Global Education Under Scrutiny: Academic Freedom Challenged by Political Intervention",
    summary:
      "Recent judicial dismissals following blocks on student deportations have sparked global concern over academic freedom and student rights. This incident highlights the increasing intersection of geopolitical tensions and educational institutions.",
    thumbnailImage: "/images/global-news/2026/2026-04-11-global-education-under-scrutiny-academic-freedom-challenged-by-political-interve.jpg",
    date: "2026-04-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-top-c-d-c-official-delays-report-on-covid-shot-s-effectiveness",
    title: "Global Health and Education Watch: Top C.D.C. Official Delays Report on Covid Shot’s Effectiveness",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-11-global-health-and-education-watch-top-c-d-c-official-delays-report-on-covid-shot.jpg",
    date: "2026-04-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israeli-strikes-kill-at-least-18-people-across-southern",
    title: "Global Health and Education Watch: Israeli strikes kill at least 18 people across southern",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-11-global-health-and-education-watch-israeli-strikes-kill-at-least-18-people-across.jpg",
    date: "2026-04-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "gaza-mourns-as-airstrikes-claim-lives-deepening-health-crisis",
    title: "Gaza Mourns as Airstrikes Claim Lives, Deepening Health Crisis",
    summary:
      "Families in Gaza are grappling with profound grief following overnight Israeli air strikes that killed seven individuals. The incident further strains the region's beleaguered healthcare system and intensifies the humanitarian crisis impacting countless lives.",
    thumbnailImage: "/images/global-news/2026/2026-04-11-gaza-mourns-as-airstrikes-claim-lives-deepening-health-crisis.jpg",
    date: "2026-04-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-student-loan-interest-could-rise-despite-cap-on-rates",
    title: "Global Health and Education Watch: Student loan interest could rise despite cap on rates",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-11-global-health-and-education-watch-student-loan-interest-could-rise-despite-cap-o.jpg",
    date: "2026-04-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "culinary-memorial-a-restaurant-s-name-echoes-gaza-s-grief-fosters-global-hope",
    title: "Culinary Memorial: A Restaurant's Name Echoes Gaza's Grief, Fosters Global Hope",
    summary:
      "A restaurant near Columbia University offers Palestinian cuisine, serving as a poignant memorial for a five-year-old child killed in Gaza. It stands as a powerful symbol of cultural preservation and hope amidst global conflict.",
    thumbnailImage: "/images/global-news/2026/2026-04-11-culinary-memorial-a-restaurant-s-name-echoes-gaza-s-grief-fosters-global-hope.jpg",
    date: "2026-04-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-alarms-ring-over-surging-glyphosate-herbicide-use",
    title: "Global Health Alarms Ring Over Surging Glyphosate Herbicide Use",
    summary:
      "Global use of the herbicide glyphosate has surged tenfold over three decades, sparking widespread alarm among public health advocates. This escalating reliance, initially driven by agricultural efficiency, now prompts urgent calls for regulatory intervention and sustainable alternatives.",
    thumbnailImage: "/images/global-news/2026/2026-04-11-global-health-alarms-ring-over-surging-glyphosate-herbicide-use.jpg",
    date: "2026-04-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "urban-violence-echoes-a-global-health-imperative-from-new-york-s-grand-central",
    title: "Urban Violence Echoes: A Global Health Imperative from New York's Grand Central",
    summary:
      "A recent violent event at New York's Grand Central station, leaving two critically injured, highlights the pervasive challenge of urban violence. This incident serves as a stark reminder of the global imperative to address public safety through robust health and social interventions.",
    thumbnailImage: "/images/global-news/2026/2026-04-11-urban-violence-echoes-a-global-health-imperative-from-new-york-s-grand-central.jpg",
    date: "2026-04-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-debate-should-teenagers-everywhere-receive-menb-vaccine",
    title: "Global Debate: Should Teenagers Everywhere Receive MenB Vaccine?",
    summary:
      "A recent meningitis outbreak in the UK has reignited discussions about the global efficacy and accessibility of the MenB vaccine for teenagers. Health organizations are evaluating the public health benefits and economic implications of extending routine immunization programs to older age groups.",
    thumbnailImage: "/images/global-news/2026/2026-04-11-global-debate-should-teenagers-everywhere-receive-menb-vaccine.jpg",
    date: "2026-04-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "gaza-s-makeshift-university-ignites-hope-amidst-unprecedented-educational-crisis",
    title: "Gaza's Makeshift University Ignites Hope Amidst Unprecedented Educational Crisis",
    summary:
      "In war-torn Gaza, a makeshift university powered by solar energy is providing a vital academic lifeline. It offers students a chance to resume their education amidst the destruction of traditional institutions and severe resource scarcity.",
    thumbnailImage: "/images/global-news/2026/2026-04-11-gaza-s-makeshift-university-ignites-hope-amidst-unprecedented-educational-crisis.jpg",
    date: "2026-04-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-midwifery-under-threat-georgia-case-highlights-urgent-need-for-reform",
    title: "Global Midwifery Under Threat: Georgia Case Highlights Urgent Need for Reform",
    summary:
      "A new lawsuit in Georgia, USA, seeks to decriminalize midwives, highlighting a global paradox where essential maternal healthcare providers face legal and systemic barriers despite worsening health crises. This situation underscores the urgent need for international reforms to integrate and support midwifery for safer, more equitable births worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-11-global-midwifery-under-threat-georgia-case-highlights-urgent-need-for-reform.jpg",
    date: "2026-04-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-looking-for-a-college-scholarship-on-social-media-sites",
    title: "Global Health and Education Watch: Looking for a College Scholarship on Social Media Sites?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-11-global-health-and-education-watch-looking-for-a-college-scholarship-on-social-me.jpg",
    date: "2026-04-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-weekend-students-at-15-universities-in-england-told-to",
    title: "Global Health and Education Watch: Weekend students at 15 universities in England told to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-11-global-health-and-education-watch-weekend-students-at-15-universities-in-england.jpg",
    date: "2026-04-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "artemis-ii-s-return-a-beacon-for-global-health-and-education",
    title: "Artemis II's Return: A Beacon for Global Health and Education",
    summary:
      "The successful return of the Artemis II mission marks a pivotal moment for space exploration, extending its influence far beyond the cosmos. This achievement serves as a powerful catalyst for advancements in global health research and ignites a renewed passion for STEM education across continents.",
    thumbnailImage: "/images/global-news/2026/2026-04-11-artemis-ii-s-return-a-beacon-for-global-health-and-education.jpg",
    date: "2026-04-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "the-health-advantage-of-optimism-a-global-perspective-on-well-being",
    title: "The Health Advantage of Optimism: A Global Perspective on Well-being",
    summary:
      "Emerging global health research indicates that cultivating optimism offers significant benefits for physical and mental well-being. Prioritizing a positive mindset may prove more beneficial for health than a purely realistic or pessimistic view.",
    thumbnailImage: "/images/global-news/2026/2026-04-11-the-health-advantage-of-optimism-a-global-perspective-on-well-being.jpg",
    date: "2026-04-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "covid-19-vaccination-s-impact-on-mgus-a-global-reassurance",
    title: "COVID-19 Vaccination's Impact on MGUS: A Global Reassurance",
    summary:
      "A significant global study provides crucial insights into the safety of SARS-CoV-2 vaccination for individuals with Monoclonal Gammopathy of Undetermined Significance (MGUS). The population-based iStopMM research offers reassurance, indicating no heightened risk of MGUS progression post-vaccination.",
    thumbnailImage: "/images/global-news/2026/2026-04-11-covid-19-vaccination-s-impact-on-mgus-a-global-reassurance.jpg",
    date: "2026-04-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-iran-war-live-us-negotiators-due-to-arrive-in",
    title: "Global Health and Education Watch: Iran war live: US negotiators due to arrive in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-11-global-health-and-education-watch-iran-war-live-us-negotiators-due-to-arrive-in.jpg",
    date: "2026-04-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "beyond-the-brush-why-tongue-cleaning-is-crucial-for-global-oral-health",
    title: "Beyond the Brush: Why Tongue Cleaning is Crucial for Global Oral Health",
    summary:
      "Despite widespread awareness of teeth brushing, experts globally emphasize the critical, often neglected, role of tongue cleaning in maintaining oral health. This simple practice is deemed as vital as brushing for preventing bad breath and contributing to overall well-being.",
    thumbnailImage: "/images/global-news/2026/2026-04-10-beyond-the-brush-why-tongue-cleaning-is-crucial-for-global-oral-health.jpg",
    date: "2026-04-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-university-of-ottawa-in-lockdown-amid-violent-incident",
    title: "Global Health and Education Watch: University of Ottawa in Lockdown Amid ‘Violent Incident’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-10-global-health-and-education-watch-university-of-ottawa-in-lockdown-amid-violent-.jpg",
    date: "2026-04-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "repurposed-drug-shows-promise-in-aggressive-ovarian-cancer-survival-trial",
    title: "Repurposed Drug Shows Promise in Aggressive Ovarian Cancer Survival Trial",
    summary:
      "A clinical trial indicates that Relacorilant, a drug previously used for Cushing's syndrome, could significantly extend survival for patients battling aggressive, platinum-resistant ovarian cancer. This development offers new hope for those facing limited treatment options worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-10-repurposed-drug-shows-promise-in-aggressive-ovarian-cancer-survival-trial.jpg",
    date: "2026-04-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "isle-of-wight-study-probes-environmental-keys-to-well-being",
    title: "Isle of Wight Study Probes Environmental Keys to Well-being",
    summary:
      "A new research initiative is underway on the Isle of Wight to uncover the specific environmental and lifestyle factors that contribute to residents' improved health. This study aims to provide insights into how geographical locations can foster well-being, with potential global implications for public health strategies.",
    thumbnailImage: "/images/global-news/2026/2026-04-10-isle-of-wight-study-probes-environmental-keys-to-well-being.jpg",
    date: "2026-04-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "sudan-s-crisis-deepens-millions-displaced-health-systems-collapse-in-war-s-third-year",
    title: "Sudan's Crisis Deepens: Millions Displaced, Health Systems Collapse in War's Third Year",
    summary:
      "Sudan's devastating civil war enters its third year, leaving 14 million people displaced and a nation grappling with widespread hunger. The conflict has decimated the health system, triggering disease outbreaks and a profound humanitarian crisis.",
    thumbnailImage: "/images/global-news/2026/2026-04-10-sudan-s-crisis-deepens-millions-displaced-health-systems-collapse-in-war-s-third.jpg",
    date: "2026-04-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "guinea-bissau-hepatitis-b-birth-dose-trial-under-global-scrutiny",
    title: "Guinea-Bissau Hepatitis B Birth Dose Trial Under Global Scrutiny",
    summary:
      "A planned hepatitis B birth dose vaccine trial in Guinea-Bissau is drawing global attention, with the World Health Organization emphasizing rigorous ethical oversight. This research is vital for advancing strategies to combat the widespread viral infection, particularly in vulnerable populations.",
    thumbnailImage: "/images/global-news/2026/2026-04-10-guinea-bissau-hepatitis-b-birth-dose-trial-under-global-scrutiny.jpg",
    date: "2026-04-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israel-threatens-healthcare-as-it-continues-to-attack-lebanon",
    title: "Global Health and Education Watch: Israel threatens healthcare as it continues to attack Lebanon",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-10-global-health-and-education-watch-israel-threatens-healthcare-as-it-continues-to.jpg",
    date: "2026-04-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-have-you-used-a-i-chatbots-for-nutrition-advice",
    title: "Global Health and Education Watch: Have You Used A.I. Chatbots for Nutrition Advice?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-10-global-health-and-education-watch-have-you-used-a-i-chatbots-for-nutrition-advic.jpg",
    date: "2026-04-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-lebanon-airstrike-casualties-still-under-the-rubble-as-ambulances",
    title: "Global Health and Education Watch: Lebanon airstrike casualties ‘still under the rubble’ as ambulances",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-10-global-health-and-education-watch-lebanon-airstrike-casualties-still-under-the-r.jpg",
    date: "2026-04-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-weather-tracker-cyclone-maila-batters-solomon-islands-with-115mph",
    title: "Global Health and Education Watch: Weather tracker: Cyclone Maila batters Solomon Islands with 115mph",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-10-global-health-and-education-watch-weather-tracker-cyclone-maila-batters-solomon-.jpg",
    date: "2026-04-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-alarm-as-acting-cdc-director-delays-report-showing-covid",
    title: "Global Health and Education Watch: Alarm as acting CDC director delays report showing Covid",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-10-global-health-and-education-watch-alarm-as-acting-cdc-director-delays-report-sho.jpg",
    date: "2026-04-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-can-food-actually-be-medicine-these-doctors-say-yes",
    title: "Global Health and Education Watch: Can Food Actually Be Medicine? These Doctors Say Yes",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-10-global-health-and-education-watch-can-food-actually-be-medicine-these-doctors-sa.jpg",
    date: "2026-04-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ai-diagnoses-rare-illness-ending-years-of-misery-and-misdiagnosis",
    title: "AI Diagnoses Rare Illness, Ending Years of Misery and Misdiagnosis",
    summary:
      "After years of baffling symptoms and medical dismissals, a woman's rare condition was finally identified with the unexpected aid of ChatGPT. This case underscores the burgeoning role of artificial intelligence in overcoming diagnostic challenges in global health.",
    thumbnailImage: "/images/global-news/2026/2026-04-10-ai-diagnoses-rare-illness-ending-years-of-misery-and-misdiagnosis.jpg",
    date: "2026-04-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "rafah-restrictions-shatter-dreams-gaza-s-future-doctors-face-bleak-horizon",
    title: "Rafah Restrictions Shatter Dreams: Gaza's Future Doctors Face Bleak Horizon",
    summary:
      "Ongoing restrictions at the Rafah crossing have severely impacted a Palestinian medical student's academic future, jeopardizing their dream of becoming a doctor. This individual case highlights the broader, catastrophic disruption of education and healthcare pathways for countless students in conflict-affected regions worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-10-rafah-restrictions-shatter-dreams-gaza-s-future-doctors-face-bleak-horizon.jpg",
    date: "2026-04-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-was-a-florida-woman-forced-to-have-a",
    title: "Global Health and Education Watch: Why was a Florida woman forced to have a",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-10-global-health-and-education-watch-why-was-a-florida-woman-forced-to-have-a.jpg",
    date: "2026-04-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-woman-with-three-deadly-diseases-has-remarkable-recovery-after",
    title: "Global Health and Education Watch: Woman with three deadly diseases has ‘remarkable’ recovery after",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-10-global-health-and-education-watch-woman-with-three-deadly-diseases-has-remarkabl.jpg",
    date: "2026-04-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ai-transforms-mock-exam-grading-faster-feedback-reduced-bias",
    title: "AI Transforms Mock Exam Grading: Faster Feedback, Reduced Bias",
    summary:
      "Artificial intelligence is being deployed in schools worldwide to mark mock exams, offering students faster, more comprehensive feedback. This innovation aims to reduce teacher bias and streamline assessment processes across educational institutions.",
    thumbnailImage: "/images/global-news/2026/2026-04-10-ai-transforms-mock-exam-grading-faster-feedback-reduced-bias.jpg",
    date: "2026-04-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-unites-who-forum-forges-stronger-scientific-collaboration",
    title: "Global Health Unites: WHO Forum Forges Stronger Scientific Collaboration",
    summary:
      "The World Health Organization convened its first Global Forum of Collaborating Centres, uniting over 800 institutions from 80+ countries. This landmark event aims to strengthen scientific collaboration, enhance global health security, and accelerate progress towards universal health coverage.",
    thumbnailImage: "/images/global-news/2026/2026-04-09-global-health-unites-who-forum-forges-stronger-scientific-collaboration.jpg",
    date: "2026-04-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-governance-faces-scrutiny-amidst-vaccine-policy-shift",
    title: "Global Health Governance Faces Scrutiny Amidst Vaccine Policy Shift",
    summary:
      "A major nation's new charter redefines its vaccine policy advisory panel, allowing the Health Secretary to reclaim policy revision. This move sparks global debate on scientific autonomy and public trust in health governance.",
    thumbnailImage: "/images/global-news/2026/2026-04-09-global-health-governance-faces-scrutiny-amidst-vaccine-policy-shift.jpg",
    date: "2026-04-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hospitals-in-beirut-struggle-to-deal-with-casualties-after",
    title: "Global Health and Education Watch: Hospitals in Beirut struggle to deal with casualties after",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-09-global-health-and-education-watch-hospitals-in-beirut-struggle-to-deal-with-casu.jpg",
    date: "2026-04-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "wearable-health-tech-valuations-soar-signifying-data-s-rising-global-value",
    title: "Wearable Health Tech Valuations Soar, Signifying Data's Rising Global Value",
    summary:
      "The recent multi-billion dollar valuations of health wearable companies Oura and Whoop underscore a significant global investment trend in personal health technology. This development signals a growing recognition of health data as a valuable asset, driving innovation and reshaping the future of wellness worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-09-wearable-health-tech-valuations-soar-signifying-data-s-rising-global-value.jpg",
    date: "2026-04-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "lebanon-s-health-system-crumbles-under-israeli-strikes-amidst-ceasefire-hopes",
    title: "Lebanon's Health System Crumbles Under Israeli Strikes Amidst Ceasefire Hopes",
    summary:
      "A recent wave of Israeli airstrikes in Lebanon, following a US-Iran ceasefire announcement, has severely crippled the nation's already fragile health system. The World Health Organization reports widespread destruction and an inability to cope with the influx of casualties and disruption to essential services.",
    thumbnailImage: "/images/global-news/2026/2026-04-09-lebanon-s-health-system-crumbles-under-israeli-strikes-amidst-ceasefire-hopes.jpg",
    date: "2026-04-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "us-withdrawal-from-who-global-health-security-at-a-crossroads",
    title: "US Withdrawal from WHO: Global Health Security at a Crossroads",
    summary:
      "The World Health Organization has acknowledged the United States' notification of withdrawal, a decision it views as detrimental to both American and global health security. This significant development will be deliberated by the WHO Executive Board and the World Health Assembly in upcoming meetings.",
    thumbnailImage: "/images/global-news/2026/2026-04-09-us-withdrawal-from-who-global-health-security-at-a-crossroads.jpg",
    date: "2026-04-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-study-illuminates-effective-early-childhood-weight-interventions",
    title: "Global Study Illuminates Effective Early Childhood Weight Interventions",
    summary:
      "A landmark systematic review and meta-analysis reveals critical insights into effective healthy weight interventions during early childhood. The findings offer a global roadmap for public health initiatives aimed at preventing childhood obesity.",
    thumbnailImage: "/images/global-news/2026/2026-04-09-global-study-illuminates-effective-early-childhood-weight-interventions.jpg",
    date: "2026-04-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "iranians-unite-in-outrage-over-strike-on-premier-university",
    title: "Iranians Unite in Outrage Over Strike on Premier University",
    summary:
      "A recent strike on the Sharif University of Technology in Tehran has sparked widespread condemnation from both Iranian government officials and anti-government activists. This incident marks the latest targeting of a higher education institution in Iran, raising global concerns about the protection of academic spaces.",
    thumbnailImage: "/images/global-news/2026/2026-04-09-iranians-unite-in-outrage-over-strike-on-premier-university.jpg",
    date: "2026-04-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "new-study-reveals-complex-malnutrition-patterns-in-sub-saharan-african-children",
    title: "New Study Reveals Complex Malnutrition Patterns in Sub-Saharan African Children",
    summary:
      "A recent study highlights the severe challenge of children in sub-Saharan Africa suffering from multiple forms of malnutrition simultaneously. This research underscores the urgent need for comprehensive, integrated interventions to address these complex health burdens effectively.",
    thumbnailImage: "/images/global-news/2026/2026-04-09-new-study-reveals-complex-malnutrition-patterns-in-sub-saharan-african-children.jpg",
    date: "2026-04-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "thousands-face-loan-repayment-crisis-over-ineligible-courses",
    title: "Thousands Face Loan Repayment Crisis Over Ineligible Courses",
    summary:
      "Over 22,000 students worldwide are confronting demands to repay maintenance and childcare loans after their courses were retrospectively declared ineligible. This unprecedented situation highlights critical flaws in student finance administration and regulatory oversight, causing immense financial and emotional distress.",
    thumbnailImage: "/images/global-news/2026/2026-04-09-thousands-face-loan-repayment-crisis-over-ineligible-courses.jpg",
    date: "2026-04-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-george-clooney-calls-donald-trump-s-a-whole-civilization-will",
    title: "Global Health and Education Watch: George Clooney calls Donald Trump’s ‘a whole civilization will",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-09-global-health-and-education-watch-george-clooney-calls-donald-trump-s-a-whole-ci.jpg",
    date: "2026-04-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-thursday-briefing-what-difference-will-the-ceasefire-in-the",
    title: "Global Health and Education Watch: Thursday briefing: ​What difference will the ceasefire in the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-09-global-health-and-education-watch-thursday-briefing-what-difference-will-the-cea.jpg",
    date: "2026-04-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-healthcare-systems-grapple-with-strikes-amid-holiday-disruptions",
    title: "Global Healthcare Systems Grapple with Strikes Amid Holiday Disruptions",
    summary:
      "A recent six-day doctors' strike in England, strategically timed over the Easter holiday, severely impacted hospital operations and patient care, with authorities citing deliberate intent to disrupt. This incident underscores universal challenges faced by healthcare systems globally in managing worker disputes and ensuring continuity of essential services during critical periods.",
    thumbnailImage: "/images/global-news/2026/2026-04-09-global-healthcare-systems-grapple-with-strikes-amid-holiday-disruptions.jpg",
    date: "2026-04-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-excessive-financial-risks-threaten-survival-of-many-english-universities",
    title: "Global Health and Education Watch: ‘Excessive’ financial risks threaten survival of many English universities",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-08-global-health-and-education-watch-excessive-financial-risks-threaten-survival-of.jpg",
    date: "2026-04-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-scrutiny-schools-grapple-with-gender-identity-parental-rights-and-student-well-being",
    title: "Global Scrutiny: Schools Grapple with Gender Identity, Parental Rights, and Student Well-being",
    summary:
      "A high-profile investigation into a major U.S. school district's gender disclosure policies underscores a growing global debate. This case, prompted by a tragic lawsuit, illuminates the intricate balance required between student well-being, parental rights, and school responsibilities.",
    thumbnailImage: "/images/global-news/2026/2026-04-08-global-scrutiny-schools-grapple-with-gender-identity-parental-rights-and-student.jpg",
    date: "2026-04-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hospitals-coping-well-with-doctors-strike-so-far",
    title: "Global Health and Education Watch: Hospitals coping well with doctors' strike so far",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-08-global-health-and-education-watch-hospitals-coping-well-with-doctors-strike-so-f.jpg",
    date: "2026-04-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-sea-level-rise-is-a-health-crisis-and-we-must",
    title: "Global Health and Education Watch: Sea-level rise is a health crisis and we must",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-08-global-health-and-education-watch-sea-level-rise-is-a-health-crisis-and-we-must.jpg",
    date: "2026-04-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "yemen-s-children-face-perilous-path-to-education-amidst-enduring-conflict",
    title: "Yemen's Children Face Perilous Path to Education Amidst Enduring Conflict",
    summary:
      "A Yemeni teenager was tragically killed by a suspected sniper while en route to school in Taiz, sparking profound grief and global concern. This incident highlights the extreme dangers children face in conflict zones, where the fundamental right to education is under constant threat.",
    thumbnailImage: "/images/global-news/2026/2026-04-08-yemen-s-children-face-perilous-path-to-education-amidst-enduring-conflict.jpg",
    date: "2026-04-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-funding-is-vital-to-end-the-scourge-of-polio",
    title: "Global Health and Education Watch: Funding is vital to end the scourge of polio",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-08-global-health-and-education-watch-funding-is-vital-to-end-the-scourge-of-polio.jpg",
    date: "2026-04-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-world-held-hostage-by-reliance-on-fossil-fuels-christiana",
    title: "Global Health and Education Watch: World held hostage by reliance on fossil fuels, Christiana",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-08-global-health-and-education-watch-world-held-hostage-by-reliance-on-fossil-fuels.jpg",
    date: "2026-04-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-leader-of-university-of-wisconsin-system-is-fired-by",
    title: "Global Health and Education Watch: Leader of University of Wisconsin System Is Fired by",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-08-global-health-and-education-watch-leader-of-university-of-wisconsin-system-is-fi.jpg",
    date: "2026-04-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-road-safety-spotlighted-after-tragic-tourist-fatality-in-vietnam",
    title: "Global Road Safety Spotlighted After Tragic Tourist Fatality in Vietnam",
    summary:
      "The recent death of a British teenager in a motorcycle accident on Vietnam's Ha Giang loop has brought renewed attention to the critical need for robust global road safety measures and accessible emergency medical services for international travelers. This tragic incident highlights the inherent risks in adventure tourism and the imperative for comprehensive pre-travel education and support systems.",
    thumbnailImage: "/images/global-news/2026/2026-04-08-global-road-safety-spotlighted-after-tragic-tourist-fatality-in-vietnam.jpg",
    date: "2026-04-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ban-for-teacher-who-told-pupils-about-drunken-night",
    title: "Global Health and Education Watch: Ban for teacher who told pupils about drunken night",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-08-global-health-and-education-watch-ban-for-teacher-who-told-pupils-about-drunken-.jpg",
    date: "2026-04-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-are-the-health-impacts-of-sea-level-rise-and",
    title: "Global Health and Education Watch: What are the health impacts of sea-level rise, and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-08-global-health-and-education-watch-what-are-the-health-impacts-of-sea-level-rise-.jpg",
    date: "2026-04-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-iranians-commemorate-victims-of-minab-school-strike",
    title: "Global Health and Education Watch: Iranians commemorate victims of Minab school strike",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-08-global-health-and-education-watch-iranians-commemorate-victims-of-minab-school-s.jpg",
    date: "2026-04-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-and-france-shift-one-health-vision-to-action",
    title: "Global Health and Education Watch: WHO and France shift One Health vision to action",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-08-global-health-and-education-watch-who-and-france-shift-one-health-vision-to-acti.jpg",
    date: "2026-04-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-crises-converge-mediterranean-tragedy-afghan-displacement-and-one-health-imperative",
    title: "Global Crises Converge: Mediterranean Tragedy, Afghan Displacement, and One Health Imperative",
    summary:
      "Over 180 individuals are feared lost in recent Mediterranean shipwrecks, while Afghanistan faces severe displacement. These crises underscore the urgency of global cooperation, as leaders convene for a 'One Health' summit to address interconnected human, animal, and environmental health threats.",
    thumbnailImage: "/images/global-news/2026/2026-04-07-global-crises-converge-mediterranean-tragedy-afghan-displacement-and-one-health-.jpg",
    date: "2026-04-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-teaching-in-an-american-university-feels-very-strange-right",
    title: "Global Health and Education Watch: Teaching in an American University Feels Very Strange Right",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-07-global-health-and-education-watch-teaching-in-an-american-university-feels-very-.jpg",
    date: "2026-04-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-early-treatment-is-key-to-children-recovering-from-eating",
    title: "Global Health and Education Watch: Early treatment is key to children recovering from eating",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-07-global-health-and-education-watch-early-treatment-is-key-to-children-recovering-.jpg",
    date: "2026-04-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-pupils-back-to-school-in-holidays-to-deal-with",
    title: "Global Health and Education Watch: Pupils back to school in holidays to deal with",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-07-global-health-and-education-watch-pupils-back-to-school-in-holidays-to-deal-with.jpg",
    date: "2026-04-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-paradox-women-live-longer-yet-suffer-more-from-systemic-bias",
    title: "Global Health Paradox: Women Live Longer, Yet Suffer More from Systemic Bias",
    summary:
      "Globally, women are living longer than ever before, but systemic medical bias and frequent misdiagnosis mean they are not living better. This disparity highlights a critical need for inclusive healthcare research and gender-sensitive clinical practices worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-07-global-health-paradox-women-live-longer-yet-suffer-more-from-systemic-bias.jpg",
    date: "2026-04-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-leadership-nci-program-shapes-cancer-prevention-experts",
    title: "Global Health Leadership: NCI Program Shapes Cancer Prevention Experts",
    summary:
      "The NCI Cancer Prevention Fellowship Program is successfully training a new generation of multidisciplinary public health leaders. These experts are vital for advancing global strategies against the rising incidence of cancer.",
    thumbnailImage: "/images/global-news/2026/2026-04-07-global-health-leadership-nci-program-shapes-cancer-prevention-experts.jpg",
    date: "2026-04-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-us-israel-are-waging-a-war-on-iranian",
    title: "Global Health and Education Watch: How US, Israel are waging a war on Iranian",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-07-global-health-and-education-watch-how-us-israel-are-waging-a-war-on-iranian.jpg",
    date: "2026-04-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-texas-considers-required-reading-list-for-schools-which-includes",
    title: "Global Health and Education Watch: Texas Considers Required Reading List for Schools, Which Includes",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-07-global-health-and-education-watch-texas-considers-required-reading-list-for-scho.jpg",
    date: "2026-04-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "invisible-threat-microplastics-linked-to-global-liver-disease-risk",
    title: "Invisible Threat: Microplastics Linked to Global Liver Disease Risk",
    summary:
      "Emerging scientific evidence suggests that ubiquitous microplastic and nanoplastic particles are not merely environmental pollutants but a significant, overlooked threat to global human health. These microscopic plastic fragments are increasingly implicated in the development and progression of liver diseases, posing a critical challenge to public health worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-07-invisible-threat-microplastics-linked-to-global-liver-disease-risk.jpg",
    date: "2026-04-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-bosses-can-help-ease-britain-s-sickness-crisis-says-former",
    title: "Global Health and Education Watch: Bosses can help ease Britain’s sickness crisis, says former",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-07-global-health-and-education-watch-bosses-can-help-ease-britain-s-sickness-crisis.jpg",
    date: "2026-04-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "exploitation-unveiled-the-harsh-reality-for-international-students-in-the-uk",
    title: "Exploitation Unveiled: The Harsh Reality for International Students in the UK",
    summary:
      "British universities' reliance on international student fees fuels a predatory recruitment ecosystem, leaving many hopefuls and their families in profound debt. This system often exposes students to exploitation, blurring lines between education and potential trafficking.",
    thumbnailImage: "/images/global-news/2026/2026-04-07-exploitation-unveiled-the-harsh-reality-for-international-students-in-the-uk.jpg",
    date: "2026-04-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "schools-must-practice-emergency-responses-beyond-fire-drills",
    title: "Schools Must Practice Emergency Responses Beyond Fire Drills",
    summary:
      "Schools worldwide are urged to adopt comprehensive emergency preparedness, practicing responses for various threats beyond just fire drills. This proactive approach aims to build resilience and ensure safety for students and staff in an evolving global landscape.",
    thumbnailImage: "/images/global-news/2026/2026-04-07-schools-must-practice-emergency-responses-beyond-fire-drills.jpg",
    date: "2026-04-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-middle-east-crisis-live-trump-says-he-is-not",
    title: "Global Health and Education Watch: Middle East crisis live: Trump says he is ‘not",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-07-global-health-and-education-watch-middle-east-crisis-live-trump-says-he-is-not.jpg",
    date: "2026-04-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "us-medicare-payment-boost-sparks-global-healthcare-funding-debate",
    title: "US Medicare Payment Boost Sparks Global Healthcare Funding Debate",
    summary:
      "US health insurer shares surged following the Trump administration's decision to boost Medicare Advantage payments, impacting major players like UnitedHealth and Humana. This policy shift highlights the complex interplay of government funding, private sector involvement, and healthcare access in a global context.",
    thumbnailImage: "/images/global-news/2026/2026-04-06-us-medicare-payment-boost-sparks-global-healthcare-funding-debate.jpg",
    date: "2026-04-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-administration-pulls-out-of-civil-rights-settlements-backing",
    title: "Global Health and Education Watch: Trump Administration Pulls Out of Civil Rights Settlements Backing",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-06-global-health-and-education-watch-trump-administration-pulls-out-of-civil-rights.jpg",
    date: "2026-04-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israeli-air-strike-kills-at-least-10-palestinians-near",
    title: "Global Health and Education Watch: Israeli air strike kills at least 10 Palestinians near",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-06-global-health-and-education-watch-israeli-air-strike-kills-at-least-10-palestini.jpg",
    date: "2026-04-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-sleep-exercise-hydrate-do-we-really-need-to-2",
    title: "Global Health and Education Watch: Sleep, exercise, hydrate - do we really need to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-06-global-health-and-education-watch-sleep-exercise-hydrate-do-we-really-need-to.jpg",
    date: "2026-04-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "un80-reform-advances-un-women-unfpa-merger-explored-for-enhanced-global-impact",
    title: "UN80 Reform Advances: UN Women, UNFPA Merger Explored for Enhanced Global Impact",
    summary:
      "The UN80 reform initiative is now in its 'delivery phase,' with Member States assessing progress on pivotal proposals. Discussions include a potential merger of UN Women and UNFPA, alongside advancements in technology and data strategies.",
    thumbnailImage: "/images/global-news/2026/2026-04-06-un80-reform-advances-un-women-unfpa-merger-explored-for-enhanced-global-impact.jpg",
    date: "2026-04-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-calls-for-action-together-for-health-stand-with",
    title: "Global Health and Education Watch: WHO calls for action: “Together for health. Stand with",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-06-global-health-and-education-watch-who-calls-for-action-together-for-health-stand.jpg",
    date: "2026-04-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "arizona-hiker-s-ordeal-spotlights-global-wilderness-health-risks",
    title: "Arizona Hiker's Ordeal Spotlights Global Wilderness Health Risks",
    summary:
      "A hiker in Arizona was hospitalized in critical condition after sustaining over a hundred bee stings, requiring a complex helicopter rescue operation. This incident highlights the global importance of understanding wilderness risks and the critical role of rapid emergency response in remote environments.",
    thumbnailImage: "/images/global-news/2026/2026-04-06-arizona-hiker-s-ordeal-spotlights-global-wilderness-health-risks.jpg",
    date: "2026-04-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-public-health-takes-center-stage-in-us-midterm-campaigns",
    title: "Global Health and Education Watch: Public health takes center stage in US midterm campaigns",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-06-global-health-and-education-watch-public-health-takes-center-stage-in-us-midterm.jpg",
    date: "2026-04-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "embracing-uncertainty-a-new-paradigm-for-global-medical-trust",
    title: "Embracing Uncertainty: A New Paradigm for Global Medical Trust",
    summary:
      "The traditional image of an infallible physician is evolving globally as doctors find strength in vulnerability. Admitting uncertainty can enhance patient trust and lead to more compassionate, effective healthcare outcomes.",
    thumbnailImage: "/images/global-news/2026/2026-04-06-embracing-uncertainty-a-new-paradigm-for-global-medical-trust.jpg",
    date: "2026-04-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "us-international-student-decline-squeezes-colleges-reshapes-global-education",
    title: "US International Student Decline Squeezes Colleges, Reshapes Global Education",
    summary:
      "A significant decline in international student enrollment in the United States, driven by Trump administration policies, is creating widespread financial strain for colleges. This shift is also profoundly reshaping global education dynamics and talent mobility worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-06-us-international-student-decline-squeezes-colleges-reshapes-global-education.jpg",
    date: "2026-04-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-the-us-needs-a-unified-mission-based-strategy-for",
    title: "Global Health and Education Watch: Why the US needs a unified, mission-based strategy for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-06-global-health-and-education-watch-why-the-us-needs-a-unified-mission-based-strat.jpg",
    date: "2026-04-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-iran-s-top-university-bombed-as-us-israel-intensify-attacks",
    title: "Global Health and Education Watch: Iran’s top university bombed as US, Israel intensify attacks",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-06-global-health-and-education-watch-iran-s-top-university-bombed-as-us-israel-inte.jpg",
    date: "2026-04-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "mpox-knowledge-and-vaccine-attitudes-in-lebanon-s-second-wave-revealed",
    title: "Mpox Knowledge and Vaccine Attitudes in Lebanon's Second Wave Revealed",
    summary:
      "A recent study from Lebanon sheds light on public knowledge and attitudes towards mpox during its second wave. The findings underscore the importance of targeted public health campaigns to address misinformation and promote vaccination globally.",
    thumbnailImage: "/images/global-news/2026/2026-04-06-mpox-knowledge-and-vaccine-attitudes-in-lebanon-s-second-wave-revealed.jpg",
    date: "2026-04-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-joint-statement-on-the-renewed-quadripartite-memorandum-of-understanding-2",
    title: "Global Health and Education Watch: Joint statement on the renewed Quadripartite Memorandum of Understanding",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-06-global-health-and-education-watch-joint-statement-on-the-renewed-quadripartite-m.jpg",
    date: "2026-04-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "china-s-quiet-grief-an-education-influencer-s-death-sparks-global-debate-on-academic-pressure",
    title: "China's Quiet Grief: An Education Influencer's Death Sparks Global Debate on Academic Pressure",
    summary:
      "The death of Chinese education influencer Zhang Xuefeng triggered a national outpouring of grief, reflecting deep public frustration with the country's demanding higher education system. This quiet revolt highlights global challenges in academic pressure, career pathways, and student well-being.",
    thumbnailImage: "/images/global-news/2026/2026-04-06-china-s-quiet-grief-an-education-influencer-s-death-sparks-global-debate-on-acad.jpg",
    date: "2026-04-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-accessibility-safeguarding-essential-disability-support-programs",
    title: "Global Accessibility: Safeguarding Essential Disability Support Programs",
    summary:
      "Across the globe, programs designed to enhance accessibility for individuals with disabilities are expanding, highlighting a universal need for support. However, this growth also brings challenges related to misuse and fraud, threatening the efficacy and fairness of these crucial initiatives.",
    thumbnailImage: "/images/global-news/2026/2026-04-06-global-accessibility-safeguarding-essential-disability-support-programs.jpg",
    date: "2026-04-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-healthcare-systems-under-strain-the-peril-of-service-disruptions",
    title: "Global Healthcare Systems Under Strain: The Peril of Service Disruptions",
    summary:
      "Healthcare systems globally face immense pressure as medical professionals advocate for improved conditions, leading to service disruptions. Patients are consistently urged not to defer necessary medical attention despite these challenges, highlighting a universal dilemma.",
    thumbnailImage: "/images/global-news/2026/2026-04-05-global-healthcare-systems-under-strain-the-peril-of-service-disruptions.jpg",
    date: "2026-04-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "eli-lilly-acquires-centessa-bolstering-narcolepsy-treatment-pipeline-globally",
    title: "Eli Lilly Acquires Centessa, Bolstering Narcolepsy Treatment Pipeline Globally",
    summary:
      "Eli Lilly has announced its intention to acquire Centessa Pharmaceuticals for $6.3 billion, aiming to advance a promising narcolepsy drug. This strategic move highlights the pharmaceutical industry's focus on addressing unmet needs in neurological health worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-05-eli-lilly-acquires-centessa-bolstering-narcolepsy-treatment-pipeline-globally.jpg",
    date: "2026-04-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-new-school-will-mean-15-hours-travelling-say-mums",
    title: "Global Health and Education Watch: New school will mean 15 hours travelling, say mums",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-05-global-health-and-education-watch-new-school-will-mean-15-hours-travelling-say-m.jpg",
    date: "2026-04-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "gaza-strike-highlights-global-health-crisis-in-conflict-zones",
    title: "Gaza Strike Highlights Global Health Crisis in Conflict Zones",
    summary:
      "An Israeli air strike in Gaza City has led to multiple severe injuries, further exacerbating the dire humanitarian and public health crisis in the besieged territory. This incident highlights the global imperative to protect civilians and ensure access to healthcare in conflict zones worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-05-gaza-strike-highlights-global-health-crisis-in-conflict-zones.jpg",
    date: "2026-04-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-push-needed-half-of-cataract-blindness-cases-lack-access-to-sight-restoring-surgery",
    title: "Global Push Needed: Half of Cataract Blindness Cases Lack Access to Sight-Restoring Surgery",
    summary:
      "Millions worldwide face preventable blindness due to cataracts, yet half lack access to simple, sight-restoring surgery. The World Health Organization is calling for urgent global action to strengthen health systems and expand access to this life-changing intervention.",
    thumbnailImage: "/images/global-news/2026/2026-04-05-global-push-needed-half-of-cataract-blindness-cases-lack-access-to-sight-restori.jpg",
    date: "2026-04-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hundreds-of-gps-tell-bbc-they-have-never-refused",
    title: "Global Health and Education Watch: Hundreds of GPs tell BBC they have never refused",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-05-global-health-and-education-watch-hundreds-of-gps-tell-bbc-they-have-never-refus.jpg",
    date: "2026-04-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-female-athletes-fertility-is-still-a-blind-spot",
    title: "Global Health and Education Watch: Female athletes’ fertility is still a blind spot |",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-05-global-health-and-education-watch-female-athletes-fertility-is-still-a-blind-spo.jpg",
    date: "2026-04-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-health-officials-appear-to-shy-away-from-anti-vaccine",
    title: "Global Health and Education Watch: US health officials appear to shy away from anti-vaccine",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-05-global-health-and-education-watch-us-health-officials-appear-to-shy-away-from-an.jpg",
    date: "2026-04-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "measles-surge-claims-lives-of-dozens-of-children-in-bangladesh",
    title: "Measles Surge Claims Lives of Dozens of Children in Bangladesh",
    summary:
      "A suspected measles outbreak in Bangladesh has tragically claimed the lives of nearly 100 children, with thousands more exhibiting symptoms. This severe health crisis underscores the critical need for robust immunization programs and resilient health infrastructure worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-05-measles-surge-claims-lives-of-dozens-of-children-in-bangladesh.jpg",
    date: "2026-04-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-i-always-considered-social-media-evil-big-tobacco-whistleblower",
    title: "Global Health and Education Watch: ‘I always considered social media evil’: big tobacco whistleblower",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-05-global-health-and-education-watch-i-always-considered-social-media-evil-big-toba.jpg",
    date: "2026-04-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-satellite-mirror-plans-could-disrupt-sleep-and-ecosystems-worldwide",
    title: "Global Health and Education Watch: Satellite mirror plans could disrupt sleep and ecosystems worldwide",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-05-global-health-and-education-watch-satellite-mirror-plans-could-disrupt-sleep-and.jpg",
    date: "2026-04-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-nhs-england-to-offer-weight-loss-drugs-to-1-2m-people",
    title: "Global Health and Education Watch: NHS England to offer weight-loss drugs to 1.2m people",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-05-global-health-and-education-watch-nhs-england-to-offer-weight-loss-drugs-to-1-2m.jpg",
    date: "2026-04-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-less-meat-more-plants-top-us-heart-body-s-diet",
    title: "Global Health and Education Watch: Less meat, more plants: top US heart body’s diet",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-05-global-health-and-education-watch-less-meat-more-plants-top-us-heart-body-s-diet.jpg",
    date: "2026-04-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-call-strengthening-child-safeguards-in-education-after-instructor-s-charges",
    title: "Global Call: Strengthening Child Safeguards in Education After Instructor's Charges",
    summary:
      "Allegations against a preschool instructor in the United States, accused of abusing multiple children over an extended period, have sparked urgent global discussions on child safety in educational environments. This case underscores the critical need for comprehensive international strategies to prevent such abuses and protect vulnerable learners worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-05-global-call-strengthening-child-safeguards-in-education-after-instructor-s-charg.jpg",
    date: "2026-04-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "telehealth-giant-hims-hers-partners-with-novo-nordisk-after-weight-loss-drug-dispute",
    title: "Telehealth Giant Hims & Hers Partners with Novo Nordisk After Weight-Loss Drug Dispute",
    summary:
      "US telehealth provider Hims & Hers has reached a significant agreement with Danish pharmaceutical giant Novo Nordisk regarding weight-loss medications. This deal marks a resolution to a prior dispute over compounded drug formulations, potentially expanding regulated access to effective obesity treatments worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-05-telehealth-giant-hims-hers-partners-with-novo-nordisk-after-weight-loss-drug-dis.jpg",
    date: "2026-04-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-digital-shift-re-evaluating-our-relationship-with-social-media",
    title: "Global Digital Shift: Re-evaluating Our Relationship with Social Media",
    summary:
      "A global re-evaluation of social media engagement is underway, with many users opting for passive consumption or disengagement amidst growing concerns about mental well-being and the permanence of digital footprints. This shift reflects a broader societal introspection on technology's role in daily life and its impact on personal health.",
    thumbnailImage: "/images/global-news/2026/2026-04-05-global-digital-shift-re-evaluating-our-relationship-with-social-media.jpg",
    date: "2026-04-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-denmark-becomes-first-country-in-the-european-union-to",
    title: "Global Health and Education Watch: Denmark becomes first country in the European Union to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-05-global-health-and-education-watch-denmark-becomes-first-country-in-the-european-.jpg",
    date: "2026-04-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "universal-child-care-global-equity-debate-ignites-policy-questions",
    title: "Universal Child Care: Global Equity Debate Ignites Policy Questions",
    summary:
      "A new publicly funded preschool in an affluent urban center has sparked a global debate on the equitable distribution of universal child care resources. This development highlights the complex challenge of balancing universal access with addressing the most pressing needs in diverse socio-economic contexts worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-05-universal-child-care-global-equity-debate-ignites-policy-questions.jpg",
    date: "2026-04-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-co-founders-behind-pioneering-covid-vaccine-to-step-down-from",
    title: "Global Health and Education Watch: Co-founders behind pioneering Covid vaccine to step down from",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-04-global-health-and-education-watch-co-founders-behind-pioneering-covid-vaccine-to.jpg",
    date: "2026-04-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-iran-says-us-israel-belong-in-stone-age-after",
    title: "Global Health and Education Watch: Iran says US, Israel belong in Stone Age after",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-04-global-health-and-education-watch-iran-says-us-israel-belong-in-stone-age-after.jpg",
    date: "2026-04-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "tehran-psychiatric-hospital-unusable-after-strike-deepening-humanitarian-crisis",
    title: "Tehran Psychiatric Hospital Unusable After Strike, Deepening Humanitarian Crisis",
    summary:
      "A major psychiatric hospital in Tehran has been incapacitated following a recent US-Israeli strike, according to its chief. This incident critically disrupts essential mental health services for a vulnerable population already facing immense challenges.",
    thumbnailImage: "/images/global-news/2026/2026-04-04-tehran-psychiatric-hospital-unusable-after-strike-deepening-humanitarian-crisis.jpg",
    date: "2026-04-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-meet-the-pupils-teaching-speeders-a-lesson-in-kids",
    title: "Global Health and Education Watch: Meet the pupils teaching speeders a lesson in Kids",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-04-global-health-and-education-watch-meet-the-pupils-teaching-speeders-a-lesson-in-.jpg",
    date: "2026-04-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-peptide-craze-hype-health-claims-and-regulatory-scrutiny",
    title: "Global Peptide Craze: Hype, Health Claims, and Regulatory Scrutiny",
    summary:
      "Peptides are gaining global traction for purported benefits like anti-aging and weight loss, driven by social media influence. Health authorities are now scrutinizing these claims and the safety of unregulated products, urging caution.",
    thumbnailImage: "/images/global-news/2026/2026-04-04-global-peptide-craze-hype-health-claims-and-regulatory-scrutiny.jpg",
    date: "2026-04-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-conflict-deepens-health-crisis-across-middle-east-who-says-2",
    title: "Global Health and Education Watch: Conflict deepens health crisis across Middle East, WHO says",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-04-global-health-and-education-watch-conflict-deepens-health-crisis-across-middle-e.jpg",
    date: "2026-04-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-under-protest-raw-dairy-farm-recalls-cheddar-linked-to",
    title: "Global Health and Education Watch: ‘Under Protest,’ Raw Dairy Farm Recalls Cheddar Linked to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-04-global-health-and-education-watch-under-protest-raw-dairy-farm-recalls-cheddar-l.jpg",
    date: "2026-04-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-medicines-watchdog-to-investigate-uk-peptide-clinics-over-health",
    title: "Global Health and Education Watch: Medicines watchdog to investigate UK peptide clinics over health",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-04-global-health-and-education-watch-medicines-watchdog-to-investigate-uk-peptide-c.jpg",
    date: "2026-04-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-feels-like-history-is-being-made-will-young-hungarian",
    title: "Global Health and Education Watch: ‘Feels like history is being made’: will young Hungarian",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-04-global-health-and-education-watch-feels-like-history-is-being-made-will-young-hu.jpg",
    date: "2026-04-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "israeli-strike-damages-tyre-hospital-injuring-11-global-health-concerns-mount",
    title: "Israeli Strike Damages Tyre Hospital, Injuring 11: Global Health Concerns Mount",
    summary:
      "An Israeli strike near the Lebanese Italian Hospital in Tyre injured at least 11 people and caused significant damage to the facility. The incident highlights mounting global concerns over the protection of healthcare in conflict zones.",
    thumbnailImage: "/images/global-news/2026/2026-04-04-israeli-strike-damages-tyre-hospital-injuring-11-global-health-concerns-mount.jpg",
    date: "2026-04-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "harvard-s-grade-cap-proposal-ignites-global-debate-on-academic-standards",
    title: "Harvard's Grade Cap Proposal Ignites Global Debate on Academic Standards",
    summary:
      "Harvard University's faculty is poised to vote on a contentious proposal aimed at curbing grade inflation by capping top marks. This move has ignited a broader international conversation about academic rigor and the future of higher education assessment.",
    thumbnailImage: "/images/global-news/2026/2026-04-04-harvard-s-grade-cap-proposal-ignites-global-debate-on-academic-standards.jpg",
    date: "2026-04-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-authorities-monitor-new-omicron-sub-variant-ba-3-2",
    title: "Global Health Authorities Monitor New Omicron Sub-variant BA.3.2",
    summary:
      "A new Omicron sub-variant, BA.3.2, featuring numerous spike mutations, has been detected, prompting global health experts to call for serious attention rather than widespread alarm. While its severity is not yet confirmed, its emergence underscores the critical importance of ongoing international genomic surveillance and public health preparedness.",
    thumbnailImage: "/images/global-news/2026/2026-04-04-global-health-authorities-monitor-new-omicron-sub-variant-ba-3-2.jpg",
    date: "2026-04-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-schools-face-masculinity-crisis-amid-rising-misogyny-concerns",
    title: "Global Schools Face 'Masculinity Crisis' Amid Rising Misogyny Concerns",
    summary:
      "A global teachers' union has issued a stark warning about a brewing 'masculinity crisis' in schools, driven by a rise in misogynistic attitudes among male students. This phenomenon poses significant challenges to educational systems and societal well-being, demanding urgent, comprehensive interventions.",
    thumbnailImage: "/images/global-news/2026/2026-04-04-global-schools-face-masculinity-crisis-amid-rising-misogyny-concerns.jpg",
    date: "2026-04-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "beyond-the-icu-the-lingering-global-health-crisis-of-post-intensive-care-syndrome",
    title: "Beyond the ICU: The Lingering Global Health Crisis of Post-Intensive Care Syndrome",
    summary:
      "Many patients worldwide face significant physical, cognitive, and mental health struggles long after leaving intensive care. This global phenomenon, known as Post-Intensive Care Syndrome, demands greater awareness and integrated support systems for survivors.",
    thumbnailImage: "/images/global-news/2026/2026-04-04-beyond-the-icu-the-lingering-global-health-crisis-of-post-intensive-care-syndrom.jpg",
    date: "2026-04-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-imperiled-by-media-s-governance-misreporting",
    title: "Global Health and Education Imperiled by Media's Governance Misreporting",
    summary:
      "A recent study in Wales reveals how media misrepresentation of devolved governance issues confuses the public, a problem mirrored globally. This widespread misinformation critically impedes informed decision-making regarding essential health and education services worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-04-global-health-and-education-imperiled-by-media-s-governance-misreporting.jpg",
    date: "2026-04-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-global-commitment-on-display-as-countries-negotiate-key-annex",
    title: "Global Health and Education Watch: Global commitment on display as countries negotiate key annex",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-04-global-health-and-education-watch-global-commitment-on-display-as-countries-nego.jpg",
    date: "2026-04-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-is-chickenpox-and-who-can-get-an-nhs-2",
    title: "Global Health and Education Watch: What is chickenpox and who can get an NHS",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-04-global-health-and-education-watch-what-is-chickenpox-and-who-can-get-an-nhs.jpg",
    date: "2026-04-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "who-alarms-over-escalating-attacks-on-iranian-healthcare-facilities",
    title: "WHO Alarms Over Escalating Attacks on Iranian Healthcare Facilities",
    summary:
      "The World Health Organization has raised serious alarms over more than 20 reported attacks on healthcare facilities in Iran since March 1. These incidents highlight a grave humanitarian crisis and underscore the urgent need for protection of medical services.",
    thumbnailImage: "/images/global-news/2026/2026-04-04-who-alarms-over-escalating-attacks-on-iranian-healthcare-facilities.jpg",
    date: "2026-04-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-masculinity-crisis-is-brewing-in-uk-schools-union",
    title: "Global Health and Education Watch: A ‘masculinity crisis’ is brewing in UK schools, union",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-03-global-health-and-education-watch-a-masculinity-crisis-is-brewing-in-uk-schools-.jpg",
    date: "2026-04-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-h-h-s-takes-a-first-step-toward-restoring-vaccine-advisory",
    title: "Global Health and Education Watch: H.H.S. Takes a First Step Toward Restoring Vaccine Advisory",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-03-global-health-and-education-watch-h-h-s-takes-a-first-step-toward-restoring-vacc.jpg",
    date: "2026-04-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "youth-health-crisis-insecure-jobs-drive-global-economic-inactivity",
    title: "Youth Health Crisis: Insecure Jobs Drive Global Economic Inactivity",
    summary:
      "New research highlights a concerning global trend where young individuals in low-paid, insecure jobs are increasingly forced to leave employment due to health issues. This phenomenon contributes significantly to economic inactivity, posing substantial challenges for both individual well-being and national economies worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-03-youth-health-crisis-insecure-jobs-drive-global-economic-inactivity.jpg",
    date: "2026-04-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-education-crisis-retaining-teachers-through-enhanced-parental-leave",
    title: "Global Education Crisis: Retaining Teachers Through Enhanced Parental Leave",
    summary:
      "A union in the UK is advocating for 26 weeks of fully paid maternity leave for teachers, citing an exodus of women from classrooms due to insufficient support. This issue reflects a broader global challenge where inadequate parental leave policies contribute to teacher attrition, impacting educational quality and gender equity.",
    thumbnailImage: "/images/global-news/2026/2026-04-03-global-education-crisis-retaining-teachers-through-enhanced-parental-leave.jpg",
    date: "2026-04-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "academic-freedom-under-scrutiny-us-university-fires-professor-over-iran-war-criticism",
    title: "Academic Freedom Under Scrutiny: US University Fires Professor Over Iran War Criticism",
    summary:
      "A University of Washington professor was removed from his leadership role after using institutional communications to critique US-Israeli actions regarding Iran. This incident is part of a growing trend where academics face severe professional repercussions for voicing contentious political opinions.",
    thumbnailImage: "/images/global-news/2026/2026-04-03-academic-freedom-under-scrutiny-us-university-fires-professor-over-iran-war-crit.jpg",
    date: "2026-04-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-youth-health-alert-the-troubling-rise-of-teenage-caffeine-pouches",
    title: "Global Youth Health Alert: The Troubling Rise of Teenage Caffeine Pouches",
    summary:
      "A global health concern is emerging as social media influencers promote caffeine pouches to adolescents, raising alarms among experts. These products pose significant health risks, including cardiovascular issues and addiction, for young users worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-03-global-youth-health-alert-the-troubling-rise-of-teenage-caffeine-pouches.jpg",
    date: "2026-04-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-the-us-and-israel-are-waging-war-on",
    title: "Global Health and Education Watch: How the US and Israel are waging war on",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-03-global-health-and-education-watch-how-the-us-and-israel-are-waging-war-on.jpg",
    date: "2026-04-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-paradox-of-progress-shapes-the-social-determinants-of",
    title: "Global Health and Education Watch: A “paradox of progress” shapes the social determinants of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-03-global-health-and-education-watch-a-paradox-of-progress-shapes-the-social-determ.jpg",
    date: "2026-04-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-texas-voucher-program-incites-fight-over-funding-islamic-schools",
    title: "Global Health and Education Watch: Texas Voucher Program Incites Fight Over Funding Islamic Schools",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-03-global-health-and-education-watch-texas-voucher-program-incites-fight-over-fundi.jpg",
    date: "2026-04-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-alarm-targeting-civilian-infrastructure-risks-catastrophic-humanitarian-crisis",
    title: "Global Alarm: Targeting Civilian Infrastructure Risks Catastrophic Humanitarian Crisis",
    summary:
      "International law experts are deeply concerned by threats to target civilian infrastructure, including schools and health centers. Such actions could constitute serious war crimes, devastating essential services and causing immense human suffering.",
    thumbnailImage: "/images/global-news/2026/2026-04-03-global-alarm-targeting-civilian-infrastructure-risks-catastrophic-humanitarian-c.jpg",
    date: "2026-04-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "sudan-s-health-crisis-doctors-watch-lives-slip-away-amidst-shortages",
    title: "Sudan's Health Crisis: Doctors Watch Lives Slip Away Amidst Shortages",
    summary:
      "Violence in Sudan's South Kordofan state has crippled healthcare, leaving doctors in maternity hospitals with critical shortages and overwhelming patient numbers. Medical professionals are forced to make agonizing decisions as lives are lost due to a lack of essential supplies.",
    thumbnailImage: "/images/global-news/2026/2026-04-03-sudan-s-health-crisis-doctors-watch-lives-slip-away-amidst-shortages.jpg",
    date: "2026-04-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-university-racing-fuels-future-engineering-talent",
    title: "Global University Racing Fuels Future Engineering Talent",
    summary:
      "University engineering competitions like Formula Student are vital for global education, transforming theoretical knowledge into practical innovation. These programs nurture future STEM talent, equipping students with essential skills for advanced industries worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-03-global-university-racing-fuels-future-engineering-talent.jpg",
    date: "2026-04-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-screen-time-guidance-does-not-go-far-enough",
    title: "Global Health and Education Watch: Screen time guidance does not go far enough |",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-03-global-health-and-education-watch-screen-time-guidance-does-not-go-far-enough.jpg",
    date: "2026-04-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-labour-is-letting-down-britain-s-children-says-national-education",
    title: "Global Health and Education Watch: Labour is letting down Britain’s children, says National Education",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-03-global-health-and-education-watch-labour-is-letting-down-britain-s-children-says.jpg",
    date: "2026-04-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-israel-is-destroying-healthcare-infrastructure-in-southern-lebanon",
    title: "Global Health and Education Watch: How Israel is destroying healthcare infrastructure in southern Lebanon",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-03-global-health-and-education-watch-how-israel-is-destroying-healthcare-infrastruc.jpg",
    date: "2026-04-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-students-are-disciplined-over-antisemitic-posts-targeting-hockey-rivals",
    title: "Global Health and Education Watch: Students Are Disciplined Over Antisemitic Posts Targeting Hockey Rivals",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-03-global-health-and-education-watch-students-are-disciplined-over-antisemitic-post.jpg",
    date: "2026-04-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-nhs-rehabilitation-care-staff-shortage-fails-stroke-patients-say",
    title: "Global Health and Education Watch: NHS rehabilitation care staff shortage fails stroke patients, say",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-03-global-health-and-education-watch-nhs-rehabilitation-care-staff-shortage-fails-s.jpg",
    date: "2026-04-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "escalating-iran-conflict-devastates-health-infrastructure-threatening-global-well-being",
    title: "Escalating Iran Conflict Devastates Health Infrastructure, Threatening Global Well-being",
    summary:
      "Recent military actions in Iran have resulted in widespread infrastructure damage, critically impacting the nation's public health capabilities. The destruction of a leading health institution raises alarms about a looming humanitarian crisis and severe global health implications.",
    thumbnailImage: "/images/global-news/2026/2026-04-03-escalating-iran-conflict-devastates-health-infrastructure-threatening-global-wel.jpg",
    date: "2026-04-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "tehran-hospital-a-beacon-of-hope-amidst-conflict-for-children",
    title: "Tehran Hospital: A Beacon of Hope Amidst Conflict for Children",
    summary:
      "In Tehran, the Children's Medical Center provides vital medical care alongside psychosocial support, organizing engaging activities to bring smiles and normalcy to young patients amidst ongoing conflict. This holistic approach helps children cope with illness and the stresses of war, fostering resilience and hope within the hospital walls.",
    thumbnailImage: "/images/global-news/2026/2026-04-02-tehran-hospital-a-beacon-of-hope-amidst-conflict-for-children.jpg",
    date: "2026-04-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-imperative-safeguarding-drinking-water-from-microplastics-and-pharmaceuticals",
    title: "Global Imperative: Safeguarding Drinking Water from Microplastics and Pharmaceuticals",
    summary:
      "Nations globally are intensifying efforts to combat the widespread presence of microplastics and pharmaceutical residues in drinking water supplies. This critical initiative underscores the urgent need for international collaboration and advanced treatment solutions to protect public health.",
    thumbnailImage: "/images/global-news/2026/2026-04-02-global-imperative-safeguarding-drinking-water-from-microplastics-and-pharmaceuti.jpg",
    date: "2026-04-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-threatens-100-tariff-on-us-drug-makers-that",
    title: "Global Health and Education Watch: Trump threatens 100% tariff on US drug makers that",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-02-global-health-and-education-watch-trump-threatens-100-tariff-on-us-drug-makers-t.jpg",
    date: "2026-04-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "teacher-misconduct-allegations-spark-global-special-needs-safeguarding-debate",
    title: "Teacher Misconduct Allegations Spark Global Special Needs Safeguarding Debate",
    summary:
      "Allegations against a special needs teacher in Boston have ignited a global discussion on student safeguarding. The incident underscores the critical importance of robust protective protocols and ethical conduct in educational settings for vulnerable children.",
    thumbnailImage: "/images/global-news/2026/2026-04-02-teacher-misconduct-allegations-spark-global-special-needs-safeguarding-debate.jpg",
    date: "2026-04-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "who-launches-urgent-global-appeal-for-health-in-crisis-zones",
    title: "WHO Launches Urgent Global Appeal for Health in Crisis Zones",
    summary:
      "The World Health Organization has initiated its 2026 global appeal to secure vital funding for health services in humanitarian crises. This urgent call aims to reach millions of vulnerable individuals suffering from conflicts and disasters worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-02-who-launches-urgent-global-appeal-for-health-in-crisis-zones.jpg",
    date: "2026-04-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-alert-cdc-staffing-crisis-halts-critical-disease-testing",
    title: "Global Health Alert: CDC Staffing Crisis Halts Critical Disease Testing",
    summary:
      "The US Centers for Disease Control and Prevention has temporarily suspended diagnostic testing for numerous infectious diseases due to severe staffing shortages. This development highlights critical weaknesses in public health infrastructure with potential global implications for disease surveillance and response.",
    thumbnailImage: "/images/global-news/2026/2026-04-02-global-health-alert-cdc-staffing-crisis-halts-critical-disease-testing.jpg",
    date: "2026-04-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-pupils-in-england-are-losing-their-thinking-skills-because",
    title: "Global Health and Education Watch: Pupils in England are losing their thinking skills because",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-02-global-health-and-education-watch-pupils-in-england-are-losing-their-thinking-sk.jpg",
    date: "2026-04-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "tragedy-strikes-ugandan-nursery-four-children-killed-in-stabbing-attack",
    title: "Tragedy Strikes Ugandan Nursery: Four Children Killed in Stabbing Attack",
    summary:
      "Four young children were tragically killed in a stabbing attack at a nursery school in Uganda's capital, Kampala. Police have a suspect in custody, but the motive behind the horrific incident remains unknown, plunging the community into grief.",
    thumbnailImage: "/images/global-news/2026/2026-04-02-tragedy-strikes-ugandan-nursery-four-children-killed-in-stabbing-attack.jpg",
    date: "2026-04-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-medical-education-shifts-nutrition-now-central-to-training",
    title: "Global Medical Education Shifts: Nutrition Now Central to Training",
    summary:
      "A key medical accreditation agency has revised its standards, making nutrition a required component of medical school curricula following advocacy for educational reform. This move reflects a growing global recognition of nutrition's critical role in preventative health and comprehensive patient care.",
    thumbnailImage: "/images/global-news/2026/2026-04-02-global-medical-education-shifts-nutrition-now-central-to-training.jpg",
    date: "2026-04-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-call-teacher-safety-crisis-revealed-by-15m-uk-payouts",
    title: "Global Call: Teacher Safety Crisis Revealed by £15M UK Payouts",
    summary:
      "A UK teachers' union revealed £15 million in compensation for staff injuries, including rat-related illness and pupil assaults. These incidents underscore the urgent global need for improved health and safety standards in educational settings.",
    thumbnailImage: "/images/global-news/2026/2026-04-02-global-call-teacher-safety-crisis-revealed-by-15m-uk-payouts.jpg",
    date: "2026-04-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-quality-health-information-for-all-is-a-fundamental-determinant",
    title: "Global Health and Education Watch: Quality health information for all is a fundamental determinant",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-02-global-health-and-education-watch-quality-health-information-for-all-is-a-fundam.jpg",
    date: "2026-04-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-teachers-unite-to-combat-rising-educational-censorship",
    title: "Global Teachers Unite to Combat Rising Educational Censorship",
    summary:
      "Education professionals globally are voicing strong opposition to increasing censorship in schools, with unions reporting widespread efforts to limit access to diverse books. This movement highlights concerns about academic freedom and the vital role of libraries in fostering critical thinking and inclusive learning environments.",
    thumbnailImage: "/images/global-news/2026/2026-04-02-global-teachers-unite-to-combat-rising-educational-censorship.jpg",
    date: "2026-04-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-countries-progress-negotiations-in-support-of-who-pandemic-agreement-2",
    title: "Global Health and Education Watch: Countries progress negotiations in support of WHO Pandemic Agreement",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-02-global-health-and-education-watch-countries-progress-negotiations-in-support-of-.jpg",
    date: "2026-04-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "tiger-woods-prioritizes-health-declining-ryder-cup-captaincy",
    title: "Tiger Woods Prioritizes Health, Declining Ryder Cup Captaincy",
    summary:
      "Golf legend Tiger Woods has declined the 2027 Ryder Cup captaincy, choosing to focus on his long-term health recovery following a severe car crash and recent legal issues. This decision underscores the critical importance of prioritizing personal well-being, even for global sports figures.",
    thumbnailImage: "/images/global-news/2026/2026-04-02-tiger-woods-prioritizes-health-declining-ryder-cup-captaincy.jpg",
    date: "2026-04-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-education-faces-legal-onslaught-as-political-agendas-drive-lawsuits",
    title: "Global Education Faces Legal Onslaught as Political Agendas Drive Lawsuits",
    summary:
      "Educational institutions globally are grappling with an unprecedented wave of lawsuits, as political figures and advocacy groups leverage legal systems to drive sweeping reforms. This strategic shift from legislative action to litigation is creating significant challenges for universities and school districts worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-02-global-education-faces-legal-onslaught-as-political-agendas-drive-lawsuits.jpg",
    date: "2026-04-02",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-syracuse-drops-84-programs-including-classics-ceramics-and-italian",
    title: "Global Health and Education Watch: Syracuse Drops 84 Programs Including Classics, Ceramics and Italian",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-01-global-health-and-education-watch-syracuse-drops-84-programs-including-classics-.jpg",
    date: "2026-04-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-manosphere-is-dead-and-no-one-cares-about",
    title: "Global Health and Education Watch: ‘The manosphere is dead and no one cares about",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-01-global-health-and-education-watch-the-manosphere-is-dead-and-no-one-cares-about.jpg",
    date: "2026-04-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-c-d-c-pauses-testing-for-rabies-and-pox-viruses",
    title: "Global Health and Education Watch: C.D.C. Pauses Testing for Rabies and Pox Viruses",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-01-global-health-and-education-watch-c-d-c-pauses-testing-for-rabies-and-pox-viruse.jpg",
    date: "2026-04-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-child-vision-crisis-deprivation-linked-to-poorer-screening-outcomes",
    title: "Global Child Vision Crisis: Deprivation Linked to Poorer Screening Outcomes",
    summary:
      "A groundbreaking study reveals a strong association between socioeconomic deprivation and social vulnerability with adverse pediatric vision screening outcomes. These findings underscore the urgent need for integrated global health strategies to ensure equitable access to crucial eye care for all children.",
    thumbnailImage: "/images/global-news/2026/2026-04-01-global-child-vision-crisis-deprivation-linked-to-poorer-screening-outcomes.jpg",
    date: "2026-04-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "fathers-forge-bonds-master-skills-in-global-parenting-evolution",
    title: "Fathers Forge Bonds, Master Skills in Global Parenting Evolution",
    summary:
      "Across the globe, fathers are discovering community and practical parenting skills through innovative social clubs. These initiatives foster stronger family bonds and support men's mental health by providing a safe, educational environment.",
    thumbnailImage: "/images/global-news/2026/2026-04-01-fathers-forge-bonds-master-skills-in-global-parenting-evolution.jpg",
    date: "2026-04-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "gaza-receives-lifesaving-aid-via-new-sea-route-amid-deepening-humanitarian-crisis",
    title: "Gaza Receives Lifesaving Aid Via New Sea Route Amid Deepening Humanitarian Crisis",
    summary:
      "The World Health Organization has successfully delivered 106 metric tonnes of vital nutrition supplies to Gaza, marking the inaugural shipment via a newly established sea corridor. This crucial aid arrives amidst severe humanitarian challenges, offering a glimmer of hope for vulnerable populations.",
    thumbnailImage: "/images/global-news/2026/2026-04-01-gaza-receives-lifesaving-aid-via-new-sea-route-amid-deepening-humanitarian-crisi.jpg",
    date: "2026-04-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-unregulated-chatbots-are-putting-lives-at-risk-letters",
    title: "Global Health and Education Watch: Unregulated chatbots are putting lives at risk | Letters",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-04-01-global-health-and-education-watch-unregulated-chatbots-are-putting-lives-at-risk.jpg",
    date: "2026-04-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-cancer-prevention-four-in-ten-cases-preventable",
    title: "Global Cancer Prevention: Four in Ten Cases Preventable",
    summary:
      "A landmark global analysis by WHO and IARC indicates that up to four in ten cancer cases worldwide are preventable. The study highlights 30 modifiable risk factors, including lifestyle choices, environmental exposures, and, for the first time, nine cancer-causing infections.",
    thumbnailImage: "/images/global-news/2026/2026-04-01-global-cancer-prevention-four-in-ten-cases-preventable.jpg",
    date: "2026-04-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "us-health-deals-african-nations-question-aid-for-minerals-and-data-demands",
    title: "US Health Deals: African Nations Question Aid for Minerals and Data Demands",
    summary:
      "African nations, including Zimbabwe and Zambia, are voicing strong opposition to new US health aid agreements. These deals are perceived as 'lopsided' due to controversial demands for critical minerals and sensitive health data.",
    thumbnailImage: "/images/global-news/2026/2026-04-01-us-health-deals-african-nations-question-aid-for-minerals-and-data-demands.jpg",
    date: "2026-04-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "fda-poised-to-restore-access-to-peptides-amid-global-health-and-longevity-debate",
    title: "FDA Poised to Restore Access to Peptides Amid Global Health and Longevity Debate",
    summary:
      "The U.S. Food and Drug Administration is anticipated to reverse its 2023 decision, allowing compounding pharmacies to once again sell certain peptides. This move follows advocacy efforts and reflects growing global interest in these compounds for health and longevity benefits.",
    thumbnailImage: "/images/global-news/2026/2026-04-01-fda-poised-to-restore-access-to-peptides-amid-global-health-and-longevity-debate.jpg",
    date: "2026-04-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "stephen-lewis-tireless-global-health-advocate-dies-at-88",
    title: "Stephen Lewis, Tireless Global Health Advocate, Dies at 88",
    summary:
      "Stephen Lewis, a prominent Canadian diplomat and human rights advocate, has passed away at 88 after a battle with cancer. He was widely recognized for his unwavering commitment to raising global awareness and action against the HIV/AIDS crisis.",
    thumbnailImage: "/images/global-news/2026/2026-04-01-stephen-lewis-tireless-global-health-advocate-dies-at-88.jpg",
    date: "2026-04-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-shift-anti-obesity-jabs-target-heart-disease-risk",
    title: "Global Health Shift: Anti-Obesity Jabs Target Heart Disease Risk",
    summary:
      "A significant development in public health sees anti-obesity medications being deployed to reduce the risk of heart attacks and strokes globally. This initiative marks a crucial step in addressing the escalating burden of cardiovascular diseases worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-01-global-health-shift-anti-obesity-jabs-target-heart-disease-risk.jpg",
    date: "2026-04-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-face-strain-amidst-escalating-geopolitical-tensions",
    title: "Global Health and Education Face Strain Amidst Escalating Geopolitical Tensions",
    summary:
      "The Iran conflict, while financially benefiting Russia, is triggering severe global health and education crises. Supply chain disruptions threaten medicine availability, and resource reallocation jeopardizes educational progress worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-04-01-global-health-and-education-face-strain-amidst-escalating-geopolitical-tensions.jpg",
    date: "2026-04-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-extremism-s-evolving-threat-a-call-for-health-and-education-reset",
    title: "Global Extremism's Evolving Threat: A Call for Health and Education Reset",
    summary:
      "Global counter-extremism efforts are struggling against evolving online threats, fluid ideologies, and the exploitation of vulnerable populations. A comprehensive global reset is needed, prioritizing mental health support and educational initiatives to build resilience and counter radicalization.",
    thumbnailImage: "/images/global-news/2026/2026-04-01-global-extremism-s-evolving-threat-a-call-for-health-and-education-reset.jpg",
    date: "2026-04-01",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-calls-for-stricter-oversight-of-private-medicinal-cannabis-clinics",
    title: "Global Calls for Stricter Oversight of Private Medicinal Cannabis Clinics",
    summary:
      "A recent UK inquest linked a patient's death to his medicinal cannabis prescription, highlighting critical gaps in regulation. This ruling intensifies global discussions on the need for tighter controls over private cannabis clinics and patient care.",
    thumbnailImage: "/images/global-news/2026/2026-03-31-global-calls-for-stricter-oversight-of-private-medicinal-cannabis-clinics.jpg",
    date: "2026-03-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-alarm-teachers-witness-soaring-eating-disorders-anxiety-among-students",
    title: "Global Alarm: Teachers Witness Soaring Eating Disorders, Anxiety Among Students",
    summary:
      "A recent survey of English teachers reveals an alarming surge in student eating disorders and widespread exam anxiety. These findings reflect a critical, escalating global mental health crisis among children and adolescents in educational settings.",
    thumbnailImage: "/images/global-news/2026/2026-03-31-global-alarm-teachers-witness-soaring-eating-disorders-anxiety-among-students.jpg",
    date: "2026-03-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "court-approves-university-data-collection-on-jewish-affiliates-sparks-global-privacy-alarm",
    title: "Court Approves University Data Collection on Jewish Affiliates, Sparks Global Privacy Alarm",
    summary:
      "A recent judicial ruling allows the U.S. government to collect names and contact information of Jewish individuals at a prominent university for an antisemitism investigation. This development has triggered significant apprehension among civil liberties advocates and the global community regarding data privacy and potential misuse of sensitive demographic information.",
    thumbnailImage: "/images/global-news/2026/2026-03-31-court-approves-university-data-collection-on-jewish-affiliates-sparks-global-pri.jpg",
    date: "2026-03-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "british-billionaire-s-190m-cambridge-gift-boosts-global-education",
    title: "British Billionaire's £190M Cambridge Gift Boosts Global Education",
    summary:
      "Hedge fund founder Chris Rokos has pledged £190 million to the University of Cambridge, driven by a desire to contribute to the UK. This significant philanthropic act will bolster global education and research capabilities at the prestigious institution.",
    thumbnailImage: "/images/global-news/2026/2026-03-31-british-billionaire-s-190m-cambridge-gift-boosts-global-education.jpg",
    date: "2026-03-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "tyre-hospital-repeatedly-struck-amid-escalating-southern-lebanon-conflict",
    title: "Tyre Hospital Repeatedly Struck Amid Escalating Southern Lebanon Conflict",
    summary:
      "A key hospital in Tyre, southern Lebanon, has been subjected to Israeli attacks for a fifth time since the conflict began, critically undermining its capacity to provide essential medical services. These repeated strikes highlight the devastating impact of escalating regional conflict on civilian health infrastructure and the urgent need for protection.",
    thumbnailImage: "/images/global-news/2026/2026-03-31-tyre-hospital-repeatedly-struck-amid-escalating-southern-lebanon-conflict.jpg",
    date: "2026-03-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "jordan-who-partnership-advances-global-health-resilience-and-mental-well-being",
    title: "Jordan-WHO Partnership Advances Global Health, Resilience, and Mental Well-being",
    summary:
      "Dr. Tedros Adhanom Ghebreyesus recently concluded a significant visit to Jordan, highlighting the nation's strong partnership with the World Health Organization. This collaboration is crucial for advancing universal health coverage, enhancing mental health services, and bolstering humanitarian health responses globally.",
    thumbnailImage: "/images/global-news/2026/2026-03-31-jordan-who-partnership-advances-global-health-resilience-and-mental-well-being.jpg",
    date: "2026-03-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "uk-deradicalisation-scheme-strains-under-mental-health-service-demand",
    title: "UK Deradicalisation Scheme Strains Under Mental Health Service Demand",
    summary:
      "A UK deradicalisation initiative faces pressure as individuals reportedly use it to bypass long waits for mental health services. This trend highlights critical deficiencies in public health infrastructure, prompting global discussions on integrated care and resource allocation.",
    thumbnailImage: "/images/global-news/2026/2026-03-31-uk-deradicalisation-scheme-strains-under-mental-health-service-demand.jpg",
    date: "2026-03-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-wealth-taxation-a-path-to-funding-essential-public-services",
    title: "Global Wealth Taxation: A Path to Funding Essential Public Services",
    summary:
      "Across the globe, governments face immense pressure to fund vital public services like education and healthcare amidst growing wealth disparities. This article explores how progressive taxation, particularly targeting the ultra-wealthy, is gaining traction as a potential solution to bridge these critical funding gaps and foster more equitable societies.",
    thumbnailImage: "/images/global-news/2026/2026-03-31-global-wealth-taxation-a-path-to-funding-essential-public-services.jpg",
    date: "2026-03-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "gaza-families-reunited-years-after-infants-evacuated-amidst-conflict",
    title: "Gaza Families Reunited: Years After Infants Evacuated Amidst Conflict",
    summary:
      "Infants evacuated from Gaza's al-Shifa Hospital during the 2023 conflict have finally reunited with their families after years of separation. This poignant return highlights the enduring human cost of conflict and the critical importance of humanitarian efforts.",
    thumbnailImage: "/images/global-news/2026/2026-03-31-gaza-families-reunited-years-after-infants-evacuated-amidst-conflict.jpg",
    date: "2026-03-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "bard-college-s-82-million-real-estate-acquisition-sparks-global-education-debate",
    title: "Bard College's $82 Million Real Estate Acquisition Sparks Global Education Debate",
    summary:
      "Bard College recently received an $82 million donation of properties in Hudson, N.Y., from a nonprofit foundation, drawing attention to universities' expanding real estate footprints. The lack of detailed plans from the institution raises questions about transparency and community impact, reflecting broader global discussions.",
    thumbnailImage: "/images/global-news/2026/2026-03-31-bard-college-s-82-million-real-estate-acquisition-sparks-global-education-debate.jpg",
    date: "2026-03-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "wearable-health-tech-soars-whoop-valuation-signals-industry-boom",
    title: "Wearable Health Tech Soars: Whoop Valuation Signals Industry Boom",
    summary:
      "Wearable health technology firm Whoop has reached a $10 billion valuation after securing $575 million in new funding, signaling a major acceleration in the global health tracking market. The company, backed by sovereign wealth funds and elite athletes, is now reportedly eyeing an initial public offering amidst surging demand for personalized wellness solutions.",
    thumbnailImage: "/images/global-news/2026/2026-03-31-wearable-health-tech-soars-whoop-valuation-signals-industry-boom.jpg",
    date: "2026-03-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-something-wasn-t-right-wrong-sperm-given-to-uk-families",
    title: "Global Health and Education Watch: 'Something wasn't right': Wrong sperm given to UK families",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-31-global-health-and-education-watch-something-wasn-t-right-wrong-sperm-given-to-uk.jpg",
    date: "2026-03-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "bolivian-clowns-protest-education-decree-threatening-livelihoods",
    title: "Bolivian Clowns Protest Education Decree Threatening Livelihoods",
    summary:
      "Clowns in Bolivia are protesting a new education decree that limits school extracurricular activities, directly impacting their income. The mandate, aimed at ensuring 200 days of lessons, inadvertently jeopardizes the livelihoods of many informal workers.",
    thumbnailImage: "/images/global-news/2026/2026-03-31-bolivian-clowns-protest-education-decree-threatening-livelihoods.jpg",
    date: "2026-03-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "libya-eradicates-trachoma-a-global-health-victory",
    title: "Libya Eradicates Trachoma: A Global Health Victory",
    summary:
      "Libya has achieved a significant public health milestone, eliminating trachoma as a public health problem. This victory, validated by the WHO, prevents future generations from preventable blindness and underscores the global commitment to eradicating neglected tropical diseases.",
    thumbnailImage: "/images/global-news/2026/2026-03-31-libya-eradicates-trachoma-a-global-health-victory.jpg",
    date: "2026-03-31",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "canada-s-ndp-elects-avi-lewis-sparking-global-education-equity-debate",
    title: "Canada's NDP Elects Avi Lewis, Sparking Global Education Equity Debate",
    summary:
      "Avi Lewis has been elected leader of Canada's New Democratic Party, promising a platform centered on equity, including tuition-free education and higher wealth taxes. This political shift in a G7 nation reignites global conversations on accessible education and progressive economic policies.",
    thumbnailImage: "/images/global-news/2026/2026-03-30-canada-s-ndp-elects-avi-lewis-sparking-global-education-equity-debate.jpg",
    date: "2026-03-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-n-y-u-closes-its-abu-dhabi-campus-as-iran-vows",
    title: "Global Health and Education Watch: N.Y.U. Closes Its Abu Dhabi Campus as Iran Vows",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-30-global-health-and-education-watch-n-y-u-closes-its-abu-dhabi-campus-as-iran-vows.jpg",
    date: "2026-03-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-world-news-in-brief-ukraine-drone-attacks-afghan-rights",
    title: "Global Health and Education Watch: World News in Brief: Ukraine drone attacks, Afghan rights",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-30-global-health-and-education-watch-world-news-in-brief-ukraine-drone-attacks-afgh.jpg",
    date: "2026-03-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-education-crisis-students-strike-over-teacher-shortages",
    title: "Global Education Crisis: Students Strike Over Teacher Shortages",
    summary:
      "Students in one region have initiated protests, demanding action against critical teacher shortages disrupting their education. This localized event underscores a pervasive global crisis threatening academic futures and educational equity worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-30-global-education-crisis-students-strike-over-teacher-shortages.jpg",
    date: "2026-03-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-positive-thinking-helps-you-age-better-that-s-the-worst",
    title: "Global Health and Education Watch: Positive thinking helps you age better? That’s the worst",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-30-global-health-and-education-watch-positive-thinking-helps-you-age-better-that-s-.jpg",
    date: "2026-03-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-kent-s-meningitis-outbreak-taught-me-that-post-covid-britain-is",
    title: "Global Health and Education Watch: Kent’s meningitis outbreak taught me that post-Covid Britain is",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-30-global-health-and-education-watch-kent-s-meningitis-outbreak-taught-me-that-post.jpg",
    date: "2026-03-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-we-dug-up-medics-in-gaza-a-year-later",
    title: "Global Health and Education Watch: We dug up medics in Gaza. A year later",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-30-global-health-and-education-watch-we-dug-up-medics-in-gaza-a-year-later.jpg",
    date: "2026-03-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "u-s-infant-mortality-trends-offer-global-insights-into-perinatal-health",
    title: "U.S. Infant Mortality Trends Offer Global Insights into Perinatal Health",
    summary:
      "A recent study analyzing U.S. infant mortality trends from 2015 to 2023 reveals critical insights into the impact of gestational age on survival rates. This data offers valuable lessons for global health initiatives aimed at reducing infant mortality and enhancing perinatal care worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-30-u-s-infant-mortality-trends-offer-global-insights-into-perinatal-health.jpg",
    date: "2026-03-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-universities-face-crisis-job-cuts-threaten-education-quality-amid-strike-warnings",
    title: "Global Universities Face Crisis: Job Cuts Threaten Education Quality Amid Strike Warnings",
    summary:
      "Universities globally are confronting significant financial challenges, leading to widespread job cuts that threaten the quality of education and student engagement. This precarious situation is prompting strong reactions from academic unions, with strike ballots underway in several regions to protest the proposed redundancies.",
    thumbnailImage: "/images/global-news/2026/2026-03-30-global-universities-face-crisis-job-cuts-threaten-education-quality-amid-strike-.jpg",
    date: "2026-03-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "conflict-s-toll-schools-and-water-systems-devastated-in-middle-east-war",
    title: "Conflict's Toll: Schools and Water Systems Devastated in Middle East War",
    summary:
      "Recent reports indicate a disturbing trend of civilian infrastructure, including schools and water facilities, being targeted in the ongoing Middle East conflict. This destruction severely undermines public health and educational access, exacerbating humanitarian crises across affected regions.",
    thumbnailImage: "/images/global-news/2026/2026-03-30-conflict-s-toll-schools-and-water-systems-devastated-in-middle-east-war.jpg",
    date: "2026-03-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-a-civics-school-with-a-conservative-bent-divided",
    title: "Global Health and Education Watch: How a Civics School With a Conservative Bent Divided",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-30-global-health-and-education-watch-how-a-civics-school-with-a-conservative-bent-d.jpg",
    date: "2026-03-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-six-years-after-covid-19-s-global-alarm-is-the-world-2",
    title: "Global Health and Education Watch: Six years after COVID-19’s global alarm: Is the world",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-30-global-health-and-education-watch-six-years-after-covid-19-s-global-alarm-is-the.jpg",
    date: "2026-03-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-vaping-dilemma-health-environment-and-policy-efficacy-post-ban",
    title: "Global Vaping Dilemma: Health, Environment, and Policy Efficacy Post-Ban",
    summary:
      "Nearly a year after some regions moved to outlaw disposable vaping devices, new data suggests policy gains are modest, while creating unforeseen challenges. The global rise of vaping presents a complex public health and environmental conundrum, balancing harm reduction with new risks.",
    thumbnailImage: "/images/global-news/2026/2026-03-30-global-vaping-dilemma-health-environment-and-policy-efficacy-post-ban.jpg",
    date: "2026-03-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-new-u-s-missile-hit-iranian-sports-hall-and-school",
    title: "Global Health and Education Watch: New U.S. Missile Hit Iranian Sports Hall and School",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-30-global-health-and-education-watch-new-u-s-missile-hit-iranian-sports-hall-and-sc.jpg",
    date: "2026-03-30",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-boston-university-pulls-pride-flags-raising-free-speech-worries",
    title: "Global Health and Education Watch: Boston University Pulls Pride Flags, Raising Free Speech Worries",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-29-global-health-and-education-watch-boston-university-pulls-pride-flags-raising-fr.jpg",
    date: "2026-03-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-social-justice-issue-london-school-believes-it-has",
    title: "Global Health and Education Watch: ‘A social justice issue’: London school believes it has",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-29-global-health-and-education-watch-a-social-justice-issue-london-school-believes-.jpg",
    date: "2026-03-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-systems-grapple-with-reform-amidst-performance-gaps",
    title: "Global Health Systems Grapple with Reform Amidst Performance Gaps",
    summary:
      "Across the globe, national health systems face immense pressure to reform and improve services, often struggling with ambitious targets. The recent restructuring of a major European health service exemplifies the complex interplay between political optimism and the realities of healthcare delivery.",
    thumbnailImage: "/images/global-news/2026/2026-03-29-global-health-systems-grapple-with-reform-amidst-performance-gaps.jpg",
    date: "2026-03-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-women-s-health-must-be-taken-more-seriously",
    title: "Global Health and Education Watch: 'Women's health must be taken more seriously'",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-29-global-health-and-education-watch-women-s-health-must-be-taken-more-seriously.jpg",
    date: "2026-03-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-recommendations-for-influenza-vaccine-composition-for-the-2026-2027-northern-2",
    title: "Global Health and Education Watch: Recommendations for influenza vaccine composition for the 2026-2027 northern",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-29-global-health-and-education-watch-recommendations-for-influenza-vaccine-composit.jpg",
    date: "2026-03-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-diabetes-overlooked-and-unchecked-poses-new-risks-in-africa",
    title: "Global Health and Education Watch: Diabetes, Overlooked and Unchecked, Poses New Risks in Africa",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-29-global-health-and-education-watch-diabetes-overlooked-and-unchecked-poses-new-ri.jpg",
    date: "2026-03-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-nhs-to-miss-targets-for-cutting-a-e-wait-times",
    title: "Global Health and Education Watch: NHS to miss targets for cutting A&E wait times",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-29-global-health-and-education-watch-nhs-to-miss-targets-for-cutting-a-e-wait-times.jpg",
    date: "2026-03-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-guardian-view-on-peptides-robert-f-kennedy-jr",
    title: "Global Health and Education Watch: The Guardian view on peptides: Robert F Kennedy Jr",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-29-global-health-and-education-watch-the-guardian-view-on-peptides-robert-f-kennedy.jpg",
    date: "2026-03-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "desert-oasis-challenges-traditional-education-a-global-model",
    title: "Desert Oasis Challenges Traditional Education: A Global Model?",
    summary:
      "Far from urban centers, an experimental educational community in the California desert is redefining learning. Operating without traditional structures like tuition or grades, it draws individuals seeking unconventional academic and personal growth.",
    thumbnailImage: "/images/global-news/2026/2026-03-29-desert-oasis-challenges-traditional-education-a-global-model.jpg",
    date: "2026-03-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-abortion-rate-holds-steady-largely-due-to-travel",
    title: "Global Health and Education Watch: US abortion rate holds steady largely due to travel",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-29-global-health-and-education-watch-us-abortion-rate-holds-steady-largely-due-to-t.jpg",
    date: "2026-03-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "full-clitoral-nerve-network-mapped-revolutionizing-women-s-pelvic-surgery",
    title: "Full Clitoral Nerve Network Mapped, Revolutionizing Women's Pelvic Surgery",
    summary:
      "A groundbreaking study has for the first time fully mapped the intricate network of clitoral nerves, a discovery poised to revolutionize women's pelvic surgery. This anatomical breakthrough aims to prevent post-operative sexual dysfunction and correct long-held medical misconceptions, enhancing global women's health.",
    thumbnailImage: "/images/global-news/2026/2026-03-29-full-clitoral-nerve-network-mapped-revolutionizing-women-s-pelvic-surgery.jpg",
    date: "2026-03-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-call-to-action-confronting-stigma-and-mental-health-crisis-in-neglected-tropical-diseases",
    title: "Global Call to Action: Confronting Stigma and Mental Health Crisis in Neglected Tropical Diseases",
    summary:
      "On World NTD Day, the WHO highlighted the unseen suffering of millions with neglected tropical diseases due to discrimination and untreated mental health issues. A global call urges governments and partners to integrate mental health support into NTD elimination efforts, ensuring no one is left in isolation.",
    thumbnailImage: "/images/global-news/2026/2026-03-29-global-call-to-action-confronting-stigma-and-mental-health-crisis-in-neglected-t.jpg",
    date: "2026-03-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "airstrikes-batter-tehran-university-sparking-global-education-crisis-concerns",
    title: "Airstrikes Batter Tehran University, Sparking Global Education Crisis Concerns",
    summary:
      "Recent airstrikes in Tehran have severely impacted a major university and surrounding residential areas, disrupting education and endangering civilian lives. The attacks underscore the profound and lasting humanitarian consequences of escalating regional conflict on vital societal institutions.",
    thumbnailImage: "/images/global-news/2026/2026-03-29-airstrikes-batter-tehran-university-sparking-global-education-crisis-concerns.jpg",
    date: "2026-03-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-fire-that-s-burning-again-welsh-language-resurges-thanks",
    title: "Global Health and Education Watch: ‘A fire that’s burning again’: Welsh language resurges thanks",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-29-global-health-and-education-watch-a-fire-that-s-burning-again-welsh-language-res.jpg",
    date: "2026-03-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-education-faces-staffing-crisis-for-inclusive-classrooms",
    title: "Global Education Faces Staffing Crisis for Inclusive Classrooms",
    summary:
      "A global education crisis looms as insufficient staffing and funding hinder the implementation of inclusive classrooms. Educational bodies emphasize the urgent need for increased investment to support diverse learning needs effectively.",
    thumbnailImage: "/images/global-news/2026/2026-03-29-global-education-faces-staffing-crisis-for-inclusive-classrooms.jpg",
    date: "2026-03-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-iran-war-live-updates-tehran-hit-by-heavy-airstrikes",
    title: "Global Health and Education Watch: Iran War Live Updates: Tehran Hit by Heavy Airstrikes",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-29-global-health-and-education-watch-iran-war-live-updates-tehran-hit-by-heavy-airs.jpg",
    date: "2026-03-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-having-coeliac-disease-aged-9-means-i-m-normal-with",
    title: "Global Health and Education Watch: 'Having coeliac disease aged 9 means I'm normal with",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-29-global-health-and-education-watch-having-coeliac-disease-aged-9-means-i-m-normal.jpg",
    date: "2026-03-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-lack-of-specialist-staff-hinders-support-for-send-children",
    title: "Global Health and Education Watch: Lack of specialist staff hinders support for Send children",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-29-global-health-and-education-watch-lack-of-specialist-staff-hinders-support-for-s.jpg",
    date: "2026-03-29",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-houthi-forces-enter-iran-conflict-with-missile-attacks-on",
    title: "Global Health and Education Watch: Houthi forces enter Iran conflict with missile attacks on",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-28-global-health-and-education-watch-houthi-forces-enter-iran-conflict-with-missile.jpg",
    date: "2026-03-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-leaders-extend-crucial-pandemic-agreement-negotiations",
    title: "Global Health Leaders Extend Crucial Pandemic Agreement Negotiations",
    summary:
      "WHO Member States have agreed to extend critical negotiations on the Pathogen Access and Benefit Sharing (PABS) annex to the Pandemic Agreement. This extension allows further deliberation on equitable access to vital resources ahead of its World Health Assembly consideration in May.",
    thumbnailImage: "/images/global-news/2026/2026-03-28-global-health-leaders-extend-crucial-pandemic-agreement-negotiations.jpg",
    date: "2026-03-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-protests-signal-deep-concerns-over-health-and-governance",
    title: "Global Protests Signal Deep Concerns Over Health and Governance",
    summary:
      "Massive global protests underscore growing public dissatisfaction with governance, reflecting profound concerns over health equity. These widespread demonstrations signal a collective demand for policies prioritizing public welfare and robust social safety nets.",
    thumbnailImage: "/images/global-news/2026/2026-03-28-global-protests-signal-deep-concerns-over-health-and-governance.jpg",
    date: "2026-03-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-protests-decry-research-cuts-demand-no-kings-just-vaccines",
    title: "Global Protests Decry Research Cuts, Demand 'No Kings, Just Vaccines!'",
    summary:
      "Demonstrators globally, including a significant gathering at the NIH headquarters, protested against severe cuts to medical research funding. These actions underscore widespread concerns about the politicization of science and its critical implications for global health security.",
    thumbnailImage: "/images/global-news/2026/2026-03-28-global-protests-decry-research-cuts-demand-no-kings-just-vaccines.jpg",
    date: "2026-03-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-colleges-pressed-to-remove-names-of-epstein-s-friends-from",
    title: "Global Health and Education Watch: Colleges Pressed to Remove Names of Epstein’s Friends From",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-28-global-health-and-education-watch-colleges-pressed-to-remove-names-of-epstein-s-.jpg",
    date: "2026-03-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-streeting-praises-response-to-meningitis-outbreak",
    title: "Global Health and Education Watch: Streeting praises response to meningitis outbreak",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-28-global-health-and-education-watch-streeting-praises-response-to-meningitis-outbr.jpg",
    date: "2026-03-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "student-s-gaza-war-protest-settlement-ignites-global-debate-on-free-speech-in-schools",
    title: "Student's Gaza War Protest Settlement Ignites Global Debate on Free Speech in Schools",
    summary:
      "A Michigan middle school student, disciplined for protesting the Gaza war by not standing for the Pledge of Allegiance, has reached a settlement with her school district. The case highlights critical issues of student free speech, alleged racial discrimination, and the protection of minority voices in educational environments globally.",
    thumbnailImage: "/images/global-news/2026/2026-03-28-student-s-gaza-war-protest-settlement-ignites-global-debate-on-free-speech-in-sc.jpg",
    date: "2026-03-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-education-under-threat-london-march-highlights-extremism-s-classroom-impact",
    title: "Global Education Under Threat: London March Highlights Extremism's Classroom Impact",
    summary:
      "Hundreds of thousands marched in London, protesting the rise of the far right and its detrimental effects on society. The demonstration highlighted how such ideologies directly threaten inclusive educational settings and student well-being globally.",
    thumbnailImage: "/images/global-news/2026/2026-03-28-global-education-under-threat-london-march-highlights-extremism-s-classroom-impa.jpg",
    date: "2026-03-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-urges-schools-worldwide-to-promote-healthy-eating-for",
    title: "Global Health and Education Watch: WHO urges schools worldwide to promote healthy eating for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-28-global-health-and-education-watch-who-urges-schools-worldwide-to-promote-healthy.jpg",
    date: "2026-03-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-nine-people-sick-from-e-coli-linked-to-raw",
    title: "Global Health and Education Watch: Nine people sick from E coli linked to raw",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-28-global-health-and-education-watch-nine-people-sick-from-e-coli-linked-to-raw.jpg",
    date: "2026-03-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "iranian-footballers-honor-school-strike-victims-amidst-escalating-conflict",
    title: "Iranian Footballers Honor School Strike Victims Amidst Escalating Conflict",
    summary:
      "Iran's national football team made a powerful statement, dedicating their first match since the Middle East conflict began to victims of a school strike. This gesture underscored the devastating human cost of the escalating regional tensions, particularly on education and youth.",
    thumbnailImage: "/images/global-news/2026/2026-03-28-iranian-footballers-honor-school-strike-victims-amidst-escalating-conflict.jpg",
    date: "2026-03-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-polio-virus-detected-in-london-days-before-ministers-cut",
    title: "Global Health and Education Watch: Polio virus detected in London days before ministers cut",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-28-global-health-and-education-watch-polio-virus-detected-in-london-days-before-min.jpg",
    date: "2026-03-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-yemen-s-houthis-launch-first-attack-on-israel-since-outbreak",
    title: "Global Health and Education Watch: Yemen’s Houthis launch first attack on Israel since outbreak",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-28-global-health-and-education-watch-yemen-s-houthis-launch-first-attack-on-israel-.jpg",
    date: "2026-03-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-sudden-death-of-a-man-who-told-chinese",
    title: "Global Health and Education Watch: The Sudden Death of a Man Who Told Chinese",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-28-global-health-and-education-watch-the-sudden-death-of-a-man-who-told-chinese.jpg",
    date: "2026-03-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "cambridge-revives-darwin-inspired-botany-course-after-historic-archive-uncovered",
    title: "Cambridge Revives Darwin-Inspired Botany Course After Historic Archive Uncovered",
    summary:
      "The University of Cambridge is reviving a foundational botany course, utilizing rare 200-year-old teaching materials that once inspired Charles Darwin. This initiative offers contemporary students a unique opportunity to engage with the original scientific methods and specimens used by Darwin's mentor, John Stevens Henslow.",
    thumbnailImage: "/images/global-news/2026/2026-03-28-cambridge-revives-darwin-inspired-botany-course-after-historic-archive-uncovered.jpg",
    date: "2026-03-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "chile-achieves-historic-leprosy-elimination-inspiring-global-health-efforts",
    title: "Chile Achieves Historic Leprosy Elimination, Inspiring Global Health Efforts",
    summary:
      "Chile has made global health history by becoming the first country in the Americas verified by the World Health Organization for eliminating leprosy. This monumental achievement underscores the power of sustained public health initiatives and offers a beacon of hope for global eradication efforts.",
    thumbnailImage: "/images/global-news/2026/2026-03-28-chile-achieves-historic-leprosy-elimination-inspiring-global-health-efforts.jpg",
    date: "2026-03-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-are-uk-students-at-risk-of-more-deadly-meningitis",
    title: "Global Health and Education Watch: Are UK students at risk of more deadly meningitis",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-28-global-health-and-education-watch-are-uk-students-at-risk-of-more-deadly-meningi.jpg",
    date: "2026-03-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-on-lead-britain-is-the-laggard-of-the-developed-2",
    title: "Global Health and Education Watch: On lead, Britain is the laggard of the developed",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-28-global-health-and-education-watch-on-lead-britain-is-the-laggard-of-the-develope.jpg",
    date: "2026-03-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-grieving-iranian-mother-tells-un-about-children-before-school",
    title: "Global Health and Education Watch: Grieving Iranian mother tells UN about children before school",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-28-global-health-and-education-watch-grieving-iranian-mother-tells-un-about-childre.jpg",
    date: "2026-03-28",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-call-to-rethink-police-response-to-mental-health-crises",
    title: "Global Call to Rethink Police Response to Mental Health Crises",
    summary:
      "A police officer's termination after fatally shooting a man in a mental health crisis underscores the critical global challenge of law enforcement's role in such situations. This event reignites discussions on the urgent need for enhanced de-escalation training and alternative crisis response models internationally.",
    thumbnailImage: "/images/global-news/2026/2026-03-27-global-call-to-rethink-police-response-to-mental-health-crises.jpg",
    date: "2026-03-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "k-pop-s-bts-connects-global-youth-to-korean-heritage-through-howard-university-link",
    title: "K-Pop's BTS Connects Global Youth to Korean Heritage Through Howard University Link",
    summary:
      "Global music sensation BTS has forged a unique connection with Howard University, leveraging the historic Korean folk song 'Arirang' to promote their latest album. This initiative highlights the profound educational power of cultural exchange and historical preservation, bridging diverse global audiences.",
    thumbnailImage: "/images/global-news/2026/2026-03-27-k-pop-s-bts-connects-global-youth-to-korean-heritage-through-howard-university-l.jpg",
    date: "2026-03-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-reform-candidate-in-wales-steps-down-after-apparent-nazi",
    title: "Global Health and Education Watch: Reform candidate in Wales steps down after apparent Nazi",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-27-global-health-and-education-watch-reform-candidate-in-wales-steps-down-after-app.jpg",
    date: "2026-03-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-schools-in-england-must-be-compelled-to-offer-pupils",
    title: "Global Health and Education Watch: Schools in England must be compelled to offer pupils",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-27-global-health-and-education-watch-schools-in-england-must-be-compelled-to-offer-.jpg",
    date: "2026-03-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-schools-face-nutritional-challenge-as-convenience-foods-dominate-lunch-breaks",
    title: "Global Schools Face Nutritional Challenge as Convenience Foods Dominate Lunch Breaks",
    summary:
      "A recent report from England reveals a significant shift in secondary school lunch habits, with students increasingly choosing convenient, often less nutritious, grab-and-go items over traditional sit-down meals. This trend poses substantial global health and educational challenges, impacting student well-being and academic performance.",
    thumbnailImage: "/images/global-news/2026/2026-03-27-global-schools-face-nutritional-challenge-as-convenience-foods-dominate-lunch-br.jpg",
    date: "2026-03-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-middle-east-war-attacks-on-vital-healthcare-evacuation-strike",
    title: "Global Health and Education Watch: Middle East war: Attacks on vital healthcare, evacuation strike",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-27-global-health-and-education-watch-middle-east-war-attacks-on-vital-healthcare-ev.jpg",
    date: "2026-03-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-russia-declares-protagonist-of-oscar-winning-documentary-a-foreign-agent",
    title: "Global Health and Education Watch: Russia declares protagonist of Oscar-winning documentary a ‘foreign agent’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-27-global-health-and-education-watch-russia-declares-protagonist-of-oscar-winning-d.jpg",
    date: "2026-03-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-italy-investigates-beauty-brands-over-concerns-about-young-girls",
    title: "Global Health and Education Watch: Italy investigates beauty brands over concerns about young girls’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-27-global-health-and-education-watch-italy-investigates-beauty-brands-over-concerns.jpg",
    date: "2026-03-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-zoomer-to-boomer-pay-phone-hotline-gets-two-generations-chatting",
    title: "Global Health and Education Watch: A ‘Zoomer-to-Boomer’ Pay Phone Hotline Gets Two Generations Chatting",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-27-global-health-and-education-watch-a-zoomer-to-boomer-pay-phone-hotline-gets-two-.jpg",
    date: "2026-03-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-science-future-imperiled-by-deep-university-research-cuts",
    title: "Global Science Future Imperiled by Deep University Research Cuts",
    summary:
      "Major funding cuts to university physics departments in the UK threaten to halt critical research and impact the global scientific landscape. Senior scientists warn these reductions could lead to department closures and a significant setback for future innovation and education.",
    thumbnailImage: "/images/global-news/2026/2026-03-27-global-science-future-imperiled-by-deep-university-research-cuts.jpg",
    date: "2026-03-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-home-education-under-scrutiny-balancing-rights-and-child-welfare",
    title: "Global Home Education Under Scrutiny: Balancing Rights and Child Welfare",
    summary:
      "Policies aimed at reducing home education are sparking intense global debate and legal challenges, with campaigners arguing such measures could undermine parental rights. This contentious issue highlights the complex balance between state educational mandates and family choices, raising concerns for children's well-being.",
    thumbnailImage: "/images/global-news/2026/2026-03-27-global-home-education-under-scrutiny-balancing-rights-and-child-welfare.jpg",
    date: "2026-03-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-attacks-on-ukraine-s-health-care-increased-by-20-in-2",
    title: "Global Health and Education Watch: Attacks on Ukraine’s health care increased by 20% in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-27-global-health-and-education-watch-attacks-on-ukraine-s-health-care-increased-by-.jpg",
    date: "2026-03-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-middle-east-live-27-march-rights-council-meets-aid",
    title: "Global Health and Education Watch: MIDDLE EAST LIVE 27 March: rights council meets, aid",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-27-global-health-and-education-watch-middle-east-live-27-march-rights-council-meets.jpg",
    date: "2026-03-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-can-students-in-gaza-continue-to-learn-with",
    title: "Global Health and Education Watch: How can students in Gaza continue to learn with",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-27-global-health-and-education-watch-how-can-students-in-gaza-continue-to-learn-wit.jpg",
    date: "2026-03-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-brussels-opens-investigation-into-snapchat-amid-concern-over-children-s",
    title: "Global Health and Education Watch: Brussels opens investigation into Snapchat amid concern over children’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-27-global-health-and-education-watch-brussels-opens-investigation-into-snapchat-ami.jpg",
    date: "2026-03-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-leadership-wobbles-us-vaccine-agenda-faces-headwinds",
    title: "Global Health Leadership Wobbles: US Vaccine Agenda Faces Headwinds",
    summary:
      "The US Health Secretary's vaccine skepticism is creating significant domestic challenges, including stalled appointments and blocked policy changes. These internal struggles are raising alarms globally about potential impacts on international health cooperation and public confidence in vital immunization programs.",
    thumbnailImage: "/images/global-news/2026/2026-03-27-global-health-leadership-wobbles-us-vaccine-agenda-faces-headwinds.jpg",
    date: "2026-03-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "nyc-hospitals-drop-palantir-amid-global-scrutiny-of-ai-in-healthcare",
    title: "NYC Hospitals Drop Palantir Amid Global Scrutiny of AI in Healthcare",
    summary:
      "New York City's public hospital system will not renew its contract with Palantir, responding to activist concerns over data privacy. This move reflects growing international scrutiny of AI firms' roles in public health, particularly in the UK's NHS.",
    thumbnailImage: "/images/global-news/2026/2026-03-27-nyc-hospitals-drop-palantir-amid-global-scrutiny-of-ai-in-healthcare.jpg",
    date: "2026-03-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-number-of-pupils-missing-more-than-half-of-school",
    title: "Global Health and Education Watch: Number of pupils missing more than half of school",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-27-global-health-and-education-watch-number-of-pupils-missing-more-than-half-of-sch.jpg",
    date: "2026-03-27",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-renews-commitment-to-a-leprosy-free-world-spotlighting-partnership",
    title: "Global Health and Education Watch: WHO renews commitment to a leprosy-free world, spotlighting partnership",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-26-global-health-and-education-watch-who-renews-commitment-to-a-leprosy-free-world-.jpg",
    date: "2026-03-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-police-fire-water-cannons-at-chile-student-protest",
    title: "Global Health and Education Watch: Police fire water cannons at Chile student protest",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-26-global-health-and-education-watch-police-fire-water-cannons-at-chile-student-pro.jpg",
    date: "2026-03-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-two-drone-strikes-on-civilian-targets-kill-28-people",
    title: "Global Health and Education Watch: Two drone strikes on civilian targets kill 28 people",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-26-global-health-and-education-watch-two-drone-strikes-on-civilian-targets-kill-28-.jpg",
    date: "2026-03-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-administration-begins-investigations-into-three-medical-schools",
    title: "Global Health and Education Watch: Trump Administration Begins Investigations Into Three Medical Schools",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-26-global-health-and-education-watch-trump-administration-begins-investigations-int.jpg",
    date: "2026-03-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "sanctions-cripple-cuban-healthcare-a-looming-humanitarian-crisis-unfolds",
    title: "Sanctions Cripple Cuban Healthcare: A Looming Humanitarian Crisis Unfolds",
    summary:
      "Cuba's healthcare system faces unprecedented challenges as U.S. sanctions disrupt essential oil supplies, impacting hospitals and clinics nationwide. This escalating crisis threatens access to critical medical care for millions across the Caribbean nation.",
    thumbnailImage: "/images/global-news/2026/2026-03-26-sanctions-cripple-cuban-healthcare-a-looming-humanitarian-crisis-unfolds.jpg",
    date: "2026-03-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-alarms-ring-as-key-leadership-vacancies-persist",
    title: "Global Health Alarms Ring as Key Leadership Vacancies Persist",
    summary:
      "Critical leadership roles in prominent national health agencies remain unfilled, raising concerns about the stability and effectiveness of global health responses. This vacuum threatens international cooperation on disease control and preparedness, impacting vulnerable populations worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-26-global-health-alarms-ring-as-key-leadership-vacancies-persist.jpg",
    date: "2026-03-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-education-faces-headwinds-as-vat-changes-force-school-closure",
    title: "Global Education Faces Headwinds as VAT Changes Force School Closure",
    summary:
      "A Christian independent school, serving 40 students, has announced its closure, attributing the decision to recent changes in value-added tax policy. This incident highlights a broader global trend of economic challenges impacting the viability of private educational institutions.",
    thumbnailImage: "/images/global-news/2026/2026-03-26-global-education-faces-headwinds-as-vat-changes-force-school-closure.jpg",
    date: "2026-03-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-policy-shift-embraces-refugees-migrants",
    title: "Global Health Policy Shift Embraces Refugees, Migrants",
    summary:
      "A recent World Health Organization report highlights encouraging global progress in inclusive health policies, revealing that over 60 countries now incorporate refugees and migrants into their national health systems. This represents a major shift, with two-thirds of surveyed nations demonstrating a commitment to ensuring health access for displaced populations.",
    thumbnailImage: "/images/global-news/2026/2026-03-26-global-health-policy-shift-embraces-refugees-migrants.jpg",
    date: "2026-03-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-warns-of-health-crisis-unfolding-in-real-time",
    title: "Global Health and Education Watch: WHO warns of health crisis ‘unfolding in real time’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-26-global-health-and-education-watch-who-warns-of-health-crisis-unfolding-in-real-t.jpg",
    date: "2026-03-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israel-hinders-repair-of-damaged-water-infra-deepening-gaza-s",
    title: "Global Health and Education Watch: Israel hinders repair of damaged water infra deepening Gaza’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-26-global-health-and-education-watch-israel-hinders-repair-of-damaged-water-infra-d.jpg",
    date: "2026-03-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "europe-s-healthcare-workers-resist-deportation-role-amid-public-health-fears",
    title: "Europe's Healthcare Workers Resist Deportation Role Amid Public Health Fears",
    summary:
      "Over 1,100 European healthcare professionals are urging MEPs to reject proposed measures that could transform hospitals into immigration enforcement sites. They warn that such policies risk public health by creating a climate of fear, deterring undocumented individuals from seeking essential medical care.",
    thumbnailImage: "/images/global-news/2026/2026-03-26-europe-s-healthcare-workers-resist-deportation-role-amid-public-health-fears.jpg",
    date: "2026-03-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-leadership-vacuum-cdc-director-nomination-stalled",
    title: "Global Health Leadership Vacuum: CDC Director Nomination Stalled",
    summary:
      "The Trump administration has postponed the nomination of a new Director for the Centers for Disease Control and Prevention. This delay stems from difficulties in identifying a candidate who can reconcile established public health principles with the Health Secretary's unique policy perspectives, particularly concerning vaccine efficacy.",
    thumbnailImage: "/images/global-news/2026/2026-03-26-global-health-leadership-vacuum-cdc-director-nomination-stalled.jpg",
    date: "2026-03-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-education-parents-without-formal-support-plans-least-satisfied",
    title: "Global Education: Parents Without Formal Support Plans Least Satisfied",
    summary:
      "Parents of children with special educational needs often feel alienated and unsupported when formal care plans are absent, a global issue impacting educational equity. This widespread dissatisfaction underscores a critical need for more robust, inclusive educational systems worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-26-global-education-parents-without-formal-support-plans-least-satisfied.jpg",
    date: "2026-03-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "netherlands-leads-global-push-restricting-phones-and-social-media-in-schools",
    title: "Netherlands Leads Global Push: Restricting Phones and Social Media in Schools",
    summary:
      "The Netherlands, two years after implementing a nationwide phone ban in schools, is now considering further restrictions on social media for under-16s. This move intensifies the global conversation around technology's impact on student health and academic performance.",
    thumbnailImage: "/images/global-news/2026/2026-03-26-netherlands-leads-global-push-restricting-phones-and-social-media-in-schools.jpg",
    date: "2026-03-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-meta-and-google-liable-for-harm-to-children-s-mental",
    title: "Global Health and Education Watch: Meta and Google liable for harm to children’s mental",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-26-global-health-and-education-watch-meta-and-google-liable-for-harm-to-children-s-.jpg",
    date: "2026-03-26",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-left-without-functioning-vaccine-panel-as-adviser-says",
    title: "Global Health and Education Watch: US left without functioning vaccine panel as adviser says",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-25-global-health-and-education-watch-us-left-without-functioning-vaccine-panel-as-a.jpg",
    date: "2026-03-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-middle-east-crisis-live-iranian-official-warns-us-troops",
    title: "Global Health and Education Watch: Middle East crisis live: Iranian official warns US troops",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-25-global-health-and-education-watch-middle-east-crisis-live-iranian-official-warns.jpg",
    date: "2026-03-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-out-of-school-crisis-deepens-273-million-children-denied-education",
    title: "Global Out-of-School Crisis Deepens: 273 Million Children Denied Education",
    summary:
      "The number of children and young people out of school worldwide has reached an alarming 273 million, marking a seventh consecutive annual increase. This crisis, highlighted by a recent UNESCO report, poses significant threats to global development and individual futures.",
    thumbnailImage: "/images/global-news/2026/2026-03-25-global-out-of-school-crisis-deepens-273-million-children-denied-education.jpg",
    date: "2026-03-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "key-adviser-s-exit-from-federal-vaccine-panel-sparks-global-health-integrity-debate",
    title: "Key Adviser's Exit From Federal Vaccine Panel Sparks Global Health Integrity Debate",
    summary:
      "Dr. Robert Malone, vice chair of a prominent federal vaccine advisory committee, has resigned, raising questions about scientific independence. His controversial appointment followed a significant overhaul of the panel, sparking global discussion on public trust in health institutions.",
    thumbnailImage: "/images/global-news/2026/2026-03-25-key-adviser-s-exit-from-federal-vaccine-panel-sparks-global-health-integrity-deb.jpg",
    date: "2026-03-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "us-policy-shifts-linked-to-global-maternal-mortality-surge",
    title: "US Policy Shifts Linked to Global Maternal Mortality Surge",
    summary:
      "New research indicates a direct link between US presidential policy shifts and a rise in global maternal mortality. Cuts to family planning aid under Republican administrations are associated with an 11% increase in deaths during pregnancy and childbirth in aid-dependent nations.",
    thumbnailImage: "/images/global-news/2026/2026-03-25-us-policy-shifts-linked-to-global-maternal-mortality-surge.jpg",
    date: "2026-03-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "kent-outbreak-spurs-global-reflection-on-vaccine-urgency",
    title: "Kent Outbreak Spurs Global Reflection on Vaccine Urgency",
    summary:
      "A recent meningitis outbreak in Kent, England, tragically claiming two teenage lives, has prompted a significant surge in routine vaccination uptake across the country. This localized event serves as a stark global reminder of the persistent threat of preventable diseases and the paramount importance of sustained public health campaigns and vaccine accessibility.",
    thumbnailImage: "/images/global-news/2026/2026-03-25-kent-outbreak-spurs-global-reflection-on-vaccine-urgency.jpg",
    date: "2026-03-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "navigating-the-digital-maze-combating-health-misinformation-online",
    title: "Navigating the Digital Maze: Combating Health Misinformation Online",
    summary:
      "Health misinformation on social media poses a significant global challenge, leading many to embrace unproven remedies. Barbora Gray's personal journey highlights this danger, inspiring her to advocate for factual health information.",
    thumbnailImage: "/images/global-news/2026/2026-03-25-navigating-the-digital-maze-combating-health-misinformation-online.jpg",
    date: "2026-03-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "china-s-dual-impact-on-african-health-a-complex-partnership",
    title: "China's Dual Impact on African Health: A Complex Partnership",
    summary:
      "China's expanding health role in Africa presents a complex duality of significant contributions and notable challenges. This analysis explores the strategic implications and practical outcomes of Beijing's healthcare initiatives across the continent.",
    thumbnailImage: "/images/global-news/2026/2026-03-25-china-s-dual-impact-on-african-health-a-complex-partnership.jpg",
    date: "2026-03-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-sudan-1000-days-of-war-deepen-the-world-s-worst",
    title: "Global Health and Education Watch: Sudan: 1000 days of war deepen the world’s worst",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-25-global-health-and-education-watch-sudan-1000-days-of-war-deepen-the-world-s-wors.jpg",
    date: "2026-03-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "middle-east-conflict-devastating-toll-on-health-and-education-systems",
    title: "Middle East Conflict: Devastating Toll on Health and Education Systems",
    summary:
      "The persistent conflict across the Middle East is systematically dismantling essential health and education services, leaving millions vulnerable. This humanitarian crisis demands urgent global attention to mitigate the catastrophic long-term impacts on human development.",
    thumbnailImage: "/images/global-news/2026/2026-03-25-middle-east-conflict-devastating-toll-on-health-and-education-systems.jpg",
    date: "2026-03-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-concerns-rise-over-teacher-misconduct-and-student-safety-in-educational-institutions",
    title: "Global Concerns Rise Over Teacher Misconduct and Student Safety in Educational Institutions",
    summary:
      "Charges against a former teacher at a Massachusetts boarding school for alleged sexual assault on students have ignited global discussions on child protection. The case underscores the critical need for robust safeguarding policies and a re-evaluation of consent laws in educational environments.",
    thumbnailImage: "/images/global-news/2026/2026-03-25-global-concerns-rise-over-teacher-misconduct-and-student-safety-in-educational-i.jpg",
    date: "2026-03-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-influencers-are-promoting-these-three-health-tests-but",
    title: "Global Health and Education Watch: Influencers are promoting these three health tests – but",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-25-global-health-and-education-watch-influencers-are-promoting-these-three-health-t.jpg",
    date: "2026-03-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-alert-the-critical-two-day-window-in-outbreak-response",
    title: "Global Health Alert: The Critical Two-Day Window in Outbreak Response",
    summary:
      "A two-day delay in reporting a meningitis outbreak in Kent, UK, highlights the critical importance of timely communication in global public health. This incident serves as a stark reminder of the universal need for robust surveillance and rapid response systems to contain infectious diseases effectively.",
    thumbnailImage: "/images/global-news/2026/2026-03-25-global-health-alert-the-critical-two-day-window-in-outbreak-response.jpg",
    date: "2026-03-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-plant-based-meat-alternatives-understanding-the-benefits-and-trade-offs-for",
    title: "Global Health and Education Watch: Plant-based meat alternatives: understanding the benefits and trade-offs for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-25-global-health-and-education-watch-plant-based-meat-alternatives-understanding-th.jpg",
    date: "2026-03-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-alarms-delayed-outbreak-response-raises-urgent-questions",
    title: "Global Health Alarms: Delayed Outbreak Response Raises Urgent Questions",
    summary:
      "A significant delay in alerting public health authorities to a potential meningitis outbreak has sparked international concern among health experts. This incident underscores the urgent need for robust global disease surveillance and swift intervention strategies to protect populations.",
    thumbnailImage: "/images/global-news/2026/2026-03-25-global-health-alarms-delayed-outbreak-response-raises-urgent-questions.jpg",
    date: "2026-03-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "merck-s-6-billion-biotech-pursuit-ignites-global-oncology-hopes",
    title: "Merck's $6 Billion Biotech Pursuit Ignites Global Oncology Hopes",
    summary:
      "Merck is reportedly nearing a significant $6 billion acquisition of a biotech firm to enhance its oncology portfolio. This strategic move aims to integrate innovative treatments for bone and blood cancers, following recent breakthroughs in clinical data.",
    thumbnailImage: "/images/global-news/2026/2026-03-25-merck-s-6-billion-biotech-pursuit-ignites-global-oncology-hopes.jpg",
    date: "2026-03-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "road-safety-crisis-nine-students-injured-in-iowa-school-curb-incident",
    title: "Road Safety Crisis: Nine Students Injured in Iowa School Curb Incident",
    summary:
      "Nine students were hospitalized after a vehicle veered onto a curb outside a Catholic school in Ankeny, Iowa, in an incident authorities deemed unintentional. This event underscores critical global challenges in ensuring safe environments for children around educational institutions and addressing vehicular safety.",
    thumbnailImage: "/images/global-news/2026/2026-03-24-road-safety-crisis-nine-students-injured-in-iowa-school-curb-incident.jpg",
    date: "2026-03-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-my-child-should-have-been-offered-meningitis-vaccine-by",
    title: "Global Health and Education Watch: My child should have been offered meningitis vaccine by",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-24-global-health-and-education-watch-my-child-should-have-been-offered-meningitis-v.jpg",
    date: "2026-03-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-in-n-y-c-classes-teachers-can-use-a-i-to-plan",
    title: "Global Health and Education Watch: In N.Y.C. Classes, Teachers Can Use A.I. to Plan",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-24-global-health-and-education-watch-in-n-y-c-classes-teachers-can-use-a-i-to-plan.jpg",
    date: "2026-03-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-teacher-barred-over-secret-email-plan-for-pupils",
    title: "Global Health and Education Watch: Teacher barred over secret email plan for pupils",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-24-global-health-and-education-watch-teacher-barred-over-secret-email-plan-for-pupi.jpg",
    date: "2026-03-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "sudan-hospital-strike-drone-attacks-escalate-civilian-health-crisis",
    title: "Sudan Hospital Strike: Drone Attacks Escalate Civilian Health Crisis",
    summary:
      "A recent deadly attack on a Darfur hospital underscores an alarming surge in drone strikes targeting civilians in Sudan. UN agencies are urgently calling for protection of healthcare facilities and adherence to international humanitarian law amidst the escalating crisis.",
    thumbnailImage: "/images/global-news/2026/2026-03-24-sudan-hospital-strike-drone-attacks-escalate-civilian-health-crisis.jpg",
    date: "2026-03-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-truly-transformative-new-diagnostic-tools-can-help-end-tuberculosis",
    title: "Global Health and Education Watch: ‘Truly transformative’ new diagnostic tools can help end tuberculosis",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-24-global-health-and-education-watch-truly-transformative-new-diagnostic-tools-can-.jpg",
    date: "2026-03-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "hbcus-linked-to-better-cognitive-health-for-black-americans",
    title: "HBCUs Linked to Better Cognitive Health for Black Americans",
    summary:
      "A recent study indicates that attending a Historically Black College or University (HBCU) may correlate with better later-life cognitive outcomes for Black Americans. This research highlights the significant impact of culturally affirming educational environments on long-term health and well-being.",
    thumbnailImage: "/images/global-news/2026/2026-03-24-hbcus-linked-to-better-cognitive-health-for-black-americans.jpg",
    date: "2026-03-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-tragic-toll-of-sudan-s-destroyed-healthcare",
    title: "Global Health and Education Watch: The tragic toll of Sudan’s destroyed healthcare",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-24-global-health-and-education-watch-the-tragic-toll-of-sudan-s-destroyed-healthcar.jpg",
    date: "2026-03-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-focus-meningitis-b-vaccine-widens-reach-amidst-declining-cases",
    title: "Global Health Focus: Meningitis B Vaccine Widens Reach Amidst Declining Cases",
    summary:
      "A Meningitis B vaccination scheme in Kent, UK, has expanded to include Year 11 pupils in affected schools, demonstrating a proactive public health response. This initiative comes as national figures indicate a significant reduction in overall cases, highlighting the vaccine's effectiveness.",
    thumbnailImage: "/images/global-news/2026/2026-03-24-global-health-focus-meningitis-b-vaccine-widens-reach-amidst-declining-cases.jpg",
    date: "2026-03-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-classrooms-confront-evolving-youth-challenges-reflected-in-popular-culture",
    title: "Global Classrooms Confront Evolving Youth Challenges Reflected in Popular Culture",
    summary:
      "Educational institutions globally are grappling with an evolving landscape of youth challenges, from historical issues like bullying to modern concerns such as cyber-bullying and vaping. Popular culture often mirrors these societal shifts, highlighting the critical need for comprehensive support and adaptive educational strategies.",
    thumbnailImage: "/images/global-news/2026/2026-03-24-global-classrooms-confront-evolving-youth-challenges-reflected-in-popular-cultur.jpg",
    date: "2026-03-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-education-grapples-with-complex-legacies-of-historical-figures",
    title: "Global Education Grapples with Complex Legacies of Historical Figures",
    summary:
      "Across educational systems globally, teachers are navigating how to present historical figures whose legacies are complicated by recent revelations. This shift emphasizes a more comprehensive and critical understanding of history and collective movements.",
    thumbnailImage: "/images/global-news/2026/2026-03-24-global-education-grapples-with-complex-legacies-of-historical-figures.jpg",
    date: "2026-03-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-recommends-new-diagnostic-tools-to-help-end-tb",
    title: "Global Health and Education Watch: WHO recommends new diagnostic tools to help end TB",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-24-global-health-and-education-watch-who-recommends-new-diagnostic-tools-to-help-en.jpg",
    date: "2026-03-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tango-therapy-how-the-dance-of-passion-is-helping",
    title: "Global Health and Education Watch: Tango Therapy: How the Dance of Passion Is Helping",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-24-global-health-and-education-watch-tango-therapy-how-the-dance-of-passion-is-help.jpg",
    date: "2026-03-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-schools-face-scrutiny-over-exclusion-of-vulnerable-students",
    title: "Global Schools Face Scrutiny Over Exclusion of Vulnerable Students",
    summary:
      "A recent study highlights a concerning trend where top-tier schools globally admit significantly fewer disadvantaged students with special educational needs and disabilities. This disparity raises serious questions about equitable access to quality education and potential systemic biases in admissions.",
    thumbnailImage: "/images/global-news/2026/2026-03-24-global-schools-face-scrutiny-over-exclusion-of-vulnerable-students.jpg",
    date: "2026-03-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-takeaways-from-the-times-s-inside-look-at-the-c-d-c",
    title: "Global Health and Education Watch: Takeaways From The Times’s Inside Look at the C.D.C.",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-24-global-health-and-education-watch-takeaways-from-the-times-s-inside-look-at-the-.jpg",
    date: "2026-03-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israeli-settlers-vandalise-school-raise-israeli-flag-in-occupied",
    title: "Global Health and Education Watch: Israeli settlers vandalise school, raise Israeli flag in occupied",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-24-global-health-and-education-watch-israeli-settlers-vandalise-school-raise-israel.jpg",
    date: "2026-03-24",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-call-for-stricter-minibus-rules-after-school-tragedies",
    title: "Global Call for Stricter Minibus Rules After School Tragedies",
    summary:
      "Tragic incidents involving school minibuses have spurred a global movement for stricter safety regulations. Parents who have lost children are leading the charge for comprehensive reforms in driver training and vehicle standards.",
    thumbnailImage: "/images/global-news/2026/2026-03-23-global-call-for-stricter-minibus-rules-after-school-tragedies.jpg",
    date: "2026-03-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-meningitis-outbreak-peaks-health-agencies-urge-continued-vigilance",
    title: "Global Meningitis Outbreak Peaks; Health Agencies Urge Continued Vigilance",
    summary:
      "Health agencies globally confirm that a recent meningitis outbreak has moved past its peak, signaling a positive shift in the public health crisis. However, officials caution that ongoing surveillance and proactive preventative strategies remain critical to managing the disease's long-term impact and preventing future surges.",
    thumbnailImage: "/images/global-news/2026/2026-03-23-global-meningitis-outbreak-peaks-health-agencies-urge-continued-vigilance.jpg",
    date: "2026-03-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "uk-visa-ban-blocks-women-s-education-echoing-restrictive-regimes",
    title: "UK Visa Ban Blocks Women's Education, Echoing Restrictive Regimes",
    summary:
      "A recent UK Home Office decision has halted new study visas for applicants from Afghanistan, Sudan, Myanmar, and Cameroon, disproportionately affecting women seeking education. This policy change threatens to derail the academic aspirations of many, including those pursuing prestigious scholarships, and has drawn comparisons to restrictive regimes.",
    thumbnailImage: "/images/global-news/2026/2026-03-23-uk-visa-ban-blocks-women-s-education-echoing-restrictive-regimes.jpg",
    date: "2026-03-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "laguardia-air-crash-a-global-lens-on-emergency-health-response",
    title: "LaGuardia Air Crash: A Global Lens on Emergency Health Response",
    summary:
      "A recent air crash at LaGuardia Airport resulted in fatalities and numerous injuries, highlighting the immense challenges faced by emergency and healthcare services. The incident prompts a global examination of preparedness for mass casualty events and the long-term support required for survivors.",
    thumbnailImage: "/images/global-news/2026/2026-03-23-laguardia-air-crash-a-global-lens-on-emergency-health-response.jpg",
    date: "2026-03-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "students-challenge-uk-visa-ban-a-global-education-rights-battle",
    title: "Students Challenge UK Visa Ban: A Global Education Rights Battle",
    summary:
      "Six students from Sudan and Afghanistan are legally challenging the UK Home Office's visa ban, which they claim is racially discriminatory. This action seeks to overturn a policy preventing them from pursuing university studies in Britain, despite receiving offers from prestigious institutions.",
    thumbnailImage: "/images/global-news/2026/2026-03-23-students-challenge-uk-visa-ban-a-global-education-rights-battle.jpg",
    date: "2026-03-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hundreds-of-n-y-u-professors-begin-strike-over-pay-and",
    title: "Global Health and Education Watch: Hundreds of N.Y.U. Professors Begin Strike Over Pay and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-23-global-health-and-education-watch-hundreds-of-n-y-u-professors-begin-strike-over.jpg",
    date: "2026-03-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "imatinib-s-global-impact-unequal-outcomes-in-cml-treatment-revealed",
    title: "Imatinib's Global Impact: Unequal Outcomes in CML Treatment Revealed",
    summary:
      "A landmark systematic review and meta-analysis reveals varying success rates of Imatinib in treating chronic myeloid leukemia globally. The study highlights critical disparities influenced by healthcare infrastructure, access, and monitoring capabilities across different regions.",
    thumbnailImage: "/images/global-news/2026/2026-03-23-imatinib-s-global-impact-unequal-outcomes-in-cml-treatment-revealed.jpg",
    date: "2026-03-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "middle-east-conflict-cultural-loss-threatens-education-and-mental-health-globally",
    title: "Middle East Conflict: Cultural Loss Threatens Education and Mental Health Globally",
    summary:
      "The recent escalation of conflict across Iran, Israel, and Lebanon has led to widespread human suffering and the irreversible damage of vital cultural heritage sites. This destruction poses a critical long-term threat to educational continuity and the mental well-being of communities, extending far beyond the immediate conflict zones.",
    thumbnailImage: "/images/global-news/2026/2026-03-23-middle-east-conflict-cultural-loss-threatens-education-and-mental-health-globall.jpg",
    date: "2026-03-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-university-to-cut-film-and-modern-languages-courses",
    title: "Global Health and Education Watch: University to cut film and modern languages courses",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-23-global-health-and-education-watch-university-to-cut-film-and-modern-languages-co.jpg",
    date: "2026-03-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "mitochondrial-dna-and-inflammation-linked-to-mortality-in-older-adults",
    title: "Mitochondrial DNA and Inflammation Linked to Mortality in Older Adults",
    summary:
      "A significant study reveals that lower leukocyte mitochondrial DNA copy number and elevated inflammation are independently associated with increased mortality risk among older adults. These findings offer crucial insights into the biological mechanisms of aging and potential targets for interventions to promote healthier longevity.",
    thumbnailImage: "/images/global-news/2026/2026-03-23-mitochondrial-dna-and-inflammation-linked-to-mortality-in-older-adults.jpg",
    date: "2026-03-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-vigilance-no-new-meningitis-cases-in-kent-outbreak",
    title: "Global Health Vigilance: No New Meningitis Cases in Kent Outbreak",
    summary:
      "Health authorities in the UK have reported no new meningitis cases linked to a recent outbreak in Kent, maintaining a total of 20 confirmed infections. This development highlights the ongoing global need for vigilant public health monitoring and swift containment strategies to protect communities from infectious diseases.",
    thumbnailImage: "/images/global-news/2026/2026-03-23-global-health-vigilance-no-new-meningitis-cases-in-kent-outbreak.jpg",
    date: "2026-03-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "teacher-banned-indefinitely-a-global-call-for-educational-safeguarding",
    title: "Teacher Banned Indefinitely: A Global Call for Educational Safeguarding",
    summary:
      "A deputy housemaster at Bede's School has been indefinitely banned from teaching after declaring love for a pupil. This incident underscores the global need for stringent safeguarding and ethical conduct in educational settings.",
    thumbnailImage: "/images/global-news/2026/2026-03-23-teacher-banned-indefinitely-a-global-call-for-educational-safeguarding.jpg",
    date: "2026-03-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "danone-acquires-huel-reshaping-global-nutrition-landscape",
    title: "Danone Acquires Huel, Reshaping Global Nutrition Landscape",
    summary:
      "Danone's €1 billion acquisition of Huel underscores a global pivot towards convenient, nutritionally complete food solutions. This strategic move by the French conglomerate aims to deepen its presence in the rapidly expanding health and wellness market.",
    thumbnailImage: "/images/global-news/2026/2026-03-23-danone-acquires-huel-reshaping-global-nutrition-landscape.jpg",
    date: "2026-03-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-jewish-and-muslim-people-face-a-wave-of-hate",
    title: "Global Health and Education Watch: Jewish and Muslim People Face a Wave of Hate",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-23-global-health-and-education-watch-jewish-and-muslim-people-face-a-wave-of-hate.jpg",
    date: "2026-03-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "afghan-exodus-from-iran-a-dual-crisis-deepens-humanitarian-woes",
    title: "Afghan Exodus from Iran: A Dual Crisis Deepens Humanitarian Woes",
    summary:
      "An escalating conflict in Iran has compelled over 70,000 Afghan workers and students to return home, severing a critical economic lifeline. This mass displacement exacerbates humanitarian challenges in Afghanistan, particularly impacting health and education sectors already under immense strain.",
    thumbnailImage: "/images/global-news/2026/2026-03-23-afghan-exodus-from-iran-a-dual-crisis-deepens-humanitarian-woes.jpg",
    date: "2026-03-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-conflict-threatens-health-education-progress",
    title: "Global Conflict Threatens Health, Education Progress",
    summary:
      "A deepening crisis in the Middle East is inflicting a severe humanitarian toll and disrupting global stability, threatening vital health and education initiatives. The conflict's economic fallout, including unprecedented energy market disruptions, exacerbates vulnerabilities and diverts critical resources from global development goals.",
    thumbnailImage: "/images/global-news/2026/2026-03-23-global-conflict-threatens-health-education-progress.jpg",
    date: "2026-03-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-outcry-youth-violence-and-the-resilience-of-community-support",
    title: "Global Outcry: Youth Violence and the Resilience of Community Support",
    summary:
      "A 15-year-old schoolgirl's survival after a stabbing incident has sparked a global conversation on youth violence and community support. Her parents' ordeal, particularly her mother's terror while abroad, underscores the universal anxieties faced by families worldwide regarding children's safety and well-being.",
    thumbnailImage: "/images/global-news/2026/2026-03-22-global-outcry-youth-violence-and-the-resilience-of-community-support.jpg",
    date: "2026-03-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-j-michael-bishop-nobel-prize-winner-for-cancer-research",
    title: "Global Health and Education Watch: J. Michael Bishop, Nobel Prize Winner for Cancer Research",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-22-global-health-and-education-watch-j-michael-bishop-nobel-prize-winner-for-cancer.jpg",
    date: "2026-03-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "youngest-world-champion-inspires-global-youth",
    title: "Youngest World Champion Inspires Global Youth",
    summary:
      "Seventeen-year-old Cooper Lutkenhaus made history by becoming the youngest indoor world champion in the 800m, balancing his high school studies with elite athletic demands. His remarkable achievement sparks global conversations about nurturing young talent within educational frameworks and supporting holistic student development.",
    thumbnailImage: "/images/global-news/2026/2026-03-22-youngest-world-champion-inspires-global-youth.jpg",
    date: "2026-03-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israeli-air-strikes-on-gaza-kill-four-palestinians",
    title: "Global Health and Education Watch: Israeli air strikes on Gaza kill four Palestinians",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-22-global-health-and-education-watch-israeli-air-strikes-on-gaza-kill-four-palestin.jpg",
    date: "2026-03-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "middle-east-conflict-daily-toll-on-children-s-lives-and-futures-in-lebanon",
    title: "Middle East Conflict: Daily Toll on Children's Lives and Futures in Lebanon",
    summary:
      "The ongoing conflict in the Middle East has claimed over a thousand lives and injured thousands more in Lebanon, with a daily toll equivalent to a classroom of children. This humanitarian crisis severely impacts critical health and education infrastructure, threatening a generation's future.",
    thumbnailImage: "/images/global-news/2026/2026-03-22-middle-east-conflict-daily-toll-on-children-s-lives-and-futures-in-lebanon.jpg",
    date: "2026-03-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-i-feel-so-grateful-to-be-alive-kent-university",
    title: "Global Health and Education Watch: 'I feel so grateful to be alive,' Kent University",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-22-global-health-and-education-watch-i-feel-so-grateful-to-be-alive-kent-university.jpg",
    date: "2026-03-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "new-era-in-obesity-treatment-drugs-thrive-with-lifestyle-synergy",
    title: "New Era in Obesity Treatment: Drugs Thrive with Lifestyle Synergy",
    summary:
      "GLP-1 medications represent a significant advance in treating obesity and potentially addiction, influencing the brain's reward systems. However, clinical evidence strongly suggests that these drugs achieve the most durable outcomes when combined with substantial lifestyle adjustments, including diet, exercise, sleep, and muscle preservation.",
    thumbnailImage: "/images/global-news/2026/2026-03-22-new-era-in-obesity-treatment-drugs-thrive-with-lifestyle-synergy.jpg",
    date: "2026-03-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-youth-confront-rising-anxiety-a-call-for-mental-health-and-education-support",
    title: "Global Youth Confront Rising Anxiety: A Call for Mental Health and Education Support",
    summary:
      "Across the globe, young adults are experiencing heightened anxiety regarding future uncertainties, from geopolitical tensions to environmental challenges. This escalating concern underscores a critical need for integrated mental health support and educational strategies to foster resilience and global understanding.",
    thumbnailImage: "/images/global-news/2026/2026-03-22-global-youth-confront-rising-anxiety-a-call-for-mental-health-and-education-supp.jpg",
    date: "2026-03-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "sudan-hospital-attack-kills-dozens-who-condemns-targeting-of-healthcare",
    title: "Sudan Hospital Attack Kills Dozens, WHO Condemns Targeting of Healthcare",
    summary:
      "A recent attack on a hospital in Sudan's Darfur region resulted in dozens of deaths, including 13 children, drawing strong condemnation from the World Health Organization. This incident underscores the devastating impact of the ongoing civil war on healthcare infrastructure and vulnerable populations.",
    thumbnailImage: "/images/global-news/2026/2026-03-22-sudan-hospital-attack-kills-dozens-who-condemns-targeting-of-healthcare.jpg",
    date: "2026-03-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "who-confirms-deadly-hospital-attack-in-sudan-amid-escalating-conflict",
    title: "WHO Confirms Deadly Hospital Attack in Sudan Amid Escalating Conflict",
    summary:
      "The World Health Organization has confirmed a deadly hospital attack in war-torn Sudan, resulting in 64 fatalities. This incident highlights the catastrophic consequences of the protracted conflict on vital healthcare facilities and civilian lives.",
    thumbnailImage: "/images/global-news/2026/2026-03-22-who-confirms-deadly-hospital-attack-in-sudan-amid-escalating-conflict.jpg",
    date: "2026-03-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-alert-kent-meningitis-outbreak-sees-case-count-revised-downward",
    title: "Global Health Alert: Kent Meningitis Outbreak Sees Case Count Revised Downward",
    summary:
      "The number of confirmed meningitis cases linked to a recent outbreak in Kent, UK, has been revised from 23 to 20 by the UK Health Security Agency after further testing. This reclassification underscores the dynamic nature of disease surveillance and the rigorous protocols involved in public health responses to infectious diseases.",
    thumbnailImage: "/images/global-news/2026/2026-03-22-global-health-alert-kent-meningitis-outbreak-sees-case-count-revised-downward.jpg",
    date: "2026-03-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "lebanese-nurse-s-unyielding-dedication-amidst-war-s-aftermath",
    title: "Lebanese Nurse's Unyielding Dedication Amidst War's Aftermath",
    summary:
      "A Lebanese nurse in the Bekaa Valley demonstrates extraordinary resilience, remaining at her hospital post after losing her fiancé in the 2024 Israel-Hezbollah war. Her unwavering commitment highlights the immense sacrifices of healthcare workers in conflict zones and the critical need for global support.",
    thumbnailImage: "/images/global-news/2026/2026-03-22-lebanese-nurse-s-unyielding-dedication-amidst-war-s-aftermath.jpg",
    date: "2026-03-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-financial-literacy-essential-for-well-being-and-resilient-communities",
    title: "Global Financial Literacy: Essential for Well-being and Resilient Communities",
    summary:
      "The global imperative for stronger financial literacy is gaining recognition as a cornerstone of public health and individual well-being. Experts are increasingly advocating for accessible education to empower communities worldwide in building healthier financial habits.",
    thumbnailImage: "/images/global-news/2026/2026-03-22-global-financial-literacy-essential-for-well-being-and-resilient-communities.jpg",
    date: "2026-03-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-navigating-the-surge-in-proactive-body-scans",
    title: "Global Health: Navigating the Surge in Proactive Body Scans",
    summary:
      "A global trend towards proactive health management is driving increased interest in advanced body scans, offering unprecedented insights into individual well-being. Understanding the various types, their benefits, and limitations is crucial for informed health decisions.",
    thumbnailImage: "/images/global-news/2026/2026-03-22-global-health-navigating-the-surge-in-proactive-body-scans.jpg",
    date: "2026-03-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-education-crisis-soaring-costs-deepen-inequality-threatening-futures",
    title: "Global Education Crisis: Soaring Costs Deepen Inequality, Threatening Futures",
    summary:
      "A global affordability crisis in education is exacerbating economic disparities, threatening access to quality learning for millions. This trend risks entrenching social stratification and hindering global progress.",
    thumbnailImage: "/images/global-news/2026/2026-03-22-global-education-crisis-soaring-costs-deepen-inequality-threatening-futures.jpg",
    date: "2026-03-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-us-health-department-investigates-13-states-that-require-insurance",
    title: "Global Health and Education Watch: US health department investigates 13 states that require insurance",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-22-global-health-and-education-watch-us-health-department-investigates-13-states-th.jpg",
    date: "2026-03-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-this-is-the-saddest-moment-families-search-for-loved",
    title: "Global Health and Education Watch: ‘This is the saddest moment’: families search for loved",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-22-global-health-and-education-watch-this-is-the-saddest-moment-families-search-for.jpg",
    date: "2026-03-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "sudan-hospital-strike-kills-dozens-wounds-many-highlighting-healthcare-under-siege",
    title: "Sudan Hospital Strike Kills Dozens, Wounds Many, Highlighting Healthcare Under Siege",
    summary:
      "A devastating strike on a healthcare facility in East Darfur, Sudan, has resulted in 64 fatalities and 89 injuries, as reported by the World Health Organization. This attack, reportedly by an army drone, underscores the severe and ongoing threat to medical infrastructure and civilian lives amidst the nation's protracted conflict.",
    thumbnailImage: "/images/global-news/2026/2026-03-22-sudan-hospital-strike-kills-dozens-wounds-many-highlighting-healthcare-under-sie.jpg",
    date: "2026-03-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "unveiling-global-eye-cancer-disparities-a-call-for-equitable-health-initiatives",
    title: "Unveiling Global Eye Cancer Disparities: A Call for Equitable Health Initiatives",
    summary:
      "New research reveals significant variations in eye cancer mortality across different populations and regions, emphasizing the urgent need for targeted public health interventions. These findings underscore the critical importance of equitable access to early diagnosis and specialized treatment worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-22-unveiling-global-eye-cancer-disparities-a-call-for-equitable-health-initiatives.jpg",
    date: "2026-03-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "sudan-hospital-attack-kills-64-who-condemns-violence-against-healthcare",
    title: "Sudan Hospital Attack Kills 64, WHO Condemns Violence Against Healthcare",
    summary:
      "A recent attack on a teaching hospital in Al Deain, East Darfur, resulted in the deaths of 64 individuals, including 13 children. The World Health Organization has condemned the violence, which has rendered the vital medical facility inoperable.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-sudan-hospital-attack-kills-64-who-condemns-violence-against-healthcare.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-i-spent-five-months-in-a-mother-and-baby",
    title: "Global Health and Education Watch: I spent five months in a mother and baby",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-global-health-and-education-watch-i-spent-five-months-in-a-mother-and-baby.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-campuses-grapple-with-intensified-antisemitism-fight",
    title: "Global Campuses Grapple with Intensified Antisemitism Fight",
    summary:
      "A global debate intensifies as renewed governmental efforts to combat antisemitism on university campuses draw both support and skepticism. Educational institutions navigate the delicate balance between protecting students and upholding academic freedom amidst these accelerating pressures.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-global-campuses-grapple-with-intensified-antisemitism-fight.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-should-the-bank-of-mum-and-dad-pay-university",
    title: "Global Health and Education Watch: Should the bank of mum and dad pay university",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-global-health-and-education-watch-should-the-bank-of-mum-and-dad-pay-university.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "us-government-sues-harvard-over-antisemitism-allegations-sparking-global-debate",
    title: "US Government Sues Harvard Over Antisemitism Allegations, Sparking Global Debate",
    summary:
      "The Trump administration has initiated legal action against Harvard University, alleging widespread antisemitism on campus. This lawsuit follows an extensive federal investigation and unsuccessful attempts to reach a settlement between the two parties.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-us-government-sues-harvard-over-antisemitism-allegations-sparking-global-debate.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "new-climate-resilient-apple-unveiled-offers-hope-for-global-food-security",
    title: "New Climate-Resilient Apple Unveiled, Offers Hope for Global Food Security",
    summary:
      "Scientists at Washington State University have introduced the Sunflare apple, a new variety engineered for resilience against extreme weather. It offers a promising solution for global food security challenges exacerbated by climate change while maintaining high taste quality.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-new-climate-resilient-apple-unveiled-offers-hope-for-global-food-security.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-mental-health-the-peril-of-automated-care",
    title: "Global Mental Health: The Peril of Automated Care",
    summary:
      "A major US healthcare provider faces therapist backlash over new screening systems that allegedly delay critical mental health care. This case highlights global concerns about technology's role in patient assessment and the potential for increased risk.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-global-mental-health-the-peril-of-automated-care.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-rhoda-roberts-indigenous-cultural-leader-who-introduced-the-term",
    title: "Global Health and Education Watch: Rhoda Roberts, Indigenous cultural leader who introduced the term",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-global-health-and-education-watch-rhoda-roberts-indigenous-cultural-leader-who-i.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-alabama-student-reportedly-fell-to-his-death-in-barcelona",
    title: "Global Health and Education Watch: Alabama student reportedly fell to his death in Barcelona",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-global-health-and-education-watch-alabama-student-reportedly-fell-to-his-death-i.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-five-questions-that-still-need-answering-about-the-meningitis",
    title: "Global Health and Education Watch: Five questions that still need answering about the meningitis",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-global-health-and-education-watch-five-questions-that-still-need-answering-about.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-student-debt-crisis-deepens-us-policy-reversal-echoes-worldwide-challenges",
    title: "Global Student Debt Crisis Deepens: US Policy Reversal Echoes Worldwide Challenges",
    summary:
      "A recent US federal court ruling, dismantling a significant student loan repayment initiative, leaves millions of American borrowers in uncertainty. This development underscores a growing global crisis where rising education costs and complex financing models burden students worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-global-student-debt-crisis-deepens-us-policy-reversal-echoes-worldwide-challenge.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-david-botstein-gene-mapping-pioneer-dies-at-83",
    title: "Global Health and Education Watch: David Botstein, Gene-Mapping Pioneer, Dies at 83",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-global-health-and-education-watch-david-botstein-gene-mapping-pioneer-dies-at-83.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "in-utero-chikungunya-exposure-linked-to-increased-child-morbimortality",
    title: "In-Utero Chikungunya Exposure Linked to Increased Child Morbimortality",
    summary:
      "New research highlights a significant link between in-utero chikungunya virus exposure and elevated rates of child morbidity and mortality. This global study underscores the urgent need for enhanced maternal health interventions and surveillance in endemic regions.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-in-utero-chikungunya-exposure-linked-to-increased-child-morbimortality.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-is-eager-to-disclose-details-on-others-health",
    title: "Global Health and Education Watch: Trump is eager to disclose details on others’ health",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-global-health-and-education-watch-trump-is-eager-to-disclose-details-on-others-h.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-wellness-heats-up-saunas-forge-connection-and-health",
    title: "Global Wellness Heats Up: Saunas Forge Connection and Health",
    summary:
      "A global surge in sauna popularity highlights a growing desire for both physical health benefits and authentic human connection. These communal spaces are becoming crucial in fostering well-being and combating digital isolation worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-global-wellness-heats-up-saunas-forge-connection-and-health.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "pet-passport-scheme-sparks-global-warning-for-british-eu-travelers",
    title: "Pet Passport Scheme Sparks Global Warning for British EU Travelers",
    summary:
      "British pet owners are being warned against using foreign-issued pet passports to circumvent post-Brexit EU travel regulations for their animals. Experts highlight the potential for severe legal, financial, and animal welfare consequences, alongside public health risks.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-pet-passport-scheme-sparks-global-warning-for-british-eu-travelers.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-thousands-get-meningitis-vaccine-as-experts-wait-to-see",
    title: "Global Health and Education Watch: Thousands get meningitis vaccine as experts wait to see",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-global-health-and-education-watch-thousands-get-meningitis-vaccine-as-experts-wa.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-something-i-ve-never-felt-since-covid-it-was-scarier",
    title: "Global Health and Education Watch: ‘Something I’ve never felt since Covid. It was scarier’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-global-health-and-education-watch-something-i-ve-never-felt-since-covid-it-was-s.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "california-state-university-challenges-federal-transgender-athlete-ban-sparking-global-education-debate",
    title: "California State University Challenges Federal Transgender Athlete Ban, Sparking Global Education Debate",
    summary:
      "The California State University system has launched a legal challenge against a federal order restricting transgender student athletes, joining a select group of institutions opposing such mandates. This pivotal case, threatening federal funding for San Jose State, underscores a global debate on equity and inclusion within higher education and sports.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-california-state-university-challenges-federal-transgender-athlete-ban-sparking-.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-sequential-deep-learning-model-for-predicting-people-with",
    title: "Global Health and Education Watch: A sequential deep learning model for predicting people with",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-global-health-and-education-watch-a-sequential-deep-learning-model-for-predictin.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "christine-mccartney-s-enduring-legacy-revolutionizing-global-public-health-microbiology",
    title: "Christine McCartney's Enduring Legacy: Revolutionizing Global Public Health Microbiology",
    summary:
      "Christine McCartney, a revered medical microbiologist, significantly advanced global public health through her tireless advocacy for integrated laboratory and epidemiological approaches. Her pioneering work in whole-genome sequencing transformed disease surveillance and response mechanisms across the world.",
    thumbnailImage: "/images/global-news/2026/2026-03-21-christine-mccartney-s-enduring-legacy-revolutionizing-global-public-health-micro.jpg",
    date: "2026-03-21",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-uncertainty-as-us-vaccine-advisory-body-faces-legal-turmoil",
    title: "Global Health Uncertainty as US Vaccine Advisory Body Faces Legal Turmoil",
    summary:
      "A recent US federal court decision has created significant ambiguity regarding the operational status of its primary vaccine advisory committee. This unprecedented legal challenge poses potential ripple effects for global public health policy and vaccine confidence worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-global-health-uncertainty-as-us-vaccine-advisory-body-faces-legal-turmoil.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-experts-consider-expanding-meningitis-vaccine-eligibility-after-kent-outbreak",
    title: "Global Health and Education Watch: Experts consider expanding meningitis vaccine eligibility after Kent outbreak",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-global-health-and-education-watch-experts-consider-expanding-meningitis-vaccine-.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-vigilance-unpacking-the-threat-of-meningitis-b",
    title: "Global Vigilance: Unpacking the Threat of Meningitis B",
    summary:
      "Meningitis B poses a serious global health challenge, particularly for infants and young adults, demanding swift recognition and intervention. Understanding its symptoms and the crucial role of vaccination is vital for prevention and mitigating its severe impact worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-global-vigilance-unpacking-the-threat-of-meningitis-b.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-meningitis-outbreak-at-the-university-of-kent-evokes",
    title: "Global Health and Education Watch: A Meningitis Outbreak at the University of Kent Evokes",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-global-health-and-education-watch-a-meningitis-outbreak-at-the-university-of-ken.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "martial-arts-icon-s-passing-highlights-global-health-and-lifelong-well-being",
    title: "Martial Arts Icon's Passing Highlights Global Health and Lifelong Well-being",
    summary:
      "The passing of martial arts legend Chuck Norris at 86 sparks a global conversation on the enduring benefits of physical discipline. His life exemplified the profound connections between martial arts, healthy aging, and holistic well-being.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-martial-arts-icon-s-passing-highlights-global-health-and-lifelong-well-being.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-administration-seeks-billions-from-harvard-over-anti-semitism-claims",
    title: "Global Health and Education Watch: Trump administration seeks billions from Harvard over anti-Semitism claims",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-global-health-and-education-watch-trump-administration-seeks-billions-from-harva.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "doxy-pep-a-global-turning-point-in-syphilis-prevention",
    title: "Doxy-PEP: A Global Turning Point in Syphilis Prevention",
    summary:
      "A pivotal study published in Nature examines the long-term public health impact of doxycycline post-exposure prophylaxis (doxy-PEP) on global syphilis transmission. This research highlights doxy-PEP's potential to significantly alter the landscape of sexually transmitted infection prevention.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-doxy-pep-a-global-turning-point-in-syphilis-prevention.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-uk-s-meningitis-outbreak-and-the-grim-legacy-of",
    title: "Global Health and Education Watch: The UK’s meningitis outbreak and the grim legacy of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-global-health-and-education-watch-the-uk-s-meningitis-outbreak-and-the-grim-lega.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-watch-kent-meningitis-outbreak-signals-broader-vigilance-against-menb",
    title: "Global Health Watch: Kent Meningitis Outbreak Signals Broader Vigilance Against MenB",
    summary:
      "Reports from Kent suggest a potential peak in a recent meningitis B outbreak, with health officials closely monitoring the situation. This development highlights the persistent global challenge of meningococcal disease and the crucial role of public health surveillance.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-global-health-watch-kent-meningitis-outbreak-signals-broader-vigilance-against-m.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-systems-brace-for-impact-as-energy-shocks-deepen",
    title: "Global Health Systems Brace for Impact as Energy Shocks Deepen",
    summary:
      "The deepening crisis in the Middle East, marked by infrastructure attacks and soaring oil prices, is creating profound global ripples. UN agencies warn of mounting pressure on health systems and supply chains worldwide, exacerbating humanitarian needs.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-global-health-systems-brace-for-impact-as-energy-shocks-deepen.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tessa-richards-obituary",
    title: "Global Health and Education Watch: Tessa Richards obituary",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-global-health-and-education-watch-tessa-richards-obituary.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "kent-meningitis-outbreak-prompts-global-health-vigilance",
    title: "Kent Meningitis Outbreak Prompts Global Health Vigilance",
    summary:
      "A severe meningitis outbreak in Kent, UK, has triggered a robust public health response, including widespread vaccination efforts. The situation highlights the critical need for global preparedness against infectious diseases, drawing comparisons and contrasts with past pandemics.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-kent-meningitis-outbreak-prompts-global-health-vigilance.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "student-freed-from-detention-vows-continued-fight-for-migrant-youth-education",
    title: "Student Freed from Detention Vows Continued Fight for Migrant Youth Education",
    summary:
      "Dylan Lopez Contreras, a New York City public school student recently freed from federal detention, has pledged to advocate for other migrants still held. His case highlights the critical global challenges faced by young migrants regarding their education and well-being.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-student-freed-from-detention-vows-continued-fight-for-migrant-youth-education.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "from-sore-ear-to-coma-meningitis-s-silent-swift-global-threat",
    title: "From Sore Ear to Coma: Meningitis's Silent, Swift Global Threat",
    summary:
      "Mark McNamee's sudden battle with meningitis, escalating from a minor ailment to an induced coma, underscores the disease's rapid progression. This global health challenge demands heightened public awareness and robust preventative measures worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-from-sore-ear-to-coma-meningitis-s-silent-swift-global-threat.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-disease-agnostic-approach-to-ensemble-learning-for-infectious-disease",
    title: "Global Health and Education Watch: A disease-agnostic approach to ensemble learning for infectious disease",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-global-health-and-education-watch-a-disease-agnostic-approach-to-ensemble-learni.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "the-global-battle-for-early-years-care-a-persistent-struggle",
    title: "The Global Battle for Early Years Care: A Persistent Struggle",
    summary:
      "Access to quality early childhood education and care is a global imperative, yet disparities persist worldwide. Recent progress in some nations highlights the ongoing advocacy needed to secure foundational learning for all children.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-the-global-battle-for-early-years-care-a-persistent-struggle.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-systems-on-brink-uk-inquiry-reveals-pandemic-vulnerabilities",
    title: "Global Health Systems on Brink: UK Inquiry Reveals Pandemic Vulnerabilities",
    summary:
      "A recent inquiry into the UK's pandemic response delivered a stark verdict on its health service, highlighting its near collapse despite staff's extraordinary efforts. These revelations underscore universal challenges faced by healthcare systems worldwide and the urgent need for enhanced global preparedness.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-global-health-systems-on-brink-uk-inquiry-reveals-pandemic-vulnerabilities.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-father-of-meningitis-victim-18-tells-of-family-s-immeasurable",
    title: "Global Health and Education Watch: Father of meningitis victim, 18, tells of family’s ‘immeasurable’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-global-health-and-education-watch-father-of-meningitis-victim-18-tells-of-family.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-independent-autism-committee-that-challenges-rfk-jr-s-overhaul-draws",
    title: "Global Health and Education Watch: Independent autism committee that challenges RFK Jr’s overhaul draws",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-global-health-and-education-watch-independent-autism-committee-that-challenges-r.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "us-student-loan-office-relocation-signals-global-education-governance-shifts",
    title: "US Student Loan Office Relocation Signals Global Education Governance Shifts",
    summary:
      "The United States is moving its federal student loan office to the Treasury Department, reflecting a broader governmental shift. This decision sparks international dialogue on centralized education policy and student financial aid management.",
    thumbnailImage: "/images/global-news/2026/2026-03-20-us-student-loan-office-relocation-signals-global-education-governance-shifts.jpg",
    date: "2026-03-20",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-healthcare-systems-faced-collapse-saved-by-worker-dedication",
    title: "Global Healthcare Systems Faced Collapse, Saved by Worker Dedication",
    summary:
      "An official inquiry into the UK's pandemic response revealed its health service was on the brink of collapse, surviving only due to the \"superhuman\" efforts of healthcare workers. This assessment underscores critical global lessons about pre-existing vulnerabilities, resource deficiencies, and the immense human cost borne by medical professionals worldwide during the crisis.",
    thumbnailImage: "/images/global-news/2026/2026-03-19-global-healthcare-systems-faced-collapse-saved-by-worker-dedication.jpg",
    date: "2026-03-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "honoring-educators-the-enduring-global-impact-of-dedicated-primary-school-teachers",
    title: "Honoring Educators: The Enduring Global Impact of Dedicated Primary School Teachers",
    summary:
      "Tributes to a beloved primary school teacher underscore the universal impact of dedicated educators worldwide. Their foundational work in early education shapes futures and strengthens communities globally.",
    thumbnailImage: "/images/global-news/2026/2026-03-19-honoring-educators-the-enduring-global-impact-of-dedicated-primary-school-teache.jpg",
    date: "2026-03-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-amid-deepening-crisis-in-palestine-girls-face-rising-risks",
    title: "Global Health and Education Watch: Amid deepening crisis in Palestine, girls face rising risks",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-19-global-health-and-education-watch-amid-deepening-crisis-in-palestine-girls-face-.jpg",
    date: "2026-03-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-from-science-to-service-overcoming-clinical-implementation-barriers-to-population",
    title: "Global Health and Education Watch: From science to service–overcoming clinical implementation barriers to population",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-19-global-health-and-education-watch-from-science-to-service-overcoming-clinical-im.jpg",
    date: "2026-03-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "uk-aid-cuts-threaten-global-health-and-education-in-poorest-nations",
    title: "UK Aid Cuts Threaten Global Health and Education in Poorest Nations",
    summary:
      "The UK government is implementing substantial cuts to its bilateral aid budget, particularly affecting African nations. This reduction, amounting to nearly £900 million by 2028-29, will severely impact critical health and education programs in some of the world's most vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-19-uk-aid-cuts-threaten-global-health-and-education-in-poorest-nations.jpg",
    date: "2026-03-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-death-toll-surpasses-1-000-in-lebanon-as-israeli-bombardment",
    title: "Global Health and Education Watch: Death toll surpasses 1,000 in Lebanon as Israeli bombardment",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-19-global-health-and-education-watch-death-toll-surpasses-1-000-in-lebanon-as-israe.jpg",
    date: "2026-03-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "the-global-crisis-of-accessible-quality-education",
    title: "The Global Crisis of Accessible, Quality Education",
    summary:
      "Families worldwide face immense pressure to find quality education for their children amidst rising costs and unequal access. This global struggle exacerbates social inequalities and impacts future generations.",
    thumbnailImage: "/images/global-news/2026/2026-03-19-the-global-crisis-of-accessible-quality-education.jpg",
    date: "2026-03-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-feasibility-of-short-term-hospital-mask-demand-forecasting-using-a",
    title: "Global Health and Education Watch: Feasibility of short-term hospital mask demand forecasting using a",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-19-global-health-and-education-watch-feasibility-of-short-term-hospital-mask-demand.jpg",
    date: "2026-03-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-patients-harmed-as-covid-pandemic-brought-nhs-close-to",
    title: "Global Health and Education Watch: Patients harmed as Covid pandemic brought NHS close to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-19-global-health-and-education-watch-patients-harmed-as-covid-pandemic-brought-nhs-.jpg",
    date: "2026-03-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-middle-east-live-19-march-civilians-bear-the-brunt",
    title: "Global Health and Education Watch: MIDDLE EAST LIVE 19 March: Civilians bear the brunt",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-19-global-health-and-education-watch-middle-east-live-19-march-civilians-bear-the-b.jpg",
    date: "2026-03-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-instagram-worse-for-mental-health-than-whatsapp-global-study",
    title: "Global Health and Education Watch: Instagram worse for mental health than WhatsApp, global study",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-19-global-health-and-education-watch-instagram-worse-for-mental-health-than-whatsap.jpg",
    date: "2026-03-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-number-of-meningitis-cases-linked-to-kent-outbreak-rises",
    title: "Global Health and Education Watch: Number of meningitis cases linked to Kent outbreak rises",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-19-global-health-and-education-watch-number-of-meningitis-cases-linked-to-kent-outb.jpg",
    date: "2026-03-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-public-health-alert-as-kent-meningitis-cases-rise",
    title: "Global Health and Education Watch: Public health alert as Kent meningitis cases rise",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-19-global-health-and-education-watch-public-health-alert-as-kent-meningitis-cases-r.jpg",
    date: "2026-03-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-f-d-a-investigates-7-e-coli-illnesses-as-raw-dairy",
    title: "Global Health and Education Watch: F.D.A. Investigates 7 E. Coli Illnesses as Raw Dairy",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-19-global-health-and-education-watch-f-d-a-investigates-7-e-coli-illnesses-as-raw-d.jpg",
    date: "2026-03-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "myanmar-s-secret-nurses-healing-a-nation-under-siege",
    title: "Myanmar's Secret Nurses: Healing a Nation Under Siege",
    summary:
      "In Myanmar, a clandestine nursing school operating in the jungle has graduated its first class of 21 students, defying military surveillance and internet blackouts. These new nurses are prepared to provide vital healthcare to displaced populations and pro-democracy fighters in areas inaccessible to government services.",
    thumbnailImage: "/images/global-news/2026/2026-03-19-myanmar-s-secret-nurses-healing-a-nation-under-siege.jpg",
    date: "2026-03-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-funerals-held-for-afghans-killed-in-pakistani-strike-on",
    title: "Global Health and Education Watch: Funerals held for Afghans killed in Pakistani strike on",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-19-global-health-and-education-watch-funerals-held-for-afghans-killed-in-pakistani-.jpg",
    date: "2026-03-19",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-florida-professors-quietly-defy-restrictions-on-race-and-gender",
    title: "Global Health and Education Watch: Florida professors quietly defy restrictions on race and gender",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-18-global-health-and-education-watch-florida-professors-quietly-defy-restrictions-o.jpg",
    date: "2026-03-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "minab-school-tragedy-who-will-answer-for-iran-s-slain-schoolchildren",
    title: "Minab School Tragedy: Who Will Answer for Iran's Slain Schoolchildren?",
    summary:
      "A recent investigation into a deadly strike on a school in Minab, Iran, indicates the attack may have been deliberate, resulting in the tragic deaths of schoolchildren. This finding ignites a critical global debate on accountability for such actions and the protection of educational institutions in conflict zones.",
    thumbnailImage: "/images/global-news/2026/2026-03-18-minab-school-tragedy-who-will-answer-for-iran-s-slain-schoolchildren.jpg",
    date: "2026-03-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-as-a-meningitis-outbreak-spreads-in-kent-uk-here-s",
    title: "Global Health and Education Watch: As a Meningitis Outbreak Spreads in Kent, UK, Here’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-18-global-health-and-education-watch-as-a-meningitis-outbreak-spreads-in-kent-uk-he.jpg",
    date: "2026-03-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-progress-in-reducing-child-deaths-slows-as-4-9-million",
    title: "Global Health and Education Watch: Progress in reducing child deaths slows as 4.9 million",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-18-global-health-and-education-watch-progress-in-reducing-child-deaths-slows-as-4-9.jpg",
    date: "2026-03-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-people-don-t-need-to-buy-a-meningitis-vaccine-streeting",
    title: "Global Health and Education Watch: People don't need to buy a meningitis vaccine, Streeting",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-18-global-health-and-education-watch-people-don-t-need-to-buy-a-meningitis-vaccine-.jpg",
    date: "2026-03-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-warning-millions-face-loss-of-vital-reproductive-care",
    title: "Global Health Warning: Millions Face Loss of Vital Reproductive Care",
    summary:
      "Millions of Americans are on the verge of losing access to critical birth control and STD screening services due to a federal funding cut. This impending crisis highlights the global vulnerability of public health systems and the devastating impact on vulnerable populations.",
    thumbnailImage: "/images/global-news/2026/2026-03-18-global-health-warning-millions-face-loss-of-vital-reproductive-care.jpg",
    date: "2026-03-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-number-of-meningitis-cases-investigated-in-kent-rises-to",
    title: "Global Health and Education Watch: Number of meningitis cases investigated in Kent rises to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-18-global-health-and-education-watch-number-of-meningitis-cases-investigated-in-ken.jpg",
    date: "2026-03-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ethiopian-study-highlights-critical-need-for-ncd-checkups",
    title: "Ethiopian Study Highlights Critical Need for NCD Checkups",
    summary:
      "A recent study in Gondar City, Ethiopia, explores awareness and factors influencing routine medical checkups for non-communicable diseases among adults. The findings offer crucial insights into improving preventive healthcare strategies in similar global settings.",
    thumbnailImage: "/images/global-news/2026/2026-03-18-ethiopian-study-highlights-critical-need-for-ncd-checkups.jpg",
    date: "2026-03-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-judge-blocks-rfk-jr-s-changes-to-us-childhood-vaccine",
    title: "Global Health and Education Watch: Judge blocks RFK Jr's changes to US childhood vaccine",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-18-global-health-and-education-watch-judge-blocks-rfk-jr-s-changes-to-us-childhood-.jpg",
    date: "2026-03-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tell-us-how-is-the-meningitis-outbreak-in-canterbury",
    title: "Global Health and Education Watch: Tell us: how is the meningitis outbreak in Canterbury",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-18-global-health-and-education-watch-tell-us-how-is-the-meningitis-outbreak-in-cant.jpg",
    date: "2026-03-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ruling-on-rfk-jr-s-vaccine-policy-changes-leaves-health",
    title: "Global Health and Education Watch: Ruling on RFK Jr.’s Vaccine Policy Changes Leaves Health",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-18-global-health-and-education-watch-ruling-on-rfk-jr-s-vaccine-policy-changes-leav.jpg",
    date: "2026-03-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-kent-meningitis-outbreak-a-timeline-of-the-health-authorities",
    title: "Global Health and Education Watch: Kent meningitis outbreak: a timeline of the health authorities’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-18-global-health-and-education-watch-kent-meningitis-outbreak-a-timeline-of-the-hea.jpg",
    date: "2026-03-18",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-kent-students-to-be-offered-targeted-meningitis-b-jabs",
    title: "Global Health and Education Watch: Kent students to be offered targeted meningitis B jabs",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-17-global-health-and-education-watch-kent-students-to-be-offered-targeted-meningiti.jpg",
    date: "2026-03-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "argentina-exits-who-amidst-global-health-governance-debate",
    title: "Argentina Exits WHO Amidst Global Health Governance Debate",
    summary:
      "Argentina has officially withdrawn from the World Health Organization, with President Javier Milei's government citing dissatisfaction with the WHO's COVID-19 pandemic response. This decision, echoing a previous US move, raises significant questions about the future of global health cooperation and multilateral institutions.",
    thumbnailImage: "/images/global-news/2026/2026-03-17-argentina-exits-who-amidst-global-health-governance-debate.jpg",
    date: "2026-03-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "aging-with-autism-a-global-healthcare-blind-spot",
    title: "Aging with Autism: A Global Healthcare Blind Spot",
    summary:
      "Older adults with autism often navigate a healthcare landscape ill-equipped to understand their specific needs, leading to significant health disparities. Recognizing and adapting systems globally is crucial for improving their well-being and quality of life.",
    thumbnailImage: "/images/global-news/2026/2026-03-17-aging-with-autism-a-global-healthcare-blind-spot.jpg",
    date: "2026-03-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-is-menb-vaccine-not-given-to-teenagers-in",
    title: "Global Health and Education Watch: Why is MenB vaccine not given to teenagers in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-17-global-health-and-education-watch-why-is-menb-vaccine-not-given-to-teenagers-in.jpg",
    date: "2026-03-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-meningitis-is-back-and-here-is-why",
    title: "Global Health and Education Watch: Meningitis is back – and here is why |",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-17-global-health-and-education-watch-meningitis-is-back-and-here-is-why.jpg",
    date: "2026-03-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-an-unprecedented-outbreak-of-meningitis-raises-alarm-in-britain",
    title: "Global Health and Education Watch: An ‘Unprecedented’ Outbreak of Meningitis Raises Alarm in Britain",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-17-global-health-and-education-watch-an-unprecedented-outbreak-of-meningitis-raises.jpg",
    date: "2026-03-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-kent-university-students-offered-meningitis-b-vaccine-amid-unprecedented",
    title: "Global Health and Education Watch: Kent university students offered meningitis B vaccine amid ‘unprecedented’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-17-global-health-and-education-watch-kent-university-students-offered-meningitis-b-.jpg",
    date: "2026-03-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "middle-east-crisis-health-systems-crumble-children-suffer-amid-regional-ripples",
    title: "Middle East Crisis: Health Systems Crumble, Children Suffer Amid Regional Ripples",
    summary:
      "The escalating crisis in the Middle East is pushing health systems to breaking point, severely impacting children and displacing hundreds of thousands. UN agencies are scaling up emergency aid amidst immense logistical challenges to address the growing humanitarian toll.",
    thumbnailImage: "/images/global-news/2026/2026-03-17-middle-east-crisis-health-systems-crumble-children-suffer-amid-regional-ripples.jpg",
    date: "2026-03-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-epstein-urged-media-mogul-to-give-up-control-of",
    title: "Global Health and Education Watch: Epstein urged media mogul to give up control of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-17-global-health-and-education-watch-epstein-urged-media-mogul-to-give-up-control-o.jpg",
    date: "2026-03-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "primary-care-modalities-impact-global-mental-health-crisis",
    title: "Primary Care Modalities Impact Global Mental Health Crisis",
    summary:
      "A new global study highlights the critical link between primary care consultation types and the demand for acute mental health services. Findings suggest that the modality of initial care significantly impacts patient pathways to specialized support.",
    thumbnailImage: "/images/global-news/2026/2026-03-17-primary-care-modalities-impact-global-mental-health-crisis.jpg",
    date: "2026-03-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-family-beyond-devastated-after-meningitis-death",
    title: "Global Health and Education Watch: Family 'beyond devastated' after meningitis death",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-17-global-health-and-education-watch-family-beyond-devastated-after-meningitis-deat.jpg",
    date: "2026-03-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-tuesday-briefing-how-the-conflict-in-iran-shattered-the",
    title: "Global Health and Education Watch: Tuesday briefing: How the conflict in Iran shattered the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-17-global-health-and-education-watch-tuesday-briefing-how-the-conflict-in-iran-shat.jpg",
    date: "2026-03-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "federal-court-rejects-vaccine-policy-shift-citing-lack-of-scientific-basis",
    title: "Federal Court Rejects Vaccine Policy Shift, Citing Lack of Scientific Basis",
    summary:
      "A federal district court has invalidated recent U.S. government vaccine policies, including revisions to childhood immunization schedules and limitations on COVID-19 shots. The ruling, stemming from a lawsuit by medical organizations, found decisions lacked a scientific foundation.",
    thumbnailImage: "/images/global-news/2026/2026-03-17-federal-court-rejects-vaccine-policy-shift-citing-lack-of-scientific-basis.jpg",
    date: "2026-03-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-preventive-cholera-vaccination-resumes-as-global-supply-reaches-critical",
    title: "Global Health and Education Watch: Preventive cholera vaccination resumes as global supply reaches critical",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-17-global-health-and-education-watch-preventive-cholera-vaccination-resumes-as-glob.jpg",
    date: "2026-03-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-telehealth-policies-must-prioritize-equity-review-reveals",
    title: "Global Telehealth Policies Must Prioritize Equity, Review Reveals",
    summary:
      "A global examination of telehealth policies, drawing insights from national reviews, underscores the critical need for equity-focused design. While virtual care offers vast potential, its benefits are often unevenly distributed, exacerbating existing health disparities without proactive policy interventions.",
    thumbnailImage: "/images/global-news/2026/2026-03-17-global-telehealth-policies-must-prioritize-equity-review-reveals.jpg",
    date: "2026-03-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-alarms-ring-data-gaps-mar-vaccine-guidance",
    title: "Global Health Alarms Ring: Data Gaps Mar Vaccine Guidance",
    summary:
      "Internal memos reveal US health officials allegedly disregarded extensive data before altering Covid vaccine recommendations for children and pregnant individuals. This incident sparks international debate on the integrity of public health guidance and the critical role of scientific evidence.",
    thumbnailImage: "/images/global-news/2026/2026-03-17-global-health-alarms-ring-data-gaps-mar-vaccine-guidance.jpg",
    date: "2026-03-17",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "eastern-india-hospital-fire-claims-ten-icu-patients-sparks-safety-review",
    title: "Eastern India Hospital Fire Claims Ten ICU Patients, Sparks Safety Review",
    summary:
      "Ten critically ill patients perished in a devastating hospital fire in eastern India, prompting an immediate investigation into the cause. The incident underscores the critical need for enhanced fire safety protocols and infrastructure upgrades in healthcare facilities worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-16-eastern-india-hospital-fire-claims-ten-icu-patients-sparks-safety-review.jpg",
    date: "2026-03-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "targeted-grants-transform-care-leavers-futures-global-study-finds",
    title: "Targeted Grants Transform Care Leavers' Futures, Global Study Finds",
    summary:
      "A new study reveals that a one-off £2,000 grant dramatically improves outcomes for young adults leaving state care. Participants were found to be less likely to experience homelessness, hospital stays, or involvement with the justice system, offering a powerful model for global social welfare.",
    thumbnailImage: "/images/global-news/2026/2026-03-16-targeted-grants-transform-care-leavers-futures-global-study-finds.jpg",
    date: "2026-03-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-youth-health-crisis-rising-ill-health-impacts-employment",
    title: "Global Youth Health Crisis: Rising Ill Health Impacts Employment",
    summary:
      "A recent study reveals a significant increase in young Britons citing ill health as a primary barrier to employment, with a 70% surge in a decade among those not in education, employment, or training. This trend underscores a growing global challenge where youth health issues increasingly impede economic participation and societal well-being.",
    thumbnailImage: "/images/global-news/2026/2026-03-16-global-youth-health-crisis-rising-ill-health-impacts-employment.jpg",
    date: "2026-03-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-kent-meningitis-outbreak-key-questions-answered",
    title: "Global Health and Education Watch: Kent meningitis outbreak: key questions answered",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-16-global-health-and-education-watch-kent-meningitis-outbreak-key-questions-answere.jpg",
    date: "2026-03-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-in-deep-red-idaho-a-republican-rift-over-schools-and",
    title: "Global Health and Education Watch: In Deep-Red Idaho, a Republican Rift Over Schools and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-16-global-health-and-education-watch-in-deep-red-idaho-a-republican-rift-over-schoo.jpg",
    date: "2026-03-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-statement-on-the-planned-hepatitis-b-birth-dose-vaccine",
    title: "Global Health and Education Watch: Statement on the planned hepatitis B birth dose vaccine",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-16-global-health-and-education-watch-statement-on-the-planned-hepatitis-b-birth-dos.jpg",
    date: "2026-03-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "kent-meningitis-outbreak-claims-second-young-life-sparks-urgent-global-health-dialogue",
    title: "Kent Meningitis Outbreak Claims Second Young Life, Sparks Urgent Global Health Dialogue",
    summary:
      "A meningitis outbreak in Kent, UK, has tragically claimed a second young life, identified as a sixth-form student, Juliette. This devastating event has triggered an urgent public health response, with long queues forming for antibiotics at the University of Kent.",
    thumbnailImage: "/images/global-news/2026/2026-03-16-kent-meningitis-outbreak-claims-second-young-life-sparks-urgent-global-health-di.jpg",
    date: "2026-03-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "kharkiv-s-children-learn-underground-a-global-beacon-of-educational-resilience-amidst-conflict",
    title: "Kharkiv's Children Learn Underground: A Global Beacon of Educational Resilience Amidst Conflict",
    summary:
      "In Ukraine's war-torn Kharkiv, 20,000 children attend schools established within the city's subway system, a vital response to ongoing Russian assaults. This innovative underground education model provides safety and continuity, highlighting global challenges in protecting children's right to learn amidst conflict.",
    thumbnailImage: "/images/global-news/2026/2026-03-16-kharkiv-s-children-learn-underground-a-global-beacon-of-educational-resilience-a.jpg",
    date: "2026-03-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-are-the-symptoms-of-meningitis-and-is-there",
    title: "Global Health and Education Watch: What are the symptoms of meningitis and is there",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-16-global-health-and-education-watch-what-are-the-symptoms-of-meningitis-and-is-the.jpg",
    date: "2026-03-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-displaced-lebanese-shelter-in-schools-stadiums-amid-israeli-attacks",
    title: "Global Health and Education Watch: Displaced Lebanese shelter in schools, stadiums amid Israeli attacks",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-16-global-health-and-education-watch-displaced-lebanese-shelter-in-schools-stadiums.jpg",
    date: "2026-03-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "middle-east-crisis-deepens-un-rushes-aid-amid-soaring-health-needs",
    title: "Middle East Crisis Deepens: UN Rushes Aid Amid Soaring Health Needs",
    summary:
      "A deepening crisis in the Middle East has pushed health systems to the brink, triggering widespread displacement and food insecurity. UN agencies are urgently scaling up aid amidst severe logistical and security hurdles to address the escalating humanitarian catastrophe.",
    thumbnailImage: "/images/global-news/2026/2026-03-16-middle-east-crisis-deepens-un-rushes-aid-amid-soaring-health-needs.jpg",
    date: "2026-03-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-confidential-report-calls-for-sweeping-changes-to-track-covid",
    title: "Global Health and Education Watch: Confidential Report Calls for Sweeping Changes to Track Covid",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-16-global-health-and-education-watch-confidential-report-calls-for-sweeping-changes.jpg",
    date: "2026-03-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "who-boosts-middle-east-health-aid-amid-escalating-regional-conflict",
    title: "WHO Boosts Middle East Health Aid Amid Escalating Regional Conflict",
    summary:
      "The UN World Health Organization has released $2 million in emergency funds to bolster health systems in Lebanon, Iraq, and Syria. This critical aid responds to escalating regional conflicts, including US and Israeli strikes against Iran and Tehran's counterstrikes, which are severely impacting vulnerable populations.",
    thumbnailImage: "/images/global-news/2026/2026-03-16-who-boosts-middle-east-health-aid-amid-escalating-regional-conflict.jpg",
    date: "2026-03-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-healthcare-strain-fuels-private-sector-reliance-watchdog-warns-of-two-tier-system",
    title: "Global Healthcare Strain Fuels Private Sector Reliance, Watchdog Warns of Two-Tier System",
    summary:
      "Across the globe, public health systems are grappling with unprecedented demand, leading many patients to seek faster treatment in the private sector. This growing trend is sparking warnings from watchdogs about the emergence of a two-tier healthcare landscape, threatening universal access.",
    thumbnailImage: "/images/global-news/2026/2026-03-16-global-healthcare-strain-fuels-private-sector-reliance-watchdog-warns-of-two-tie.jpg",
    date: "2026-03-16",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-the-guardian-view-on-post-16-qualifications-the-case-for",
    title: "Global Health and Education Watch: The Guardian view on post-16 qualifications: the case for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-global-health-and-education-watch-the-guardian-view-on-post-16-qualifications-th.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-two-dead-and-11-seriously-ill-in-meningitis-outbreak",
    title: "Global Health and Education Watch: Two dead and 11 seriously ill in meningitis outbreak",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-global-health-and-education-watch-two-dead-and-11-seriously-ill-in-meningitis-ou.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-restraining-and-sedating-dementia-patients-routine-in-hospitals-in",
    title: "Global Health and Education Watch: Restraining and sedating dementia patients ‘routine’ in hospitals in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-global-health-and-education-watch-restraining-and-sedating-dementia-patients-rou.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-i-ve-been-living-under-a-shadow-for-13-years",
    title: "Global Health and Education Watch: ‘I’ve been living under a shadow for 13 years’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-global-health-and-education-watch-i-ve-been-living-under-a-shadow-for-13-years.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "uk-regulator-faces-legal-challenge-over-public-funding-for-theological-colleges",
    title: "UK Regulator Faces Legal Challenge Over Public Funding for Theological Colleges",
    summary:
      "A university regulator in England faces legal action from the National Secular Society over its alleged failure to investigate academic freedom concerns at theological colleges. The society argues these institutions may be ineligible for public funding due to their doctrinal commitments, prompting a judicial review.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-uk-regulator-faces-legal-challenge-over-public-funding-for-theological-colleges.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-concerns-rise-over-state-guardianship-for-vulnerable-populations",
    title: "Global Concerns Rise Over State Guardianship for Vulnerable Populations",
    summary:
      "A recent policy shift empowering government attorneys to initiate guardianship for homeless individuals deemed unable to make healthcare decisions has ignited a global discussion. This move raises critical questions about individual autonomy, due process, and the ethical responsibilities of states towards their most vulnerable citizens.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-global-concerns-rise-over-state-guardianship-for-vulnerable-populations.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-security-imperiled-by-us-withdrawal-from-who",
    title: "Global Health Security Imperiled by US Withdrawal from WHO",
    summary:
      "The World Health Organization has voiced deep concern over the United States' notification of withdrawal, signaling potential setbacks for global health security. This decision is slated for review by the WHO Executive Board and the World Health Assembly in upcoming sessions.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-global-health-security-imperiled-by-us-withdrawal-from-who.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-security-faces-setback-as-united-states-initiates-who-withdrawal",
    title: "Global Health Security Faces Setback as United States Initiates WHO Withdrawal",
    summary:
      "The World Health Organization expresses regret over the United States' notification to withdraw, a decision poised to impact global health security. This significant development will be deliberated by the WHO Executive Board and the World Health Assembly in upcoming meetings.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-global-health-security-faces-setback-as-united-states-initiates-who-withdrawal.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "rebuilding-futures-global-education-s-imperative-in-crisis-zones",
    title: "Rebuilding Futures: Global Education's Imperative in Crisis Zones",
    summary:
      "Millions of children worldwide face disrupted education due to conflict and natural disasters, threatening their future. Global initiatives are urgently working to establish resilient learning environments and provide psychosocial support in these vulnerable regions.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-rebuilding-futures-global-education-s-imperative-in-crisis-zones.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "uk-eu-tuition-fee-standoff-threatens-starmer-s-european-reset",
    title: "UK-EU Tuition Fee Standoff Threatens Starmer's European Reset",
    summary:
      "A critical dispute over tuition fees for European students is jeopardizing the UK's ambitious plans to reset its relationship with the European Union. Brussels' unexpected demand for 'home' fees for its students could cost British universities an estimated £140 million annually.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-uk-eu-tuition-fee-standoff-threatens-starmer-s-european-reset.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "hustle-culture-s-global-toll-reclaiming-sustainable-well-being",
    title: "Hustle Culture's Global Toll: Reclaiming Sustainable Well-being",
    summary:
      "Across the globe, the pervasive 'hustle culture' is pushing professionals to unsustainable limits, leading to widespread burnout and mental health crises. This article explores the profound costs of this relentless drive and advocates for a global paradigm shift towards sustainable well-being and productivity.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-hustle-culture-s-global-toll-reclaiming-sustainable-well-being.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "navigating-the-global-surge-of-anxiety-across-life-s-stages",
    title: "Navigating the Global Surge of Anxiety Across Life's Stages",
    summary:
      "A global surge in anxiety is impacting individuals across all age groups, driven by widespread uncertainty. Understanding and implementing age-appropriate coping mechanisms are crucial for mental well-being worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-navigating-the-global-surge-of-anxiety-across-life-s-stages.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-alarm-colon-cancer-surges-among-under-50s-now-leading-cause-of-death",
    title: "Global Alarm: Colon Cancer Surges Among Under-50s, Now Leading Cause of Death",
    summary:
      "Colorectal cancer has become the primary cause of cancer-related deaths for individuals under 50 in the United States, a trend experts warn could reflect a broader global health crisis. Younger people are urged to take symptoms like rectal bleeding seriously, as delayed diagnosis significantly impacts outcomes.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-global-alarm-colon-cancer-surges-among-under-50s-now-leading-cause-of-death.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-colon-cancer-now-leading-cause-of-cancer-deaths-under-2",
    title: "Global Health and Education Watch: Colon cancer now leading cause of cancer deaths under",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-global-health-and-education-watch-colon-cancer-now-leading-cause-of-cancer-death.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-colon-cancer-now-leading-cause-of-cancer-deaths-under",
    title: "Global Health and Education Watch: Colon cancer now leading cause of cancer deaths under",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-global-health-and-education-watch-colon-cancer-now-leading-cause-of-cancer-death.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-alarm-colon-cancer-now-leading-cause-of-cancer-deaths-under-50",
    title: "Global Alarm: Colon Cancer Now Leading Cause of Cancer Deaths Under 50",
    summary:
      "Colorectal cancer has become the leading cause of cancer death for individuals under 50 in some regions, prompting global health experts to issue urgent warnings. Younger people are advised not to dismiss persistent symptoms and to prioritize early medical consultation for better outcomes.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-global-alarm-colon-cancer-now-leading-cause-of-cancer-deaths-under-50.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "colon-cancer-surges-among-under-50s-globally-prompting-urgent-health-warnings",
    title: "Colon Cancer Surges Among Under-50s Globally, Prompting Urgent Health Warnings",
    summary:
      "Colorectal cancer is now the leading cause of cancer death for people under 50 in the US, a trend mirrored globally. Experts are urging younger individuals not to dismiss symptoms like rectal bleeding, as delayed diagnoses are increasingly common.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-colon-cancer-surges-among-under-50s-globally-prompting-urgent-health-warnings.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "precision-strikes-on-classrooms-a-global-education-crisis",
    title: "Precision Strikes on Classrooms: A Global Education Crisis",
    summary:
      "The deliberate targeting of educational institutions in conflict zones constitutes grave war crimes, devastating communities and future generations. Urgent global action is imperative to protect students and educators, and ensure perpetrators are held accountable under international law.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-precision-strikes-on-classrooms-a-global-education-crisis.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "brazil-ex-president-hospitalized-health-politics-intersect",
    title: "Brazil Ex-President Hospitalized: Health, Politics Intersect",
    summary:
      "Brazil's former President Jair Bolsonaro has been hospitalized with a lung infection, a development linked to persistent health issues stemming from a 2018 assassination attempt. His ongoing medical challenges underscore the intricate connection between personal health and national political stability.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-brazil-ex-president-hospitalized-health-politics-intersect.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-dozens-of-medical-workers-killed-as-israel-hits-lebanon",
    title: "Global Health and Education Watch: Dozens of Medical Workers Killed as Israel Hits Lebanon",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-global-health-and-education-watch-dozens-of-medical-workers-killed-as-israel-hit.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-teacher-banned-after-sending-former-pupil-500-2",
    title: "Global Health and Education Watch: Teacher banned after sending former pupil £500",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-global-health-and-education-watch-teacher-banned-after-sending-former-pupil-500.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-teacher-banned-after-sending-former-pupil-500",
    title: "Global Health and Education Watch: Teacher banned after sending former pupil £500",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-global-health-and-education-watch-teacher-banned-after-sending-former-pupil-500.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "teacher-banned-global-call-for-upholding-educational-ethics-and-safeguarding",
    title: "Teacher Banned: Global Call for Upholding Educational Ethics and Safeguarding",
    summary:
      "A geography teacher was banned after sending £500 to a former pupil, with a panel deeming his actions 'clearly unprofessional'. This incident underscores the global importance of maintaining strict professional boundaries and robust safeguarding measures in education.",
    thumbnailImage: "/images/global-news/2026/2026-03-15-teacher-banned-global-call-for-upholding-educational-ethics-and-safeguarding.jpg",
    date: "2026-03-15",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "infant-fatality-in-london-sparks-global-dialogue-on-child-welfare",
    title: "Infant Fatality in London Sparks Global Dialogue on Child Welfare",
    summary:
      "A recent tragedy in central London, involving the death of an 18-day-old infant, has brought critical global issues of child safety and parental well-being into sharp focus. This incident underscores the urgent need for robust support systems and mental health resources for new parents across the globe.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-infant-fatality-in-london-sparks-global-dialogue-on-child-welfare.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-unesco-condemns-strike-on-minab-girls-school-they-attacked",
    title: "Global Health and Education Watch: UNESCO condemns strike on Minab girls’ school: ‘They attacked",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-global-health-and-education-watch-unesco-condemns-strike-on-minab-girls-school-t.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "israeli-strike-kills-12-healthcare-workers-escalating-crisis-in-southern-lebanon",
    title: "Israeli Strike Kills 12 Healthcare Workers, Escalating Crisis in Southern Lebanon",
    summary:
      "An Israeli strike in southern Lebanon killed 12 healthcare workers, bringing the total medical staff casualties in the region to 31 over 12 days. The attack on a primary healthcare facility in Burj Qalaouiyah has drawn widespread condemnation for violating international humanitarian laws.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-israeli-strike-kills-12-healthcare-workers-escalating-crisis-in-southern-lebanon.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "deadly-strike-on-lebanon-healthcare-facility-ignites-global-outcry",
    title: "Deadly Strike on Lebanon Healthcare Facility Ignites Global Outcry",
    summary:
      "An Israeli strike in southern Lebanon tragically claimed the lives of twelve healthcare workers at a primary facility, bringing the total medical staff casualties in the region to 31 in just twelve days. This devastating incident has drawn widespread condemnation, with the Lebanese Ministry of Health asserting a clear violation of international humanitarian laws.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-deadly-strike-on-lebanon-healthcare-facility-ignites-global-outcry.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-israeli-strike-kills-12-healthcare-workers-in-southern-lebanon",
    title: "Global Health and Education Watch: Israeli strike kills 12 healthcare workers in southern Lebanon",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-global-health-and-education-watch-israeli-strike-kills-12-healthcare-workers-in-.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-intraocular-foreign-bodies-in-asia-insights-from-the-global",
    title: "Global Health and Education Watch: Intraocular foreign bodies in Asia: insights from the Global",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-global-health-and-education-watch-intraocular-foreign-bodies-in-asia-insights-fr.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-protesters-in-cuba-attack-communist-party-office-in-rare",
    title: "Global Health and Education Watch: Protesters in Cuba attack Communist party office in rare",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-global-health-and-education-watch-protesters-in-cuba-attack-communist-party-offi.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "unilateral-foreign-policy-s-shadow-on-global-health-and-education",
    title: "Unilateral Foreign Policy's Shadow on Global Health and Education",
    summary:
      "A former US army general's characterization of a 'we should do because we can' foreign policy approach raises critical questions about global stability. This perspective has far-reaching consequences for health and education initiatives worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-unilateral-foreign-policy-s-shadow-on-global-health-and-education.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "antisemitic-attacks-target-european-jewish-schools-raising-global-education-safety-concerns",
    title: "Antisemitic Attacks Target European Jewish Schools, Raising Global Education Safety Concerns",
    summary:
      "Two recent explosions targeting Jewish institutions in the Netherlands, including a school in Amsterdam, have heightened global concerns over antisemitic violence. These incidents, though causing no physical harm, highlight the urgent need to protect educational spaces from hate-motivated attacks and ensure the safety of all students.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-antisemitic-attacks-target-european-jewish-schools-raising-global-education-safe.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "tragedy-forgiveness-and-learning-charges-dropped-in-georgia-teacher-s-prank-death",
    title: "Tragedy, Forgiveness, and Learning: Charges Dropped in Georgia Teacher's Prank Death",
    summary:
      "Homicide charges have been dropped against a Georgia teenager involved in the tragic death of a high school teacher during a community prank. The decision came after the victim's family urged authorities against further legal action, highlighting a global conversation on restorative justice and school safety.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-tragedy-forgiveness-and-learning-charges-dropped-in-georgia-teacher-s-prank-deat.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-viral-interplay-reshaping-epidemic-timelines-and-health-risks",
    title: "Global Viral Interplay: Reshaping Epidemic Timelines and Health Risks",
    summary:
      "Groundbreaking research from Nature highlights the complex interplay between SARS-CoV-2, influenza, and RSV, demonstrating their significant influence on the timing and risk of global respiratory epidemics. This understanding is crucial for refining public health strategies and enhancing preparedness against future viral threats.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-global-viral-interplay-reshaping-epidemic-timelines-and-health-risks.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ai-chatbots-raise-global-concern-over-delusional-thinking-in-vulnerable-users",
    title: "AI Chatbots Raise Global Concern Over Delusional Thinking in Vulnerable Users",
    summary:
      "A recent scientific review suggests AI chatbots could foster delusional thinking, particularly in vulnerable individuals. Experts advocate for rigorous clinical testing involving mental health professionals to mitigate potential risks.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-ai-chatbots-raise-global-concern-over-delusional-thinking-in-vulnerable-users.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "social-drivers-of-health-global-impact-on-breast-cancer-surgery-delays",
    title: "Social Drivers of Health: Global Impact on Breast Cancer Surgery Delays",
    summary:
      "Emerging global research reveals that social drivers of health significantly contribute to delays in breast cancer surgery, impacting patient outcomes. Addressing these systemic inequities is crucial for improving timely access to life-saving treatment across diverse populations.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-social-drivers-of-health-global-impact-on-breast-cancer-surgery-delays.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-this-doctor-treated-migrants-severe-injuries-at-the-us-mexico",
    title: "Global Health and Education Watch: This doctor treated migrants’ severe injuries at the US-Mexico",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-global-health-and-education-watch-this-doctor-treated-migrants-severe-injuries-a.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-out-of-the-blue-how-the-colour-of-light",
    title: "Global Health and Education Watch: Out of the blue? How the colour of light",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-global-health-and-education-watch-out-of-the-blue-how-the-colour-of-light.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "trump-administration-s-ncar-dismantling-threatens-global-health-education",
    title: "Trump Administration's NCAR Dismantling Threatens Global Health, Education",
    summary:
      "The Trump Administration's plans to dismantle NCAR, including transferring its supercomputer and space weather lab, raise alarms globally. This move threatens integrated climate research, global health preparedness, and international scientific education.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-trump-administration-s-ncar-dismantling-threatens-global-health-education.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "amsterdam-jewish-school-attack-ignites-global-concern-for-educational-safety",
    title: "Amsterdam Jewish School Attack Ignites Global Concern for Educational Safety",
    summary:
      "An explosion at a Jewish school in Amsterdam, characterized by authorities as a deliberate attack, has sparked widespread concern for the safety of educational institutions globally. The incident, which caused limited damage and no injuries, highlights the critical need to protect learning environments and vulnerable communities from targeted violence.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-amsterdam-jewish-school-attack-ignites-global-concern-for-educational-safety.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-confidential-health-records-from-uk-biobank-project-exposed-online",
    title: "Global Health and Education Watch: Confidential health records from UK BioBank project exposed online",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-global-health-and-education-watch-confidential-health-records-from-uk-biobank-pr.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-new-horizons-the-invisible-power-of-longevity-homes",
    title: "Global Health and Education Watch: New horizons: the invisible power of longevity homes",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-global-health-and-education-watch-new-horizons-the-invisible-power-of-longevity-.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-education-systems-grapple-with-exam-marking-accuracy-concerns",
    title: "Global Education Systems Grapple with Exam Marking Accuracy Concerns",
    summary:
      "An educational institution recently uncovered numerous errors in GCSE English test markings, raising significant concerns about the reliability of high-stakes examinations. This incident underscores a critical global challenge in ensuring fairness and accuracy in student assessments.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-global-education-systems-grapple-with-exam-marking-accuracy-concerns.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "investigation-launched-into-deadly-strike-on-iranian-school",
    title: "Investigation Launched into Deadly Strike on Iranian School",
    summary:
      "An independent investigation has been initiated following a deadly strike on an Iranian school, announced by official sources. The incident has drawn international condemnation, highlighting the urgent need for accountability and protection of educational facilities in conflict zones.",
    thumbnailImage: "/images/global-news/2026/2026-03-14-investigation-launched-into-deadly-strike-on-iranian-school.jpg",
    date: "2026-03-14",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-king-charles-concerned-about-alberta-separatist-movement-first-nation",
    title: "Global Health and Education Watch: King Charles concerned about Alberta separatist movement, First Nation",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-global-health-and-education-watch-king-charles-concerned-about-alberta-separatis.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ai-toys-need-strict-global-oversight-for-child-safety",
    title: "AI Toys Need Strict Global Oversight for Child Safety",
    summary:
      "New research from the University of Cambridge reveals AI-powered toys can misinterpret children's emotions, leading to inappropriate responses that could impact development. Experts are calling for immediate, tighter global regulations to safeguard children interacting with these increasingly sophisticated devices.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-ai-toys-need-strict-global-oversight-for-child-safety.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "sudan-conflict-escalates-civilian-health-education-devastated-by-drone-warfare",
    title: "Sudan Conflict Escalates: Civilian Health, Education Devastated by Drone Warfare",
    summary:
      "A recent drone attack on a market in Sudan killed 11, underscoring a rapidly escalating conflict where civilian casualties are mounting. Over 200 non-combatants have died in recent days, with critical infrastructure like schools and hospitals increasingly targeted.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-sudan-conflict-escalates-civilian-health-education-devastated-by-drone-warfare.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "africa-s-health-sovereignty-at-risk-us-biomedical-engagements-spark-imperialism-fears",
    title: "Africa's Health Sovereignty at Risk: US Biomedical Engagements Spark Imperialism Fears",
    summary:
      "New US health deals across Africa are raising significant concerns among local experts and civil society. Critics fear these initiatives could perpetuate biomedical extractivism, echoing historical patterns of unequal partnerships and resource exploitation.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-africa-s-health-sovereignty-at-risk-us-biomedical-engagements-spark-imperialism-.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-alarm-plasma-donation-safety-under-scrutiny-after-tragic-deaths",
    title: "Global Alarm: Plasma Donation Safety Under Scrutiny After Tragic Deaths",
    summary:
      "Recent deaths linked to frequent plasma donations in Canadian for-profit clinics have raised significant global concerns about donor safety. This has prompted an urgent re-evaluation of regulatory standards and ethical practices across the international plasma supply chain.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-global-alarm-plasma-donation-safety-under-scrutiny-after-tragic-deaths.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-trump-calls-iran-leaders-deranged-scumbags-as-middle-east",
    title: "Global Health and Education Watch: Trump calls Iran leaders ‘deranged scumbags’ as Middle East",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-global-health-and-education-watch-trump-calls-iran-leaders-deranged-scumbags-as-.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-conflict-s-echoes-trauma-education-and-community-safety",
    title: "Global Conflict's Echoes: Trauma, Education, and Community Safety",
    summary:
      "A recent synagogue attack in Michigan, driven by the perpetrator's profound loss in a global conflict, underscores the critical link between international hostilities and community well-being. This incident highlights the urgent need for robust mental health support and peace education to address trauma and foster resilience globally.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-global-conflict-s-echoes-trauma-education-and-community-safety.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "education-secretary-alleges-lawyer-exploitation-in-special-needs-system",
    title: "Education Secretary Alleges Lawyer Exploitation in Special Needs System",
    summary:
      "A top education official has sparked a global conversation by accusing legal professionals of profiting from the struggles of parents seeking special needs support. This highlights the urgent need for equitable and less confrontational systems for children with disabilities worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-education-secretary-alleges-lawyer-exploitation-in-special-needs-system.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-alert-policies-threaten-surge-in-lung-disease-and-premature-death",
    title: "Global Health Alert: Policies Threaten Surge in Lung Disease and Premature Death",
    summary:
      "Experts predict a concerning rise in lung disease and premature mortality, stemming from policy changes impacting healthcare, environmental protection, and public health. This comprehensive analysis highlights the interconnectedness of policy decisions and global respiratory health outcomes.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-global-health-alert-policies-threaten-surge-in-lung-disease-and-premature-death.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-initiatives-bridge-care-gap-for-inmate-reintegration",
    title: "Global Health Initiatives Bridge Care Gap for Inmate Reintegration",
    summary:
      "Across the globe, new financial mechanisms are emerging to support comprehensive healthcare for individuals transitioning from incarceration back into society. This strategic investment aims to improve public health outcomes and reduce recidivism by ensuring continuity of care.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-global-health-initiatives-bridge-care-gap-for-inmate-reintegration.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-implications-of-violence-in-sacred-and-educational-spaces",
    title: "Global Implications of Violence in Sacred and Educational Spaces",
    summary:
      "Attacks on a Michigan synagogue and a Virginia university highlight a global pattern of violence impacting public and educational environments. This necessitates a comprehensive international focus on mental health, security, and educational strategies for prevention.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-global-implications-of-violence-in-sacred-and-educational-spaces.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-should-schools-respond-in-emergency-situations",
    title: "Global Health and Education Watch: How should schools respond in emergency situations?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-global-health-and-education-watch-how-should-schools-respond-in-emergency-situat.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-it-s-like-a-giant-book-club-how-schools-are",
    title: "Global Health and Education Watch: ‘It’s like a giant book club’: how schools are",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-global-health-and-education-watch-it-s-like-a-giant-book-club-how-schools-are.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-it-has-changed-my-life-how-a-dose-of",
    title: "Global Health and Education Watch: ‘It has changed my life’: How a dose of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-global-health-and-education-watch-it-has-changed-my-life-how-a-dose-of.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "middle-east-crisis-a-global-health-and-education-catastrophe-unfolding",
    title: "Middle East Crisis: A Global Health and Education Catastrophe Unfolding",
    summary:
      "Escalating conflicts across the Middle East are causing a profound global health and education crisis, marked by mass displacement and critical service disruptions. Millions face dire conditions, with children and vulnerable families bearing the brunt of a generational catastrophe.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-middle-east-crisis-a-global-health-and-education-catastrophe-unfolding.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-friday-briefing-the-legacy-of-the-dunblane-massacre-30",
    title: "Global Health and Education Watch: Friday briefing: The legacy of the Dunblane massacre, 30",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-global-health-and-education-watch-friday-briefing-the-legacy-of-the-dunblane-mas.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-third-of-americans-have-cut-spending-or-borrowed",
    title: "Global Health and Education Watch: A Third of Americans Have Cut Spending or Borrowed",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-global-health-and-education-watch-a-third-of-americans-have-cut-spending-or-borr.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-joint-statement-on-the-renewed-quadripartite-memorandum-of-understanding",
    title: "Global Health and Education Watch: Joint statement on the renewed Quadripartite Memorandum of Understanding",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-global-health-and-education-watch-joint-statement-on-the-renewed-quadripartite-m.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-nhs-tracker-are-hospital-waiting-times-improving-near",
    title: "Global Health and Education Watch: NHS tracker - are hospital waiting times improving near",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-global-health-and-education-watch-nhs-tracker-are-hospital-waiting-times-improvi.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-short-tempers-and-legal-threats-uk-teachers-report-rise",
    title: "Global Health and Education Watch: Short tempers and legal threats: UK teachers report rise",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-13-global-health-and-education-watch-short-tempers-and-legal-threats-uk-teachers-re.jpg",
    date: "2026-03-13",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-reckoning-social-media-addiction-trial-signals-new-era-for-tech-accountability",
    title: "Global Reckoning: Social Media Addiction Trial Signals New Era for Tech Accountability",
    summary:
      "A pivotal US jury trial examining the alleged addictive design of major social media platforms recently concluded, sparking global conversations about tech company responsibility. This case, seen as a bellwether, addresses claims that platforms intentionally foster addiction, leading to significant mental health challenges among young users worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-global-reckoning-social-media-addiction-trial-signals-new-era-for-tech-accountab.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-fatal-shooting-at-virginia-university-investigated-as-act-of",
    title: "Global Health and Education Watch: Fatal shooting at Virginia university investigated as act of",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-global-health-and-education-watch-fatal-shooting-at-virginia-university-investig.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-change-energy-use-to-reduce-pollution-and-protect-our",
    title: "Global Health and Education Watch: Change energy use to reduce pollution and protect our",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-global-health-and-education-watch-change-energy-use-to-reduce-pollution-and-prot.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-gunman-one-victim-dead-in-shooting-at-old-dominion",
    title: "Global Health and Education Watch: Gunman, one victim dead in shooting at Old Dominion",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-global-health-and-education-watch-gunman-one-victim-dead-in-shooting-at-old-domi.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "devastating-strike-on-iranian-school-ignites-global-outcry-for-civilian-protection",
    title: "Devastating Strike on Iranian School Ignites Global Outcry for Civilian Protection",
    summary:
      "A recent U.S. missile strike tragically impacted a school in Iran, resulting in the deaths of 175 individuals. This devastating event has sparked widespread international condemnation and intensified discussions on the protection of educational facilities during conflict.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-devastating-strike-on-iranian-school-ignites-global-outcry-for-civilian-protecti.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-gps-tell-bbc-they-ve-never-refused-sick-note-for",
    title: "Global Health and Education Watch: GPs tell BBC they've NEVER refused sick note for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-global-health-and-education-watch-gps-tell-bbc-they-ve-never-refused-sick-note-f.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-call-half-of-cataract-blindness-sufferers-await-sight-restoring-surgery",
    title: "Global Call: Half of Cataract Blindness Sufferers Await Sight-Restoring Surgery",
    summary:
      "Millions globally endure preventable blindness due to cataracts, with half lacking access to life-changing surgery. The World Health Organization is pressing countries to accelerate efforts, highlighting the procedure as a highly effective and affordable solution.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-global-call-half-of-cataract-blindness-sufferers-await-sight-restoring-surgery.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-energy-crisis-threatens-health-education-progress",
    title: "Global Energy Crisis Threatens Health, Education Progress",
    summary:
      "An escalating Middle East conflict is causing the largest oil supply disruption in history, threatening global health and education systems. Soaring energy costs and economic instability risk reversing decades of progress, especially for vulnerable populations.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-global-energy-crisis-threatens-health-education-progress.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "china-s-new-law-mandates-mandarin-eroding-minority-language-education",
    title: "China's New Law Mandates Mandarin, Eroding Minority Language Education",
    summary:
      "China's National People's Congress is poised to approve a new \"ethnic unity\" law that will fundamentally alter the linguistic landscape of its education system. This legislation prioritizes Mandarin instruction, effectively sidelining minority languages such as Tibetan, Uyghur, and Mongolian across schools nationwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-china-s-new-law-mandates-mandarin-eroding-minority-language-education.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "trauma-surgeon-s-global-witness-hope-amidst-unimaginable-horror",
    title: "Trauma Surgeon's Global Witness: Hope Amidst Unimaginable Horror",
    summary:
      "Dr. Shehan Hettiaratchy, a leading trauma surgeon, shares his profound insights from treating victims of terror attacks and conflict zones like Ukraine and Gaza. Despite witnessing immense suffering, he maintains an unwavering belief in humanity's capacity for optimism and selfless action.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-trauma-surgeon-s-global-witness-hope-amidst-unimaginable-horror.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-student-mental-health-crisis-social-pressure-s-toll-in-universities",
    title: "Global Student Mental Health Crisis: Social Pressure's Toll in Universities",
    summary:
      "A recent study in Karachi, Pakistan, illuminates the critical connection between social pressure and mental health challenges among university students. Its findings underscore a global imperative for enhanced support systems and policy interventions in higher education.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-global-student-mental-health-crisis-social-pressure-s-toll-in-universities.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-her-lab-worked-to-future-proof-fruits-and-vegetables",
    title: "Global Health and Education Watch: Her Lab Worked to Future-Proof Fruits and Vegetables",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-global-health-and-education-watch-her-lab-worked-to-future-proof-fruits-and-vege.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "unraveling-nicotine-s-grip-understanding-addiction-and-effective-quitting-strategies",
    title: "Unraveling Nicotine's Grip: Understanding Addiction and Effective Quitting Strategies",
    summary:
      "Smoking's potent addictiveness stems from nicotine's rapid neurological impact, creating a powerful cycle of dependence. Effective quitting strategies combine pharmacological support with robust behavioral and psychological interventions.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-unraveling-nicotine-s-grip-understanding-addiction-and-effective-quitting-strate.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-surge-in-mental-health-sick-leave-challenges-healthcare-systems",
    title: "Global Surge in Mental Health Sick Leave Challenges Healthcare Systems",
    summary:
      "A significant global increase in medical certificates issued for mental health concerns is putting unprecedented strain on primary healthcare systems worldwide. This trend highlights a critical need for enhanced mental health support and proactive workplace well-being strategies.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-global-surge-in-mental-health-sick-leave-challenges-healthcare-systems.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-instability-ai-risks-a-looming-crisis-for-health-and-education",
    title: "Global Instability, AI Risks: A Looming Crisis for Health and Education",
    summary:
      "Geopolitical conflicts and economic volatility are diverting crucial resources from global health and education initiatives. Simultaneously, the unchecked proliferation of AI presents new ethical dilemmas and risks to societal well-being.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-global-instability-ai-risks-a-looming-crisis-for-health-and-education.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-bombed-the-iranian-girls-school-killing-more-than",
    title: "Global Health and Education Watch: Who bombed the Iranian girls’ school, killing more than",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-global-health-and-education-watch-who-bombed-the-iranian-girls-school-killing-mo.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-call-for-child-protection-brown-advocates-international-court-for-war-crimes",
    title: "Global Call for Child Protection: Brown Advocates International Court for War Crimes",
    summary:
      "Former UK Prime Minister Gordon Brown has advocated for establishing an international criminal court specifically for crimes against children, asserting that schools must hold the same protected status as hospitals under global law. This urgent appeal follows a devastating missile attack on an Iranian school that resulted in the deaths of 168 schoolgirls, highlighting the urgent need for enhanced child protection in conflict zones.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-global-call-for-child-protection-brown-advocates-international-court-for-war-cri.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-sleep-exercise-hydrate-do-we-really-need-to",
    title: "Global Health and Education Watch: Sleep, exercise, hydrate - do we really need to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-global-health-and-education-watch-sleep-exercise-hydrate-do-we-really-need-to.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-two-people-die-after-paid-plasma-donation-at-clinics",
    title: "Global Health and Education Watch: Two People Die After Paid Plasma Donation at Clinics",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-global-health-and-education-watch-two-people-die-after-paid-plasma-donation-at-c.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-if-u-s-colleges-are-dying-why-are-students-applying",
    title: "Global Health and Education Watch: If U.S. Colleges Are Dying, Why Are Students Applying?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-12-global-health-and-education-watch-if-u-s-colleges-are-dying-why-are-students-app.jpg",
    date: "2026-03-12",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-women-receiving-worse-treatment-for-back-and-neck-pain",
    title: "Global Health and Education Watch: Women receiving worse treatment for back and neck pain",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-global-health-and-education-watch-women-receiving-worse-treatment-for-back-and-n.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-generational-divide-isn-t-as-wide-as-you-think",
    title: "Global Health and Education Watch: Generational divide isn’t as wide as you think |",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-global-health-and-education-watch-generational-divide-isn-t-as-wide-as-you-think.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "lebanese-families-seek-school-sanctuary-amidst-border-conflict",
    title: "Lebanese Families Seek School Sanctuary Amidst Border Conflict",
    summary:
      "Families from southern Lebanon have sought shelter in a Sidon school, fleeing intense cross-border hostilities. This displacement underscores the urgent need for humanitarian aid and protection for civilians in conflict zones.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-lebanese-families-seek-school-sanctuary-amidst-border-conflict.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-conflict-deepens-health-crisis-across-middle-east-who-says",
    title: "Global Health and Education Watch: Conflict deepens health crisis across Middle East, WHO says",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-global-health-and-education-watch-conflict-deepens-health-crisis-across-middle-e.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "sudan-drone-strike-kills-17-devastates-school-and-health-centre",
    title: "Sudan Drone Strike Kills 17, Devastates School and Health Centre",
    summary:
      "A drone strike in Sudan's White Nile province killed at least 17 people, mostly schoolgirls, and wounded ten others, hitting a secondary school and a healthcare centre. The attack underscores the devastating impact of the ongoing three-year conflict on vital civilian infrastructure and fundamental human rights.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-sudan-drone-strike-kills-17-devastates-school-and-health-centre.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-clinics-redefine-care-amid-financial-strain-embrace-aesthetics",
    title: "Global Health Clinics Redefine Care Amid Financial Strain, Embrace Aesthetics",
    summary:
      "Across the globe, healthcare institutions are exploring innovative revenue streams, including aesthetic services, to combat financial pressures. This strategic shift aims to maintain essential care access but raises critical questions about mission and equity.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-global-health-clinics-redefine-care-amid-financial-strain-embrace-aesthetics.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "denmark-achieves-landmark-eliminates-mother-to-child-hiv-and-syphilis-transmission",
    title: "Denmark Achieves Landmark: Eliminates Mother-to-Child HIV and Syphilis Transmission",
    summary:
      "Denmark has been certified by the World Health Organization for eliminating mother-to-child transmission of HIV and syphilis, marking a significant global health milestone. This achievement underscores the power of sustained public health commitment and integrated healthcare systems in protecting the most vulnerable.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-denmark-achieves-landmark-eliminates-mother-to-child-hiv-and-syphilis-transmissi.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-experts-fear-unethical-vaccine-trial-in-africa-is-prototype",
    title: "Global Health and Education Watch: Experts fear ‘unethical’ vaccine trial in Africa is ‘prototype’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-global-health-and-education-watch-experts-fear-unethical-vaccine-trial-in-africa.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-first-v-level-subjects-announced-with-aim-to-prepare-for",
    title: "Global Health and Education Watch: First V-level subjects announced with aim to 'prepare for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-global-health-and-education-watch-first-v-level-subjects-announced-with-aim-to-p.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "iran-war-devastates-health-infrastructure-civilian-lives",
    title: "Iran War Devastates Health Infrastructure, Civilian Lives",
    summary:
      "Recent conflict in Iran has severely impacted civilian populations and critical healthcare infrastructure. The Iranian Red Crescent reports nearly 20,000 civilian buildings and 77 healthcare facilities damaged or destroyed, exacerbating a growing humanitarian crisis.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-iran-war-devastates-health-infrastructure-civilian-lives.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-university-tuition-fees-system-is-a-mess-says-clegg",
    title: "Global Health and Education Watch: University tuition fees system is a 'mess', says Clegg",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-global-health-and-education-watch-university-tuition-fees-system-is-a-mess-says-.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ergonomics-key-to-post-conflict-workplace-safety-in-kurdistan",
    title: "Ergonomics Key to Post-Conflict Workplace Safety in Kurdistan",
    summary:
      "Research from the Kurdistan Region of Iraq demonstrates the effectiveness of ILO ergonomic checkpoints in enhancing workplace health and safety within post-conflict small and medium-sized enterprises. This initiative offers a practical framework for improving working conditions and fostering sustainable economic recovery globally.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-ergonomics-key-to-post-conflict-workplace-safety-in-kurdistan.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "navigating-the-infodemic-pediatricians-confront-global-vaccine-misinformation",
    title: "Navigating the Infodemic: Pediatricians Confront Global Vaccine Misinformation",
    summary:
      "Pediatricians globally are on the front lines, combating a surge of vaccine misinformation to protect children's health. They employ empathetic communication and evidence-based strategies to navigate parental mistrust and confusion.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-navigating-the-infodemic-pediatricians-confront-global-vaccine-misinformation.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "immersive-journalism-unveiling-global-education-s-complexities",
    title: "Immersive Journalism: Unveiling Global Education's Complexities",
    summary:
      "Covering vast education systems demands immersive, on-the-ground reporting to capture their intricate realities. This approach is crucial for understanding global educational challenges and informing communities effectively.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-immersive-journalism-unveiling-global-education-s-complexities.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-five-killed-in-strikes-on-lebanon-health-ministry-reports",
    title: "Global Health and Education Watch: Five killed in strikes on Lebanon, health ministry reports",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-global-health-and-education-watch-five-killed-in-strikes-on-lebanon-health-minis.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-middle-east-crisis-live-new-supreme-leader-safe-despite",
    title: "Global Health and Education Watch: Middle East crisis live: New supreme leader ‘safe’ despite",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-global-health-and-education-watch-middle-east-crisis-live-new-supreme-leader-saf.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "india-s-elite-tech-schools-grapple-with-tragic-student-suicide-crisis",
    title: "India's Elite Tech Schools Grapple with Tragic Student Suicide Crisis",
    summary:
      "India's prestigious engineering institutions face a severe mental health crisis, with nearly 160 student suicides recorded over the past two decades. This alarming trend highlights the urgent need for comprehensive mental health support and systemic changes in elite educational environments globally.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-india-s-elite-tech-schools-grapple-with-tragic-student-suicide-crisis.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-commitment-drives-pandemic-accord-negotiations-forward",
    title: "Global Commitment Drives Pandemic Accord Negotiations Forward",
    summary:
      "Member States of the World Health Organization recently concluded a pivotal round of negotiations on the Pathogen Access and Benefit Sharing (PABS) annex to the WHO Pandemic Agreement. This crucial component aims to ensure equitable access to health tools during future global health crises.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-global-commitment-drives-pandemic-accord-negotiations-forward.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-families-welcome-appointment-of-donna-ockenden-to-leeds-maternity",
    title: "Global Health and Education Watch: Families welcome appointment of Donna Ockenden to Leeds maternity",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-global-health-and-education-watch-families-welcome-appointment-of-donna-ockenden.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-coverage-and-associated-factors-of-inactivated-polio-vaccine-uptake",
    title: "Global Health and Education Watch: Coverage and associated factors of inactivated polio vaccine uptake",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-11-global-health-and-education-watch-coverage-and-associated-factors-of-inactivated.jpg",
    date: "2026-03-11",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-cancer-haunts-neighbors-of-canada-s-oil-sands-wastelands",
    title: "Global Health and Education Watch: Cancer Haunts Neighbors of Canada’s Oil Sands Wastelands",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-global-health-and-education-watch-cancer-haunts-neighbors-of-canada-s-oil-sands-.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-sobering-preview-extreme-heat-now-affects-one-in",
    title: "Global Health and Education Watch: ‘A sobering preview’: extreme heat now affects one in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-global-health-and-education-watch-a-sobering-preview-extreme-heat-now-affects-on.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-la-county-reports-first-drop-in-deaths-of-unhoused",
    title: "Global Health and Education Watch: LA county reports first drop in deaths of unhoused",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-global-health-and-education-watch-la-county-reports-first-drop-in-deaths-of-unho.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "who-warns-black-rain-in-iran-poses-severe-global-health-risks",
    title: "WHO Warns: 'Black Rain' in Iran Poses Severe Global Health Risks",
    summary:
      "The World Health Organization has issued a stark warning regarding the severe health risks posed by 'black rain' in Iran, following recent strikes on the nation's oil facilities. This environmental fallout threatens immediate and long-term public health, impacting respiratory systems, water quality, and agricultural land.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-who-warns-black-rain-in-iran-poses-severe-global-health-risks.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-rfk-jr-s-pick-to-review-covid-vaccines-authored-misleading",
    title: "Global Health and Education Watch: RFK Jr’s pick to review Covid vaccines authored misleading",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-global-health-and-education-watch-rfk-jr-s-pick-to-review-covid-vaccines-authore.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "nepal-s-silent-epidemic-alzheimer-s-disease-surges-unseen",
    title: "Nepal's Silent Epidemic: Alzheimer's Disease Surges Unseen",
    summary:
      "Alzheimer's disease is rapidly increasing in Nepal, often misdiagnosed or overlooked due to lack of awareness and resources. This silent epidemic places immense strain on families and the healthcare system, necessitating immediate national focus and support.",
    thumbnailImage: "/images/nepal-news/2026/2026-03-10-nepal-s-silent-epidemic-alzheimer-s-disease-surges-unseen.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Nepal Desk",
    featured: true,
    type: "News",
  },
  {
    slug: "global-education-confronts-ai-safeguarding-critical-thinking",
    title: "Global Education Confronts AI: Safeguarding Critical Thinking",
    summary:
      "The rapid integration of AI into education challenges traditional learning, prompting global educators to innovate. They are developing new methods to foster critical thinking and human-centered skills amidst technological disruption.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-global-education-confronts-ai-safeguarding-critical-thinking.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-conflict-s-shadow-protecting-health-and-education-amidst-escalation",
    title: "Global Conflict's Shadow: Protecting Health and Education Amidst Escalation",
    summary:
      "Recent warnings of intensified military actions highlight the devastating impact of conflict on essential services. Protecting schools and hospitals remains paramount for global health and educational stability.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-global-conflict-s-shadow-protecting-health-and-education-amidst-escalation.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-culture-at-columbia-shielded-sexual-assault-by-physician-report",
    title: "Global Health and Education Watch: Culture at Columbia Shielded Sexual Assault by Physician, Report",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-global-health-and-education-watch-culture-at-columbia-shielded-sexual-assault-by.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-prevent-pandemics-through-one-health-commitments",
    title: "Global Health and Education Watch: Prevent pandemics through One Health commitments",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-global-health-and-education-watch-prevent-pandemics-through-one-health-commitmen.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-maternity-inquiry-chair-named-in-government-u-turn",
    title: "Global Health and Education Watch: Maternity inquiry chair named in government U-turn",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-global-health-and-education-watch-maternity-inquiry-chair-named-in-government-u-.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-pakistan-orders-sweeping-austerity-measures-as-iran-war-triggers",
    title: "Global Health and Education Watch: Pakistan orders sweeping austerity measures as Iran war triggers",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-global-health-and-education-watch-pakistan-orders-sweeping-austerity-measures-as.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "scrutiny-mounts-over-vaccine-advisor-s-research-amid-global-health-concerns",
    title: "Scrutiny Mounts Over Vaccine Advisor's Research Amid Global Health Concerns",
    summary:
      "An MIT professor appointed to a key US vaccine advisory committee faces intense scrutiny over the scientific standards of his Covid-19 vaccine research. Public health experts fear his involvement could undermine evidence-based recommendations and global vaccine confidence.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-scrutiny-mounts-over-vaccine-advisor-s-research-amid-global-health-concerns.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "measles-outbreak-in-dhorpatan-nepal-s-health-ministry-mobilizes-for-urgent-vaccination-drive",
    title: "Measles Outbreak in Dhorpatan: Nepal's Health Ministry Mobilizes for Urgent Vaccination Drive",
    summary:
      "A measles outbreak has been confirmed in Dhorpatan Municipality, Baglung, prompting the Ministry of Health and Population to initiate immediate vaccination preparations. This rapid response aims to contain the highly contagious disease and safeguard public health, particularly among children in the remote region.",
    thumbnailImage: "/images/nepal-news/2026/2026-03-10-measles-outbreak-in-dhorpatan-nepal-s-health-ministry-mobilizes-for-urgent-vacci.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Nepal Desk",
    featured: true,
    type: "News",
  },
  {
    slug: "pioneers-of-covid-vaccine-depart-biontech-for-new-mrna-frontier",
    title: "Pioneers of COVID Vaccine Depart BioNTech for New mRNA Frontier",
    summary:
      "The visionary co-founders of BioNTech, Uğur Şahin and Özlem Türeci, are stepping down from the German pharmaceutical giant. They plan to establish a new mRNA-focused enterprise, aiming to push the boundaries of this transformative technology further.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-pioneers-of-covid-vaccine-depart-biontech-for-new-mrna-frontier.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "us-court-battle-looms-over-demand-for-jewish-student-staff-list-at-penn",
    title: "US Court Battle Looms Over Demand for Jewish Student, Staff List at Penn",
    summary:
      "A US administration has initiated legal proceedings against the University of Pennsylvania for its refusal to disclose information about Jewish students and staff, citing an antisemitism inquiry. This case sparks significant debate over data privacy, academic autonomy, and the potential for discriminatory targeting within educational institutions globally.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-us-court-battle-looms-over-demand-for-jewish-student-staff-list-at-penn.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-john-oliver-on-the-demise-of-usaid-what-this",
    title: "Global Health and Education Watch: John Oliver on the demise of USAID: ‘What this",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-global-health-and-education-watch-john-oliver-on-the-demise-of-usaid-what-this.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-inequity-a-crisis-of-unjust-disparities",
    title: "Global Health Inequity: A Crisis of Unjust Disparities",
    summary:
      "Profound health inequities persist globally, with vast disparities in healthy life expectancy between different communities. Governments often prioritize short-term fixes over comprehensive strategies addressing the root social and commercial determinants of ill-health.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-global-health-inequity-a-crisis-of-unjust-disparities.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-schools-grapple-with-screen-time-a-growing-health-and-education-debate",
    title: "Global Schools Grapple with Screen Time: A Growing Health and Education Debate",
    summary:
      "A global debate is intensifying over the pervasive use of digital screens in educational settings, driven by increasing parental concern and scientific evidence of potential harm to children. Schools worldwide are now re-evaluating their technology integration strategies amidst calls for a more balanced approach to learning.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-global-schools-grapple-with-screen-time-a-growing-health-and-education-debate.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "medical-students-face-heightened-suicide-risk-from-gambling-disorder",
    title: "Medical Students Face Heightened Suicide Risk from Gambling Disorder",
    summary:
      "A recent study highlights gambling disorder as a significant risk factor for suicidal ideation among medical students worldwide. The findings underscore an urgent need for targeted mental health interventions within medical education systems.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-medical-students-face-heightened-suicide-risk-from-gambling-disorder.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "who-launches-urgent-2026-appeal-for-global-health-crises",
    title: "WHO Launches Urgent 2026 Appeal for Global Health Crises",
    summary:
      "The World Health Organization has initiated its 2026 global appeal to secure vital healthcare for millions affected by humanitarian crises and conflicts. This urgent funding aims to bolster health systems and deliver essential services in dire circumstances worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-who-launches-urgent-2026-appeal-for-global-health-crises.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "dhorpatan-measles-outbreak-a-stark-reminder-of-nepal-s-immunization-challenges",
    title: "Dhorpatan Measles Outbreak: A Stark Reminder of Nepal's Immunization Challenges",
    summary:
      "A recent measles outbreak in Dhorpatan, Baglung, has infected eighteen individuals, underscoring persistent challenges in Nepal's immunization efforts. This incident in a remote mountainous region calls for intensified public health interventions and strengthened vaccine delivery systems.",
    thumbnailImage: "/images/nepal-news/2026/2026-03-10-dhorpatan-measles-outbreak-a-stark-reminder-of-nepal-s-immunization-challenges.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Nepal Desk",
    featured: true,
    type: "News",
  },
  {
    slug: "martyn-butler-s-enduring-legacy-pioneering-hiv-aids-advocacy",
    title: "Martyn Butler's Enduring Legacy: Pioneering HIV/AIDS Advocacy",
    summary:
      "Martyn Butler, a pivotal figure in the early fight against HIV/AIDS, co-founded the Terrence Higgins Trust in 1982. His courageous advocacy laid the groundwork for Europe's first and Britain's leading HIV charity, profoundly impacting global health.",
    thumbnailImage: "/images/global-news/2026/2026-03-10-martyn-butler-s-enduring-legacy-pioneering-hiv-aids-advocacy.jpg",
    date: "2026-03-10",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-ohio-state-university-president-resigns-over-inappropriate-relationship",
    title: "Global Health and Education Watch: Ohio State University president resigns over ‘inappropriate relationship’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-09-global-health-and-education-watch-ohio-state-university-president-resigns-over-i.jpg",
    date: "2026-03-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-cancer-survival-rises-amidst-stark-health-equity-challenges",
    title: "Global Cancer Survival Rises Amidst Stark Health Equity Challenges",
    summary:
      "Global cancer survival rates have significantly improved over recent decades due to medical breakthroughs and public health initiatives. However, persistent inequalities in access to diagnostics and treatment mean these advancements do not reach everyone, highlighting a critical global health equity challenge.",
    thumbnailImage: "/images/global-news/2026/2026-03-09-global-cancer-survival-rises-amidst-stark-health-equity-challenges.jpg",
    date: "2026-03-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-colman-mccarthy-87-journalist-who-waged-peace-in-the",
    title: "Global Health and Education Watch: Colman McCarthy, 87, Journalist Who Waged Peace in the",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-09-global-health-and-education-watch-colman-mccarthy-87-journalist-who-waged-peace-.jpg",
    date: "2026-03-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "us-senators-urge-probe-into-deadly-attack-on-iranian-girls-school",
    title: "US Senators Urge Probe into Deadly Attack on Iranian Girls' School",
    summary:
      "A devastating bombing at a girls' school in Minab, Iran, resulted in at least 170 fatalities, prompting strong international condemnation. Leading US Democrats are now calling for a comprehensive and impartial investigation into the appalling incident.",
    thumbnailImage: "/images/global-news/2026/2026-03-09-us-senators-urge-probe-into-deadly-attack-on-iranian-girls-school.jpg",
    date: "2026-03-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-education-reforms-threaten-disabled-children-s-legal-safeguards-charity-warns",
    title: "Global Education Reforms Threaten Disabled Children's Legal Safeguards, Charity Warns",
    summary:
      "A leading charity has voiced alarm over proposed education reforms in a developed nation, fearing they could strip away vital legal protections for children with special educational needs and disabilities. This development highlights a broader global challenge in upholding inclusive education standards amidst budgetary pressures.",
    thumbnailImage: "/images/global-news/2026/2026-03-09-global-education-reforms-threaten-disabled-children-s-legal-safeguards-charity-w.jpg",
    date: "2026-03-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "nepal-s-youth-games-a-catalyst-for-educational-and-health-advancement",
    title: "Nepal's Youth Games: A Catalyst for Educational and Health Advancement",
    summary:
      "Nepal is leveraging its role as host for international youth games to significantly enhance physical education curricula and promote robust public health among its younger generations. These events are seen as crucial opportunities to inspire active lifestyles and foster cross-cultural learning within the country's educational framework.",
    thumbnailImage: "/images/nepal-news/2026/2026-03-09-nepal-s-youth-games-a-catalyst-for-educational-and-health-advancement.jpg",
    date: "2026-03-09",
    author: "Nivaran Foundation Nepal Desk",
    featured: true,
    type: "News",
  },
  {
    slug: "global-call-for-comprehensive-sex-education-communities-bridge-critical-gaps",
    title: "Global Call for Comprehensive Sex Education: Communities Bridge Critical Gaps",
    summary:
      "Inadequate comprehensive sex education in schools presents a global challenge, leaving young people vulnerable to misinformation and health risks. Across diverse communities, parents and faith-based organizations are proactively developing alternative programs to ensure adolescents receive crucial, medically accurate information.",
    thumbnailImage: "/images/global-news/2026/2026-03-09-global-call-for-comprehensive-sex-education-communities-bridge-critical-gaps.jpg",
    date: "2026-03-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hims-shares-shoot-up-after-weight-loss-drug-deal-with",
    title: "Global Health and Education Watch: Hims shares shoot up after weight-loss drug deal with",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-09-global-health-and-education-watch-hims-shares-shoot-up-after-weight-loss-drug-de.jpg",
    date: "2026-03-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-countries-progress-negotiations-in-support-of-who-pandemic-agreement",
    title: "Global Health and Education Watch: Countries progress negotiations in support of WHO Pandemic Agreement",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-09-global-health-and-education-watch-countries-progress-negotiations-in-support-of-.jpg",
    date: "2026-03-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-infection-acquired-protection-against-sars-cov-2-infection-and-clinical-severity-by",
    title: "Global Health and Education Watch: Infection-acquired protection against SARS-CoV-2 infection and clinical severity by",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-09-global-health-and-education-watch-infection-acquired-protection-against-sars-cov.jpg",
    date: "2026-03-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "new-tool-unravels-viral-origins-bolstering-global-pandemic-preparedness",
    title: "New Tool Unravels Viral Origins, Bolstering Global Pandemic Preparedness",
    summary:
      "A groundbreaking new research tool offers unprecedented clarity in determining the origins of viral outbreaks. This development significantly strengthens global health security by providing objective insights into pathogen emergence.",
    thumbnailImage: "/images/global-news/2026/2026-03-09-new-tool-unravels-viral-origins-bolstering-global-pandemic-preparedness.jpg",
    date: "2026-03-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-iran-says-1-255-people-killed-in-us-israeli-attacks-mostly",
    title: "Global Health and Education Watch: Iran says 1,255 people killed in US-Israeli attacks, mostly",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-09-global-health-and-education-watch-iran-says-1-255-people-killed-in-us-israeli-at.jpg",
    date: "2026-03-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-nhs-england-pauses-new-prescriptions-of-cross-sex-hormones-for",
    title: "Global Health and Education Watch: NHS England pauses new prescriptions of cross-sex hormones for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-09-global-health-and-education-watch-nhs-england-pauses-new-prescriptions-of-cross-.jpg",
    date: "2026-03-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "volunteers-rebuild-sudan-s-oldest-psychiatric-hospital-amidst-war-s-devastation",
    title: "Volunteers Rebuild Sudan's Oldest Psychiatric Hospital Amidst War's Devastation",
    summary:
      "In war-torn Sudan, volunteers are diligently rebuilding the nation's oldest psychiatric hospital, a vital institution destroyed by ongoing conflict. This critical effort unfolds as countless families, like one returning from displacement, struggle to find support for loved ones battling severe addiction and mental trauma.",
    thumbnailImage: "/images/global-news/2026/2026-03-09-volunteers-rebuild-sudan-s-oldest-psychiatric-hospital-amidst-war-s-devastation.jpg",
    date: "2026-03-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "parkinson-s-claims-anti-war-icon-highlighting-global-health-challenge",
    title: "Parkinson's Claims Anti-War Icon, Highlighting Global Health Challenge",
    summary:
      "Country Joe McDonald, the iconic anti-war musician, has died at 84 from Parkinson's complications, drawing renewed attention to the global impact of neurodegenerative conditions. His passing highlights the critical importance of advancing research and providing comprehensive care for those affected worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-09-parkinson-s-claims-anti-war-icon-highlighting-global-health-challenge.jpg",
    date: "2026-03-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ai-unveils-hidden-abuse-transforms-patient-care-amid-global-upheaval",
    title: "AI Unveils Hidden Abuse, Transforms Patient Care Amid Global Upheaval",
    summary:
      "Healthcare innovations like Martha's Rule are enhancing patient safety, while AI tools are simultaneously uncovering under-reported abuse and providing therapeutic support to survivors. These advancements occur against a backdrop of global conflicts that profoundly impact mental health and societal stability.",
    thumbnailImage: "/images/global-news/2026/2026-03-09-ai-unveils-hidden-abuse-transforms-patient-care-amid-global-upheaval.jpg",
    date: "2026-03-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "experts-urge-new-nepali-government-make-healthcare-top-priority",
    title: "Experts Urge New Nepali Government: Make Healthcare Top Priority",
    summary:
      "Healthcare experts across Nepal are calling on the newly formed government to elevate public health to a primary national agenda. They stress that strategic investment and comprehensive reforms are crucial for ensuring equitable access and improving the nation's health outcomes.",
    thumbnailImage: "/images/nepal-news/2026/2026-03-09-experts-urge-new-nepali-government-make-healthcare-top-priority.jpg",
    date: "2026-03-09",
    author: "Nivaran Foundation Nepal Desk",
    featured: true,
    type: "News",
  },
  {
    slug: "global-communities-embrace-informal-dialogues-for-mental-well-being",
    title: "Global Communities Embrace Informal Dialogues for Mental Well-being",
    summary:
      "Informal community gatherings are emerging as vital platforms for mental health discussions globally, offering accessible support. These inclusive spaces help dismantle stigma and encourage open dialogue about personal well-being.",
    thumbnailImage: "/images/global-news/2026/2026-03-09-global-communities-embrace-informal-dialogues-for-mental-well-being.jpg",
    date: "2026-03-09",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "health-secretary-s-nutrition-pivot-divides-allies-amid-global-health-debates",
    title: "Health Secretary's Nutrition Pivot Divides Allies Amid Global Health Debates",
    summary:
      "Health Secretary Kennedy's recent pivot from vaccine-centric advocacy to prioritizing \"real food\" initiatives has ignited significant debate among his traditional supporters. This strategic shift, unfolding amidst global health challenges and upcoming midterm elections, underscores the complex interplay of public health policy and political strategy.",
    thumbnailImage: "/images/global-news/2026/2026-03-08-health-secretary-s-nutrition-pivot-divides-allies-amid-global-health-debates.jpg",
    date: "2026-03-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "unmasking-health-disparities-across-latin-america-gender-ethnicity-and-chronic-disease",
    title: "Unmasking Health Disparities Across Latin America: Gender, Ethnicity, and Chronic Disease",
    summary:
      "A recent study reveals profound health disparities driven by gender, ethnicity, and chronic diseases across Latin American populations. Understanding these complex interactions is crucial for developing equitable and effective public health strategies.",
    thumbnailImage: "/images/global-news/2026/2026-03-08-unmasking-health-disparities-across-latin-america-gender-ethnicity-and-chronic-d.jpg",
    date: "2026-03-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "nepal-pioneers-genetic-testing-for-rheumatic-diseases-revolutionizing-diagnosis",
    title: "Nepal Pioneers Genetic Testing for Rheumatic Diseases, Revolutionizing Diagnosis",
    summary:
      "Nepal has launched its first-ever genetic testing service for rheumatic diseases, marking a pivotal moment in the nation's healthcare landscape. This groundbreaking initiative promises more accurate and timely diagnoses, improving patient outcomes nationwide.",
    thumbnailImage: "/images/nepal-news/2026/2026-03-08-nepal-pioneers-genetic-testing-for-rheumatic-diseases-revolutionizing-diagnosis.jpg",
    date: "2026-03-08",
    author: "Nivaran Foundation Nepal Desk",
    featured: true,
    type: "News",
  },
  {
    slug: "global-health-breakthrough-four-in-ten-cancers-preventable-who-study-reveals",
    title: "Global Health Breakthrough: Four in Ten Cancers Preventable, WHO Study Reveals",
    summary:
      "A groundbreaking global analysis from the World Health Organization and IARC indicates that nearly half of all cancer diagnoses worldwide are potentially preventable. This extensive study identifies 30 modifiable risk factors, notably incorporating nine cancer-causing infections for the first time alongside established lifestyle and environmental factors.",
    thumbnailImage: "/images/global-news/2026/2026-03-08-global-health-breakthrough-four-in-ten-cancers-preventable-who-study-reveals.jpg",
    date: "2026-03-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-adhd-diagnosis-helped-my-mental-health-letters",
    title: "Global Health and Education Watch: How ADHD diagnosis helped my mental health | Letters",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-08-global-health-and-education-watch-how-adhd-diagnosis-helped-my-mental-health-let.jpg",
    date: "2026-03-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-crisis-inexpensive-harmful-drinks-drive-disease-and-injury-surge",
    title: "Global Health Crisis: Inexpensive Harmful Drinks Drive Disease and Injury Surge",
    summary:
      "New global reports from the World Health Organization highlight the urgent need for governments to increase taxes on sugary drinks and alcoholic beverages. This measure aims to counter the rising tide of preventable noncommunicable diseases and injuries, which are placing immense pressure on health systems globally.",
    thumbnailImage: "/images/global-news/2026/2026-03-08-global-health-crisis-inexpensive-harmful-drinks-drive-disease-and-injury-surge.jpg",
    date: "2026-03-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-healthcare-confronts-medical-misogyny-as-women-report-widespread-dismissal",
    title: "Global Healthcare Confronts 'Medical Misogyny' as Women Report Widespread Dismissal",
    summary:
      "Across global healthcare systems, women frequently report their health concerns are dismissed or ignored due to systemic gender bias, a phenomenon increasingly recognized as 'medical misogyny.' This widespread issue leads to delayed diagnoses, inadequate treatment, and a profound erosion of trust in medical professionals.",
    thumbnailImage: "/images/global-news/2026/2026-03-08-global-healthcare-confronts-medical-misogyny-as-women-report-widespread-dismissa.jpg",
    date: "2026-03-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "remote-robotic-surgery-bridges-continents-redefining-global-healthcare-access",
    title: "Remote Robotic Surgery Bridges Continents, Redefining Global Healthcare Access",
    summary:
      "A pioneering remote robotic surgery saw a London-based surgeon successfully operate on a prostate cancer patient in Gibraltar, bridging a 1,500-mile distance. This landmark procedure highlights the transformative potential of advanced technology in delivering specialized medical care across geographical barriers.",
    thumbnailImage: "/images/global-news/2026/2026-03-08-remote-robotic-surgery-bridges-continents-redefining-global-healthcare-access.jpg",
    date: "2026-03-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-f-d-a-faces-upset-over-denials-of-new-drugs",
    title: "Global Health and Education Watch: F.D.A. Faces Upset Over Denials of New Drugs",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-08-global-health-and-education-watch-f-d-a-faces-upset-over-denials-of-new-drugs.jpg",
    date: "2026-03-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "tech-oligarchs-rise-shaping-global-health-and-education-futures",
    title: "Tech Oligarchs' Rise: Shaping Global Health and Education Futures",
    summary:
      "The unprecedented concentration of wealth and influence among a select group of tech leaders is profoundly reshaping global health and education landscapes. Their strategic investments and technological advancements raise critical questions about equitable access and the future direction of human development.",
    thumbnailImage: "/images/global-news/2026/2026-03-08-tech-oligarchs-rise-shaping-global-health-and-education-futures.jpg",
    date: "2026-03-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-is-he-going-to-have-the-time-nih",
    title: "Global Health and Education Watch: ‘How is he going to have the time?’ NIH",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-08-global-health-and-education-watch-how-is-he-going-to-have-the-time-nih.jpg",
    date: "2026-03-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "the-global-mental-health-crisis-navigating-political-turmoil-and-societal-stress",
    title: "The Global Mental Health Crisis: Navigating Political Turmoil and Societal Stress",
    summary:
      "A pervasive sense of psychological distress, often termed 'political depression,' is increasingly linked to global political instability and societal polarization. Mental health professionals are observing a surge in related conditions, emphasizing community engagement as a vital coping mechanism.",
    thumbnailImage: "/images/global-news/2026/2026-03-08-the-global-mental-health-crisis-navigating-political-turmoil-and-societal-stress.jpg",
    date: "2026-03-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-children-wounded-in-the-us-israeli-strikes-receive-treatment-in",
    title: "Global Health and Education Watch: Children wounded in the US-Israeli strikes receive treatment in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-08-global-health-and-education-watch-children-wounded-in-the-us-israeli-strikes-rec.jpg",
    date: "2026-03-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "who-director-general-lauds-jordan-s-health-leadership-amidst-regional-challenges",
    title: "WHO Director-General Lauds Jordan's Health Leadership Amidst Regional Challenges",
    summary:
      "The WHO Director-General concluded a significant visit to Jordan, recognizing the nation's strong commitment to health system strengthening and humanitarian aid. The visit underscored collaborative efforts in advancing universal health coverage, mental health services, and emergency preparedness.",
    thumbnailImage: "/images/global-news/2026/2026-03-08-who-director-general-lauds-jordan-s-health-leadership-amidst-regional-challenges.jpg",
    date: "2026-03-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-what-is-chickenpox-and-who-can-get-an-nhs",
    title: "Global Health and Education Watch: What is chickenpox and who can get an NHS",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-08-global-health-and-education-watch-what-is-chickenpox-and-who-can-get-an-nhs.jpg",
    date: "2026-03-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-why-are-democrats-surrendering-the-issue-of-healthy-food",
    title: "Global Health and Education Watch: Why are Democrats surrendering the issue of healthy food?",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-08-global-health-and-education-watch-why-are-democrats-surrendering-the-issue-of-he.jpg",
    date: "2026-03-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-china-s-competency-framework-offers-blueprint-for-primary-care-excellence",
    title: "Global Health: China's Competency Framework Offers Blueprint for Primary Care Excellence",
    summary:
      "A groundbreaking framework from China outlines essential competencies for primary healthcare workers, setting a new standard for public health service delivery. This model offers critical insights for global efforts to strengthen primary care and achieve universal health coverage.",
    thumbnailImage: "/images/global-news/2026/2026-03-08-global-health-china-s-competency-framework-offers-blueprint-for-primary-care-exc.jpg",
    date: "2026-03-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "caffeine-pouches-a-global-health-concern-for-adolescents",
    title: "Caffeine Pouches: A Global Health Concern for Adolescents",
    summary:
      "A concerning global trend sees caffeine pouches targeting adolescents, promoted by social media influencers to young gym-goers and students. Health experts are raising alarms about the potential health risks and the urgent need for regulatory oversight.",
    thumbnailImage: "/images/global-news/2026/2026-03-08-caffeine-pouches-a-global-health-concern-for-adolescents.jpg",
    date: "2026-03-08",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-alarm-as-unreviewed-food-ingredients-enter-supply-chains",
    title: "Global Alarm as Unreviewed Food Ingredients Enter Supply Chains",
    summary:
      "A recent analysis by the Environmental Working Group uncovered that more than 100 food ingredients in common US products have not undergone health and safety reviews by the FDA. This regulatory gap allows numerous unvetted chemicals into the food system, prompting global concerns about consumer health and food safety standards.",
    thumbnailImage: "/images/global-news/2026/2026-03-07-global-alarm-as-unreviewed-food-ingredients-enter-supply-chains.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-deadly-clashes-in-lebanon-as-israel-renews-search-for",
    title: "Global Health and Education Watch: Deadly Clashes in Lebanon as Israel Renews Search for",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-07-global-health-and-education-watch-deadly-clashes-in-lebanon-as-israel-renews-sea.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-for-xi-trump-s-embrace-of-war-proves-china-needs",
    title: "Global Health and Education Watch: For Xi, Trump’s Embrace of War Proves China Needs",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-07-global-health-and-education-watch-for-xi-trump-s-embrace-of-war-proves-china-nee.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "libya-achieves-landmark-trachoma-elimination-inspiring-global-health-efforts",
    title: "Libya Achieves Landmark Trachoma Elimination, Inspiring Global Health Efforts",
    summary:
      "Libya has achieved a significant public health milestone with the World Health Organization's validation of trachoma elimination. This success safeguards future generations from preventable blindness and underscores global efforts against neglected tropical diseases.",
    thumbnailImage: "/images/global-news/2026/2026-03-07-libya-achieves-landmark-trachoma-elimination-inspiring-global-health-efforts.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-alberto-carvalho-became-l-a-u-s-d-superintendent-despite-scandals",
    title: "Global Health and Education Watch: How Alberto Carvalho Became L.A.U.S.D. Superintendent Despite Scandals",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-07-global-health-and-education-watch-how-alberto-carvalho-became-l-a-u-s-d-superint.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "zimbabwean-descendants-urge-uk-repatriate-looted-skulls-of-resistance-heroes",
    title: "Zimbabwean Descendants Urge UK: Repatriate Looted Skulls of Resistance Heroes",
    summary:
      "Descendants of Zimbabwe's First Chimurenga heroes are pressing UK institutions to locate and return the skulls of their ancestors, taken during colonial suppression in the 1890s. This plea highlights the ongoing global movement for historical justice and the ethical responsibilities of museums regarding looted human remains.",
    thumbnailImage: "/images/global-news/2026/2026-03-07-zimbabwean-descendants-urge-uk-repatriate-looted-skulls-of-resistance-heroes.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-child-safety-imperative-lessons-from-a-tragedy-s-enduring-shadow",
    title: "Global Child Safety Imperative: Lessons from a Tragedy's Enduring Shadow",
    summary:
      "The recent demise of Ian Huntley, convicted for the shocking 2002 murders of two schoolgirls in Britain, brings renewed focus to the critical global imperative of child protection. This tragic case profoundly influenced child safeguarding policies and educational approaches, underscoring the continuous need for vigilance and robust support systems.",
    thumbnailImage: "/images/global-news/2026/2026-03-07-global-child-safety-imperative-lessons-from-a-tragedy-s-enduring-shadow.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-divisive-f-d-a-vaccine-regulator-is-resigning",
    title: "Global Health and Education Watch: Divisive F.D.A. Vaccine Regulator Is Resigning",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-07-global-health-and-education-watch-divisive-f-d-a-vaccine-regulator-is-resigning.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "escalation-in-lebanon-underscores-urgent-humanitarian-crisis",
    title: "Escalation in Lebanon Underscores Urgent Humanitarian Crisis",
    summary:
      "Recent military actions in eastern Lebanon have resulted in significant casualties, exposing the severe vulnerabilities of local health and education infrastructures. This escalating crisis underscores an urgent need for global humanitarian support for affected communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-07-escalation-in-lebanon-underscores-urgent-humanitarian-crisis.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "deaf-child-deported-without-aid-a-global-disability-rights-crisis",
    title: "Deaf Child Deported Without Aid: A Global Disability Rights Crisis",
    summary:
      "A six-year-old deaf boy, his mother, and sibling were deported from the United States to Colombia by immigration authorities, reportedly without the child's essential assistive devices. This incident has ignited a global debate on the humanitarian treatment of vulnerable individuals within immigration systems and the universal right to health and education.",
    thumbnailImage: "/images/global-news/2026/2026-03-07-deaf-child-deported-without-aid-a-global-disability-rights-crisis.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-global-summit-charts-a-bold-future-for-traditional",
    title: "Global Health and Education Watch: WHO Global Summit charts a bold future for traditional",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-07-global-health-and-education-watch-who-global-summit-charts-a-bold-future-for-tra.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-debate-school-vouchers-and-public-education-s-future",
    title: "Global Debate: School Vouchers and Public Education's Future",
    summary:
      "A recent debate on school vouchers has sparked global discussion about their potential to improve public education versus concerns over equity and resource diversion. This article explores the multifaceted arguments, highlighting the complex interplay of parental choice, public responsibility, and the future of educational systems worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-07-global-debate-school-vouchers-and-public-education-s-future.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-weight-loss-drugs-alone-will-not-solve-uk-s-obesity-crisis",
    title: "Global Health and Education Watch: Weight-loss drugs alone will not solve UK’s obesity crisis",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-07-global-health-and-education-watch-weight-loss-drugs-alone-will-not-solve-uk-s-ob.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-child-safety-imperative-a-call-for-vigilance-and-protection",
    title: "Global Child Safety Imperative: A Call for Vigilance and Protection",
    summary:
      "The passing of Ian Huntley, convicted of the 2002 Soham murders, underscores the critical global need for enhanced child protection measures. This event prompts a renewed focus on community vigilance, educational initiatives, and robust support systems for families affected by such tragedies.",
    thumbnailImage: "/images/global-news/2026/2026-03-07-global-child-safety-imperative-a-call-for-vigilance-and-protection.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-prevalence-of-excessive-screen-time-and-its-associated-factors",
    title: "Global Health and Education Watch: Prevalence of excessive screen time and its associated factors",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-07-global-health-and-education-watch-prevalence-of-excessive-screen-time-and-its-as.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-hezbollah-israeli-troops-clash-on-the-ground-in-eastern",
    title: "Global Health and Education Watch: Hezbollah, Israeli troops clash on the ground in eastern",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-07-global-health-and-education-watch-hezbollah-israeli-troops-clash-on-the-ground-i.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-integrity-under-scrutiny-peer-resigns-amid-ppe-scandal",
    title: "Global Health Integrity Under Scrutiny: Peer Resigns Amid PPE Scandal",
    summary:
      "A prominent UK peer is stepping down from the House of Lords following an investigation into multiple breaches of conduct related to COVID-19 PPE procurement. The case underscores critical global challenges in maintaining ethical standards and transparency during public health emergencies.",
    thumbnailImage: "/images/global-news/2026/2026-03-07-global-health-integrity-under-scrutiny-peer-resigns-amid-ppe-scandal.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-six-years-after-covid-19-s-global-alarm-is-the-world",
    title: "Global Health and Education Watch: Six years after COVID-19’s global alarm: Is the world",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-07-global-health-and-education-watch-six-years-after-covid-19-s-global-alarm-is-the.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "mahabir-pun-s-enduring-vision-for-education-and-innovation-resonates-in-myagdi",
    title: "Mahabir Pun's Enduring Vision for Education and Innovation Resonates in Myagdi",
    summary:
      "Mahabir Pun, a celebrated proponent of innovation and rural development, is demonstrating significant electoral support in Myagdi. His decades-long efforts in education and technology are widely recognized as pivotal factors in his current political standing.",
    thumbnailImage: "/images/nepal-news/2026/2026-03-07-mahabir-pun-s-enduring-vision-for-education-and-innovation-resonates-in-myagdi.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Nepal Desk",
    featured: true,
    type: "News",
  },
  {
    slug: "devastating-strike-on-iranian-school-unraveling-the-evidence",
    title: "Devastating Strike on Iranian School: Unraveling the Evidence",
    summary:
      "A horrific airstrike on an elementary school in southern Iran claimed at least 175 lives, prompting an in-depth visual investigation. Analysts used satellite imagery and other evidence to meticulously examine the incident and identify potential perpetrators.",
    thumbnailImage: "/images/global-news/2026/2026-03-07-devastating-strike-on-iranian-school-unraveling-the-evidence.jpg",
    date: "2026-03-07",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "fda-vaccine-chief-s-second-departure-raises-global-health-governance-questions",
    title: "FDA Vaccine Chief's Second Departure Raises Global Health Governance Questions",
    summary:
      "Dr. Vinay Prasad, the FDA's vaccine and specialty drug chief, is departing the agency for the second time in less than a year. His exit prompts global discussion on regulatory stability, public trust, and the challenges facing health governance.",
    thumbnailImage: "/images/global-news/2026/2026-03-06-fda-vaccine-chief-s-second-departure-raises-global-health-governance-questions.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-outcry-as-iranian-girls-school-strike-under-investigation",
    title: "Global Outcry as Iranian Girls' School Strike Under Investigation",
    summary:
      "An ongoing investigation is examining an apparent strike on an Iranian girls' school that tragically killed scores of children, with initial assessments suggesting potential US military involvement. This devastating incident underscores the urgent global challenge of protecting educational institutions and safeguarding children's right to learn in conflict zones.",
    thumbnailImage: "/images/global-news/2026/2026-03-06-global-outcry-as-iranian-girls-school-strike-under-investigation.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "ai-breakthrough-boosts-trust-in-arabic-online-health-information",
    title: "AI Breakthrough Boosts Trust in Arabic Online Health Information",
    summary:
      "Researchers have developed an enhanced AI model to improve the trustworthiness evaluation of Arabic online health information. This innovation aims to combat misinformation and provide more reliable health resources to Arabic-speaking populations worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-06-ai-breakthrough-boosts-trust-in-arabic-online-health-information.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-calls-grow-for-independent-probe-into-deadly-iranian-girls",
    title: "Global Health and Education Watch: Calls grow for independent probe into deadly Iranian girls’",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-06-global-health-and-education-watch-calls-grow-for-independent-probe-into-deadly-i.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-labour-s-send-reforms-get-this-right-disabled-children-in",
    title: "Global Health and Education Watch: Labour’s Send reforms get this right: disabled children in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-06-global-health-and-education-watch-labour-s-send-reforms-get-this-right-disabled-.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "women-s-pain-a-global-silent-epidemic-shaped-by-life-experiences",
    title: "Women's Pain: A Global Silent Epidemic Shaped by Life Experiences",
    summary:
      "For countless women globally, pain is normalized from childhood, profoundly shaping their health perceptions and interactions with medical systems. This ingrained acceptance often leads to significant delays in diagnosis and inadequate treatment for chronic conditions.",
    thumbnailImage: "/images/global-news/2026/2026-03-06-women-s-pain-a-global-silent-epidemic-shaped-by-life-experiences.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-vexing-problem-for-college-students-course-availability",
    title: "Global Health and Education Watch: A Vexing Problem for College Students: Course Availability",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-06-global-health-and-education-watch-a-vexing-problem-for-college-students-course-a.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-year-on-a-cancer-vaccine-trial-at-london-s",
    title: "Global Health and Education Watch: A year on a cancer vaccine trial at London’s",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-06-global-health-and-education-watch-a-year-on-a-cancer-vaccine-trial-at-london-s.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "tehran-school-strike-highlights-global-education-vulnerability-in-conflict",
    title: "Tehran School Strike Highlights Global Education Vulnerability in Conflict",
    summary:
      "An elementary school in Tehran was reportedly hit, drawing global attention to the pervasive threat against educational institutions in conflict zones. The incident highlights the critical need for international adherence to laws protecting children and schools from attack.",
    thumbnailImage: "/images/global-news/2026/2026-03-06-tehran-school-strike-highlights-global-education-vulnerability-in-conflict.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "early-childhood-upf-intake-a-global-health-challenge",
    title: "Early Childhood UPF Intake: A Global Health Challenge",
    summary:
      "A recent study reveals complex individual, family, and societal factors influencing ultra-processed food intake in preschoolers. These findings underscore an urgent global need for comprehensive strategies to protect children's health from pervasive unhealthy food environments.",
    thumbnailImage: "/images/global-news/2026/2026-03-06-early-childhood-upf-intake-a-global-health-challenge.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-communities-unite-to-address-stigma-and-discrimination-affecting-people",
    title: "Global Health and Education Watch: Communities unite to address stigma and discrimination affecting people",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-06-global-health-and-education-watch-communities-unite-to-address-stigma-and-discri.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-debate-world-book-day-s-evolving-role-in-fostering-reading",
    title: "Global Debate: World Book Day's Evolving Role in Fostering Reading",
    summary:
      "Discussions around World Book Day highlight a global pedagogical debate on the most effective methods to cultivate reading for pleasure among children. While celebrated for its engagement, some educators question if elaborate costume events inadvertently overshadow the fundamental goal of literacy promotion.",
    thumbnailImage: "/images/global-news/2026/2026-03-06-global-debate-world-book-day-s-evolving-role-in-fostering-reading.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "balendra-shah-s-rise-a-new-era-for-nepal-s-public-health",
    title: "Balendra Shah's Rise: A New Era for Nepal's Public Health?",
    summary:
      "Balendra Shah's political ascent brings renewed attention to public health, particularly given his wife's professional background. This potential shift in leadership focus could significantly impact Nepal's healthcare landscape, emphasizing preventative care and equitable access.",
    thumbnailImage: "/images/nepal-news/2026/2026-03-06-balendra-shah-s-rise-a-new-era-for-nepal-s-public-health.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Nepal Desk",
    featured: true,
    type: "News",
  },
  {
    slug: "academic-freedom-under-siege-students-fight-for-education-s-future-in-florida",
    title: "Academic Freedom Under Siege: Students Fight for Education's Future in Florida",
    summary:
      "A recent documentary exposes the swift dismantling of academic freedom at Florida's New College, once a beacon of independent thought. Students and faculty are shown resisting a state-orchestrated conservative overhaul that targeted curricula, libraries, and campus culture.",
    thumbnailImage: "/images/global-news/2026/2026-03-06-academic-freedom-under-siege-students-fight-for-education-s-future-in-florida.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-hubs-foster-community-well-being-redefining-care-models",
    title: "Global Health Hubs Foster Community Well-being, Redefining Care Models",
    summary:
      "Across the globe, organizations are innovating by establishing integrated community hubs designed to foster social connection and holistic well-being. These multi-functional centers aim to move beyond conventional healthcare, providing spaces for comprehensive support and community engagement.",
    thumbnailImage: "/images/global-news/2026/2026-03-06-global-health-hubs-foster-community-well-being-redefining-care-models.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "fewer-glp-1-shots-sustain-weight-loss-global-study-suggests",
    title: "Fewer GLP-1 Shots Sustain Weight Loss, Global Study Suggests",
    summary:
      "A recent global review suggests that patients can maintain substantial weight loss and associated health benefits with less frequent GLP-1 agonist injections. This finding holds promise for improving long-term adherence and accessibility of these transformative therapies across the globe.",
    thumbnailImage: "/images/global-news/2026/2026-03-06-fewer-glp-1-shots-sustain-weight-loss-global-study-suggests.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-vice-chancellor-calls-for-review-into-student-loans-for-those",
    title: "Global Health and Education Watch: Vice-chancellor calls for review into student loans for those",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-06-global-health-and-education-watch-vice-chancellor-calls-for-review-into-student-.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "qatar-study-illuminates-global-healthcare-disaster-preparedness-gaps",
    title: "Qatar Study Illuminates Global Healthcare Disaster Preparedness Gaps",
    summary:
      "A recent study in Qatar explored healthcare practitioners' perceptions of disaster management, highlighting both strengths and significant areas for improvement. The findings provide valuable insights for enhancing global healthcare preparedness and response strategies.",
    thumbnailImage: "/images/global-news/2026/2026-03-06-qatar-study-illuminates-global-healthcare-disaster-preparedness-gaps.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-recommendations-for-influenza-vaccine-composition-for-the-2026-2027-northern",
    title: "Global Health and Education Watch: Recommendations for influenza vaccine composition for the 2026-2027 northern",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-06-global-health-and-education-watch-recommendations-for-influenza-vaccine-composit.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "escalating-crises-undermine-global-health-gains-amidst-new-hope",
    title: "Escalating Crises Undermine Global Health Gains Amidst New Hope",
    summary:
      "Violent conflict in Sudan's Kordofan region is causing widespread destruction of civilian infrastructure, severely impacting health and education access. This humanitarian crisis unfolds against a backdrop of deepening global inequality, contrasting with significant advancements in HIV treatment and prevention worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-06-escalating-crises-undermine-global-health-gains-amidst-new-hope.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "nepal-s-health-tapestry-weaving-traditional-wisdom-with-modern-care",
    title: "Nepal's Health Tapestry: Weaving Traditional Wisdom with Modern Care",
    summary:
      "In Nepal, health and illness narratives are deeply rooted in cultural beliefs and traditional practices, significantly influencing how communities perceive well-being and seek care. Effective public health initiatives must respectfully integrate scientific knowledge with these indigenous understandings to achieve sustainable impact.",
    thumbnailImage: "/images/nepal-news/2026/2026-03-06-nepal-s-health-tapestry-weaving-traditional-wisdom-with-modern-care.jpg",
    date: "2026-03-06",
    author: "Nivaran Foundation Nepal Desk",
    featured: true,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-rfk-jr-urges-medical-schools-to-increase-nutrition-education",
    title: "Global Health and Education Watch: RFK Jr urges medical schools to increase nutrition education",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-05-global-health-and-education-watch-rfk-jr-urges-medical-schools-to-increase-nutri.jpg",
    date: "2026-03-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-moment-of-reckoning-needed-in-social-care-says-louise",
    title: "Global Health and Education Watch: 'Moment of reckoning' needed in social care, says Louise",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-05-global-health-and-education-watch-moment-of-reckoning-needed-in-social-care-says.jpg",
    date: "2026-03-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-education-shifts-medical-schools-embrace-nutrition",
    title: "Global Health Education Shifts: Medical Schools Embrace Nutrition",
    summary:
      "A notable number of medical schools have pledged to enhance nutrition education, reflecting a growing global recognition of its critical role in health. This development could inspire similar curriculum reforms worldwide to address prevalent diet-related diseases.",
    thumbnailImage: "/images/global-news/2026/2026-03-05-global-health-education-shifts-medical-schools-embrace-nutrition.jpg",
    date: "2026-03-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "escalating-strikes-devastate-iran-s-health-education-infrastructure",
    title: "Escalating Strikes Devastate Iran's Health, Education Infrastructure",
    summary:
      "Intensified aerial assaults across Iran have severely impacted critical health and education facilities, particularly in Tehran. This escalation threatens the well-being and future of countless civilians, disrupting daily life and essential services.",
    thumbnailImage: "/images/global-news/2026/2026-03-05-escalating-strikes-devastate-iran-s-health-education-infrastructure.jpg",
    date: "2026-03-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "chitwan-s-vote-a-mandate-for-health-and-education-reform-in-nepal",
    title: "Chitwan's Vote: A Mandate for Health and Education Reform in Nepal",
    summary:
      "The recent election in Chitwan, marked by Coordinator Dahal's participation, underscores the critical public demand for improved health and education services across Nepal. This electoral moment serves as a powerful reminder of the deep connection between political leadership and the well-being of communities.",
    thumbnailImage: "/images/nepal-news/2026/2026-03-05-chitwan-s-vote-a-mandate-for-health-and-education-reform-in-nepal.jpg",
    date: "2026-03-05",
    author: "Nivaran Foundation Nepal Desk",
    featured: true,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-nationwide-social-contact-survey-dataset-for-public-health",
    title: "Global Health and Education Watch: A Nationwide Social Contact Survey Dataset for Public Health",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-05-global-health-and-education-watch-a-nationwide-social-contact-survey-dataset-for.jpg",
    date: "2026-03-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "missile-strikes-devastate-schools-near-tehran-escalating-regional-tensions",
    title: "Missile Strikes Devastate Schools Near Tehran, Escalating Regional Tensions",
    summary:
      "Two schools in Parand, near Tehran, were struck by missiles reportedly launched by US and Israeli forces, marking a severe escalation in regional hostilities. This attack, following a recent deadly incident, underscores the devastating impact of conflict on civilian infrastructure and children's education.",
    thumbnailImage: "/images/global-news/2026/2026-03-05-missile-strikes-devastate-schools-near-tehran-escalating-regional-tensions.jpg",
    date: "2026-03-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "who-urges-global-schools-to-prioritize-healthy-eating-for-children-s-future",
    title: "WHO Urges Global Schools to Prioritize Healthy Eating for Children's Future",
    summary:
      "The World Health Organization has released new global guidelines urging schools to promote healthy eating, emphasizing its crucial role in shaping lifelong dietary habits. These evidence-based policies aim to create supportive school food environments, addressing the urgent global challenge of childhood malnutrition and obesity.",
    thumbnailImage: "/images/global-news/2026/2026-03-05-who-urges-global-schools-to-prioritize-healthy-eating-for-children-s-future.jpg",
    date: "2026-03-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "the-global-burden-questioning-higher-education-s-promise",
    title: "The Global Burden: Questioning Higher Education's Promise",
    summary:
      "A generation of students worldwide faces unprecedented financial burdens from higher education, leading to widespread questioning of the long-term value of their degrees. Rising debts, frozen repayment thresholds, and spiraling interest rates are reshaping economic futures for millions.",
    thumbnailImage: "/images/global-news/2026/2026-03-05-the-global-burden-questioning-higher-education-s-promise.jpg",
    date: "2026-03-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "england-mandates-allergy-training-in-schools-setting-global-precedent",
    title: "England Mandates Allergy Training in Schools, Setting Global Precedent",
    summary:
      "England is set to implement mandatory allergy training for all school staff starting in September, a move driven by a campaign for improved student safety. This initiative highlights a growing global focus on comprehensive health protocols within educational environments.",
    thumbnailImage: "/images/global-news/2026/2026-03-05-england-mandates-allergy-training-in-schools-setting-global-precedent.jpg",
    date: "2026-03-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-data-centric-approach-to-detecting-and-mitigating-demographic-bias",
    title: "Global Health and Education Watch: A data-centric approach to detecting and mitigating demographic bias",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-05-global-health-and-education-watch-a-data-centric-approach-to-detecting-and-mitig.jpg",
    date: "2026-03-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-after-pete-hegseth-cut-pentagon-funding-harvard-offers-options",
    title: "Global Health and Education Watch: After Pete Hegseth Cut Pentagon Funding, Harvard Offers Options",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-05-global-health-and-education-watch-after-pete-hegseth-cut-pentagon-funding-harvar.jpg",
    date: "2026-03-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-new-normal-inquiry-s-key-findings-on-how-covid",
    title: "Global Health and Education Watch: ‘A new normal’: inquiry’s key findings on how Covid",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-05-global-health-and-education-watch-a-new-normal-inquiry-s-key-findings-on-how-cov.jpg",
    date: "2026-03-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-push-to-integrate-nutrition-into-medical-training",
    title: "Global Push to Integrate Nutrition into Medical Training",
    summary:
      "A global conversation is intensifying about the critical role of nutrition in medical school curricula, driven by figures advocating for reform. This movement seeks to equip future doctors with essential dietary knowledge, addressing the rising tide of chronic diseases globally.",
    thumbnailImage: "/images/global-news/2026/2026-03-05-global-push-to-integrate-nutrition-into-medical-training.jpg",
    date: "2026-03-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "himalaya-eye-hospital-s-landmark-year-a-vision-of-hope-for-nepal",
    title: "Himalaya Eye Hospital's Landmark Year: A Vision of Hope for Nepal",
    summary:
      "Himalaya Eye Hospital has provided essential eye care to 247,585 patients in a single year, marking a significant achievement in Nepal's public health sector. This remarkable service delivery underscores the ongoing efforts to expand access to specialized medical facilities and reduce the burden of visual impairment across the nation.",
    thumbnailImage: "/images/nepal-news/2026/2026-03-05-himalaya-eye-hospital-s-landmark-year-a-vision-of-hope-for-nepal.jpg",
    date: "2026-03-05",
    author: "Nivaran Foundation Nepal Desk",
    featured: true,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-chile-becomes-the-first-country-in-the-americas-to",
    title: "Global Health and Education Watch: Chile becomes the first country in the Americas to",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-05-global-health-and-education-watch-chile-becomes-the-first-country-in-the-america.jpg",
    date: "2026-03-05",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "sierra-leone-s-new-maternal-hospital-a-global-blueprint-for-hope",
    title: "Sierra Leone's New Maternal Hospital: A Global Blueprint for Hope",
    summary:
      "Sierra Leone grapples with an alarming maternal mortality crisis, prompting a groundbreaking effort to establish a new hospital. This facility, championed by a committed nurse and midwife, aims to set a global standard for comprehensive maternal care.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-sierra-leone-s-new-maternal-hospital-a-global-blueprint-for-hope.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-sisters-drown-in-welsh-national-park-after-paddling-fully",
    title: "Global Health and Education Watch: Sisters drown in Welsh national park after paddling fully",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-global-health-and-education-watch-sisters-drown-in-welsh-national-park-after-pad.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-youth-crisis-tackling-the-neet-challenge",
    title: "Global Youth Crisis: Tackling the NEET Challenge",
    summary:
      "The global phenomenon of young people not in education, employment, or training (NEET) represents a critical challenge for sustainable development. Addressing this issue requires comprehensive, collaborative strategies to foster youth integration and economic stability worldwide.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-global-youth-crisis-tackling-the-neet-challenge.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-maternity-services-need-investment-in-people-and-training-not",
    title: "Global Health and Education Watch: Maternity services need investment in people and training, not",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-global-health-and-education-watch-maternity-services-need-investment-in-people-a.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "parkinson-s-disease-a-global-surge-explained-by-epidemiological-principles",
    title: "Parkinson's Disease: A Global Surge Explained by Epidemiological Principles",
    summary:
      "Parkinson's disease is experiencing a significant global rise, driven by complex epidemiological factors. A 'bathtub analogy' helps elucidate how incidence, mortality, and diagnostic advancements contribute to this increasing worldwide prevalence.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-parkinson-s-disease-a-global-surge-explained-by-epidemiological-principles.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "nepal-intensifies-fight-against-lymphatic-filariasis-aims-for-2030-elimination",
    title: "Nepal Intensifies Fight Against Lymphatic Filariasis, Aims for 2030 Elimination",
    summary:
      "Nepal is accelerating its national program to eliminate lymphatic filariasis by the World Health Organization's 2030 target. This ambitious public health initiative focuses on mass drug administration and improved surveillance in affected districts.",
    thumbnailImage: "/images/nepal-news/2026/2026-03-04-nepal-intensifies-fight-against-lymphatic-filariasis-aims-for-2030-elimination.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Nepal Desk",
    featured: true,
    type: "News",
  },
  {
    slug: "ai-s-global-classroom-new-york-s-pivotal-moment-in-educational-transformation",
    title: "AI's Global Classroom: New York's Pivotal Moment in Educational Transformation",
    summary:
      "New York City schools, notably absent from the nationwide trend of AI integration, are poised for a potential transformation. This shift could redefine learning experiences and administrative efficiency, aligning the city with global educational advancements.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-ai-s-global-classroom-new-york-s-pivotal-moment-in-educational-transformation.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-who-validates-brazil-for-eliminating-mother-to-child-transmission-of-hiv",
    title: "Global Health and Education Watch: WHO validates Brazil for eliminating mother-to-child transmission of HIV",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-global-health-and-education-watch-who-validates-brazil-for-eliminating-mother-to.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "nepal-s-public-health-future-dr-dhimal-s-global-insights",
    title: "Nepal's Public Health Future: Dr. Dhimal's Global Insights",
    summary:
      "Dr. Meghnath Dhimal, a leading Nepali public health expert, is engaging with global institutions like Yale to address Nepal's pressing health concerns. His work focuses on climate change impacts, disease prevention, and strengthening healthcare systems across the nation.",
    thumbnailImage: "/images/nepal-news/2026/2026-03-04-nepal-s-public-health-future-dr-dhimal-s-global-insights.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Nepal Desk",
    featured: true,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-deadly-bombing-of-iran-primary-school-a-grave-violation",
    title: "Global Health and Education Watch: Deadly bombing of Iran primary school ‘a grave violation",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-global-health-and-education-watch-deadly-bombing-of-iran-primary-school-a-grave-.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-schools-in-england-sidelining-dressing-up-for-world-book-day",
    title: "Global Health and Education Watch: Schools in England sidelining dressing-up for World Book Day",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-global-health-and-education-watch-schools-in-england-sidelining-dressing-up-for-.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-pupils-told-to-remove-blazers-to-prevent-disorder",
    title: "Global Health and Education Watch: Pupils told to remove blazers to prevent disorder",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-global-health-and-education-watch-pupils-told-to-remove-blazers-to-prevent-disor.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-as-measles-spreads-in-south-carolina-rfk-jr-s-allies",
    title: "Global Health and Education Watch: As measles spreads in South Carolina, RFK Jr’s allies",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-global-health-and-education-watch-as-measles-spreads-in-south-carolina-rfk-jr-s-.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-we-were-just-praying-pakistani-students-recount-escape-from",
    title: "Global Health and Education Watch: ‘We were just praying’: Pakistani students recount escape from",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-global-health-and-education-watch-we-were-just-praying-pakistani-students-recoun.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-advancing-a-new-generation-of-heat-health-warning-system-in",
    title: "Global Health and Education Watch: Advancing a new generation of heat-health warning system in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-global-health-and-education-watch-advancing-a-new-generation-of-heat-health-warn.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-supreme-court-sides-with-religious-parents-blocking-california-s-trans",
    title: "Global Health and Education Watch: Supreme Court Sides With Religious Parents, Blocking California’s Trans",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-global-health-and-education-watch-supreme-court-sides-with-religious-parents-blo.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-attacks-on-ukraine-s-health-care-increased-by-20-in",
    title: "Global Health and Education Watch: Attacks on Ukraine’s health care increased by 20% in",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-global-health-and-education-watch-attacks-on-ukraine-s-health-care-increased-by-.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-briton-diagnosed-with-rabies-after-psychiatrist-raised-fears-inquest",
    title: "Global Health and Education Watch: Briton diagnosed with rabies after psychiatrist raised fears, inquest",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-global-health-and-education-watch-briton-diagnosed-with-rabies-after-psychiatris.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-how-do-student-loans-work-and-when-are-they",
    title: "Global Health and Education Watch: How do student loans work and when are they",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-global-health-and-education-watch-how-do-student-loans-work-and-when-are-they.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-on-lead-britain-is-the-laggard-of-the-developed",
    title: "Global Health and Education Watch: On lead, Britain is the laggard of the developed",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-global-health-and-education-watch-on-lead-britain-is-the-laggard-of-the-develope.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-uk-to-end-study-visas-for-myanmar-afghanistan-cameroon",
    title: "Global Health and Education Watch: UK to end study visas for Myanmar, Afghanistan, Cameroon",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-global-health-and-education-watch-uk-to-end-study-visas-for-myanmar-afghanistan-.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-a-randomised-controlled-trial-of-a-lived-experience-and",
    title: "Global Health and Education Watch: A randomised controlled trial of a lived experience and",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-04-global-health-and-education-watch-a-randomised-controlled-trial-of-a-lived-exper.jpg",
    date: "2026-03-04",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-iran-crisis-schoolgirls-killed-thousands-displaced-and-aid-compromised",
    title: "Global Health and Education Watch: Iran crisis: Schoolgirls killed, thousands displaced and aid compromised",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-03-03-global-health-and-education-watch-iran-crisis-schoolgirls-killed-thousands-displ.jpg",
    date: "2026-03-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "south-carolina-battles-largest-measles-outbreak-in-decades-amid-plunging-vaccination-rates",
    title: "South Carolina Battles Largest Measles Outbreak in Decades Amid Plunging Vaccination Rates",
    summary:
      "A historic measles outbreak in South Carolina has exposed the severe consequences of declining immunization rates. With one local school reporting only 21 percent vaccine coverage, health officials are scrambling to contain the highly contagious virus.",
    thumbnailImage: "/images/global-news/2026/2026-03-03-south-carolina-battles-largest-measles-outbreak-in-decades-amid-plunging-vaccina.jpg",
    date: "2026-03-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {

    slug: "denmark-s-national-initiative-transforms-mental-health-stigma-through-the-power-of-personal-storytelling",
    title: "Denmark’s National Initiative Transforms Mental Health Stigma Through the Power of Personal Storytelling",
    summary:
      "Denmark’s 'One of Us' campaign is redefining how society views mental illness by facilitating direct dialogue between patients and the public. This nationwide effort utilizes personal narratives to dismantle stereotypes in critical sectors like law enforcement and healthcare.",
    thumbnailImage: "/images/global-news/2026/2026-03-03-denmark-s-national-initiative-transforms-mental-health-stigma-through-the-power-.png",
    date: "2026-03-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "the-digital-confidant-are-ai-counselors-the-future-of-student-mental-health",
    title: "The Digital Confidant: Are AI Counselors the Future of Student Mental Health?",
    summary:
      "Schools globally are adopting AI-driven chat platforms to monitor student mental health outside classroom hours. While proponents argue these tools save lives, privacy advocates question the long-term implications of algorithmic surveillance.",
    thumbnailImage: "/images/global-news/2026/2026-03-03-the-digital-confidant-are-ai-counselors-the-future-of-student-mental-health.png",
    date: "2026-03-03",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "nphl-and-who-nepal-decentralize-measles-rubella-testing-to-strengthen-provincial-health-security",
    title: "NPHL and WHO Nepal Decentralize Measles-Rubella Testing to Strengthen Provincial Health Security",
    summary:
      "The National Public Health Laboratory and WHO Nepal have launched a critical initiative to expand Measles-Rubella testing capabilities to provincial laboratories. This decentralization aims to drastically reduce diagnostic delays and bolster Nepal's federal health infrastructure.",
    thumbnailImage: "/images/nepal-news/2026/2026-02-25-nphl-and-who-nepal-decentralize-measles-rubella-testing-to-strengthen-provincial.jpg",
    date: "2026-02-25",
    author: "Nivaran Foundation Nepal Desk",
    featured: true,
    type: "News",
  },
  {
    slug: "sudan-s-agony-one-thousand-days-of-war-yield-world-s-worst-humanitarian-catastrophe",
    title: "Sudan’s Agony: One Thousand Days of War Yield World’s Worst Humanitarian Catastrophe",
    summary:
      "The conflict in Sudan has reached a grim 1,000-day milestone, leaving the health system in ruins and millions displaced. With famine looming and disease outbreaks spreading, the World Health Organization warns of a total collapse without immediate intervention.",
    thumbnailImage: "/images/global-news/2026/2026-02-25-sudan-s-agony-one-thousand-days-of-war-yield-world-s-worst-humanitarian-catastro.jpg",
    date: "2026-02-25",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "compassion-in-the-metropolis-singapore-s-charities-bridging-the-distance-for-vulnerable-populations",
    title: "Compassion in the Metropolis: Singapore's Charities Bridging the Distance for Vulnerable Populations",
    summary:
      "Despite Singapore's economic prowess, significant vulnerabilities persist among its populations. This in-depth analysis, in the Nivaran/Founder tone, explores the vital role of five key charities—Willing Hearts, Food From the Heart, HealthServe, TWC2, and SPD—in bridging the socio-economic, cultural, and systemic 'distances' that create disparities in healthcare, education, and basic needs, offering a model for inclusive societal development.",
    thumbnailImage: "/blogs/thumbnail/healthcareTransformation.jpg",
    date: "2026-02-25",
    author: "Nivaran/Founder",
    featured: true,
    type: "Analysis",
  },
  {
    slug: "the-unseen-crisis-ocular-disorders-among-internally-displaced-persons-in-benue-state",
    title: "The Unseen Crisis: Ocular Disorders Among Internally Displaced Persons in Benue State",
    summary:
      "A new study reveals a staggering 62.5% prevalence of ocular disorders among internally displaced persons in Benue State, Nigeria, highlighting critical gaps in health access and the profound impact of displacement on vision and quality of life. This analysis, in the Nivaran/Founder tone, delves into the systemic failures and urgent humanitarian imperatives, underscoring how economic, educational, and geographical distances transform treatable conditions into debilitating impairments.",
    thumbnailImage: "/blogs/thumbnail/doctorUsingLaptop.jpeg",
    date: "2026-02-24",
    author: "Nivaran/Founder",
    featured: true,
    type: "Analysis",
  },
  {
    slug: "the-3-2-billion-betrayal-education-aid-collapse-threatens-6-million-children",
    title: "The $3.2 Billion Betrayal: Education Aid Collapse Threatens 6 Million Children",
    summary:
      "International aid for education is projected to drop by 24% by 2026. For children in fragile states like Sudan and Haiti, this retreat of global support dismantles the only sanctuary they have left.",
    thumbnailImage: "/images/global-news/2026/2026-02-23-unicef-sudan-education-crisis.jpg", // Corrected image path
    date: "2026-02-23",
    author: "Nivaran Foundation Global Desk",
    featured: true,
    type: "News",
  },
  {
    slug: "the-2026-threat-matrix-six-health-crises-defining-the-year",
    title: "The 2026 Threat Matrix: Six Health Crises Defining the Year",
    summary:
      "As violence hits post-WWII highs, conflict has become a primary driver of infectious disease. Cholera deaths rose 50% last year, largely in war zones. This is the new epidemiology of instability.",
    thumbnailImage: "/images/global-news/2026/2026-02-23-the-2026-threat-matrix-six-health-crises-defining-the-year.jpg",
    date: "2026-02-23",
    author: "Nivaran Foundation Global Desk",
    featured: true,
    type: "News",
  },
  {
    slug: "the-lethal-gap-why-conflict-zones-are-now-the-world-s-deadliest-maternity-wards",
    title: "The Lethal Gap: Why Conflict Zones Are Now the World's Deadliest Maternity Wards",
    summary:
      "A 15-year-old girl in a conflict zone faces a 1 in 51 lifetime risk of dying during pregnancy. This is the geography of failure.",
    thumbnailImage: "/images/global-news/2026/2026-02-23-the-lethal-gap-why-conflict-zones-are-now-the-world-s-deadliest-maternity-wards.jpg",
    date: "2026-02-23",
    author: "Nivaran Foundation Global Desk",
    featured: true,
    type: "News",
  },
  {
    slug: "greenland-rejects-us-hospital-ship-offer-defending-arctic-health-sovereignty-against-political-critique",
    title: "Greenland Rejects US Hospital Ship Offer, Defending Arctic Health Sovereignty Against Political Critique",
    summary:
      "Greenland’s government has firmly declined a US offer to send a hospital ship to the Arctic territory, following comments from President Donald Trump mocking the island's healthcare infrastructure. Officials in Nuuk defended their public health system, framing the rejection as a matter of national pride and autonomy.",
    thumbnailImage: "/images/global-news/2026/2026-02-23-greenland-rejects-us-hospital-ship-offer-defending-arctic-health-sovereignty-aga.jpg",
    date: "2026-02-23",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-and-education-watch-public-health-and-education-accountability-update",
    title: "Global Health and Education Watch: Public health and education accountability update",
    summary:
      "A high-impact global update is reshaping how health and education systems prioritize access, staffing, and continuity. This analysis maps the operational consequences for vulnerable communities.",
    thumbnailImage: "/images/global-news/2026/2026-02-22-global-health-and-education-watch-public-health-and-education-accountability-upd.jpg",
    date: "2026-02-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "the-empty-desk-dilemma-rethinking-state-intervention-in-chronic-absenteeism",
    title: "The Empty Desk Dilemma: Rethinking State Intervention in Chronic Absenteeism",
    summary:
      "Mandatory reporting laws often force teachers to involve child protective services when students miss school, sparking a global debate on the criminalization of poverty. New policy proposals suggest decoupling attendance issues from child welfare to focus on root causes like health and housing.",
    thumbnailImage: "/images/global-news/2026/2026-02-22-the-empty-desk-dilemma-rethinking-state-intervention-in-chronic-absenteeism.jpg",
    date: "2026-02-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "england-unveils-ambitious-strategy-to-halve-educational-attainment-gap-through-funding-reform",
    title: "England Unveils Ambitious Strategy to Halve Educational Attainment Gap Through Funding Reform",
    summary:
      "Ministers in England are set to launch a comprehensive strategy aimed at halving the academic achievement gap between wealthy and poor students. The plan focuses on revising school funding allocations to better support the most vulnerable demographics.",
    thumbnailImage: "/images/global-news/2026/2026-02-22-england-unveils-ambitious-strategy-to-halve-educational-attainment-gap-through-f.jpg",
    date: "2026-02-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "who-unveils-global-framework-to-transform-school-food-environments-for-future-generations",
    title: "WHO Unveils Global Framework to Transform School Food Environments for Future Generations",
    summary:
      "The World Health Organization has unveiled a new set of global guidelines designed to overhaul food environments within educational institutions. By prioritizing evidence-based nutritional policies, the initiative aims to foster lifelong healthy eating habits and curb the rise of noncommunicable diseases among children.",
    thumbnailImage: "/images/global-news/2026/2026-02-22-who-unveils-global-framework-to-transform-school-food-environments-for-future-ge.jpg",
    date: "2026-02-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "global-health-coverage-expands-yet-billions-remain-vulnerable-to-financial-ruin-report-finds",
    title: "Global Health Coverage Expands, Yet Billions Remain Vulnerable to Financial Ruin, Report Finds",
    summary:
      "A new joint report reveals that while global health service coverage has improved significantly since 2000, progress has slowed, leaving billions without essential care. Financial hardship remains a critical barrier, pushing 1.6 billion people deeper into poverty due to out-of-pocket medical expenses.",
    thumbnailImage: "/images/global-news/2026/2026-02-22-global-health-coverage-expands-yet-billions-remain-vulnerable-to-financial-ruin-report-finds-v2.jpg",
    date: "2026-02-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "1-000-days-of-war-sudan-endures-the-world-s-worst-humanitarian-catastrophe",
    title: "1,000 Days of War: Sudan Endures the World’s Worst Humanitarian Catastrophe",
    summary:
      "Sudan’s conflict has reached its 1,000th day, leaving over 33 million people in desperate need of aid. With the health system shattered and disease rampant, the crisis stands as the largest displacement emergency globally.",
    thumbnailImage: "/images/global-news/2026/2026-02-22-1-000-days-of-war-sudan-endures-the-world-s-worst-humanitarian-catastrophe-v3.jpg",
    date: "2026-02-22",
    author: "Nivaran Foundation Global Desk",
    featured: false,
    type: "News",
  },
  {
    slug: "food-insecurity-america",
    title: "Tackling Food Insecurity in the USA",
    summary:
      "Exploring the causes, impacts, and community-driven solutions to end hunger and foster resilience across the United States.",
    thumbnailImage: "/blogs/thumbnail/foodInsecurityThumbnail.png",
    date: "2025-01-16",
    type: "Story",
    author: "Nivaran Foundation",
  },
  {
    slug: "california-wildfire",
    title: "2025 California Wildfires: A Growing Crisis",
    summary:
      "Unprecedented winds, soaring temperatures, and climate change fuel a disaster reshaping lives in Southern California.",
    thumbnailImage: "/blogs/thumbnail/wildfireThumbnail.jpg",
    date: "2025-01-15",
    author: "Nivaran Foundation",
    type: "Story",
  },
];

export const usaBlogs: blogListType[] = [
];
